
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire78e9"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire78e9"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("3mxm3", function(module, exports) {
$parcel$export(module.exports, "BrowserRouter", () => $272d4cb71d942b6d$export$9ba4e89fdfa1fc54);
$parcel$export(module.exports, "useSearchParams", () => $272d4cb71d942b6d$export$f1a78c17382fe22a);
$parcel$export(module.exports, "useLocation", () => (parcelRequire("bfivG")).useLocation);
$parcel$export(module.exports, "useNavigate", () => (parcelRequire("bfivG")).useNavigate);
/**
 * React Router DOM v6.27.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $4tluv = parcelRequire("4tluv");

var $lImzW = parcelRequire("lImzW");

var $dtynv = parcelRequire("dtynv");
var $bfivG = parcelRequire("bfivG");

var $dtynv = parcelRequire("dtynv");
function $272d4cb71d942b6d$var$_extends() {
    $272d4cb71d942b6d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $272d4cb71d942b6d$var$_extends.apply(this, arguments);
}
function $272d4cb71d942b6d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $272d4cb71d942b6d$var$defaultMethod = "get";
const $272d4cb71d942b6d$var$defaultEncType = "application/x-www-form-urlencoded";
function $272d4cb71d942b6d$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $272d4cb71d942b6d$var$isButtonElement(object) {
    return $272d4cb71d942b6d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $272d4cb71d942b6d$var$isFormElement(object) {
    return $272d4cb71d942b6d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $272d4cb71d942b6d$var$isInputElement(object) {
    return $272d4cb71d942b6d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $272d4cb71d942b6d$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $272d4cb71d942b6d$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$272d4cb71d942b6d$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $272d4cb71d942b6d$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $272d4cb71d942b6d$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $272d4cb71d942b6d$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $272d4cb71d942b6d$var$_formDataSupportsSubmitter = null;
function $272d4cb71d942b6d$var$isFormDataSubmitterSupported() {
    if ($272d4cb71d942b6d$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $272d4cb71d942b6d$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $272d4cb71d942b6d$var$_formDataSupportsSubmitter = true;
    }
    return $272d4cb71d942b6d$var$_formDataSupportsSubmitter;
}
const $272d4cb71d942b6d$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $272d4cb71d942b6d$var$getFormEncType(encType) {
    if (encType != null && !$272d4cb71d942b6d$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $272d4cb71d942b6d$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($272d4cb71d942b6d$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $dtynv.stripBasename)(attr, basename) : null;
        method = target.getAttribute("method") || $272d4cb71d942b6d$var$defaultMethod;
        encType = $272d4cb71d942b6d$var$getFormEncType(target.getAttribute("enctype")) || $272d4cb71d942b6d$var$defaultEncType;
        formData = new FormData(target);
    } else if ($272d4cb71d942b6d$var$isButtonElement(target) || $272d4cb71d942b6d$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $dtynv.stripBasename)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $272d4cb71d942b6d$var$defaultMethod;
        encType = $272d4cb71d942b6d$var$getFormEncType(target.getAttribute("formenctype")) || $272d4cb71d942b6d$var$getFormEncType(form.getAttribute("enctype")) || $272d4cb71d942b6d$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$272d4cb71d942b6d$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($272d4cb71d942b6d$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $272d4cb71d942b6d$var$defaultMethod;
        action = null;
        encType = $272d4cb71d942b6d$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $272d4cb71d942b6d$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $272d4cb71d942b6d$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $272d4cb71d942b6d$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $272d4cb71d942b6d$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $272d4cb71d942b6d$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $272d4cb71d942b6d$export$1f3f55432a00e06d(routes, opts) {
    return (0, $dtynv.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $272d4cb71d942b6d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $dtynv.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $272d4cb71d942b6d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $bfivG.UNSAFE_mapRouteProperties),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $272d4cb71d942b6d$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $dtynv.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $272d4cb71d942b6d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $dtynv.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $272d4cb71d942b6d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $bfivG.UNSAFE_mapRouteProperties),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $272d4cb71d942b6d$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $272d4cb71d942b6d$var$_extends({}, state, {
        errors: $272d4cb71d942b6d$var$deserializeErrors(state.errors)
    });
    return state;
}
function $272d4cb71d942b6d$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $dtynv.UNSAFE_ErrorResponseImpl)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $272d4cb71d942b6d$export$7ad602f0e94e62d1 = /*#__PURE__*/ $4tluv.createContext({
    isTransitioning: false
});
const $272d4cb71d942b6d$export$148fd98d095596d4 = /*#__PURE__*/ $4tluv.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $272d4cb71d942b6d$var$START_TRANSITION = "startTransition";
const $272d4cb71d942b6d$var$startTransitionImpl = $4tluv[$272d4cb71d942b6d$var$START_TRANSITION];
const $272d4cb71d942b6d$var$FLUSH_SYNC = "flushSync";
const $272d4cb71d942b6d$var$flushSyncImpl = $lImzW[$272d4cb71d942b6d$var$FLUSH_SYNC];
const $272d4cb71d942b6d$var$USE_ID = "useId";
const $272d4cb71d942b6d$var$useIdImpl = $4tluv[$272d4cb71d942b6d$var$USE_ID];
function $272d4cb71d942b6d$var$startTransitionSafe(cb) {
    if ($272d4cb71d942b6d$var$startTransitionImpl) $272d4cb71d942b6d$var$startTransitionImpl(cb);
    else cb();
}
function $272d4cb71d942b6d$var$flushSyncSafe(cb) {
    if ($272d4cb71d942b6d$var$flushSyncImpl) $272d4cb71d942b6d$var$flushSyncImpl(cb);
    else cb();
}
class $272d4cb71d942b6d$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $272d4cb71d942b6d$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $4tluv.useState(router.state);
    let [pendingState, setPendingState] = $4tluv.useState();
    let [vtContext, setVtContext] = $4tluv.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $4tluv.useState();
    let [transition, setTransition] = $4tluv.useState();
    let [interruption, setInterruption] = $4tluv.useState();
    let fetcherData = $4tluv.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $4tluv.useCallback((cb)=>{
        if (v7_startTransition) $272d4cb71d942b6d$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $4tluv.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $272d4cb71d942b6d$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $272d4cb71d942b6d$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $272d4cb71d942b6d$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $272d4cb71d942b6d$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $272d4cb71d942b6d$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $4tluv.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $4tluv.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $272d4cb71d942b6d$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $4tluv.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $4tluv.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $4tluv.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $4tluv.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $4tluv.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $4tluv.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $4tluv.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $4tluv.createElement($4tluv.Fragment, null, /*#__PURE__*/ $4tluv.createElement((0, $bfivG.UNSAFE_DataRouterContext).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $4tluv.createElement((0, $bfivG.UNSAFE_DataRouterStateContext).Provider, {
        value: state
    }, /*#__PURE__*/ $4tluv.createElement($272d4cb71d942b6d$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $4tluv.createElement($272d4cb71d942b6d$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $4tluv.createElement((0, $bfivG.Router), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $4tluv.createElement($272d4cb71d942b6d$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $272d4cb71d942b6d$var$MemoizedDataRoutes = /*#__PURE__*/ $4tluv.memo($272d4cb71d942b6d$var$DataRoutes);
function $272d4cb71d942b6d$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $bfivG.UNSAFE_useRoutesImpl)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $272d4cb71d942b6d$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $4tluv.useRef();
    if (historyRef.current == null) historyRef.current = (0, $dtynv.createBrowserHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $4tluv.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $4tluv.useCallback((newState)=>{
        v7_startTransition && $272d4cb71d942b6d$var$startTransitionImpl ? $272d4cb71d942b6d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $4tluv.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $4tluv.createElement((0, $bfivG.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $272d4cb71d942b6d$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $4tluv.useRef();
    if (historyRef.current == null) historyRef.current = (0, $dtynv.createHashHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $4tluv.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $4tluv.useCallback((newState)=>{
        v7_startTransition && $272d4cb71d942b6d$var$startTransitionImpl ? $272d4cb71d942b6d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $4tluv.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $4tluv.createElement((0, $bfivG.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $272d4cb71d942b6d$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $4tluv.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $4tluv.useCallback((newState)=>{
        v7_startTransition && $272d4cb71d942b6d$var$startTransitionImpl ? $272d4cb71d942b6d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $4tluv.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $4tluv.createElement((0, $bfivG.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $272d4cb71d942b6d$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $272d4cb71d942b6d$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $272d4cb71d942b6d$export$a6c7ac8248d6e38a = /*#__PURE__*/ $4tluv.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $272d4cb71d942b6d$var$_objectWithoutPropertiesLoose(_ref7, $272d4cb71d942b6d$var$_excluded);
    let { basename: basename } = $4tluv.useContext((0, $bfivG.UNSAFE_NavigationContext));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $272d4cb71d942b6d$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($272d4cb71d942b6d$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $dtynv.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $bfivG.useHref)(to, {
        relative: relative
    });
    let internalOnClick = $272d4cb71d942b6d$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $4tluv.createElement("a", $272d4cb71d942b6d$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $272d4cb71d942b6d$export$b0d92dbee9b5b60d = /*#__PURE__*/ $4tluv.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $272d4cb71d942b6d$var$_objectWithoutPropertiesLoose(_ref8, $272d4cb71d942b6d$var$_excluded2);
    let path = (0, $bfivG.useResolvedPath)(to, {
        relative: rest.relative
    });
    let location = (0, $bfivG.useLocation)();
    let routerState = $4tluv.useContext((0, $bfivG.UNSAFE_DataRouterStateContext));
    let { navigator: navigator, basename: basename } = $4tluv.useContext((0, $bfivG.UNSAFE_NavigationContext));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $272d4cb71d942b6d$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $dtynv.stripBasename)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $4tluv.createElement($272d4cb71d942b6d$export$a6c7ac8248d6e38a, $272d4cb71d942b6d$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $272d4cb71d942b6d$export$a7fed597f4b8afd8 = /*#__PURE__*/ $4tluv.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $272d4cb71d942b6d$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $272d4cb71d942b6d$var$_objectWithoutPropertiesLoose(_ref9, $272d4cb71d942b6d$var$_excluded3);
    let submit = $272d4cb71d942b6d$export$47c85c6e3a081d3();
    let formAction = $272d4cb71d942b6d$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $4tluv.createElement("form", $272d4cb71d942b6d$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $272d4cb71d942b6d$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $272d4cb71d942b6d$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $272d4cb71d942b6d$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($272d4cb71d942b6d$var$DataRouterHook || ($272d4cb71d942b6d$var$DataRouterHook = {}));
var $272d4cb71d942b6d$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($272d4cb71d942b6d$var$DataRouterStateHook || ($272d4cb71d942b6d$var$DataRouterStateHook = {}));
// Internal hooks
function $272d4cb71d942b6d$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $272d4cb71d942b6d$var$useDataRouterContext(hookName) {
    let ctx = $4tluv.useContext((0, $bfivG.UNSAFE_DataRouterContext));
    !ctx && (0, $dtynv.UNSAFE_invariant)(false);
    return ctx;
}
function $272d4cb71d942b6d$var$useDataRouterState(hookName) {
    let state = $4tluv.useContext((0, $bfivG.UNSAFE_DataRouterStateContext));
    !state && (0, $dtynv.UNSAFE_invariant)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $272d4cb71d942b6d$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $bfivG.useNavigate)();
    let location = (0, $bfivG.useLocation)();
    let path = (0, $bfivG.useResolvedPath)(to, {
        relative: relative
    });
    return $4tluv.useCallback((event)=>{
        if ($272d4cb71d942b6d$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $dtynv.createPath)(location) === (0, $dtynv.createPath)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $272d4cb71d942b6d$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $4tluv.useRef($272d4cb71d942b6d$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $4tluv.useRef(false);
    let location = (0, $bfivG.useLocation)();
    let searchParams = $4tluv.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $272d4cb71d942b6d$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $bfivG.useNavigate)();
    let setSearchParams = $4tluv.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $272d4cb71d942b6d$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $272d4cb71d942b6d$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $272d4cb71d942b6d$var$fetcherId = 0;
let $272d4cb71d942b6d$var$getUniqueFetcherId = ()=>"__" + String(++$272d4cb71d942b6d$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $272d4cb71d942b6d$export$47c85c6e3a081d3() {
    let { router: router } = $272d4cb71d942b6d$var$useDataRouterContext($272d4cb71d942b6d$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $4tluv.useContext((0, $bfivG.UNSAFE_NavigationContext));
    let currentRouteId = (0, $bfivG.UNSAFE_useRouteId)();
    return $4tluv.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $272d4cb71d942b6d$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $272d4cb71d942b6d$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $272d4cb71d942b6d$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $272d4cb71d942b6d$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $4tluv.useContext((0, $bfivG.UNSAFE_NavigationContext));
    let routeContext = $4tluv.useContext((0, $bfivG.UNSAFE_RouteContext));
    !routeContext && (0, $dtynv.UNSAFE_invariant)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $272d4cb71d942b6d$var$_extends({}, (0, $bfivG.useResolvedPath)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $bfivG.useLocation)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $dtynv.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, $dtynv.createPath)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $272d4cb71d942b6d$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $272d4cb71d942b6d$var$useDataRouterContext($272d4cb71d942b6d$var$DataRouterHook.UseFetcher);
    let state = $272d4cb71d942b6d$var$useDataRouterState($272d4cb71d942b6d$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $4tluv.useContext($272d4cb71d942b6d$export$148fd98d095596d4);
    let route = $4tluv.useContext((0, $bfivG.UNSAFE_RouteContext));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $dtynv.UNSAFE_invariant)(false);
    !route && (0, $dtynv.UNSAFE_invariant)(false);
    !(routeId != null) && (0, $dtynv.UNSAFE_invariant)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $272d4cb71d942b6d$var$useIdImpl ? $272d4cb71d942b6d$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $4tluv.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($272d4cb71d942b6d$var$getUniqueFetcherId());
    // Registration/cleanup
    $4tluv.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $4tluv.useCallback((href, opts)=>{
        !routeId && (0, $dtynv.UNSAFE_invariant)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $272d4cb71d942b6d$export$47c85c6e3a081d3();
    let submit = $4tluv.useCallback((target, opts)=>{
        submitImpl(target, $272d4cb71d942b6d$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $4tluv.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $4tluv.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $4tluv.createElement($272d4cb71d942b6d$export$a7fed597f4b8afd8, $272d4cb71d942b6d$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $dtynv.IDLE_FETCHER);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $4tluv.useMemo(()=>$272d4cb71d942b6d$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $272d4cb71d942b6d$export$fa996778a3a31087() {
    let state = $272d4cb71d942b6d$var$useDataRouterState($272d4cb71d942b6d$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $272d4cb71d942b6d$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $272d4cb71d942b6d$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $272d4cb71d942b6d$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $272d4cb71d942b6d$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $272d4cb71d942b6d$var$useDataRouterContext($272d4cb71d942b6d$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $272d4cb71d942b6d$var$useDataRouterState($272d4cb71d942b6d$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $4tluv.useContext((0, $bfivG.UNSAFE_NavigationContext));
    let location = (0, $bfivG.useLocation)();
    let matches = (0, $bfivG.useMatches)();
    let navigation = (0, $bfivG.useNavigation)();
    // Trigger manual scroll restoration while we're active
    $4tluv.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $272d4cb71d942b6d$var$usePageHide($4tluv.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $272d4cb71d942b6d$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $272d4cb71d942b6d$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($272d4cb71d942b6d$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $4tluv.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $272d4cb71d942b6d$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $272d4cb71d942b6d$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $4tluv.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($272d4cb71d942b6d$var$_extends({}, location, {
                    pathname: (0, $dtynv.stripBasename)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($272d4cb71d942b6d$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $4tluv.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $272d4cb71d942b6d$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $4tluv.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $272d4cb71d942b6d$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $4tluv.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $272d4cb71d942b6d$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $bfivG.useBlocker)(when);
    $4tluv.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $4tluv.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $272d4cb71d942b6d$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $4tluv.useContext($272d4cb71d942b6d$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $dtynv.UNSAFE_invariant)(false);
    let { basename: basename } = $272d4cb71d942b6d$var$useDataRouterContext($272d4cb71d942b6d$var$DataRouterHook.useViewTransitionState);
    let path = (0, $bfivG.useResolvedPath)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $dtynv.stripBasename)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $dtynv.stripBasename)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $dtynv.matchPath)(path.pathname, nextPath) != null || (0, $dtynv.matchPath)(path.pathname, currentPath) != null;
}

});
parcelRegister("dtynv", function(module, exports) {
$parcel$export(module.exports, "Action", () => $9cf8a699c929dbf1$export$e19cd5f9376f8cee);
$parcel$export(module.exports, "createMemoryHistory", () => $9cf8a699c929dbf1$export$2b76ad033c6e6d08);
$parcel$export(module.exports, "createPath", () => $9cf8a699c929dbf1$export$fe53371bee54353d);
$parcel$export(module.exports, "parsePath", () => $9cf8a699c929dbf1$export$8ccf933b0513f8d0);
$parcel$export(module.exports, "createBrowserHistory", () => $9cf8a699c929dbf1$export$719fc203c4e16dee);
$parcel$export(module.exports, "createHashHistory", () => $9cf8a699c929dbf1$export$b71fdd3798280242);
$parcel$export(module.exports, "UNSAFE_invariant", () => $9cf8a699c929dbf1$export$3e9cee6b33872309);
$parcel$export(module.exports, "matchRoutes", () => $9cf8a699c929dbf1$export$2708184779ceb39d);
$parcel$export(module.exports, "stripBasename", () => $9cf8a699c929dbf1$export$b69e3301ce081aa3);
$parcel$export(module.exports, "UNSAFE_decodePath", () => $9cf8a699c929dbf1$export$30d21fd6d7295f52);
$parcel$export(module.exports, "UNSAFE_convertRouteMatchToUiMatch", () => $9cf8a699c929dbf1$export$b3fac024fad9e8ff);
$parcel$export(module.exports, "joinPaths", () => $9cf8a699c929dbf1$export$86d9a7913e44197e);
$parcel$export(module.exports, "matchPath", () => $9cf8a699c929dbf1$export$81336c211d5ff295);
$parcel$export(module.exports, "UNSAFE_getResolveToMatches", () => $9cf8a699c929dbf1$export$a5784978eca585fa);
$parcel$export(module.exports, "resolveTo", () => $9cf8a699c929dbf1$export$cae722b0cc860f13);
$parcel$export(module.exports, "AbortedDeferredError", () => $9cf8a699c929dbf1$export$42a99a7a4bc0e76a);
$parcel$export(module.exports, "UNSAFE_ErrorResponseImpl", () => $9cf8a699c929dbf1$export$6c6580e81da25755);
$parcel$export(module.exports, "isRouteErrorResponse", () => $9cf8a699c929dbf1$export$972111febbeef05b);
$parcel$export(module.exports, "IDLE_FETCHER", () => $9cf8a699c929dbf1$export$52eace9c284d3585);
$parcel$export(module.exports, "IDLE_BLOCKER", () => $9cf8a699c929dbf1$export$386d57f03f0b2883);
$parcel$export(module.exports, "createRouter", () => $9cf8a699c929dbf1$export$baddd0131ee8c05b);
/**
 * @remix-run/router v1.20.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $9cf8a699c929dbf1$var$_extends() {
    $9cf8a699c929dbf1$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9cf8a699c929dbf1$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $9cf8a699c929dbf1$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($9cf8a699c929dbf1$export$e19cd5f9376f8cee || ($9cf8a699c929dbf1$export$e19cd5f9376f8cee = {}));
const $9cf8a699c929dbf1$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $9cf8a699c929dbf1$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $9cf8a699c929dbf1$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $9cf8a699c929dbf1$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $9cf8a699c929dbf1$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $9cf8a699c929dbf1$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $9cf8a699c929dbf1$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $9cf8a699c929dbf1$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $9cf8a699c929dbf1$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $9cf8a699c929dbf1$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $9cf8a699c929dbf1$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $9cf8a699c929dbf1$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $9cf8a699c929dbf1$export$fe53371bee54353d(to);
    }
    return $9cf8a699c929dbf1$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $9cf8a699c929dbf1$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $9cf8a699c929dbf1$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $9cf8a699c929dbf1$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $9cf8a699c929dbf1$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $9cf8a699c929dbf1$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $9cf8a699c929dbf1$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $9cf8a699c929dbf1$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $9cf8a699c929dbf1$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $9cf8a699c929dbf1$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $9cf8a699c929dbf1$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $9cf8a699c929dbf1$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $9cf8a699c929dbf1$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $9cf8a699c929dbf1$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $9cf8a699c929dbf1$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $9cf8a699c929dbf1$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $9cf8a699c929dbf1$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $9cf8a699c929dbf1$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $9cf8a699c929dbf1$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($9cf8a699c929dbf1$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $9cf8a699c929dbf1$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $9cf8a699c929dbf1$export$e19cd5f9376f8cee.Push;
        let location = $9cf8a699c929dbf1$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $9cf8a699c929dbf1$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $9cf8a699c929dbf1$export$e19cd5f9376f8cee.Replace;
        let location = $9cf8a699c929dbf1$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $9cf8a699c929dbf1$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $9cf8a699c929dbf1$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $9cf8a699c929dbf1$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($9cf8a699c929dbf1$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($9cf8a699c929dbf1$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $9cf8a699c929dbf1$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($9cf8a699c929dbf1$var$ResultType || ($9cf8a699c929dbf1$var$ResultType = {}));
const $9cf8a699c929dbf1$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $9cf8a699c929dbf1$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $9cf8a699c929dbf1$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $9cf8a699c929dbf1$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $9cf8a699c929dbf1$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($9cf8a699c929dbf1$var$isIndexRoute(route)) {
            let indexRoute = $9cf8a699c929dbf1$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $9cf8a699c929dbf1$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $9cf8a699c929dbf1$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $9cf8a699c929dbf1$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $9cf8a699c929dbf1$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $9cf8a699c929dbf1$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $9cf8a699c929dbf1$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $9cf8a699c929dbf1$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $9cf8a699c929dbf1$var$flattenRoutes(routes);
    $9cf8a699c929dbf1$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $9cf8a699c929dbf1$export$30d21fd6d7295f52(pathname);
        matches = $9cf8a699c929dbf1$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $9cf8a699c929dbf1$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $9cf8a699c929dbf1$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $9cf8a699c929dbf1$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $9cf8a699c929dbf1$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $9cf8a699c929dbf1$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $9cf8a699c929dbf1$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $9cf8a699c929dbf1$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $9cf8a699c929dbf1$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $9cf8a699c929dbf1$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $9cf8a699c929dbf1$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $9cf8a699c929dbf1$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $9cf8a699c929dbf1$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $9cf8a699c929dbf1$var$paramRe = /^:[\w-]+$/;
const $9cf8a699c929dbf1$var$dynamicSegmentValue = 3;
const $9cf8a699c929dbf1$var$indexRouteValue = 2;
const $9cf8a699c929dbf1$var$emptySegmentValue = 1;
const $9cf8a699c929dbf1$var$staticSegmentValue = 10;
const $9cf8a699c929dbf1$var$splatPenalty = -2;
const $9cf8a699c929dbf1$var$isSplat = (s)=>s === "*";
function $9cf8a699c929dbf1$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($9cf8a699c929dbf1$var$isSplat)) initialScore += $9cf8a699c929dbf1$var$splatPenalty;
    if (index) initialScore += $9cf8a699c929dbf1$var$indexRouteValue;
    return segments.filter((s)=>!$9cf8a699c929dbf1$var$isSplat(s)).reduce((score, segment)=>score + ($9cf8a699c929dbf1$var$paramRe.test(segment) ? $9cf8a699c929dbf1$var$dynamicSegmentValue : segment === "" ? $9cf8a699c929dbf1$var$emptySegmentValue : $9cf8a699c929dbf1$var$staticSegmentValue), initialScore);
}
function $9cf8a699c929dbf1$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $9cf8a699c929dbf1$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $9cf8a699c929dbf1$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $9cf8a699c929dbf1$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $9cf8a699c929dbf1$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $9cf8a699c929dbf1$export$a5c6d149b50c1d86($9cf8a699c929dbf1$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $9cf8a699c929dbf1$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $9cf8a699c929dbf1$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $9cf8a699c929dbf1$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $9cf8a699c929dbf1$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $9cf8a699c929dbf1$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $9cf8a699c929dbf1$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $9cf8a699c929dbf1$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $9cf8a699c929dbf1$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $9cf8a699c929dbf1$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $9cf8a699c929dbf1$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $9cf8a699c929dbf1$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $9cf8a699c929dbf1$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $9cf8a699c929dbf1$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $9cf8a699c929dbf1$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $9cf8a699c929dbf1$var$normalizeSearch(search),
        hash: $9cf8a699c929dbf1$var$normalizeHash(hash)
    };
}
function $9cf8a699c929dbf1$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $9cf8a699c929dbf1$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $9cf8a699c929dbf1$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $9cf8a699c929dbf1$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $9cf8a699c929dbf1$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $9cf8a699c929dbf1$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $9cf8a699c929dbf1$export$8ccf933b0513f8d0(toArg);
    else {
        to = $9cf8a699c929dbf1$var$_extends({}, toArg);
        $9cf8a699c929dbf1$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $9cf8a699c929dbf1$var$getInvalidPathError("?", "pathname", "search", to));
        $9cf8a699c929dbf1$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $9cf8a699c929dbf1$var$getInvalidPathError("#", "pathname", "hash", to));
        $9cf8a699c929dbf1$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $9cf8a699c929dbf1$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $9cf8a699c929dbf1$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $9cf8a699c929dbf1$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $9cf8a699c929dbf1$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $9cf8a699c929dbf1$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $9cf8a699c929dbf1$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $9cf8a699c929dbf1$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $9cf8a699c929dbf1$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $9cf8a699c929dbf1$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $9cf8a699c929dbf1$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $9cf8a699c929dbf1$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $9cf8a699c929dbf1$export$4051a07651545597(data, init) {
    return new $9cf8a699c929dbf1$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $9cf8a699c929dbf1$export$42a99a7a4bc0e76a extends Error {
}
class $9cf8a699c929dbf1$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $9cf8a699c929dbf1$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $9cf8a699c929dbf1$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $9cf8a699c929dbf1$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $9cf8a699c929dbf1$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $9cf8a699c929dbf1$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $9cf8a699c929dbf1$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $9cf8a699c929dbf1$var$unwrapTrackedPromise(value) {
    if (!$9cf8a699c929dbf1$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $9cf8a699c929dbf1$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $9cf8a699c929dbf1$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $9cf8a699c929dbf1$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $9cf8a699c929dbf1$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $9cf8a699c929dbf1$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $9cf8a699c929dbf1$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $9cf8a699c929dbf1$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $9cf8a699c929dbf1$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $9cf8a699c929dbf1$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $9cf8a699c929dbf1$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $9cf8a699c929dbf1$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $9cf8a699c929dbf1$var$validMutationMethods = new Set($9cf8a699c929dbf1$var$validMutationMethodsArr);
const $9cf8a699c929dbf1$var$validRequestMethodsArr = [
    "get",
    ...$9cf8a699c929dbf1$var$validMutationMethodsArr
];
const $9cf8a699c929dbf1$var$validRequestMethods = new Set($9cf8a699c929dbf1$var$validRequestMethodsArr);
const $9cf8a699c929dbf1$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $9cf8a699c929dbf1$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $9cf8a699c929dbf1$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $9cf8a699c929dbf1$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $9cf8a699c929dbf1$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $9cf8a699c929dbf1$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $9cf8a699c929dbf1$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $9cf8a699c929dbf1$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $9cf8a699c929dbf1$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $9cf8a699c929dbf1$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $9cf8a699c929dbf1$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $9cf8a699c929dbf1$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $9cf8a699c929dbf1$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $9cf8a699c929dbf1$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $9cf8a699c929dbf1$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $9cf8a699c929dbf1$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $9cf8a699c929dbf1$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) initialMatches = fogOfWar.matches;
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$9cf8a699c929dbf1$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$9cf8a699c929dbf1$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $9cf8a699c929dbf1$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $9cf8a699c929dbf1$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $9cf8a699c929dbf1$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $9cf8a699c929dbf1$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $9cf8a699c929dbf1$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$9cf8a699c929dbf1$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($9cf8a699c929dbf1$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $9cf8a699c929dbf1$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $9cf8a699c929dbf1$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $9cf8a699c929dbf1$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $9cf8a699c929dbf1$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $9cf8a699c929dbf1$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $9cf8a699c929dbf1$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $9cf8a699c929dbf1$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $9cf8a699c929dbf1$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $9cf8a699c929dbf1$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($9cf8a699c929dbf1$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $9cf8a699c929dbf1$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $9cf8a699c929dbf1$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $9cf8a699c929dbf1$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $9cf8a699c929dbf1$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $9cf8a699c929dbf1$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $9cf8a699c929dbf1$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $9cf8a699c929dbf1$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $9cf8a699c929dbf1$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $9cf8a699c929dbf1$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $9cf8a699c929dbf1$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $9cf8a699c929dbf1$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $9cf8a699c929dbf1$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $9cf8a699c929dbf1$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $9cf8a699c929dbf1$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $9cf8a699c929dbf1$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $9cf8a699c929dbf1$var$findNearestBoundary(matches).route.id,
            {
                type: $9cf8a699c929dbf1$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $9cf8a699c929dbf1$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($9cf8a699c929dbf1$var$isErrorResult(result) && $9cf8a699c929dbf1$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $9cf8a699c929dbf1$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $9cf8a699c929dbf1$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $9cf8a699c929dbf1$var$_extends({
            matches: updatedMatches || matches
        }, $9cf8a699c929dbf1$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $9cf8a699c929dbf1$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $9cf8a699c929dbf1$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $9cf8a699c929dbf1$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $9cf8a699c929dbf1$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $9cf8a699c929dbf1$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $9cf8a699c929dbf1$var$ResultType.error,
            error: $9cf8a699c929dbf1$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($9cf8a699c929dbf1$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $9cf8a699c929dbf1$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($9cf8a699c929dbf1$var$isDeferredResult(result)) throw $9cf8a699c929dbf1$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($9cf8a699c929dbf1$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $9cf8a699c929dbf1$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $9cf8a699c929dbf1$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $9cf8a699c929dbf1$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $9cf8a699c929dbf1$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($9cf8a699c929dbf1$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $9cf8a699c929dbf1$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $9cf8a699c929dbf1$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $9cf8a699c929dbf1$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $9cf8a699c929dbf1$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $9cf8a699c929dbf1$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $9cf8a699c929dbf1$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $9cf8a699c929dbf1$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $9cf8a699c929dbf1$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $9cf8a699c929dbf1$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $9cf8a699c929dbf1$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$9cf8a699c929dbf1$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $9cf8a699c929dbf1$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $9cf8a699c929dbf1$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $9cf8a699c929dbf1$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $9cf8a699c929dbf1$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $9cf8a699c929dbf1$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $9cf8a699c929dbf1$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $9cf8a699c929dbf1$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $9cf8a699c929dbf1$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $9cf8a699c929dbf1$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $9cf8a699c929dbf1$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $9cf8a699c929dbf1$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $9cf8a699c929dbf1$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($9cf8a699c929dbf1$var$isRedirectResult(actionResult) || $9cf8a699c929dbf1$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $9cf8a699c929dbf1$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($9cf8a699c929dbf1$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $9cf8a699c929dbf1$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $9cf8a699c929dbf1$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($9cf8a699c929dbf1$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($9cf8a699c929dbf1$var$isDeferredResult(actionResult)) throw $9cf8a699c929dbf1$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $9cf8a699c929dbf1$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $9cf8a699c929dbf1$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $9cf8a699c929dbf1$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $9cf8a699c929dbf1$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $9cf8a699c929dbf1$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $9cf8a699c929dbf1$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $9cf8a699c929dbf1$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $9cf8a699c929dbf1$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $9cf8a699c929dbf1$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $9cf8a699c929dbf1$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $9cf8a699c929dbf1$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $9cf8a699c929dbf1$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $9cf8a699c929dbf1$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $9cf8a699c929dbf1$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $9cf8a699c929dbf1$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $9cf8a699c929dbf1$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($9cf8a699c929dbf1$var$isDeferredResult(result)) result = await $9cf8a699c929dbf1$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $9cf8a699c929dbf1$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($9cf8a699c929dbf1$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $9cf8a699c929dbf1$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($9cf8a699c929dbf1$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $9cf8a699c929dbf1$export$3e9cee6b33872309(!$9cf8a699c929dbf1$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $9cf8a699c929dbf1$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $9cf8a699c929dbf1$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $9cf8a699c929dbf1$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $9cf8a699c929dbf1$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($9cf8a699c929dbf1$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $9cf8a699c929dbf1$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $9cf8a699c929dbf1$export$e19cd5f9376f8cee.Replace : $9cf8a699c929dbf1$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $9cf8a699c929dbf1$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($9cf8a699c929dbf1$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $9cf8a699c929dbf1$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $9cf8a699c929dbf1$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $9cf8a699c929dbf1$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $9cf8a699c929dbf1$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $9cf8a699c929dbf1$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($9cf8a699c929dbf1$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $9cf8a699c929dbf1$var$ResultType.redirect,
                response: $9cf8a699c929dbf1$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $9cf8a699c929dbf1$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $9cf8a699c929dbf1$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $9cf8a699c929dbf1$var$ResultType.error,
                    error: $9cf8a699c929dbf1$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $9cf8a699c929dbf1$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $9cf8a699c929dbf1$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $9cf8a699c929dbf1$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $9cf8a699c929dbf1$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $9cf8a699c929dbf1$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $9cf8a699c929dbf1$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $9cf8a699c929dbf1$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $9cf8a699c929dbf1$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $9cf8a699c929dbf1$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $9cf8a699c929dbf1$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $9cf8a699c929dbf1$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $9cf8a699c929dbf1$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $9cf8a699c929dbf1$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $9cf8a699c929dbf1$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$9cf8a699c929dbf1$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $9cf8a699c929dbf1$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $9cf8a699c929dbf1$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    path: pathname,
                    matches: partialMatches,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $9cf8a699c929dbf1$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $9cf8a699c929dbf1$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $9cf8a699c929dbf1$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $9cf8a699c929dbf1$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $9cf8a699c929dbf1$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $9cf8a699c929dbf1$export$4d0306f8f6a4585b = Symbol("deferred");
function $9cf8a699c929dbf1$export$3336b097a6fbc59a(routes, opts) {
    $9cf8a699c929dbf1$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $9cf8a699c929dbf1$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $9cf8a699c929dbf1$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $9cf8a699c929dbf1$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $9cf8a699c929dbf1$var$createLocation("", $9cf8a699c929dbf1$export$fe53371bee54353d(url), null, "default");
        let matches = $9cf8a699c929dbf1$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$9cf8a699c929dbf1$var$isValidMethod(method) && method !== "HEAD") {
            let error = $9cf8a699c929dbf1$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $9cf8a699c929dbf1$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $9cf8a699c929dbf1$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $9cf8a699c929dbf1$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($9cf8a699c929dbf1$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $9cf8a699c929dbf1$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $9cf8a699c929dbf1$var$createLocation("", $9cf8a699c929dbf1$export$fe53371bee54353d(url), null, "default");
        let matches = $9cf8a699c929dbf1$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$9cf8a699c929dbf1$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $9cf8a699c929dbf1$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $9cf8a699c929dbf1$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $9cf8a699c929dbf1$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $9cf8a699c929dbf1$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $9cf8a699c929dbf1$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($9cf8a699c929dbf1$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$9cf8a699c929dbf1$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $9cf8a699c929dbf1$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($9cf8a699c929dbf1$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $9cf8a699c929dbf1$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $9cf8a699c929dbf1$var$isResponse(result) ? result : $9cf8a699c929dbf1$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($9cf8a699c929dbf1$var$isDataStrategyResult(e) && $9cf8a699c929dbf1$var$isResponse(e.result)) {
                if (e.type === $9cf8a699c929dbf1$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($9cf8a699c929dbf1$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $9cf8a699c929dbf1$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $9cf8a699c929dbf1$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $9cf8a699c929dbf1$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($9cf8a699c929dbf1$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($9cf8a699c929dbf1$var$isDeferredResult(result)) {
            let error = $9cf8a699c929dbf1$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $9cf8a699c929dbf1$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($9cf8a699c929dbf1$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($9cf8a699c929dbf1$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $9cf8a699c929dbf1$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $9cf8a699c929dbf1$var$_extends({}, context, {
                statusCode: $9cf8a699c929dbf1$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $9cf8a699c929dbf1$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $9cf8a699c929dbf1$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $9cf8a699c929dbf1$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $9cf8a699c929dbf1$var$isErrorResult(pendingActionResult[1]) ? $9cf8a699c929dbf1$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $9cf8a699c929dbf1$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $9cf8a699c929dbf1$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $9cf8a699c929dbf1$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $9cf8a699c929dbf1$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $9cf8a699c929dbf1$var$callDataStrategyImpl(dataStrategy || $9cf8a699c929dbf1$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($9cf8a699c929dbf1$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $9cf8a699c929dbf1$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($9cf8a699c929dbf1$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $9cf8a699c929dbf1$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $9cf8a699c929dbf1$export$fec11da027c70692(routes, context, error) {
    let newContext = $9cf8a699c929dbf1$var$_extends({}, context, {
        statusCode: $9cf8a699c929dbf1$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $9cf8a699c929dbf1$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $9cf8a699c929dbf1$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $9cf8a699c929dbf1$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $9cf8a699c929dbf1$export$cae722b0cc860f13(to ? to : ".", $9cf8a699c929dbf1$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $9cf8a699c929dbf1$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $9cf8a699c929dbf1$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $9cf8a699c929dbf1$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $9cf8a699c929dbf1$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $9cf8a699c929dbf1$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$9cf8a699c929dbf1$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$9cf8a699c929dbf1$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $9cf8a699c929dbf1$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $9cf8a699c929dbf1$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $9cf8a699c929dbf1$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$9cf8a699c929dbf1$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$9cf8a699c929dbf1$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $9cf8a699c929dbf1$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $9cf8a699c929dbf1$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $9cf8a699c929dbf1$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $9cf8a699c929dbf1$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $9cf8a699c929dbf1$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($9cf8a699c929dbf1$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $9cf8a699c929dbf1$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $9cf8a699c929dbf1$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $9cf8a699c929dbf1$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $9cf8a699c929dbf1$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $9cf8a699c929dbf1$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $9cf8a699c929dbf1$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $9cf8a699c929dbf1$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $9cf8a699c929dbf1$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $9cf8a699c929dbf1$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $9cf8a699c929dbf1$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($9cf8a699c929dbf1$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $9cf8a699c929dbf1$var$shouldRevalidateLoader(match, $9cf8a699c929dbf1$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $9cf8a699c929dbf1$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $9cf8a699c929dbf1$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $9cf8a699c929dbf1$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $9cf8a699c929dbf1$var$shouldRevalidateLoader(fetcherMatch, $9cf8a699c929dbf1$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $9cf8a699c929dbf1$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $9cf8a699c929dbf1$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $9cf8a699c929dbf1$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $9cf8a699c929dbf1$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $9cf8a699c929dbf1$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $9cf8a699c929dbf1$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$9cf8a699c929dbf1$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $9cf8a699c929dbf1$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $9cf8a699c929dbf1$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$9cf8a699c929dbf1$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $9cf8a699c929dbf1$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $9cf8a699c929dbf1$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $9cf8a699c929dbf1$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$9cf8a699c929dbf1$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $9cf8a699c929dbf1$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $9cf8a699c929dbf1$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $9cf8a699c929dbf1$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $9cf8a699c929dbf1$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $9cf8a699c929dbf1$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $9cf8a699c929dbf1$var$ResultType.data,
                result: undefined
            });
        };
        return $9cf8a699c929dbf1$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $9cf8a699c929dbf1$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $9cf8a699c929dbf1$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $9cf8a699c929dbf1$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $9cf8a699c929dbf1$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $9cf8a699c929dbf1$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $9cf8a699c929dbf1$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $9cf8a699c929dbf1$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($9cf8a699c929dbf1$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $9cf8a699c929dbf1$var$ResultType.error,
                error: e
            };
        }
        if (type === $9cf8a699c929dbf1$var$ResultType.error) return {
            type: $9cf8a699c929dbf1$var$ResultType.error,
            error: new $9cf8a699c929dbf1$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $9cf8a699c929dbf1$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $9cf8a699c929dbf1$var$ResultType.error) {
        if ($9cf8a699c929dbf1$export$e0163cfdf7bc9cfa(result)) {
            var _result$init2;
            if (result.data instanceof Error) {
                var _result$init;
                return {
                    type: $9cf8a699c929dbf1$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status
                };
            }
            // Convert thrown data() to ErrorResponse instances
            result = new $9cf8a699c929dbf1$export$6c6580e81da25755(((_result$init2 = result.init) == null ? void 0 : _result$init2.status) || 500, undefined, result.data);
        }
        return {
            type: $9cf8a699c929dbf1$var$ResultType.error,
            error: result,
            statusCode: $9cf8a699c929dbf1$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($9cf8a699c929dbf1$export$fbcedacb60443473(result)) {
        var _result$init3, _result$init4;
        return {
            type: $9cf8a699c929dbf1$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init3 = result.init) == null ? void 0 : _result$init3.status,
            headers: ((_result$init4 = result.init) == null ? void 0 : _result$init4.headers) && new Headers(result.init.headers)
        };
    }
    if ($9cf8a699c929dbf1$export$e0163cfdf7bc9cfa(result)) {
        var _result$init5, _result$init6;
        return {
            type: $9cf8a699c929dbf1$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: (_result$init6 = result.init) != null && _result$init6.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $9cf8a699c929dbf1$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $9cf8a699c929dbf1$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $9cf8a699c929dbf1$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$9cf8a699c929dbf1$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $9cf8a699c929dbf1$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $9cf8a699c929dbf1$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($9cf8a699c929dbf1$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $9cf8a699c929dbf1$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $9cf8a699c929dbf1$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($9cf8a699c929dbf1$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $9cf8a699c929dbf1$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $9cf8a699c929dbf1$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $9cf8a699c929dbf1$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $9cf8a699c929dbf1$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $9cf8a699c929dbf1$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $9cf8a699c929dbf1$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $9cf8a699c929dbf1$export$3e9cee6b33872309(!$9cf8a699c929dbf1$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($9cf8a699c929dbf1$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $9cf8a699c929dbf1$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $9cf8a699c929dbf1$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($9cf8a699c929dbf1$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $9cf8a699c929dbf1$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $9cf8a699c929dbf1$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $9cf8a699c929dbf1$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($9cf8a699c929dbf1$var$isErrorResult(result)) {
            let boundaryMatch = $9cf8a699c929dbf1$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $9cf8a699c929dbf1$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($9cf8a699c929dbf1$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $9cf8a699c929dbf1$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($9cf8a699c929dbf1$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $9cf8a699c929dbf1$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $9cf8a699c929dbf1$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $9cf8a699c929dbf1$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $9cf8a699c929dbf1$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $9cf8a699c929dbf1$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $9cf8a699c929dbf1$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $9cf8a699c929dbf1$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $9cf8a699c929dbf1$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $9cf8a699c929dbf1$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $9cf8a699c929dbf1$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $9cf8a699c929dbf1$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($9cf8a699c929dbf1$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $9cf8a699c929dbf1$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $9cf8a699c929dbf1$export$8ccf933b0513f8d0(path) : path;
    return $9cf8a699c929dbf1$export$fe53371bee54353d($9cf8a699c929dbf1$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $9cf8a699c929dbf1$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $9cf8a699c929dbf1$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $9cf8a699c929dbf1$var$ResultType.data || result.type === $9cf8a699c929dbf1$var$ResultType.error);
}
function $9cf8a699c929dbf1$var$isRedirectDataStrategyResultResult(result) {
    return $9cf8a699c929dbf1$var$isResponse(result.result) && $9cf8a699c929dbf1$var$redirectStatusCodes.has(result.result.status);
}
function $9cf8a699c929dbf1$var$isDeferredResult(result) {
    return result.type === $9cf8a699c929dbf1$var$ResultType.deferred;
}
function $9cf8a699c929dbf1$var$isErrorResult(result) {
    return result.type === $9cf8a699c929dbf1$var$ResultType.error;
}
function $9cf8a699c929dbf1$var$isRedirectResult(result) {
    return (result && result.type) === $9cf8a699c929dbf1$var$ResultType.redirect;
}
function $9cf8a699c929dbf1$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $9cf8a699c929dbf1$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $9cf8a699c929dbf1$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $9cf8a699c929dbf1$var$isRedirectResponse(result) {
    if (!$9cf8a699c929dbf1$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $9cf8a699c929dbf1$var$isValidMethod(method) {
    return $9cf8a699c929dbf1$var$validRequestMethods.has(method.toLowerCase());
}
function $9cf8a699c929dbf1$var$isMutationMethod(method) {
    return $9cf8a699c929dbf1$var$validMutationMethods.has(method.toLowerCase());
}
async function $9cf8a699c929dbf1$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$9cf8a699c929dbf1$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($9cf8a699c929dbf1$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $9cf8a699c929dbf1$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $9cf8a699c929dbf1$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($9cf8a699c929dbf1$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $9cf8a699c929dbf1$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $9cf8a699c929dbf1$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $9cf8a699c929dbf1$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $9cf8a699c929dbf1$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $9cf8a699c929dbf1$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $9cf8a699c929dbf1$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $9cf8a699c929dbf1$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $9cf8a699c929dbf1$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $9cf8a699c929dbf1$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $9cf8a699c929dbf1$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $9cf8a699c929dbf1$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $9cf8a699c929dbf1$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $9cf8a699c929dbf1$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $9cf8a699c929dbf1$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $9cf8a699c929dbf1$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $9cf8a699c929dbf1$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $9cf8a699c929dbf1$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $9cf8a699c929dbf1$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($9cf8a699c929dbf1$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $9cf8a699c929dbf1$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($9cf8a699c929dbf1$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $9cf8a699c929dbf1$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

});

parcelRegister("bfivG", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_DataRouterContext", () => $82ff74251c33b492$export$3add0d5dce533e2e);
$parcel$export(module.exports, "UNSAFE_DataRouterStateContext", () => $82ff74251c33b492$export$145dfa71566a64dc);
$parcel$export(module.exports, "UNSAFE_NavigationContext", () => $82ff74251c33b492$export$26749e8557646306);
$parcel$export(module.exports, "UNSAFE_RouteContext", () => $82ff74251c33b492$export$9072aa6dd1f93057);
$parcel$export(module.exports, "useHref", () => $82ff74251c33b492$export$b66bb29c5006f12f);
$parcel$export(module.exports, "useResolvedPath", () => $82ff74251c33b492$export$e75d2a2d1b3c245b);
$parcel$export(module.exports, "useLocation", () => $82ff74251c33b492$export$45d76561a5302f2b);
$parcel$export(module.exports, "useMatch", () => $82ff74251c33b492$export$6c330e8992e8a295);
$parcel$export(module.exports, "useNavigate", () => $82ff74251c33b492$export$9770f232ac06a008);
$parcel$export(module.exports, "UNSAFE_useRoutesImpl", () => $82ff74251c33b492$export$5fcee62552a12fbf);
$parcel$export(module.exports, "UNSAFE_useRouteId", () => $82ff74251c33b492$export$5fc8298006ad9e58);
$parcel$export(module.exports, "useNavigation", () => $82ff74251c33b492$export$d0fd4b7106de2769);
$parcel$export(module.exports, "useMatches", () => $82ff74251c33b492$export$2378eb7f5ff86053);
$parcel$export(module.exports, "useBlocker", () => $82ff74251c33b492$export$b273b3273281a049);
$parcel$export(module.exports, "Router", () => $82ff74251c33b492$export$55185c17a0fcbe46);
$parcel$export(module.exports, "Outlet", () => $82ff74251c33b492$export$910ae8079b2c2852);
$parcel$export(module.exports, "Route", () => $82ff74251c33b492$export$e7b0ac011bb776c6);
$parcel$export(module.exports, "Routes", () => $82ff74251c33b492$export$3565eb3d00ca5a74);
$parcel$export(module.exports, "UNSAFE_mapRouteProperties", () => $82ff74251c33b492$export$52b333d321859367);
/**
 * React Router v6.27.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $4tluv = parcelRequire("4tluv");

var $dtynv = parcelRequire("dtynv");
function $82ff74251c33b492$var$_extends() {
    $82ff74251c33b492$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $82ff74251c33b492$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $82ff74251c33b492$export$3add0d5dce533e2e = /*#__PURE__*/ $4tluv.createContext(null);
const $82ff74251c33b492$export$145dfa71566a64dc = /*#__PURE__*/ $4tluv.createContext(null);
const $82ff74251c33b492$var$AwaitContext = /*#__PURE__*/ $4tluv.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $82ff74251c33b492$export$26749e8557646306 = /*#__PURE__*/ $4tluv.createContext(null);
const $82ff74251c33b492$export$c7914228fb69b0f5 = /*#__PURE__*/ $4tluv.createContext(null);
const $82ff74251c33b492$export$9072aa6dd1f93057 = /*#__PURE__*/ $4tluv.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $82ff74251c33b492$var$RouteErrorContext = /*#__PURE__*/ $4tluv.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $82ff74251c33b492$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$82ff74251c33b492$export$9c954a9d03d32f4a() && (0, $dtynv.UNSAFE_invariant)(false);
    let { basename: basename, navigator: navigator } = $4tluv.useContext($82ff74251c33b492$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $82ff74251c33b492$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $dtynv.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $82ff74251c33b492$export$9c954a9d03d32f4a() {
    return $4tluv.useContext($82ff74251c33b492$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $82ff74251c33b492$export$45d76561a5302f2b() {
    !$82ff74251c33b492$export$9c954a9d03d32f4a() && (0, $dtynv.UNSAFE_invariant)(false);
    return $4tluv.useContext($82ff74251c33b492$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $82ff74251c33b492$export$1b3f31771c5d07c() {
    return $4tluv.useContext($82ff74251c33b492$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $82ff74251c33b492$export$6c330e8992e8a295(pattern) {
    !$82ff74251c33b492$export$9c954a9d03d32f4a() && (0, $dtynv.UNSAFE_invariant)(false);
    let { pathname: pathname } = $82ff74251c33b492$export$45d76561a5302f2b();
    return $4tluv.useMemo(()=>(0, $dtynv.matchPath)(pattern, (0, $dtynv.UNSAFE_decodePath)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $82ff74251c33b492$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $82ff74251c33b492$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $4tluv.useContext($82ff74251c33b492$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $4tluv.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $82ff74251c33b492$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $4tluv.useContext($82ff74251c33b492$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $82ff74251c33b492$var$useNavigateStable() : $82ff74251c33b492$var$useNavigateUnstable();
}
function $82ff74251c33b492$var$useNavigateUnstable() {
    !$82ff74251c33b492$export$9c954a9d03d32f4a() && (0, $dtynv.UNSAFE_invariant)(false);
    let dataRouterContext = $4tluv.useContext($82ff74251c33b492$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $4tluv.useContext($82ff74251c33b492$export$26749e8557646306);
    let { matches: matches } = $4tluv.useContext($82ff74251c33b492$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $82ff74251c33b492$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $dtynv.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    let activeRef = $4tluv.useRef(false);
    $82ff74251c33b492$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $4tluv.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $dtynv.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $dtynv.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $82ff74251c33b492$var$OutletContext = /*#__PURE__*/ $4tluv.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $82ff74251c33b492$export$4138103a3ae699cc() {
    return $4tluv.useContext($82ff74251c33b492$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $82ff74251c33b492$export$a3be3530d8e40d0b(context) {
    let outlet = $4tluv.useContext($82ff74251c33b492$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $4tluv.createElement($82ff74251c33b492$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $82ff74251c33b492$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $4tluv.useContext($82ff74251c33b492$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $82ff74251c33b492$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $4tluv.useContext($82ff74251c33b492$export$26749e8557646306);
    let { matches: matches } = $4tluv.useContext($82ff74251c33b492$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $82ff74251c33b492$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $dtynv.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    return $4tluv.useMemo(()=>(0, $dtynv.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $82ff74251c33b492$export$5d3fca4a98652595(routes, locationArg) {
    return $82ff74251c33b492$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $82ff74251c33b492$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$82ff74251c33b492$export$9c954a9d03d32f4a() && (0, $dtynv.UNSAFE_invariant)(false);
    let { navigator: navigator } = $4tluv.useContext($82ff74251c33b492$export$26749e8557646306);
    let { matches: parentMatches } = $4tluv.useContext($82ff74251c33b492$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $82ff74251c33b492$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $dtynv.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $dtynv.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $dtynv.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $82ff74251c33b492$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $dtynv.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $dtynv.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $4tluv.createElement($82ff74251c33b492$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $82ff74251c33b492$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $dtynv.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $82ff74251c33b492$var$DefaultErrorComponent() {
    let error = $82ff74251c33b492$export$ed527bf60f6e05f2();
    let message = (0, $dtynv.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $4tluv.createElement($4tluv.Fragment, null, /*#__PURE__*/ $4tluv.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $4tluv.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $4tluv.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $82ff74251c33b492$var$defaultErrorElement = /*#__PURE__*/ $4tluv.createElement($82ff74251c33b492$var$DefaultErrorComponent, null);
class $82ff74251c33b492$var$RenderErrorBoundary extends $4tluv.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $4tluv.createElement($82ff74251c33b492$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $4tluv.createElement($82ff74251c33b492$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $82ff74251c33b492$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $4tluv.useContext($82ff74251c33b492$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $4tluv.createElement($82ff74251c33b492$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $82ff74251c33b492$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $dtynv.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $82ff74251c33b492$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $82ff74251c33b492$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $4tluv.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $4tluv.createElement($82ff74251c33b492$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $4tluv.createElement($82ff74251c33b492$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $82ff74251c33b492$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($82ff74251c33b492$var$DataRouterHook || {});
var $82ff74251c33b492$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($82ff74251c33b492$var$DataRouterStateHook || {});
function $82ff74251c33b492$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $82ff74251c33b492$var$useDataRouterContext(hookName) {
    let ctx = $4tluv.useContext($82ff74251c33b492$export$3add0d5dce533e2e);
    !ctx && (0, $dtynv.UNSAFE_invariant)(false);
    return ctx;
}
function $82ff74251c33b492$var$useDataRouterState(hookName) {
    let state = $4tluv.useContext($82ff74251c33b492$export$145dfa71566a64dc);
    !state && (0, $dtynv.UNSAFE_invariant)(false);
    return state;
}
function $82ff74251c33b492$var$useRouteContext(hookName) {
    let route = $4tluv.useContext($82ff74251c33b492$export$9072aa6dd1f93057);
    !route && (0, $dtynv.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $82ff74251c33b492$var$useCurrentRouteId(hookName) {
    let route = $82ff74251c33b492$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $dtynv.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $82ff74251c33b492$export$5fc8298006ad9e58() {
    return $82ff74251c33b492$var$useCurrentRouteId($82ff74251c33b492$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $82ff74251c33b492$export$d0fd4b7106de2769() {
    let state = $82ff74251c33b492$var$useDataRouterState($82ff74251c33b492$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $82ff74251c33b492$export$600dc272ed516c15() {
    let dataRouterContext = $82ff74251c33b492$var$useDataRouterContext($82ff74251c33b492$var$DataRouterHook.UseRevalidator);
    let state = $82ff74251c33b492$var$useDataRouterState($82ff74251c33b492$var$DataRouterStateHook.UseRevalidator);
    return $4tluv.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $82ff74251c33b492$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $82ff74251c33b492$var$useDataRouterState($82ff74251c33b492$var$DataRouterStateHook.UseMatches);
    return $4tluv.useMemo(()=>matches.map((m)=>(0, $dtynv.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $82ff74251c33b492$export$1448a5050d252c4d() {
    let state = $82ff74251c33b492$var$useDataRouterState($82ff74251c33b492$var$DataRouterStateHook.UseLoaderData);
    let routeId = $82ff74251c33b492$var$useCurrentRouteId($82ff74251c33b492$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $82ff74251c33b492$export$fd5d37484eab868d(routeId) {
    let state = $82ff74251c33b492$var$useDataRouterState($82ff74251c33b492$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $82ff74251c33b492$export$fdc00f3f26066d5e() {
    let state = $82ff74251c33b492$var$useDataRouterState($82ff74251c33b492$var$DataRouterStateHook.UseActionData);
    let routeId = $82ff74251c33b492$var$useCurrentRouteId($82ff74251c33b492$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $82ff74251c33b492$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $4tluv.useContext($82ff74251c33b492$var$RouteErrorContext);
    let state = $82ff74251c33b492$var$useDataRouterState($82ff74251c33b492$var$DataRouterStateHook.UseRouteError);
    let routeId = $82ff74251c33b492$var$useCurrentRouteId($82ff74251c33b492$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $82ff74251c33b492$export$78a72ddb39bdd145() {
    let value = $4tluv.useContext($82ff74251c33b492$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $82ff74251c33b492$export$17f53340677d5831() {
    let value = $4tluv.useContext($82ff74251c33b492$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $82ff74251c33b492$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $82ff74251c33b492$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $82ff74251c33b492$var$useDataRouterContext($82ff74251c33b492$var$DataRouterHook.UseBlocker);
    let state = $82ff74251c33b492$var$useDataRouterState($82ff74251c33b492$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $4tluv.useState("");
    let blockerFunction = $4tluv.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $82ff74251c33b492$var$_extends({}, currentLocation, {
                pathname: (0, $dtynv.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $82ff74251c33b492$var$_extends({}, nextLocation, {
                pathname: (0, $dtynv.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $4tluv.useEffect(()=>{
        let key = String(++$82ff74251c33b492$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $4tluv.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $dtynv.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $82ff74251c33b492$var$useNavigateStable() {
    let { router: router } = $82ff74251c33b492$var$useDataRouterContext($82ff74251c33b492$var$DataRouterHook.UseNavigateStable);
    let id = $82ff74251c33b492$var$useCurrentRouteId($82ff74251c33b492$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $4tluv.useRef(false);
    $82ff74251c33b492$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $4tluv.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $82ff74251c33b492$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $82ff74251c33b492$var$alreadyWarned = {};
function $82ff74251c33b492$var$warningOnce(key, cond, message) {
    if (!cond && !$82ff74251c33b492$var$alreadyWarned[key]) $82ff74251c33b492$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $82ff74251c33b492$var$START_TRANSITION = "startTransition";
const $82ff74251c33b492$var$startTransitionImpl = $4tluv[$82ff74251c33b492$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $82ff74251c33b492$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $4tluv.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $4tluv.useCallback((newState)=>{
        if (v7_startTransition && $82ff74251c33b492$var$startTransitionImpl) $82ff74251c33b492$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $4tluv.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $4tluv.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $4tluv.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $4tluv.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $4tluv.createElement($4tluv.Fragment, null, /*#__PURE__*/ $4tluv.createElement($82ff74251c33b492$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $4tluv.createElement($82ff74251c33b492$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $4tluv.createElement($82ff74251c33b492$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $4tluv.createElement($82ff74251c33b492$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $82ff74251c33b492$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $82ff74251c33b492$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $82ff74251c33b492$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $4tluv.useRef();
    if (historyRef.current == null) historyRef.current = (0, $dtynv.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $4tluv.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $4tluv.useCallback((newState)=>{
        v7_startTransition && $82ff74251c33b492$var$startTransitionImpl ? $82ff74251c33b492$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $4tluv.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $4tluv.createElement($82ff74251c33b492$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $82ff74251c33b492$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$82ff74251c33b492$export$9c954a9d03d32f4a() && (0, $dtynv.UNSAFE_invariant)(false);
    let { future: future, static: isStatic } = $4tluv.useContext($82ff74251c33b492$export$26749e8557646306);
    let { matches: matches } = $4tluv.useContext($82ff74251c33b492$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $82ff74251c33b492$export$45d76561a5302f2b();
    let navigate = $82ff74251c33b492$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $dtynv.resolveTo)(to, (0, $dtynv.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $4tluv.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $82ff74251c33b492$export$910ae8079b2c2852(props) {
    return $82ff74251c33b492$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $82ff74251c33b492$export$e7b0ac011bb776c6(_props) {
    (0, $dtynv.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $82ff74251c33b492$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $dtynv.Action).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$82ff74251c33b492$export$9c954a9d03d32f4a() && (0, $dtynv.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $4tluv.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $82ff74251c33b492$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $dtynv.parsePath)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $4tluv.useMemo(()=>{
        let trailingPathname = (0, $dtynv.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $4tluv.createElement($82ff74251c33b492$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $4tluv.createElement($82ff74251c33b492$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $82ff74251c33b492$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $82ff74251c33b492$export$5d3fca4a98652595($82ff74251c33b492$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $82ff74251c33b492$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $4tluv.createElement($82ff74251c33b492$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $4tluv.createElement($82ff74251c33b492$var$ResolveAwait, null, children));
}
var $82ff74251c33b492$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($82ff74251c33b492$var$AwaitRenderStatus || {});
const $82ff74251c33b492$var$neverSettledPromise = new Promise(()=>{});
class $82ff74251c33b492$var$AwaitErrorBoundary extends $4tluv.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $82ff74251c33b492$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $82ff74251c33b492$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $82ff74251c33b492$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $82ff74251c33b492$var$AwaitRenderStatus.error : "_data" in promise ? $82ff74251c33b492$var$AwaitRenderStatus.success : $82ff74251c33b492$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $82ff74251c33b492$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $82ff74251c33b492$var$AwaitRenderStatus.error && promise._error instanceof (0, $dtynv.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw $82ff74251c33b492$var$neverSettledPromise;
        if (status === $82ff74251c33b492$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $82ff74251c33b492$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $4tluv.createElement($82ff74251c33b492$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $82ff74251c33b492$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $4tluv.createElement($82ff74251c33b492$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $82ff74251c33b492$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $82ff74251c33b492$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $4tluv.createElement($4tluv.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $82ff74251c33b492$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $4tluv.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $4tluv.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $4tluv.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $82ff74251c33b492$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $82ff74251c33b492$export$e7b0ac011bb776c6) && (0, $dtynv.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, $dtynv.UNSAFE_invariant)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $82ff74251c33b492$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $82ff74251c33b492$export$daf73786167a7f72(matches) {
    return $82ff74251c33b492$var$_renderMatches(matches);
}
function $82ff74251c33b492$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $4tluv.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $4tluv.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $4tluv.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $82ff74251c33b492$export$f30f7e456d254e83(routes, opts) {
    return (0, $dtynv.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $82ff74251c33b492$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $dtynv.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $82ff74251c33b492$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}

});


parcelRegister("aX5WL", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundary", () => $2d81aa6051fd745a$export$e926676385687eaf);

var $bgpJv = parcelRequire("bgpJv");

var $4tluv = parcelRequire("4tluv");

var $kbKpL = parcelRequire("kbKpL");
var $kfPot = parcelRequire("kfPot");

var $lIP59 = parcelRequire("lIP59");

var $8TrAC = parcelRequire("8TrAC");

var $dDtM2 = parcelRequire("dDtM2");
parcelRequire("1wxU2");
var $j0FUQ = parcelRequire("j0FUQ");
const $2d81aa6051fd745a$var$errorStyles = (0, $kfPot.xcss)({
    marginTop: "space.800",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    rowGap: "space.150"
});
const $2d81aa6051fd745a$var$errorHeaderStyles = (0, $kfPot.xcss)({
    font: "font.heading.medium",
    fontWeight: "font.weight.medium"
});
const $2d81aa6051fd745a$var$errorSubheaderStyles = (0, $kfPot.xcss)({
    font: "font.body"
});
const $2d81aa6051fd745a$var$defaultFallback = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $kbKpL.default), {
    testId: "default-error",
    xcss: $2d81aa6051fd745a$var$errorStyles
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $8TrAC.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $kbKpL.default), {
    xcss: $2d81aa6051fd745a$var$errorHeaderStyles
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $lIP59.default), (0, $dDtM2.messages).errorHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $kbKpL.default), {
    xcss: $2d81aa6051fd745a$var$errorSubheaderStyles
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $lIP59.default), (0, $dDtM2.messages).errorBoundarySubheader)));
const $2d81aa6051fd745a$export$e926676385687eaf = ({ children: children, fallback: fallback })=>{
    const reportUFOError = (0, $j0FUQ.useReportUFOError)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement($bgpJv.ErrorBoundary, {
        fallback: fallback ?? $2d81aa6051fd745a$var$defaultFallback,
        onError: reportUFOError
    }, children);
};

});
parcelRegister("lIP59", function(module, exports) {
$parcel$export(module.exports, "default", () => $fd0554d90cd4995b$export$2e2bcd8739ae039);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $fvB0y = parcelRequire("fvB0y");

var $4tluv = parcelRequire("4tluv");

var $cQG32 = parcelRequire("cQG32");

var $7Ywk8 = parcelRequire("7Ywk8");
function $fd0554d90cd4995b$var$areEqual(prevProps, nextProps) {
    var values = prevProps.values, otherProps = (0, $fvB0y.__rest)(prevProps, [
        "values"
    ]);
    var nextValues = nextProps.values, nextOtherProps = (0, $fvB0y.__rest)(nextProps, [
        "values"
    ]);
    return (0, $cQG32.shallowEqual)(nextValues, values) && (0, $cQG32.shallowEqual)(otherProps, nextOtherProps);
}
function $fd0554d90cd4995b$var$FormattedMessage(props) {
    var intl = (0, $7Ywk8.default)();
    var formatMessage = intl.formatMessage, _a = intl.textComponent, Text = _a === void 0 ? $4tluv.Fragment : _a;
    var id = props.id, description = props.description, defaultMessage = props.defaultMessage, values = props.values, children = props.children, _b = props.tagName, Component = _b === void 0 ? Text : _b, ignoreTag = props.ignoreTag;
    var descriptor = {
        id: id,
        description: description,
        defaultMessage: defaultMessage
    };
    var nodes = formatMessage(descriptor, values, {
        ignoreTag: ignoreTag
    });
    if (typeof children === 'function') return children(Array.isArray(nodes) ? nodes : [
        nodes
    ]);
    if (Component) return $4tluv.createElement(Component, null, nodes);
    return $4tluv.createElement($4tluv.Fragment, null, nodes);
}
$fd0554d90cd4995b$var$FormattedMessage.displayName = 'FormattedMessage';
var $fd0554d90cd4995b$var$MemoizedFormattedMessage = $4tluv.memo($fd0554d90cd4995b$var$FormattedMessage, $fd0554d90cd4995b$var$areEqual);
$fd0554d90cd4995b$var$MemoizedFormattedMessage.displayName = 'MemoizedFormattedMessage';
var $fd0554d90cd4995b$export$2e2bcd8739ae039 = $fd0554d90cd4995b$var$MemoizedFormattedMessage;

});
parcelRegister("fvB0y", function(module, exports) {
$parcel$export(module.exports, "__extends", () => $b4a67548ba0b40aa$export$a8ba968b8961cb8a);
$parcel$export(module.exports, "__assign", () => $b4a67548ba0b40aa$export$18ce0697a983be9b);
$parcel$export(module.exports, "__rest", () => $b4a67548ba0b40aa$export$3c9a16f847548506);
$parcel$export(module.exports, "__awaiter", () => $b4a67548ba0b40aa$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $b4a67548ba0b40aa$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__values", () => $b4a67548ba0b40aa$export$19a8beecd37a4c45);
$parcel$export(module.exports, "__read", () => $b4a67548ba0b40aa$export$8d051b38c9118094);
$parcel$export(module.exports, "__spread", () => $b4a67548ba0b40aa$export$afc72e2116322959);
$parcel$export(module.exports, "__spreadArray", () => $b4a67548ba0b40aa$export$1216008129fb82ed);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $b4a67548ba0b40aa$var$extendStatics = function(d, b) {
    $b4a67548ba0b40aa$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $b4a67548ba0b40aa$var$extendStatics(d, b);
};
function $b4a67548ba0b40aa$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $b4a67548ba0b40aa$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $b4a67548ba0b40aa$export$18ce0697a983be9b = function() {
    $b4a67548ba0b40aa$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b4a67548ba0b40aa$export$18ce0697a983be9b.apply(this, arguments);
};
function $b4a67548ba0b40aa$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $b4a67548ba0b40aa$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $b4a67548ba0b40aa$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $b4a67548ba0b40aa$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $b4a67548ba0b40aa$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $b4a67548ba0b40aa$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $b4a67548ba0b40aa$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $b4a67548ba0b40aa$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $b4a67548ba0b40aa$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $b4a67548ba0b40aa$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $b4a67548ba0b40aa$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $b4a67548ba0b40aa$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $b4a67548ba0b40aa$export$45d3717a4c69092e(o, m, p);
}
function $b4a67548ba0b40aa$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $b4a67548ba0b40aa$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $b4a67548ba0b40aa$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($b4a67548ba0b40aa$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $b4a67548ba0b40aa$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $b4a67548ba0b40aa$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $b4a67548ba0b40aa$export$10c90e4f7922046c(v) {
    return this instanceof $b4a67548ba0b40aa$export$10c90e4f7922046c ? (this.v = v, this) : new $b4a67548ba0b40aa$export$10c90e4f7922046c(v);
}
function $b4a67548ba0b40aa$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $b4a67548ba0b40aa$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $b4a67548ba0b40aa$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $b4a67548ba0b40aa$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $b4a67548ba0b40aa$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $b4a67548ba0b40aa$export$19a8beecd37a4c45 === "function" ? $b4a67548ba0b40aa$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $b4a67548ba0b40aa$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $b4a67548ba0b40aa$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $b4a67548ba0b40aa$var$ownKeys = function(o) {
    $b4a67548ba0b40aa$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $b4a67548ba0b40aa$var$ownKeys(o);
};
function $b4a67548ba0b40aa$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $b4a67548ba0b40aa$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $b4a67548ba0b40aa$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $b4a67548ba0b40aa$var$__setModuleDefault(result, mod);
    return result;
}
function $b4a67548ba0b40aa$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $b4a67548ba0b40aa$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $b4a67548ba0b40aa$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $b4a67548ba0b40aa$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $b4a67548ba0b40aa$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $b4a67548ba0b40aa$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $b4a67548ba0b40aa$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $b4a67548ba0b40aa$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $b4a67548ba0b40aa$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $b4a67548ba0b40aa$export$2e2bcd8739ae039 = {
    __extends: $b4a67548ba0b40aa$export$a8ba968b8961cb8a,
    __assign: $b4a67548ba0b40aa$export$18ce0697a983be9b,
    __rest: $b4a67548ba0b40aa$export$3c9a16f847548506,
    __decorate: $b4a67548ba0b40aa$export$29e00dfd3077644b,
    __param: $b4a67548ba0b40aa$export$d5ad3fd78186038f,
    __esDecorate: $b4a67548ba0b40aa$export$3a84e1ae4e97e9b0,
    __runInitializers: $b4a67548ba0b40aa$export$d831c04e792af3d,
    __propKey: $b4a67548ba0b40aa$export$6a2a36740a146cb8,
    __setFunctionName: $b4a67548ba0b40aa$export$d1a06452d3489bc7,
    __metadata: $b4a67548ba0b40aa$export$f1db080c865becb9,
    __awaiter: $b4a67548ba0b40aa$export$1050f835b63b671e,
    __generator: $b4a67548ba0b40aa$export$67ebef60e6f28a6,
    __createBinding: $b4a67548ba0b40aa$export$45d3717a4c69092e,
    __exportStar: $b4a67548ba0b40aa$export$f33643c0debef087,
    __values: $b4a67548ba0b40aa$export$19a8beecd37a4c45,
    __read: $b4a67548ba0b40aa$export$8d051b38c9118094,
    __spread: $b4a67548ba0b40aa$export$afc72e2116322959,
    __spreadArrays: $b4a67548ba0b40aa$export$6388937ca91ccae8,
    __spreadArray: $b4a67548ba0b40aa$export$1216008129fb82ed,
    __await: $b4a67548ba0b40aa$export$10c90e4f7922046c,
    __asyncGenerator: $b4a67548ba0b40aa$export$e427f37a30a4de9b,
    __asyncDelegator: $b4a67548ba0b40aa$export$bbd80228419bb833,
    __asyncValues: $b4a67548ba0b40aa$export$e3b29a3d6162315f,
    __makeTemplateObject: $b4a67548ba0b40aa$export$4fb47efe1390b86f,
    __importStar: $b4a67548ba0b40aa$export$c21735bcef00d192,
    __importDefault: $b4a67548ba0b40aa$export$da59b14a69baef04,
    __classPrivateFieldGet: $b4a67548ba0b40aa$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $b4a67548ba0b40aa$export$d40a35129aaff81f,
    __classPrivateFieldIn: $b4a67548ba0b40aa$export$81fdc39f203e4e04,
    __addDisposableResource: $b4a67548ba0b40aa$export$88ac25d8e944e405,
    __disposeResources: $b4a67548ba0b40aa$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $b4a67548ba0b40aa$export$889dfb5d17574b0b
};

});

parcelRegister("cQG32", function(module, exports) {
$parcel$export(module.exports, "invariant", () => $95aaf538d53927bf$export$f5708dca728d7177);
$parcel$export(module.exports, "invariantIntlContext", () => $95aaf538d53927bf$export$45c4bbf6e55bba1f);
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", () => $95aaf538d53927bf$export$b52f8d6fc0d47415);
$parcel$export(module.exports, "toKeyedReactNodeArray", () => $95aaf538d53927bf$export$d2fd241e0b53c057);
$parcel$export(module.exports, "assignUniqueKeysToParts", () => $95aaf538d53927bf$export$cfec03d26465fa63);
$parcel$export(module.exports, "shallowEqual", () => $95aaf538d53927bf$export$d36bdfa510afb180);

var $fvB0y = parcelRequire("fvB0y");

var $4tluv = parcelRequire("4tluv");

var $5wooz = parcelRequire("5wooz");
function $95aaf538d53927bf$export$f5708dca728d7177(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}
function $95aaf538d53927bf$export$45c4bbf6e55bba1f(intl) {
    $95aaf538d53927bf$export$f5708dca728d7177(intl, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
var $95aaf538d53927bf$export$b52f8d6fc0d47415 = (0, $fvB0y.__assign)((0, $fvB0y.__assign)({}, (0, $5wooz.DEFAULT_INTL_CONFIG)), {
    textComponent: $4tluv.Fragment
});
var $95aaf538d53927bf$var$toKeyedReactNode = function(reactNode, key) {
    return $4tluv.isValidElement(reactNode) ? $4tluv.cloneElement(reactNode, {
        key: key
    }) : reactNode;
};
var $95aaf538d53927bf$export$d2fd241e0b53c057 = function(children) {
    var _a;
    /**
 * Note: {@link React.Children.map} will add its own index-based prefix to
 * every key anyway, so the auto-injected one doesn't even have to be unique.
 * This basically just tells React that it's explicit/intentional.
 */ return (_a = $4tluv.Children.map(children, $95aaf538d53927bf$var$toKeyedReactNode)) !== null && _a !== void 0 ? _a : [];
};
function $95aaf538d53927bf$export$cfec03d26465fa63(formatXMLElementFn) {
    return function(parts) {
        // eslint-disable-next-line prefer-rest-params
        return formatXMLElementFn($95aaf538d53927bf$export$d2fd241e0b53c057(parts));
    };
}
function $95aaf538d53927bf$export$d36bdfa510afb180(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(var i = 0; i < len; i++){
        var key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}

});
parcelRegister("5wooz", function(module, exports) {
$parcel$export(module.exports, "invariant", () => $4052dd48ecdd4a9d$export$f5708dca728d7177);
$parcel$export(module.exports, "filterProps", () => $4052dd48ecdd4a9d$export$d697c39a2985a4c);
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", () => $4052dd48ecdd4a9d$export$b52f8d6fc0d47415);
$parcel$export(module.exports, "createIntlCache", () => $4052dd48ecdd4a9d$export$51c4f4e973f2dc00);
$parcel$export(module.exports, "createFormatters", () => $4052dd48ecdd4a9d$export$c3f4cd5551df13fd);
$parcel$export(module.exports, "getNamedFormat", () => $4052dd48ecdd4a9d$export$4ee1db8ce44a209b);

var $fvB0y = parcelRequire("fvB0y");

var $ibNg2 = parcelRequire("ibNg2");
parcelRequire("2d7mK");
var $1wqlV = parcelRequire("1wqlV");

var $9ZGqC = parcelRequire("9ZGqC");
function $4052dd48ecdd4a9d$export$f5708dca728d7177(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}
function $4052dd48ecdd4a9d$export$d697c39a2985a4c(props, allowlist, defaults) {
    if (defaults === void 0) defaults = {};
    return allowlist.reduce(function(filtered, name) {
        if (name in props) filtered[name] = props[name];
        else if (name in defaults) filtered[name] = defaults[name];
        return filtered;
    }, {});
}
var $4052dd48ecdd4a9d$var$defaultErrorHandler = function(error) {};
var $4052dd48ecdd4a9d$var$defaultWarnHandler = function(warning) {};
var $4052dd48ecdd4a9d$export$b52f8d6fc0d47415 = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: 'en',
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: $4052dd48ecdd4a9d$var$defaultErrorHandler,
    onWarn: $4052dd48ecdd4a9d$var$defaultWarnHandler
};
function $4052dd48ecdd4a9d$export$51c4f4e973f2dc00() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {}
    };
}
function $4052dd48ecdd4a9d$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $4052dd48ecdd4a9d$export$c3f4cd5551df13fd(cache) {
    if (cache === void 0) cache = $4052dd48ecdd4a9d$export$51c4f4e973f2dc00();
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    var ListFormat = Intl.ListFormat;
    var DisplayNames = Intl.DisplayNames;
    var getDateTimeFormat = (0, $ibNg2.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $fvB0y.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $4052dd48ecdd4a9d$var$createFastMemoizeCache(cache.dateTime),
        strategy: (0, $ibNg2.strategies).variadic
    });
    var getNumberFormat = (0, $ibNg2.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $fvB0y.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $4052dd48ecdd4a9d$var$createFastMemoizeCache(cache.number),
        strategy: (0, $ibNg2.strategies).variadic
    });
    var getPluralRules = (0, $ibNg2.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $fvB0y.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $4052dd48ecdd4a9d$var$createFastMemoizeCache(cache.pluralRules),
        strategy: (0, $ibNg2.strategies).variadic
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: (0, $ibNg2.memoize)(function(message, locales, overrideFormats, opts) {
            return new (0, $1wqlV.IntlMessageFormat)(message, locales, overrideFormats, (0, $fvB0y.__assign)({
                formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules
                }
            }, opts || {}));
        }, {
            cache: $4052dd48ecdd4a9d$var$createFastMemoizeCache(cache.message),
            strategy: (0, $ibNg2.strategies).variadic
        }),
        getRelativeTimeFormat: (0, $ibNg2.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, (0, $fvB0y.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $4052dd48ecdd4a9d$var$createFastMemoizeCache(cache.relativeTime),
            strategy: (0, $ibNg2.strategies).variadic
        }),
        getPluralRules: getPluralRules,
        getListFormat: (0, $ibNg2.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (ListFormat.bind.apply(ListFormat, (0, $fvB0y.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $4052dd48ecdd4a9d$var$createFastMemoizeCache(cache.list),
            strategy: (0, $ibNg2.strategies).variadic
        }),
        getDisplayNames: (0, $ibNg2.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (DisplayNames.bind.apply(DisplayNames, (0, $fvB0y.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $4052dd48ecdd4a9d$var$createFastMemoizeCache(cache.displayNames),
            strategy: (0, $ibNg2.strategies).variadic
        })
    };
}
function $4052dd48ecdd4a9d$export$4ee1db8ce44a209b(formats, type, name, onError) {
    var formatType = formats && formats[type];
    var format;
    if (formatType) format = formatType[name];
    if (format) return format;
    onError(new (0, $9ZGqC.UnsupportedFormatterError)("No ".concat(type, " format named: ").concat(name)));
}

});
parcelRegister("ibNg2", function(module, exports) {
$parcel$export(module.exports, "memoize", () => $d3df76a4c4525baa$export$fc10aeed3a532e2a);
$parcel$export(module.exports, "strategies", () => $d3df76a4c4525baa$export$c5491a8691a23b9e);
//
// Main
//
function $d3df76a4c4525baa$export$fc10aeed3a532e2a(fn, options) {
    var cache = options && options.cache ? options.cache : $d3df76a4c4525baa$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $d3df76a4c4525baa$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $d3df76a4c4525baa$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $d3df76a4c4525baa$var$isPrimitive(value) {
    return value == null || typeof value === 'number' || typeof value === 'boolean'; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $d3df76a4c4525baa$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $d3df76a4c4525baa$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $d3df76a4c4525baa$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $d3df76a4c4525baa$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $d3df76a4c4525baa$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $d3df76a4c4525baa$var$monadic : $d3df76a4c4525baa$var$variadic;
    return $d3df76a4c4525baa$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $d3df76a4c4525baa$var$strategyVariadic(fn, options) {
    return $d3df76a4c4525baa$var$assemble(fn, this, $d3df76a4c4525baa$var$variadic, options.cache.create(), options.serializer);
}
function $d3df76a4c4525baa$var$strategyMonadic(fn, options) {
    return $d3df76a4c4525baa$var$assemble(fn, this, $d3df76a4c4525baa$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $d3df76a4c4525baa$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
var $d3df76a4c4525baa$var$ObjectWithoutPrototypeCache = /** @class */ function() {
    function ObjectWithoutPrototypeCache() {
        this.cache = Object.create(null);
    }
    ObjectWithoutPrototypeCache.prototype.get = function(key) {
        return this.cache[key];
    };
    ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
        this.cache[key] = value;
    };
    return ObjectWithoutPrototypeCache;
}();
var $d3df76a4c4525baa$var$cacheDefault = {
    create: function create() {
        return new $d3df76a4c4525baa$var$ObjectWithoutPrototypeCache();
    }
};
var $d3df76a4c4525baa$export$c5491a8691a23b9e = {
    variadic: $d3df76a4c4525baa$var$strategyVariadic,
    monadic: $d3df76a4c4525baa$var$strategyMonadic
};

});

parcelRegister("2d7mK", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "ErrorCode", () => (parcelRequire("iqNwe")).ErrorCode);
$parcel$export(module.exports, "FormatError", () => (parcelRequire("iqNwe")).FormatError);
$parcel$export(module.exports, "isFormatXMLElementFn", () => (parcelRequire("gTMtP")).isFormatXMLElementFn);
$parcel$export(module.exports, "IntlMessageFormat", () => (parcelRequire("1wqlV")).IntlMessageFormat);
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $1wqlV = parcelRequire("1wqlV");
parcelRequire("iqNwe");
parcelRequire("gTMtP");
var $19c282646710fb2d$export$2e2bcd8739ae039 = (0, $1wqlV.IntlMessageFormat);

});
parcelRegister("1wqlV", function(module, exports) {
$parcel$export(module.exports, "IntlMessageFormat", () => $11bd38b368fb909a$export$d342343268debc40);
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $fvB0y = parcelRequire("fvB0y");

var $ibNg2 = parcelRequire("ibNg2");

var $35YLm = parcelRequire("35YLm");

var $gTMtP = parcelRequire("gTMtP");
// -- MessageFormat --------------------------------------------------------
function $11bd38b368fb909a$var$mergeConfig(c1, c2) {
    if (!c2) return c1;
    return (0, $fvB0y.__assign)((0, $fvB0y.__assign)((0, $fvB0y.__assign)({}, c1 || {}), c2 || {}), Object.keys(c1).reduce(function(all, k) {
        all[k] = (0, $fvB0y.__assign)((0, $fvB0y.__assign)({}, c1[k]), c2[k] || {});
        return all;
    }, {}));
}
function $11bd38b368fb909a$var$mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce(function(all, k) {
        all[k] = $11bd38b368fb909a$var$mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0, $fvB0y.__assign)({}, defaultConfig));
}
function $11bd38b368fb909a$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $11bd38b368fb909a$var$createDefaultFormatters(cache) {
    if (cache === void 0) cache = {
        number: {},
        dateTime: {},
        pluralRules: {}
    };
    return {
        getNumberFormat: (0, $ibNg2.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $fvB0y.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $11bd38b368fb909a$var$createFastMemoizeCache(cache.number),
            strategy: (0, $ibNg2.strategies).variadic
        }),
        getDateTimeFormat: (0, $ibNg2.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $fvB0y.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $11bd38b368fb909a$var$createFastMemoizeCache(cache.dateTime),
            strategy: (0, $ibNg2.strategies).variadic
        }),
        getPluralRules: (0, $ibNg2.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $fvB0y.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $11bd38b368fb909a$var$createFastMemoizeCache(cache.pluralRules),
            strategy: (0, $ibNg2.strategies).variadic
        })
    };
}
var $11bd38b368fb909a$export$d342343268debc40 = /** @class */ function() {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        if (locales === void 0) locales = IntlMessageFormat.defaultLocale;
        var _this = this;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {}
        };
        this.format = function(values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) return parts[0].value;
            var result = parts.reduce(function(all, part) {
                if (!all.length || part.type !== (0, $gTMtP.PART_TYPE).literal || typeof all[all.length - 1] !== 'string') all.push(part.value);
                else all[all.length - 1] += part.value;
                return all;
            }, []);
            if (result.length <= 1) return result[0] || '';
            return result;
        };
        this.formatToParts = function(values) {
            return (0, $gTMtP.formatToParts)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function() {
            var _a;
            return {
                locale: ((_a = _this.resolvedLocale) === null || _a === void 0 ? void 0 : _a.toString()) || Intl.NumberFormat.supportedLocalesOf(_this.locales)[0]
            };
        };
        this.getAst = function() {
            return _this.ast;
        };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === 'string') {
            this.message = message;
            if (!IntlMessageFormat.__parse) throw new TypeError('IntlMessageFormat.__parse must be set to process `message` of type `string`');
            var _a = opts || {}, formatters = _a.formatters, parseOpts = (0, $fvB0y.__rest)(_a, [
                "formatters"
            ]);
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, (0, $fvB0y.__assign)((0, $fvB0y.__assign)({}, parseOpts), {
                locale: this.resolvedLocale
            }));
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError('A message must be provided as a String or AST.');
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = $11bd38b368fb909a$var$mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters = opts && opts.formatters || $11bd38b368fb909a$var$createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function() {
            if (!IntlMessageFormat.memoizedDefaultLocale) IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function(locales) {
        if (typeof Intl.Locale === 'undefined') return;
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
        return new Intl.Locale(typeof locales === 'string' ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = (0, $35YLm.parse);
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0
            },
            currency: {
                style: 'currency'
            },
            percent: {
                style: 'percent'
            }
        },
        date: {
            short: {
                month: 'numeric',
                day: 'numeric',
                year: '2-digit'
            },
            medium: {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
            },
            long: {
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            },
            full: {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            }
        },
        time: {
            short: {
                hour: 'numeric',
                minute: 'numeric'
            },
            medium: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },
            long: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            },
            full: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            }
        }
    };
    return IntlMessageFormat;
}();

});
parcelRegister("35YLm", function(module, exports) {
$parcel$export(module.exports, "isArgumentElement", () => (parcelRequire("caG7o")).isArgumentElement);
$parcel$export(module.exports, "isDateElement", () => (parcelRequire("caG7o")).isDateElement);
$parcel$export(module.exports, "isDateTimeSkeleton", () => (parcelRequire("caG7o")).isDateTimeSkeleton);
$parcel$export(module.exports, "isLiteralElement", () => (parcelRequire("caG7o")).isLiteralElement);
$parcel$export(module.exports, "isNumberElement", () => (parcelRequire("caG7o")).isNumberElement);
$parcel$export(module.exports, "isNumberSkeleton", () => (parcelRequire("caG7o")).isNumberSkeleton);
$parcel$export(module.exports, "isPluralElement", () => (parcelRequire("caG7o")).isPluralElement);
$parcel$export(module.exports, "isPoundElement", () => (parcelRequire("caG7o")).isPoundElement);
$parcel$export(module.exports, "isSelectElement", () => (parcelRequire("caG7o")).isSelectElement);
$parcel$export(module.exports, "isTagElement", () => (parcelRequire("caG7o")).isTagElement);
$parcel$export(module.exports, "isTimeElement", () => (parcelRequire("caG7o")).isTimeElement);
$parcel$export(module.exports, "TYPE", () => (parcelRequire("caG7o")).TYPE);
$parcel$export(module.exports, "parse", () => $2410f8fa3c946398$export$98e6a39c04603d36);

var $fvB0y = parcelRequire("fvB0y");

var $cWGBc = parcelRequire("cWGBc");

var $2R1G3 = parcelRequire("2R1G3");

var $caG7o = parcelRequire("caG7o");

var $13hEe = parcelRequire("13hEe");
function $2410f8fa3c946398$var$pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, $caG7o.isSelectElement)(el) || (0, $caG7o.isPluralElement)(el)) for(var k in el.options){
            delete el.options[k].location;
            $2410f8fa3c946398$var$pruneLocation(el.options[k].value);
        }
        else if ((0, $caG7o.isNumberElement)(el) && (0, $caG7o.isNumberSkeleton)(el.style)) delete el.style.location;
        else if (((0, $caG7o.isDateElement)(el) || (0, $caG7o.isTimeElement)(el)) && (0, $caG7o.isDateTimeSkeleton)(el.style)) delete el.style.location;
        else if ((0, $caG7o.isTagElement)(el)) $2410f8fa3c946398$var$pruneLocation(el.children);
    });
}
function $2410f8fa3c946398$export$98e6a39c04603d36(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, $fvB0y.__assign)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, $2R1G3.Parser)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, $cWGBc.ErrorKind)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) $2410f8fa3c946398$var$pruneLocation(result.val);
    return result.val;
}
var $2410f8fa3c946398$export$d3c1bfa0f7d806e9 = (0, $2R1G3.Parser);

});
parcelRegister("cWGBc", function(module, exports) {
$parcel$export(module.exports, "ErrorKind", () => $96cbf219e66e299e$export$896afd8541959ee5);
var $96cbf219e66e299e$export$896afd8541959ee5;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})($96cbf219e66e299e$export$896afd8541959ee5 || ($96cbf219e66e299e$export$896afd8541959ee5 = {}));

});

parcelRegister("2R1G3", function(module, exports) {
$parcel$export(module.exports, "Parser", () => $2141d51708599e4d$export$7acfa6ed01010e37);

var $fvB0y = parcelRequire("fvB0y");

var $cWGBc = parcelRequire("cWGBc");

var $caG7o = parcelRequire("caG7o");

var $gtPoV = parcelRequire("gtPoV");
parcelRequire("krJNb");
var $71IYY = parcelRequire("71IYY");
var $kt6M3 = parcelRequire("kt6M3");

var $b40Af = parcelRequire("b40Af");
var $2141d51708599e4d$var$_a;
var $2141d51708599e4d$var$SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, $gtPoV.SPACE_SEPARATOR_REGEX).source, "*"));
var $2141d51708599e4d$var$SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, $gtPoV.SPACE_SEPARATOR_REGEX).source, "*$"));
function $2141d51708599e4d$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var $2141d51708599e4d$var$hasNativeStartsWith = !!String.prototype.startsWith && '_a'.startsWith('a', 1);
var $2141d51708599e4d$var$hasNativeFromCodePoint = !!String.fromCodePoint;
var $2141d51708599e4d$var$hasNativeFromEntries = !!Object.fromEntries;
var $2141d51708599e4d$var$hasNativeCodePointAt = !!String.prototype.codePointAt;
var $2141d51708599e4d$var$hasTrimStart = !!String.prototype.trimStart;
var $2141d51708599e4d$var$hasTrimEnd = !!String.prototype.trimEnd;
var $2141d51708599e4d$var$hasNativeIsSafeInteger = !!Number.isSafeInteger;
var $2141d51708599e4d$var$isSafeInteger = $2141d51708599e4d$var$hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === 'number' && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var $2141d51708599e4d$var$REGEX_SUPPORTS_U_AND_Y = true;
try {
    var $2141d51708599e4d$var$re = $2141d51708599e4d$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ $2141d51708599e4d$var$REGEX_SUPPORTS_U_AND_Y = (($2141d51708599e4d$var$_a = $2141d51708599e4d$var$re.exec('a')) === null || $2141d51708599e4d$var$_a === void 0 ? void 0 : $2141d51708599e4d$var$_a[0]) === 'a';
} catch (_) {
    $2141d51708599e4d$var$REGEX_SUPPORTS_U_AND_Y = false;
}
var $2141d51708599e4d$var$startsWith = $2141d51708599e4d$var$hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var $2141d51708599e4d$var$fromCodePoint = $2141d51708599e4d$var$hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = '';
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + ' is not a valid code point');
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var $2141d51708599e4d$var$fromEntries = // native
$2141d51708599e4d$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var $2141d51708599e4d$var$codePointAt = $2141d51708599e4d$var$hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var $2141d51708599e4d$var$trimStart = $2141d51708599e4d$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($2141d51708599e4d$var$SPACE_SEPARATOR_START_REGEX, '');
};
var $2141d51708599e4d$var$trimEnd = $2141d51708599e4d$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($2141d51708599e4d$var$SPACE_SEPARATOR_END_REGEX, '');
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function $2141d51708599e4d$var$RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var $2141d51708599e4d$var$matchIdentifierAtIndex;
if ($2141d51708599e4d$var$REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var $2141d51708599e4d$var$IDENTIFIER_PREFIX_RE_1 = $2141d51708599e4d$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    $2141d51708599e4d$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        $2141d51708599e4d$var$IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = $2141d51708599e4d$var$IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : '';
    };
} else // IE11
$2141d51708599e4d$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = $2141d51708599e4d$var$codePointAt(s, index);
        if (c === undefined || $2141d51708599e4d$var$_isWhiteSpace(c) || $2141d51708599e4d$var$_isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return $2141d51708599e4d$var$fromCodePoint.apply(void 0, match);
};
var $2141d51708599e4d$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error('parser can only be used once');
        return this.parseMessage(0, '', false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal')) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, $caG7o.TYPE).pound,
                    location: $2141d51708599e4d$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, $cWGBc.ErrorKind).UNMATCHED_CLOSING_TAG, $2141d51708599e4d$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && $2141d51708599e4d$var$_isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf('/>')) // Self closing tag
        return {
            val: {
                type: (0, $caG7o.TYPE).literal,
                value: "<".concat(tagName, "/>"),
                location: $2141d51708599e4d$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf('>')) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf('</')) {
                if (this.isEOF() || !$2141d51708599e4d$var$_isAlpha(this.char())) return this.error((0, $cWGBc.ErrorKind).INVALID_TAG, $2141d51708599e4d$var$createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, $cWGBc.ErrorKind).UNMATCHED_CLOSING_TAG, $2141d51708599e4d$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf('>')) return this.error((0, $cWGBc.ErrorKind).INVALID_TAG, $2141d51708599e4d$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, $caG7o.TYPE).tag,
                        value: tagName,
                        children: children,
                        location: $2141d51708599e4d$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, $cWGBc.ErrorKind).UNCLOSED_TAG, $2141d51708599e4d$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, $cWGBc.ErrorKind).INVALID_TAG, $2141d51708599e4d$var$createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && $2141d51708599e4d$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = '';
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = $2141d51708599e4d$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, $caG7o.TYPE).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !$2141d51708599e4d$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return '<';
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === 'plural' || parentArgType === 'selectordinal') break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return $2141d51708599e4d$var$fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal') || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return $2141d51708599e4d$var$fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $cWGBc.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $2141d51708599e4d$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, $cWGBc.ErrorKind).EMPTY_ARGUMENT, $2141d51708599e4d$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, $cWGBc.ErrorKind).MALFORMED_ARGUMENT, $2141d51708599e4d$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $cWGBc.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $2141d51708599e4d$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, $caG7o.TYPE).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: $2141d51708599e4d$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, $cWGBc.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $2141d51708599e4d$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, $cWGBc.ErrorKind).MALFORMED_ARGUMENT, $2141d51708599e4d$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = $2141d51708599e4d$var$matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = $2141d51708599e4d$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case '':
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, $cWGBc.ErrorKind).EXPECT_ARGUMENT_TYPE, $2141d51708599e4d$var$createLocation(typeStartPosition, typeEndPosition));
            case 'number':
            case 'date':
            case 'time':
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(',')) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = $2141d51708599e4d$var$trimEnd(result.val);
                    if (style.length === 0) return this.error((0, $cWGBc.ErrorKind).EXPECT_ARGUMENT_STYLE, $2141d51708599e4d$var$createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = $2141d51708599e4d$var$createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = $2141d51708599e4d$var$createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && $2141d51708599e4d$var$startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, '::', 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = $2141d51708599e4d$var$trimStart(styleAndLocation.style.slice(2));
                    if (argType === 'number') {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, $caG7o.TYPE).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, $cWGBc.ErrorKind).EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, $b40Af.getBestPattern)(skeleton, this.locale);
                        var style = {
                            type: (0, $caG7o.SKELETON_TYPE).dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, $71IYY.parseDateTimeSkeleton)(dateTimePattern) : {}
                        };
                        var type = argType === 'date' ? (0, $caG7o.TYPE).date : (0, $caG7o.TYPE).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === 'number' ? (0, $caG7o.TYPE).number : argType === 'date' ? (0, $caG7o.TYPE).date : (0, $caG7o.TYPE).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case 'plural':
            case 'selectordinal':
            case 'select':
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(',')) return this.error((0, $cWGBc.ErrorKind).EXPECT_SELECT_ARGUMENT_OPTIONS, $2141d51708599e4d$var$createLocation(typeEndPosition_1, (0, $fvB0y.__assign)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== 'select' && identifierAndLocation.value === 'offset') {
                    if (!this.bumpIf(':')) return this.error((0, $cWGBc.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $2141d51708599e4d$var$createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, $cWGBc.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, $cWGBc.ErrorKind).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = $2141d51708599e4d$var$createLocation(openingBracePosition, this.clonePosition());
                if (argType === 'select') return {
                    val: {
                        type: (0, $caG7o.TYPE).select,
                        value: value,
                        options: $2141d51708599e4d$var$fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, $caG7o.TYPE).plural,
                        value: value,
                        options: $2141d51708599e4d$var$fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === 'plural' ? 'cardinal' : 'ordinal',
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, $cWGBc.ErrorKind).INVALID_ARGUMENT_TYPE, $2141d51708599e4d$var$createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, $cWGBc.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $2141d51708599e4d$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, $cWGBc.ErrorKind).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $2141d51708599e4d$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, $kt6M3.parseNumberSkeletonFromString)(skeleton);
        } catch (e) {
            return this.error((0, $cWGBc.ErrorKind).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, $caG7o.SKELETON_TYPE).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $kt6M3.parseNumberSkeleton)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== 'select' && this.bumpIf('=')) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, $cWGBc.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, $cWGBc.ErrorKind).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $2141d51708599e4d$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === 'select' ? (0, $cWGBc.ErrorKind).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, $cWGBc.ErrorKind).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === 'other') hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf('{')) return this.error(parentArgType === 'select' ? (0, $cWGBc.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, $cWGBc.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $2141d51708599e4d$var$createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $2141d51708599e4d$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === 'select' ? (0, $cWGBc.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, $cWGBc.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, $2141d51708599e4d$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, $cWGBc.ErrorKind).MISSING_OTHER_CLAUSE, $2141d51708599e4d$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf('+')) ;
        else if (this.bumpIf('-')) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = $2141d51708599e4d$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!$2141d51708599e4d$var$isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error('out of bound');
        var code = $2141d51708599e4d$var$codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if ($2141d51708599e4d$var$startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && $2141d51708599e4d$var$_isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function $2141d51708599e4d$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $2141d51708599e4d$var$_isAlphaOrSlash(codepoint) {
    return $2141d51708599e4d$var$_isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function $2141d51708599e4d$var$_isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $2141d51708599e4d$var$_isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $2141d51708599e4d$var$_isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}

});
parcelRegister("caG7o", function(module, exports) {
$parcel$export(module.exports, "TYPE", () => $8dc717090f09b373$export$b87f371cbc396fcf);
$parcel$export(module.exports, "SKELETON_TYPE", () => $8dc717090f09b373$export$906452485466fa53);
$parcel$export(module.exports, "isLiteralElement", () => $8dc717090f09b373$export$cfa10c5697238752);
$parcel$export(module.exports, "isArgumentElement", () => $8dc717090f09b373$export$4f55724281bdfaf9);
$parcel$export(module.exports, "isNumberElement", () => $8dc717090f09b373$export$e11187b219e191e1);
$parcel$export(module.exports, "isDateElement", () => $8dc717090f09b373$export$32d811605da75f40);
$parcel$export(module.exports, "isTimeElement", () => $8dc717090f09b373$export$34ec46f596b1702f);
$parcel$export(module.exports, "isSelectElement", () => $8dc717090f09b373$export$dcfe1c11d168b5a1);
$parcel$export(module.exports, "isPluralElement", () => $8dc717090f09b373$export$6c796d116f0a4fbc);
$parcel$export(module.exports, "isPoundElement", () => $8dc717090f09b373$export$c0ece297bdd0c082);
$parcel$export(module.exports, "isTagElement", () => $8dc717090f09b373$export$5c83de34745812b);
$parcel$export(module.exports, "isNumberSkeleton", () => $8dc717090f09b373$export$3f9a19cd4152eda3);
$parcel$export(module.exports, "isDateTimeSkeleton", () => $8dc717090f09b373$export$7680c41f1a55f4cf);
var $8dc717090f09b373$export$b87f371cbc396fcf;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})($8dc717090f09b373$export$b87f371cbc396fcf || ($8dc717090f09b373$export$b87f371cbc396fcf = {}));
var $8dc717090f09b373$export$906452485466fa53;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})($8dc717090f09b373$export$906452485466fa53 || ($8dc717090f09b373$export$906452485466fa53 = {}));
function $8dc717090f09b373$export$cfa10c5697238752(el) {
    return el.type === $8dc717090f09b373$export$b87f371cbc396fcf.literal;
}
function $8dc717090f09b373$export$4f55724281bdfaf9(el) {
    return el.type === $8dc717090f09b373$export$b87f371cbc396fcf.argument;
}
function $8dc717090f09b373$export$e11187b219e191e1(el) {
    return el.type === $8dc717090f09b373$export$b87f371cbc396fcf.number;
}
function $8dc717090f09b373$export$32d811605da75f40(el) {
    return el.type === $8dc717090f09b373$export$b87f371cbc396fcf.date;
}
function $8dc717090f09b373$export$34ec46f596b1702f(el) {
    return el.type === $8dc717090f09b373$export$b87f371cbc396fcf.time;
}
function $8dc717090f09b373$export$dcfe1c11d168b5a1(el) {
    return el.type === $8dc717090f09b373$export$b87f371cbc396fcf.select;
}
function $8dc717090f09b373$export$6c796d116f0a4fbc(el) {
    return el.type === $8dc717090f09b373$export$b87f371cbc396fcf.plural;
}
function $8dc717090f09b373$export$c0ece297bdd0c082(el) {
    return el.type === $8dc717090f09b373$export$b87f371cbc396fcf.pound;
}
function $8dc717090f09b373$export$5c83de34745812b(el) {
    return el.type === $8dc717090f09b373$export$b87f371cbc396fcf.tag;
}
function $8dc717090f09b373$export$3f9a19cd4152eda3(el) {
    return !!(el && typeof el === 'object' && el.type === $8dc717090f09b373$export$906452485466fa53.number);
}
function $8dc717090f09b373$export$7680c41f1a55f4cf(el) {
    return !!(el && typeof el === 'object' && el.type === $8dc717090f09b373$export$906452485466fa53.dateTime);
}
function $8dc717090f09b373$export$f0ac572c1121c662(value) {
    return {
        type: $8dc717090f09b373$export$b87f371cbc396fcf.literal,
        value: value
    };
}
function $8dc717090f09b373$export$425e864b0ba114f1(value, style) {
    return {
        type: $8dc717090f09b373$export$b87f371cbc396fcf.number,
        value: value,
        style: style
    };
}

});

parcelRegister("gtPoV", function(module, exports) {
$parcel$export(module.exports, "SPACE_SEPARATOR_REGEX", () => $bff739f60d54814b$export$523451f94304dd6c);
// @generated from regex-gen.ts
var $bff739f60d54814b$export$523451f94304dd6c = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var $bff739f60d54814b$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;

});

parcelRegister("krJNb", function(module, exports) {
$parcel$export(module.exports, "parseDateTimeSkeleton", () => (parcelRequire("71IYY")).parseDateTimeSkeleton);
$parcel$export(module.exports, "parseNumberSkeleton", () => (parcelRequire("kt6M3")).parseNumberSkeleton);
$parcel$export(module.exports, "parseNumberSkeletonFromString", () => (parcelRequire("kt6M3")).parseNumberSkeletonFromString);
parcelRequire("71IYY");
parcelRequire("kt6M3");

});
parcelRegister("71IYY", function(module, exports) {
$parcel$export(module.exports, "parseDateTimeSkeleton", () => $51db84fe11f218a9$export$f7b99fb377fe69fa);
/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */ var $51db84fe11f218a9$var$DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function $51db84fe11f218a9$export$f7b99fb377fe69fa(skeleton) {
    var result = {};
    skeleton.replace($51db84fe11f218a9$var$DATE_TIME_REGEX, function(match) {
        var len = match.length;
        switch(match[0]){
            // Era
            case 'G':
                result.era = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            // Year
            case 'y':
                result.year = len === 2 ? '2-digit' : 'numeric';
                break;
            case 'Y':
            case 'u':
            case 'U':
            case 'r':
                throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
            // Quarter
            case 'q':
            case 'Q':
                throw new RangeError('`q/Q` (quarter) patterns are not supported');
            // Month
            case 'M':
            case 'L':
                result.month = [
                    'numeric',
                    '2-digit',
                    'short',
                    'long',
                    'narrow'
                ][len - 1];
                break;
            // Week
            case 'w':
            case 'W':
                throw new RangeError('`w/W` (week) patterns are not supported');
            case 'd':
                result.day = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'D':
            case 'F':
            case 'g':
                throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
            // Weekday
            case 'E':
                result.weekday = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            case 'e':
                if (len < 4) throw new RangeError('`e..eee` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            case 'c':
                if (len < 4) throw new RangeError('`c..ccc` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            // Period
            case 'a':
                result.hour12 = true;
                break;
            case 'b':
            case 'B':
                throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
            // Hour
            case 'h':
                result.hourCycle = 'h12';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'H':
                result.hourCycle = 'h23';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'K':
                result.hourCycle = 'h11';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'k':
                result.hourCycle = 'h24';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'j':
            case 'J':
            case 'C':
                throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
            // Minute
            case 'm':
                result.minute = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            // Second
            case 's':
                result.second = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'S':
            case 'A':
                throw new RangeError('`S/A` (second) patterns are not supported, use `s` instead');
            // Zone
            case 'z':
                result.timeZoneName = len < 4 ? 'short' : 'long';
                break;
            case 'Z':
            case 'O':
            case 'v':
            case 'V':
            case 'X':
            case 'x':
                throw new RangeError('`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead');
        }
        return '';
    });
    return result;
}

});

parcelRegister("kt6M3", function(module, exports) {
$parcel$export(module.exports, "parseNumberSkeletonFromString", () => $ee6bc547f2b92e3a$export$71cee2f16fba2480);
$parcel$export(module.exports, "parseNumberSkeleton", () => $ee6bc547f2b92e3a$export$47c6f8480bda3e11);

var $fvB0y = parcelRequire("fvB0y");

var $4ll5Z = parcelRequire("4ll5Z");
function $ee6bc547f2b92e3a$export$71cee2f16fba2480(skeleton) {
    if (skeleton.length === 0) throw new Error('Number skeleton cannot be empty');
    // Parse the skeleton
    var stringTokens = skeleton.split((0, $4ll5Z.WHITE_SPACE_REGEX)).filter(function(x) {
        return x.length > 0;
    });
    var tokens = [];
    for(var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++){
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split('/');
        if (stemAndOptions.length === 0) throw new Error('Invalid number skeleton');
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for(var _a = 0, options_1 = options; _a < options_1.length; _a++){
            var option = options_1[_a];
            if (option.length === 0) throw new Error('Invalid number skeleton');
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
function $ee6bc547f2b92e3a$var$icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, '');
}
var $ee6bc547f2b92e3a$var$FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var $ee6bc547f2b92e3a$var$SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var $ee6bc547f2b92e3a$var$INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var $ee6bc547f2b92e3a$var$CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function $ee6bc547f2b92e3a$var$parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === 'r') result.roundingPriority = 'morePrecision';
    else if (str[str.length - 1] === 's') result.roundingPriority = 'lessPrecision';
    str.replace($ee6bc547f2b92e3a$var$SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== 'string') {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === '+') result.minimumSignificantDigits = g1.length;
        else if (g1[0] === '#') result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === 'string' ? g2.length : 0);
        }
        return '';
    });
    return result;
}
function $ee6bc547f2b92e3a$var$parseSign(str) {
    switch(str){
        case 'sign-auto':
            return {
                signDisplay: 'auto'
            };
        case 'sign-accounting':
        case '()':
            return {
                currencySign: 'accounting'
            };
        case 'sign-always':
        case '+!':
            return {
                signDisplay: 'always'
            };
        case 'sign-accounting-always':
        case '()!':
            return {
                signDisplay: 'always',
                currencySign: 'accounting'
            };
        case 'sign-except-zero':
        case '+?':
            return {
                signDisplay: 'exceptZero'
            };
        case 'sign-accounting-except-zero':
        case '()?':
            return {
                signDisplay: 'exceptZero',
                currencySign: 'accounting'
            };
        case 'sign-never':
        case '+_':
            return {
                signDisplay: 'never'
            };
    }
}
function $ee6bc547f2b92e3a$var$parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === 'E' && stem[1] === 'E') {
        result = {
            notation: 'engineering'
        };
        stem = stem.slice(2);
    } else if (stem[0] === 'E') {
        result = {
            notation: 'scientific'
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === '+!') {
            result.signDisplay = 'always';
            stem = stem.slice(2);
        } else if (signDisplay === '+?') {
            result.signDisplay = 'exceptZero';
            stem = stem.slice(2);
        }
        if (!$ee6bc547f2b92e3a$var$CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error('Malformed concise eng/scientific notation');
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function $ee6bc547f2b92e3a$var$parseNotationOptions(opt) {
    var result = {};
    var signOpts = $ee6bc547f2b92e3a$var$parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
function $ee6bc547f2b92e3a$export$47c6f8480bda3e11(tokens) {
    var result = {};
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        switch(token.stem){
            case 'percent':
            case '%':
                result.style = 'percent';
                continue;
            case '%x100':
                result.style = 'percent';
                result.scale = 100;
                continue;
            case 'currency':
                result.style = 'currency';
                result.currency = token.options[0];
                continue;
            case 'group-off':
            case ',_':
                result.useGrouping = false;
                continue;
            case 'precision-integer':
            case '.':
                result.maximumFractionDigits = 0;
                continue;
            case 'measure-unit':
            case 'unit':
                result.style = 'unit';
                result.unit = $ee6bc547f2b92e3a$var$icuUnitToEcma(token.options[0]);
                continue;
            case 'compact-short':
            case 'K':
                result.notation = 'compact';
                result.compactDisplay = 'short';
                continue;
            case 'compact-long':
            case 'KK':
                result.notation = 'compact';
                result.compactDisplay = 'long';
                continue;
            case 'scientific':
                result = (0, $fvB0y.__assign)((0, $fvB0y.__assign)((0, $fvB0y.__assign)({}, result), {
                    notation: 'scientific'
                }), token.options.reduce(function(all, opt) {
                    return (0, $fvB0y.__assign)((0, $fvB0y.__assign)({}, all), $ee6bc547f2b92e3a$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'engineering':
                result = (0, $fvB0y.__assign)((0, $fvB0y.__assign)((0, $fvB0y.__assign)({}, result), {
                    notation: 'engineering'
                }), token.options.reduce(function(all, opt) {
                    return (0, $fvB0y.__assign)((0, $fvB0y.__assign)({}, all), $ee6bc547f2b92e3a$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'notation-simple':
                result.notation = 'standard';
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case 'unit-width-narrow':
                result.currencyDisplay = 'narrowSymbol';
                result.unitDisplay = 'narrow';
                continue;
            case 'unit-width-short':
                result.currencyDisplay = 'code';
                result.unitDisplay = 'short';
                continue;
            case 'unit-width-full-name':
                result.currencyDisplay = 'name';
                result.unitDisplay = 'long';
                continue;
            case 'unit-width-iso-code':
                result.currencyDisplay = 'symbol';
                continue;
            case 'scale':
                result.scale = parseFloat(token.options[0]);
                continue;
            case 'rounding-mode-floor':
                result.roundingMode = 'floor';
                continue;
            case 'rounding-mode-ceiling':
                result.roundingMode = 'ceil';
                continue;
            case 'rounding-mode-down':
                result.roundingMode = 'trunc';
                continue;
            case 'rounding-mode-up':
                result.roundingMode = 'expand';
                continue;
            case 'rounding-mode-half-even':
                result.roundingMode = 'halfEven';
                continue;
            case 'rounding-mode-half-down':
                result.roundingMode = 'halfTrunc';
                continue;
            case 'rounding-mode-half-up':
                result.roundingMode = 'halfExpand';
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case 'integer-width':
                if (token.options.length > 1) throw new RangeError('integer-width stems only accept a single optional option');
                token.options[0].replace($ee6bc547f2b92e3a$var$INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error('We currently do not support maximum integer digits');
                    else if (g5) throw new Error('We currently do not support exact integer digits');
                    return '';
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if ($ee6bc547f2b92e3a$var$CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if ($ee6bc547f2b92e3a$var$FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError('Fraction-precision stems only accept a single optional option');
            token.stem.replace($ee6bc547f2b92e3a$var$FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === '*') result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === '#') result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return '';
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === 'w') result = (0, $fvB0y.__assign)((0, $fvB0y.__assign)({}, result), {
                trailingZeroDisplay: 'stripIfInteger'
            });
            else if (opt) result = (0, $fvB0y.__assign)((0, $fvB0y.__assign)({}, result), $ee6bc547f2b92e3a$var$parseSignificantPrecision(opt));
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if ($ee6bc547f2b92e3a$var$SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0, $fvB0y.__assign)((0, $fvB0y.__assign)({}, result), $ee6bc547f2b92e3a$var$parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = $ee6bc547f2b92e3a$var$parseSign(token.stem);
        if (signOpts) result = (0, $fvB0y.__assign)((0, $fvB0y.__assign)({}, result), signOpts);
        var conciseScientificAndEngineeringOpts = $ee6bc547f2b92e3a$var$parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = (0, $fvB0y.__assign)((0, $fvB0y.__assign)({}, result), conciseScientificAndEngineeringOpts);
    }
    return result;
}

});
parcelRegister("4ll5Z", function(module, exports) {
$parcel$export(module.exports, "WHITE_SPACE_REGEX", () => $32997cbb8625e22f$export$2b8db14d8bcaece7);
// @generated from regex-gen.ts
var $32997cbb8625e22f$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

});



parcelRegister("b40Af", function(module, exports) {
$parcel$export(module.exports, "getBestPattern", () => $80e085567c47965b$export$29c5368be8904d27);

var $g3EmS = parcelRequire("g3EmS");
function $80e085567c47965b$export$29c5368be8904d27(skeleton, locale) {
    var skeletonCopy = '';
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === 'j') {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = 'a';
            var hourChar = $80e085567c47965b$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == 'H' || hourChar == 'k') dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === 'J') skeletonCopy += 'H';
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function $80e085567c47965b$var$getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case 'h24':
            return 'k';
        case 'h23':
            return 'H';
        case 'h12':
            return 'h';
        case 'h11':
            return 'K';
        default:
            throw new Error('Invalid hourCycle');
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== 'root') regionTag = locale.maximize().region;
    var hourCycles = (0, $g3EmS.timeData)[regionTag || ''] || (0, $g3EmS.timeData)[languageTag || ''] || (0, $g3EmS.timeData)["".concat(languageTag, "-001")] || (0, $g3EmS.timeData)['001'];
    return hourCycles[0];
}

});
parcelRegister("g3EmS", function(module, exports) {
$parcel$export(module.exports, "timeData", () => $bb0c3d656f5d3d23$export$a8c9209db4084317);
// @generated from time-data-gen.ts
// prettier-ignore  
var $bb0c3d656f5d3d23$export$a8c9209db4084317 = {
    "001": [
        "H",
        "h"
    ],
    "419": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AS": [
        "h",
        "H"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "AX": [
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BI": [
        "H",
        "h"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "BO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "BQ": [
        "H"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BT": [
        "h",
        "H"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BY": [
        "H",
        "h"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CL": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CP": [
        "H"
    ],
    "CR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CU": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "CW": [
        "H",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CZ": [
        "H"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "DK": [
        "H"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EC": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "FI": [
        "H"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FO": [
        "H",
        "h"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GH": [
        "h",
        "H"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GL": [
        "H",
        "h"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GT": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HN": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "HU": [
        "H",
        "h"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ID": [
        "H"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IN": [
        "h",
        "H"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "IS": [
        "H"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JP": [
        "H",
        "K",
        "h"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LS": [
        "h",
        "H"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MG": [
        "H",
        "h"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ML": [
        "H"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MT": [
        "H",
        "h"
    ],
    "MU": [
        "H",
        "h"
    ],
    "MV": [
        "H",
        "h"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MX": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NE": [
        "H"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NI": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "NO": [
        "H",
        "h"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "PL": [
        "H",
        "h"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "PW": [
        "h",
        "H"
    ],
    "PY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "RU": [
        "H"
    ],
    "RW": [
        "H",
        "h"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SE": [
        "H"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "SO": [
        "h",
        "H"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "SV": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TH": [
        "H",
        "h"
    ],
    "TJ": [
        "H",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TM": [
        "H",
        "h"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VN": [
        "H",
        "h"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "WS": [
        "h",
        "H"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZW": [
        "H",
        "h"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-HK": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-IL": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "en-MY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ]
};

});



parcelRegister("13hEe", function(module, exports) {

var $fvB0y = parcelRequire("fvB0y");

var $caG7o = parcelRequire("caG7o");
function $0c43c2bd108f954b$var$cloneDeep(obj) {
    if (Array.isArray(obj)) // @ts-expect-error meh
    return (0, $fvB0y.__spreadArray)([], obj.map($0c43c2bd108f954b$var$cloneDeep), true);
    if (obj !== null && typeof obj === 'object') // @ts-expect-error meh
    return Object.keys(obj).reduce(function(cloned, k) {
        // @ts-expect-error meh
        cloned[k] = $0c43c2bd108f954b$var$cloneDeep(obj[k]);
        return cloned;
    }, {});
    return obj;
}
function $0c43c2bd108f954b$var$hoistPluralOrSelectElement(ast, el, positionToInject) {
    // pull this out of the ast and move it to the top
    var cloned = $0c43c2bd108f954b$var$cloneDeep(el);
    var options = cloned.options;
    cloned.options = Object.keys(options).reduce(function(all, k) {
        var newValue = $0c43c2bd108f954b$export$be5687ba8bbdf416((0, $fvB0y.__spreadArray)((0, $fvB0y.__spreadArray)((0, $fvB0y.__spreadArray)([], ast.slice(0, positionToInject), true), options[k].value, true), ast.slice(positionToInject + 1), true));
        all[k] = {
            value: newValue
        };
        return all;
    }, {});
    return cloned;
}
function $0c43c2bd108f954b$var$isPluralOrSelectElement(el) {
    return (0, $caG7o.isPluralElement)(el) || (0, $caG7o.isSelectElement)(el);
}
function $0c43c2bd108f954b$var$findPluralOrSelectElement(ast) {
    return !!ast.find(function(el) {
        if ($0c43c2bd108f954b$var$isPluralOrSelectElement(el)) return true;
        if ((0, $caG7o.isTagElement)(el)) return $0c43c2bd108f954b$var$findPluralOrSelectElement(el.children);
        return false;
    });
}
function $0c43c2bd108f954b$export$be5687ba8bbdf416(ast) {
    for(var i = 0; i < ast.length; i++){
        var el = ast[i];
        if ($0c43c2bd108f954b$var$isPluralOrSelectElement(el)) return [
            $0c43c2bd108f954b$var$hoistPluralOrSelectElement(ast, el, i)
        ];
        if ((0, $caG7o.isTagElement)(el) && $0c43c2bd108f954b$var$findPluralOrSelectElement([
            el
        ])) throw new Error('Cannot hoist plural/select within a tag element. Please put the tag element inside each plural/select option');
    }
    return ast;
}
/**
 * Collect all variables in an AST to Record<string, TYPE>
 * @param ast AST to collect variables from
 * @param vars Record of variable name to variable type
 */ function $0c43c2bd108f954b$var$collectVariables(ast, vars) {
    if (vars === void 0) vars = new Map();
    ast.forEach(function(el) {
        if ((0, $caG7o.isArgumentElement)(el) || (0, $caG7o.isDateElement)(el) || (0, $caG7o.isTimeElement)(el) || (0, $caG7o.isNumberElement)(el)) {
            if (el.value in vars && vars.get(el.value) !== el.type) throw new Error("Variable ".concat(el.value, " has conflicting types"));
            vars.set(el.value, el.type);
        }
        if ((0, $caG7o.isPluralElement)(el) || (0, $caG7o.isSelectElement)(el)) {
            vars.set(el.value, el.type);
            Object.keys(el.options).forEach(function(k) {
                $0c43c2bd108f954b$var$collectVariables(el.options[k].value, vars);
            });
        }
        if ((0, $caG7o.isTagElement)(el)) {
            vars.set(el.value, el.type);
            $0c43c2bd108f954b$var$collectVariables(el.children, vars);
        }
    });
}
function $0c43c2bd108f954b$export$1edd9c892fdd9d27(a, b) {
    var aVars = new Map();
    var bVars = new Map();
    $0c43c2bd108f954b$var$collectVariables(a, aVars);
    $0c43c2bd108f954b$var$collectVariables(b, bVars);
    if (aVars.size !== bVars.size) return {
        success: false,
        error: new Error("Different number of variables: [".concat(Array.from(aVars.keys()).join(', '), "] vs [").concat(Array.from(bVars.keys()).join(', '), "]"))
    };
    return Array.from(aVars.entries()).reduce(function(result, _a) {
        var key = _a[0], type = _a[1];
        if (!result.success) return result;
        var bType = bVars.get(key);
        if (bType == null) return {
            success: false,
            error: new Error("Missing variable ".concat(key, " in message"))
        };
        if (bType !== type) return {
            success: false,
            error: new Error("Variable ".concat(key, " has conflicting types: ").concat((0, $caG7o.TYPE)[type], " vs ").concat((0, $caG7o.TYPE)[bType]))
        };
        return result;
    }, {
        success: true
    });
}

});


parcelRegister("gTMtP", function(module, exports) {
$parcel$export(module.exports, "PART_TYPE", () => $c4d7638474d51a40$export$49694c2877b44c57);
$parcel$export(module.exports, "isFormatXMLElementFn", () => $c4d7638474d51a40$export$df0c12a2d414a163);
$parcel$export(module.exports, "formatToParts", () => $c4d7638474d51a40$export$275d4a3bb5f66fda);
parcelRequire("35YLm");
var $caG7o = parcelRequire("caG7o");

var $iqNwe = parcelRequire("iqNwe");
var $c4d7638474d51a40$export$49694c2877b44c57;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})($c4d7638474d51a40$export$49694c2877b44c57 || ($c4d7638474d51a40$export$49694c2877b44c57 = {}));
function $c4d7638474d51a40$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== $c4d7638474d51a40$export$49694c2877b44c57.literal || part.type !== $c4d7638474d51a40$export$49694c2877b44c57.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $c4d7638474d51a40$export$df0c12a2d414a163(el) {
    return typeof el === 'function';
}
function $c4d7638474d51a40$export$275d4a3bb5f66fda(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, $caG7o.isLiteralElement)(els[0])) return [
        {
            type: $c4d7638474d51a40$export$49694c2877b44c57.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, $caG7o.isLiteralElement)(el)) {
            result.push({
                type: $c4d7638474d51a40$export$49694c2877b44c57.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, $caG7o.isPoundElement)(el)) {
            if (typeof currentPluralValue === 'number') result.push({
                type: $c4d7638474d51a40$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new (0, $iqNwe.MissingValueError)(varName, originalMessage);
        var value = values[varName];
        if ((0, $caG7o.isArgumentElement)(el)) {
            if (!value || typeof value === 'string' || typeof value === 'number') value = typeof value === 'string' || typeof value === 'number' ? String(value) : '';
            result.push({
                type: typeof value === 'string' ? $c4d7638474d51a40$export$49694c2877b44c57.literal : $c4d7638474d51a40$export$49694c2877b44c57.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, $caG7o.isDateElement)(el)) {
            var style = typeof el.style === 'string' ? formats.date[el.style] : (0, $caG7o.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $c4d7638474d51a40$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $caG7o.isTimeElement)(el)) {
            var style = typeof el.style === 'string' ? formats.time[el.style] : (0, $caG7o.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: $c4d7638474d51a40$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $caG7o.isNumberElement)(el)) {
            var style = typeof el.style === 'string' ? formats.number[el.style] : (0, $caG7o.isNumberSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: $c4d7638474d51a40$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $caG7o.isTagElement)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!$c4d7638474d51a40$export$df0c12a2d414a163(formatFn)) throw new (0, $iqNwe.InvalidValueTypeError)(value_1, 'function', originalMessage);
            var parts = $c4d7638474d51a40$export$275d4a3bb5f66fda(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === 'string' ? $c4d7638474d51a40$export$49694c2877b44c57.literal : $c4d7638474d51a40$export$49694c2877b44c57.object,
                    value: c
                };
            }));
        }
        if ((0, $caG7o.isSelectElement)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new (0, $iqNwe.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $c4d7638474d51a40$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $caG7o.isPluralElement)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new (0, $iqNwe.FormatError)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $iqNwe.ErrorCode).MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new (0, $iqNwe.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $c4d7638474d51a40$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return $c4d7638474d51a40$var$mergeLiteral(result);
}

});
parcelRegister("iqNwe", function(module, exports) {
$parcel$export(module.exports, "ErrorCode", () => $d6b11124292f70b6$export$d4e71bc0b80dc0fb);
$parcel$export(module.exports, "FormatError", () => $d6b11124292f70b6$export$7369836851cc1329);
$parcel$export(module.exports, "InvalidValueError", () => $d6b11124292f70b6$export$565c3afc07dfa382);
$parcel$export(module.exports, "InvalidValueTypeError", () => $d6b11124292f70b6$export$cbc0db47c750f7c9);
$parcel$export(module.exports, "MissingValueError", () => $d6b11124292f70b6$export$8bfc137e4d23fdf0);

var $fvB0y = parcelRequire("fvB0y");
var $d6b11124292f70b6$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})($d6b11124292f70b6$export$d4e71bc0b80dc0fb || ($d6b11124292f70b6$export$d4e71bc0b80dc0fb = {}));
var $d6b11124292f70b6$export$7369836851cc1329 = /** @class */ function(_super) {
    (0, $fvB0y.__extends)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
var $d6b11124292f70b6$export$565c3afc07dfa382 = /** @class */ function(_super) {
    (0, $fvB0y.__extends)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, "Invalid values for \"".concat(variableId, "\": \"").concat(value, "\". Options are \"").concat(Object.keys(options).join('", "'), "\""), $d6b11124292f70b6$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}($d6b11124292f70b6$export$7369836851cc1329);
var $d6b11124292f70b6$export$cbc0db47c750f7c9 = /** @class */ function(_super) {
    (0, $fvB0y.__extends)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, "Value for \"".concat(value, "\" must be of type ").concat(type), $d6b11124292f70b6$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}($d6b11124292f70b6$export$7369836851cc1329);
var $d6b11124292f70b6$export$8bfc137e4d23fdf0 = /** @class */ function(_super) {
    (0, $fvB0y.__extends)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, "The intl string context variable \"".concat(variableId, "\" was not provided to the string \"").concat(originalMessage, "\""), $d6b11124292f70b6$export$d4e71bc0b80dc0fb.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}($d6b11124292f70b6$export$7369836851cc1329);

});




parcelRegister("9ZGqC", function(module, exports) {
$parcel$export(module.exports, "IntlErrorCode", () => $746ab8f741628f0f$export$557d6acb76e8a244);
$parcel$export(module.exports, "IntlError", () => $746ab8f741628f0f$export$c016d36112f6ddf8);
$parcel$export(module.exports, "UnsupportedFormatterError", () => $746ab8f741628f0f$export$549f97e137a05c90);
$parcel$export(module.exports, "InvalidConfigError", () => $746ab8f741628f0f$export$3ca04dd7fb305893);
$parcel$export(module.exports, "MissingDataError", () => $746ab8f741628f0f$export$c1eaf877d81384b6);
$parcel$export(module.exports, "IntlFormatError", () => $746ab8f741628f0f$export$e3b7eee1dbc44895);
$parcel$export(module.exports, "MessageFormatError", () => $746ab8f741628f0f$export$74a601a3d3f31621);
$parcel$export(module.exports, "MissingTranslationError", () => $746ab8f741628f0f$export$2ddcb436d0aa3688);

var $fvB0y = parcelRequire("fvB0y");
var $746ab8f741628f0f$export$557d6acb76e8a244;
(function(IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
})($746ab8f741628f0f$export$557d6acb76e8a244 || ($746ab8f741628f0f$export$557d6acb76e8a244 = {}));
var $746ab8f741628f0f$export$c016d36112f6ddf8 = /** @class */ function(_super) {
    (0, $fvB0y.__extends)(IntlError, _super);
    function IntlError(code, message, exception) {
        var _this = this;
        var err = exception ? exception instanceof Error ? exception : new Error(String(exception)) : undefined;
        _this = _super.call(this, "[@formatjs/intl Error ".concat(code, "] ").concat(message, "\n").concat(err ? "\n".concat(err.message, "\n").concat(err.stack) : '')) || this;
        _this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === 'function') // @ts-ignore just so we don't need to declare dep on @types/node
        Error.captureStackTrace(_this, IntlError);
        return _this;
    }
    return IntlError;
}(Error);
var $746ab8f741628f0f$export$549f97e137a05c90 = /** @class */ function(_super) {
    (0, $fvB0y.__extends)(UnsupportedFormatterError, _super);
    function UnsupportedFormatterError(message, exception) {
        return _super.call(this, $746ab8f741628f0f$export$557d6acb76e8a244.UNSUPPORTED_FORMATTER, message, exception) || this;
    }
    return UnsupportedFormatterError;
}($746ab8f741628f0f$export$c016d36112f6ddf8);
var $746ab8f741628f0f$export$3ca04dd7fb305893 = /** @class */ function(_super) {
    (0, $fvB0y.__extends)(InvalidConfigError, _super);
    function InvalidConfigError(message, exception) {
        return _super.call(this, $746ab8f741628f0f$export$557d6acb76e8a244.INVALID_CONFIG, message, exception) || this;
    }
    return InvalidConfigError;
}($746ab8f741628f0f$export$c016d36112f6ddf8);
var $746ab8f741628f0f$export$c1eaf877d81384b6 = /** @class */ function(_super) {
    (0, $fvB0y.__extends)(MissingDataError, _super);
    function MissingDataError(message, exception) {
        return _super.call(this, $746ab8f741628f0f$export$557d6acb76e8a244.MISSING_DATA, message, exception) || this;
    }
    return MissingDataError;
}($746ab8f741628f0f$export$c016d36112f6ddf8);
var $746ab8f741628f0f$export$e3b7eee1dbc44895 = /** @class */ function(_super) {
    (0, $fvB0y.__extends)(IntlFormatError, _super);
    function IntlFormatError(message, locale, exception) {
        var _this = _super.call(this, $746ab8f741628f0f$export$557d6acb76e8a244.FORMAT_ERROR, "".concat(message, "\nLocale: ").concat(locale, "\n"), exception) || this;
        _this.locale = locale;
        return _this;
    }
    return IntlFormatError;
}($746ab8f741628f0f$export$c016d36112f6ddf8);
var $746ab8f741628f0f$export$74a601a3d3f31621 = /** @class */ function(_super) {
    (0, $fvB0y.__extends)(MessageFormatError, _super);
    function MessageFormatError(message, locale, descriptor, exception) {
        var _this = _super.call(this, "".concat(message, "\nMessageID: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.id, "\nDefault Message: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage, "\nDescription: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.description, "\n"), locale, exception) || this;
        _this.descriptor = descriptor;
        _this.locale = locale;
        return _this;
    }
    return MessageFormatError;
}($746ab8f741628f0f$export$e3b7eee1dbc44895);
var $746ab8f741628f0f$export$2ddcb436d0aa3688 = /** @class */ function(_super) {
    (0, $fvB0y.__extends)(MissingTranslationError, _super);
    function MissingTranslationError(descriptor, locale) {
        var _this = _super.call(this, $746ab8f741628f0f$export$557d6acb76e8a244.MISSING_TRANSLATION, "Missing message: \"".concat(descriptor.id, "\" for locale \"").concat(locale, "\", using ").concat(descriptor.defaultMessage ? "default message (".concat(typeof descriptor.defaultMessage === 'string' ? descriptor.defaultMessage : descriptor.defaultMessage.map(function(e) {
            var _a;
            return (_a = e.value) !== null && _a !== void 0 ? _a : JSON.stringify(e);
        }).join(), ")") : 'id', " as fallback.")) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MissingTranslationError;
}($746ab8f741628f0f$export$c016d36112f6ddf8);

});



parcelRegister("7Ywk8", function(module, exports) {
$parcel$export(module.exports, "default", () => $5ce735d2c01d774c$export$2e2bcd8739ae039);

var $4tluv = parcelRequire("4tluv");

var $cQG32 = parcelRequire("cQG32");

var $4K6RG = parcelRequire("4K6RG");
function $5ce735d2c01d774c$export$2e2bcd8739ae039() {
    var intl = $4tluv.useContext((0, $4K6RG.Context));
    (0, $cQG32.invariantIntlContext)(intl);
    return intl;
}

});
parcelRegister("4K6RG", function(module, exports) {
$parcel$export(module.exports, "Provider", () => $3740c88283064a76$export$2881499e37b75b9a);
$parcel$export(module.exports, "Context", () => $3740c88283064a76$export$841858b892ce1f4c);
$parcel$export(module.exports, "default", () => $3740c88283064a76$export$2e2bcd8739ae039);

var $fvB0y = parcelRequire("fvB0y");

var $523n4 = parcelRequire("523n4");

var $4tluv = parcelRequire("4tluv");

var $cQG32 = parcelRequire("cQG32");
function $3740c88283064a76$var$getDisplayName(Component) {
    return Component.displayName || Component.name || 'Component';
}
// This is primarily dealing with packaging systems where multiple copies of react-intl
// might exist
var $3740c88283064a76$var$IntlContext = typeof window !== 'undefined' && !window.__REACT_INTL_BYPASS_GLOBAL_CONTEXT__ ? window.__REACT_INTL_CONTEXT__ || (window.__REACT_INTL_CONTEXT__ = $4tluv.createContext(null)) : $4tluv.createContext(null);
var $3740c88283064a76$var$IntlConsumer = $3740c88283064a76$var$IntlContext.Consumer, $3740c88283064a76$var$IntlProvider = $3740c88283064a76$var$IntlContext.Provider;
var $3740c88283064a76$export$2881499e37b75b9a = $3740c88283064a76$var$IntlProvider;
var $3740c88283064a76$export$841858b892ce1f4c = $3740c88283064a76$var$IntlContext;
function $3740c88283064a76$export$2e2bcd8739ae039(WrappedComponent, options) {
    var _a = options || {}, _b = _a.intlPropName, intlPropName = _b === void 0 ? 'intl' : _b, _c = _a.forwardRef, forwardRef = _c === void 0 ? false : _c, _d = _a.enforceContext, enforceContext = _d === void 0 ? true : _d;
    var WithIntl = function(props) {
        return $4tluv.createElement($3740c88283064a76$var$IntlConsumer, null, function(intl) {
            var _a;
            if (enforceContext) (0, $cQG32.invariantIntlContext)(intl);
            var intlProp = (_a = {}, _a[intlPropName] = intl, _a);
            return $4tluv.createElement(WrappedComponent, (0, $fvB0y.__assign)({}, props, intlProp, {
                ref: forwardRef ? props.forwardedRef : null
            }));
        });
    };
    WithIntl.displayName = "injectIntl(".concat($3740c88283064a76$var$getDisplayName(WrappedComponent), ")");
    WithIntl.WrappedComponent = WrappedComponent;
    if (forwardRef) return (0, (/*@__PURE__*/$parcel$interopDefault($523n4)))(// @ts-expect-error
    $4tluv.forwardRef(function(props, ref) {
        return $4tluv.createElement(WithIntl, (0, $fvB0y.__assign)({}, props, {
            forwardedRef: ref
        }));
    }), WrappedComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($523n4)))(WithIntl, WrappedComponent);
}

});
parcelRegister("523n4", function(module, exports) {
'use strict';

var $3qiVw = parcelRequire("3qiVw");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $3a9fc11070bd2d4b$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $3a9fc11070bd2d4b$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $3a9fc11070bd2d4b$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $3a9fc11070bd2d4b$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $3a9fc11070bd2d4b$var$TYPE_STATICS = {};
$3a9fc11070bd2d4b$var$TYPE_STATICS[$3qiVw.ForwardRef] = $3a9fc11070bd2d4b$var$FORWARD_REF_STATICS;
$3a9fc11070bd2d4b$var$TYPE_STATICS[$3qiVw.Memo] = $3a9fc11070bd2d4b$var$MEMO_STATICS;
function $3a9fc11070bd2d4b$var$getStatics(component) {
    // React v16.11 and below
    if ($3qiVw.isMemo(component)) return $3a9fc11070bd2d4b$var$MEMO_STATICS;
     // React v16.12 and above
    return $3a9fc11070bd2d4b$var$TYPE_STATICS[component['$$typeof']] || $3a9fc11070bd2d4b$var$REACT_STATICS;
}
var $3a9fc11070bd2d4b$var$defineProperty = Object.defineProperty;
var $3a9fc11070bd2d4b$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $3a9fc11070bd2d4b$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $3a9fc11070bd2d4b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $3a9fc11070bd2d4b$var$getPrototypeOf = Object.getPrototypeOf;
var $3a9fc11070bd2d4b$var$objectPrototype = Object.prototype;
function $3a9fc11070bd2d4b$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($3a9fc11070bd2d4b$var$objectPrototype) {
            var inheritedComponent = $3a9fc11070bd2d4b$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $3a9fc11070bd2d4b$var$objectPrototype) $3a9fc11070bd2d4b$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $3a9fc11070bd2d4b$var$getOwnPropertyNames(sourceComponent);
        if ($3a9fc11070bd2d4b$var$getOwnPropertySymbols) keys = keys.concat($3a9fc11070bd2d4b$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $3a9fc11070bd2d4b$var$getStatics(targetComponent);
        var sourceStatics = $3a9fc11070bd2d4b$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$3a9fc11070bd2d4b$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $3a9fc11070bd2d4b$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $3a9fc11070bd2d4b$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $3a9fc11070bd2d4b$var$hoistNonReactStatics;

});




parcelRegister("8TrAC", function(module, exports) {
$parcel$export(module.exports, "default", () => $0e9d1c572d133af8$export$2e2bcd8739ae039);

var $4tluv = parcelRequire("4tluv");

var $9KBmj = parcelRequire("9KBmj");

var $7FhUM = parcelRequire("7FhUM");

var $4LfXS = parcelRequire("4LfXS");
const $0e9d1c572d133af8$var$ErrorIllustration = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $9KBmj.default), {
        alt: "Error",
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7FhUM))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($4LfXS)))
    });
var $0e9d1c572d133af8$export$2e2bcd8739ae039 = $0e9d1c572d133af8$var$ErrorIllustration;

});
parcelRegister("7FhUM", function(module, exports) {
module.exports = new URL("light.6e26cad7.svg", import.meta.url).toString();

});

parcelRegister("4LfXS", function(module, exports) {
module.exports = new URL("dark.d6d496b3.svg", import.meta.url).toString();

});


parcelRegister("dDtM2", function(module, exports) {
$parcel$export(module.exports, "messages", () => $330656388d41e79f$export$defe85febe8b728c);

var $38Fhe = parcelRequire("38Fhe");
const $330656388d41e79f$export$defe85febe8b728c = (0, $38Fhe.defineMessages)({
    errorHeader: {
        id: "rovo-extension.error-header.label",
        defaultMessage: "Something went wrong",
        description: "Header label for extension error message"
    },
    chatErrorSubheader: {
        id: "rovo-extension.chat-error-subheader.label",
        defaultMessage: "Try refreshing the page, or starting a new chat.",
        description: "Subheader label for extension error message suggestions"
    },
    errorBoundarySubheader: {
        id: "rovo-extension.error-boundary-subheader.label",
        defaultMessage: "Please try again.",
        description: "Subheader label for extension error message"
    },
    rovoDisabledError: {
        id: "rovo-extension.rovo-disabled-error.label",
        defaultMessage: "Are you there Rovo?",
        description: "Header label for extension error message when Rovo is missing for the user's Atlassian site"
    },
    rovoDisabledErrorSubheader: {
        id: "rovo-extension.rovo-disabled-error-subheader.label",
        defaultMessage: "It looks like you don't have access to Rovo.",
        description: "Subheader label for extension error message when Rovo is disabled for the user's Atlassian site"
    },
    rovoDisabledErrorLink: {
        id: "rovo-extension.rovo-disabled-error-link.label",
        defaultMessage: "More about Rovo",
        description: "Link label for missing Rovo error message to redirect to more information about Rovo"
    },
    welcomeHeaderWithName: {
        id: "rovo-extension.welcome-header-with-name.label",
        defaultMessage: "What can I help you with, {name}?",
        description: "Header label for extension welcome message with user's name"
    },
    welcomeHeaderWithoutName: {
        id: "rovo-extension.welcome-header-without-name.label",
        defaultMessage: "What can I help you with?",
        description: "Header label for extension welcome message without user's name"
    },
    welcomeHeaderMorning: {
        id: "rovo-extension.welcome-header-morning.label",
        defaultMessage: "Good morning, {name}",
        description: "Header label for extension welcome message in the morning"
    },
    welcomeHeaderMorningNoName: {
        id: "rovo-extension.welcome-header-morning-no-name.label",
        defaultMessage: "Good morning",
        description: "Header label for extension welcome message in the morning when no name is provided"
    },
    welcomeHeaderAfternoon: {
        id: "rovo-extension.welcome-header-afternoon.label",
        defaultMessage: "Good afternoon, {name}",
        description: "Header label for extension welcome message in the afternoon"
    },
    welcomeHeaderAfternoonNoName: {
        id: "rovo-extension.welcome-header-afternoon-no-name.label",
        defaultMessage: "Good afternoon",
        description: "Header label for extension welcome message in the afternoon when no name is provided"
    },
    welcomeHeaderEvening: {
        id: "rovo-extension.welcome-header-evening.label",
        defaultMessage: "Good evening, {name}",
        description: "Header label for extension welcome message in the evening"
    },
    welcomeHeaderEveningNoName: {
        id: "rovo-extension.welcome-header-evening-no-name.label",
        defaultMessage: "Good evening",
        description: "Header label for extension welcome message in the evening when no name is provided"
    },
    reloadButtonLabel: {
        id: "rovo-extension.rovo-disabled-error.button",
        defaultMessage: "Try again",
        description: "Label for reload button when Rovo is disabled"
    }
});

});
parcelRegister("38Fhe", function(module, exports) {
$parcel$export(module.exports, "defineMessages", () => $249223366b99fd8c$export$1adfeb024f5185b);
$parcel$export(module.exports, "defineMessage", () => $249223366b99fd8c$export$747d244ee58120dd);
$parcel$export(module.exports, "FormattedDate", () => $249223366b99fd8c$export$40ae3194919d16b);
$parcel$export(module.exports, "FormattedTime", () => $249223366b99fd8c$export$5b390a54f8a846f7);
$parcel$export(module.exports, "FormattedNumber", () => $249223366b99fd8c$export$db80edc1e6b2f63d);
$parcel$export(module.exports, "FormattedList", () => $249223366b99fd8c$export$f52b44e459e6e71d);
$parcel$export(module.exports, "FormattedDisplayName", () => $249223366b99fd8c$export$c2336ea5aaab92fa);
$parcel$export(module.exports, "FormattedDateParts", () => $249223366b99fd8c$export$7fdc7d2c91ce149b);
$parcel$export(module.exports, "FormattedTimeParts", () => $249223366b99fd8c$export$ec35873761676c2a);
$parcel$export(module.exports, "createIntlCache", () => (parcelRequire("5wooz")).createIntlCache);
$parcel$export(module.exports, "InvalidConfigError", () => (parcelRequire("9ZGqC")).InvalidConfigError);
$parcel$export(module.exports, "MessageFormatError", () => (parcelRequire("9ZGqC")).MessageFormatError);
$parcel$export(module.exports, "MissingDataError", () => (parcelRequire("9ZGqC")).MissingDataError);
$parcel$export(module.exports, "MissingTranslationError", () => (parcelRequire("9ZGqC")).MissingTranslationError);
$parcel$export(module.exports, "ReactIntlError", () => (parcelRequire("9ZGqC")).IntlError);
$parcel$export(module.exports, "ReactIntlErrorCode", () => (parcelRequire("9ZGqC")).IntlErrorCode);
$parcel$export(module.exports, "UnsupportedFormatterError", () => (parcelRequire("9ZGqC")).UnsupportedFormatterError);
$parcel$export(module.exports, "createIntl", () => (parcelRequire("7D74H")).createIntl);
$parcel$export(module.exports, "FormattedDateTimeRange", () => (parcelRequire("4IPLQ")).default);
$parcel$export(module.exports, "FormattedMessage", () => (parcelRequire("lIP59")).default);
$parcel$export(module.exports, "FormattedPlural", () => (parcelRequire("hFt0r")).default);
$parcel$export(module.exports, "FormattedRelativeTime", () => (parcelRequire("4QGGt")).default);
$parcel$export(module.exports, "injectIntl", () => (parcelRequire("4K6RG")).default);
$parcel$export(module.exports, "IntlContext", () => (parcelRequire("4K6RG")).Context);
$parcel$export(module.exports, "IntlProvider", () => (parcelRequire("iEMA6")).default);
$parcel$export(module.exports, "RawIntlProvider", () => (parcelRequire("4K6RG")).Provider);
$parcel$export(module.exports, "useIntl", () => (parcelRequire("7Ywk8")).default);
$parcel$export(module.exports, "FormattedListParts", () => (parcelRequire("3jNfS")).FormattedListParts);
$parcel$export(module.exports, "FormattedNumberParts", () => (parcelRequire("3jNfS")).FormattedNumberParts);

var $3jNfS = parcelRequire("3jNfS");

var $7D74H = parcelRequire("7D74H");

var $4IPLQ = parcelRequire("4IPLQ");

var $4K6RG = parcelRequire("4K6RG");

var $lIP59 = parcelRequire("lIP59");

var $hFt0r = parcelRequire("hFt0r");

var $iEMA6 = parcelRequire("iEMA6");

var $4QGGt = parcelRequire("4QGGt");

var $7Ywk8 = parcelRequire("7Ywk8");

var $5wooz = parcelRequire("5wooz");
var $9ZGqC = parcelRequire("9ZGqC");
function $249223366b99fd8c$export$1adfeb024f5185b(msgs) {
    return msgs;
}
function $249223366b99fd8c$export$747d244ee58120dd(msg) {
    return msg;
}
var $249223366b99fd8c$export$40ae3194919d16b = (0, $3jNfS.createFormattedComponent)('formatDate');
var $249223366b99fd8c$export$5b390a54f8a846f7 = (0, $3jNfS.createFormattedComponent)('formatTime');
var $249223366b99fd8c$export$db80edc1e6b2f63d = (0, $3jNfS.createFormattedComponent)('formatNumber');
var $249223366b99fd8c$export$f52b44e459e6e71d = (0, $3jNfS.createFormattedComponent)('formatList');
var $249223366b99fd8c$export$c2336ea5aaab92fa = (0, $3jNfS.createFormattedComponent)('formatDisplayName');
var $249223366b99fd8c$export$7fdc7d2c91ce149b = (0, $3jNfS.createFormattedDateTimePartsComponent)('formatDate');
var $249223366b99fd8c$export$ec35873761676c2a = (0, $3jNfS.createFormattedDateTimePartsComponent)('formatTime');

});
parcelRegister("3jNfS", function(module, exports) {
$parcel$export(module.exports, "FormattedNumberParts", () => $26a95a7b7997d419$export$54d4989ed3eea1ea);
$parcel$export(module.exports, "FormattedListParts", () => $26a95a7b7997d419$export$5ac259c7da6d2188);
$parcel$export(module.exports, "createFormattedDateTimePartsComponent", () => $26a95a7b7997d419$export$7448277f6036d2ab);
$parcel$export(module.exports, "createFormattedComponent", () => $26a95a7b7997d419$export$b37e14176d001dec);

var $fvB0y = parcelRequire("fvB0y");

var $4tluv = parcelRequire("4tluv");

var $7Ywk8 = parcelRequire("7Ywk8");
var $26a95a7b7997d419$var$DisplayName;
(function(DisplayName) {
    DisplayName["formatDate"] = "FormattedDate";
    DisplayName["formatTime"] = "FormattedTime";
    DisplayName["formatNumber"] = "FormattedNumber";
    DisplayName["formatList"] = "FormattedList";
    // Note that this DisplayName is the locale display name, not to be confused with
    // the name of the enum, which is for React component display name in dev tools.
    DisplayName["formatDisplayName"] = "FormattedDisplayName";
})($26a95a7b7997d419$var$DisplayName || ($26a95a7b7997d419$var$DisplayName = {}));
var $26a95a7b7997d419$var$DisplayNameParts;
(function(DisplayNameParts) {
    DisplayNameParts["formatDate"] = "FormattedDateParts";
    DisplayNameParts["formatTime"] = "FormattedTimeParts";
    DisplayNameParts["formatNumber"] = "FormattedNumberParts";
    DisplayNameParts["formatList"] = "FormattedListParts";
})($26a95a7b7997d419$var$DisplayNameParts || ($26a95a7b7997d419$var$DisplayNameParts = {}));
var $26a95a7b7997d419$export$54d4989ed3eea1ea = function(props) {
    var intl = (0, $7Ywk8.default)();
    var value = props.value, children = props.children, formatProps = (0, $fvB0y.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatNumberToParts(value, formatProps));
};
$26a95a7b7997d419$export$54d4989ed3eea1ea.displayName = 'FormattedNumberParts';
var $26a95a7b7997d419$export$5ac259c7da6d2188 = function(props) {
    var intl = (0, $7Ywk8.default)();
    var value = props.value, children = props.children, formatProps = (0, $fvB0y.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatListToParts(value, formatProps));
};
$26a95a7b7997d419$export$54d4989ed3eea1ea.displayName = 'FormattedNumberParts';
function $26a95a7b7997d419$export$7448277f6036d2ab(name) {
    var ComponentParts = function(props) {
        var intl = (0, $7Ywk8.default)();
        var value = props.value, children = props.children, formatProps = (0, $fvB0y.__rest)(props, [
            "value",
            "children"
        ]);
        var date = typeof value === 'string' ? new Date(value || 0) : value;
        var formattedParts = name === 'formatDate' ? intl.formatDateToParts(date, formatProps) : intl.formatTimeToParts(date, formatProps);
        return children(formattedParts);
    };
    ComponentParts.displayName = $26a95a7b7997d419$var$DisplayNameParts[name];
    return ComponentParts;
}
function $26a95a7b7997d419$export$b37e14176d001dec(name) {
    var Component = function(props) {
        var intl = (0, $7Ywk8.default)();
        var value = props.value, children = props.children, formatProps = (0, $fvB0y.__rest)(props, [
            "value",
            "children"
        ]);
        // TODO: fix TS type definition for localeMatcher upstream
        var formattedValue = intl[name](value, formatProps);
        if (typeof children === 'function') return children(formattedValue);
        var Text = intl.textComponent || $4tluv.Fragment;
        return $4tluv.createElement(Text, null, formattedValue);
    };
    Component.displayName = $26a95a7b7997d419$var$DisplayName[name];
    return Component;
}

});

parcelRegister("7D74H", function(module, exports) {
$parcel$export(module.exports, "createIntl", () => $58e1a9d05032c437$export$7e4cbedfdd7b4c0d);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $fvB0y = parcelRequire("fvB0y");

var $blcil = parcelRequire("blcil");
var $j0vAa = parcelRequire("j0vAa");

var $gTMtP = parcelRequire("gTMtP");

var $cQG32 = parcelRequire("cQG32");
function $58e1a9d05032c437$var$assignUniqueKeysToFormatXMLElementFnArgument(values) {
    if (!values) return values;
    return Object.keys(values).reduce(function(acc, k) {
        var v = values[k];
        acc[k] = (0, $gTMtP.isFormatXMLElementFn)(v) ? (0, $cQG32.assignUniqueKeysToParts)(v) : v;
        return acc;
    }, {});
}
var $58e1a9d05032c437$var$formatMessage = function(config, formatters, descriptor, rawValues) {
    var rest = [];
    for(var _i = 4; _i < arguments.length; _i++)rest[_i - 4] = arguments[_i];
    var values = $58e1a9d05032c437$var$assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
    var chunks = (0, $j0vAa.formatMessage).apply(void 0, (0, $fvB0y.__spreadArray)([
        config,
        formatters,
        descriptor,
        values
    ], rest, false));
    if (Array.isArray(chunks)) return (0, $cQG32.toKeyedReactNodeArray)(chunks);
    return chunks;
};
var $58e1a9d05032c437$export$7e4cbedfdd7b4c0d = function(_a, cache) {
    var rawDefaultRichTextElements = _a.defaultRichTextElements, config = (0, $fvB0y.__rest)(_a, [
        "defaultRichTextElements"
    ]);
    var defaultRichTextElements = $58e1a9d05032c437$var$assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
    var coreIntl = (0, $blcil.createIntl)((0, $fvB0y.__assign)((0, $fvB0y.__assign)((0, $fvB0y.__assign)({}, (0, $cQG32.DEFAULT_INTL_CONFIG)), config), {
        defaultRichTextElements: defaultRichTextElements
    }), cache);
    var resolvedConfig = {
        locale: coreIntl.locale,
        timeZone: coreIntl.timeZone,
        fallbackOnEmptyString: coreIntl.fallbackOnEmptyString,
        formats: coreIntl.formats,
        defaultLocale: coreIntl.defaultLocale,
        defaultFormats: coreIntl.defaultFormats,
        messages: coreIntl.messages,
        onError: coreIntl.onError,
        defaultRichTextElements: defaultRichTextElements
    };
    return (0, $fvB0y.__assign)((0, $fvB0y.__assign)({}, coreIntl), {
        formatMessage: $58e1a9d05032c437$var$formatMessage.bind(null, resolvedConfig, coreIntl.formatters),
        $t: $58e1a9d05032c437$var$formatMessage.bind(null, resolvedConfig, coreIntl.formatters)
    });
};

});
parcelRegister("blcil", function(module, exports) {
$parcel$export(module.exports, "createIntl", () => $841b3161410a75ab$export$7e4cbedfdd7b4c0d);

var $fvB0y = parcelRequire("fvB0y");

var $dLkEV = parcelRequire("dLkEV");

var $kWRyc = parcelRequire("kWRyc");

var $9ZGqC = parcelRequire("9ZGqC");

var $4aMZW = parcelRequire("4aMZW");

var $j0vAa = parcelRequire("j0vAa");

var $fKWSw = parcelRequire("fKWSw");

var $kIPy1 = parcelRequire("kIPy1");

var $kKMg8 = parcelRequire("kKMg8");

var $5wooz = parcelRequire("5wooz");
function $841b3161410a75ab$var$messagesContainString(messages) {
    var firstMessage = messages ? messages[Object.keys(messages)[0]] : undefined;
    return typeof firstMessage === 'string';
}
function $841b3161410a75ab$var$verifyConfigMessages(config) {
    if (config.onWarn && config.defaultRichTextElements && $841b3161410a75ab$var$messagesContainString(config.messages || {})) config.onWarn("[@formatjs/intl] \"defaultRichTextElements\" was specified but \"message\" was not pre-compiled. \nPlease consider using \"@formatjs/cli\" to pre-compile your messages for performance.\nFor more details see https://formatjs.github.io/docs/getting-started/message-distribution");
}
function $841b3161410a75ab$export$7e4cbedfdd7b4c0d(config, cache) {
    var formatters = (0, $5wooz.createFormatters)(cache);
    var resolvedConfig = (0, $fvB0y.__assign)((0, $fvB0y.__assign)({}, (0, $5wooz.DEFAULT_INTL_CONFIG)), config);
    var locale = resolvedConfig.locale, defaultLocale = resolvedConfig.defaultLocale, onError = resolvedConfig.onError;
    if (!locale) {
        if (onError) onError(new (0, $9ZGqC.InvalidConfigError)("\"locale\" was not configured, using \"".concat(defaultLocale, "\" as fallback. See https://formatjs.github.io/docs/react-intl/api#intlshape for more details")));
        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        resolvedConfig.locale = resolvedConfig.defaultLocale || 'en';
    } else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $9ZGqC.MissingDataError)("Missing locale data for locale: \"".concat(locale, "\" in Intl.NumberFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.github.io/docs/react-intl#runtime-requirements for more details")));
    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $9ZGqC.MissingDataError)("Missing locale data for locale: \"".concat(locale, "\" in Intl.DateTimeFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.github.io/docs/react-intl#runtime-requirements for more details")));
    $841b3161410a75ab$var$verifyConfigMessages(resolvedConfig);
    return (0, $fvB0y.__assign)((0, $fvB0y.__assign)({}, resolvedConfig), {
        formatters: formatters,
        formatNumber: (0, $fKWSw.formatNumber).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatNumberToParts: (0, $fKWSw.formatNumberToParts).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatRelativeTime: (0, $kKMg8.formatRelativeTime).bind(null, resolvedConfig, formatters.getRelativeTimeFormat),
        formatDate: (0, $dLkEV.formatDate).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateToParts: (0, $dLkEV.formatDateToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTime: (0, $dLkEV.formatTime).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateTimeRange: (0, $dLkEV.formatDateTimeRange).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTimeToParts: (0, $dLkEV.formatTimeToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatPlural: (0, $kIPy1.formatPlural).bind(null, resolvedConfig, formatters.getPluralRules),
        formatMessage: (0, $j0vAa.formatMessage).bind(null, resolvedConfig, formatters),
        $t: (0, $j0vAa.formatMessage).bind(null, resolvedConfig, formatters),
        formatList: (0, $4aMZW.formatList).bind(null, resolvedConfig, formatters.getListFormat),
        formatListToParts: (0, $4aMZW.formatListToParts).bind(null, resolvedConfig, formatters.getListFormat),
        formatDisplayName: (0, $kWRyc.formatDisplayName).bind(null, resolvedConfig, formatters.getDisplayNames)
    });
}

});
parcelRegister("dLkEV", function(module, exports) {
$parcel$export(module.exports, "formatDate", () => $a04fb099aa3b58ac$export$3ae94a2503e890a1);
$parcel$export(module.exports, "formatTime", () => $a04fb099aa3b58ac$export$3203edd9e5edd663);
$parcel$export(module.exports, "formatDateTimeRange", () => $a04fb099aa3b58ac$export$a7fc3a91cb2ec376);
$parcel$export(module.exports, "formatDateToParts", () => $a04fb099aa3b58ac$export$dc1f059bce486b1);
$parcel$export(module.exports, "formatTimeToParts", () => $a04fb099aa3b58ac$export$af6e5d7a5c73edeb);

var $fvB0y = parcelRequire("fvB0y");

var $9ZGqC = parcelRequire("9ZGqC");

var $5wooz = parcelRequire("5wooz");
var $a04fb099aa3b58ac$var$DATE_TIME_FORMAT_OPTIONS = [
    'formatMatcher',
    'timeZone',
    'hour12',
    'weekday',
    'era',
    'year',
    'month',
    'day',
    'hour',
    'minute',
    'second',
    'timeZoneName',
    'hourCycle',
    'dateStyle',
    'timeStyle',
    'calendar',
    // 'dayPeriod',
    'numberingSystem',
    'fractionalSecondDigits'
];
function $a04fb099aa3b58ac$export$a7f9565e3c81cd54(_a, type, getDateTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError, timeZone = _a.timeZone;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = (0, $fvB0y.__assign)((0, $fvB0y.__assign)({}, timeZone && {
        timeZone: timeZone
    }), format && (0, $5wooz.getNamedFormat)(formats, type, format, onError));
    var filteredOptions = (0, $5wooz.filterProps)(options, $a04fb099aa3b58ac$var$DATE_TIME_FORMAT_OPTIONS, defaults);
    if (type === 'time' && !filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second && !filteredOptions.timeStyle && !filteredOptions.dateStyle) // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = (0, $fvB0y.__assign)((0, $fvB0y.__assign)({}, filteredOptions), {
        hour: 'numeric',
        minute: 'numeric'
    });
    return getDateTimeFormat(locale, filteredOptions);
}
function $a04fb099aa3b58ac$export$3ae94a2503e890a1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $a04fb099aa3b58ac$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $9ZGqC.IntlFormatError)('Error formatting date.', config.locale, e));
    }
    return String(date);
}
function $a04fb099aa3b58ac$export$3203edd9e5edd663(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $a04fb099aa3b58ac$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $9ZGqC.IntlFormatError)('Error formatting time.', config.locale, e));
    }
    return String(date);
}
function $a04fb099aa3b58ac$export$a7fc3a91cb2ec376(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var from = _a[0], to = _a[1], _b = _a[2], options = _b === void 0 ? {} : _b;
    var fromDate = typeof from === 'string' ? new Date(from || 0) : from;
    var toDate = typeof to === 'string' ? new Date(to || 0) : to;
    try {
        return $a04fb099aa3b58ac$export$a7f9565e3c81cd54(config, 'dateTimeRange', getDateTimeFormat, options).formatRange(fromDate, toDate);
    } catch (e) {
        config.onError(new (0, $9ZGqC.IntlFormatError)('Error formatting date time range.', config.locale, e));
    }
    return String(fromDate);
}
function $a04fb099aa3b58ac$export$dc1f059bce486b1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $a04fb099aa3b58ac$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $9ZGqC.IntlFormatError)('Error formatting date.', config.locale, e));
    }
    return [];
}
function $a04fb099aa3b58ac$export$af6e5d7a5c73edeb(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $a04fb099aa3b58ac$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $9ZGqC.IntlFormatError)('Error formatting time.', config.locale, e));
    }
    return [];
}

});

parcelRegister("kWRyc", function(module, exports) {
$parcel$export(module.exports, "formatDisplayName", () => $f402c3776c9708ff$export$62fe1a4d9e891fa2);

var $5wooz = parcelRequire("5wooz");

var $iqNwe = parcelRequire("iqNwe");

var $9ZGqC = parcelRequire("9ZGqC");
var $f402c3776c9708ff$var$DISPLAY_NAMES_OPTONS = [
    'style',
    'type',
    'fallback',
    'languageDisplay'
];
function $f402c3776c9708ff$export$62fe1a4d9e891fa2(_a, getDisplayNames, value, options) {
    var locale = _a.locale, onError = _a.onError;
    var DisplayNames = Intl.DisplayNames;
    if (!DisplayNames) onError(new (0, $iqNwe.FormatError)("Intl.DisplayNames is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-displaynames\"\n", (0, $iqNwe.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $5wooz.filterProps)(options, $f402c3776c9708ff$var$DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    } catch (e) {
        onError(new (0, $9ZGqC.IntlFormatError)('Error formatting display name.', locale, e));
    }
}

});

parcelRegister("4aMZW", function(module, exports) {
$parcel$export(module.exports, "formatList", () => $309e1a933ea6d0ba$export$e8b8be48b45905bb);
$parcel$export(module.exports, "formatListToParts", () => $309e1a933ea6d0ba$export$6f284aad1934db69);

var $fvB0y = parcelRequire("fvB0y");

var $iqNwe = parcelRequire("iqNwe");

var $9ZGqC = parcelRequire("9ZGqC");

var $5wooz = parcelRequire("5wooz");
var $309e1a933ea6d0ba$var$LIST_FORMAT_OPTIONS = [
    'type',
    'style'
];
var $309e1a933ea6d0ba$var$now = Date.now();
function $309e1a933ea6d0ba$var$generateToken(i) {
    return "".concat($309e1a933ea6d0ba$var$now, "_").concat(i, "_").concat($309e1a933ea6d0ba$var$now);
}
function $309e1a933ea6d0ba$export$e8b8be48b45905bb(opts, getListFormat, values, options) {
    if (options === void 0) options = {};
    var results = $309e1a933ea6d0ba$export$6f284aad1934db69(opts, getListFormat, values, options).reduce(function(all, el) {
        var val = el.value;
        if (typeof val !== 'string') all.push(val);
        else if (typeof all[all.length - 1] === 'string') all[all.length - 1] += val;
        else all.push(val);
        return all;
    }, []);
    return results.length === 1 ? results[0] : results.length === 0 ? '' : results;
}
function $309e1a933ea6d0ba$export$6f284aad1934db69(_a, getListFormat, values, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    var ListFormat = Intl.ListFormat;
    if (!ListFormat) onError(new (0, $iqNwe.FormatError)("Intl.ListFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-listformat\"\n", (0, $iqNwe.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $5wooz.filterProps)(options, $309e1a933ea6d0ba$var$LIST_FORMAT_OPTIONS);
    try {
        var richValues_1 = {};
        var serializedValues = Array.from(values).map(function(v, i) {
            if (typeof v === 'object' && v !== null) {
                var id = $309e1a933ea6d0ba$var$generateToken(i);
                richValues_1[id] = v;
                return id;
            }
            return String(v);
        });
        return getListFormat(locale, filteredOptions).formatToParts(serializedValues).map(function(part) {
            return part.type === 'literal' ? part : (0, $fvB0y.__assign)((0, $fvB0y.__assign)({}, part), {
                value: richValues_1[part.value] || part.value
            });
        });
    } catch (e) {
        onError(new (0, $9ZGqC.IntlFormatError)('Error formatting list.', locale, e));
    }
    // @ts-ignore
    return values;
}

});

parcelRegister("j0vAa", function(module, exports) {
$parcel$export(module.exports, "formatMessage", () => $03922b6b4f5e4a4a$export$25868d1e8e76735f);

var $fvB0y = parcelRequire("fvB0y");
parcelRequire("35YLm");
var $caG7o = parcelRequire("caG7o");
parcelRequire("2d7mK");
var $1wqlV = parcelRequire("1wqlV");

var $9ZGqC = parcelRequire("9ZGqC");

var $5wooz = parcelRequire("5wooz");
function $03922b6b4f5e4a4a$var$setTimeZoneInOptions(opts, timeZone) {
    return Object.keys(opts).reduce(function(all, k) {
        all[k] = (0, $fvB0y.__assign)({
            timeZone: timeZone
        }, opts[k]);
        return all;
    }, {});
}
function $03922b6b4f5e4a4a$var$deepMergeOptions(opts1, opts2) {
    var keys = Object.keys((0, $fvB0y.__assign)((0, $fvB0y.__assign)({}, opts1), opts2));
    return keys.reduce(function(all, k) {
        all[k] = (0, $fvB0y.__assign)((0, $fvB0y.__assign)({}, opts1[k] || {}), opts2[k] || {});
        return all;
    }, {});
}
function $03922b6b4f5e4a4a$var$deepMergeFormatsAndSetTimeZone(f1, timeZone) {
    if (!timeZone) return f1;
    var mfFormats = (0, $1wqlV.IntlMessageFormat).formats;
    return (0, $fvB0y.__assign)((0, $fvB0y.__assign)((0, $fvB0y.__assign)({}, mfFormats), f1), {
        date: $03922b6b4f5e4a4a$var$deepMergeOptions($03922b6b4f5e4a4a$var$setTimeZoneInOptions(mfFormats.date, timeZone), $03922b6b4f5e4a4a$var$setTimeZoneInOptions(f1.date || {}, timeZone)),
        time: $03922b6b4f5e4a4a$var$deepMergeOptions($03922b6b4f5e4a4a$var$setTimeZoneInOptions(mfFormats.time, timeZone), $03922b6b4f5e4a4a$var$setTimeZoneInOptions(f1.time || {}, timeZone))
    });
}
var $03922b6b4f5e4a4a$export$25868d1e8e76735f = function(_a, state, messageDescriptor, values, opts) {
    var locale = _a.locale, formats = _a.formats, messages = _a.messages, defaultLocale = _a.defaultLocale, defaultFormats = _a.defaultFormats, fallbackOnEmptyString = _a.fallbackOnEmptyString, onError = _a.onError, timeZone = _a.timeZone, defaultRichTextElements = _a.defaultRichTextElements;
    if (messageDescriptor === void 0) messageDescriptor = {
        id: ''
    };
    var msgId = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
    // `id` is a required field of a Message Descriptor.
    (0, $5wooz.invariant)(!!msgId, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.github.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.github.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.github.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
    var id = String(msgId);
    var message = // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    messages && Object.prototype.hasOwnProperty.call(messages, id) && messages[id];
    // IMPORTANT: Hot path if `message` is AST with a single literal node
    if (Array.isArray(message) && message.length === 1 && message[0].type === (0, $caG7o.TYPE).literal) return message[0].value;
    // IMPORTANT: Hot path straight lookup for performance
    if (!values && message && typeof message === 'string' && !defaultRichTextElements) return message.replace(/'\{(.*?)\}'/gi, "{$1}");
    values = (0, $fvB0y.__assign)((0, $fvB0y.__assign)({}, defaultRichTextElements), values || {});
    formats = $03922b6b4f5e4a4a$var$deepMergeFormatsAndSetTimeZone(formats, timeZone);
    defaultFormats = $03922b6b4f5e4a4a$var$deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
    if (!message) {
        if (fallbackOnEmptyString === false && message === '') return message;
        if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) // This prevents warnings from littering the console in development
        // when no `messages` are passed into the <IntlProvider> for the
        // default locale.
        onError(new (0, $9ZGqC.MissingTranslationError)(messageDescriptor, locale));
        if (defaultMessage) try {
            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
            return formatter.format(values);
        } catch (e) {
            onError(new (0, $9ZGqC.MessageFormatError)("Error formatting default message for: \"".concat(id, "\", rendering default message verbatim"), locale, messageDescriptor, e));
            return typeof defaultMessage === 'string' ? defaultMessage : id;
        }
        return id;
    }
    // We have the translated message
    try {
        var formatter = state.getMessageFormat(message, locale, formats, (0, $fvB0y.__assign)({
            formatters: state
        }, opts || {}));
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $9ZGqC.MessageFormatError)("Error formatting message: \"".concat(id, "\", using ").concat(defaultMessage ? 'default message' : 'id', " as fallback."), locale, messageDescriptor, e));
    }
    if (defaultMessage) try {
        var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $9ZGqC.MessageFormatError)("Error formatting the default message for: \"".concat(id, "\", rendering message verbatim"), locale, messageDescriptor, e));
    }
    if (typeof message === 'string') return message;
    if (typeof defaultMessage === 'string') return defaultMessage;
    return id;
};

});

parcelRegister("fKWSw", function(module, exports) {
$parcel$export(module.exports, "formatNumber", () => $b788d2eff616ba12$export$f5dd818bff069720);
$parcel$export(module.exports, "formatNumberToParts", () => $b788d2eff616ba12$export$6871080848f10b2f);

var $9ZGqC = parcelRequire("9ZGqC");

var $5wooz = parcelRequire("5wooz");
var $b788d2eff616ba12$var$NUMBER_FORMAT_OPTIONS = [
    'style',
    'currency',
    'unit',
    'unitDisplay',
    'useGrouping',
    'minimumIntegerDigits',
    'minimumFractionDigits',
    'maximumFractionDigits',
    'minimumSignificantDigits',
    'maximumSignificantDigits',
    // ES2020 NumberFormat
    'compactDisplay',
    'currencyDisplay',
    'currencySign',
    'notation',
    'signDisplay',
    'unit',
    'unitDisplay',
    'numberingSystem',
    // ES2023 NumberFormat
    'trailingZeroDisplay',
    'roundingPriority',
    'roundingIncrement',
    'roundingMode'
];
function $b788d2eff616ba12$export$a7f9565e3c81cd54(_a, getNumberFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = format && (0, $5wooz.getNamedFormat)(formats, 'number', format, onError) || {};
    var filteredOptions = (0, $5wooz.filterProps)(options, $b788d2eff616ba12$var$NUMBER_FORMAT_OPTIONS, defaults);
    return getNumberFormat(locale, filteredOptions);
}
function $b788d2eff616ba12$export$f5dd818bff069720(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $b788d2eff616ba12$export$a7f9565e3c81cd54(config, getNumberFormat, options).format(value);
    } catch (e) {
        config.onError(new (0, $9ZGqC.IntlFormatError)('Error formatting number.', config.locale, e));
    }
    return String(value);
}
function $b788d2eff616ba12$export$6871080848f10b2f(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $b788d2eff616ba12$export$a7f9565e3c81cd54(config, getNumberFormat, options).formatToParts(value);
    } catch (e) {
        config.onError(new (0, $9ZGqC.IntlFormatError)('Error formatting number.', config.locale, e));
    }
    return [];
}

});

parcelRegister("kIPy1", function(module, exports) {
$parcel$export(module.exports, "formatPlural", () => $f15fe708d5df350e$export$bbbd05c900f3568d);

var $iqNwe = parcelRequire("iqNwe");

var $9ZGqC = parcelRequire("9ZGqC");

var $5wooz = parcelRequire("5wooz");
var $f15fe708d5df350e$var$PLURAL_FORMAT_OPTIONS = [
    'type'
];
function $f15fe708d5df350e$export$bbbd05c900f3568d(_a, getPluralRules, value, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    if (!Intl.PluralRules) onError(new (0, $iqNwe.FormatError)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $iqNwe.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $5wooz.filterProps)(options, $f15fe708d5df350e$var$PLURAL_FORMAT_OPTIONS);
    try {
        return getPluralRules(locale, filteredOptions).select(value);
    } catch (e) {
        onError(new (0, $9ZGqC.IntlFormatError)('Error formatting plural.', locale, e));
    }
    return 'other';
}

});

parcelRegister("kKMg8", function(module, exports) {
$parcel$export(module.exports, "formatRelativeTime", () => $f1bd89ceba0bc016$export$b4ea3b48dcf921f6);

var $5wooz = parcelRequire("5wooz");

var $iqNwe = parcelRequire("iqNwe");

var $9ZGqC = parcelRequire("9ZGqC");
var $f1bd89ceba0bc016$var$RELATIVE_TIME_FORMAT_OPTIONS = [
    'numeric',
    'style'
];
function $f1bd89ceba0bc016$var$getFormatter(_a, getRelativeTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = !!format && (0, $5wooz.getNamedFormat)(formats, 'relative', format, onError) || {};
    var filteredOptions = (0, $5wooz.filterProps)(options, $f1bd89ceba0bc016$var$RELATIVE_TIME_FORMAT_OPTIONS, defaults);
    return getRelativeTimeFormat(locale, filteredOptions);
}
function $f1bd89ceba0bc016$export$b4ea3b48dcf921f6(config, getRelativeTimeFormat, value, unit, options) {
    if (options === void 0) options = {};
    if (!unit) unit = 'second';
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    if (!RelativeTimeFormat) config.onError(new (0, $iqNwe.FormatError)("Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-relativetimeformat\"\n", (0, $iqNwe.ErrorCode).MISSING_INTL_API));
    try {
        return $f1bd89ceba0bc016$var$getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
    } catch (e) {
        config.onError(new (0, $9ZGqC.IntlFormatError)('Error formatting relative time.', config.locale, e));
    }
    return String(value);
}

});



parcelRegister("4IPLQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $37036e0c87c5adde$export$2e2bcd8739ae039);

var $fvB0y = parcelRequire("fvB0y");

var $4tluv = parcelRequire("4tluv");

var $7Ywk8 = parcelRequire("7Ywk8");
var $37036e0c87c5adde$var$FormattedDateTimeRange = function(props) {
    var intl = (0, $7Ywk8.default)();
    var from = props.from, to = props.to, children = props.children, formatProps = (0, $fvB0y.__rest)(props, [
        "from",
        "to",
        "children"
    ]);
    var formattedValue = intl.formatDateTimeRange(from, to, formatProps);
    if (typeof children === 'function') return children(formattedValue);
    var Text = intl.textComponent || $4tluv.Fragment;
    return $4tluv.createElement(Text, null, formattedValue);
};
$37036e0c87c5adde$var$FormattedDateTimeRange.displayName = 'FormattedDateTimeRange';
var $37036e0c87c5adde$export$2e2bcd8739ae039 = $37036e0c87c5adde$var$FormattedDateTimeRange;

});

parcelRegister("hFt0r", function(module, exports) {
$parcel$export(module.exports, "default", () => $cdccc402796dbdb0$export$2e2bcd8739ae039);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $4tluv = parcelRequire("4tluv");

var $7Ywk8 = parcelRequire("7Ywk8");
var $cdccc402796dbdb0$var$FormattedPlural = function(props) {
    var _a = (0, $7Ywk8.default)(), formatPlural = _a.formatPlural, Text = _a.textComponent;
    var value = props.value, other = props.other, children = props.children;
    var pluralCategory = formatPlural(value, props);
    var formattedPlural = props[pluralCategory] || other;
    if (typeof children === 'function') return children(formattedPlural);
    if (Text) return $4tluv.createElement(Text, null, formattedPlural);
    // Work around @types/react where React.FC cannot return string
    return formattedPlural;
};
$cdccc402796dbdb0$var$FormattedPlural.displayName = 'FormattedPlural';
var $cdccc402796dbdb0$export$2e2bcd8739ae039 = $cdccc402796dbdb0$var$FormattedPlural;

});

parcelRegister("iEMA6", function(module, exports) {
$parcel$export(module.exports, "default", () => $d951a5ace1304a82$export$2e2bcd8739ae039);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $fvB0y = parcelRequire("fvB0y");

var $5wooz = parcelRequire("5wooz");

var $4tluv = parcelRequire("4tluv");

var $cQG32 = parcelRequire("cQG32");

var $7D74H = parcelRequire("7D74H");

var $4K6RG = parcelRequire("4K6RG");
function $d951a5ace1304a82$var$processIntlConfig(config) {
    return {
        locale: config.locale,
        timeZone: config.timeZone,
        fallbackOnEmptyString: config.fallbackOnEmptyString,
        formats: config.formats,
        textComponent: config.textComponent,
        messages: config.messages,
        defaultLocale: config.defaultLocale,
        defaultFormats: config.defaultFormats,
        onError: config.onError,
        onWarn: config.onWarn,
        wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment,
        defaultRichTextElements: config.defaultRichTextElements
    };
}
var $d951a5ace1304a82$var$IntlProvider = /** @class */ function(_super) {
    (0, $fvB0y.__extends)(IntlProvider, _super);
    function IntlProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = (0, $5wooz.createIntlCache)();
        _this.state = {
            cache: _this.cache,
            intl: (0, $7D74H.createIntl)($d951a5ace1304a82$var$processIntlConfig(_this.props), _this.cache),
            prevConfig: $d951a5ace1304a82$var$processIntlConfig(_this.props)
        };
        return _this;
    }
    IntlProvider.getDerivedStateFromProps = function(props, _a) {
        var prevConfig = _a.prevConfig, cache = _a.cache;
        var config = $d951a5ace1304a82$var$processIntlConfig(props);
        if (!(0, $cQG32.shallowEqual)(prevConfig, config)) return {
            intl: (0, $7D74H.createIntl)(config, cache),
            prevConfig: config
        };
        return null;
    };
    IntlProvider.prototype.render = function() {
        (0, $cQG32.invariantIntlContext)(this.state.intl);
        return $4tluv.createElement((0, $4K6RG.Provider), {
            value: this.state.intl
        }, this.props.children);
    };
    IntlProvider.displayName = 'IntlProvider';
    IntlProvider.defaultProps = (0, $cQG32.DEFAULT_INTL_CONFIG);
    return IntlProvider;
}($4tluv.PureComponent);
var $d951a5ace1304a82$export$2e2bcd8739ae039 = $d951a5ace1304a82$var$IntlProvider;

});

parcelRegister("4QGGt", function(module, exports) {
$parcel$export(module.exports, "default", () => $387d20ee5bd4c482$export$2e2bcd8739ae039);

var $fvB0y = parcelRequire("fvB0y");

var $4tluv = parcelRequire("4tluv");

var $cQG32 = parcelRequire("cQG32");

var $7Ywk8 = parcelRequire("7Ywk8");
var $387d20ee5bd4c482$var$MINUTE = 60;
var $387d20ee5bd4c482$var$HOUR = 3600;
var $387d20ee5bd4c482$var$DAY = 86400;
function $387d20ee5bd4c482$var$selectUnit(seconds) {
    var absValue = Math.abs(seconds);
    if (absValue < $387d20ee5bd4c482$var$MINUTE) return 'second';
    if (absValue < $387d20ee5bd4c482$var$HOUR) return 'minute';
    if (absValue < $387d20ee5bd4c482$var$DAY) return 'hour';
    return 'day';
}
function $387d20ee5bd4c482$var$getDurationInSeconds(unit) {
    switch(unit){
        case 'second':
            return 1;
        case 'minute':
            return $387d20ee5bd4c482$var$MINUTE;
        case 'hour':
            return $387d20ee5bd4c482$var$HOUR;
        default:
            return $387d20ee5bd4c482$var$DAY;
    }
}
function $387d20ee5bd4c482$var$valueToSeconds(value, unit) {
    if (!value) return 0;
    switch(unit){
        case 'second':
            return value;
        case 'minute':
            return value * $387d20ee5bd4c482$var$MINUTE;
        default:
            return value * $387d20ee5bd4c482$var$HOUR;
    }
}
var $387d20ee5bd4c482$var$INCREMENTABLE_UNITS = [
    'second',
    'minute',
    'hour'
];
function $387d20ee5bd4c482$var$canIncrement(unit) {
    if (unit === void 0) unit = 'second';
    return $387d20ee5bd4c482$var$INCREMENTABLE_UNITS.indexOf(unit) > -1;
}
var $387d20ee5bd4c482$var$SimpleFormattedRelativeTime = function(props) {
    var _a = (0, $7Ywk8.default)(), formatRelativeTime = _a.formatRelativeTime, Text = _a.textComponent;
    var children = props.children, value = props.value, unit = props.unit, otherProps = (0, $fvB0y.__rest)(props, [
        "children",
        "value",
        "unit"
    ]);
    var formattedRelativeTime = formatRelativeTime(value || 0, unit, otherProps);
    if (typeof children === 'function') return children(formattedRelativeTime);
    if (Text) return $4tluv.createElement(Text, null, formattedRelativeTime);
    return $4tluv.createElement($4tluv.Fragment, null, formattedRelativeTime);
};
var $387d20ee5bd4c482$var$FormattedRelativeTime = function(_a) {
    var _b = _a.value, value = _b === void 0 ? 0 : _b, _c = _a.unit, unit = _c === void 0 ? 'second' : _c, updateIntervalInSeconds = _a.updateIntervalInSeconds, otherProps = (0, $fvB0y.__rest)(_a, [
        "value",
        "unit",
        "updateIntervalInSeconds"
    ]);
    (0, $cQG32.invariant)(!updateIntervalInSeconds || !!(updateIntervalInSeconds && $387d20ee5bd4c482$var$canIncrement(unit)), 'Cannot schedule update with unit longer than hour');
    var _d = $4tluv.useState(), prevUnit = _d[0], setPrevUnit = _d[1];
    var _e = $4tluv.useState(0), prevValue = _e[0], setPrevValue = _e[1];
    var _f = $4tluv.useState(0), currentValueInSeconds = _f[0], setCurrentValueInSeconds = _f[1];
    var updateTimer;
    if (unit !== prevUnit || value !== prevValue) {
        setPrevValue(value || 0);
        setPrevUnit(unit);
        setCurrentValueInSeconds($387d20ee5bd4c482$var$canIncrement(unit) ? $387d20ee5bd4c482$var$valueToSeconds(value, unit) : 0);
    }
    $4tluv.useEffect(function() {
        function clearUpdateTimer() {
            clearTimeout(updateTimer);
        }
        clearUpdateTimer();
        // If there's no interval and we cannot increment this unit, do nothing
        if (!updateIntervalInSeconds || !$387d20ee5bd4c482$var$canIncrement(unit)) return clearUpdateTimer;
        // Figure out the next interesting time
        var nextValueInSeconds = currentValueInSeconds - updateIntervalInSeconds;
        var nextUnit = $387d20ee5bd4c482$var$selectUnit(nextValueInSeconds);
        // We've reached the max auto incrementable unit, don't schedule another update
        if (nextUnit === 'day') return clearUpdateTimer;
        var unitDuration = $387d20ee5bd4c482$var$getDurationInSeconds(nextUnit);
        var remainder = nextValueInSeconds % unitDuration;
        var prevInterestingValueInSeconds = nextValueInSeconds - remainder;
        var nextInterestingValueInSeconds = prevInterestingValueInSeconds >= currentValueInSeconds ? prevInterestingValueInSeconds - unitDuration : prevInterestingValueInSeconds;
        var delayInSeconds = Math.abs(nextInterestingValueInSeconds - currentValueInSeconds);
        if (currentValueInSeconds !== nextInterestingValueInSeconds) updateTimer = setTimeout(function() {
            return setCurrentValueInSeconds(nextInterestingValueInSeconds);
        }, delayInSeconds * 1e3);
        return clearUpdateTimer;
    }, [
        currentValueInSeconds,
        updateIntervalInSeconds,
        unit
    ]);
    var currentValue = value || 0;
    var currentUnit = unit;
    if ($387d20ee5bd4c482$var$canIncrement(unit) && typeof currentValueInSeconds === 'number' && updateIntervalInSeconds) {
        currentUnit = $387d20ee5bd4c482$var$selectUnit(currentValueInSeconds);
        var unitDuration = $387d20ee5bd4c482$var$getDurationInSeconds(currentUnit);
        currentValue = Math.round(currentValueInSeconds / unitDuration);
    }
    return $4tluv.createElement($387d20ee5bd4c482$var$SimpleFormattedRelativeTime, (0, $fvB0y.__assign)({
        value: currentValue,
        unit: currentUnit
    }, otherProps));
};
$387d20ee5bd4c482$var$FormattedRelativeTime.displayName = 'FormattedRelativeTime';
var $387d20ee5bd4c482$export$2e2bcd8739ae039 = $387d20ee5bd4c482$var$FormattedRelativeTime;

});



parcelRegister("1wxU2", function(module, exports) {
$parcel$export(module.exports, "initUFO", () => (parcelRequire("iVysF")).initUFO);
$parcel$export(module.exports, "useReactUFORouteWatcher", () => (parcelRequire("67pgD")).useReactUFORouteWatcher);
$parcel$export(module.exports, "useReportUFOError", () => (parcelRequire("j0FUQ")).useReportUFOError);
$parcel$export(module.exports, "UFOLoadingSpinner", () => (parcelRequire("8widT")).UFOLoadingSpinner);
$parcel$export(module.exports, "UFOSuspenseFallback", () => (parcelRequire("cFd5E")).UFOSuspenseFallback);
$parcel$export(module.exports, "UFOSegment", () => (parcelRequire("cyDwo")).default);

var $iVysF = parcelRequire("iVysF");

var $67pgD = parcelRequire("67pgD");

var $j0FUQ = parcelRequire("j0FUQ");

var $7jMOi = parcelRequire("7jMOi");

var $8widT = parcelRequire("8widT");

var $cFd5E = parcelRequire("cFd5E");




var $cyDwo = parcelRequire("cyDwo");


});
parcelRegister("iVysF", function(module, exports) {
$parcel$export(module.exports, "initUFO", () => $b775c8566bc86c35$export$af995ee1d7017fea);

var $ijGRe = parcelRequire("ijGRe");

var $c1YdO = parcelRequire("c1YdO");

var $dX6kP = parcelRequire("dX6kP");

var $7jMOi = parcelRequire("7jMOi");
function $b775c8566bc86c35$export$af995ee1d7017fea() {
    const config = {
        product: "rovoExtension",
        region: "prod-west2",
        kind: {
            page_load: 1,
            transition: 1,
            press: 1,
            typing: 0,
            legacy: 0,
            hover: 0
        },
        vc: {
            enabled: true,
            heatmapSize: 200,
            oldDomUpdates: false,
            devToolsEnabled: false,
            selectorConfig: {
                id: false,
                role: true,
                className: true,
                testId: true
            }
        },
        assetsConfig: $7jMOi.assetsConfig
    };
    (0, $ijGRe.init)(Promise.resolve((0, $dX6kP.analyticsClient)), config);
    (0, $c1YdO.default)();
}

});
parcelRegister("ijGRe", function(module, exports) {
$parcel$export(module.exports, "init", () => $8f65e915699be785$export$2cd8252107eb640b);

var $1IBIv = parcelRequire("1IBIv");

var $3X3Vo = parcelRequire("3X3Vo");

var $a4SHs = parcelRequire("a4SHs");

var $dXdid = parcelRequire("dXdid");

var $50omK = parcelRequire("50omK");

var $9pXDa = parcelRequire("9pXDa");

var $i2PYg = parcelRequire("i2PYg");

var $fubJS = parcelRequire("fubJS");

var $dWn9F = parcelRequire("dWn9F");

var $bCt4g = parcelRequire("bCt4g");

var $CBD6A = parcelRequire("CBD6A");

var $7Xuvn = parcelRequire("7Xuvn");

var $7j9k3 = parcelRequire("7j9k3");
let $8f65e915699be785$var$initialized = false;
function $8f65e915699be785$var$sinkInteraction(instance, payloadPackage) {
    function sinkFn(interactionId, interaction) {
        function onIdle() {
            payloadPackage.createPayloads(interactionId, interaction).then((payloads)=>{
                // NOTE: This API is used by the UFO DevTool Chrome Extension and Criterion
                const devToolObserver = globalThis.__ufo_devtool_onUfoPayload;
                payloads?.forEach((payload)=>{
                    if (typeof devToolObserver === 'function') devToolObserver?.(payload);
                    instance.sendOperationalEvent(payload);
                });
            }).catch((error)=>{
                throw error;
            });
        }
        (0, $7j9k3.default)(onIdle);
    }
    (0, $dWn9F.sinkInteractionHandler)(sinkFn);
}
function $8f65e915699be785$var$sinkExperimentalInteractionMetrics(instance, payloadPackage) {
    function experimentalMetricsSinkFn(interactionId, interaction) {
        function experimentalMetricsOnIdle() {
            const payloadPromise = payloadPackage.createExperimentalMetricsPayload(interactionId, interaction);
            payloadPromise.then((payload)=>{
                if (payload) instance.sendOperationalEvent(payload);
            });
        }
        (0, $7j9k3.default)(experimentalMetricsOnIdle);
    }
    (0, $50omK.sinkExperimentalHandler)(experimentalMetricsSinkFn);
}
function $8f65e915699be785$var$sinkPostInteractionLog(instance, createPostInteractionLogPayload) {
    (0, $dWn9F.sinkPostInteractionLogHandler)((logOutput)=>{
        (0, $7j9k3.default)(()=>{
            const payload = createPostInteractionLogPayload(logOutput);
            if (payload) instance.sendOperationalEvent(payload);
        });
    });
}
function $8f65e915699be785$var$sinkTerminalErrors(instance, createTerminalErrorPayload) {
    (0, $7Xuvn.sinkTerminalErrorHandler)((errorData, context)=>{
        (0, $7j9k3.default)(()=>{
            const payload = createTerminalErrorPayload(errorData, context);
            if (payload) instance.sendOperationalEvent(payload);
        });
    });
}
function $8f65e915699be785$var$sinkInteractionExtraMetrics(instance, createInteractionExtraLogPayload) {
    (0, $dWn9F.interactionExtraMetrics).sinkHandler((interactionId, interaction, lastInteractionFinish, lastInteractionFinishVCResult)=>{
        (0, $7j9k3.default)(async ()=>{
            const payload = await createInteractionExtraLogPayload(interactionId, interaction, lastInteractionFinish, lastInteractionFinishVCResult);
            if (payload) instance.sendOperationalEvent(payload);
        });
    });
}
function $8f65e915699be785$var$sinkExtraSearchPageInteraction(instance, payloadPackage) {
    function sinkFn(interactionId, interaction) {
        function onIdle() {
            payloadPackage.createExtraSearchPageInteractionPayload(interactionId, interaction).then((payloads)=>{
                // NOTE: This API is used by the UFO DevTool Chrome Extension and Criterion
                const devToolObserver = globalThis.__ufo_devtool_onUfoPayload;
                payloads?.forEach((payload)=>{
                    if (typeof devToolObserver === 'function') devToolObserver?.(payload);
                    instance.sendOperationalEvent(payload);
                });
            }).catch((error)=>{
                throw error;
            });
        }
        (0, $7j9k3.default)(onIdle);
    }
    (0, $9pXDa.sinkExtraSearchPageInteractionHandler)(sinkFn);
}




function $8f65e915699be785$export$2cd8252107eb640b(analyticsWebClientAsync, config) {
    if ($8f65e915699be785$var$initialized) return;
    // Always set config first so isUFOEnabled() can check config.enabled
    (0, $dXdid.setUFOConfig)(config);
    // If UFO is disabled via config, skip all initialization
    if (!(0, $dXdid.isUFOEnabled)()) {
        $8f65e915699be785$var$initialized = true;
        return;
    }
    // Initialize pressure observer for CPU usage monitoring
    (0, $CBD6A.initialisePressureObserver)();
    (0, $CBD6A.initialiseMemoryObserver)();
    if ((0, $3X3Vo.fg)('platform_ufo_enable_otel_context_manager')) {
        // Configure global OTel context manager
        const contextManager = new (0, $i2PYg.UFOContextManager)();
        // set the contextmanager somewhere we can reference it later
        (0, $i2PYg.setContextManager)(contextManager);
        // Register the context manager with the global OTel API
        contextManager.enable();
        (0, $1IBIv.context).setGlobalContextManager(contextManager);
    }
    if (config.vc?.enabled) {
        const vcOptions = {
            heatmapSize: config.vc.heatmapSize,
            oldDomUpdates: config.vc.oldDomUpdates,
            devToolsEnabled: config.vc.devToolsEnabled,
            // Use centralised getter so the FedRAMP override (forces every
            // selector field to false) is applied consistently.
            selectorConfig: (0, $dXdid.getSelectorConfig)(),
            ssrEnablePageLayoutPlaceholder: config.vc.ssrEnablePageLayoutPlaceholder,
            trackLayoutShiftOffenders: config.vc.trackLayoutShiftOffenders
        };
        (0, $dWn9F.postInteractionLog).initializeVCObserver(vcOptions);
        if (config?.experimentalInteractionMetrics?.enabled) (0, $50omK.experimentalVC).initialize(vcOptions).start({
            startTime: 0
        });
        if (config?.extraInteractionMetrics?.enabled) (0, $dWn9F.interactionExtraMetrics).initializeVCObserver(vcOptions);
    }
    (0, $fubJS.setupHiddenTimingCapture)();
    (0, $a4SHs.startLighthouseObserver)();
    (0, $fubJS.setupThrottleDetection)();
    $8f65e915699be785$var$initialized = true;
    if (typeof PerformanceObserver !== 'undefined') {
        const observer = (0, $bCt4g.getPerformanceObserver)();
        observer.observe({
            type: 'event',
            buffered: true,
            durationThreshold: 16
        });
    }
    Promise.all([
        analyticsWebClientAsync,
        (parcelRequire("7SxnG")),
        (parcelRequire("9E4E1")),
        (parcelRequire("hg288")),
        (parcelRequire("eDJTo"))
    ]).then(([awc, payloadPackage, createPostInteractionLogPayloadPackage, createInteractionExtraMetricsPayloadPackage, createTerminalErrorPayloadPackage])=>{
        if (awc.getAnalyticsWebClientPromise) awc.getAnalyticsWebClientPromise().then((client)=>{
            const instance = client.getInstance();
            $8f65e915699be785$var$sinkInteraction(instance, payloadPackage);
            if (config?.terminalErrors?.enabled && (0, $3X3Vo.fg)('platform_ufo_enable_terminal_errors')) $8f65e915699be785$var$sinkTerminalErrors(instance, createTerminalErrorPayloadPackage.default);
            if (config?.experimentalInteractionMetrics?.enabled) $8f65e915699be785$var$sinkExperimentalInteractionMetrics(instance, payloadPackage);
            if (config.postInteractionLog?.enabled) $8f65e915699be785$var$sinkPostInteractionLog(instance, createPostInteractionLogPayloadPackage.default);
            if (config?.extraInteractionMetrics?.enabled) $8f65e915699be785$var$sinkInteractionExtraMetrics(instance, createInteractionExtraMetricsPayloadPackage.default);
            if (config?.extraSearchPageInteraction?.enabled) $8f65e915699be785$var$sinkExtraSearchPageInteraction(instance, payloadPackage);
        });
        else if (awc.sendOperationalEvent) {
            $8f65e915699be785$var$sinkInteraction(awc, payloadPackage);
            if (config?.terminalErrors?.enabled && (0, $3X3Vo.fg)('platform_ufo_enable_terminal_errors')) $8f65e915699be785$var$sinkTerminalErrors(awc, createTerminalErrorPayloadPackage.default);
            if (config?.experimentalInteractionMetrics?.enabled) $8f65e915699be785$var$sinkExperimentalInteractionMetrics(awc, payloadPackage);
            if (config.postInteractionLog?.enabled) $8f65e915699be785$var$sinkPostInteractionLog(awc, createPostInteractionLogPayloadPackage.default);
            if (config?.extraInteractionMetrics?.enabled) $8f65e915699be785$var$sinkInteractionExtraMetrics(awc, createInteractionExtraMetricsPayloadPackage.default);
            if (config?.extraSearchPageInteraction?.enabled) $8f65e915699be785$var$sinkExtraSearchPageInteraction(awc, payloadPackage);
        }
    });
}

});
parcelRegister("3X3Vo", function(module, exports) {
$parcel$export(module.exports, "setBooleanFeatureFlagResolver", () => $340478607cc68955$export$ba05d765b8392e5e);
$parcel$export(module.exports, "fg", () => $340478607cc68955$export$b40ec24ac8275656);

var $i3uKA = parcelRequire("i3uKA");
function $340478607cc68955$export$ba05d765b8392e5e(flagResolver) {
    (0, $i3uKA.setBooleanResolver)(flagResolver);
}
function $340478607cc68955$export$470e5c2be1411c89(name) {
    return (0, $i3uKA.resolveBooleanFlag)(name);
}
function $340478607cc68955$export$b40ec24ac8275656(name) {
    return (0, $i3uKA.resolveBooleanFlag)(name);
}

});
parcelRegister("i3uKA", function(module, exports) {
$parcel$export(module.exports, "setBooleanResolver", () => $105dac64b83dbf14$export$f2b591175b3e424c);
$parcel$export(module.exports, "resolveBooleanFlag", () => $105dac64b83dbf14$export$6333b6aff9fc6275);

var $lVHOI = parcelRequire("lVHOI");

var $kWxvM = parcelRequire("kWxvM");

var $hcSxw = parcelRequire("hcSxw");
const $105dac64b83dbf14$var$pkgName = '@atlaskit/platform-feature-flags';
const $105dac64b83dbf14$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
const $105dac64b83dbf14$var$hasProcessEnv = typeof $hcSxw !== 'undefined' && typeof $hcSxw.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
const $105dac64b83dbf14$var$ENV_ENABLE_PLATFORM_FF = $105dac64b83dbf14$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
const $105dac64b83dbf14$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $105dac64b83dbf14$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
const $105dac64b83dbf14$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $105dac64b83dbf14$var$ENV_ENABLE_PLATFORM_FF || $105dac64b83dbf14$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
const $105dac64b83dbf14$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
const $105dac64b83dbf14$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$105dac64b83dbf14$var$globalVar[$105dac64b83dbf14$export$7e41b1b2bdee3f98] = $105dac64b83dbf14$var$globalVar[$105dac64b83dbf14$export$7e41b1b2bdee3f98] || $105dac64b83dbf14$var$DEFAULT_PFF_GLOBAL;
function $105dac64b83dbf14$export$f2b591175b3e424c(resolver) {
    $105dac64b83dbf14$var$globalVar[$105dac64b83dbf14$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $105dac64b83dbf14$export$6333b6aff9fc6275(flagKey) {
    if ($105dac64b83dbf14$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $kWxvM.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $105dac64b83dbf14$var$pkgName, flagKey);
        return true;
    }
    try {
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if ($105dac64b83dbf14$var$globalVar[$105dac64b83dbf14$export$7e41b1b2bdee3f98]?.booleanResolver === undefined || $105dac64b83dbf14$var$globalVar[$105dac64b83dbf14$export$7e41b1b2bdee3f98]?.booleanResolver === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $lVHOI.default).checkGate(flagKey);
        const result = $105dac64b83dbf14$var$globalVar[$105dac64b83dbf14$export$7e41b1b2bdee3f98]?.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn(`${flagKey} resolved to a non-boolean value, returning false for safety`);
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("kWxvM", function(module, exports) {
$parcel$export(module.exports, "debug", () => $f58165a8b9b808a3$export$1c9f709888824e05);
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
const $f58165a8b9b808a3$var$TESTS_MODE = globalThis?.process?.env?.JEST_WORKER_ID !== undefined;
const $f58165a8b9b808a3$var$DEBUG_MODE = !$f58165a8b9b808a3$var$TESTS_MODE && globalThis?.process?.env?.NODE_ENV !== 'production';
const $f58165a8b9b808a3$export$1c9f709888824e05 = (...args)=>{
    if (!$f58165a8b9b808a3$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    console.debug(...args);
};

});

parcelRegister("hcSxw", function(module, exports) {
// shim for using process in browser
var $c86ddd1fcec6baba$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $c86ddd1fcec6baba$var$cachedSetTimeout;
var $c86ddd1fcec6baba$var$cachedClearTimeout;
function $c86ddd1fcec6baba$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $c86ddd1fcec6baba$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $c86ddd1fcec6baba$var$cachedSetTimeout = setTimeout;
        else $c86ddd1fcec6baba$var$cachedSetTimeout = $c86ddd1fcec6baba$var$defaultSetTimout;
    } catch (e) {
        $c86ddd1fcec6baba$var$cachedSetTimeout = $c86ddd1fcec6baba$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $c86ddd1fcec6baba$var$cachedClearTimeout = clearTimeout;
        else $c86ddd1fcec6baba$var$cachedClearTimeout = $c86ddd1fcec6baba$var$defaultClearTimeout;
    } catch (e) {
        $c86ddd1fcec6baba$var$cachedClearTimeout = $c86ddd1fcec6baba$var$defaultClearTimeout;
    }
})();
function $c86ddd1fcec6baba$var$runTimeout(fun) {
    if ($c86ddd1fcec6baba$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($c86ddd1fcec6baba$var$cachedSetTimeout === $c86ddd1fcec6baba$var$defaultSetTimout || !$c86ddd1fcec6baba$var$cachedSetTimeout) && setTimeout) {
        $c86ddd1fcec6baba$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $c86ddd1fcec6baba$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $c86ddd1fcec6baba$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $c86ddd1fcec6baba$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $c86ddd1fcec6baba$var$runClearTimeout(marker) {
    if ($c86ddd1fcec6baba$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($c86ddd1fcec6baba$var$cachedClearTimeout === $c86ddd1fcec6baba$var$defaultClearTimeout || !$c86ddd1fcec6baba$var$cachedClearTimeout) && clearTimeout) {
        $c86ddd1fcec6baba$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $c86ddd1fcec6baba$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $c86ddd1fcec6baba$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $c86ddd1fcec6baba$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $c86ddd1fcec6baba$var$queue = [];
var $c86ddd1fcec6baba$var$draining = false;
var $c86ddd1fcec6baba$var$currentQueue;
var $c86ddd1fcec6baba$var$queueIndex = -1;
function $c86ddd1fcec6baba$var$cleanUpNextTick() {
    if (!$c86ddd1fcec6baba$var$draining || !$c86ddd1fcec6baba$var$currentQueue) return;
    $c86ddd1fcec6baba$var$draining = false;
    if ($c86ddd1fcec6baba$var$currentQueue.length) $c86ddd1fcec6baba$var$queue = $c86ddd1fcec6baba$var$currentQueue.concat($c86ddd1fcec6baba$var$queue);
    else $c86ddd1fcec6baba$var$queueIndex = -1;
    if ($c86ddd1fcec6baba$var$queue.length) $c86ddd1fcec6baba$var$drainQueue();
}
function $c86ddd1fcec6baba$var$drainQueue() {
    if ($c86ddd1fcec6baba$var$draining) return;
    var timeout = $c86ddd1fcec6baba$var$runTimeout($c86ddd1fcec6baba$var$cleanUpNextTick);
    $c86ddd1fcec6baba$var$draining = true;
    var len = $c86ddd1fcec6baba$var$queue.length;
    while(len){
        $c86ddd1fcec6baba$var$currentQueue = $c86ddd1fcec6baba$var$queue;
        $c86ddd1fcec6baba$var$queue = [];
        while(++$c86ddd1fcec6baba$var$queueIndex < len)if ($c86ddd1fcec6baba$var$currentQueue) $c86ddd1fcec6baba$var$currentQueue[$c86ddd1fcec6baba$var$queueIndex].run();
        $c86ddd1fcec6baba$var$queueIndex = -1;
        len = $c86ddd1fcec6baba$var$queue.length;
    }
    $c86ddd1fcec6baba$var$currentQueue = null;
    $c86ddd1fcec6baba$var$draining = false;
    $c86ddd1fcec6baba$var$runClearTimeout(timeout);
}
$c86ddd1fcec6baba$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $c86ddd1fcec6baba$var$queue.push(new $c86ddd1fcec6baba$var$Item(fun, args));
    if ($c86ddd1fcec6baba$var$queue.length === 1 && !$c86ddd1fcec6baba$var$draining) $c86ddd1fcec6baba$var$runTimeout($c86ddd1fcec6baba$var$drainQueue);
};
// v8 likes predictible objects
function $c86ddd1fcec6baba$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$c86ddd1fcec6baba$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$c86ddd1fcec6baba$var$process.title = 'browser';
$c86ddd1fcec6baba$var$process.browser = true;
$c86ddd1fcec6baba$var$process.env = {};
$c86ddd1fcec6baba$var$process.argv = [];
$c86ddd1fcec6baba$var$process.version = ''; // empty string to avoid regexp issues
$c86ddd1fcec6baba$var$process.versions = {};
function $c86ddd1fcec6baba$var$noop() {}
$c86ddd1fcec6baba$var$process.on = $c86ddd1fcec6baba$var$noop;
$c86ddd1fcec6baba$var$process.addListener = $c86ddd1fcec6baba$var$noop;
$c86ddd1fcec6baba$var$process.once = $c86ddd1fcec6baba$var$noop;
$c86ddd1fcec6baba$var$process.off = $c86ddd1fcec6baba$var$noop;
$c86ddd1fcec6baba$var$process.removeListener = $c86ddd1fcec6baba$var$noop;
$c86ddd1fcec6baba$var$process.removeAllListeners = $c86ddd1fcec6baba$var$noop;
$c86ddd1fcec6baba$var$process.emit = $c86ddd1fcec6baba$var$noop;
$c86ddd1fcec6baba$var$process.prependListener = $c86ddd1fcec6baba$var$noop;
$c86ddd1fcec6baba$var$process.prependOnceListener = $c86ddd1fcec6baba$var$noop;
$c86ddd1fcec6baba$var$process.listeners = function(name) {
    return [];
};
$c86ddd1fcec6baba$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$c86ddd1fcec6baba$var$process.cwd = function() {
    return '/';
};
$c86ddd1fcec6baba$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$c86ddd1fcec6baba$var$process.umask = function() {
    return 0;
};

});



parcelRegister("a4SHs", function(module, exports) {
$parcel$export(module.exports, "startLighthouseObserver", () => $be17c3dccb19fcba$export$5ecf2aafafee3e0);
$parcel$export(module.exports, "getLighthouseMetrics", () => $be17c3dccb19fcba$export$b46cecdf698e4bb5);

var $dQuZO = parcelRequire("dQuZO");

var $7SNUQ = parcelRequire("7SNUQ");

var $98eKn = parcelRequire("98eKn");

var $2BLOW = parcelRequire("2BLOW");

var $9Ufks = parcelRequire("9Ufks");
function $be17c3dccb19fcba$export$5ecf2aafafee3e0() {
    (0, $9Ufks.startLSObserver)();
    (0, $9Ufks.startLTObserver)();
}
function $be17c3dccb19fcba$export$b46cecdf698e4bb5({ start: start, stop: stop }) {
    const tbt = (0, $98eKn.getTBT)(start, stop, (0, $2BLOW.EntriesBuffer)[(0, $7SNUQ.PerformanceObserverEntryTypes).LongTask]);
    // no round as CLS is usually 0-1
    const cls = (0, $dQuZO.getCLS)(start, stop, (0, $2BLOW.EntriesBuffer)[(0, $7SNUQ.PerformanceObserverEntryTypes).LayoutShift]);
    return {
        'metric:tbt': Math.round(tbt.total),
        'metric:tbt:observed': Math.round(tbt.observed),
        'metric:cls': cls
    };
}

});
parcelRegister("dQuZO", function(module, exports) {
$parcel$export(module.exports, "getCLS", () => $bc1f42159fd8b57e$export$fc6227831ee7c7);

var $3X3Vo = parcelRequire("3X3Vo");
function $bc1f42159fd8b57e$var$isSameRects(rect1, rect2) {
    return rect1.x === rect2.x && rect1.y === rect2.y && rect1.width === rect2.width && rect1.height === rect2.height && rect1.top === rect2.top && rect1.right === rect2.right && rect1.bottom === rect2.bottom && rect1.left === rect2.left;
}
function $bc1f42159fd8b57e$export$fc6227831ee7c7(start, stop, buffer) {
    const layoutShifts = buffer.getAll().filter((_entry)=>{
        const entry = _entry;
        const isWithinObservationWindow = entry.startTime >= start && entry.startTime <= stop;
        if ((0, $3X3Vo.fg)('platform_ufo_filter_cls_logs_same_rects_positions')) {
            const allSourcesHaveSameRects = entry?.sources?.every(({ previousRect: previousRect, currentRect: currentRect })=>$bc1f42159fd8b57e$var$isSameRects(previousRect, currentRect));
            return isWithinObservationWindow && !allSourcesHaveSameRects;
        }
        return isWithinObservationWindow;
    });
    const sessionWindows = [];
    let currentWindow = null;
    // Group layout shifts into session windows
    for (const shift of layoutShifts){
        const { startTime: startTime } = shift;
        const endTime = shift.startTime + shift.duration;
        const score = shift.value;
        if (currentWindow === null || startTime - currentWindow.endTime > 1000 || endTime - currentWindow.startTime > 5000) {
            // Start a new session window
            currentWindow = {
                startTime: startTime,
                endTime: endTime,
                score: score
            };
            sessionWindows.push(currentWindow);
        } else {
            // Add layout shift to current session window
            currentWindow.endTime = endTime;
            currentWindow.score += score;
        }
    }
    // Find session window with highest cumulative score
    const maxScore = sessionWindows.reduce((max, sessionWindow)=>sessionWindow.score > max ? sessionWindow.score : max, 0);
    // Return score of largest burst as CLS metric
    return Math.round(maxScore * 10000) / 10000;
}

});

parcelRegister("7SNUQ", function(module, exports) {
$parcel$export(module.exports, "PerformanceObserverEntryTypes", () => $de0ba265ff87e226$export$a4def92db6fc8e17);
const $de0ba265ff87e226$export$a4def92db6fc8e17 = {
    LayoutShift: 'layout-shift',
    LongTask: 'longtask'
};

});

parcelRegister("98eKn", function(module, exports) {
$parcel$export(module.exports, "getTBT", () => $1f9191fa45cc8380$export$2d6e933b35bd3407);
const $1f9191fa45cc8380$var$MAX_ACCEPTABLE_TASK_DURATION = 50;
function $1f9191fa45cc8380$export$2d6e933b35bd3407(start, stop, buffer) {
    return buffer.getAll().filter((entry)=>entry.startTime <= stop && entry.duration > $1f9191fa45cc8380$var$MAX_ACCEPTABLE_TASK_DURATION && (entry.startTime >= start || entry.startTime + entry.duration >= start || entry.startTime <= start && entry.startTime + entry.duration >= stop)).reduce((tbt, entry)=>{
        const longTaskStop = entry.startTime + entry.duration;
        const intersectStart = Math.max(entry.startTime + $1f9191fa45cc8380$var$MAX_ACCEPTABLE_TASK_DURATION, start);
        const intersectStop = Math.min(longTaskStop, stop);
        const longTaskIncluded = Math.max(intersectStop - intersectStart, 0);
        // eslint-disable-next-line no-param-reassign
        tbt.observed += entry.duration - $1f9191fa45cc8380$var$MAX_ACCEPTABLE_TASK_DURATION;
        // eslint-disable-next-line no-param-reassign
        tbt.total += longTaskIncluded;
        return tbt;
    }, {
        total: 0,
        observed: 0
    });
}

});

parcelRegister("2BLOW", function(module, exports) {
$parcel$export(module.exports, "EntriesBuffer", () => $ee7233021c0c78af$export$f7dc16cbd16f7bbe);

var $7SNUQ = parcelRequire("7SNUQ");
class $ee7233021c0c78af$export$2c6e86519c9e8188 {
    constructor(maxLength = 1000){
        this.buffer = [];
        this.full = false;
        this.maxLength = maxLength;
    }
    push(item) {
        if (this.full || this.maxLength === this.buffer.length) {
            this.full = true;
            this.buffer.shift();
        }
        this.buffer.push(item);
    }
    getAll() {
        return this.buffer;
    }
}
const $ee7233021c0c78af$export$f7dc16cbd16f7bbe = {
    [(0, $7SNUQ.PerformanceObserverEntryTypes).LongTask]: new $ee7233021c0c78af$export$2c6e86519c9e8188(),
    [(0, $7SNUQ.PerformanceObserverEntryTypes).LayoutShift]: new $ee7233021c0c78af$export$2c6e86519c9e8188()
};

});

parcelRegister("9Ufks", function(module, exports) {
$parcel$export(module.exports, "startLSObserver", () => $458def105ef7017a$export$768ccc3ab7bac3ea);
$parcel$export(module.exports, "startLTObserver", () => $458def105ef7017a$export$54fb8b6aaf70ec9c);

var $7SNUQ = parcelRequire("7SNUQ");

var $2BLOW = parcelRequire("2BLOW");
let $458def105ef7017a$var$pe = null;
function $458def105ef7017a$var$getObserver() {
    if (typeof PerformanceObserver !== 'function') // Only instantiate the IntersectionObserver if it's supported
    return null;
    if ($458def105ef7017a$var$pe !== null) return $458def105ef7017a$var$pe;
    const performanceObserverCallback = (list)=>{
        list.getEntries().forEach((entry)=>{
            if (entry.entryType === (0, $7SNUQ.PerformanceObserverEntryTypes).LayoutShift) (0, $2BLOW.EntriesBuffer)[(0, $7SNUQ.PerformanceObserverEntryTypes).LayoutShift].push(entry);
            if (entry.entryType === (0, $7SNUQ.PerformanceObserverEntryTypes).LongTask) (0, $2BLOW.EntriesBuffer)[(0, $7SNUQ.PerformanceObserverEntryTypes).LongTask].push(entry);
        });
    };
    $458def105ef7017a$var$pe = new PerformanceObserver(performanceObserverCallback);
    return $458def105ef7017a$var$pe;
}
function $458def105ef7017a$export$768ccc3ab7bac3ea() {
    $458def105ef7017a$var$getObserver()?.observe({
        type: (0, $7SNUQ.PerformanceObserverEntryTypes).LayoutShift,
        buffered: true
    });
}
function $458def105ef7017a$export$54fb8b6aaf70ec9c() {
    $458def105ef7017a$var$getObserver()?.observe({
        type: (0, $7SNUQ.PerformanceObserverEntryTypes).LongTask,
        buffered: true
    });
}

});


parcelRegister("dXdid", function(module, exports) {
$parcel$export(module.exports, "isFedrampOverrideActive", () => $f83a2a0ae3838e5f$export$1133b5e2873baa7a);
$parcel$export(module.exports, "DEFAULT_TTVC_REVISION", () => $f83a2a0ae3838e5f$export$f9bb3bb330fb9609);
$parcel$export(module.exports, "setUFOConfig", () => $f83a2a0ae3838e5f$export$10d6139a8fb42158);
$parcel$export(module.exports, "getConfig", () => $f83a2a0ae3838e5f$export$44487a86467333c3);
$parcel$export(module.exports, "getSelectorConfig", () => $f83a2a0ae3838e5f$export$59e1f072477dfb48);
$parcel$export(module.exports, "isUFOEnabled", () => $f83a2a0ae3838e5f$export$74bdb753f1cf4860);
$parcel$export(module.exports, "isVCRevisionEnabled", () => $f83a2a0ae3838e5f$export$4babcefc81a3ef0b);
$parcel$export(module.exports, "getMostRecentVCRevision", () => $f83a2a0ae3838e5f$export$70184d6e2c753893);
$parcel$export(module.exports, "getReactHydrationStats", () => $f83a2a0ae3838e5f$export$2d8f8d64dc343d7b);
$parcel$export(module.exports, "getInteractionRate", () => $f83a2a0ae3838e5f$export$9466a8f085fa7d4e);
$parcel$export(module.exports, "getExperimentalInteractionRate", () => $f83a2a0ae3838e5f$export$563f73272328c0d);
$parcel$export(module.exports, "getVCRawDataInteractionRate", () => $f83a2a0ae3838e5f$export$48f4e0d964030a96);
$parcel$export(module.exports, "shouldUseRawDataThirdPartyBehavior", () => $f83a2a0ae3838e5f$export$9c69f5a724f05f38);
$parcel$export(module.exports, "getPostInteractionRate", () => $f83a2a0ae3838e5f$export$1d459f020c06ae34);
$parcel$export(module.exports, "getCapabilityRate", () => $f83a2a0ae3838e5f$export$29b9ffb14861a1d);
$parcel$export(module.exports, "getExtraInteractionRate", () => $f83a2a0ae3838e5f$export$203bd06a99c66a0d);
$parcel$export(module.exports, "getAwaitBM3TTIList", () => $f83a2a0ae3838e5f$export$2d311b3fd18dcab1);
$parcel$export(module.exports, "getUfoNameOverrides", () => $f83a2a0ae3838e5f$export$4f4649ef27b6f5d6);
$parcel$export(module.exports, "getMinorInteractions", () => $f83a2a0ae3838e5f$export$b150ddad71c80d77);
$parcel$export(module.exports, "getDoNotAbortActivePressInteraction", () => $f83a2a0ae3838e5f$export$3c170167645a0eff);
$parcel$export(module.exports, "getDoNotAbortActivePressInteractionOnTransition", () => $f83a2a0ae3838e5f$export$d6dc9444bd15f70f);
$parcel$export(module.exports, "getFinishInteractionOnTransition", () => $f83a2a0ae3838e5f$export$20e8108b8ccdd0bd);
$parcel$export(module.exports, "getInteractionTimeout", () => $f83a2a0ae3838e5f$export$c681731847989445);

var $kDPHl = parcelRequire("kDPHl");

var $3X3Vo = parcelRequire("3X3Vo");
let $f83a2a0ae3838e5f$var$config;
/**
 * Cached result of `isFedrampModerate()` so we don't re-parse cookies on
 * every selector lookup. Reset via `__resetFedrampOverrideCacheForTests` in
 * unit tests only.
 */ let $f83a2a0ae3838e5f$var$cachedIsFedrampModerate;
function $f83a2a0ae3838e5f$var$detectIsFedrampModerate() {
    if ($f83a2a0ae3838e5f$var$cachedIsFedrampModerate !== undefined) return $f83a2a0ae3838e5f$var$cachedIsFedrampModerate;
    try {
        $f83a2a0ae3838e5f$var$cachedIsFedrampModerate = (0, $kDPHl.isFedrampModerate)();
    } catch  {
        // Defensive default: if perimeter detection throws, treat as non-FedRAMP
        // so UFO behaviour is unchanged. Mirrors `analyticsWebClient` pattern.
        $f83a2a0ae3838e5f$var$cachedIsFedrampModerate = false;
    }
    return $f83a2a0ae3838e5f$var$cachedIsFedrampModerate;
}
function $f83a2a0ae3838e5f$export$89dc2b6be8cc261() {
    $f83a2a0ae3838e5f$var$cachedIsFedrampModerate = undefined;
}
function $f83a2a0ae3838e5f$export$1133b5e2873baa7a() {
    try {
        return (0, $3X3Vo.fg)('platform_ufo_fedramp_overrides') && $f83a2a0ae3838e5f$var$detectIsFedrampModerate();
    } catch  {
        return false;
    }
}
const $f83a2a0ae3838e5f$var$FEDRAMP_DISABLED_SELECTOR_CONFIG = Object.freeze({
    id: false,
    testId: false,
    role: false,
    className: false,
    dataVC: false
});
const $f83a2a0ae3838e5f$export$f9bb3bb330fb9609 = 'fy26.04';
function $f83a2a0ae3838e5f$export$2182e73d31080cbc() {
    return $f83a2a0ae3838e5f$export$f9bb3bb330fb9609;
}
const $f83a2a0ae3838e5f$export$d50dacda7fe6392b = 1000;
function $f83a2a0ae3838e5f$export$10d6139a8fb42158(newConfig) {
    // Handle edge cases with `enabledVCRevisions`
    const { enabledVCRevisions: enabledVCRevisions } = newConfig?.vc ?? {};
    if (enabledVCRevisions) {
        const byExperience = typeof enabledVCRevisions?.byExperience === 'object' ? enabledVCRevisions.byExperience : {};
        const allRevisions = [
            // Products control their own revisions.
            ...enabledVCRevisions?.all ?? [],
            ...Object.values(byExperience).flat()
        ];
        $f83a2a0ae3838e5f$var$config = {
            ...newConfig,
            vc: {
                ...newConfig.vc,
                enabledVCRevisions: {
                    all: Array.from(new Set(allRevisions)),
                    byExperience: byExperience
                }
            }
        };
    } else $f83a2a0ae3838e5f$var$config = newConfig;
}
function $f83a2a0ae3838e5f$export$44487a86467333c3() {
    return $f83a2a0ae3838e5f$var$config;
}
function $f83a2a0ae3838e5f$export$59e1f072477dfb48(callerOverride, defaultConfig) {
    // Gate guard: when the gate is OFF we keep the historical behaviour
    // untouched. Pre-FedRAMP code expected `getSelectorConfig()` (no args)
    // to return only the centrally configured value, and per-observer
    // merges to take care of caller overrides and defaults locally.
    if (!(0, $3X3Vo.fg)('platform_ufo_fedramp_overrides')) return callerOverride ?? $f83a2a0ae3838e5f$var$config?.vc?.selectorConfig;
    // Gate ON.
    // 1. FedRAMP override always wins.
    if ($f83a2a0ae3838e5f$var$detectIsFedrampModerate()) return $f83a2a0ae3838e5f$var$FEDRAMP_DISABLED_SELECTOR_CONFIG;
    // 2. Then caller-provided.
    // 3. Then centrally configured.
    // 4. Then caller-provided default.
    return callerOverride ?? $f83a2a0ae3838e5f$var$config?.vc?.selectorConfig ?? defaultConfig;
}
function $f83a2a0ae3838e5f$export$74bdb753f1cf4860() {
    // Default to enabled if config is not set or enabled is not explicitly false
    return $f83a2a0ae3838e5f$var$config?.enabled !== false;
}
const $f83a2a0ae3838e5f$var$isValidConfigArray = (array)=>{
    return Array.isArray(array) && array.length > 0;
};
function $f83a2a0ae3838e5f$export$87fbc8e01b137811(experienceKey = '') {
    try {
        if (!$f83a2a0ae3838e5f$var$config) return [];
        if ($f83a2a0ae3838e5f$var$config.vc?.enabled) {
            const { enabledVCRevisions: enabledVCRevisions } = $f83a2a0ae3838e5f$var$config.vc ?? {};
            if ($f83a2a0ae3838e5f$var$isValidConfigArray(enabledVCRevisions?.byExperience?.[experienceKey])) return enabledVCRevisions.byExperience?.[experienceKey];
            // When the disable flag is on, treat an explicitly-set empty array as
            // "no client-side revisions" rather than falling back to the default revision.
            const allRevisions = enabledVCRevisions?.all;
            if (Array.isArray(allRevisions) && allRevisions.length === 0 && (0, $3X3Vo.fg)('ufo_disable_ttvc_v4')) return allRevisions;
            if ($f83a2a0ae3838e5f$var$isValidConfigArray(allRevisions)) return allRevisions;
            return [
                $f83a2a0ae3838e5f$export$2182e73d31080cbc()
            ];
        }
        return [];
    } catch  {
        return [];
    }
}
function $f83a2a0ae3838e5f$export$4babcefc81a3ef0b(revision, experienceKey) {
    return $f83a2a0ae3838e5f$export$87fbc8e01b137811(experienceKey).includes(revision);
}
function $f83a2a0ae3838e5f$export$70184d6e2c753893(experienceKey = '') {
    const enabledVCRevisions = $f83a2a0ae3838e5f$export$87fbc8e01b137811(experienceKey);
    if (enabledVCRevisions.length === 0) return $f83a2a0ae3838e5f$export$2182e73d31080cbc();
    return enabledVCRevisions[enabledVCRevisions.length - 1];
}
function $f83a2a0ae3838e5f$export$2d8f8d64dc343d7b() {
    if (!$f83a2a0ae3838e5f$var$config) return undefined;
    try {
        const stats = $f83a2a0ae3838e5f$var$config?.getReactHydrationStats?.();
        return stats ?? undefined;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error('getReactHydrationStats threw an error: ', e);
        return undefined;
    }
}
function $f83a2a0ae3838e5f$export$9466a8f085fa7d4e(name, interactionKind) {
    try {
        if (!$f83a2a0ae3838e5f$var$config) return 0;
        const { killswitch: killswitch, rates: rates, rules: rules, kind: kind, autoGeneratedRate: autoGeneratedRate } = $f83a2a0ae3838e5f$var$config;
        if (killswitch != null) {
            // Specifically kill certain events
            if (killswitch.includes(name)) return 0;
        }
        const isUnknown = name === 'unknown';
        if (isUnknown) {
            if (rates?.[name] != null) return rates[name];
            // Return default rate for unknown events when no explicit rate is configured
            return $f83a2a0ae3838e5f$export$d50dacda7fe6392b;
        }
        if (rates != null) {
            // Decide the rate explicitly
            if (rates[name] != null) return rates[name];
        }
        if (rules != null) for(let i = 0; i < rules.length; i++){
            const rule = rules[i];
            const { test: test, rate: rate } = rule;
            if (test != null && rate != null) {
                const regexp = new RegExp(test, 'ig');
                if (regexp.test(name)) return rate;
            }
        }
        const isAutogenerated = name?.startsWith('auto-generated');
        if (isAutogenerated) {
            const rate = autoGeneratedRate;
            if (rate != null) return rate;
        }
        if (kind != null) {
            const rate = kind[interactionKind];
            if (rate != null) return rate;
        }
        return 0;
    } catch  {
        // Fallback
        return 0;
    }
}
function $f83a2a0ae3838e5f$export$563f73272328c0d(name, interactionType) {
    try {
        if (!$f83a2a0ae3838e5f$var$config) return 0;
        const { experimentalInteractionMetrics: experimentalInteractionMetrics } = $f83a2a0ae3838e5f$var$config;
        if (!experimentalInteractionMetrics?.enabled) return 0;
        if (experimentalInteractionMetrics.rates && typeof experimentalInteractionMetrics.rates[name] === 'number') return experimentalInteractionMetrics.rates[name];
        if (experimentalInteractionMetrics.kind && typeof experimentalInteractionMetrics.kind[interactionType] === 'number') return experimentalInteractionMetrics.kind[interactionType];
        return 0;
    } catch  {
        return 0;
    }
}
function $f83a2a0ae3838e5f$export$48f4e0d964030a96(name, interactionType) {
    return $f83a2a0ae3838e5f$var$getConfigRate(name, interactionType, 'enableVCRawDataRates');
}
function $f83a2a0ae3838e5f$export$9c69f5a724f05f38(name, interactionType) {
    if (!(0, $3X3Vo.fg)('platform_ufo_raw_data_thirdparty')) return false;
    return $f83a2a0ae3838e5f$export$48f4e0d964030a96(name, interactionType) > 0;
}
function $f83a2a0ae3838e5f$export$1d459f020c06ae34(name, interactionType) {
    return $f83a2a0ae3838e5f$var$getConfigRate(name, interactionType, 'postInteractionLog');
}
function $f83a2a0ae3838e5f$export$29b9ffb14861a1d(capability) {
    if ((0, $3X3Vo.fg)('platform_ufo_remove_deprecated_config_fields')) return 1;
    try {
        if (!$f83a2a0ae3838e5f$var$config) return 0;
        const { capability: capabilityRate } = $f83a2a0ae3838e5f$var$config;
        if (capabilityRate != null) {
            const rate = capabilityRate[capability];
            if (rate != null) return rate;
        }
        return 0;
    } catch  {
        return 0;
    }
}
function $f83a2a0ae3838e5f$var$getConfigRate(name, interactionType, configName) {
    try {
        if (!$f83a2a0ae3838e5f$var$config) return 0;
        const gotConfig = $f83a2a0ae3838e5f$var$config[configName];
        if (!gotConfig?.enabled) return 0;
        if (interactionType !== 'page_load' && interactionType !== 'transition') return 0;
        if (gotConfig.rates && typeof gotConfig.rates[name] === 'number') return gotConfig.rates[name];
        if ('kind' in gotConfig && gotConfig.kind && typeof gotConfig.kind[interactionType] === 'number') return gotConfig.kind[interactionType];
        return 0;
    } catch  {
        return 0;
    }
}
function $f83a2a0ae3838e5f$export$203bd06a99c66a0d(name, interactionType) {
    return $f83a2a0ae3838e5f$var$getConfigRate(name, interactionType, 'extraInteractionMetrics');
}
const $f83a2a0ae3838e5f$var$validTypingMethods = [
    'timeout',
    'timeoutNoAlloc',
    'mutationObserver'
];
function $f83a2a0ae3838e5f$export$7e32aae12bf9b50f() {
    const defaultMethod = 'timeout';
    try {
        if (!$f83a2a0ae3838e5f$var$config) return defaultMethod;
        const { typingMethod: typingMethod } = $f83a2a0ae3838e5f$var$config;
        if (typingMethod != null && $f83a2a0ae3838e5f$var$validTypingMethods.find((m)=>m === typingMethod)) return typingMethod;
        else return defaultMethod;
    } catch  {
        return defaultMethod;
    }
}
function $f83a2a0ae3838e5f$export$2d311b3fd18dcab1() {
    try {
        if (!$f83a2a0ae3838e5f$var$config) return [];
        const { awaitBM3TTI: awaitBM3TTI } = $f83a2a0ae3838e5f$var$config;
        if (awaitBM3TTI != null) return awaitBM3TTI;
        else return [];
    } catch  {
        return [];
    }
}
function $f83a2a0ae3838e5f$export$4f4649ef27b6f5d6() {
    try {
        if (!$f83a2a0ae3838e5f$var$config) return undefined;
        const { ufoNameOverrides: ufoNameOverrides } = $f83a2a0ae3838e5f$var$config;
        if (ufoNameOverrides != null) return ufoNameOverrides;
        return undefined;
    } catch  {
        return undefined;
    }
}
function $f83a2a0ae3838e5f$export$b150ddad71c80d77() {
    try {
        if (!$f83a2a0ae3838e5f$var$config) return undefined;
        const { minorInteractions: minorInteractions } = $f83a2a0ae3838e5f$var$config;
        return minorInteractions;
    } catch  {
        return undefined;
    }
}
function $f83a2a0ae3838e5f$export$3c170167645a0eff() {
    try {
        if (!$f83a2a0ae3838e5f$var$config) return undefined;
        const { doNotAbortActivePressInteraction: doNotAbortActivePressInteraction } = $f83a2a0ae3838e5f$var$config;
        return doNotAbortActivePressInteraction;
    } catch  {
        return undefined;
    }
}
function $f83a2a0ae3838e5f$export$d6dc9444bd15f70f() {
    try {
        if (!$f83a2a0ae3838e5f$var$config) return undefined;
        const { doNotAbortActivePressInteractionOnTransition: doNotAbortActivePressInteractionOnTransition } = $f83a2a0ae3838e5f$var$config;
        return doNotAbortActivePressInteractionOnTransition;
    } catch  {
        return undefined;
    }
}
function $f83a2a0ae3838e5f$export$20e8108b8ccdd0bd() {
    try {
        if (!$f83a2a0ae3838e5f$var$config) return undefined;
        const { finishInteractionOnTransition: finishInteractionOnTransition } = $f83a2a0ae3838e5f$var$config;
        return finishInteractionOnTransition;
    } catch  {
        return undefined;
    }
}
const $f83a2a0ae3838e5f$export$2a8604960d7d23d9 = 60000;
function $f83a2a0ae3838e5f$export$c681731847989445(ufoName) {
    try {
        if (!$f83a2a0ae3838e5f$var$config) return $f83a2a0ae3838e5f$export$2a8604960d7d23d9;
        const { interactionTimeout: interactionTimeout } = $f83a2a0ae3838e5f$var$config;
        if (interactionTimeout != null && interactionTimeout[ufoName] != null) return interactionTimeout[ufoName];
        if (interactionTimeout != null && interactionTimeout.__globalInteractionTimeout != null) return interactionTimeout.__globalInteractionTimeout;
        else return $f83a2a0ae3838e5f$export$2a8604960d7d23d9;
    } catch  {
        return $f83a2a0ae3838e5f$export$2a8604960d7d23d9;
    }
}

});
parcelRegister("kDPHl", function(module, exports) {
$parcel$export(module.exports, "isIsolatedCloud", () => $5af1c0e17a197c8a$export$9186ccba8effc5de);
$parcel$export(module.exports, "isFedrampModerate", () => $5af1c0e17a197c8a$export$104cb891a6e90b3a);
$parcel$export(module.exports, "isolatedCloudDomain", () => $5af1c0e17a197c8a$export$80638ee198476daf);
$parcel$export(module.exports, "isolationContextId", () => $5af1c0e17a197c8a$export$839b022803d38d4d);
$parcel$export(module.exports, "cloudEnvironment", () => $5af1c0e17a197c8a$export$9e04105551ffc5c4);

var $jHyBb = parcelRequire("jHyBb");

var $6RB6e = parcelRequire("6RB6e");
function $5af1c0e17a197c8a$export$9186ccba8effc5de() {
    if (typeof document === 'undefined') // @ts-ignore
    return globalThis.ssrContext?.isInIC ?? false;
    const atlCtxCookieValues = (0, $6RB6e.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return false;
    // The icDomain check is needed for when federal perimeters are eventually added to Isolated Cloud as well
    return (0, $jHyBb.ISOLATED_CLOUD_PERIMETERS).includes(atlCtxCookieValues.perimeter) && atlCtxCookieValues.icDomain !== undefined;
}
function $5af1c0e17a197c8a$export$104cb891a6e90b3a() {
    if (typeof document === 'undefined') // @ts-ignore
    return globalThis.ssrContext?.isInFedramp ?? false;
    const atlCtxCookieValues = (0, $6RB6e.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return false;
    return atlCtxCookieValues.perimeter === (0, $jHyBb.FEDRAMP_MODERATE);
}
function $5af1c0e17a197c8a$export$80638ee198476daf() {
    if (typeof document === 'undefined') return globalThis.location?.hostname;
    const atlCtxCookieValues = (0, $6RB6e.parseAtlCtxCookies)();
    return atlCtxCookieValues?.icDomain;
}
function $5af1c0e17a197c8a$export$839b022803d38d4d() {
    if (typeof document === 'undefined') // @ts-ignore
    return $5af1c0e17a197c8a$export$9186ccba8effc5de() ? globalThis.ssrContext?.icName : undefined;
    const atlCtxCookieValues = (0, $6RB6e.parseAtlCtxCookies)();
    return atlCtxCookieValues?.icId;
}
function $5af1c0e17a197c8a$export$9e04105551ffc5c4() {
    if (typeof document === 'undefined') return $5af1c0e17a197c8a$var$cloudEnvironmentSsrLookup();
    return $5af1c0e17a197c8a$var$cloudEnvironmentCookieLookup();
}
function $5af1c0e17a197c8a$var$cloudEnvironmentSsrLookup() {
    // @ts-ignore
    if (globalThis.ssrContext?.isInIC === true) return {
        type: 'isolated-cloud',
        perimeter: (0, $jHyBb.COMMERCIAL)
    };
    // @ts-ignore
    if (globalThis.ssrContext?.isInFedramp === true) return {
        type: 'non-isolated-cloud',
        perimeter: (0, $jHyBb.FEDRAMP_MODERATE)
    };
    return {
        type: 'non-isolated-cloud',
        perimeter: (0, $jHyBb.COMMERCIAL)
    };
}
function $5af1c0e17a197c8a$var$cloudEnvironmentCookieLookup() {
    // Avoid calling isFedrampModerate() and isIsolatedCloud() here to avoid repeated cookie parsing
    const atlCtxCookieValues = (0, $6RB6e.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return {
        type: 'non-isolated-cloud',
        perimeter: (0, $jHyBb.COMMERCIAL)
    };
    const isIc = (0, $jHyBb.ISOLATED_CLOUD_PERIMETERS).includes(atlCtxCookieValues.perimeter) && atlCtxCookieValues.icDomain !== undefined;
    if (isIc) return {
        type: 'isolated-cloud',
        perimeter: (0, $jHyBb.COMMERCIAL)
    };
    if (atlCtxCookieValues.perimeter === (0, $jHyBb.FEDRAMP_MODERATE)) return {
        type: 'non-isolated-cloud',
        perimeter: (0, $jHyBb.FEDRAMP_MODERATE)
    };
    // If a new cloud environment has been created but not added to this library, return undefined
    return undefined;
}

});
parcelRegister("jHyBb", function(module, exports) {
$parcel$export(module.exports, "FEDRAMP_MODERATE", () => $637ae14deba4143d$export$ce553301d55c2fd8);
$parcel$export(module.exports, "COMMERCIAL", () => $637ae14deba4143d$export$f005e2e9f707cb5f);
$parcel$export(module.exports, "STAGING", () => $637ae14deba4143d$export$a739cd5aac835909);
$parcel$export(module.exports, "PRODUCTION", () => $637ae14deba4143d$export$42dd0cdd351a4a9);
$parcel$export(module.exports, "DEV", () => $637ae14deba4143d$export$404582bc18fe4d9e);
$parcel$export(module.exports, "ISOLATED_CLOUD_PERIMETERS", () => $637ae14deba4143d$export$d8347b4aae768c2d);
$parcel$export(module.exports, "ATL_CTX_PERIMETER", () => $637ae14deba4143d$export$87285944378c596);
$parcel$export(module.exports, "ATL_CTX_ISOLATION_CONTEXT_DOMAIN", () => $637ae14deba4143d$export$715603e81922c3ec);
$parcel$export(module.exports, "ATL_CTX_ISOLATION_CONTEXT_ID", () => $637ae14deba4143d$export$a0ffa0598c95dfb7);
const $637ae14deba4143d$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $637ae14deba4143d$export$f005e2e9f707cb5f = 'commercial';
const $637ae14deba4143d$export$a739cd5aac835909 = 'staging';
const $637ae14deba4143d$export$42dd0cdd351a4a9 = 'prod';
const $637ae14deba4143d$export$404582bc18fe4d9e = 'dev';
const $637ae14deba4143d$export$d8347b4aae768c2d = [
    $637ae14deba4143d$export$f005e2e9f707cb5f
];
const $637ae14deba4143d$export$b1b1ccc8f3e7f954 = [
    $637ae14deba4143d$export$f005e2e9f707cb5f,
    $637ae14deba4143d$export$ce553301d55c2fd8
];
const $637ae14deba4143d$export$87285944378c596 = 'Atl-Ctx-Perimeter';
const $637ae14deba4143d$export$715603e81922c3ec = 'Atl-Ctx-Isolation-Context-Domain';
const $637ae14deba4143d$export$a0ffa0598c95dfb7 = 'Atl-Ctx-Isolation-Context-Id';

});

parcelRegister("6RB6e", function(module, exports) {
$parcel$export(module.exports, "parseAtlCtxCookies", () => $08a6e292198640de$export$3fa7b7af96286cc9);

var $jHyBb = parcelRequire("jHyBb");
/**
 * Internal helper function used to parse cookie values and extract value of provided cookie name
 * @param {AtlCtxCookieName} cookieName - The name of the cookie to extract
 * @param {string} cookieString - The full cookie string
 * @returns {string | undefined} - The cookie value if present, undefined otherwise
 */ function $08a6e292198640de$var$getRawCookieValue(cookieName, cookieString) {
    if (!cookieString) return undefined;
    const cookies = cookieString.split(';');
    for (const cookie of cookies){
        const [name, value] = cookie.trim().split('=');
        if (name === cookieName) return value;
    }
    return undefined;
}
function $08a6e292198640de$export$3fa7b7af96286cc9() {
    const global = globalThis;
    try {
        // HOT-118791: the code below doesn't work on the server, and creates log spam in the catch block - "Cannot read properties of undefined (reading 'cookie')"
        if (typeof globalThis.document === 'undefined') return undefined;
        const cookies = global.document.cookie;
        const perimeter = $08a6e292198640de$var$getRawCookieValue((0, $jHyBb.ATL_CTX_PERIMETER), cookies);
        if (!perimeter) // Indicative of non-isolated commercial perimeter
        return undefined;
        const icDomain = $08a6e292198640de$var$getRawCookieValue((0, $jHyBb.ATL_CTX_ISOLATION_CONTEXT_DOMAIN), cookies);
        const icId = $08a6e292198640de$var$getRawCookieValue((0, $jHyBb.ATL_CTX_ISOLATION_CONTEXT_ID), cookies);
        // The IC Domain and IC Id cookie values are empty strings for non Isolated Cloud
        const emptyIcDomain = !icDomain || icDomain.length === 0;
        const emptyIcId = !icId || icId.length === 0;
        return {
            perimeter: perimeter,
            icDomain: emptyIcDomain ? undefined : icDomain,
            icId: emptyIcId ? undefined : icId
        };
    } catch (e) {
        console.warn('Failed to parse atl-ctx cookies:', e);
        return undefined;
    }
}

});



parcelRegister("50omK", function(module, exports) {
$parcel$export(module.exports, "sinkExperimentalHandler", () => $fb3c25142e0fe256$export$7aa99c40634ac65f);
$parcel$export(module.exports, "onExperimentalInteractionComplete", () => $fb3c25142e0fe256$export$1aed449484dedf63);
$parcel$export(module.exports, "experimentalVC", () => $fb3c25142e0fe256$export$81b28dca2587ec47);
$parcel$export(module.exports, "getExperimentalVCMetrics", () => $fb3c25142e0fe256$export$d17d2b5c5e8d732e);

var $fubJS = parcelRequire("fubJS");

var $eLxnz = parcelRequire("eLxnz");
const $fb3c25142e0fe256$var$interactionBuffer = [];
let $fb3c25142e0fe256$var$bufferInteractionData = (interactionId, data)=>{
    $fb3c25142e0fe256$var$interactionBuffer.push({
        interactionId: interactionId,
        data: data
    });
};
function $fb3c25142e0fe256$var$clearInteractionBuffer() {
    $fb3c25142e0fe256$var$interactionBuffer.length = 0;
}
function $fb3c25142e0fe256$var$appendInteractionData(interactionId, data) {
    $fb3c25142e0fe256$var$bufferInteractionData(interactionId, data);
}
function $fb3c25142e0fe256$export$c8a9e17ae62a073d(handler) {
    for (const { interactionId: interactionId, data: data } of $fb3c25142e0fe256$var$interactionBuffer)handler(interactionId, data);
    $fb3c25142e0fe256$var$clearInteractionBuffer();
    $fb3c25142e0fe256$var$bufferInteractionData = handler;
}
function $fb3c25142e0fe256$export$7aa99c40634ac65f(sinkFn) {
    $fb3c25142e0fe256$export$c8a9e17ae62a073d(sinkFn);
}
function $fb3c25142e0fe256$export$1aed449484dedf63(interactionId, data, endTime = performance.now()) {
    if (data.ufoName) {
        data.end = endTime;
        $fb3c25142e0fe256$var$appendInteractionData(interactionId, data);
        $fb3c25142e0fe256$var$clearInteractionBuffer();
    }
}
class $fb3c25142e0fe256$export$f9a59f57e0282541 {
    initialize(options) {
        if (this.vcObserver === null) this.vcObserver = new (0, $eLxnz.VCObserver)({
            ...options,
            isPostInteraction: true
        });
        return this;
    }
    start({ startTime: startTime }) {
        this.vcObserver?.start({
            startTime: startTime
        });
    }
    constructor(){
        this.vcObserver = null;
    }
}
const $fb3c25142e0fe256$export$81b28dca2587ec47 = new $fb3c25142e0fe256$export$f9a59f57e0282541();
async function $fb3c25142e0fe256$export$d17d2b5c5e8d732e(interaction) {
    // Use per-interaction VC observer if available, otherwise fall back to global experimentalVC
    const vcObserver = interaction.experimentalVCObserver || $fb3c25142e0fe256$export$81b28dca2587ec47.vcObserver;
    const pageVisibilityUpToTTAI = (0, $fubJS.getPageVisibilityState)(interaction.start, interaction.end);
    if (vcObserver) {
        const prefix = 'ufo-experimental';
        const result = await vcObserver.getVCResult({
            start: interaction.start,
            stop: interaction.end,
            tti: interaction.apdex?.[0]?.stopTime,
            isEventAborted: !!interaction.abortReason,
            prefix: prefix,
            vc: interaction.vc,
            experienceKey: interaction.ufoName,
            interactionId: interaction.id,
            interactionType: interaction.type,
            isPageVisible: pageVisibilityUpToTTAI === 'visible',
            interactionAbortReason: interaction.abortReason
        });
        const VC = result?.['metrics:vc'];
        if (!VC || !result?.[`${prefix}:vc:clean`]) return result;
        if (interaction.abortReason || pageVisibilityUpToTTAI !== 'visible') return result;
        return {
            ...result,
            'metric:experimental:vc90': VC['90']
        };
    }
    return null;
}

});
parcelRegister("fubJS", function(module, exports) {
$parcel$export(module.exports, "getEarliestHiddenTiming", () => $9bc8f1433c345f58$export$754443ce7c615bd7);
$parcel$export(module.exports, "isOpenedInBackground", () => $9bc8f1433c345f58$export$21a1a62a307062f1);
$parcel$export(module.exports, "getHasHiddenTimingBeforeSetup", () => $9bc8f1433c345f58$export$95f048bd8bcdda23);
$parcel$export(module.exports, "setupHiddenTimingCapture", () => $9bc8f1433c345f58$export$554cefe0f0373da4);
$parcel$export(module.exports, "getPageVisibilityState", () => $9bc8f1433c345f58$export$768b2008623433e1);
$parcel$export(module.exports, "setupThrottleDetection", () => $9bc8f1433c345f58$export$fa0d29a9c87052da);
$parcel$export(module.exports, "isTabThrottled", () => $9bc8f1433c345f58$export$62a28c860277b3bf);
$parcel$export(module.exports, "getPageVisibilityTimeline", () => $9bc8f1433c345f58$export$5a06b84e47ad70d9);

var $Hyfcf = parcelRequire("Hyfcf");

var $3X3Vo = parcelRequire("3X3Vo");
const $9bc8f1433c345f58$var$timings = [];
let $9bc8f1433c345f58$var$wasHiddenFlag;
let $9bc8f1433c345f58$var$setupFlag = false;
// Threshold for determining if page was opened in background.
// If setup runs within this time and page is hidden, we assume it was opened in a background tab.
const $9bc8f1433c345f58$var$OPENED_IN_BACKGROUND_THRESHOLD_MS = 100;
let $9bc8f1433c345f58$var$openedInBackground = null;
function $9bc8f1433c345f58$var$isPageHidden() {
    if ('visibilityState' in document) return document.visibilityState === 'hidden';
    else // @ts-expect-error - Property 'hidden' does not exist on type 'never'.
    return document.hidden;
}
const $9bc8f1433c345f58$var$SIZE = 50;
let $9bc8f1433c345f58$var$insertIndex = 0;
function $9bc8f1433c345f58$export$754443ce7c615bd7(startTime, endTime) {
    const earliestHiddenTiming = $9bc8f1433c345f58$var$timings.find(({ hidden: hidden, time: time })=>hidden && time > 0 && time >= startTime && time <= endTime)?.time;
    if (typeof earliestHiddenTiming === 'number') return Math.round(earliestHiddenTiming - startTime);
}
function $9bc8f1433c345f58$export$21a1a62a307062f1(interactionType) {
    if (interactionType !== 'page_load') return false;
    // Check native visibility-state entries first (most reliable, Chromium only)
    try {
        const entries = performance.getEntriesByType('visibility-state');
        if (entries.length > 0) return entries.some((entry)=>entry.name === 'hidden' && entry.startTime <= $9bc8f1433c345f58$var$OPENED_IN_BACKGROUND_THRESHOLD_MS);
    } catch  {
    // visibility-state not supported (Firefox/Safari)
    }
    // Fallback to cached value from setup (determined using time threshold)
    return $9bc8f1433c345f58$var$openedInBackground === true;
}
function $9bc8f1433c345f58$var$pushHidden(isPageHiddenFlag, time) {
    $9bc8f1433c345f58$var$timings[$9bc8f1433c345f58$var$insertIndex] = {
        time: time ?? performance.now(),
        hidden: isPageHiddenFlag
    };
    $9bc8f1433c345f58$var$insertIndex = ($9bc8f1433c345f58$var$insertIndex + 1) % $9bc8f1433c345f58$var$SIZE;
    $9bc8f1433c345f58$var$wasHiddenFlag = isPageHiddenFlag;
}
function $9bc8f1433c345f58$var$handleChange() {
    const isPageHiddenFlag = $9bc8f1433c345f58$var$isPageHidden();
    if (isPageHiddenFlag) {
        if (!$9bc8f1433c345f58$var$wasHiddenFlag) $9bc8f1433c345f58$var$pushHidden(isPageHiddenFlag);
        $9bc8f1433c345f58$var$wasHiddenFlag = true;
    } else {
        if ($9bc8f1433c345f58$var$wasHiddenFlag) $9bc8f1433c345f58$var$pushHidden(isPageHiddenFlag);
        $9bc8f1433c345f58$var$wasHiddenFlag = false;
    }
}
let $9bc8f1433c345f58$var$hasHiddenTimingBeforeSetup = false;
function $9bc8f1433c345f58$export$95f048bd8bcdda23() {
    return $9bc8f1433c345f58$var$hasHiddenTimingBeforeSetup;
}
function $9bc8f1433c345f58$var$setup() {
    try {
        const results = performance.getEntriesByType('visibility-state');
        results?.forEach((result)=>{
            if ((0, $3X3Vo.fg)('platform_ufo_use_native_page_visibility_api')) $9bc8f1433c345f58$var$pushHidden(result.name === 'hidden', result.startTime);
            if (result.name === 'hidden') $9bc8f1433c345f58$var$hasHiddenTimingBeforeSetup = true;
        });
    } catch  {
    /* do nothing */ /* note: visibility-state entry types are not available in Firefox/Safari: https://developer.mozilla.org/en-US/docs/Web/API/VisibilityStateEntry#browser_compatibility */ }
    (0, $Hyfcf.bind)(window, {
        type: 'pageshow',
        listener: $9bc8f1433c345f58$var$handleChange
    });
    (0, $Hyfcf.bind)(window, {
        type: 'pagehide',
        listener: $9bc8f1433c345f58$var$handleChange
    });
    (0, $Hyfcf.bind)(document, {
        type: 'visibilitychange',
        listener: $9bc8f1433c345f58$var$handleChange
    });
}
function $9bc8f1433c345f58$export$554cefe0f0373da4() {
    if (!$9bc8f1433c345f58$var$setupFlag) {
        const isPageHiddenFlag = $9bc8f1433c345f58$var$isPageHidden();
        const setupTime = performance.now();
        // Determine if page was opened in background.
        // If we're early in page lifecycle (< threshold) and page is hidden,
        // it's likely the page was opened in a background tab.
        if ($9bc8f1433c345f58$var$openedInBackground === null) $9bc8f1433c345f58$var$openedInBackground = isPageHiddenFlag && setupTime < $9bc8f1433c345f58$var$OPENED_IN_BACKGROUND_THRESHOLD_MS;
        $9bc8f1433c345f58$var$pushHidden(isPageHiddenFlag, 0);
        $9bc8f1433c345f58$var$setup();
        $9bc8f1433c345f58$var$setupFlag = true;
    }
}
function $9bc8f1433c345f58$export$768b2008623433e1(start, end) {
    // Input validation - return default for invalid inputs
    if (!Number.isFinite(start) || !Number.isFinite(end)) return 'visible';
    // Desirable default value is visible
    if ($9bc8f1433c345f58$var$timings.length === 0) return 'visible';
    const currentSize = $9bc8f1433c345f58$var$timings.length;
    let hiddenState = 'mixed';
    let startIdx = $9bc8f1433c345f58$var$insertIndex;
    let endIdx = $9bc8f1433c345f58$var$insertIndex;
    // currentSize is capped at SIZE.
    for(let i = 0; i < currentSize; i++){
        const tmpIdx = ($9bc8f1433c345f58$var$insertIndex + i) % currentSize;
        // Add bounds checking before accessing array element
        if ($9bc8f1433c345f58$var$timings[tmpIdx] && $9bc8f1433c345f58$var$timings[tmpIdx].time <= end) {
            endIdx = tmpIdx;
            if ($9bc8f1433c345f58$var$timings[tmpIdx].time <= start) startIdx = tmpIdx;
        }
    }
    // Add bounds checking before accessing timings array
    if (endIdx - startIdx === 0 && $9bc8f1433c345f58$var$timings[startIdx]) hiddenState = $9bc8f1433c345f58$var$timings[startIdx].hidden ? 'hidden' : 'visible';
    return hiddenState;
}
// Throttle detection configuration
// Expected interval for timer checks (in milliseconds)
const $9bc8f1433c345f58$var$THROTTLE_CHECK_INTERVAL_MS = 1000;
// Threshold for considering a timer as throttled (50% drift tolerance)
const $9bc8f1433c345f58$var$THROTTLE_DRIFT_THRESHOLD = 1.5;
// Maximum number of throttle measurements to store (circular buffer)
const $9bc8f1433c345f58$var$THROTTLE_BUFFER_SIZE = 120;
// Circular buffer to store throttle measurements
const $9bc8f1433c345f58$var$throttleMeasurements = [];
let $9bc8f1433c345f58$var$throttleInsertIndex = 0;
let $9bc8f1433c345f58$var$throttleIntervalId = null;
let $9bc8f1433c345f58$var$lastThrottleCheckTime = null;
let $9bc8f1433c345f58$var$throttleSetupDone = false;
function $9bc8f1433c345f58$var$recordThrottleMeasurement(expectedElapsed, actualElapsed) {
    const isThrottled = actualElapsed > expectedElapsed * $9bc8f1433c345f58$var$THROTTLE_DRIFT_THRESHOLD;
    $9bc8f1433c345f58$var$throttleMeasurements[$9bc8f1433c345f58$var$throttleInsertIndex] = {
        time: performance.now(),
        expectedElapsed: expectedElapsed,
        actualElapsed: actualElapsed,
        isThrottled: isThrottled
    };
    $9bc8f1433c345f58$var$throttleInsertIndex = ($9bc8f1433c345f58$var$throttleInsertIndex + 1) % $9bc8f1433c345f58$var$THROTTLE_BUFFER_SIZE;
}
function $9bc8f1433c345f58$var$throttleCheckCallback() {
    const currentTime = performance.now();
    if ($9bc8f1433c345f58$var$lastThrottleCheckTime !== null) {
        const actualElapsed = currentTime - $9bc8f1433c345f58$var$lastThrottleCheckTime;
        $9bc8f1433c345f58$var$recordThrottleMeasurement($9bc8f1433c345f58$var$THROTTLE_CHECK_INTERVAL_MS, actualElapsed);
    }
    $9bc8f1433c345f58$var$lastThrottleCheckTime = currentTime;
}
function $9bc8f1433c345f58$export$fa0d29a9c87052da() {
    if ($9bc8f1433c345f58$var$throttleSetupDone) return;
    $9bc8f1433c345f58$var$throttleSetupDone = true;
    // Record the initial timestamp
    $9bc8f1433c345f58$var$lastThrottleCheckTime = performance.now();
    // Start the periodic timer for throttle detection
    $9bc8f1433c345f58$var$throttleIntervalId = setInterval($9bc8f1433c345f58$var$throttleCheckCallback, $9bc8f1433c345f58$var$THROTTLE_CHECK_INTERVAL_MS);
}
function $9bc8f1433c345f58$export$3279694d66e4a1() {
    if ($9bc8f1433c345f58$var$throttleIntervalId !== null) {
        clearInterval($9bc8f1433c345f58$var$throttleIntervalId);
        $9bc8f1433c345f58$var$throttleIntervalId = null;
    }
    $9bc8f1433c345f58$var$lastThrottleCheckTime = null;
    $9bc8f1433c345f58$var$throttleSetupDone = false;
    $9bc8f1433c345f58$var$throttleMeasurements.length = 0;
    $9bc8f1433c345f58$var$throttleInsertIndex = 0;
}
function $9bc8f1433c345f58$export$62a28c860277b3bf(startTime, endTime) {
    // Input validation
    if (!Number.isFinite(startTime) || !Number.isFinite(endTime) || startTime >= endTime) return false;
    // No measurements available
    if ($9bc8f1433c345f58$var$throttleMeasurements.length === 0) return false;
    // Check if any measurement within the time window indicates throttling
    for(let i = 0; i < $9bc8f1433c345f58$var$throttleMeasurements.length; i++){
        const measurement = $9bc8f1433c345f58$var$throttleMeasurements[i];
        if (measurement && measurement.time >= startTime && measurement.time <= endTime && measurement.isThrottled) return true;
    }
    return false;
}
function $9bc8f1433c345f58$export$77aaa9b1ce57d9bc(startTime, endTime) {
    // Input validation
    if (!Number.isFinite(startTime) || !Number.isFinite(endTime) || startTime >= endTime) return [];
    return $9bc8f1433c345f58$var$throttleMeasurements.filter((measurement)=>measurement && measurement.time >= startTime && measurement.time <= endTime);
}
function $9bc8f1433c345f58$export$9332de935653b687(measurement) {
    $9bc8f1433c345f58$var$throttleMeasurements[$9bc8f1433c345f58$var$throttleInsertIndex] = measurement;
    $9bc8f1433c345f58$var$throttleInsertIndex = ($9bc8f1433c345f58$var$throttleInsertIndex + 1) % $9bc8f1433c345f58$var$THROTTLE_BUFFER_SIZE;
}
function $9bc8f1433c345f58$export$5a06b84e47ad70d9(startTime, endTime) {
    // Input validation
    if (!Number.isFinite(startTime) || !Number.isFinite(endTime) || startTime >= endTime) return [];
    if ($9bc8f1433c345f58$var$timings.length === 0) return [];
    const result = [];
    // Find the most recent entry at or before startTime to establish initial state
    let initialEntry;
    const currentSize = $9bc8f1433c345f58$var$timings.length;
    for(let i = 0; i < currentSize; i++){
        const idx = ($9bc8f1433c345f58$var$insertIndex + i) % currentSize;
        const entry = $9bc8f1433c345f58$var$timings[idx];
        if (entry && entry.time <= startTime) initialEntry = entry;
    }
    // Add the initial visibility state at the start of the window
    if (initialEntry) result.push({
        time: 0,
        hidden: initialEntry.hidden
    });
    // Add all entries within the time window
    for(let i = 0; i < currentSize; i++){
        const idx = ($9bc8f1433c345f58$var$insertIndex + i) % currentSize;
        const entry = $9bc8f1433c345f58$var$timings[idx];
        if (entry && entry.time > startTime && entry.time <= endTime) result.push({
            time: Math.round(entry.time - startTime),
            hidden: entry.hidden
        });
    }
    return result;
}
// Expose testing API on window for integration tests
if (typeof window !== 'undefined') window.__reactUfoHiddenTiming = {
    __injectThrottleMeasurementForTesting: $9bc8f1433c345f58$export$9332de935653b687
};

});
parcelRegister("Hyfcf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = module.exports.bind = void 0;

var $1MYa3 = parcelRequire("1MYa3");
Object.defineProperty(module.exports, "bind", {
    enumerable: true,
    get: function() {
        return $1MYa3.bind;
    }
});

var $59eEO = parcelRequire("59eEO");
Object.defineProperty(module.exports, "bindAll", {
    enumerable: true,
    get: function() {
        return $59eEO.bindAll;
    }
});

});
parcelRegister("1MYa3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bind = void 0;
function $14d8f0e27e042111$var$bind(target, _a) {
    var type = _a.type, listener = _a.listener, options = _a.options;
    target.addEventListener(type, listener, options);
    return function unbind() {
        target.removeEventListener(type, listener, options);
    };
}
module.exports.bind = $14d8f0e27e042111$var$bind;

});

parcelRegister("59eEO", function(module, exports) {
"use strict";
var $3bf929a0ea4942ec$var$__assign = module.exports && module.exports.__assign || function() {
    $3bf929a0ea4942ec$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3bf929a0ea4942ec$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = void 0;

var $1MYa3 = parcelRequire("1MYa3");
function $3bf929a0ea4942ec$var$toOptions(value) {
    if (typeof value === 'undefined') return undefined;
    if (typeof value === 'boolean') return {
        capture: value
    };
    return value;
}
function $3bf929a0ea4942ec$var$getBinding(original, sharedOptions) {
    if (sharedOptions == null) return original;
    var binding = $3bf929a0ea4942ec$var$__assign($3bf929a0ea4942ec$var$__assign({}, original), {
        options: $3bf929a0ea4942ec$var$__assign($3bf929a0ea4942ec$var$__assign({}, $3bf929a0ea4942ec$var$toOptions(sharedOptions)), $3bf929a0ea4942ec$var$toOptions(original.options))
    });
    return binding;
}
function $3bf929a0ea4942ec$var$bindAll(target, bindings, sharedOptions) {
    var unbinds = bindings.map(function(original) {
        var binding = $3bf929a0ea4942ec$var$getBinding(original, sharedOptions);
        return (0, $1MYa3.bind)(target, binding);
    });
    return function unbindAll() {
        unbinds.forEach(function(unbind) {
            return unbind();
        });
    };
}
module.exports.bindAll = $3bf929a0ea4942ec$var$bindAll;

});



parcelRegister("eLxnz", function(module, exports) {
$parcel$export(module.exports, "VCObserver", () => $896484caa6fe7e43$export$1f70d263701b1d01);

var $3X3Vo = parcelRequire("3X3Vo");

var $dXdid = parcelRequire("dXdid");

var $dWn9F = parcelRequire("dWn9F");

var $4iBoC = parcelRequire("4iBoC");

var $fUPSA = parcelRequire("fUPSA");

var $76Plu = parcelRequire("76Plu");

var $etRaB = parcelRequire("etRaB");

var $fiBcB = parcelRequire("fiBcB");
const $896484caa6fe7e43$var$abortReason = {
    scroll: 'scroll',
    keypress: 'keypress',
    resize: 'resize',
    error: 'error'
};
const $896484caa6fe7e43$var$UNUSED_SECTOR = 0;
function $896484caa6fe7e43$var$filterComponentsLog(log) {
    return Object.fromEntries(Object.entries(log).map(([timestamp, entries])=>[
            Number(timestamp),
            entries.map((entry)=>{
                const { __debug__element: __debug__element, ...rest } = entry;
                return rest;
            })
        ]));
}
class $896484caa6fe7e43$export$1f70d263701b1d01 {
    static{
        /** config * */ this.VCParts = [
            '25',
            '50',
            '75',
            '80',
            '85',
            '90',
            '95',
            '98',
            '99'
        ];
    }
    constructor(options){
        /* abort logic */ this.abortReason = {
            reason: null,
            info: '',
            timestamp: -1,
            blocking: false
        };
        this.outOfBoundaryInfo = '';
        this.viewport = {
            w: 0,
            h: 0
        };
        /* heatmap */ this.arraySize = 0;
        this.componentsLog = {};
        this.vcRatios = {};
        this.active = false;
        this.totalTime = 0;
        this.startTime = 0;
        this._startMeasureTimestamp = -1;
        this.ssr = {
            reactRendered: -1
        };
        this.unbind = [];
        this.getAbortReasonInfo = ()=>{
            if (this.abortReason.reason === null) return null;
            const info = this.abortReason.info !== '' ? ` ${this.abortReason.info}` : '';
            return `${this.abortReason.reason}${info}`;
        };
        this.getVCRawData = ()=>{
            this.measureStart();
            if (!this.active) {
                this.measureStop();
                return null;
            }
            this.stop();
            const abortReasonInfo = this.getAbortReasonInfo();
            this.measureStop();
            return {
                abortReasonInfo: abortReasonInfo,
                abortReason: {
                    ...this.abortReason
                },
                heatmap: this.heatmap,
                heatmapNext: this.heatmapNext,
                outOfBoundaryInfo: this.outOfBoundaryInfo,
                totalTime: Math.round(this.totalTime + this.observers.getTotalTime()),
                componentsLog: {
                    ...this.componentsLog
                },
                viewport: {
                    ...this.viewport
                },
                oldDomUpdatesEnabled: this.oldDomUpdatesEnabled,
                devToolsEnabled: this.devToolsEnabled,
                ratios: this.vcRatios
            };
        };
        this.getVCResult = async ({ start: start, stop: stop, tti: tti, prefix: prefix, ssr: ssr, vc: vc, isEventAborted: isEventAborted, experienceKey: experienceKey, interactionId: interactionId, includeSSRRatio: includeSSRRatio })=>{
            const startTime = performance.now();
            // add local measurement
            const fullPrefix = prefix !== undefined && prefix !== '' ? `${prefix}:` : '';
            const rawData = vc !== undefined ? vc : this.getVCRawData();
            if (rawData === null) return {};
            const { abortReason: abortReason, abortReasonInfo: abortReasonInfo, heatmap: heatmap, heatmapNext: heatmapNext, outOfBoundaryInfo: outOfBoundaryInfo, totalTime: totalTime, componentsLog: componentsLog, viewport: viewport, devToolsEnabled: devToolsEnabled, ratios: ratios } = rawData;
            const isTTVCv1Disabled = !(0, $dXdid.isVCRevisionEnabled)('fy25.01', experienceKey);
            if (abortReasonInfo !== null) {
                // exposing data to devtools
                try {
                    if (devToolsEnabled && !this.isPostInteraction) window.__vcNotAvailableReason = abortReasonInfo;
                } catch  {}
                const vcAbortedResultWithRevisions = {
                    [`${fullPrefix}vc:rev`]: [
                        {
                            revision: 'fy25.02',
                            clean: false,
                            'metric:vc90': null,
                            abortReason: abortReason.reason,
                            abortTimestamp: Math.round(abortReason.timestamp)
                        }
                    ]
                };
                if (!isTTVCv1Disabled) vcAbortedResultWithRevisions[`${fullPrefix}vc:rev`].push({
                    revision: 'fy25.01',
                    clean: false,
                    'metric:vc90': null,
                    abortReason: abortReason.reason,
                    abortTimestamp: Math.round(abortReason.timestamp)
                });
                return vcAbortedResultWithRevisions;
            }
            const ttvcV1Result = isTTVCv1Disabled ? {
                VC: {},
                VCBox: {},
                VCEntries: {
                    abs: [],
                    rel: [],
                    speedIndex: -1
                },
                totalPainted: -1
            } : $896484caa6fe7e43$export$1f70d263701b1d01.calculateVC({
                heatmap: heatmap,
                ssr: ssr,
                componentsLog: {
                    ...componentsLog
                },
                viewport: viewport,
                fixSSRAttribution: includeSSRRatio
            });
            const { VC: VC, VCBox: VCBox, VCEntries: VCEntries, totalPainted: totalPainted } = ttvcV1Result;
            const _componentsLog = {};
            Object.entries(this.componentsLog).forEach(([_timestamp, value])=>{
                const timestamp = Number(_timestamp);
                if (stop > timestamp) _componentsLog[timestamp] = value;
            });
            const vcNext = $896484caa6fe7e43$export$1f70d263701b1d01.calculateVC({
                heatmap: heatmapNext,
                ssr: ssr,
                componentsLog: _componentsLog,
                viewport: viewport,
                fixSSRAttribution: includeSSRRatio
            });
            const outOfBoundary = outOfBoundaryInfo ? {
                [`${fullPrefix}vc:oob`]: outOfBoundaryInfo
            } : {};
            //const oldDomUpdates = oldDomUpdatesEnabled ? { [`${fullPrefix}vc:old:dom`]: vcNext.VCBox } : {};
            const stopTime = performance.now();
            // exposing data to devtools
            try {
                if (!this.isPostInteraction && devToolsEnabled) {
                    const ttvcV1DevToolInfo = isTTVCv1Disabled ? undefined : {
                        entries: VCEntries.rel,
                        log: componentsLog,
                        metrics: {
                            '75': VC['75'],
                            '80': VC['80'],
                            '85': VC['85'],
                            '90': VC['90'],
                            '95': VC['95'],
                            '98': VC['98'],
                            '99': VC['99'],
                            tti: tti,
                            ttai: stop - start
                        },
                        start: start,
                        stop: stop,
                        heatmap: heatmap,
                        ratios: ratios
                    };
                    const ttvcV2DevToolInfo = {
                        entries: vcNext.VCEntries.rel,
                        log: componentsLog,
                        metrics: {
                            '75': vcNext.VC['75'],
                            '80': vcNext.VC['80'],
                            '85': vcNext.VC['85'],
                            '90': vcNext.VC['90'],
                            '95': vcNext.VC['95'],
                            '98': vcNext.VC['98'],
                            '99': vcNext.VC['99'],
                            tti: tti,
                            ttai: stop - start
                        },
                        start: start,
                        stop: stop,
                        heatmap: heatmapNext,
                        ratios: ratios
                    };
                    if (isTTVCv1Disabled) {
                        window.__vc = ttvcV2DevToolInfo;
                        window.__vcNext = ttvcV2DevToolInfo;
                    } else {
                        window.__vc = ttvcV1DevToolInfo;
                        window.__vcNext = ttvcV2DevToolInfo;
                    }
                    // Emitting a custom event to make it available in the Chrome extension
                    window.dispatchEvent(new CustomEvent('vcReady', {
                        detail: {
                            log: $896484caa6fe7e43$var$filterComponentsLog(componentsLog),
                            entries: isTTVCv1Disabled ? vcNext.VCEntries.rel : VCEntries.rel
                        }
                    }));
                }
                if (!this.isPostInteraction) {
                    // Only create revision debug details if callbacks exist
                    const shouldCreateDebugDetails = typeof window.__ufo_devtool_onVCRevisionReady__ === 'function' || typeof window.__on_ufo_vc_debug_data_ready === 'function';
                    if (shouldCreateDebugDetails) {
                        const v1RevisionDebugDetails = (0, $fUPSA.getVCRevisionDebugDetails)({
                            revision: 'fy25.01',
                            isClean: !abortReasonInfo,
                            abortReason: abortReason.reason,
                            VCEntries: VCEntries.rel,
                            componentsLog: componentsLog,
                            interactionId: interactionId
                        });
                        const v2RevisionDebugDetails = (0, $fUPSA.getVCRevisionDebugDetails)({
                            revision: 'fy25.02',
                            isClean: !abortReasonInfo,
                            abortReason: abortReason.reason,
                            VCEntries: vcNext.VCEntries.rel,
                            componentsLog: componentsLog,
                            interactionId: interactionId
                        });
                        // Add devtool callback for both v1 and v2
                        if (typeof window.__ufo_devtool_onVCRevisionReady__ === 'function') {
                            // Handle v1 if not disabled
                            if (!isTTVCv1Disabled) window.__ufo_devtool_onVCRevisionReady__?.(v1RevisionDebugDetails);
                            // Handle v2
                            window.__ufo_devtool_onVCRevisionReady__?.(v2RevisionDebugDetails);
                        }
                        if (typeof window.__on_ufo_vc_debug_data_ready === 'function') {
                            if (!isTTVCv1Disabled) window.__on_ufo_vc_debug_data_ready?.(v1RevisionDebugDetails);
                            window.__on_ufo_vc_debug_data_ready?.(v2RevisionDebugDetails);
                        }
                    }
                }
            } catch  {
            /*  do nothing */ }
            const isVCClean = !abortReasonInfo;
            const revisionsData = (0, $76Plu.getVCRevisionsData)({
                fullPrefix: fullPrefix,
                interaction: {
                    start: start,
                    end: stop
                },
                isVCClean: isVCClean,
                calculatedVC: {
                    VC: VC,
                    VCBox: VCBox
                },
                calculatedVCNext: {
                    VC: vcNext.VC,
                    VCBox: vcNext.VCBox
                },
                isEventAborted: isEventAborted,
                experienceKey: experienceKey,
                ratios: ratios
            });
            const speedIndex = {
                [`ufo:speedIndex`]: isTTVCv1Disabled ? vcNext.VCEntries.speedIndex : VCEntries.speedIndex,
                [`ufo:next:speedIndex`]: vcNext.VCEntries.speedIndex
            };
            const SSRRatio = $896484caa6fe7e43$export$1f70d263701b1d01.getSSRRatio(VCEntries.rel, ssr);
            const SSRRatioNext = $896484caa6fe7e43$export$1f70d263701b1d01.getSSRRatio(vcNext.VCEntries.rel, ssr);
            const SSRRatioPayload = includeSSRRatio ? {
                [`${fullPrefix}vc:ssrRatio`]: isTTVCv1Disabled ? SSRRatioNext : SSRRatio,
                [`${fullPrefix}vc:next:ssrRatio`]: SSRRatioNext
            } : {};
            if (isTTVCv1Disabled) return {
                [`${fullPrefix}vc:size`]: viewport,
                [`${fullPrefix}vc:time`]: Math.round(totalTime + (stopTime - startTime)),
                [`${fullPrefix}vc:ratios`]: ratios,
                ...outOfBoundary,
                [`${fullPrefix}vc:ignored`]: this.getIgnoredElements(componentsLog),
                ...SSRRatioPayload,
                [`${fullPrefix}vc:ssrRatio`]: SSRRatioNext,
                ...revisionsData,
                ...speedIndex
            };
            const isTTVCv3Enabled = (0, $dXdid.isVCRevisionEnabled)('fy25.03', experienceKey);
            return {
                'metrics:vc': VC,
                [`${fullPrefix}vc:state`]: true,
                [`${fullPrefix}vc:clean`]: isVCClean,
                [`${fullPrefix}vc:dom`]: VCBox,
                [`${fullPrefix}vc:updates`]: isTTVCv3Enabled ? undefined : VCEntries.rel.slice(0, 50),
                // max 50
                [`${fullPrefix}vc:size`]: viewport,
                [`${fullPrefix}vc:time`]: Math.round(totalTime + (stopTime - startTime)),
                [`${fullPrefix}vc:total`]: totalPainted,
                [`${fullPrefix}vc:ratios`]: ratios,
                [`${fullPrefix}vc:ssrRatio`]: SSRRatio,
                ...outOfBoundary,
                [`${fullPrefix}vc:next`]: vcNext.VC,
                [`${fullPrefix}vc:next:updates`]: isTTVCv3Enabled ? undefined : vcNext.VCEntries.rel.slice(0, 50),
                // max 50
                [`${fullPrefix}vc:next:dom`]: vcNext.VCBox,
                ...SSRRatioPayload,
                [`${fullPrefix}vc:ignored`]: this.getIgnoredElements(componentsLog),
                ...revisionsData,
                ...speedIndex
            };
        };
        this.handleUpdate = (rawTime, intersectionRect, targetName, element, type, ignoreReason, attributeName, oldValue, newValue)=>{
            if (this.abortReason.reason === null || this.abortReason.blocking === false) {
                const time = Math.round(rawTime - this.startTime);
                const mappedValues = this.mapPixelsToHeatmap(intersectionRect.left, intersectionRect.top, intersectionRect.width, intersectionRect.height);
                this.vcRatios[targetName] = this.getElementRatio(mappedValues);
                if (!ignoreReason) this.applyChangesToHeatMap(mappedValues, time, this.heatmapNext);
                const interaction = (0, $dWn9F.getActiveInteraction)();
                const isTTVCv1Disabled = !(0, $dXdid.isVCRevisionEnabled)('fy25.01', interaction?.ufoName);
                if (!isTTVCv1Disabled && (!ignoreReason || ignoreReason === 'not-visible') && type !== 'attr') this.applyChangesToHeatMap(mappedValues, time, this.heatmap);
                if (!this.componentsLog[time]) this.componentsLog[time] = [];
                this.componentsLog[time].push({
                    __debug__element: this.devToolsEnabled ? new WeakRef(element) : null,
                    type: type,
                    intersectionRect: intersectionRect,
                    targetName: targetName,
                    ignoreReason: ignoreReason,
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue
                });
            }
        };
        this.mapPixelsToHeatmap = (left, top, width, height)=>{
            const { w: w, h: h } = this.viewport;
            const l = Math.floor(left / w * this.arraySize);
            const t = Math.floor(top / h * this.arraySize);
            const r = Math.ceil((left + width) / w * this.arraySize);
            const b = Math.ceil((top + height) / h * this.arraySize);
            // that info is temporary to get info why it goes over boundary
            if (this.outOfBoundaryInfo === '') {
                let outOfBoundaryInfo = '';
                if (r > this.arraySize) outOfBoundaryInfo += ` r ${r} ! ${left} ${width}`;
                if (b > this.arraySize) outOfBoundaryInfo += ` r ${r} ! ${top} ${height}`;
                this.outOfBoundaryInfo = outOfBoundaryInfo;
            }
            // correct values to min - 0, max - arraySize
            const result = {
                l: Math.max(0, l),
                t: Math.max(0, t),
                r: Math.min(this.arraySize, r),
                b: Math.min(this.arraySize, b)
            };
            return result;
        };
        this.getElementRatio = (mappedValues)=>{
            const { r: r, l: l, b: b, t: t } = mappedValues;
            return (r - l) * (b - t) / (this.arraySize * this.arraySize);
        };
        this.abortReasonCallback = (key, time)=>{
            switch(key){
                case 'wheel':
                    this.setAbortReason($896484caa6fe7e43$var$abortReason.scroll, time);
                    break;
                case 'keydown':
                    // Don't abort press interactions on keydown events, as keydown is expected
                    // when users press Enter/Space to activate buttons or other interactive elements
                    if ((0, $3X3Vo.fg)('platform_ufo_keypress_interaction_abort')) {
                        const interaction = (0, $dWn9F.getActiveInteraction)();
                        if (interaction?.type === 'press') break;
                    }
                    this.setAbortReason($896484caa6fe7e43$var$abortReason.keypress, time);
                    break;
                case 'resize':
                    this.setAbortReason($896484caa6fe7e43$var$abortReason.resize, time);
                    break;
            }
        };
        this.attachAbortListeners = ()=>{
            this.detachAbortListeners();
            let unbinds = (0, $4iBoC.attachAbortListeners)(window, this.viewport, this.abortReasonCallback);
            if (window?.__SSR_ABORT_LISTENERS__) Object.entries(window.__SSR_ABORT_LISTENERS__.aborts).forEach(([key, time])=>{
                if (time) this.abortReasonCallback(key, time);
            });
            this.unbind = unbinds;
        };
        this.arraySize = options.heatmapSize || 200;
        this.devToolsEnabled = options.devToolsEnabled || false;
        this.oldDomUpdatesEnabled = options.oldDomUpdates || false;
        const { ssrEnablePageLayoutPlaceholder: ssrEnablePageLayoutPlaceholder, ssrPlaceholderHandler: ssrPlaceholderHandler } = options;
        // Selector-config resolution is centralised in `getSelectorConfig()`
        // (`../../config`). It enforces FedRAMP-override > caller-override >
        // centrally configured > caller default, gated by
        // `platform_ufo_fedramp_overrides`. When the gate is OFF the helper
        // returns `options.selectorConfig ?? config?.vc?.selectorConfig`, and
        // we fall back to the legacy hard-coded default — byte-for-byte
        // unchanged from pre-FedRAMP behaviour.
        const LEGACY_DEFAULT_SELECTOR_CONFIG = {
            id: false,
            testId: false,
            role: false,
            className: true,
            dataVC: true
        };
        this.observers = new (0, $fiBcB.Observers)({
            selectorConfig: (0, $dXdid.getSelectorConfig)(options.selectorConfig, LEGACY_DEFAULT_SELECTOR_CONFIG) || options.selectorConfig || LEGACY_DEFAULT_SELECTOR_CONFIG,
            SSRConfig: {
                enablePageLayoutPlaceholder: ssrEnablePageLayoutPlaceholder || false
            },
            ssrPlaceholderHandler: ssrPlaceholderHandler
        });
        this.heatmap = !(0, $dXdid.isVCRevisionEnabled)('fy25.01') ? [] : this.getCleanHeatmap();
        this.heatmapNext = this.getCleanHeatmap();
        this.isPostInteraction = options.isPostInteraction || false;
    }
    start({ startTime: startTime }) {
        this.active = true;
        if (this.observers.isBrowserSupported()) {
            this.setViewportSize();
            this.resetState();
            this.startTime = startTime;
            this.attachAbortListeners();
            this.observers.subscribeResults(this.handleUpdate);
            this.observers.observe();
        } else this.setAbortReason('not-supported', startTime);
    }
    stop() {
        this.observers.disconnect();
        this.detachAbortListeners();
    }
    getIgnoredElements(componentsLog) {
        return Object.values(componentsLog).flat().filter(({ ignoreReason: ignoreReason })=>Boolean(ignoreReason)).map(({ targetName: targetName, ignoreReason: ignoreReason })=>({
                targetName: targetName,
                ignoreReason: ignoreReason
            }));
    }
    static getSSRRatio(entries, ssr) {
        if (ssr === undefined || entries.length === 0) return undefined;
        const maybeSSR = entries[0];
        if (maybeSSR.elements[0] === 'SSR') return maybeSSR.vc;
        return 0;
    }
    static calculateVC({ heatmap: heatmap, ssr: ssr = $896484caa6fe7e43$var$UNUSED_SECTOR, componentsLog: componentsLog, viewport: viewport, fixSSRAttribution: fixSSRAttribution }) {
        const lastUpdate = {};
        let totalPainted = 0;
        const ssrTime = fixSSRAttribution ? Math.floor(ssr) : ssr;
        if (ssrTime !== $896484caa6fe7e43$var$UNUSED_SECTOR) {
            const element = {
                __debug__element: new WeakRef(window.document?.body),
                intersectionRect: {
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    x: 0,
                    y: 0,
                    width: viewport.w,
                    height: viewport.h,
                    toJSON () {
                        return {};
                    }
                },
                targetName: 'SSR'
            };
            if (!componentsLog[ssrTime]) componentsLog[ssrTime] = [];
            componentsLog[ssrTime].push(element);
        }
        heatmap.forEach((line)=>{
            line.forEach((entry)=>{
                const rounded = Math.floor(entry === $896484caa6fe7e43$var$UNUSED_SECTOR && ssrTime !== $896484caa6fe7e43$var$UNUSED_SECTOR ? ssrTime : entry);
                totalPainted += rounded !== $896484caa6fe7e43$var$UNUSED_SECTOR ? 1 : 0;
                if (rounded !== $896484caa6fe7e43$var$UNUSED_SECTOR) lastUpdate[rounded] = lastUpdate[rounded] ? lastUpdate[rounded] + 1 : 1;
            });
        });
        const entries = Object.entries(lastUpdate).map((a)=>[
                parseInt(a[0], 10),
                a[1]
            ]).sort((a, b)=>a[0] > b[0] ? 1 : -1);
        const VC = $896484caa6fe7e43$export$1f70d263701b1d01.makeVCReturnObj();
        const VCBox = $896484caa6fe7e43$export$1f70d263701b1d01.makeVCReturnObj();
        entries.reduce((acc = 0, v)=>{
            const currRatio = v[1] / totalPainted;
            let VCRatio = currRatio + acc;
            const preciseCurrRatio = Math.round(100 * (v[1] / totalPainted));
            const preciseAccRatio = Math.round(acc * 100);
            VCRatio = (preciseCurrRatio + preciseAccRatio) / 100;
            const time = v[0];
            $896484caa6fe7e43$export$1f70d263701b1d01.VCParts.forEach((key)=>{
                const value = parseInt(key, 10);
                if ((VC[key] === null || VC[key] === undefined) && VCRatio >= value / 100) {
                    VC[key] = time;
                    VCBox[key] = [
                        ...new Set(componentsLog[time]?.filter((v)=>!v.ignoreReason).map((v)=>v.targetName))
                    ];
                }
            });
            return VCRatio;
        }, 0);
        const VCEntries = entries.reduce((acc, [timestamp, entryPainted], i)=>{
            const currentlyPainted = entryPainted + (acc.abs[i - 1]?.[1] || 0);
            const currentlyPaintedRatio = Math.round(currentlyPainted / totalPainted * 1000) / 10;
            const logEntry = [
                ...new Set(componentsLog[timestamp]?.filter((v)=>!v.ignoreReason).map((v)=>v.targetName))
            ];
            const ratioDelta = (currentlyPaintedRatio - (acc.rel[i - 1]?.vc ?? 0)) / 100;
            const speedIndex = timestamp * ratioDelta;
            acc.speedIndex += speedIndex;
            acc.abs.push([
                timestamp,
                currentlyPainted
            ]);
            acc.rel.push({
                time: timestamp,
                vc: currentlyPaintedRatio,
                elements: logEntry
            });
            return acc;
        }, {
            abs: [],
            rel: [],
            speedIndex: 0
        });
        VCEntries.speedIndex = Math.round(VCEntries.speedIndex);
        return {
            VC: VC,
            VCBox: VCBox,
            VCEntries: VCEntries,
            totalPainted: totalPainted
        };
    }
    setSSRElement(element) {
        this.observers.setReactRootElement(element);
    }
    setReactRootRenderStart(startTime = performance.now()) {
        this.observers.setReactRootRenderStart(startTime);
    }
    setReactRootRenderStop(stopTime = performance.now()) {
        this.observers.setReactRootRenderStop(stopTime);
    }
    collectSSRPlaceholders() {
    // This is handled by the shared SSRPlaceholderHandlers in VCObserverWrapper
    // Individual observers don't need to implement this
    }
    setAbortReason(abort, timestamp, info = '') {
        if (this.abortReason.reason === null || this.abortReason.blocking === false) {
            this.abortReason.reason = abort;
            this.abortReason.info = info;
            this.abortReason.timestamp = timestamp;
            this.abortReason.blocking = abort !== $896484caa6fe7e43$var$abortReason.scroll;
            if (this.abortReason.blocking) this.detachAbortListeners();
        }
    }
    resetState() {
        this.abortReason = {
            reason: null,
            info: '',
            timestamp: -1,
            blocking: false
        };
        this.detachAbortListeners();
        this.heatmap = !(0, $dXdid.isVCRevisionEnabled)('fy25.01') ? [] : this.getCleanHeatmap();
        this.heatmapNext = this.getCleanHeatmap();
        this.totalTime = 0;
        this.componentsLog = {};
        this.vcRatios = {};
    }
    getCleanHeatmap() {
        return Array(this.arraySize).fill('').map(()=>Array(this.arraySize).fill($896484caa6fe7e43$var$UNUSED_SECTOR));
    }
    setViewportSize() {
        this.viewport.w = (0, $etRaB.getViewportWidth)();
        this.viewport.h = (0, $etRaB.getViewportHeight)();
    }
    applyChangesToHeatMap(a, time, heatmap) {
        const { l: l, t: t, r: r, b: b } = a;
        const localHeatmap = heatmap;
        for(let row = t; row < b; row++){
            for(let col = l; col < r; col++)if (localHeatmap[row] === undefined) {
                try {
                    this.setAbortReason($896484caa6fe7e43$var$abortReason.error, time, `index - ${row}`);
                } catch  {
                    this.setAbortReason($896484caa6fe7e43$var$abortReason.error, time, 'row error');
                }
                return;
            } else localHeatmap[row][col] = time;
        }
    }
    static makeVCReturnObj() {
        const vc = {};
        $896484caa6fe7e43$export$1f70d263701b1d01.VCParts.forEach((v)=>{
            vc[v] = null;
        });
        return vc;
    }
    detachAbortListeners() {
        if (this.unbind) {
            const { unbind: unbind } = this;
            for(let i = 0; i < unbind.length; i++)unbind[i]();
            this.unbind.length = 0;
        }
    }
    measureStart() {
        this._startMeasureTimestamp = performance.now();
    }
    measureStop() {
        if (this._startMeasureTimestamp === -1) return;
        this.totalTime += performance.now() - this._startMeasureTimestamp;
        this._startMeasureTimestamp = -1;
    }
}

});
parcelRegister("dWn9F", function(module, exports) {
$parcel$export(module.exports, "PreviousInteractionLog", () => $48f592adf5dd6cf2$export$dbba6cdedab4e68b);
$parcel$export(module.exports, "postInteractionLog", () => $48f592adf5dd6cf2$export$d8f52e8f804021e8);
$parcel$export(module.exports, "interactionExtraMetrics", () => $48f592adf5dd6cf2$export$481f88116dc8b7ad);
$parcel$export(module.exports, "segmentUnmountCache", () => $48f592adf5dd6cf2$export$a2b14406ded37d60);
$parcel$export(module.exports, "getActiveInteraction", () => $48f592adf5dd6cf2$export$2b3954d2e8509985);
$parcel$export(module.exports, "remove", () => $48f592adf5dd6cf2$export$cd7f480d6b8286c3);
$parcel$export(module.exports, "updatePageLoadInteractionName", () => $48f592adf5dd6cf2$export$f6f1cf5bedf83c71);
$parcel$export(module.exports, "addCustomData", () => $48f592adf5dd6cf2$export$e4380431c2bdabee);
$parcel$export(module.exports, "addCohortingCustomData", () => $48f592adf5dd6cf2$export$20265b12c6625451);
$parcel$export(module.exports, "addCustomTiming", () => $48f592adf5dd6cf2$export$27cacb7d7f3fe20a);
$parcel$export(module.exports, "addMark", () => $48f592adf5dd6cf2$export$728e28c22a0fba4);
$parcel$export(module.exports, "markFirstSegmentLoad", () => $48f592adf5dd6cf2$export$85d1eb835f669bf);
$parcel$export(module.exports, "addSpan", () => $48f592adf5dd6cf2$export$2c1d6e17cfa9bbc7);
$parcel$export(module.exports, "addSpanToAll", () => $48f592adf5dd6cf2$export$943a8b2b5d6b1809);
$parcel$export(module.exports, "addHold", () => $48f592adf5dd6cf2$export$7606887303596f82);
$parcel$export(module.exports, "addHoldByID", () => $48f592adf5dd6cf2$export$10582acd678c213);
$parcel$export(module.exports, "removeHoldByID", () => $48f592adf5dd6cf2$export$4983dfbbb996f7ae);
$parcel$export(module.exports, "getCurrentInteractionType", () => $48f592adf5dd6cf2$export$2df109852219d16e);
$parcel$export(module.exports, "addError", () => $48f592adf5dd6cf2$export$239c33984d9b1367);
$parcel$export(module.exports, "addErrorToAll", () => $48f592adf5dd6cf2$export$7379c15afd3840fa);
$parcel$export(module.exports, "addProfilerTimings", () => $48f592adf5dd6cf2$export$53d6f611de951a13);
$parcel$export(module.exports, "sinkInteractionHandler", () => $48f592adf5dd6cf2$export$9e614a29a1ac213e);
$parcel$export(module.exports, "sinkPostInteractionLogHandler", () => $48f592adf5dd6cf2$export$8a1ba7bef607358a);
$parcel$export(module.exports, "tryComplete", () => $48f592adf5dd6cf2$export$673be905888f8839);
$parcel$export(module.exports, "abort", () => $48f592adf5dd6cf2$export$5def58af4fd46132);
$parcel$export(module.exports, "abortByNewInteraction", () => $48f592adf5dd6cf2$export$c4a545284f55edf2);
$parcel$export(module.exports, "abortAll", () => $48f592adf5dd6cf2$export$614a7af2affc5dff);
$parcel$export(module.exports, "addOnCancelCallback", () => $48f592adf5dd6cf2$export$7b9261a96cfe427b);
$parcel$export(module.exports, "addNewInteraction", () => $48f592adf5dd6cf2$export$1a1ed1e1fdb2006b);
$parcel$export(module.exports, "addBrowserMetricEvent", () => $48f592adf5dd6cf2$export$4a759336b50e86e3);
$parcel$export(module.exports, "addApdex", () => $48f592adf5dd6cf2$export$35220fd6cdd1b731);
$parcel$export(module.exports, "addRequestInfo", () => $48f592adf5dd6cf2$export$57d55b4569823d8f);
$parcel$export(module.exports, "addSegment", () => $48f592adf5dd6cf2$export$1c43f9ac826b6462);
$parcel$export(module.exports, "removeSegment", () => $48f592adf5dd6cf2$export$d0365e48b58231c3);
$parcel$export(module.exports, "interactionSpans", () => $48f592adf5dd6cf2$export$6ce04c7ca6810a7e);
$parcel$export(module.exports, "addCustomSpans", () => $48f592adf5dd6cf2$export$5342dcad19138a1c);
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $40SCs = parcelRequire("40SCs");

var $3X3Vo = parcelRequire("3X3Vo");

var $irOPS = parcelRequire("irOPS");

var $d6EUi = parcelRequire("d6EUi");

var $dXdid = parcelRequire("dXdid");

var $50omK = parcelRequire("50omK");

var $9pXDa = parcelRequire("9pXDa");

var $2AagZ = parcelRequire("2AagZ");

var $3EjrT = parcelRequire("3EjrT");

var $dSjTj = parcelRequire("dSjTj");

var $kPZVD = parcelRequire("kPZVD");

var $dD8QO = parcelRequire("dD8QO");

var $9oQne = parcelRequire("9oQne");

var $kp8di = parcelRequire("kp8di");

var $2Sm5I = parcelRequire("2Sm5I");

var $ggIEI = parcelRequire("ggIEI");
const $48f592adf5dd6cf2$export$dbba6cdedab4e68b = {
    id: undefined,
    name: undefined,
    type: undefined,
    isAborted: undefined,
    timestamp: undefined
};
const $48f592adf5dd6cf2$export$d8f52e8f804021e8 = new (0, $ggIEI.default)();
const $48f592adf5dd6cf2$export$481f88116dc8b7ad = new (0, $2Sm5I.default)();
const $48f592adf5dd6cf2$var$interactionQueue = [];
const $48f592adf5dd6cf2$var$segmentCache = new Map();
const $48f592adf5dd6cf2$export$a2b14406ded37d60 = new Map(); // Temporarily store segment unmount counts
let $48f592adf5dd6cf2$var$firstSegmentLoadMarked = false;
const $48f592adf5dd6cf2$var$segmentObservers = [];
function $48f592adf5dd6cf2$export$2b3954d2e8509985() {
    const interactionId = (0, $kPZVD.getInteractionId)();
    if (!interactionId.current) return;
    return (0, $kp8di.interactions).get(interactionId.current);
}
function $48f592adf5dd6cf2$var$isPerformanceTracingEnabled() {
    return (0, $dXdid.getConfig)()?.enableAdditionalPerformanceMarks || window.__REACT_UFO_ENABLE_PERF_TRACING || false;
}
let $48f592adf5dd6cf2$var$performanceEventObserver;
const $48f592adf5dd6cf2$export$17afbba0f16b4b19 = ()=>{
    $48f592adf5dd6cf2$var$performanceEventObserver = $48f592adf5dd6cf2$var$performanceEventObserver || new PerformanceObserver((entries)=>{
        const list = entries.getEntries();
        for (let entry of list)if (entry.name === 'click') $48f592adf5dd6cf2$export$e6be05b411ce21a6(entry);
    });
    return $48f592adf5dd6cf2$var$performanceEventObserver;
};
const $48f592adf5dd6cf2$export$e6be05b411ce21a6 = (entry)=>{
    const interaction = $48f592adf5dd6cf2$export$2b3954d2e8509985();
    if (interaction?.type === 'press') {
        const responsiveness = interaction.responsiveness || {};
        // if happens there is another event interaction that has started after
        // the initial one, we don't want to replace the values if they have already
        // been set up
        responsiveness.experimentalInputToNextPaint = responsiveness.experimentalInputToNextPaint || entry.duration;
        responsiveness.inputDelay = responsiveness.experimentalInputToNextPaint || entry.processingStart - entry.startTime;
        interaction.responsiveness = responsiveness;
        // if the entry start time is lower than the one in the interaction
        // it means the interaction start time is not accurate, we assign
        // this value which will match the timestamp in the event
        if (entry.startTime < interaction.start) interaction.start = entry.startTime;
    }
};
function $48f592adf5dd6cf2$var$labelStackToString(labelStack, name) {
    const stack = [
        ...labelStack ?? []
    ];
    if (name) stack.push({
        name: name
    });
    return stack.map((l)=>l.name)?.join('/');
}
function $48f592adf5dd6cf2$var$labelStackToIdString(labelStack) {
    return labelStack?.map((l)=>'segmentId' in l ? `${l.name}:${l.segmentId}` : `${l.name}`)?.join('/');
}
function $48f592adf5dd6cf2$var$addSegmentObserver(observer) {
    $48f592adf5dd6cf2$var$segmentObservers.push(observer);
    for (const segmentInfo of $48f592adf5dd6cf2$var$segmentCache.values())observer.onAdd(segmentInfo);
}
function $48f592adf5dd6cf2$var$removeSegmentObserver(observer) {
    const index = $48f592adf5dd6cf2$var$segmentObservers.findIndex((obs)=>obs === observer);
    if (index !== -1) $48f592adf5dd6cf2$var$segmentObservers.splice(index, 1);
}
function $48f592adf5dd6cf2$export$cd7f480d6b8286c3(interactionId) {
    (0, $kp8di.interactions).delete(interactionId);
}
function $48f592adf5dd6cf2$export$f6f1cf5bedf83c71(ufoName, routeName = ufoName) {
    const interaction = $48f592adf5dd6cf2$export$2b3954d2e8509985();
    if (!interaction || interaction.type !== 'page_load' && interaction.type !== 'transition') return;
    interaction.ufoName = ufoName;
    interaction.routeName = routeName;
}
function $48f592adf5dd6cf2$export$12f2b6cb85d59904(interactionId, data) {
    const interaction = (0, $kp8di.interactions).get(interactionId);
    if (interaction != null) Object.keys(data).forEach((key)=>{
        interaction.metaData[key] = data[key];
    });
}
function $48f592adf5dd6cf2$export$e4380431c2bdabee(interactionId, labelStack, data) {
    const interaction = (0, $kp8di.interactions).get(interactionId);
    if (interaction != null) Object.keys(data).forEach((i)=>{
        interaction.customData.push({
            labelStack: labelStack,
            data: {
                [i]: data[i]
            }
        });
    });
}
function $48f592adf5dd6cf2$export$c227d812a1e08d80(interactionId, segmentId, entry) {
    const interaction = (0, $kp8di.interactions).get(interactionId);
    if (interaction != null && (0, $3X3Vo.fg)('platform_ufo_3p_segment_timings')) {
        if (!interaction.segment3pTimings) interaction.segment3pTimings = {};
        if (!interaction.segment3pTimings[segmentId]) interaction.segment3pTimings[segmentId] = [];
        interaction.segment3pTimings[segmentId].push(entry);
    }
}
function $48f592adf5dd6cf2$export$20265b12c6625451(interactionId, key, value) {
    const interaction = (0, $kp8di.interactions).get(interactionId);
    if (interaction == null) return;
    // Allow null and undefined values
    if (value === null || value === undefined) {
        interaction.cohortingCustomData.set(key, value);
        return;
    }
    // Validate that the value is a primitive (number, boolean, or string)
    if (typeof value !== 'number' && typeof value !== 'boolean' && typeof value !== 'string') return;
    // Validate string length (max 50 characters)
    if (typeof value === 'string' && value.length > 50) return;
    interaction.cohortingCustomData.set(key, value);
}
function $48f592adf5dd6cf2$export$27cacb7d7f3fe20a(interactionId, labelStack, data) {
    const interaction = (0, $kp8di.interactions).get(interactionId);
    if (interaction != null) {
        const sanitizedData = Object.fromEntries(Object.entries(data).map(([key, timingData])=>[
                (0, $d6EUi.sanitizeTimingName)(key),
                timingData
            ]));
        interaction.customTimings.push({
            labelStack: labelStack,
            data: sanitizedData
        });
        if ($48f592adf5dd6cf2$var$isPerformanceTracingEnabled()) for (const [key, timingData] of Object.entries(sanitizedData)){
            const { startTime: startTime, endTime: endTime } = timingData;
            try {
                // for Firefox 102 and older
                performance.measure(`\u{1F6F8} ${$48f592adf5dd6cf2$var$labelStackToString(labelStack, key)} [custom_timing]`, {
                    start: startTime,
                    end: endTime,
                    detail: {
                        devtools: {
                            track: "\uD83D\uDEF8 reactUFO detailed timings",
                            color: 'tertiary-light'
                        }
                    }
                });
            } catch  {
            // do nothing
            }
        }
    }
}
function $48f592adf5dd6cf2$export$728e28c22a0fba4(interactionId, type, name, labelStack, time = performance.now()) {
    const interaction = (0, $kp8di.interactions).get(interactionId);
    if (interaction != null) interaction.marks.push({
        type: type,
        name: name,
        labelStack: labelStack,
        time: time
    });
    if ($48f592adf5dd6cf2$var$isPerformanceTracingEnabled()) performance.mark(`\u{1F6F8} ${$48f592adf5dd6cf2$var$labelStackToString(labelStack, name)} [${type}]`, {
        startTime: time
    });
}
function $48f592adf5dd6cf2$export$85d1eb835f669bf(interactionId, labelStack, time = performance.now()) {
    if (!(0, $3X3Vo.fg)('platform_mark_ufo_segment_first_load')) return;
    const interaction = (0, $kp8di.interactions).get(interactionId);
    if (interaction != null && !$48f592adf5dd6cf2$var$firstSegmentLoadMarked) {
        $48f592adf5dd6cf2$var$firstSegmentLoadMarked = true;
        interaction.marks.push({
            type: 'first_segment_load',
            name: 'first_segment_load',
            labelStack: labelStack,
            time: time
        });
    }
}
function $48f592adf5dd6cf2$export$c4b23cc624bd2fb(type, name, labelStack, time = performance.now()) {
    (0, $kp8di.interactions).forEach((interaction)=>{
        interaction.marks.push({
            type: type,
            name: name,
            labelStack: labelStack,
            time: time
        });
    });
    if ($48f592adf5dd6cf2$var$isPerformanceTracingEnabled()) performance.mark(`\u{1F6F8} ${$48f592adf5dd6cf2$var$labelStackToString(labelStack, name)} [${type}]`, {
        startTime: time
    });
}
function $48f592adf5dd6cf2$export$2c1d6e17cfa9bbc7(interactionId, type, name, labelStack, start, end = performance.now(), size) {
    const interaction = (0, $kp8di.interactions).get(interactionId);
    if (interaction != null) {
        interaction.spans.push({
            type: type,
            name: name,
            labelStack: labelStack,
            start: start,
            end: end,
            size: size
        });
        if ($48f592adf5dd6cf2$var$isPerformanceTracingEnabled()) try {
            // for Firefox 102 and older
            performance.measure(`\u{1F6F8} ${$48f592adf5dd6cf2$var$labelStackToString(labelStack, name)} [${type}]`, {
                start: start,
                end: end,
                detail: {
                    devtools: {
                        track: "\uD83D\uDEF8 reactUFO detailed timings",
                        color: 'secondary'
                    }
                }
            });
        } catch  {
        // do nothing
        }
    }
}
function $48f592adf5dd6cf2$export$943a8b2b5d6b1809(type, name, labelStack, start, end = performance.now(), size = 0) {
    (0, $kp8di.interactions).forEach((interaction)=>{
        interaction.spans.push({
            type: type,
            name: name,
            labelStack: labelStack,
            start: start,
            end: end,
            size: size
        });
    });
    if ($48f592adf5dd6cf2$var$isPerformanceTracingEnabled()) try {
        // for Firefox 102 and older
        performance.measure(`\u{1F6F8} ${$48f592adf5dd6cf2$var$labelStackToString(labelStack, name)} [${type}]`, {
            start: start,
            end: end,
            detail: {
                devtools: {
                    track: "\uD83D\uDEF8 reactUFO detailed timings",
                    color: 'secondary'
                }
            }
        });
    } catch  {
    // do nothing
    }
}
function $48f592adf5dd6cf2$export$9e04fe1a58571ec(moduleId, timestamp) {
    $48f592adf5dd6cf2$export$c4b23cc624bd2fb('bundle_preload', moduleId, null, timestamp);
}
function $48f592adf5dd6cf2$export$6f228d1fdc911d7(identifier, start, end) {
    $48f592adf5dd6cf2$export$943a8b2b5d6b1809('bundle_load', identifier, null, start, end - start);
}
const $48f592adf5dd6cf2$var$moduleLoadingRequests = {};
function $48f592adf5dd6cf2$export$f5a8f10de74904da(input) {
    let result = input ?? '';
    result = result.replace(/^\.\/src\/packages\//, '');
    result = result.replace(/^\.\/node_modules\//, '');
    result = result.replace(/(\/src)?\/(index|main)\.(tsx|ts|js|jsx)$/, '');
    return result;
}
function $48f592adf5dd6cf2$var$addHoldCriterion(id, labelStack, name, startTime) {
    if (!window.__CRITERION__?.addUFOHold) return;
    window.__CRITERION__.addUFOHold(id, $48f592adf5dd6cf2$var$labelStackToString(labelStack), name, startTime);
}
function $48f592adf5dd6cf2$var$removeHoldCriterion(id) {
    if (!window.__CRITERION__?.removeUFOHold) return;
    window.__CRITERION__.removeUFOHold(id);
}
function $48f592adf5dd6cf2$export$7606887303596f82(interactionId, labelStack, name, _experimental) {
    const interaction = (0, $kp8di.interactions).get(interactionId);
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const id = (0, $40SCs.v4)();
    if (!interaction) // add hold timestamp to post interaction log if interaction is complete
    $48f592adf5dd6cf2$export$d8f52e8f804021e8.addHoldInfo(labelStack, name, performance.now());
    if (interaction != null) {
        const start = performance.now();
        const holdActive = {
            labelStack: labelStack,
            name: name,
            start: start
        };
        const is3pHold = labelStack.some((l)=>'type' in l && l.type === 'third-party');
        if (is3pHold) {
            if (!interaction.hold3pActive) interaction.hold3pActive = new Map();
            interaction.hold3pActive.set(id, {
                ...holdActive,
                start: start
            });
        } else {
            interaction.holdActive.set(id, {
                ...holdActive,
                start: start
            });
            $48f592adf5dd6cf2$var$addHoldCriterion(id, labelStack, name, start);
        }
        return ()=>{
            const end = performance.now();
            if ($48f592adf5dd6cf2$var$isPerformanceTracingEnabled()) try {
                // for Firefox 102 and older
                performance.measure(`\u{1F6F8} ${$48f592adf5dd6cf2$var$labelStackToString(labelStack, name)} [hold]`, {
                    start: start,
                    end: end,
                    detail: {
                        devtools: {
                            track: "\uD83D\uDEF8 reactUFO detailed timings",
                            color: 'secondary-light'
                        }
                    }
                });
            } catch  {
            // do nothing
            }
            $48f592adf5dd6cf2$var$removeHoldCriterion(id);
            const currentInteraction = (0, $kp8di.interactions).get(interactionId);
            const currentHold = interaction.holdActive.get(id);
            const expHold = interaction.holdExpActive.get(id);
            if (currentInteraction != null) {
                if (currentHold != null) {
                    currentInteraction.holdInfo.push({
                        ...currentHold,
                        end: end
                    });
                    interaction.holdActive.delete(id);
                }
                if (expHold != null) {
                    currentInteraction.holdExpInfo.push({
                        ...expHold,
                        end: end
                    });
                    interaction.holdExpActive.delete(id);
                }
                if (interaction.hold3pActive) {
                    const current3pHold = interaction.hold3pActive.get(id);
                    if (current3pHold != null) {
                        if (!currentInteraction.hold3pInfo) currentInteraction.hold3pInfo = [];
                        currentInteraction.hold3pInfo.push({
                            ...current3pHold,
                            end: end
                        });
                        interaction.hold3pActive.delete(id);
                    }
                }
            }
        };
    }
    return ()=>{};
}
function $48f592adf5dd6cf2$export$10582acd678c213(interactionId, labelStack, name, id, ignoreOnSubmit) {
    const interaction = (0, $kp8di.interactions).get(interactionId);
    if (interaction != null) {
        const start = performance.now();
        const is3pHold = labelStack.some((l)=>'type' in l && l.type === 'third-party');
        if (is3pHold) {
            if (!interaction.hold3pActive) interaction.hold3pActive = new Map();
            interaction.hold3pActive.set(id, {
                labelStack: labelStack,
                name: name,
                start: start,
                ignoreOnSubmit: ignoreOnSubmit
            });
        } else {
            interaction.holdActive.set(id, {
                labelStack: labelStack,
                name: name,
                start: start,
                ignoreOnSubmit: ignoreOnSubmit
            });
            $48f592adf5dd6cf2$var$addHoldCriterion(id, labelStack, name, start);
        }
    }
    return ()=>{};
}
function $48f592adf5dd6cf2$export$4983dfbbb996f7ae(interactionId, id) {
    const interaction = (0, $kp8di.interactions).get(interactionId);
    if (interaction != null) {
        const end = performance.now();
        const currentInteraction = (0, $kp8di.interactions).get(interactionId);
        const currentHold = interaction.holdActive.get(id);
        if (currentInteraction != null && currentHold != null) {
            currentInteraction.holdInfo.push({
                ...currentHold,
                end: end
            });
            interaction.holdActive.delete(id);
            $48f592adf5dd6cf2$var$removeHoldCriterion(id);
        }
        if (interaction.hold3pActive) {
            const current3pHold = interaction.hold3pActive.get(id);
            if (currentInteraction != null && current3pHold != null) {
                if (!currentInteraction.hold3pInfo) currentInteraction.hold3pInfo = [];
                currentInteraction.hold3pInfo.push({
                    ...current3pHold,
                    end: end
                });
                interaction.hold3pActive.delete(id);
            }
        }
    }
}
function $48f592adf5dd6cf2$export$2df109852219d16e(interactionId) {
    const interaction = (0, $kp8di.interactions).get(interactionId);
    if (interaction) return interaction.type;
    return null;
}
const $48f592adf5dd6cf2$export$9591b52b33ccc510 = {
    onPreload (moduleId, _priority) {
        $48f592adf5dd6cf2$export$9e04fe1a58571ec($48f592adf5dd6cf2$export$f5a8f10de74904da(moduleId), performance.now());
    },
    onLoadStart (info) {
        const timeoutId = setTimeout(()=>{
            delete $48f592adf5dd6cf2$var$moduleLoadingRequests[info.identifier];
        }, 30000);
        const request = {
            start: performance.now(),
            timeoutId: timeoutId
        };
        $48f592adf5dd6cf2$var$moduleLoadingRequests[info.identifier] = request;
    },
    onLoadComplete (info) {
        const request = $48f592adf5dd6cf2$var$moduleLoadingRequests[info.identifier];
        if (request) {
            clearTimeout(request.timeoutId);
            delete $48f592adf5dd6cf2$var$moduleLoadingRequests[info.identifier];
            $48f592adf5dd6cf2$export$6f228d1fdc911d7($48f592adf5dd6cf2$export$f5a8f10de74904da(info.identifier), request.start, performance.now());
        }
    },
    placeholderFallBackMounted (id, moduleId) {
        const interactionId = (0, $kPZVD.getInteractionId)();
        const currentInteractionId = interactionId.current;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $48f592adf5dd6cf2$export$10582acd678c213(currentInteractionId, [], moduleId, id);
    },
    placeholderFallBackUnmounted (id) {
        const interactionId = (0, $kPZVD.getInteractionId)();
        const currentInteractionId = interactionId.current;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $48f592adf5dd6cf2$export$4983dfbbb996f7ae(currentInteractionId, id);
    }
};
function $48f592adf5dd6cf2$export$239c33984d9b1367(interactionId, name, labelStack, errorType, errorMessage, errorStack, forcedError, errorHash, errorStatusCode) {
    const interaction = (0, $kp8di.interactions).get(interactionId);
    if (interaction != null) interaction.errors.push({
        name: name,
        labelStack: labelStack,
        errorType: errorType,
        errorMessage: errorMessage,
        errorStack: errorStack,
        forcedError: forcedError,
        errorHash: errorHash,
        errorStatusCode: errorStatusCode
    });
}
function $48f592adf5dd6cf2$export$7379c15afd3840fa(name, labelStack, errorType, errorMessage, errorStack, errorHash, errorStatusCode) {
    (0, $kp8di.interactions).forEach((interaction)=>{
        interaction.errors.push({
            name: name,
            labelStack: labelStack,
            errorType: errorType,
            errorMessage: errorMessage,
            errorStack: errorStack,
            errorHash: errorHash,
            errorStatusCode: errorStatusCode
        });
    });
}
function $48f592adf5dd6cf2$export$53d6f611de951a13(interactionId, labelStack, type, actualDuration, baseDuration, startTime, commitTime) {
    if ($48f592adf5dd6cf2$var$isPerformanceTracingEnabled()) try {
        // for Firefox 102 and older
        performance.measure(`\u{1F6F8} ${$48f592adf5dd6cf2$var$labelStackToString(labelStack)} [react-profiler] ${type}`, {
            start: startTime,
            duration: actualDuration,
            detail: {
                devtools: {
                    track: "\uD83D\uDEF8 reactUFO detailed timings",
                    color: 'secondary-dark'
                }
            }
        });
    } catch  {
    // do nothing
    }
    const interaction = (0, $kp8di.interactions).get(interactionId);
    if (interaction != null) interaction.reactProfilerTimings.push({
        labelStack: labelStack,
        type: type,
        actualDuration: actualDuration,
        baseDuration: baseDuration,
        startTime: startTime,
        commitTime: commitTime
    });
    else if ((0, $dXdid.getConfig)()?.postInteractionLog?.enabled) $48f592adf5dd6cf2$export$d8f52e8f804021e8.addProfilerTimings(labelStack, type, actualDuration, baseDuration, startTime, commitTime);
}
function $48f592adf5dd6cf2$var$pushToQueue(id, data) {
    $48f592adf5dd6cf2$var$interactionQueue.push({
        id: id,
        data: data
    });
}
let $48f592adf5dd6cf2$var$handleInteraction = $48f592adf5dd6cf2$var$pushToQueue;
function $48f592adf5dd6cf2$var$callCleanUpCallbacks(interaction) {
    interaction.cleanupCallbacks.reverse().forEach((cleanUpCallback)=>{
        cleanUpCallback();
    });
}
function $48f592adf5dd6cf2$var$finishInteraction(id, data, endTime = performance.now()) {
    data.end = endTime;
    try {
        // for Firefox 102 and older
        performance.measure(`\u{1F6F8} [${data.type}] ${data.ufoName} [ttai]`, {
            start: data.start,
            end: data.end,
            detail: {
                devtools: {
                    track: 'main metrics',
                    trackGroup: "\uD83D\uDEF8 reactUFO metrics",
                    color: 'tertiary'
                }
            }
        });
        performance.mark(`TTAI`, {
            startTime: data.end,
            detail: {
                devtools: {
                    dataType: 'marker'
                }
            }
        });
    } catch  {
    // do nothing
    }
    if (data.featureFlags) data.featureFlags.during = Object.fromEntries((0, $dSjTj.currentFeatureFlagsAccessed));
    (0, $3EjrT.clearActiveTrace)();
    $48f592adf5dd6cf2$var$callCleanUpCallbacks(data);
    (0, $dD8QO.flushSsrRenderProfilerTraces)();
    if (data.type === 'page_load') data.hydration = (0, $dXdid.getReactHydrationStats)();
    // By this time, stop the post interaction log observer if coinflip rate is 0
    const sanitisedUfoName = (0, $2AagZ.sanitizeUfoName)(data.ufoName);
    if (!(0, $irOPS.default)((0, $dXdid.getPostInteractionRate)(sanitisedUfoName, data.type))) $48f592adf5dd6cf2$export$d8f52e8f804021e8.stopVCObserver();
    if (!(0, $irOPS.default)((0, $dXdid.getExtraInteractionRate)(sanitisedUfoName, data.type))) $48f592adf5dd6cf2$export$481f88116dc8b7ad.stopAll(id);
    else if (!data.hold3pActive || data.hold3pActive.size === 0) {
        if (!(0, $dXdid.getConfig)()?.experimentalInteractionMetrics?.enabled) $48f592adf5dd6cf2$export$cd7f480d6b8286c3(id);
    }
    if ((0, $3X3Vo.fg)('platform_ufo_enable_terminal_errors')) {
        $48f592adf5dd6cf2$export$dbba6cdedab4e68b.id = data.id;
        $48f592adf5dd6cf2$export$dbba6cdedab4e68b.type = data.type;
        $48f592adf5dd6cf2$export$dbba6cdedab4e68b.timestamp = data.end;
    }
    $48f592adf5dd6cf2$export$dbba6cdedab4e68b.name = data.ufoName || 'unknown';
    $48f592adf5dd6cf2$export$dbba6cdedab4e68b.isAborted = data.abortReason != null;
    if (data.ufoName) {
        if ($48f592adf5dd6cf2$export$481f88116dc8b7ad.finishedInteraction?.id !== id) // If this same interaction was not already handled, handle it
        $48f592adf5dd6cf2$var$handleInteraction(id, data);
    }
    if ($48f592adf5dd6cf2$var$isPerformanceTracingEnabled()) {
        const profilerTimingMap = new Map();
        data.reactProfilerTimings.forEach((profilerTiming)=>{
            const labelStackId = $48f592adf5dd6cf2$var$labelStackToIdString(profilerTiming.labelStack);
            if (labelStackId) {
                const timing = profilerTimingMap.get(labelStackId) ?? {
                    labelStack: profilerTiming.labelStack
                };
                timing.start = profilerTiming.startTime < (timing.start ?? Number.MAX_SAFE_INTEGER) ? profilerTiming.startTime : timing.start;
                timing.end = profilerTiming.commitTime > (timing.end ?? Number.MIN_SAFE_INTEGER) ? profilerTiming.commitTime : timing.end;
                profilerTimingMap.set(labelStackId, timing);
            }
        });
        try {
            // for Firefox 102 and older
            for (const [, { labelStack: labelStack, start: start, end: end }] of profilerTimingMap.entries())performance.measure(`\u{1F6F8} ${$48f592adf5dd6cf2$var$labelStackToString(labelStack)} [segment_ttai]`, {
                start: start,
                end: end,
                detail: {
                    devtools: {
                        track: "\uD83D\uDEF8 reactUFO detailed timings",
                        color: 'secondary-dark'
                    }
                }
            });
        } catch  {
        // do nothing
        }
    }
    try {
        // dispatch a global window event to notify the measure is completed
        window.dispatchEvent(new CustomEvent('UFO_FINISH_INTERACTION', {
            detail: data
        }));
    } catch  {
    // do nothing
    }
}
function $48f592adf5dd6cf2$export$9e614a29a1ac213e(sinkFn) {
    if ($48f592adf5dd6cf2$var$handleInteraction === $48f592adf5dd6cf2$var$pushToQueue) {
        $48f592adf5dd6cf2$var$handleInteraction = sinkFn;
        $48f592adf5dd6cf2$var$interactionQueue.forEach((interaction)=>{
            sinkFn(interaction.id, interaction.data);
        });
        $48f592adf5dd6cf2$var$interactionQueue.length = 0;
    }
}
function $48f592adf5dd6cf2$export$8a1ba7bef607358a(sinkFn) {
    $48f592adf5dd6cf2$export$d8f52e8f804021e8.sinkHandler(sinkFn);
}
// a flag to prevent multiple submitting
let $48f592adf5dd6cf2$var$activeSubmitted = false;
function $48f592adf5dd6cf2$export$673be905888f8839(interactionId, endTime) {
    const interaction = (0, $kp8di.interactions).get(interactionId);
    if (interaction != null) {
        const noMoreActiveHolds = interaction.holdActive.size === 0;
        const noMoreExpHolds = interaction.holdExpActive.size === 0;
        const shouldUseRawDataThirdParty = (0, $dXdid.shouldUseRawDataThirdPartyBehavior)(interaction.ufoName, interaction.type);
        const postInteraction = async ()=>{
            if ((0, $dXdid.getConfig)()?.postInteractionLog?.enabled) {
                let experimentalVC90;
                let experimentalTTAI;
                if ((0, $dXdid.getConfig)()?.experimentalInteractionMetrics?.enabled) {
                    experimentalVC90 = (await (0, $50omK.getExperimentalVCMetrics)(interaction))?.['metric:experimental:vc90'];
                    const { start: start, end: end } = interaction;
                    experimentalTTAI = !interaction.abortReason ? Math.round(end - start) : undefined;
                }
                $48f592adf5dd6cf2$export$d8f52e8f804021e8.onInteractionComplete({
                    ...interaction,
                    experimentalTTAI: experimentalTTAI,
                    experimentalVC90: experimentalVC90
                });
            }
            if ($48f592adf5dd6cf2$export$481f88116dc8b7ad.finishedInteraction?.id !== interactionId) // If interactionExtraMetrics is not waiting for measuring this interaction
            {
                if ((0, $dXdid.getConfig)()?.experimentalInteractionMetrics?.enabled) $48f592adf5dd6cf2$export$cd7f480d6b8286c3(interactionId);
            }
            $48f592adf5dd6cf2$var$activeSubmitted = false;
        };
        const noMoreActive3pHolds = interaction.hold3pActive?.size === 0 || interaction.hold3pActive === undefined;
        // If using raw data third party behavior, wait for 3p holds to clear
        if (shouldUseRawDataThirdParty) {
            // If there are no non-3p holds active, mark the interaction as successful
            // but don't finish until 3p holds are cleared
            if (noMoreActiveHolds && !noMoreActive3pHolds) {
                // Mark interaction as successful by setting endTime, but don't finish yet
                if (endTime !== undefined && interaction.end === 0) interaction.end = endTime;
                // Wait for 3p holds to clear before finishing
                return;
            }
            // If all holds (including 3p) are cleared, finish the interaction
            if (noMoreActiveHolds && noMoreActive3pHolds) {
                if (!$48f592adf5dd6cf2$var$activeSubmitted) {
                    // Set end3p to current time when 3p holds cleared, but ensure it's at least interaction.end
                    const currentTime = endTime ?? performance.now();
                    interaction.end3p = interaction.end !== 0 && currentTime < interaction.end ? interaction.end : currentTime;
                    $48f592adf5dd6cf2$var$finishInteraction(interactionId, interaction, interaction.end !== 0 ? interaction.end : endTime);
                    if ((0, $dXdid.getConfig)()?.extraInteractionMetrics?.enabled) $48f592adf5dd6cf2$export$481f88116dc8b7ad.updateFinishedInteraction(interaction);
                    if ((0, $dXdid.getConfig)()?.extraSearchPageInteraction?.enabled && interaction.ufoName === (0, $dXdid.getConfig)()?.extraSearchPageInteraction?.searchPageMetricName) (0, $9pXDa.onSearchPageInteractionComplete)(interactionId, interaction);
                    $48f592adf5dd6cf2$var$activeSubmitted = true;
                }
                if (noMoreExpHolds) {
                    if ((0, $dXdid.getConfig)()?.experimentalInteractionMetrics?.enabled) (0, $50omK.onExperimentalInteractionComplete)(interactionId, interaction, endTime || interaction.end);
                    postInteraction();
                }
            }
            // Send separated third-party event even when feature flag is active
            if (noMoreActiveHolds && noMoreActive3pHolds) {
                const data = {
                    ...interaction,
                    end: endTime || interaction.end
                };
                $48f592adf5dd6cf2$export$481f88116dc8b7ad.onInteractionComplete(interactionId, data);
            }
        } else {
            // Original behavior when feature flag is not active
            if (noMoreActiveHolds && $48f592adf5dd6cf2$export$481f88116dc8b7ad.finishedInteraction?.id !== interactionId) {
                // If it's not waiting for extra metrics to complete, finish the interaction as normal
                if (!$48f592adf5dd6cf2$var$activeSubmitted) {
                    $48f592adf5dd6cf2$var$finishInteraction(interactionId, interaction, endTime);
                    if ((0, $dXdid.getConfig)()?.extraInteractionMetrics?.enabled) $48f592adf5dd6cf2$export$481f88116dc8b7ad.updateFinishedInteraction(interaction);
                    if ((0, $dXdid.getConfig)()?.extraSearchPageInteraction?.enabled && interaction.ufoName === (0, $dXdid.getConfig)()?.extraSearchPageInteraction?.searchPageMetricName) (0, $9pXDa.onSearchPageInteractionComplete)(interactionId, interaction);
                    $48f592adf5dd6cf2$var$activeSubmitted = true;
                }
                if (noMoreExpHolds) {
                    if ((0, $dXdid.getConfig)()?.experimentalInteractionMetrics?.enabled) (0, $50omK.onExperimentalInteractionComplete)(interactionId, interaction, endTime);
                    postInteraction();
                }
            }
            if (noMoreActiveHolds && noMoreActive3pHolds) {
                const data = {
                    ...interaction,
                    end: endTime
                };
                $48f592adf5dd6cf2$export$481f88116dc8b7ad.onInteractionComplete(interactionId, data);
            }
        }
    }
}
function $48f592adf5dd6cf2$var$callCancelCallbacks(interaction) {
    interaction.cancelCallbacks.reverse().forEach((cancelCallback)=>{
        cancelCallback();
    });
}
function $48f592adf5dd6cf2$export$5def58af4fd46132(interactionId, abortReason) {
    const interaction = (0, $kp8di.interactions).get(interactionId);
    if (interaction != null) {
        const shouldUseRawDataThirdParty = (0, $dXdid.shouldUseRawDataThirdPartyBehavior)(interaction.ufoName, interaction.type);
        const noMoreActiveHolds = interaction.holdActive.size === 0;
        const has3pHoldsActive = interaction.hold3pActive && interaction.hold3pActive.size > 0;
        // If only third-party holds are active, finish as successful instead of aborting
        if (shouldUseRawDataThirdParty && noMoreActiveHolds && has3pHoldsActive) {
            const endTime = interaction.end !== 0 ? interaction.end : performance.now();
            interaction.end3p = performance.now();
            $48f592adf5dd6cf2$var$finishInteraction(interactionId, interaction, endTime);
            $48f592adf5dd6cf2$export$d8f52e8f804021e8.reset();
            $48f592adf5dd6cf2$export$d8f52e8f804021e8.stopVCObserver();
            $48f592adf5dd6cf2$export$481f88116dc8b7ad.stopAll(interactionId);
            if ((0, $irOPS.default)((0, $dXdid.getExperimentalInteractionRate)(interaction.ufoName, interaction.type))) {
                (0, $50omK.onExperimentalInteractionComplete)(interactionId, interaction, endTime);
                $48f592adf5dd6cf2$export$cd7f480d6b8286c3(interactionId);
            }
            return;
        }
        $48f592adf5dd6cf2$var$callCancelCallbacks(interaction);
        interaction.abortReason = abortReason;
        $48f592adf5dd6cf2$var$finishInteraction(interactionId, interaction);
        $48f592adf5dd6cf2$export$d8f52e8f804021e8.reset();
        $48f592adf5dd6cf2$export$d8f52e8f804021e8.stopVCObserver();
        $48f592adf5dd6cf2$export$481f88116dc8b7ad.stopAll(interactionId);
        if ((0, $irOPS.default)((0, $dXdid.getExperimentalInteractionRate)(interaction.ufoName, interaction.type))) {
            (0, $50omK.onExperimentalInteractionComplete)(interactionId, interaction);
            $48f592adf5dd6cf2$export$cd7f480d6b8286c3(interactionId);
        }
    }
}
function $48f592adf5dd6cf2$export$c4a545284f55edf2(interactionId, interactionName) {
    const interaction = (0, $kp8di.interactions).get(interactionId);
    if (interaction != null) {
        const shouldUseRawDataThirdParty = (0, $dXdid.shouldUseRawDataThirdPartyBehavior)(interaction.ufoName, interaction.type);
        const noMoreActiveHolds = interaction.holdActive.size === 0;
        const has3pHoldsActive = interaction.hold3pActive && interaction.hold3pActive.size > 0;
        // If only third-party holds are active, finish as successful instead of aborting
        if (shouldUseRawDataThirdParty && noMoreActiveHolds && has3pHoldsActive) {
            const endTime = interaction.end !== 0 ? interaction.end : performance.now();
            // Set end3p to current time, but ensure it's at least interaction.end
            interaction.end3p = performance.now();
            $48f592adf5dd6cf2$var$finishInteraction(interactionId, interaction, endTime);
            $48f592adf5dd6cf2$export$d8f52e8f804021e8.reset();
            $48f592adf5dd6cf2$export$d8f52e8f804021e8.stopVCObserver();
            $48f592adf5dd6cf2$export$481f88116dc8b7ad.stopAll(interactionId);
            if ((0, $irOPS.default)((0, $dXdid.getExperimentalInteractionRate)(interaction.ufoName, interaction.type))) {
                (0, $50omK.onExperimentalInteractionComplete)(interactionId, interaction, endTime);
                $48f592adf5dd6cf2$export$cd7f480d6b8286c3(interactionId);
            }
            return;
        }
        $48f592adf5dd6cf2$var$callCancelCallbacks(interaction);
        interaction.abortReason = 'new_interaction';
        interaction.abortedByInteractionName = interactionName;
        $48f592adf5dd6cf2$var$finishInteraction(interactionId, interaction);
        $48f592adf5dd6cf2$export$d8f52e8f804021e8.reset();
        $48f592adf5dd6cf2$export$d8f52e8f804021e8.stopVCObserver();
        $48f592adf5dd6cf2$export$481f88116dc8b7ad.stopAll(interactionId);
        if ((0, $irOPS.default)((0, $dXdid.getExperimentalInteractionRate)(interaction.ufoName, interaction.type))) {
            (0, $50omK.onExperimentalInteractionComplete)(interactionId, interaction);
            $48f592adf5dd6cf2$export$cd7f480d6b8286c3(interactionId);
        }
    } else if ((0, $3X3Vo.fg)('platform_reset_post_interaction_on_new_interaction')) {
        // post-interaction log is active after interaction is aborted by new one
        $48f592adf5dd6cf2$export$d8f52e8f804021e8.reset();
        $48f592adf5dd6cf2$export$d8f52e8f804021e8.stopVCObserver();
    }
}
function $48f592adf5dd6cf2$export$614a7af2affc5dff(abortReason, abortedByInteractionName) {
    const activeInteraction = $48f592adf5dd6cf2$export$2b3954d2e8509985();
    const finishInteractions = (0, $dXdid.getFinishInteractionOnTransition)();
    (0, $kp8di.interactions).forEach((interaction, interactionId)=>{
        const isActiveInteraction = activeInteraction === interaction;
        let hasFinished = interaction.holdActive.size === 0;
        if (isActiveInteraction && abortReason === 'transition' && interaction.type === 'press' && finishInteractions?.includes(interaction.ufoName)) hasFinished = true;
        const shouldUseRawDataThirdParty = (0, $dXdid.shouldUseRawDataThirdPartyBehavior)(interaction.ufoName, interaction.type);
        const noMoreActiveHolds = interaction.holdActive.size === 0;
        const has3pHoldsActive = interaction.hold3pActive && interaction.hold3pActive.size > 0;
        // If only third-party holds are active, finish as successful instead of aborting
        if (shouldUseRawDataThirdParty && noMoreActiveHolds && has3pHoldsActive) {
            const endTime = interaction.end !== 0 ? interaction.end : performance.now();
            interaction.end3p = performance.now();
            $48f592adf5dd6cf2$var$finishInteraction(interactionId, interaction, endTime);
            $48f592adf5dd6cf2$export$d8f52e8f804021e8.reset();
            $48f592adf5dd6cf2$export$d8f52e8f804021e8.stopVCObserver();
            $48f592adf5dd6cf2$export$481f88116dc8b7ad.stopAll(interactionId);
            if ((0, $irOPS.default)((0, $dXdid.getExperimentalInteractionRate)(interaction.ufoName, interaction.type))) {
                (0, $50omK.onExperimentalInteractionComplete)(interactionId, interaction, endTime);
                $48f592adf5dd6cf2$export$cd7f480d6b8286c3(interactionId);
            }
            return;
        }
        if (!hasFinished) {
            $48f592adf5dd6cf2$var$callCancelCallbacks(interaction);
            interaction.abortReason = abortReason;
            if (abortedByInteractionName != null) interaction.abortedByInteractionName = abortedByInteractionName;
        }
        $48f592adf5dd6cf2$var$finishInteraction(interactionId, interaction);
        $48f592adf5dd6cf2$export$d8f52e8f804021e8.reset();
        $48f592adf5dd6cf2$export$d8f52e8f804021e8.stopVCObserver();
        $48f592adf5dd6cf2$export$481f88116dc8b7ad.stopAll(interactionId);
        if ((0, $irOPS.default)((0, $dXdid.getExperimentalInteractionRate)(interaction.ufoName, interaction.type))) {
            (0, $50omK.onExperimentalInteractionComplete)(interactionId, interaction);
            $48f592adf5dd6cf2$export$cd7f480d6b8286c3(interactionId);
        }
    });
}
function $48f592adf5dd6cf2$export$7b9261a96cfe427b(id, cancelCallback) {
    const interaction = (0, $kp8di.interactions).get(id);
    interaction?.cancelCallbacks.push(cancelCallback);
}
function $48f592adf5dd6cf2$export$1a1ed1e1fdb2006b(interactionId, ufoName, type, startTime, rate, labelStack, routeName, trace = null) {
    $48f592adf5dd6cf2$export$481f88116dc8b7ad.reset();
    $48f592adf5dd6cf2$export$d8f52e8f804021e8.reset();
    let vcObserver;
    let previousTime = startTime;
    let timeoutTime = (0, $dXdid.getInteractionTimeout)(ufoName);
    const timerID = setTimeout(()=>{
        $48f592adf5dd6cf2$export$5def58af4fd46132(interactionId, 'timeout');
    }, timeoutTime);
    function changeTimeout(newTime) {
        // we compare if the time left is lower than the new time to no
        // extend the timeout beyond the initial waiting time
        const currentTime = performance.now();
        const timeLeft = timeoutTime - (currentTime - previousTime);
        if (timeLeft < newTime) return;
        clearTimeout(this.timerID);
        const newTimerID = setTimeout(()=>{
            $48f592adf5dd6cf2$export$5def58af4fd46132(interactionId, 'timeout');
        }, newTime);
        timeoutTime = newTime;
        previousTime = currentTime;
        this.timerID = newTimerID;
    }
    const addFeatureFlagsToInteraction = (0, $irOPS.default)((0, $dXdid.getCapabilityRate)('feature_flag_access'));
    const config = (0, $dXdid.getConfig)();
    const searchPageConfig = {
        enableSmartAnswersMutations: config?.extraSearchPageInteraction?.enabled,
        searchPageRoute: config?.extraSearchPageInteraction?.searchPageRoute
    };
    if (config && config.vc) {
        const vcOptions = {
            heatmapSize: config.vc.heatmapSize,
            oldDomUpdates: config.vc.oldDomUpdates,
            devToolsEnabled: config.vc.devToolsEnabled,
            // Use centralised getter so the FedRAMP override (forces every
            // selector field to false) is applied consistently.
            selectorConfig: (0, $dXdid.getSelectorConfig)(),
            ssrEnablePageLayoutPlaceholder: config.vc.ssrEnablePageLayoutPlaceholder,
            trackLayoutShiftOffenders: config.vc.trackLayoutShiftOffenders,
            searchPageConfig: searchPageConfig
        };
        vcObserver = (0, $9oQne.newVCObserver)(vcOptions);
    }
    const priorAccessedFg = type === 'press' && (0, $3X3Vo.fg)('platform_ufo_drop_prior_fg_interactions') ? {} : Object.fromEntries((0, $dSjTj.allFeatureFlagsAccessed));
    const metrics = {
        id: interactionId,
        start: startTime,
        end: 0,
        ufoName: ufoName,
        type: type,
        previousInteractionName: $48f592adf5dd6cf2$export$dbba6cdedab4e68b.name,
        isPreviousInteractionAborted: $48f592adf5dd6cf2$export$dbba6cdedab4e68b.isAborted === true,
        marks: [],
        customData: [],
        cohortingCustomData: new Map(),
        customTimings: [],
        spans: [],
        requestInfo: [],
        reactProfilerTimings: [],
        holdInfo: [],
        holdExpInfo: [],
        holdActive: new Map(),
        holdExpActive: new Map(),
        // measure when we execute this code
        // from this, we can measure the input delay -
        // how long the browser took to hand execution back to JS)
        measureStart: performance.now(),
        rate: rate,
        cancelCallbacks: [],
        metaData: {},
        errors: [],
        apdex: [],
        labelStack: labelStack,
        routeName: routeName ?? ufoName,
        featureFlags: addFeatureFlagsToInteraction ? {
            prior: priorAccessedFg,
            during: {}
        } : undefined,
        knownSegments: [],
        cleanupCallbacks: [],
        awaitReactProfilerCount: 0,
        redirects: [],
        timerID: timerID,
        changeTimeout: changeTimeout,
        trace: trace,
        vcObserver: vcObserver,
        hold3pActive: new Map(),
        hold3pInfo: [],
        minorInteractions: []
    };
    if (addFeatureFlagsToInteraction) (0, $dSjTj.currentFeatureFlagsAccessed).clear();
    (0, $kp8di.interactions).set(interactionId, metrics);
    const segmentObserver = {
        onAdd (segment) {
            metrics.knownSegments.push(segment);
        },
        onRemove () {}
    };
    $48f592adf5dd6cf2$var$addSegmentObserver(segmentObserver);
    metrics.cleanupCallbacks.push(()=>{
        $48f592adf5dd6cf2$var$removeSegmentObserver(segmentObserver);
    });
    metrics.cleanupCallbacks.push(()=>{
        clearTimeout(metrics.timerID);
    });
    // Add cleanup for per-interaction VC observer
    if (vcObserver) metrics.cleanupCallbacks.push(()=>{
        vcObserver.stop(ufoName);
    });
    const awaitBM3TTIList = (0, $dXdid.getAwaitBM3TTIList)();
    if (awaitBM3TTIList.includes(ufoName)) $48f592adf5dd6cf2$export$10582acd678c213(interactionId, [], ufoName, ufoName, true);
    if (type === 'transition' || type === 'page_load') {
        // Use per-interaction VC observer if available, otherwise fall back to global
        const observer = vcObserver;
        if (observer) observer.start({
            startTime: startTime,
            experienceKey: ufoName
        });
        // Start post interaction observer for all if config is enabled
        // in case ufoName is updated at later time
        if ((0, $dXdid.getConfig)()?.postInteractionLog?.enabled) $48f592adf5dd6cf2$export$d8f52e8f804021e8.startVCObserver({
            startTime: startTime
        });
        if ((0, $irOPS.default)((0, $dXdid.getExperimentalInteractionRate)(ufoName, type))) (0, $50omK.experimentalVC).start({
            startTime: startTime
        });
        if (config?.extraInteractionMetrics?.enabled) $48f592adf5dd6cf2$export$481f88116dc8b7ad.startVCObserver({
            startTime: startTime
        }, interactionId);
    }
    if (type === 'press') {
        // Use per-interaction VC observer if available, otherwise fall back to global
        const observer = vcObserver;
        if (observer) observer.start({
            startTime: startTime,
            experienceKey: ufoName
        });
    }
}
function $48f592adf5dd6cf2$export$4a759336b50e86e3(event) {
    const interaction = $48f592adf5dd6cf2$export$2b3954d2e8509985();
    if (interaction) {
        interaction.legacyMetrics = interaction.legacyMetrics || [];
        interaction.legacyMetrics.push(event);
        if ((interaction.type === 'page_load' || interaction.type === 'transition') && event.config?.type === 'PAGE_LOAD') $48f592adf5dd6cf2$export$4983dfbbb996f7ae(interaction.id, interaction.ufoName);
    }
}
function $48f592adf5dd6cf2$export$ad216cc25852d44b(apdex) {
    (0, $kp8di.interactions).forEach((interaction, key)=>{
        interaction.apdex.push(apdex);
        try {
            // for Firefox 102 and older
            performance.measure(`\u{1F6F8} ${apdex.key} [bm3_tti]`, {
                start: apdex.startTime ?? interaction.start,
                end: apdex.stopTime,
                detail: {
                    devtools: {
                        track: 'main metrics',
                        trackGroup: "\uD83D\uDEF8 reactUFO metrics",
                        color: 'primary-dark'
                    }
                }
            });
            performance.mark(`[bm3] TTI`, {
                startTime: apdex.stopTime,
                detail: {
                    devtools: {
                        dataType: 'marker'
                    }
                }
            });
        } catch  {
        // do nothing
        }
        if (interaction.type === 'page_load' || interaction.type === 'transition') $48f592adf5dd6cf2$export$4983dfbbb996f7ae(key, interaction.ufoName);
    });
}
function $48f592adf5dd6cf2$export$35220fd6cdd1b731(interactionId, apdexInfo) {
    const interaction = (0, $kp8di.interactions).get(interactionId);
    if (interaction != null) {
        interaction.apdex.push(apdexInfo);
        try {
            // for Firefox 102 and older
            performance.measure(`\u{1F6F8} ${apdexInfo.key} [bm3_tti]`, {
                start: apdexInfo.startTime ?? interaction.start,
                end: apdexInfo.stopTime,
                detail: {
                    devtools: {
                        track: 'main metrics',
                        trackGroup: "\uD83D\uDEF8 reactUFO metrics",
                        color: 'primary-dark'
                    }
                }
            });
            performance.mark(`[bm3] TTI`, {
                startTime: apdexInfo.stopTime,
                detail: {
                    devtools: {
                        dataType: 'marker'
                    }
                }
            });
        } catch  {
        // do nothing
        }
        if (interaction.type === 'page_load' || interaction.type === 'transition') $48f592adf5dd6cf2$export$4983dfbbb996f7ae(interactionId, interaction.ufoName);
    }
}
function $48f592adf5dd6cf2$export$57d55b4569823d8f(interactionId, labelStack, requestInfo) {
    const interaction = (0, $kp8di.interactions).get(interactionId);
    if (interaction != null) interaction.requestInfo.push({
        labelStack: labelStack,
        ...requestInfo
    });
}
function $48f592adf5dd6cf2$var$isSegmentLabel(obj) {
    return obj && typeof obj.name === 'string' && typeof obj.segmentId === 'string';
}
function $48f592adf5dd6cf2$var$getSegmentCacheKey(labelStack) {
    return labelStack.map((l)=>{
        if ($48f592adf5dd6cf2$var$isSegmentLabel(l)) return `${l.name}_${l.segmentId}`;
        return l.name;
    }).join('|');
}
function $48f592adf5dd6cf2$export$1c43f9ac826b6462(labelStack) {
    const key = $48f592adf5dd6cf2$var$getSegmentCacheKey(labelStack);
    const existingSegment = $48f592adf5dd6cf2$var$segmentCache.get(key);
    if (!existingSegment) {
        const segmentInfo = {
            labelStack: labelStack
        };
        $48f592adf5dd6cf2$var$segmentCache.set(key, segmentInfo);
        $48f592adf5dd6cf2$var$segmentObservers.forEach((observer)=>{
            observer.onAdd(segmentInfo);
        });
    }
}
function $48f592adf5dd6cf2$export$d0365e48b58231c3(labelStack) {
    const key = $48f592adf5dd6cf2$var$getSegmentCacheKey(labelStack);
    const segmentInfo = $48f592adf5dd6cf2$var$segmentCache.get(key);
    if (segmentInfo) {
        $48f592adf5dd6cf2$var$segmentCache.delete(JSON.stringify(labelStack));
        const cacheKey = (0, $2AagZ.stringifyLabelStackFully)(labelStack);
        $48f592adf5dd6cf2$export$a2b14406ded37d60.set(cacheKey, ($48f592adf5dd6cf2$export$a2b14406ded37d60.get(cacheKey) || 0) + 1);
        $48f592adf5dd6cf2$var$segmentObservers.forEach((observer)=>{
            observer.onRemove(segmentInfo);
        });
    }
}
function $48f592adf5dd6cf2$export$bbf14d79614d9818(interactionId, fromUfoName, nextUfoName, nextRouteName, time) {
    const interaction = (0, $kp8di.interactions).get(interactionId);
    if (interaction != null) {
        interaction.ufoName = nextUfoName;
        interaction.routeName = nextRouteName;
        interaction.redirects.push({
            fromInteractionName: fromUfoName,
            time: time
        });
        if ($48f592adf5dd6cf2$var$isPerformanceTracingEnabled()) {
            const prevRedirect = interaction.redirects.at(-2);
            try {
                // for Firefox 102 and older
                performance.measure(`\u{1F6F8} ${nextUfoName} [redirect]`, {
                    start: prevRedirect?.time ?? interaction.start,
                    end: time,
                    detail: {
                        devtools: {
                            track: "\uD83D\uDEF8 reactUFO detailed timings",
                            color: 'tertiary'
                        }
                    }
                });
            } catch  {
            // do nothing
            }
        }
    }
}
const $48f592adf5dd6cf2$export$6ce04c7ca6810a7e = [];
const $48f592adf5dd6cf2$var$defaultLabelStack = [
    {
        name: 'custom'
    }
];
function $48f592adf5dd6cf2$export$5342dcad19138a1c(name, start, end = performance.now(), size = 0, labelStack = $48f592adf5dd6cf2$var$defaultLabelStack) {
    const customSpan = {
        type: 'custom',
        name: name,
        start: start,
        end: end,
        labelStack: labelStack,
        size: size
    };
    $48f592adf5dd6cf2$export$6ce04c7ca6810a7e.push(customSpan);
}

});
parcelRegister("40SCs", function(module, exports) {

var $8eget = parcelRequire("8eget");

var $ec2KI = parcelRequire("ec2KI");
var $2ec187be14ae4eb1$var$uuid = $ec2KI;
$2ec187be14ae4eb1$var$uuid.v1 = $8eget;
$2ec187be14ae4eb1$var$uuid.v4 = $ec2KI;
module.exports = $2ec187be14ae4eb1$var$uuid;

});
parcelRegister("8eget", function(module, exports) {

var $1Bne6 = parcelRequire("1Bne6");

var $bOisJ = parcelRequire("bOisJ");
// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var $5fdc38f069ad1302$var$_nodeId;
var $5fdc38f069ad1302$var$_clockseq;
// Previous uuid creation time
var $5fdc38f069ad1302$var$_lastMSecs = 0;
var $5fdc38f069ad1302$var$_lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function $5fdc38f069ad1302$var$v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || $5fdc38f069ad1302$var$_nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : $5fdc38f069ad1302$var$_clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = $1Bne6();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = $5fdc38f069ad1302$var$_nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = $5fdc38f069ad1302$var$_clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : $5fdc38f069ad1302$var$_lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - $5fdc38f069ad1302$var$_lastMSecs + (nsecs - $5fdc38f069ad1302$var$_lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > $5fdc38f069ad1302$var$_lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
    $5fdc38f069ad1302$var$_lastMSecs = msecs;
    $5fdc38f069ad1302$var$_lastNSecs = nsecs;
    $5fdc38f069ad1302$var$_clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : $bOisJ(b);
}
module.exports = $5fdc38f069ad1302$var$v1;

});
parcelRegister("1Bne6", function(module, exports) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $12ab436dfdef8c79$var$getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);
if ($12ab436dfdef8c79$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $12ab436dfdef8c79$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    module.exports = function whatwgRNG() {
        $12ab436dfdef8c79$var$getRandomValues($12ab436dfdef8c79$var$rnds8);
        return $12ab436dfdef8c79$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $12ab436dfdef8c79$var$rnds = new Array(16);
    module.exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $12ab436dfdef8c79$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $12ab436dfdef8c79$var$rnds;
    };
}

});

parcelRegister("bOisJ", function(module, exports) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $8992af785da41afa$var$byteToHex = [];
for(var $8992af785da41afa$var$i = 0; $8992af785da41afa$var$i < 256; ++$8992af785da41afa$var$i)$8992af785da41afa$var$byteToHex[$8992af785da41afa$var$i] = ($8992af785da41afa$var$i + 0x100).toString(16).substr(1);
function $8992af785da41afa$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $8992af785da41afa$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join('');
}
module.exports = $8992af785da41afa$var$bytesToUuid;

});


parcelRegister("ec2KI", function(module, exports) {

var $1Bne6 = parcelRequire("1Bne6");

var $bOisJ = parcelRequire("bOisJ");
function $a554523f004ab827$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == 'string') {
        buf = options === 'binary' ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $1Bne6)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $bOisJ(rnds);
}
module.exports = $a554523f004ab827$var$v4;

});


parcelRegister("irOPS", function(module, exports) {
$parcel$export(module.exports, "default", () => $a9d3161ba8e8de36$export$2e2bcd8739ae039);
/**
 * A random function that passes one in rate times.
 * E.g. coinflip(2) is the same as if you flipped a coin.
 * It will pass 50% of the time
 * @param rate The change that it will pass (1 in <rate> times)
 * @returns bool, if it passes or not
 */ function $a9d3161ba8e8de36$var$coinflip(rate) {
    if (rate === 0) return false;
    else if (rate === 1) return true;
    else return Math.random() * rate <= 1;
}
var $a9d3161ba8e8de36$export$2e2bcd8739ae039 = $a9d3161ba8e8de36$var$coinflip;

});

parcelRegister("d6EUi", function(module, exports) {
$parcel$export(module.exports, "sanitizeTimingName", () => $687340f4b9a76dc1$export$23e69abaca7d0236);
const $687340f4b9a76dc1$export$4c07c8a3507ce307 = 255;
function $687340f4b9a76dc1$export$23e69abaca7d0236(name) {
    if (name.length <= $687340f4b9a76dc1$export$4c07c8a3507ce307) return name;
    return name.slice(0, $687340f4b9a76dc1$export$4c07c8a3507ce307);
}

});

parcelRegister("9pXDa", function(module, exports) {
$parcel$export(module.exports, "sinkExtraSearchPageInteractionHandler", () => $610603f8acfb8568$export$e6a07a94f3e112d4);
$parcel$export(module.exports, "onSearchPageInteractionComplete", () => $610603f8acfb8568$export$74b9ce7e9d206a8);
const $610603f8acfb8568$var$interactionBuffer = [];
let $610603f8acfb8568$var$bufferInteractionData = (interactionId, data)=>{
    $610603f8acfb8568$var$interactionBuffer.push({
        interactionId: interactionId,
        data: data
    });
};
function $610603f8acfb8568$var$clearInteractionBuffer() {
    $610603f8acfb8568$var$interactionBuffer.length = 0;
}
function $610603f8acfb8568$var$appendInteractionData(interactionId, data) {
    $610603f8acfb8568$var$bufferInteractionData(interactionId, data);
}
function $610603f8acfb8568$var$installInteractionSink(handler) {
    for (const { interactionId: interactionId, data: data } of $610603f8acfb8568$var$interactionBuffer)handler(interactionId, data);
    $610603f8acfb8568$var$clearInteractionBuffer();
    $610603f8acfb8568$var$bufferInteractionData = handler;
}
function $610603f8acfb8568$export$e6a07a94f3e112d4(sinkFn) {
    $610603f8acfb8568$var$installInteractionSink(sinkFn);
}
function $610603f8acfb8568$export$74b9ce7e9d206a8(interactionId, data) {
    if (data.ufoName) {
        $610603f8acfb8568$var$appendInteractionData(interactionId, data);
        $610603f8acfb8568$var$clearInteractionBuffer();
    }
}

});

parcelRegister("2AagZ", function(module, exports) {
$parcel$export(module.exports, "sanitizeUfoName", () => $6fdb6c2300488d36$export$e08487ea3ae92adb);
$parcel$export(module.exports, "isSegmentLabel", () => $6fdb6c2300488d36$export$1adbaf5c2363e4ae);
$parcel$export(module.exports, "buildSegmentTree", () => $6fdb6c2300488d36$export$1569bc0edeecbcd8);
$parcel$export(module.exports, "stringifyLabelStackFully", () => $6fdb6c2300488d36$export$caeee352b541de1f);
$parcel$export(module.exports, "labelStackStartWith", () => $6fdb6c2300488d36$export$1787b1cd413c7e2);
$parcel$export(module.exports, "optimizeLabelStack", () => $6fdb6c2300488d36$export$a0cd72da07c76b4c);
$parcel$export(module.exports, "optimizeLabelStackWithRegistry", () => $6fdb6c2300488d36$export$cb3145456a04e238);
$parcel$export(module.exports, "getOldSegmentsLabelStack", () => $6fdb6c2300488d36$export$b70bcfd92c93435e);

var $dXdid = parcelRequire("dXdid");
function $6fdb6c2300488d36$export$e08487ea3ae92adb(name) {
    return name.replace(/_/g, '-');
}
function $6fdb6c2300488d36$export$1adbaf5c2363e4ae(obj) {
    return obj && typeof obj.name === 'string' && typeof obj.segmentId === 'string';
}
function $6fdb6c2300488d36$export$1569bc0edeecbcd8(labelStacks) {
    const r = {
        n: 'segment-tree-root',
        c: {}
    };
    const config = (0, $dXdid.getConfig)();
    const segmentThreshold = config?.segmentsThreshold;
    const addSegmentsMap = new Map();
    labelStacks.forEach((labelStack)=>{
        const stringifiedLabelStack = $6fdb6c2300488d36$export$88f21baa687271f4(labelStack);
        let currentNode = r;
        for (const label of labelStack){
            const isSegment = $6fdb6c2300488d36$export$1adbaf5c2363e4ae(label);
            const name = label.name;
            if (isSegment && segmentThreshold && segmentThreshold[name]) {
                const threshold = segmentThreshold[name];
                const count = addSegmentsMap.get(stringifiedLabelStack) || 0;
                if (count < threshold) addSegmentsMap.set(stringifiedLabelStack, count + 1);
                else break;
            }
            const id = isSegment ? label.segmentId : undefined;
            const key = id !== undefined ? id : name;
            const type = isSegment ? label.type : undefined;
            if (!currentNode.c) currentNode.c = {};
            if (!currentNode.c[key]) currentNode.c[key] = {
                n: name,
                ...type ? {
                    t: type
                } : {}
            };
            currentNode = currentNode.c[key];
        }
    });
    return {
        r: r
    };
}
function $6fdb6c2300488d36$export$caeee352b541de1f(labelStack) {
    return labelStack.map((l)=>{
        if ($6fdb6c2300488d36$export$1adbaf5c2363e4ae(l)) return `${l.name}:${l.segmentId}`;
        return l.name;
    }).join('/');
}
function $6fdb6c2300488d36$export$88f21baa687271f4(labelStack) {
    return labelStack.map((l)=>{
        if ($6fdb6c2300488d36$export$1adbaf5c2363e4ae(l)) return `${l.name}:segment`;
        return l.name;
    }).join('/');
}
function $6fdb6c2300488d36$var$getLabelStackReference(labelStack) {
    return labelStack.map((l)=>$6fdb6c2300488d36$export$1adbaf5c2363e4ae(l) ? l.segmentId : l.name).join('/');
}
function $6fdb6c2300488d36$export$1787b1cd413c7e2(labelStack, startWith) {
    return $6fdb6c2300488d36$export$caeee352b541de1f(labelStack).startsWith($6fdb6c2300488d36$export$caeee352b541de1f(startWith));
}
function $6fdb6c2300488d36$export$a0cd72da07c76b4c(labelStack, reactUFOVersion) {
    return reactUFOVersion === '2.0.0' ? $6fdb6c2300488d36$var$getLabelStackReference(labelStack) : labelStack.map((ls)=>({
            n: ls.name,
            ...ls.segmentId ? {
                s: ls.segmentId
            } : {},
            ...ls.type ? {
                t: ls.type
            } : {}
        }));
}
function $6fdb6c2300488d36$export$cb3145456a04e238(labelStack, reactUFOVersion, registry) {
    if (registry && reactUFOVersion === '2.0.0') {
        const ref = $6fdb6c2300488d36$var$getLabelStackReference(labelStack);
        return registry.register(ref);
    }
    return $6fdb6c2300488d36$export$a0cd72da07c76b4c(labelStack, reactUFOVersion);
}
function $6fdb6c2300488d36$export$b70bcfd92c93435e(segments, _interactionType) {
    const config = (0, $dXdid.getConfig)();
    const addSegmentsMap = new Map();
    const segmentThreshold = config?.segmentsThreshold;
    return segments.map(({ labelStack: labelStack, ...others })=>{
        const stringifiedLabelStack = $6fdb6c2300488d36$export$88f21baa687271f4(labelStack);
        const segmentsInfo = [];
        for (const ls of labelStack){
            const isSegment = $6fdb6c2300488d36$export$1adbaf5c2363e4ae(ls);
            if (isSegment && segmentThreshold && segmentThreshold[ls.name]) {
                const threshold = segmentThreshold[ls.name];
                const count = addSegmentsMap.get(stringifiedLabelStack) || 0;
                if (count < threshold) addSegmentsMap.set(stringifiedLabelStack, count + 1);
                else break;
            }
            segmentsInfo.push({
                n: ls.name,
                ...ls.segmentId ? {
                    s: ls.segmentId
                } : {},
                ...ls.type ? {
                    t: ls.type
                } : {}
            });
        }
        return {
            ...others,
            labelStack: segmentsInfo
        };
    });
}

});

parcelRegister("3EjrT", function(module, exports) {
$parcel$export(module.exports, "setInteractionActiveTrace", () => $0e3bd38059236671$export$f2e521e495a88544);
$parcel$export(module.exports, "setActiveTrace", () => $0e3bd38059236671$export$a1002be327997103);
$parcel$export(module.exports, "getActiveTrace", () => $0e3bd38059236671$export$b6ac780db3a3cc77);
$parcel$export(module.exports, "clearActiveTrace", () => $0e3bd38059236671$export$17ab21d7be720b);
$parcel$export(module.exports, "getActiveTraceHttpRequestHeaders", () => $0e3bd38059236671$export$6e17cce6446848f9);

var $1IBIv = parcelRequire("1IBIv");
var $S8N63 = parcelRequire("S8N63");

var $3X3Vo = parcelRequire("3X3Vo");

var $i2PYg = parcelRequire("i2PYg");

var $9wrzK = parcelRequire("9wrzK");
const $0e3bd38059236671$var$state = {
    context: null
};
const $0e3bd38059236671$var$traceIdKey = (0, $S8N63.createContextKey)('traceId');
const $0e3bd38059236671$var$spanIdKey = (0, $S8N63.createContextKey)('spanId');
const $0e3bd38059236671$var$experienceTypeKey = (0, $S8N63.createContextKey)('type');
function $0e3bd38059236671$export$295213bc4d0c54ad() {
    return Array.from(new Array(16), ()=>Math.floor(Math.random() * 16).toString(16)).join('');
}
function $0e3bd38059236671$export$f2e521e495a88544(interactionId, experienceType) {
    $0e3bd38059236671$export$a1002be327997103(interactionId.replace(/-/g, ''), $0e3bd38059236671$export$295213bc4d0c54ad(), experienceType);
}
function $0e3bd38059236671$export$a1002be327997103(traceId, spanId, type) {
    if ((0, $3X3Vo.fg)('platform_ufo_enable_otel_context_manager')) {
        const activeTraceContext = (0, $S8N63.ROOT_CONTEXT).setValue($0e3bd38059236671$var$traceIdKey, traceId).setValue($0e3bd38059236671$var$spanIdKey, spanId).setValue($0e3bd38059236671$var$experienceTypeKey, type);
        // Now we need to get the global Context Manager and set the active context
        // Using type assertion because we've "extended" the ContextManager type
        if ((0, $i2PYg.getContextManager)() instanceof (0, $i2PYg.UFOContextManager)) {
            let contextManager = (0, $i2PYg.getContextManager)();
            contextManager.setActive(activeTraceContext);
        }
    } else $0e3bd38059236671$var$state.context = {
        traceId: traceId,
        spanId: spanId,
        type: type
    };
}
function $0e3bd38059236671$export$b6ac780db3a3cc77() {
    if ((0, $3X3Vo.fg)('platform_ufo_enable_otel_context_manager')) {
        // Get trace context from active context
        const activeTraceContext = {
            traceId: String((0, $1IBIv.context).active().getValue($0e3bd38059236671$var$traceIdKey)),
            spanId: String((0, $1IBIv.context).active().getValue($0e3bd38059236671$var$spanIdKey)),
            type: String((0, $1IBIv.context).active().getValue($0e3bd38059236671$var$experienceTypeKey))
        };
        // Return activeTraceContext if traceId and spanId are not "undefined"
        return activeTraceContext.traceId !== 'undefined' && activeTraceContext.spanId !== 'undefined' ? activeTraceContext : undefined;
    } else return $0e3bd38059236671$var$state.context || undefined;
}
function $0e3bd38059236671$export$17ab21d7be720b() {
    if ((0, $3X3Vo.fg)('platform_ufo_enable_otel_context_manager')) // Now we need to get the global Context Manager and set the active context
    // Using type assertion because we've "extended" the ContextManager type
    {
        if ((0, $i2PYg.getContextManager)() instanceof (0, $i2PYg.UFOContextManager)) {
            let contextManager = (0, $i2PYg.getContextManager)();
            // ROOT_CONTEXT is an empty context used to initialise ContextManagers
            contextManager.setActive((0, $S8N63.ROOT_CONTEXT));
        }
    } else $0e3bd38059236671$var$state.context = null;
}
function $0e3bd38059236671$export$6e17cce6446848f9(_url) {
    if ($0e3bd38059236671$export$b6ac780db3a3cc77() === undefined) return null;
    const { traceId: traceId, spanId: spanId } = $0e3bd38059236671$export$b6ac780db3a3cc77();
    return (0, $9wrzK.makeTraceHttpRequestHeaders)(traceId, spanId);
}
function $0e3bd38059236671$export$a1e7396778592551(_url) {
    const traceHeaders = $0e3bd38059236671$export$6e17cce6446848f9();
    return traceHeaders ? new URLSearchParams(traceHeaders).toString().toLowerCase() : null;
}

});
parcelRegister("i2PYg", function(module, exports) {
$parcel$export(module.exports, "setContextManager", () => $66f90c1a1c8f4c2c$export$4a00ab8a5dd9b5cf);
$parcel$export(module.exports, "getContextManager", () => $66f90c1a1c8f4c2c$export$831109c9f7727010);
$parcel$export(module.exports, "UFOContextManager", () => $66f90c1a1c8f4c2c$export$dd301b96c16f583d);

var $S8N63 = parcelRequire("S8N63");
/**
 * We need to store a reference to the Context manager so that we can get it later.
 * This is because the OTel JS API doesn't allow us to get the registered context manager,
 * and we need to get it because we need to call a function that's not available in the OTel API:
 * `setActive`. The OTel JS API design doesn't allow us to manually set the active context
 * despite the spec allowing for the capability. Sigh.
 *
 * I imagine this situation might not be permanent if we can move to a system were we can rely
 * solely on the API, but for the purposes of the first change being React UFO API compatible,
 * we'll need to do this.
 */ let $66f90c1a1c8f4c2c$var$contextManager;
function $66f90c1a1c8f4c2c$export$4a00ab8a5dd9b5cf(ctxMgr) {
    $66f90c1a1c8f4c2c$var$contextManager = ctxMgr;
}
function $66f90c1a1c8f4c2c$export$831109c9f7727010() {
    return $66f90c1a1c8f4c2c$var$contextManager;
}
class $66f90c1a1c8f4c2c$export$dd301b96c16f583d {
    /**
   *
   * @param context
   * @param target Function to be executed within the context
   */ // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
    _bindFunction(context = (0, $S8N63.ROOT_CONTEXT), target) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const manager = this;
        const contextWrapper = function(...args) {
            return manager.with(context, ()=>target.apply(this, args));
        };
        Object.defineProperty(contextWrapper, 'length', {
            enumerable: false,
            configurable: true,
            writable: false,
            value: target.length
        });
        return contextWrapper;
    }
    /**
   * Returns the active context
   */ active() {
        return this._currentContext;
    }
    /**
   * Binds a the certain context or the active one to the target function and then returns the target
   * @param context A context (span) to be bind to target
   * @param target a function or event emitter. When target or one of its callbacks is called,
   *  the provided context will be used as the active context for the duration of the call.
   */ bind(context, target) {
        // if no specific context to propagate is given, we use the current one
        if (context === undefined) context = this.active();
        if (typeof target === 'function') return this._bindFunction(context, target);
        return target;
    }
    /**
   * Disable the context manager (clears the current context)
   */ disable() {
        this._currentContext = (0, $S8N63.ROOT_CONTEXT);
        this._enabled = false;
        return this;
    }
    /**
   * Enables the context manager and creates a default(root) context
   */ enable() {
        if (this._enabled) return this;
        this._enabled = true;
        this._currentContext = (0, $S8N63.ROOT_CONTEXT);
        return this;
    }
    /**
   * Calls the callback function [fn] with the provided [context]. If [context] is undefined then it will use the window.
   * The context will be set as active
   * @param context
   * @param fn Callback function
   * @param thisArg optional receiver to be used for calling fn
   * @param args optional arguments forwarded to fn
   */ with(context, fn, thisArg, ...args) {
        const previousContext = this._currentContext;
        this._currentContext = context || (0, $S8N63.ROOT_CONTEXT);
        try {
            return fn.call(thisArg, ...args);
        } finally{
            this._currentContext = previousContext;
        }
    }
    /**
   * Sets the active context.
   * This function is an extension of the OTel spec, in order to facilitate the current API of React UFO trace context handling.
   * It doesn't keep track of any previously set active contexts, because it's assumed (for now) that only one trace context
   * will ever exist at a time.
   * The next step in the work to improve tracing in the FE will likely remove this function as we need to track the
   * hierarchy of contexts (likely using the `with()` function above).
   * @param context The context to be made the globally active one
   */ setActive(context) {
        if (this._enabled) this._currentContext = context;
    }
    constructor(){
        /**
   * whether the context manager is enabled or not
   */ this._enabled = false;
        /**
   * Keeps the reference to current context
   */ this._currentContext = (0, $S8N63.ROOT_CONTEXT);
    }
}

});

parcelRegister("9wrzK", function(module, exports) {
$parcel$export(module.exports, "makeTraceHttpRequestHeaders", () => $debbe478cf7fbb05$export$1115c5277eb10d5e);
function $debbe478cf7fbb05$export$1115c5277eb10d5e(traceId, spanId) {
    return {
        'X-B3-TraceId': traceId,
        'X-B3-SpanId': spanId
    };
}

});


parcelRegister("dSjTj", function(module, exports) {
$parcel$export(module.exports, "allFeatureFlagsAccessed", () => $c4498c21e4ca15f1$export$5b78c989c8db2561);
$parcel$export(module.exports, "currentFeatureFlagsAccessed", () => $c4498c21e4ca15f1$export$2a5c8df26bb89760);
$parcel$export(module.exports, "addFeatureFlagAccessed", () => $c4498c21e4ca15f1$export$47fade9662f71000);

var $aq7Rb = parcelRequire("aq7Rb");
const $c4498c21e4ca15f1$export$5b78c989c8db2561 = new Map();
const $c4498c21e4ca15f1$export$2a5c8df26bb89760 = new Map();
function $c4498c21e4ca15f1$export$47fade9662f71000(featureFlagName, featureFlagValue) {
    try {
        // Inform Criterion about FF being accessed
        if (globalThis.__CRITERION__ && typeof globalThis.__CRITERION__.addFeatureFlagAccessed === 'function') globalThis.__CRITERION__.addFeatureFlagAccessed(featureFlagName, featureFlagValue);
    } catch (_e) {
    // ignore the criterion error
    }
    const value = (0, $aq7Rb.redactValue)(featureFlagValue);
    $c4498c21e4ca15f1$export$5b78c989c8db2561.set(featureFlagName, value);
    $c4498c21e4ca15f1$export$2a5c8df26bb89760.set(featureFlagName, value);
}

});
parcelRegister("aq7Rb", function(module, exports) {
$parcel$export(module.exports, "redactValue", () => $8c76d8353f6d0a60$export$fcc03ee4c944962f);

var $c5ukR = parcelRequire("c5ukR");
function $8c76d8353f6d0a60$var$startsAsObject(value) {
    try {
        if (value.charAt(0) === '{') return true;
    } catch  {
        return false;
    }
    return false;
}
function $8c76d8353f6d0a60$var$isObject(value) {
    return value && typeof value === 'object' && value.constructor === Object;
}
function $8c76d8353f6d0a60$var$isString(input) {
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch  {
        // swallow any errors
        result = false;
    }
    return result;
}
function $8c76d8353f6d0a60$export$7b4abba432e57989(value) {
    return $8c76d8353f6d0a60$var$isString(value) && $8c76d8353f6d0a60$var$startsAsObject(value) || $8c76d8353f6d0a60$var$isObject(value);
}
function $8c76d8353f6d0a60$export$fcc03ee4c944962f(featureFlagValue) {
    return $8c76d8353f6d0a60$export$7b4abba432e57989(featureFlagValue) ? (0, $c5ukR.NON_BOOLEAN_VALUE) : featureFlagValue;
}

});
parcelRegister("c5ukR", function(module, exports) {
$parcel$export(module.exports, "NON_BOOLEAN_VALUE", () => $249ec7104c63a5e1$export$42f4885608027d0c);
const $249ec7104c63a5e1$export$42f4885608027d0c = 'non_boolean';

});



parcelRegister("kPZVD", function(module, exports) {
$parcel$export(module.exports, "DefaultInteractionID", () => $994b37aef04729e3$export$3109542b68df9ba1);
$parcel$export(module.exports, "subscribeToInteractionIdChanges", () => $994b37aef04729e3$export$3e0c3023952f6774);
$parcel$export(module.exports, "default", () => $994b37aef04729e3$export$2e2bcd8739ae039);
$parcel$export(module.exports, "getInteractionId", () => $994b37aef04729e3$export$37bca3107733ac1e);

var $4tluv = parcelRequire("4tluv");
const $994b37aef04729e3$var$listeners = new Set();
// Observable interaction ID implementation
class $994b37aef04729e3$var$ObservableInteractionID {
    get current() {
        return this._current;
    }
    set current(newId) {
        const oldId = this._current;
        this._current = newId;
        // Notify all listeners if the ID actually changed
        if (oldId !== newId) $994b37aef04729e3$var$listeners.forEach((listener)=>listener(newId));
    }
    constructor(){
        this._current = null;
    }
}
// Ensures a single DefaultInteractionID instance exists across the entire application,
// even when the module is loaded multiple times in different contexts
const $994b37aef04729e3$var$initializeGlobalDefaultInteractionID = ()=>{
    // Return existing instance if already initialized
    if (globalThis.__UFO_DEFAULT_INTERACTION_ID__) return globalThis.__UFO_DEFAULT_INTERACTION_ID__;
    // Create and store new instance globally
    const instance = new $994b37aef04729e3$var$ObservableInteractionID();
    globalThis.__UFO_DEFAULT_INTERACTION_ID__ = instance;
    return instance;
};
const $994b37aef04729e3$export$3109542b68df9ba1 = $994b37aef04729e3$var$initializeGlobalDefaultInteractionID();
const $994b37aef04729e3$export$3e0c3023952f6774 = (listener)=>{
    $994b37aef04729e3$var$listeners.add(listener);
    return ()=>{
        $994b37aef04729e3$var$listeners.delete(listener);
    };
};
// We use a context to allow modals to have their own lifecycle
const $994b37aef04729e3$var$interactionContext = (0, $4tluv.createContext)($994b37aef04729e3$export$3109542b68df9ba1);
var $994b37aef04729e3$export$2e2bcd8739ae039 = $994b37aef04729e3$var$interactionContext;
const $994b37aef04729e3$export$37bca3107733ac1e = ()=>$994b37aef04729e3$export$3109542b68df9ba1;
const $994b37aef04729e3$export$9f6000531b78127e = ()=>$994b37aef04729e3$export$3109542b68df9ba1;

});

parcelRegister("dD8QO", function(module, exports) {
$parcel$export(module.exports, "flushSsrRenderProfilerTraces", () => $3d9d631a9bffd0c9$export$c8760e11c713fafc);
$parcel$export(module.exports, "default", () => $3d9d631a9bffd0c9$export$2e2bcd8739ae039);

var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $dXdid = parcelRequire("dXdid");

var $dWn9F = parcelRequire("dWn9F");

var $hcSxw = parcelRequire("hcSxw");
// These are stored outside react context to be resilient to concurrent mode
// restarting the start marker from a suspense and losing the initial render
const $3d9d631a9bffd0c9$var$startTimes = new Map();
const $3d9d631a9bffd0c9$var$spanStates = new Map();
const $3d9d631a9bffd0c9$export$cf4e4023c0a34c8d = ()=>{
    $3d9d631a9bffd0c9$var$startTimes.clear();
    $3d9d631a9bffd0c9$var$spanStates.clear();
};
// Keep track of the last interaction id and reset the start timers if it ever changes.
// This is to allow multi-step ssr to track the render timers from different "interaction"s seperately
let $3d9d631a9bffd0c9$var$lastActiveInteraction;
function $3d9d631a9bffd0c9$var$checkActiveInteractionAndResetStartMarksIfSet() {
    const activeInteractionId = (0, $dWn9F.getActiveInteraction)()?.id;
    if (!!$3d9d631a9bffd0c9$var$lastActiveInteraction && $3d9d631a9bffd0c9$var$lastActiveInteraction !== activeInteractionId) $3d9d631a9bffd0c9$export$cf4e4023c0a34c8d();
    $3d9d631a9bffd0c9$var$lastActiveInteraction = activeInteractionId;
}
const $3d9d631a9bffd0c9$var$getIsNativeTracingEnabled = ()=>(0, $dXdid.getConfig)()?.ssr?.enableNativeTracing ?? false;
const $3d9d631a9bffd0c9$var$onStartRender = (id, currentSegmentName, parentContext)=>{
    if (!$3d9d631a9bffd0c9$var$startTimes.has(id)) $3d9d631a9bffd0c9$var$startTimes.set(id, []);
    $3d9d631a9bffd0c9$var$startTimes.get(id)?.push(performance.now());
    if (!$3d9d631a9bffd0c9$var$getIsNativeTracingEnabled()) return null;
    const startSpan = globalThis.__vm_internals__?.telemetry?.startSpan;
    let spanState = $3d9d631a9bffd0c9$var$spanStates.get(id) ?? null;
    if (!spanState && startSpan) {
        const span = startSpan(currentSegmentName, {
            parentSpanId: parentContext?.spanId
        });
        spanState = {
            span: span
        };
        $3d9d631a9bffd0c9$var$spanStates.set(id, spanState);
    }
    return spanState;
};
const $3d9d631a9bffd0c9$var$isInSSR = typeof __SERVER__ !== 'undefined' && __SERVER__ || typeof $hcSxw !== 'undefined' && Boolean($hcSxw?.env?.REACT_SSR || false);
const $3d9d631a9bffd0c9$var$ProfilerMarker = ({ onRender: onRender })=>{
    onRender?.();
    return null;
};
const $3d9d631a9bffd0c9$var$ParentSpanContext = /*#__PURE__*/ (0, $4tluv.createContext)(null);
const $3d9d631a9bffd0c9$export$c8760e11c713fafc = ()=>{
    $3d9d631a9bffd0c9$var$spanStates.forEach((spanState)=>{
        if (spanState.latestEndTime != null) spanState.span.end(spanState.latestEndTime);
    });
    $3d9d631a9bffd0c9$var$spanStates.clear();
};
const $3d9d631a9bffd0c9$export$b8bd105b650b1c1e = ({ children: children, labelStack: labelStack, onRender: onRender })=>{
    const reactProfilerId = (0, $4tluv.useMemo)(()=>labelStack.map((l)=>l.name).join('/'), [
        labelStack
    ]);
    $3d9d631a9bffd0c9$var$checkActiveInteractionAndResetStartMarksIfSet();
    const parentSpan = (0, $4tluv.useContext)($3d9d631a9bffd0c9$var$ParentSpanContext);
    const currentSpanState = $3d9d631a9bffd0c9$var$onStartRender(reactProfilerId, labelStack[labelStack.length - 1].name, parentSpan);
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $2iln5.Fragment), {
        children: /*#__PURE__*/ (0, $2iln5.jsxs)($3d9d631a9bffd0c9$var$ParentSpanContext.Provider, {
            value: currentSpanState?.span.getSpanContext() ?? null,
            children: [
                children,
                /*#__PURE__*/ (0, $2iln5.jsx)($3d9d631a9bffd0c9$var$ProfilerMarker, {
                    onRender: ()=>{
                        const startTimesForId = $3d9d631a9bffd0c9$var$startTimes.get(reactProfilerId);
                        if (startTimesForId?.length) {
                            const endTime = performance.now();
                            const firstStartTime = startTimesForId[0];
                            const lastStartTime = startTimesForId[startTimesForId.length - 1];
                            const baseDuration = endTime - lastStartTime;
                            const actualDuration = endTime - firstStartTime;
                            onRender('mount', // this is incorrect, but on the server there is no mount phase
                            actualDuration, baseDuration, firstStartTime, endTime);
                        }
                        const spanState = $3d9d631a9bffd0c9$var$spanStates.get(reactProfilerId);
                        if (spanState) spanState.latestEndTime = performance.now();
                    }
                })
            ]
        })
    });
};
const $3d9d631a9bffd0c9$var$SsrRenderProfiler = (props)=>{
    if ($3d9d631a9bffd0c9$var$isInSSR) return /*#__PURE__*/ (0, $2iln5.jsx)($3d9d631a9bffd0c9$export$b8bd105b650b1c1e, {
        ...props
    });
    // ensure structure similar to SSR implementation
    return /*#__PURE__*/ (0, $2iln5.jsxs)((0, $2iln5.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2iln5.jsx)($3d9d631a9bffd0c9$var$ProfilerMarker, {}),
            props.children
        ]
    });
};
var $3d9d631a9bffd0c9$export$2e2bcd8739ae039 = $3d9d631a9bffd0c9$var$SsrRenderProfiler;

});

parcelRegister("9oQne", function(module, exports) {
$parcel$export(module.exports, "VCObserverWrapper", () => $14311d5b592f0408$export$4a1fe1ab3c13bbf5);
$parcel$export(module.exports, "newVCObserver", () => $14311d5b592f0408$export$c69731bddfc24d85);

var $3X3Vo = parcelRequire("3X3Vo");

var $dXdid = parcelRequire("dXdid");

var $lNUpp = parcelRequire("lNUpp");

var $eLxnz = parcelRequire("eLxnz");

var $lsmLm = parcelRequire("lsmLm");

var $3AhO2 = parcelRequire("3AhO2");

var $7uaw7 = parcelRequire("7uaw7");

var $hcSxw = parcelRequire("hcSxw");
class $14311d5b592f0408$export$4a1fe1ab3c13bbf5 {
    /**
   * Returns true if the new VC observer pipeline should be active.
   * This is needed even when no client-side revisions are enabled, because
   * the raw-handler must still collect observations for server-side TTVC
   * recalculation when the server-side sync gate is on.
   */ static shouldUseNewVCObserver(experienceKey) {
        return (0, $dXdid.isVCRevisionEnabled)('fy25.03', experienceKey) || (0, $dXdid.isVCRevisionEnabled)('fy26.04', experienceKey) || (0, $3X3Vo.fg)('ufo_disable_ttvc_v4');
    }
    constructor(opts = {}){
        this.newVCObserver = null;
        this.oldVCObserver = null;
        // Initialize SSR placeholder handler once
        this.ssrPlaceholderHandler = new (0, $7uaw7.SSRPlaceholderHandlers)({
            enablePageLayoutPlaceholder: opts.ssrEnablePageLayoutPlaceholder ?? false
        });
        if ($14311d5b592f0408$export$4a1fe1ab3c13bbf5.shouldUseNewVCObserver()) this.newVCObserver = new (0, $lsmLm.default)({
            selectorConfig: opts.selectorConfig,
            isPostInteraction: opts.isPostInteraction,
            SSRConfig: {
                enablePageLayoutPlaceholder: opts.ssrEnablePageLayoutPlaceholder ?? false
            },
            ssrPlaceholderHandler: this.ssrPlaceholderHandler,
            trackLayoutShiftOffenders: opts.trackLayoutShiftOffenders ?? false,
            searchPageConfig: opts.searchPageConfig
        });
        if ((0, $dXdid.isVCRevisionEnabled)('fy25.01') || (0, $dXdid.isVCRevisionEnabled)('fy25.02')) this.oldVCObserver = new (0, $eLxnz.VCObserver)({
            ...opts,
            ssrPlaceholderHandler: this.ssrPlaceholderHandler
        });
    }
    // Helper method to process SSR abort listeners
    processSsrAbortListeners() {
        // Process any SSR abort listeners that remain
        if (window?.__SSR_ABORT_LISTENERS__) {
            // Clean up any event listeners that may have been registered during SSR
            // This is centralized here so only the wrapper handles unbinding, not individual observers
            if (window.__SSR_ABORT_LISTENERS__.unbinds && Array.isArray(window.__SSR_ABORT_LISTENERS__.unbinds)) window.__SSR_ABORT_LISTENERS__.unbinds.forEach((unbind)=>{
                if (typeof unbind === 'function') unbind();
            });
            // After all observers had a chance to process abort events,
            // we can safely delete the SSR_ABORT_LISTENERS object
            delete window.__SSR_ABORT_LISTENERS__;
        }
    }
    start({ startTime: startTime, experienceKey: experienceKey }) {
        if ((0, $dXdid.isVCRevisionEnabled)('fy25.01', experienceKey) || (0, $dXdid.isVCRevisionEnabled)('fy25.02', experienceKey)) this.oldVCObserver?.start({
            startTime: startTime
        });
        if ($14311d5b592f0408$export$4a1fe1ab3c13bbf5.shouldUseNewVCObserver(experienceKey)) this.newVCObserver?.start({
            startTime: startTime
        });
        // Clean up any remaining SSR abort listeners after all observers have been started
        this.processSsrAbortListeners();
    }
    stop(experienceKey) {
        if ((0, $dXdid.isVCRevisionEnabled)('fy25.01', experienceKey) || (0, $dXdid.isVCRevisionEnabled)('fy25.02', experienceKey)) this.oldVCObserver?.stop();
        if ($14311d5b592f0408$export$4a1fe1ab3c13bbf5.shouldUseNewVCObserver(experienceKey)) this.newVCObserver?.stop();
        (0, $3AhO2.RLLPlaceholderHandlers).getInstance().reset();
        // Clear shared SSR placeholder handler
        this.ssrPlaceholderHandler.clear();
    }
    getVCRawData() {
        return this.oldVCObserver?.getVCRawData() ?? null;
    }
    async getVCResult(param) {
        const { experienceKey: experienceKey, include3p: include3p, excludeSmartAnswersInSearch: excludeSmartAnswersInSearch, includeSSRRatio: includeSSRRatio, includeRawData: includeRawData } = param;
        const v1v2Result = (0, $dXdid.isVCRevisionEnabled)('fy25.01', experienceKey) || (0, $dXdid.isVCRevisionEnabled)('fy25.02', experienceKey) ? await this.oldVCObserver?.getVCResult(param) : {};
        const v3v4Result = $14311d5b592f0408$export$4a1fe1ab3c13bbf5.shouldUseNewVCObserver(experienceKey) ? await this.newVCObserver?.getVCResult({
            start: param.start,
            stop: param.stop,
            interactionId: param.interactionId,
            ssr: param.ssr,
            include3p: include3p,
            excludeSmartAnswersInSearch: excludeSmartAnswersInSearch,
            includeSSRRatio: includeSSRRatio,
            interactionType: param.interactionType,
            isPageVisible: param.isPageVisible,
            interactionAbortReason: param.interactionAbortReason,
            includeRawData: includeRawData,
            includeSSRInV3: param.includeSSRInV3,
            rawDataStopTime: param.rawDataStopTime,
            reportLayoutShiftOffenders: param.reportLayoutShiftOffenders
        }) : [];
        if (!v3v4Result || v3v4Result.length === 0) return v1v2Result ?? {};
        const ssrRatio = v3v4Result?.[0]?.ssrRatio;
        return {
            ...includeSSRRatio && ssrRatio !== undefined ? {
                'ufo:vc:ssrRatio': ssrRatio
            } : {},
            ...v1v2Result,
            'ufo:vc:rev': [
                ...v1v2Result?.['ufo:vc:rev'] ?? [],
                ...v3v4Result ?? []
            ]
        };
    }
    setSSRElement(element) {
        this.oldVCObserver?.setSSRElement(element);
        this.newVCObserver?.setReactRootElement(element);
    }
    setReactRootRenderStart(startTime) {
        this.oldVCObserver?.setReactRootRenderStart(startTime || performance.now());
        this.newVCObserver?.setReactRootRenderStart(startTime || performance.now());
    }
    setReactRootRenderStop(stopTime) {
        this.oldVCObserver?.setReactRootRenderStop(stopTime || performance.now());
        this.newVCObserver?.setReactRootRenderStop(stopTime || performance.now());
    }
    collectSSRPlaceholders() {
        this.ssrPlaceholderHandler.collectExistingPlaceholders();
    }
}
// Some products set this variable to indicate it is running in SSR
let $14311d5b592f0408$var$isServer = Boolean(globalThis?.__SERVER__);
// Other products set this other variable to indicate it is running in SSR
let $14311d5b592f0408$var$isReactSSR = typeof $hcSxw !== 'undefined' && Boolean($hcSxw?.env?.REACT_SSR || false);
function $14311d5b592f0408$export$68d57b133e88584d() {
    // SSR environment aren't supported
    if ($14311d5b592f0408$var$isReactSSR || $14311d5b592f0408$var$isServer) return false;
    // Legacy browsers that doesn't support WeakRef
    // aren't valid
    if (typeof globalThis?.WeakRef !== 'function') return false;
    if (typeof globalThis?.MutationObserver !== 'function' || typeof globalThis?.IntersectionObserver !== 'function' || typeof globalThis?.PerformanceObserver !== 'function') return false;
    return true;
}
function $14311d5b592f0408$export$b3bc47985717b49e(opts = {}) {
    if (!globalThis.__vcObserver) {
        const shouldMockVCObserver = !$14311d5b592f0408$export$68d57b133e88584d();
        globalThis.__vcObserver = shouldMockVCObserver ? new (0, $lNUpp.VCObserverNOOP)() : new $14311d5b592f0408$export$4a1fe1ab3c13bbf5(opts);
    }
    return globalThis.__vcObserver;
}
function $14311d5b592f0408$export$c69731bddfc24d85(opts = {}) {
    const shouldMockVCObserver = !$14311d5b592f0408$export$68d57b133e88584d();
    const observer = shouldMockVCObserver ? new (0, $lNUpp.VCObserverNOOP)() : new $14311d5b592f0408$export$4a1fe1ab3c13bbf5(opts);
    return observer;
}

});
parcelRegister("lNUpp", function(module, exports) {
$parcel$export(module.exports, "VCObserverNOOP", () => $f3df66703d25c9a0$export$24d07287b49da906);
class $f3df66703d25c9a0$export$24d07287b49da906 {
    start(_) {}
    stop() {}
    getVCRawData() {
        return null;
    }
    getVCResult(_) {
        return Promise.resolve({
            'ufo:vc:noop': true
        });
    }
    setSSRElement(_) {}
    setReactRootRenderStart(_) {}
    setReactRootRenderStop(_) {}
}

});

parcelRegister("lsmLm", function(module, exports) {
$parcel$export(module.exports, "getHasAbortingEventDuringSSR", () => $2af95803fd143b67$export$88af4849fcc5bbc9);
$parcel$export(module.exports, "default", () => $2af95803fd143b67$export$2e2bcd8739ae039);

var $3X3Vo = parcelRequire("3X3Vo");

var $dXdid = parcelRequire("dXdid");

var $dWn9F = parcelRequire("dWn9F");

var $7uaw7 = parcelRequire("7uaw7");

var $gHArC = parcelRequire("gHArC");

var $kEMKo = parcelRequire("kEMKo");

var $dCEAU = parcelRequire("dCEAU");

var $TjVaI = parcelRequire("TjVaI");

var $2bz2Y = parcelRequire("2bz2Y");

var $71YoW = parcelRequire("71YoW");

var $gBsjL = parcelRequire("gBsjL");

var $iDavP = parcelRequire("iDavP");

var $6LN5u = parcelRequire("6LN5u");

var $g1o6y = parcelRequire("g1o6y");
const $2af95803fd143b67$var$SSRState = {
    normal: 1,
    waitingForFirstRender: 2,
    ignoring: 3
};
const $2af95803fd143b67$var$DEFAULT_SELECTOR_CONFIG = {
    id: false,
    testId: true,
    role: false,
    className: false,
    dataVC: true
};
let $2af95803fd143b67$var$hasAbortingEventDuringSSR = false;
function $2af95803fd143b67$export$88af4849fcc5bbc9() {
    return $2af95803fd143b67$var$hasAbortingEventDuringSSR;
}
class $2af95803fd143b67$export$2e2bcd8739ae039 {
    constructor(config){
        this.viewportObserver = null;
        this.windowEventObserver = null;
        // SSR related properties
        this.ssrPlaceholderHandler = null;
        this.ssr = {
            state: $2af95803fd143b67$var$SSRState.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        };
        this.entriesTimeline = new (0, $gHArC.default)();
        this.isPostInteraction = config.isPostInteraction ?? false;
        // Selector-config resolution is centralised in `getSelectorConfig()`
        // (`../../config`). It applies the FedRAMP all-`false` override when
        // `platform_ufo_fedramp_overrides` + `isFedrampModerate()` are both
        // true; otherwise it returns `caller-override → setUFOConfig value →
        // historical default`.
        //
        // When the gate is OFF, `getSelectorConfig()` returns the same value
        // it always did, so the local `?? DEFAULT_SELECTOR_CONFIG` fallback
        // preserves the previous behaviour byte-for-byte.
        this.selectorConfig = (0, $dXdid.getSelectorConfig)(config.selectorConfig, $2af95803fd143b67$var$DEFAULT_SELECTOR_CONFIG) ?? config.selectorConfig ?? $2af95803fd143b67$var$DEFAULT_SELECTOR_CONFIG;
        // Use shared SSR placeholder handler if provided, otherwise create new one if feature flag is enabled
        if (config.ssrPlaceholderHandler) this.ssrPlaceholderHandler = config.ssrPlaceholderHandler;
        else this.ssrPlaceholderHandler = new (0, $7uaw7.SSRPlaceholderHandlers)({
            enablePageLayoutPlaceholder: config.SSRConfig?.enablePageLayoutPlaceholder ?? false
        });
        this.trackLayoutShiftOffenders = config.trackLayoutShiftOffenders ?? false;
        this.viewportObserver = new (0, $6LN5u.default)({
            onChange: (onChangeArg)=>{
                const { time: time, type: type, elementRef: elementRef, visible: visible, rect: rect, previousRect: previousRect, mutationData: mutationData } = onChangeArg;
                let elementName = 'unknown';
                const element = elementRef.deref();
                if (element) elementName = this.getElementName(element);
                const data = {
                    type: type,
                    elementName: elementName,
                    rect: rect,
                    previousRect: previousRect,
                    visible: visible,
                    attributeName: mutationData?.attributeName,
                    oldValue: mutationData?.oldValue,
                    newValue: mutationData?.newValue,
                    originalMutationTimestamp: mutationData?.timestamp
                };
                if (element) {
                    const labelStacks = $2af95803fd143b67$var$getLabelStacks(element);
                    if (labelStacks) Object.assign(data, {
                        labelStacks: labelStacks
                    });
                }
                this.entriesTimeline.push({
                    time: time,
                    data: data
                });
            },
            // Pass SSR context to ViewportObserver
            getSSRState: ()=>this.getSSRState(),
            getSSRPlaceholderHandler: ()=>this.getSSRPlaceholderHandler(),
            searchPageConfig: config.searchPageConfig,
            trackLayoutShiftOffenders: this.trackLayoutShiftOffenders
        });
        this.windowEventObserver = new (0, $g1o6y.default)({
            onEvent: ({ time: time, type: type })=>{
                // Don't abort press interactions on keydown events, as keydown is expected
                // when users press Enter/Space to activate buttons or other interactive elements
                if (type === 'keydown' && (0, $3X3Vo.fg)('platform_ufo_keypress_interaction_abort')) {
                    const interaction = (0, $dWn9F.getActiveInteraction)();
                    if (interaction?.type === 'press') return;
                }
                this.entriesTimeline.push({
                    time: time,
                    data: {
                        type: 'window:event',
                        eventType: type
                    }
                });
            }
        });
    }
    start(_) {
        // Reset SSR state on start (matches old VCObserver behavior)
        this.ssr = {
            state: $2af95803fd143b67$var$SSRState.normal,
            reactRootElement: null,
            // Reset to null (matches old VCObserver)
            renderStart: -1,
            renderStop: -1
        };
        this.viewportObserver?.start();
        if ((0, $3X3Vo.fg)('ufo_fix_aborting_interaction_detection_during_ssr')) {
            this.entriesTimeline.clear();
            if (window?.__SSR_ABORT_LISTENERS__) {
                const abortListeners = window.__SSR_ABORT_LISTENERS__;
                const aborts = abortListeners.aborts;
                if (aborts && typeof aborts === 'object') Object.entries(aborts).forEach(([key, time])=>{
                    if (typeof time === 'number') this.entriesTimeline.push({
                        time: time,
                        data: {
                            type: 'window:event',
                            eventType: key
                        }
                    });
                });
            }
            this.windowEventObserver?.start();
        } else {
            if (window?.__SSR_ABORT_LISTENERS__) {
                const abortListeners = window.__SSR_ABORT_LISTENERS__;
                const aborts = abortListeners.aborts;
                if (aborts && typeof aborts === 'object') Object.entries(aborts).forEach(([key, time])=>{
                    if (typeof time === 'number') {
                        this.entriesTimeline.push({
                            time: time,
                            data: {
                                type: 'window:event',
                                eventType: key
                            }
                        });
                        if ((0, $3X3Vo.fg)('ufo_detect_aborting_interaction_during_ssr')) $2af95803fd143b67$var$hasAbortingEventDuringSSR = true;
                    }
                });
            }
            this.windowEventObserver?.start();
            this.entriesTimeline.clear();
        }
    }
    stop() {
        this.viewportObserver?.stop();
        this.windowEventObserver?.stop();
        // Clear SSR state on stop (matches old VCObserver behavior)
        this.ssr.reactRootElement = null;
    }
    // SSR related methods
    setReactRootElement(element) {
        this.ssr.reactRootElement = element;
    }
    setReactRootRenderStart(startTime = performance.now()) {
        this.ssr.renderStart = startTime;
        this.ssr.state = $2af95803fd143b67$var$SSRState.waitingForFirstRender;
    }
    setReactRootRenderStop(stopTime = performance.now()) {
        this.ssr.renderStop = stopTime;
    }
    collectSSRPlaceholders() {
    // This is handled by the shared SSRPlaceholderHandlers in VCObserverWrapper
    // Individual observers don't need to implement this
    }
    // Internal methods for ViewportObserver to access SSR state
    getSSRState() {
        return this.ssr;
    }
    getSSRPlaceholderHandler() {
        return this.ssrPlaceholderHandler;
    }
    addSSR(ssr) {
        this.entriesTimeline.push({
            time: ssr,
            data: {
                elementName: 'SSR',
                type: 'mutation:element',
                rect: {
                    height: (0, $2bz2Y.default)(),
                    width: (0, $71YoW.default)(),
                    left: 0,
                    top: 0,
                    x: 0,
                    y: 0,
                    bottom: (0, $2bz2Y.default)(),
                    right: (0, $71YoW.default)(),
                    toJSON () {
                        return null;
                    }
                },
                visible: true
            }
        });
    }
    async getVCResult(param) {
        const { start: start, stop: stop, interactionId: interactionId, interactionType: interactionType, interactionAbortReason: interactionAbortReason, isPageVisible: isPageVisible, include3p: include3p, includeSSRRatio: includeSSRRatio, excludeSmartAnswersInSearch: excludeSmartAnswersInSearch, includeRawData: includeRawData, rawDataStopTime: rawDataStopTime } = param;
        const results = [];
        this.addStartEntry(start);
        const feVCCalculationStartTime = performance.now();
        const calculator_fy25_03 = new (0, $dCEAU.default)();
        if (param.includeSSRInV3 && param.ssr) this.addSSR(param.ssr);
        const orderedEntries = this.entriesTimeline.getOrderedEntries({
            start: start,
            stop: stop
        });
        const fy25_03 = (0, $dXdid.isVCRevisionEnabled)('fy25.03') ? await calculator_fy25_03.calculate({
            orderedEntries: orderedEntries,
            startTime: start,
            stopTime: stop,
            interactionId: interactionId,
            interactionType: interactionType,
            isPostInteraction: this.isPostInteraction,
            include3p: include3p,
            excludeSmartAnswersInSearch: excludeSmartAnswersInSearch,
            includeSSRRatio: includeSSRRatio,
            isPageVisible: isPageVisible,
            interactionAbortReason: interactionAbortReason,
            reportLayoutShiftOffenders: this.trackLayoutShiftOffenders
        }) : null;
        if (fy25_03) results.push(fy25_03);
        // From TTVC v4 onwards, ensuring that SSR entry is always auto-added, whenever it is configured.
        if (param.ssr) this.addSSR(param.ssr);
        const calculator_fy26_04 = new (0, $TjVaI.default)();
        const calculator_next = new (0, $gBsjL.default)();
        const calculatorParams = {
            orderedEntries: orderedEntries,
            startTime: start,
            stopTime: stop,
            interactionId: interactionId,
            interactionType: interactionType,
            isPostInteraction: this.isPostInteraction,
            include3p: include3p,
            excludeSmartAnswersInSearch: excludeSmartAnswersInSearch,
            includeSSRRatio: includeSSRRatio,
            isPageVisible: isPageVisible,
            interactionAbortReason: interactionAbortReason,
            reportLayoutShiftOffenders: this.trackLayoutShiftOffenders
        };
        const isFy2604Enabled = (0, $dXdid.isVCRevisionEnabled)('fy26.04');
        const [fy26_04, vcNext] = await Promise.all([
            isFy2604Enabled ? calculator_fy26_04.calculate(calculatorParams) : null,
            (0, $dXdid.isVCRevisionEnabled)('next') ? calculator_next.calculate(calculatorParams) : null
        ]);
        if (fy26_04) results.push(fy26_04);
        if (vcNext) results.push(vcNext);
        const feVCCalculationEndTime = performance.now();
        // Always include raw data when fy26.04 is not in the client config so the server
        // can recalculate fy26.04 metrics (ssrRatio, labelStacks, speedIndex) from raw observations.
        const shouldIncludeRawData = includeRawData || !isFy2604Enabled;
        if (shouldIncludeRawData) {
            const rawVCCalculationStartTime = performance.now();
            const rawHandler = new (0, $iDavP.default)();
            // Use rawDataStopTime (end3p) when available to capture observations during 3p holds
            const rawStopTime = rawDataStopTime ?? stop;
            const rawOrderedEntries = rawDataStopTime ? this.entriesTimeline.getOrderedEntries({
                start: start,
                stop: rawStopTime
            }) : orderedEntries;
            const raw = await rawHandler.getRawData({
                entries: rawOrderedEntries,
                startTime: start,
                stopTime: rawStopTime,
                isPageVisible: isPageVisible
            });
            results.forEach((result)=>{
                delete result.vcDetails;
                delete result.ratios;
            });
            if (raw) {
                raw.rawVCTime = Number((performance.now() - rawVCCalculationStartTime).toFixed(2));
                raw.feVCTime = Number((feVCCalculationEndTime - feVCCalculationStartTime).toFixed(2));
                results.push(raw);
            }
        }
        return results;
    }
    addStartEntry(startTime) {
        this.entriesTimeline.push({
            time: startTime,
            data: {
                type: 'mutation:element',
                elementName: 'START',
                visible: true,
                rect: {
                    x: 0,
                    y: 0,
                    width: window.innerWidth,
                    height: window.innerHeight,
                    top: 0,
                    left: 0,
                    bottom: window.innerHeight,
                    right: window.innerWidth,
                    toJSON: function() {
                        return {
                            x: this.x,
                            y: this.y,
                            width: this.width,
                            height: this.height,
                            top: this.top,
                            left: this.left,
                            bottom: this.bottom,
                            right: this.right
                        };
                    }
                }
            }
        });
    }
    getElementName(element) {
        return (0, $kEMKo.default)(this.selectorConfig, element);
    }
}
function $2af95803fd143b67$var$labelStackFromFiber(fiber) {
    const value = fiber?.child?.memoizedProps?.value;
    return Array.isArray(value?.labelStack) ? value.labelStack : [];
}
function $2af95803fd143b67$var$labelStackToString(labelStack) {
    return labelStack.map((label)=>label.name).join('/');
}
function $2af95803fd143b67$var$labelStackToSegment(labelStack) {
    let segmentIndex = -1;
    for(let i = labelStack.length - 1; i >= 0; i--)if (labelStack[i].segmentId) {
        segmentIndex = i;
        break;
    }
    return labelStack.slice(0, segmentIndex + 1).map((label)=>label.name).join('/');
}
function $2af95803fd143b67$var$traverseFiber(fiber) {
    let segment = 'unknown';
    let labelStackString = 'unknown';
    let currentFiber = fiber;
    while(currentFiber){
        if (currentFiber.type) {
            const componentName = currentFiber.type.displayName || currentFiber.type.name;
            if (componentName === 'UFOSegment' || componentName === 'UFOLabel') {
                const labelStack = $2af95803fd143b67$var$labelStackFromFiber(currentFiber);
                labelStackString = $2af95803fd143b67$var$labelStackToString(labelStack) || 'unknown';
                segment = $2af95803fd143b67$var$labelStackToSegment(labelStack) || 'unknown';
                break;
            }
        }
        currentFiber = currentFiber.return;
    }
    return {
        segment: segment,
        labelStack: labelStackString
    };
}
function $2af95803fd143b67$var$getLabelStacks(element) {
    const reactFiberKey = Object.keys(element).find((key)=>key.startsWith('__reactFiber$'));
    if (!reactFiberKey) return null;
    const fiber = element[reactFiberKey];
    return fiber ? $2af95803fd143b67$var$traverseFiber(fiber) : null;
}

});
parcelRegister("7uaw7", function(module, exports) {
$parcel$export(module.exports, "SSRPlaceholderHandlers", () => $8bc61c9996a12da1$export$c0102f1a1198d10f);
const $8bc61c9996a12da1$var$ANCESTOR_LOOKUP_LIMIT = 10;
const $8bc61c9996a12da1$var$PAGE_LAYOUT_ID = 'page-layout.root';
class $8bc61c9996a12da1$export$c0102f1a1198d10f {
    constructor({ enablePageLayoutPlaceholder: enablePageLayoutPlaceholder = false }){
        this.staticPlaceholders = new Map();
        this.callbacks = new Map();
        this.getSizeCallbacks = new Map();
        this.reactValidateCallbacks = new Map();
        this.EQUALITY_THRESHOLD = 1;
        this.getPlaceholderId = (el)=>{
            const ssrPlaceholderId = el?.dataset?.ssrPlaceholder;
            if (!!ssrPlaceholderId) return ssrPlaceholderId;
            if (this.enablePageLayoutPlaceholder && el?.dataset.testid === $8bc61c9996a12da1$var$PAGE_LAYOUT_ID) return $8bc61c9996a12da1$var$PAGE_LAYOUT_ID;
            return '';
        };
        this.getPlaceholderReplacementId = (el)=>{
            const ssrPlaceholderReplaceId = el?.dataset?.ssrPlaceholderReplace;
            if (!!ssrPlaceholderReplaceId) return ssrPlaceholderReplaceId;
            if (this.enablePageLayoutPlaceholder && el?.dataset.testid === $8bc61c9996a12da1$var$PAGE_LAYOUT_ID) return $8bc61c9996a12da1$var$PAGE_LAYOUT_ID;
            return '';
        };
        this.intersectionObserverCallback = ({ target: target, boundingClientRect: boundingClientRect })=>{
            this.intersectionObserver?.unobserve(target);
            if (!(target instanceof HTMLElement)) // impossible case - keep typescript healthy
            return;
            const staticKey = this.getPlaceholderId(target);
            if (staticKey) {
                if (this.staticPlaceholders.has(staticKey) && this.callbacks.has(staticKey)) {
                    // validation
                    const resolve = this.callbacks.get(staticKey);
                    if (!resolve) return;
                    const rect = this.staticPlaceholders.get(staticKey);
                    const hasSameSizePosition = this.hasSameSizePosition(rect, boundingClientRect);
                    if (hasSameSizePosition || this.isDummyRect(rect)) resolve(hasSameSizePosition);
                    else requestAnimationFrame(()=>{
                        const targetRect = this.getEffectiveBoundingRect(target);
                        const hasSameSizePosition = this.hasSameSizePosition(rect, targetRect);
                        resolve(hasSameSizePosition);
                    });
                    this.callbacks.delete(staticKey);
                }
            } else {
                const key = this.getPlaceholderReplacementId(target);
                const resolve = this.reactValidateCallbacks.get(key);
                if (!resolve) return;
                const rect = this.staticPlaceholders.get(key);
                const hasSameSizePosition = this.hasSameSizePosition(rect, boundingClientRect);
                if (hasSameSizePosition || this.isDummyRect(rect)) resolve(hasSameSizePosition);
                else requestAnimationFrame(()=>{
                    const targetRect = this.getEffectiveBoundingRect(target);
                    const hasSameSizePosition = this.hasSameSizePosition(rect, targetRect);
                    resolve(hasSameSizePosition);
                });
                this.staticPlaceholders.delete(staticKey);
                this.reactValidateCallbacks.delete(staticKey);
            }
        };
        if (typeof IntersectionObserver === 'function') // Only instantiate the IntersectionObserver if it's supported
        this.intersectionObserver = new IntersectionObserver((entries)=>entries.filter((entry)=>entry.intersectionRatio > 0).forEach(this.intersectionObserverCallback));
        this.enablePageLayoutPlaceholder = enablePageLayoutPlaceholder;
        if (window.document) try {
            // Collect initial placeholders using SSR dimensions
            this.collectPlaceholdersInternal();
        } catch  {} finally{
            delete window.__SSR_PLACEHOLDERS_DIMENSIONS__;
        }
    }
    clear() {
        this.staticPlaceholders = new Map();
        this.callbacks = new Map();
        this.getSizeCallbacks = new Map();
        this.reactValidateCallbacks = new Map();
    }
    collectPlaceholdersInternal() {
        const selector = this.enablePageLayoutPlaceholder ? '[data-ssr-placeholder],[data-testid="page-layout.root"]' : '[data-ssr-placeholder]';
        const existingElements = document.querySelectorAll(selector);
        existingElements.forEach((el)=>{
            const placeholderId = el instanceof HTMLElement && this.getPlaceholderId(el);
            if (placeholderId && !this.staticPlaceholders.has(placeholderId)) {
                let width = -1;
                let height = -1;
                let x = -1;
                let y = -1;
                // Use SSR dimensions from window global if available
                const boundingClientRect = window.__SSR_PLACEHOLDERS_DIMENSIONS__?.[placeholderId];
                if (boundingClientRect) {
                    width = boundingClientRect.width;
                    height = boundingClientRect.height;
                    x = boundingClientRect.x;
                    y = boundingClientRect.y;
                } else {
                    // Fallback to current bounding rect if SSR dimensions not available
                    const rect = el.getBoundingClientRect();
                    width = rect.width;
                    height = rect.height;
                    x = rect.x;
                    y = rect.y;
                }
                this.staticPlaceholders.set(placeholderId, {
                    width: width,
                    height: height,
                    x: x,
                    y: y
                });
                this.intersectionObserver?.observe(el);
            }
        });
    }
    /**
   * Added this method to be utilised for testing purposes.
   * In production it collection placeholder should only happens on constructor
   */ collectExistingPlaceholders() {
        if (!window.document) return;
        try {
            // Collect placeholders using SSR dimensions or fallback to live dimensions
            this.collectPlaceholdersInternal();
        } catch  {
        // Silently fail if there are any issues
        } finally{
            delete window.__SSR_PLACEHOLDERS_DIMENSIONS__;
        }
    }
    isPlaceholder(element) {
        return Boolean(this.getPlaceholderId(element));
    }
    isPlaceholderReplacement(element) {
        return Boolean(this.getPlaceholderReplacementId(element));
    }
    isPlaceholderIgnored(element) {
        // data-ssr-placeholder-ignored doesn't have a value.
        return 'ssrPlaceholderIgnored' in element.dataset;
    }
    isPlaceholderV4(element) {
        let currentElement = element;
        let i = 0;
        while(currentElement && i < $8bc61c9996a12da1$var$ANCESTOR_LOOKUP_LIMIT){
            if (Boolean(this.getPlaceholderId(currentElement))) return true;
            currentElement = currentElement.parentElement;
            i++;
        }
        return false;
    }
    isPlaceholderReplacementV4(element) {
        let currentElement = element;
        let i = 0;
        while(currentElement && i < $8bc61c9996a12da1$var$ANCESTOR_LOOKUP_LIMIT){
            if (Boolean(this.getPlaceholderReplacementId(currentElement))) return true;
            currentElement = currentElement.parentElement;
            i++;
        }
        return false;
    }
    findNearestPlaceholderContainerIfIgnored(element) {
        if (!this.isPlaceholderIgnored(element)) return element;
        let ancestor = element.parentElement;
        let i = 0;
        while(ancestor && i < $8bc61c9996a12da1$var$ANCESTOR_LOOKUP_LIMIT){
            if (this.isPlaceholder(ancestor) || this.isPlaceholderReplacement(ancestor)) return ancestor;
            ancestor = ancestor.parentElement;
            i++;
        }
        return element;
    }
    findNearestPlaceholderOrContainer(element, limit = $8bc61c9996a12da1$var$ANCESTOR_LOOKUP_LIMIT) {
        let ancestor = element;
        if (this.isPlaceholderIgnored(element) && element.parentElement) ancestor = element.parentElement;
        let i = 0;
        while(ancestor && i < limit){
            if (this.isPlaceholder(ancestor) || this.isPlaceholderReplacement(ancestor)) return ancestor;
            if (ancestor.parentElement) {
                ancestor = ancestor.parentElement;
                i++;
            } else break;
        }
        return element;
    }
    // Validates placeholder match using asynchronous observation and resolves with the result
    checkIfExistedAndSizeMatching(el) {
        el = this.findNearestPlaceholderContainerIfIgnored(el);
        const id = this.getPlaceholderId(el);
        return new Promise((resolve)=>{
            if (!this.staticPlaceholders.has(id)) {
                resolve(false);
                return;
            } else {
                this.callbacks.set(id, resolve);
                this.intersectionObserver?.observe(el);
            }
        });
    }
    // Validates placeholder match synchronously using stored SSR dimensions and current bounds
    checkIfExistedAndSizeMatchingV3(el) {
        el = this.findNearestPlaceholderContainerIfIgnored(el);
        const id = this.getPlaceholderId(el);
        const placeholderRects = this.staticPlaceholders.get(id);
        if (!placeholderRects) return false;
        return this.hasSameSizePosition(placeholderRects, this.getEffectiveBoundingRect(el));
    }
    getSize(el) {
        return new Promise((resolve)=>{
            this.getSizeCallbacks.set(this.getPlaceholderId(el), resolve);
            this.intersectionObserver?.observe(el);
        });
    }
    validateReactComponentMatchToPlaceholder(el) {
        el = this.findNearestPlaceholderContainerIfIgnored(el);
        const id = this.getPlaceholderReplacementId(el);
        return new Promise((resolve)=>{
            if (!this.staticPlaceholders.has(id)) {
                resolve(false);
                return;
            } else {
                this.reactValidateCallbacks.set(id, resolve);
                this.intersectionObserver?.observe(el);
            }
        });
    }
    validateReactComponentMatchToPlaceholderV4(el) {
        el = this.findNearestPlaceholderOrContainer(el, 2); // We are using 2 due to over-eagerness of the default, only check itself and 1 ancestor
        const id = this.getPlaceholderReplacementId(el);
        return this.staticPlaceholders.has(id);
    }
    hasSameSizePosition(rect, boundingClientRect) {
        if (!rect) return false;
        const horizontalCheck = Math.abs(rect.x - boundingClientRect.x) < this.EQUALITY_THRESHOLD && Math.abs(rect.width - boundingClientRect.width) < this.EQUALITY_THRESHOLD;
        const verticalCheck = Math.abs(rect.y - boundingClientRect.y) < this.EQUALITY_THRESHOLD && Math.abs(rect.height - boundingClientRect.height) < this.EQUALITY_THRESHOLD;
        return horizontalCheck && verticalCheck || false;
    }
    /**
   * Gets the effective bounding rectangle for an element, handling display: contents elements
   * by collecting dimensions from their children instead
   */ getEffectiveBoundingRect(el) {
        const computedStyle = window.getComputedStyle(el);
        // If element has display: contents, collect bounding rect from children
        if (computedStyle.display === 'contents') {
            const children = Array.from(el.children);
            if (children.length === 0) // No children, return zero rect
            return new DOMRect(0, 0, 0, 0);
            // Calculate union of all children's bounding rects
            let minX = Infinity;
            let minY = Infinity;
            let maxX = -Infinity;
            let maxY = -Infinity;
            children.forEach((child)=>{
                const childRect = child.getBoundingClientRect();
                // Skip children with zero dimensions (likely also display: contents)
                if (childRect.width > 0 || childRect.height > 0) {
                    minX = Math.min(minX, childRect.left);
                    minY = Math.min(minY, childRect.top);
                    maxX = Math.max(maxX, childRect.right);
                    maxY = Math.max(maxY, childRect.bottom);
                }
            });
            // If no children with dimensions found, return zero rect
            if (minX === Infinity) return new DOMRect(0, 0, 0, 0);
            return new DOMRect(minX, minY, maxX - minX, maxY - minY);
        }
        // Normal element, return its bounding rect
        return el.getBoundingClientRect();
    }
    isDummyRect(rect) {
        return rect && rect.width < 0 && rect.height < 0 || false;
    }
}

});

parcelRegister("gHArC", function(module, exports) {
$parcel$export(module.exports, "default", () => $94dcc16bcad0f2b2$export$2e2bcd8739ae039);
class $94dcc16bcad0f2b2$export$2e2bcd8739ae039 {
    constructor(){
        this.unorderedEntries = [];
        this.sortedEntriesCache = new Map();
    }
    push(entry) {
        this.unorderedEntries.push(entry);
        this.sortedEntriesCache.clear();
    }
    getCacheKey(start, stop) {
        return `${start ?? 'null'}_${stop ?? 'null'}`;
    }
    getOrderedEntries({ start: start, stop: stop }) {
        const cacheKey = this.getCacheKey(start, stop);
        const cachedSortedEntries = this.sortedEntriesCache.get(cacheKey)?.deref();
        if (cachedSortedEntries) return cachedSortedEntries;
        const filteredEntries = this.unorderedEntries.filter((e)=>e.time >= (start ?? 0) && e.time <= (stop ?? performance.now()));
        const sortedEntries = filteredEntries.sort((a, b)=>a.time - b.time);
        this.sortedEntriesCache.set(cacheKey, new WeakRef(sortedEntries));
        return sortedEntries;
    }
    clear() {
        this.unorderedEntries = [];
        this.sortedEntriesCache.clear();
    }
}

});

parcelRegister("kEMKo", function(module, exports) {
$parcel$export(module.exports, "default", () => $14a886ee5b3edb3a$export$2e2bcd8739ae039);
const $14a886ee5b3edb3a$var$nameCache = new WeakMap();
function $14a886ee5b3edb3a$var$getElementName(selectorConfig, element) {
    if (!(element instanceof HTMLElement)) {
        let elementInstance = 'Unknown';
        // Types of elements according to LLM
        if (element instanceof Text) elementInstance = 'Text';
        else if (element instanceof DocumentFragment) elementInstance = 'DocumentFragment';
        else if (element instanceof Document) elementInstance = 'Document';
        else if (element instanceof Comment) elementInstance = 'Comment';
        else if (element instanceof ProcessingInstruction) elementInstance = 'ProcessingInstruction';
        else if (element instanceof Attr) elementInstance = 'Attr';
        else if (element instanceof CDATASection) elementInstance = 'CDATASection';
        if (element.parentElement && element.parentElement instanceof HTMLElement) {
            const parentElementSelector = $14a886ee5b3edb3a$var$getElementName(selectorConfig, element.parentElement);
            return `${parentElementSelector} > ${elementInstance}`;
        } else return elementInstance;
    }
    const cachedName = $14a886ee5b3edb3a$var$nameCache.get(element);
    if (cachedName) return cachedName;
    // Get the tag name of the element.
    const tagName = element.localName;
    const encodeValue = (s)=>{
        if (typeof encodeURIComponent !== 'function') return '';
        try {
            return encodeURIComponent(s);
        } catch  {
            return 'malformed_value';
        }
    };
    // Helper function to construct attribute selectors.
    const getAttributeSelector = (attributeName, prefix = '')=>{
        if (element && typeof element.getAttribute !== 'function') return '';
        const attrValue = element.getAttribute(attributeName);
        if (!attrValue) return '';
        const encondedAttrValue = encodeValue(attrValue);
        return `${prefix}[${attributeName}="${encondedAttrValue}"]`;
    };
    // Construct the data-vc attribute selector if specified in the config.
    const dataVC = selectorConfig.dataVC !== false ? getAttributeSelector('data-vc') : '';
    // Construct the ID selector if specified in the config and the element has an ID.
    const id = selectorConfig.id && element.id ? `#${encodeValue(element.id)}` : '';
    // Construct the test ID selector if specified in the config.
    const testId = selectorConfig.testId ? getAttributeSelector('data-testid') || getAttributeSelector('data-test-id') : '';
    // Construct the role selector if specified in the config.
    const role = selectorConfig.role ? getAttributeSelector('role') : '';
    const classNames = Array.from(element.classList).map(encodeValue).join('.');
    // Construct the class list selector if specified in the config.
    const classList = selectorConfig.className && classNames ? `.${classNames}` : '';
    // Combine primary attribute selectors (id, testId, role) into a single string.
    const primaryAttributes = [
        id,
        testId,
        role
    ].filter(Boolean).join('');
    // Use dataVC if available, otherwise use the primary attributes.
    const attributes = dataVC || primaryAttributes;
    // If no attributes or class list, recursively get the parent's name.
    if (!attributes && !classList) {
        const parentName = element.parentElement ? $14a886ee5b3edb3a$var$getElementName(selectorConfig, element.parentElement) : 'unknown';
        return `${parentName} > ${tagName}`;
    }
    // Return the final constructed name: tagName + attributes or classList.
    const name = `${tagName}${attributes || classList}`;
    $14a886ee5b3edb3a$var$nameCache.set(element, name);
    return name;
}
var $14a886ee5b3edb3a$export$2e2bcd8739ae039 = $14a886ee5b3edb3a$var$getElementName;

});

parcelRegister("dCEAU", function(module, exports) {
$parcel$export(module.exports, "default", () => $b39919355a4e8c46$export$2e2bcd8739ae039);

var $3X3Vo = parcelRequire("3X3Vo");

var $9VxdV = parcelRequire("9VxdV");

var $bCSVH = parcelRequire("bCSVH");

var $2XUZI = parcelRequire("2XUZI");

var $dApVQ = parcelRequire("dApVQ");

var $jp9zE = parcelRequire("jp9zE");
const $b39919355a4e8c46$var$ABORTING_WINDOW_EVENT = [
    'wheel',
    'scroll',
    'keydown',
    'resize'
];
const $b39919355a4e8c46$var$REVISION_NO = 'fy25.03';
const $b39919355a4e8c46$var$getConsideredEntryTypes = (include3p, excludeSmartAnswersInSearch)=>{
    const entryTypes = [
        'mutation:child-element',
        'mutation:element',
        'mutation:attribute',
        'layout-shift',
        'layout-shift:same-rect',
        'window:event'
    ];
    // Only include third-party elements in TTVC calculation when explicitly requested
    if (include3p) {
        entryTypes.push('mutation:third-party-element');
        entryTypes.push('mutation:third-party-attribute');
    }
    if (!excludeSmartAnswersInSearch) {
        entryTypes.push('mutation:smart-answers-element');
        entryTypes.push('mutation:smart-answers-attribute');
    }
    entryTypes.push('mutation:media');
    // Still included as part of TTVC v3
    entryTypes.push('mutation:attribute:non-visual-input-name');
    return entryTypes;
};
class $b39919355a4e8c46$export$2e2bcd8739ae039 extends (0, $2XUZI.default) {
    constructor(revisionNo){
        super(revisionNo ?? $b39919355a4e8c46$var$REVISION_NO);
    }
    isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch) {
        if (!$b39919355a4e8c46$var$getConsideredEntryTypes(include3p, excludeSmartAnswersInSearch).includes(entry.data.type)) return false;
        if (entry.data.type === 'mutation:attribute:framework-routing') return false;
        if (entry.data.type === 'mutation:media' && (0, $3X3Vo.fg)('media-perf-uplift-mutation-fix')) {
            const entryData = entry.data;
            const attributeName = entryData.attributeName;
            if (attributeName && (/data-(test|file|context)-\S+/g.test(attributeName) || attributeName === 'data-cursor' || attributeName === 'alt' || (attributeName === 'localid' || attributeName === 'contenteditable' || attributeName === 'anchor-name') && (0, $9VxdV.expVal)('platform_editor_media_vc_fixes', 'isEnabled', false))) return false;
            // special case for style attribute to ignore only anchor-name changes
            if ((0, $9VxdV.expVal)('platform_editor_media_vc_fixes', 'isEnabled', false)) {
                if ((0, $bCSVH.containsDnDMutationInStyle)({
                    attributeName: entryData.attributeName,
                    oldValue: entryData.oldValue,
                    newValue: entryData.newValue
                })) return false;
            }
        }
        if (entry.data.type === 'mutation:attribute') {
            const entryData = entry.data;
            const attributeName = entryData.attributeName;
            if (!attributeName || (0, $dApVQ.KNOWN_ATTRIBUTES_THAT_DOES_NOT_CAUSE_LAYOUT_SHIFTS).includes(attributeName)) return false;
            if (attributeName.startsWith('data-test') || (0, $dApVQ.NON_VISUAL_ARIA_ATTRIBUTES).includes(attributeName) || (0, $dApVQ.THIRD_PARTY_BROWSER_EXTENSION_ATTRIBUTES).includes(attributeName) && (0, $3X3Vo.fg)('platform_ufo_exclude_3p_extensions_from_ttvc') || (0, $dApVQ.DARK_READER_BROWSER_EXTENSION_ATTRIBUTES).includes(attributeName) && (0, $3X3Vo.fg)('platform_ufo_exclude_dark_reader_extension') || (0, $dApVQ.MORE_THIRD_PARTY_EXTENSION_ATTRIBUTES).includes(attributeName) && (0, $3X3Vo.fg)('platform_ufo_exclude_fdprocessedid_attribute')) return false;
            return true;
        }
        if ((0, $jp9zE.default)(entry.data) && !entry.data.visible) return false;
        return true;
    }
    getVCCleanStatus(filteredEntries) {
        let dirtyReason = '';
        let abortTimestamp = -1;
        const hasAbortEvent = filteredEntries.some((entry)=>{
            if (entry.data.type === 'window:event') {
                const data = entry.data;
                const eventType = data.eventType;
                if ($b39919355a4e8c46$var$ABORTING_WINDOW_EVENT.includes(eventType)) {
                    dirtyReason = eventType === 'keydown' ? 'keypress' : eventType;
                    abortTimestamp = Math.round(entry.time);
                    return true;
                }
            }
            return false;
        });
        if (hasAbortEvent && dirtyReason) return {
            isVCClean: false,
            dirtyReason: dirtyReason,
            abortTimestamp: abortTimestamp
        };
        return {
            isVCClean: true
        };
    }
}

});
parcelRegister("9VxdV", function(module, exports) {
$parcel$export(module.exports, "expVal", () => $ea601c33129c5c6a$export$9db1624a8af791a4);

var $lVHOI = parcelRequire("lVHOI");

var $dSjTj = parcelRequire("dSjTj");
const $ea601c33129c5c6a$export$9db1624a8af791a4 = (experimentName, experimentParam, defaultValue)=>{
    // If client is not initialized, we return the default value
    if (!(0, $lVHOI.default).initializeCompleted()) return defaultValue;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $lVHOI.default).getExperimentValue(experimentName, experimentParam, defaultValue);
    (0, $dSjTj.addFeatureFlagAccessed)(`${experimentName}:${experimentParam}`, experimentValue);
    return experimentValue;
};

});

parcelRegister("bCSVH", function(module, exports) {
$parcel$export(module.exports, "containsDnDMutationInStyle", () => $3982fdd9e56572b1$export$7867ddcf372cd2bf);
$parcel$export(module.exports, "default", () => $3982fdd9e56572b1$export$2e2bcd8739ae039);
const $3982fdd9e56572b1$var$isDnDStyleChange = (style)=>{
    return style.startsWith('anchor-name: --node-anchor');
};
const $3982fdd9e56572b1$var$parseStyleSet = (style)=>{
    if (!style) return null;
    const set = new Set();
    for (const part of style.split(';')){
        const t = part.trim();
        if (t) set.add(t);
    }
    return set;
};
/**
 * Checks if a mutation record represents a style change from Editor's
 * drag and drop feature, which don't cause visual shifts.
 * This should be removed once DnD has been fixed.
 * @param mutation - The mutation record to check
 * @returns boolean indicating if this is a DnD style mutation
 */ function $3982fdd9e56572b1$export$e20e7bf2c822f3df({ target: target, attributeName: attributeName, oldValue: oldValue, newValue: newValue }) {
    if (!(target instanceof Element)) return false;
    return $3982fdd9e56572b1$export$7867ddcf372cd2bf({
        attributeName: attributeName,
        oldValue: oldValue,
        newValue: newValue
    });
}
function $3982fdd9e56572b1$export$7867ddcf372cd2bf({ attributeName: attributeName, oldValue: oldValue, newValue: newValue }) {
    if (attributeName !== 'style') return false;
    const oldStyles = $3982fdd9e56572b1$var$parseStyleSet(oldValue);
    const newStyles = $3982fdd9e56572b1$var$parseStyleSet(newValue);
    let isDnDMutation = false;
    for (const s of oldStyles ?? [])if (!newStyles?.has(s)) {
        if (!$3982fdd9e56572b1$var$isDnDStyleChange(s)) return false;
        isDnDMutation = true;
    }
    for (const s of newStyles ?? [])if (!oldStyles?.has(s)) {
        if (!$3982fdd9e56572b1$var$isDnDStyleChange(s)) return false;
        isDnDMutation = true;
    }
    return isDnDMutation;
}
var $3982fdd9e56572b1$export$2e2bcd8739ae039 = $3982fdd9e56572b1$export$e20e7bf2c822f3df;

});

parcelRegister("2XUZI", function(module, exports) {
$parcel$export(module.exports, "default", () => $e74c8c7a575f2e2f$export$2e2bcd8739ae039);

var $8VT3D = parcelRequire("8VT3D");

var $hfaKj = parcelRequire("hfaKj");

var $2bz2Y = parcelRequire("2bz2Y");

var $71YoW = parcelRequire("71YoW");
// Helper function for reporting ratios
function $e74c8c7a575f2e2f$var$roundDecimal(value, decimals = 3) {
    const factor = Math.pow(10, decimals);
    return Math.round(value * factor) / factor;
}
class $e74c8c7a575f2e2f$export$2e2bcd8739ae039 {
    constructor(revisionNo){
        this.revisionNo = revisionNo;
    }
    filterViewportEntries(entries) {
        return entries.filter((entry)=>{
            return 'rect' in entry.data;
        });
    }
    /**
   * Calculate ratios for each element based on their viewport coverage.
   */ calculateRatios(filteredEntries) {
        const ratios = {};
        const viewportWidth = (0, $71YoW.default)();
        const viewportHeight = (0, $2bz2Y.default)();
        const totalViewportArea = viewportWidth * viewportHeight;
        if (totalViewportArea === 0) return ratios;
        const elementRects = new Map();
        for (const entry of filteredEntries)if ('rect' in entry.data) {
            const viewportEntry = entry.data;
            elementRects.set(viewportEntry.elementName, viewportEntry.rect);
        }
        for (const [elementName, rect] of elementRects){
            const elementArea = rect.width * rect.height;
            ratios[elementName] = $e74c8c7a575f2e2f$var$roundDecimal(elementArea / totalViewportArea);
        }
        return ratios;
    }
    getLabelStacks(filteredEntries, isPostInteraction) {
        const labelStacks = {};
        for (const entry of filteredEntries)if ('elementName' in entry.data && entry.data.labelStacks) {
            if (isPostInteraction) labelStacks[entry.data.elementName] = {
                segment: entry.data.labelStacks.segment,
                labelStack: entry.data.labelStacks.labelStack
            };
            else labelStacks[entry.data.elementName] = entry.data.labelStacks.labelStack;
        }
        return labelStacks;
    }
    async calculateWithDebugInfo(filteredEntries, startTime, stopTime, isPostInteraction, isVCClean, interactionType, isPageVisible, interactionId, dirtyReason, allEntries, include3p, excludeSmartAnswersInSearch, interactionAbortReason, includeSSRRatio, reportLayoutShiftOffenders) {
        const percentiles = [
            25,
            50,
            75,
            80,
            85,
            90,
            95,
            98,
            99,
            100
        ];
        const viewportEntries = this.filterViewportEntries(filteredEntries);
        const { entries: vcLogs, speedIndex: speedIndex } = await (0, $8VT3D.calculateTTVCPercentilesWithDebugInfo)({
            viewport: {
                width: (0, $71YoW.default)(),
                height: (0, $2bz2Y.default)()
            },
            startTime: startTime,
            stopTime: stopTime,
            orderedEntries: viewportEntries
        });
        const vcDetails = {};
        let percentileIndex = 0;
        const entryDataBuffer = new Set();
        let ssrRatio = -1;
        let layoutShiftInsights = null;
        let previousViewportPercentage = 0;
        if (vcLogs) for (const entry of vcLogs){
            const { time: time, viewportPercentage: viewportPercentage, entries: entries } = entry;
            if (includeSSRRatio && ssrRatio === -1 && entries.some((e)=>e.elementName === 'SSR')) ssrRatio = viewportPercentage;
            // Only process entries if we haven't reached all percentiles
            if (percentileIndex >= percentiles.length) break;
            // Check if this entry matches any checkpoint percentiles
            if (viewportPercentage >= percentiles[percentileIndex]) {
                const elementNames = [
                    ...new Set(entries.map((e)=>e.elementName))
                ];
                // Process all matching percentiles in one go
                while(percentileIndex < percentiles.length && viewportPercentage >= percentiles[percentileIndex]){
                    vcDetails[`${percentiles[percentileIndex]}`] = {
                        t: Math.round(time),
                        e: elementNames
                    };
                    if (reportLayoutShiftOffenders && percentiles[percentileIndex] === 90 && entries.some((e)=>e.type === 'layout-shift')) {
                        const layoutShiftEntries = entries.filter((e)=>e.type === 'layout-shift');
                        layoutShiftInsights = {
                            layoutShiftOffendersResult: (0, $hfaKj.detectLayoutShiftCause)({
                                viewportEntries: viewportEntries,
                                layoutShiftEntries: layoutShiftEntries,
                                time: time,
                                startTime: startTime
                            }),
                            layoutShiftEntriesCount: layoutShiftEntries.length,
                            layoutShiftImpact: viewportPercentage - previousViewportPercentage
                        };
                    }
                    percentileIndex++;
                }
                // Clear buffer after processing all matching percentiles
                entryDataBuffer.clear();
            } else // Only add to buffer if we haven't reached all percentiles
            entries.forEach((e)=>entryDataBuffer.add(e));
            previousViewportPercentage = viewportPercentage;
        }
        // Fill in any missing percentiles with the last known values
        let previousResult = {
            t: 0,
            e: []
        };
        for(let i = 0; i < percentiles.length; i++){
            const percentile = percentiles[i];
            if (!(percentile in vcDetails)) vcDetails[`${percentile}`] = previousResult;
            else previousResult = vcDetails[`${percentile}`];
        }
        let enhancedVcLogs = vcLogs ? vcLogs.map((log)=>({
                ...log,
                entries: log.entries.map((entry)=>({
                        ...entry,
                        rect: entry.rect?.toJSON(),
                        previousRect: entry.previousRect?.toJSON()
                    })),
                viewportPercentage: log.viewportPercentage
            })) : [];
        // If 3p metric enabled - calculate the debug details
        const shouldCalculate3p = include3p;
        // Only calculate enhanced debug details if devtool callbacks exist
        const shouldCalculateDebugDetails = !isPostInteraction && (typeof window?.__ufo_devtool_onVCRevisionReady__ === 'function' || typeof window?.__on_ufo_vc_debug_data_ready === 'function' || typeof window?.__ufo_devtool_vc_3p_debug_data === 'function');
        if (shouldCalculateDebugDetails && allEntries && vcLogs) {
            // Pre-sort vcLogs by time for efficient lookups
            const sortedVcLogs = [
                ...vcLogs
            ].sort((a, b)=>a.time - b.time);
            // Pre-calculate max viewport percentage up to each time for efficient lookups
            const maxViewportPercentageAtTime = new Map();
            let maxSoFar = 0;
            for (const log of sortedVcLogs)if (log.viewportPercentage !== null) {
                maxSoFar = Math.max(maxSoFar, log.viewportPercentage);
                maxViewportPercentageAtTime.set(log.time, maxSoFar);
            }
            // Helper function to find the biggest previous viewport percentage
            const getBiggestPreviousViewportPercentage = (targetTime)=>{
                // Binary search for the largest time <= targetTime
                let left = 0;
                let right = sortedVcLogs.length - 1;
                let result = -1;
                while(left <= right){
                    const mid = Math.floor((left + right) / 2);
                    if (sortedVcLogs[mid].time <= targetTime) {
                        result = mid;
                        left = mid + 1;
                    } else right = mid - 1;
                }
                return result >= 0 ? maxViewportPercentageAtTime.get(sortedVcLogs[result].time) || null : null;
            };
            // Group ignored entries by timestamp
            const ignoredEntriesByTime = new Map();
            for (const entry of allEntries)if ('rect' in entry.data && !this.isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch)) {
                const viewportData = entry.data;
                const timestamp = Math.round(entry.time);
                if (!ignoredEntriesByTime.has(timestamp)) ignoredEntriesByTime.set(timestamp, []);
                ignoredEntriesByTime.get(timestamp)?.push({
                    ...viewportData,
                    rect: viewportData.rect?.toJSON(),
                    previousRect: viewportData.previousRect?.toJSON(),
                    ignoreReason: viewportData.visible ? viewportData.type : 'not-visible'
                });
            }
            // Add ignored entries to vcLogs
            const additionalVcLogs = [];
            for (const [timestamp, ignoredEntries] of ignoredEntriesByTime)if (ignoredEntries.length > 0) {
                const viewportPercentage = getBiggestPreviousViewportPercentage(timestamp);
                additionalVcLogs.push({
                    time: timestamp,
                    viewportPercentage: viewportPercentage,
                    entries: ignoredEntries
                });
            }
            // Combine and sort all vcLogs
            enhancedVcLogs = [
                ...enhancedVcLogs,
                ...additionalVcLogs
            ].sort((a, b)=>a.time - b.time);
        }
        // Only create debug details if callbacks exist
        let v3RevisionDebugDetails = null;
        if (shouldCalculateDebugDetails) v3RevisionDebugDetails = {
            revision: this.revisionNo,
            isClean: isVCClean && !interactionAbortReason && isPageVisible,
            abortReason: !isPageVisible ? 'browser_backgrounded' : dirtyReason ?? interactionAbortReason,
            vcLogs: enhancedVcLogs,
            interactionId: interactionId,
            interactionType: interactionType
        };
        // Handle devtool callback
        if (v3RevisionDebugDetails && typeof window?.__ufo_devtool_onVCRevisionReady__ === 'function' && !include3p) try {
            window?.__ufo_devtool_onVCRevisionReady__?.(v3RevisionDebugDetails);
        } catch (e) {
            // if any error communicating with devtool, we don't want to break the app
            // eslint-disable-next-line no-console
            console.error('Error in onVCRevisionReady', e);
        }
        if (v3RevisionDebugDetails && typeof window?.__on_ufo_vc_debug_data_ready === 'function' && !include3p) try {
            window?.__on_ufo_vc_debug_data_ready?.(v3RevisionDebugDetails);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('Error in onVCRevisionReady', e);
        }
        if (v3RevisionDebugDetails && shouldCalculate3p) try {
            // Log vc details with 3p for debugging
            window.__ufo_devtool_vc_3p_debug_data = v3RevisionDebugDetails;
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('Error in 3pDebugData', e);
        }
        return {
            vcDetails: vcDetails,
            ssrRatio: ssrRatio,
            speedIndex: speedIndex,
            VC90layoutShiftInsights: layoutShiftInsights
        };
    }
    async calculate({ startTime: startTime, stopTime: stopTime, orderedEntries: orderedEntries, interactionId: interactionId, isPostInteraction: isPostInteraction, include3p: include3p, excludeSmartAnswersInSearch: excludeSmartAnswersInSearch, includeSSRRatio: includeSSRRatio, interactionType: interactionType, isPageVisible: isPageVisible, interactionAbortReason: interactionAbortReason, reportLayoutShiftOffenders: reportLayoutShiftOffenders }) {
        const filteredEntries = orderedEntries.filter((entry)=>{
            return this.isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch);
        });
        let isVCClean;
        let dirtyReason;
        const getVCCleanStatusResult = this.getVCCleanStatus(filteredEntries);
        isVCClean = getVCCleanStatusResult.isVCClean;
        dirtyReason = getVCCleanStatusResult.dirtyReason;
        if (!isVCClean) return {
            revision: this.revisionNo,
            'metric:vc90': null,
            clean: false,
            abortReason: dirtyReason,
            abortTimestamp: getVCCleanStatusResult.abortTimestamp
        };
        const { vcDetails: vcDetails, ssrRatio: ssrRatio, speedIndex: speedIndex, VC90layoutShiftInsights: VC90layoutShiftInsights } = await this.calculateWithDebugInfo(filteredEntries, startTime, stopTime, isPostInteraction, isVCClean, interactionType, isPageVisible, interactionId, dirtyReason, orderedEntries, include3p, excludeSmartAnswersInSearch, interactionAbortReason, includeSSRRatio, reportLayoutShiftOffenders);
        let layoutShiftInsightsPayload;
        if (VC90layoutShiftInsights !== null && reportLayoutShiftOffenders) {
            const { layoutShiftOffendersResult: layoutShiftOffendersResult, layoutShiftEntriesCount: layoutShiftEntriesCount, layoutShiftImpact: layoutShiftImpact } = VC90layoutShiftInsights;
            layoutShiftInsightsPayload = {
                impact: layoutShiftImpact,
                sources: layoutShiftEntriesCount ?? 0,
                same: {
                    dir: layoutShiftOffendersResult?.layoutShiftVariables.allMovedSameWay ?? false,
                    dist: layoutShiftOffendersResult?.layoutShiftVariables.allMovedSameAmount ?? false
                },
                total_mut: layoutShiftOffendersResult?.layoutShiftOffenders.length ?? 0,
                mut: layoutShiftOffendersResult?.layoutShiftOffenders.sort((a, b)=>Math.abs(a.distanceToLS) - Math.abs(b.distanceToLS)).slice(0, 5).map((offender)=>({
                        e: offender.offender,
                        size: -1,
                        // @todo: calculate size
                        attr: {
                            t_before: offender.happenedBefore,
                            t_distance: offender.distanceToLS,
                            p_above: offender.isAbove,
                            p_left: offender.isLeft,
                            p_right: offender.isRight,
                            p_h_overlap: offender.hasHorizontalOverlap,
                            p_v_overlap: offender.hasVerticalOverlap,
                            p_same_offset: offender.matchesLayoutShiftDelta ? 'all' : 'none'
                        }
                    }))
            };
        }
        const result = {
            revision: this.revisionNo,
            clean: true,
            'metric:vc90': vcDetails?.['90']?.t ?? null,
            vcDetails: vcDetails ?? undefined,
            'vc90:ls': layoutShiftInsightsPayload ?? undefined
        };
        result.ratios = this.calculateRatios(filteredEntries);
        if (ssrRatio !== -1) result.ssrRatio = ssrRatio;
        // speedIndex is only included in the result when it has a meaningful value (> 0)
        if (speedIndex > 0) result.speedIndex = speedIndex;
        result.labelStacks = this.getLabelStacks(filteredEntries, isPostInteraction);
        return result;
    }
}

});
parcelRegister("8VT3D", function(module, exports) {
$parcel$export(module.exports, "calculateTTVCPercentilesWithDebugInfo", () => $e5c600b58eaacdf7$export$96ea73435089b05a);

var $3X3Vo = parcelRequire("3X3Vo");

var $1Lu2v = parcelRequire("1Lu2v");
async function $e5c600b58eaacdf7$var$calculateTTVCPercentiles({ viewport: viewport, orderedEntries: orderedEntries, percentiles: percentiles, startTime: startTime }) {
    const canvas = new (0, $1Lu2v.ViewportCanvas)(viewport, (0, $3X3Vo.fg)('platform_ufo_canvas_heatmap_full_precision') ? 1 : 0.25);
    const elementMap = new Map();
    for (const entry of orderedEntries){
        if (!('rect' in entry.data)) continue;
        const rect = entry.data.rect;
        const elementName = entry.data.elementName;
        canvas.drawRect(rect, entry.time);
        if (!elementMap.has(entry.time)) elementMap.set(entry.time, new Set());
        elementMap.get(entry.time).add(elementName);
    }
    // Get pixel counts
    const timePixelCounts = await canvas.getPixelCounts();
    const canvasDimenstions = canvas.getScaledDimensions();
    const totalPixels = canvasDimenstions.width * canvasDimenstions.height;
    return $e5c600b58eaacdf7$export$89c8da9b65eff678(timePixelCounts, elementMap, percentiles, totalPixels, startTime);
}
async function $e5c600b58eaacdf7$export$96ea73435089b05a({ viewport: viewport, orderedEntries: orderedEntries, startTime: startTime }) {
    const canvas = new (0, $1Lu2v.ViewportCanvas)(viewport, (0, $3X3Vo.fg)('platform_ufo_canvas_heatmap_full_precision') ? 1 : 0.25);
    const elementMap = new Map();
    for (const entry of orderedEntries){
        if (!('rect' in entry.data)) continue;
        const rect = entry.data.rect;
        canvas.drawRect(rect, entry.time);
        if (!elementMap.has(entry.time)) elementMap.set(entry.time, []);
        elementMap.get(entry.time).push(entry.data);
    }
    // Get pixel counts
    const timePixelCounts = await canvas.getPixelCounts();
    const canvasDimensions = canvas.getScaledDimensions();
    const totalPixels = canvasDimensions.width * canvasDimensions.height;
    return $e5c600b58eaacdf7$export$a532ce01ea38d882(timePixelCounts, elementMap, totalPixels, startTime);
}
var $e5c600b58eaacdf7$export$2e2bcd8739ae039 = $e5c600b58eaacdf7$var$calculateTTVCPercentiles;
function $e5c600b58eaacdf7$export$89c8da9b65eff678(timePixelCounts, elementMap, unorderedPercentiles, totalPixels, startTime) {
    const results = {};
    let cumulativePixels = 0;
    const percentiles = unorderedPercentiles.sort((a, b)=>a - b);
    // Sort entries by timestamp for consistent processing
    const sortedEntries = Array.from(timePixelCounts.entries()).sort(([timeA], [timeB])=>Number(timeA) - Number(timeB));
    let percentileIndex = 0;
    let domElementsBuffer = new Set();
    for (const [time, pixelCount] of sortedEntries){
        cumulativePixels += pixelCount;
        const percentCovered = cumulativePixels / totalPixels * 100;
        const elementNames = elementMap.get(time) || new Set();
        elementNames.forEach((elName)=>domElementsBuffer.add(elName));
        let matchesAnyCheckpoints = false;
        while(percentileIndex < percentiles.length && percentCovered >= percentiles[percentileIndex]){
            results[`${percentiles[percentileIndex]}`] = {
                t: Math.round(Number(time - startTime)),
                e: Array.from(domElementsBuffer)
            };
            percentileIndex++;
            matchesAnyCheckpoints = true;
        }
        if (matchesAnyCheckpoints) domElementsBuffer.clear();
        if (percentileIndex >= percentiles.length) break;
    }
    let previousResult = {
        t: 0,
        e: []
    };
    for(let i = 0; i < percentiles.length; i++){
        const percentile = percentiles[i];
        if (!(percentile in results)) results[`${percentile}`] = previousResult;
        previousResult = results[`${percentile}`];
    }
    return results;
}
function $e5c600b58eaacdf7$export$a532ce01ea38d882(timePixelCounts, elementMap, totalPixels, startTime) {
    const entries = new Array(elementMap.size);
    let cumulativePixels = 0;
    let speedIndex = 0;
    let previousPercentCovered = 0;
    const sortedEntries = Array.from(timePixelCounts.entries()).sort(([timeA], [timeB])=>Number(timeA) - Number(timeB));
    for(let i = 0; i < sortedEntries.length; i++){
        const [time, pixelCount] = sortedEntries[i];
        cumulativePixels += pixelCount;
        const percentCovered = cumulativePixels / totalPixels * 100;
        const entryDatas = elementMap.get(time) || [];
        const relativeTime = Math.round(Number(time - startTime));
        entries[i] = {
            time: relativeTime,
            viewportPercentage: percentCovered,
            entries: Array.from(entryDatas)
        };
        // Speed index calculation: sum of (time × incremental viewport percentage)
        const ratioDelta = (percentCovered - previousPercentCovered) / 100;
        speedIndex += relativeTime * ratioDelta;
        previousPercentCovered = percentCovered;
    }
    return {
        entries: entries,
        speedIndex: Math.round(speedIndex)
    };
}

});
parcelRegister("1Lu2v", function(module, exports) {
$parcel$export(module.exports, "ViewportCanvas", () => $3bbb21c79ad301f5$export$3e59ac9de7402fb1);

var $h65zB = parcelRequire("h65zB");
class $3bbb21c79ad301f5$export$3e59ac9de7402fb1 {
    /**
   * Creates a new ViewportCanvas instance.
   * @param viewport - The dimensions of the viewport
   * @param scaleFactor - Scale factor to apply to the canvas (default: 0.5)
   * @throws {Error} If canvas context cannot be obtained
   */ constructor(viewport, scaleFactor = 1){
        this.scaleFactor = scaleFactor;
        this.colorCounter = 1;
        this.colorTimeMap = new Map();
        const safeViewportWidth = Math.max(viewport.width, 1);
        const safeViewportHeight = Math.max(viewport.height, 1);
        // Calculate scaled dimensions
        this.scaledWidth = Math.max(Math.ceil(safeViewportWidth * scaleFactor), 1);
        this.scaledHeight = Math.max(Math.ceil(safeViewportHeight * scaleFactor), 1);
        this.scaleX = this.scaledWidth / safeViewportWidth;
        this.scaleY = this.scaledHeight / safeViewportHeight;
        // Initialize canvas with scaled dimensions
        this.canvas = this.createCanvas(this.scaledWidth, this.scaledHeight);
        const ctx = this.canvas.getContext('2d', {
            alpha: false,
            // Disable alpha channel for better performance
            willReadFrequently: true,
            // Optimize for frequent pixel reading
            colorSpace: 'srgb' // Use standard RGB color space
        });
        if (!ctx) throw new Error('Could not get canvas context');
        this.ctx = ctx;
        this.ctx.globalCompositeOperation = 'source-over';
        this.ctx.imageSmoothingEnabled = false; // Disable image smoothing for better performance
        this.clear();
    }
    /**
   * Creates a canvas instance, falling back to HTMLCanvasElement if OffscreenCanvas is not available
   */ createCanvas(width, height) {
        if (typeof OffscreenCanvas !== 'undefined') return new OffscreenCanvas(width, height);
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        return canvas;
    }
    getScaledDimensions() {
        return {
            width: this.scaledWidth,
            height: this.scaledHeight
        };
    }
    /**
   * Clears the entire canvas by removing all drawn content.
   * @private
   */ clear() {
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    }
    /**
   * Generates a unique RGB color from an incrementing counter.
   * Uses a 24-bit color space (16,777,216 possible colors).
   *
   * @private
   * @returns A unique RGB color string
   *
   * @example
   * // Example bit operations for color 0x00FF8040:
   * // Red:   (0x00FF8040 >> 16) & 0xFF = 0xFF = 255
   * // Green: (0x00FF8040 >> 8) & 0xFF  = 0x80 = 128
   * // Blue:   0x00FF8040 & 0xFF        = 0x40 = 64
   */ generateColor() {
        // Wrap around at 16,777,215 (0x00FFFFFF) to stay within 24-bit color space
        const rgbColor = this.colorCounter++ % 0x00ffffff;
        return $3bbb21c79ad301f5$export$54591583ed0b20ce(rgbColor);
    }
    /**
   * Draws a rectangle on the canvas with a unique color and associates it with a timestamp.
   * Each drawn rectangle gets a unique color which is mapped to the provided timestamp.
   *
   * @param rect - The rectangle dimensions to draw
   * @param timestamp - The timestamp to associate with this drawing operation
   */ drawRect(rect, timestamp) {
        const color = this.generateColor();
        this.colorTimeMap.set(color, timestamp);
        this.ctx.fillStyle = color;
        if (this.scaleFactor === 1) return this.ctx.fillRect(rect.x, rect.y, rect.width, rect.height);
        const scaledX = rect.x * this.scaleX;
        const scaledY = rect.y * this.scaleY;
        const scaledWidth = rect.width * this.scaleX;
        const scaledHeight = rect.height * this.scaleY;
        this.ctx.fillRect(Math.floor(scaledX), Math.ceil(scaledY), Math.max(scaledWidth, 1), Math.max(scaledHeight, 1));
    }
    /**
   * Calculates the number of pixels drawn for each timestamp.
   * This method:
   * 1. Reads the pixel data from the canvas
   * 2. Counts pixels of each unique color
   * 3. Maps colors back to their timestamps
   * 4. Adjusts counts based on the scale factor
   *
   * @returns A Map containing timestamp to pixel count mappings
   */ async getPixelCounts() {
        const imageData = this.ctx.getImageData(0, 0, this.canvas.width, this.canvas.height);
        const timestampsAmount = this.colorTimeMap.size;
        const pixelCounts = await $3bbb21c79ad301f5$export$fafc9be44839f9c8(imageData, this.scaleFactor, timestampsAmount);
        // Convert color counts to timestamp counts
        const timePixelCounts = new Map();
        for(let i = 0; i < pixelCounts.length; i++){
            const count = pixelCounts[i];
            if (typeof count !== 'number') continue;
            const color = i + 1;
            const rgbColor = $3bbb21c79ad301f5$export$54591583ed0b20ce(color);
            const timestamp = this.colorTimeMap.get(rgbColor);
            if (timestamp !== undefined) timePixelCounts.set(timestamp, (timePixelCounts.get(timestamp) || 0) + count);
        }
        return timePixelCounts;
    }
}
function $3bbb21c79ad301f5$export$54591583ed0b20ce(n) {
    // Ensure the input is within the valid range for a 24-bit color
    if (n < 0 || n > 0xffffff) throw new Error('Input number must be between 0 and 16777215 (inclusive).');
    // Extract blue component (bits 0-7)
    const blue = n & 0xff;
    // Extract green component (bits 8-15)
    const green = n >> 8 & 0xff;
    // Extract red component (bits 16-23)
    const red = n >> 16 & 0xff;
    return `rgb(${red}, ${green}, ${blue})`;
}
async function $3bbb21c79ad301f5$export$fafc9be44839f9c8(imageData, _, arraySize) {
    const data = imageData.data;
    const arr = new Uint32Array(arraySize);
    for(let i = 0; i < data.length; i += 4){
        // Check alpha
        if (data[i + 3] !== 0) {
            // Combine RGB components into a single 24-bit color value:
            // (data[i] << 16)   - Shift red component left 16 bits   (bits 16-23)
            // (data[i + 1] << 8) - Shift green component left 8 bits (bits 8-15)
            // data[i + 2]       - Blue component stays as is         (bits 0-7)
            // The | operator combines all bits together
            const color = data[i] << 16 | data[i + 1] << 8 | data[i + 2];
            const colorIndex = color - 1;
            arr[colorIndex] = (arr[colorIndex] || 0) + 1;
        }
        if (i % 10000 === 0) await (0, $h65zB.default)();
    }
    return arr;
}

});
parcelRegister("h65zB", function(module, exports) {
$parcel$export(module.exports, "default", () => $6bcba6839f4fd9c3$export$2e2bcd8739ae039);
// See https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API
async function $6bcba6839f4fd9c3$var$taskYield() {
    // This is using globalThis to allow the yield task to be used outside of a browser env
    if ('scheduler' in globalThis && // @ts-ignore
    'yield' in globalThis.scheduler) {
        // @ts-ignore
        await scheduler.yield();
        return;
    }
    let resolve = ()=>{};
    const p = new Promise((a)=>{
        resolve = a;
    });
    setTimeout(resolve, 0);
    await p;
}
var $6bcba6839f4fd9c3$export$2e2bcd8739ae039 = $6bcba6839f4fd9c3$var$taskYield;

});



parcelRegister("hfaKj", function(module, exports) {
$parcel$export(module.exports, "detectLayoutShiftCause", () => $d887f0a81c6a3847$export$93ce39b765ea2cd3);
const $d887f0a81c6a3847$var$calculateOffenderState = (current, matchesCurrentEntry)=>{
    // Once we know it's mixed across entries, we can short-circuit.
    if (current === 'some') return 'some';
    const entryState = matchesCurrentEntry ? 'all' : 'none';
    if (current == null) return entryState;
    // If the state flips between entries (all <-> none), it's "some".
    if (current !== entryState) return 'some';
    return current;
};
const $d887f0a81c6a3847$var$calculateLayoutShiftMovement = (layoutShiftEntries)=>{
    const movements = layoutShiftEntries.map((lsEntry)=>{
        const rect = lsEntry.rect;
        const previousRect = lsEntry.previousRect;
        if (!rect || !previousRect) return null;
        const dx = rect.x - previousRect.x;
        const dy = rect.y - previousRect.y;
        return {
            dx: dx,
            dy: dy,
            movedX: dx !== 0,
            movedY: dy !== 0,
            dirX: Math.sign(dx),
            dirY: Math.sign(dy),
            absDx: Math.abs(dx),
            absDy: Math.abs(dy)
        };
    });
    const hasMovement = (m)=>m !== null;
    const validMovements = movements.filter(hasMovement);
    const allHaveRects = layoutShiftEntries.length > 0 && validMovements.length === layoutShiftEntries.length;
    if (!allHaveRects) return {
        allHaveRects: allHaveRects,
        allMovedSameWay: false,
        allMovedSameAmount: false
    };
    const first = validMovements[0];
    const allMovedSameWay = validMovements.every((m)=>m.movedX === first.movedX && m.movedY === first.movedY && m.dirX === first.dirX && m.dirY === first.dirY);
    const allMovedSameAmount = allMovedSameWay && validMovements.every((m)=>m.absDx === first.absDx && m.absDy === first.absDy);
    return {
        allHaveRects: allHaveRects,
        allMovedSameWay: allMovedSameWay,
        allMovedSameAmount: allMovedSameAmount,
        deltaX: first.dx,
        deltaY: first.dy
    };
};
const $d887f0a81c6a3847$export$93ce39b765ea2cd3 = ({ viewportEntries: viewportEntries, layoutShiftEntries: layoutShiftEntries, time: time, startTime: startTime, offenderWindowMs: offenderWindowMs = 250 })=>{
    const checkpointTimestamp = startTime + time;
    const filteredLSPotentialOffenders = viewportEntries.filter((viewportEntry)=>(viewportEntry.time < checkpointTimestamp && viewportEntry.time > checkpointTimestamp - offenderWindowMs || viewportEntry.time > checkpointTimestamp && viewportEntry.time < checkpointTimestamp + offenderWindowMs) && viewportEntry.data.type !== 'layout-shift');
    // Summarize whether all layout-shift entries moved in a consistent direction and by the same amount.
    const layoutShiftVariables = $d887f0a81c6a3847$var$calculateLayoutShiftMovement(layoutShiftEntries);
    // Classify each offender against *all* layout-shift entries when the layout shift is consistently moving in a
    // single axis (pure X or pure Y) so we can reason about whether an offender could have caused the movement.
    const layoutShiftOffenders = filteredLSPotentialOffenders.reduce((acc, offender)=>{
        const offenderData = offender.data;
        const offenderRect = offenderData.rect;
        if (!offenderRect) return acc;
        const offenderTimestamp = offenderData.originalMutationTimestamp ?? offender.time;
        const happenedBefore = offenderTimestamp <= checkpointTimestamp;
        const offenderLeft = offenderRect.x;
        const offenderRight = offenderRect.x + offenderRect.width;
        const offenderTop = offenderRect.y;
        const offenderBottom = offenderRect.y + offenderRect.height;
        const shouldClassifyAgainstAllEntries = layoutShiftVariables.allMovedSameWay && 'deltaX' in layoutShiftVariables && 'deltaY' in layoutShiftVariables && layoutShiftVariables.deltaX === 0 !== (layoutShiftVariables.deltaY === 0);
        let isAbove = null;
        let isLeft = null;
        let isRight = null;
        let hasHorizontalOverlap = null;
        let hasVerticalOverlap = null;
        if (shouldClassifyAgainstAllEntries) for (const lsEntry of layoutShiftEntries){
            const lsRect = lsEntry.rect;
            if (!lsRect) continue;
            const lsLeft = lsRect.x;
            const lsRight = lsRect.x + lsRect.width;
            const lsTop = lsRect.y;
            const lsBottom = lsRect.y + lsRect.height;
            isAbove = $d887f0a81c6a3847$var$calculateOffenderState(isAbove, offenderBottom <= lsTop);
            isLeft = $d887f0a81c6a3847$var$calculateOffenderState(isLeft, offenderRight <= lsLeft);
            isRight = $d887f0a81c6a3847$var$calculateOffenderState(isRight, offenderLeft >= lsRight);
            hasHorizontalOverlap = $d887f0a81c6a3847$var$calculateOffenderState(hasHorizontalOverlap, offenderLeft < lsRight && offenderRight > lsLeft);
            hasVerticalOverlap = $d887f0a81c6a3847$var$calculateOffenderState(hasVerticalOverlap, offenderTop < lsBottom && offenderBottom > lsTop);
        }
        let matchesLayoutShiftDelta = false;
        if (shouldClassifyAgainstAllEntries && layoutShiftVariables.allMovedSameAmount && offenderData.previousRect) {
            const dx = offenderRect.x - offenderData.previousRect.x;
            const dy = offenderRect.y - offenderData.previousRect.y;
            const isPureX = layoutShiftVariables.deltaX !== 0 && layoutShiftVariables.deltaY === 0;
            const isPureY = layoutShiftVariables.deltaY !== 0 && layoutShiftVariables.deltaX === 0;
            if (isPureX) matchesLayoutShiftDelta = dx === layoutShiftVariables.deltaX && dy === 0;
            else if (isPureY) matchesLayoutShiftDelta = dy === layoutShiftVariables.deltaY && dx === 0;
        }
        acc.push({
            offender: offenderData.elementName,
            happenedBefore: happenedBefore,
            distanceToLS: Math.round(offenderTimestamp - checkpointTimestamp),
            isAbove: isAbove ?? 'none',
            isLeft: isLeft ?? 'none',
            isRight: isRight ?? 'none',
            hasHorizontalOverlap: hasHorizontalOverlap ?? 'none',
            hasVerticalOverlap: hasVerticalOverlap ?? 'none',
            matchesLayoutShiftDelta: matchesLayoutShiftDelta
        });
        return acc;
    }, []);
    return {
        layoutShiftVariables: layoutShiftVariables,
        layoutShiftOffenders: layoutShiftOffenders
    };
};

});

parcelRegister("2bz2Y", function(module, exports) {
$parcel$export(module.exports, "default", () => $f48cdf30e43b132e$export$2e2bcd8739ae039);
function $f48cdf30e43b132e$var$getViewportHeight(document = window.document) {
    let documentHeight;
    try {
        documentHeight = document.documentElement.clientHeight || 0;
    } catch  {
        documentHeight = 0;
    }
    return Math.max(documentHeight, window.innerHeight || 0);
}
var $f48cdf30e43b132e$export$2e2bcd8739ae039 = $f48cdf30e43b132e$var$getViewportHeight;

});

parcelRegister("71YoW", function(module, exports) {
$parcel$export(module.exports, "default", () => $9ddb393d2f8ec38b$export$2e2bcd8739ae039);
function $9ddb393d2f8ec38b$var$getViewportWidth(document = window.document) {
    let documentWidth;
    try {
        documentWidth = document.documentElement.clientWidth || 0;
    } catch  {
        documentWidth = 0;
    }
    return Math.max(documentWidth, window.innerWidth || 0);
}
var $9ddb393d2f8ec38b$export$2e2bcd8739ae039 = $9ddb393d2f8ec38b$var$getViewportWidth;

});


parcelRegister("dApVQ", function(module, exports) {
$parcel$export(module.exports, "KNOWN_ATTRIBUTES_THAT_DOES_NOT_CAUSE_LAYOUT_SHIFTS", () => $e2679ece623d7771$export$98812f4e79596e2b);
$parcel$export(module.exports, "NON_VISUAL_ARIA_ATTRIBUTES", () => $e2679ece623d7771$export$44331555a87fcd9e);
$parcel$export(module.exports, "THIRD_PARTY_BROWSER_EXTENSION_ATTRIBUTES", () => $e2679ece623d7771$export$c4351da6279bef53);
$parcel$export(module.exports, "MORE_THIRD_PARTY_EXTENSION_ATTRIBUTES", () => $e2679ece623d7771$export$2492353b2cc31cc0);
$parcel$export(module.exports, "DARK_READER_BROWSER_EXTENSION_ATTRIBUTES", () => $e2679ece623d7771$export$5a7b359ee5e32a5b);
// TODO: AFO-3523
// Those are the attributes we have found when testing the 'fy25.03' manually.
// We still need to replace this hardcoded list with a proper automation
const $e2679ece623d7771$export$98812f4e79596e2b = [
    'data-drop-target-for-element',
    'data-drop-target-for-external',
    'draggable',
    'data-is-observed',
    'data-aui-version',
    'data-testid',
    'data-vc',
    'data-ssr-placeholder',
    'data-ssr-placeholder-replace',
    'data-vc-nvs',
    'data-media-vc-wrapper',
    'data-renderer-start-pos',
    'data-table-local-id',
    'spellcheck',
    'data-auto-scrollable',
    'id',
    'tabindex',
    'data-is-ttvc-ready',
    'contenteditable',
    'data-has-collab-initialised',
    'translate',
    'data-comment-id'
];
const $e2679ece623d7771$export$44331555a87fcd9e = [
    'aria-label',
    'aria-labelledby',
    'aria-describedby',
    'aria-hidden',
    'aria-expanded',
    'aria-controls',
    'aria-selected',
    'aria-checked',
    'aria-disabled',
    'aria-required',
    'aria-current',
    'aria-haspopup',
    'aria-pressed',
    'aria-atomic',
    'aria-live'
];
const $e2679ece623d7771$export$c4351da6279bef53 = [
    'bis_skin_checked',
    'cz-shortcut-listen',
    'monica-version',
    'data-gr-ext-installed',
    'data-dashlane-rid',
    'sapling-installed',
    'data-gptw',
    // grammarly extensions
    'data-new-gr-c-s-loaded',
    'data-gr-aaa-notch-connection-id',
    'data-gr-aaa-loaded'
];
const $e2679ece623d7771$export$2492353b2cc31cc0 = [
    'fdprocessedid',
    'data-dashlane-classification'
];
const $e2679ece623d7771$export$5a7b359ee5e32a5b = [
    // dark reader extension
    'data-darkreader-inline-bgcolor',
    'data-darkreader-inline-bgimage',
    'data-darkreader-inline-border',
    'data-darkreader-inline-border-bottom',
    'data-darkreader-inline-border-left',
    'data-darkreader-inline-border-right',
    'data-darkreader-inline-border-top',
    'data-darkreader-inline-boxshadow',
    'data-darkreader-inline-color',
    'data-darkreader-inline-fill',
    'data-darkreader-inline-stroke',
    'data-darkreader-inline-outline',
    'data-darkreader-inline-stopcolor',
    'data-darkreader-inline-bg',
    'data-darkreader-inline-border-short',
    'data-darkreader-inline-border-bottom-short',
    'data-darkreader-inline-border-left-short',
    'data-darkreader-inline-border-right-short',
    'data-darkreader-inline-border-top-short'
];

});

parcelRegister("jp9zE", function(module, exports) {
$parcel$export(module.exports, "default", () => $5ae7df746f18f000$export$2e2bcd8739ae039);
function $5ae7df746f18f000$var$isViewportEntryData(data) {
    if (data) {
        const hasElementName = typeof data.elementName === 'string';
        const hasRect = typeof data.rect !== 'undefined';
        if (hasRect && hasElementName) return true;
    }
    return false;
}
var $5ae7df746f18f000$export$2e2bcd8739ae039 = $5ae7df746f18f000$var$isViewportEntryData;

});


parcelRegister("TjVaI", function(module, exports) {
$parcel$export(module.exports, "default", () => $ec823c1c981c47c6$export$2e2bcd8739ae039);

var $3X3Vo = parcelRequire("3X3Vo");

var $dCEAU = parcelRequire("dCEAU");

var $dApVQ = parcelRequire("dApVQ");
const $ec823c1c981c47c6$var$getConsideredEntryTypes = ()=>{
    const consideredEntryTypes = [
        'mutation:display-contents-children-element'
    ];
    consideredEntryTypes.push('mutation:display-contents-children-attribute');
    return consideredEntryTypes;
};
const $ec823c1c981c47c6$var$getExcludedEntryTypes = ()=>{
    const excludedEntryTypes = [
        'layout-shift:same-rect',
        'mutation:attribute:non-visual-input-name'
    ];
    return excludedEntryTypes;
};
const $ec823c1c981c47c6$var$fy26_04_excluded_attributes = [
    'data-is-hovered' // non-visual attribute
];
class $ec823c1c981c47c6$export$2e2bcd8739ae039 extends (0, $dCEAU.default) {
    constructor(revisionNo = 'fy26.04'){
        super(revisionNo);
    }
    isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch) {
        const extra_fy26_04_excluded_attributes = (0, $3X3Vo.fg)('platform_ufo_ignore_data_fabric_mode') ? [
            'data-fabric-mode'
        ] : [];
        const entryData = entry.data;
        const { attributeName: attributeName } = entryData;
        if (entry.data.type === 'mutation:attribute' && attributeName && extra_fy26_04_excluded_attributes.includes(attributeName)) return false;
        const isEntryIncludedInV3 = super.isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch);
        if (isEntryIncludedInV3 && !$ec823c1c981c47c6$var$getExcludedEntryTypes().includes(entry.data.type)) return true;
        if (entry.data.type === 'mutation:attribute' && (!attributeName || $ec823c1c981c47c6$var$fy26_04_excluded_attributes.includes(attributeName) && (0, $3X3Vo.fg)('platform_ufo_data-is-hovered-v4-exclusion'))) return false;
        const thirdPartyAttributes = [
            ...(0, $dApVQ.THIRD_PARTY_BROWSER_EXTENSION_ATTRIBUTES),
            ...(0, $3X3Vo.fg)('platform_ufo_exclude_dark_reader_extension') ? (0, $dApVQ.DARK_READER_BROWSER_EXTENSION_ATTRIBUTES) : [],
            ...(0, $3X3Vo.fg)('platform_ufo_exclude_fdprocessedid_attribute') ? (0, $dApVQ.MORE_THIRD_PARTY_EXTENSION_ATTRIBUTES) : []
        ];
        if (entryData.type === 'mutation:display-contents-children-attribute') {
            if (!attributeName || attributeName.startsWith('data-test') || (0, $dApVQ.KNOWN_ATTRIBUTES_THAT_DOES_NOT_CAUSE_LAYOUT_SHIFTS).includes(attributeName) || (0, $dApVQ.NON_VISUAL_ARIA_ATTRIBUTES).includes(attributeName) || thirdPartyAttributes.includes(attributeName)) return false;
            return true;
        }
        return $ec823c1c981c47c6$var$getConsideredEntryTypes().includes(entry.data.type);
    }
}

});

parcelRegister("gBsjL", function(module, exports) {
$parcel$export(module.exports, "default", () => $9adc955227a10929$export$2e2bcd8739ae039);

var $TjVaI = parcelRequire("TjVaI");
const $9adc955227a10929$var$ABORTING_WINDOW_EVENT = [
    'wheel',
    'scroll',
    'keydown',
    'resize',
    'scroll-container'
];
const $9adc955227a10929$var$getConsideredEntryTypes = ()=>{
    const consideredEntryTypes = [];
    return consideredEntryTypes;
};
const $9adc955227a10929$var$getExcludedEntryTypes = ()=>{
    const excludedEntryTypes = [];
    return excludedEntryTypes;
};
class $9adc955227a10929$export$2e2bcd8739ae039 extends (0, $TjVaI.default) {
    constructor(){
        super('next');
    }
    isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch) {
        const isEntryIncludedInV4 = super.isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch);
        if (isEntryIncludedInV4 && !$9adc955227a10929$var$getExcludedEntryTypes().includes(entry.data.type)) return true;
        return $9adc955227a10929$var$getConsideredEntryTypes().includes(entry.data.type);
    }
    getVCCleanStatus(filteredEntries) {
        let dirtyReason = '';
        let abortTimestamp = -1;
        const hasAbortEvent = filteredEntries.some((entry)=>{
            if (entry.data.type === 'window:event') {
                const data = entry.data;
                const eventType = data.eventType;
                if ($9adc955227a10929$var$ABORTING_WINDOW_EVENT.includes(eventType)) {
                    if (eventType === 'keydown') dirtyReason = 'keypress';
                    else if (eventType === 'scroll-container') dirtyReason = 'scroll';
                    else dirtyReason = eventType;
                    abortTimestamp = Math.round(entry.time);
                    return true;
                }
            }
            return false;
        });
        if (hasAbortEvent && dirtyReason) return {
            isVCClean: false,
            dirtyReason: dirtyReason,
            abortTimestamp: abortTimestamp
        };
        return {
            isVCClean: true
        };
    }
}

});

parcelRegister("iDavP", function(module, exports) {
$parcel$export(module.exports, "default", () => $f9a35d0b4003c3cf$export$2e2bcd8739ae039);

var $dXdid = parcelRequire("dXdid");

var $fubJS = parcelRequire("fubJS");

var $2bz2Y = parcelRequire("2bz2Y");

var $71YoW = parcelRequire("71YoW");
const $f9a35d0b4003c3cf$var$ABORTING_WINDOW_EVENT = [
    'wheel',
    'scroll',
    'keydown',
    'resize'
];
const $f9a35d0b4003c3cf$var$MAX_OBSERVATIONS = 200;
const $f9a35d0b4003c3cf$var$encodeRect = (rect)=>[
        Math.round(rect.left * 10) / 10,
        Math.round(rect.top * 10) / 10,
        Math.round(rect.right * 10) / 10,
        Math.round(rect.bottom * 10) / 10
    ];
const $f9a35d0b4003c3cf$var$areRectsEqual = (left, right)=>left.every((value, index)=>value === right[index]);
function $f9a35d0b4003c3cf$var$isWindowEventEntryData(data) {
    return data.type === 'window:event' && 'eventType' in data;
}
class $f9a35d0b4003c3cf$export$2e2bcd8739ae039 {
    getVCCleanStatus(filteredEntries) {
        let dirtyReason = '';
        let abortTimestamp = -1;
        const hasAbortEvent = filteredEntries.some((entry)=>{
            if (entry.data.type === 'window:event') {
                const data = entry.data;
                const eventType = data.eventType;
                if ($f9a35d0b4003c3cf$var$ABORTING_WINDOW_EVENT.includes(eventType)) {
                    dirtyReason = eventType === 'keydown' ? 'keypress' : eventType;
                    abortTimestamp = Math.round(entry.time);
                    return true;
                }
            }
            return false;
        });
        if (hasAbortEvent && dirtyReason) return {
            isVCClean: false,
            dirtyReason: dirtyReason,
            abortTimestamp: abortTimestamp
        };
        return {
            isVCClean: true
        };
    }
    async getRawData({ entries: entries, startTime: startTime, stopTime: stopTime, isPageVisible: isPageVisible }) {
        let isVCClean;
        let dirtyReason;
        const getVCCleanStatusResult = this.getVCCleanStatus(entries);
        isVCClean = getVCCleanStatusResult.isVCClean;
        dirtyReason = getVCCleanStatusResult.dirtyReason;
        if (!isPageVisible) return {
            revision: this.revisionNo,
            clean: false,
            'metric:vc90': null,
            abortReason: 'browser_backgrounded',
            abortTimestamp: (0, $fubJS.getEarliestHiddenTiming)(startTime, stopTime) ?? -1,
            viewport: {
                w: (0, $71YoW.default)(),
                h: (0, $2bz2Y.default)()
            }
        };
        const viewportEntries = entries.filter((entry)=>{
            return entry.time >= startTime && entry.time <= stopTime && entry.data && entry.data.visible;
        });
        const windowEventEntries = entries.filter((entry)=>{
            return entry.time >= startTime && entry.time <= stopTime && entry.data && $f9a35d0b4003c3cf$var$isWindowEventEntryData(entry.data);
        });
        const targetNameToIdMap = new Map();
        const elementMapEntriesMap = {};
        let nextElementId = 1;
        const typeMap = new Map();
        const typeMapEntriesMap = {};
        let nextTypeId = 1;
        const attributeMap = new Map();
        const attributeEntriesMap = {};
        let nextAttributeId = 1;
        const eventTypeMap = new Map();
        const eventTypeMapEntriesMap = {};
        let nextEventTypeId = 1;
        const labelStacksMap = {};
        let rawObservations = viewportEntries.map((entry)=>{
            const viewportEntry = entry.data;
            const targetName = viewportEntry.elementName || '';
            const type = viewportEntry.type || '';
            const rect = viewportEntry.rect;
            const attributeName = viewportEntry.attributeName || '';
            let eid = targetNameToIdMap.get(viewportEntry.elementName || '') || 0;
            if (eid === 0) {
                eid = nextElementId;
                nextElementId += 1;
                targetNameToIdMap.set(targetName, eid);
                elementMapEntriesMap[eid] = targetName;
            }
            // Capture labelStacks per element (only stored once per unique element)
            if (viewportEntry.labelStacks && !(eid in labelStacksMap)) {
                const labelInfo = {
                    s: viewportEntry.labelStacks.segment,
                    l: viewportEntry.labelStacks.labelStack
                };
                const shouldCompactImplicitUnknown = labelInfo.s === 'unknown' && labelInfo.l === 'unknown';
                labelStacksMap[eid] = shouldCompactImplicitUnknown ? 'u' : labelInfo;
            }
            let chg = typeMap.get(type || '') || 0;
            if (chg === 0) {
                chg = nextTypeId;
                nextTypeId += 1;
                typeMap.set(type, chg);
                typeMapEntriesMap[chg] = type;
            }
            let att = 0;
            if (attributeName) {
                att = attributeMap.get(attributeName) || 0;
                if (att === 0) {
                    att = nextAttributeId;
                    nextAttributeId += 1;
                    attributeMap.set(attributeName, att);
                    attributeEntriesMap[att] = attributeName;
                }
            }
            const encodedRect = $f9a35d0b4003c3cf$var$encodeRect(rect);
            const encodedPreviousRect = viewportEntry.previousRect ? $f9a35d0b4003c3cf$var$encodeRect(viewportEntry.previousRect) : null;
            const shouldIncludePreviousRect = encodedPreviousRect === null || !$f9a35d0b4003c3cf$var$areRectsEqual(encodedRect, encodedPreviousRect);
            const observation = {
                t: Math.round(entry.time - startTime),
                r: encodedRect,
                ...shouldIncludePreviousRect ? {
                    pr: encodedPreviousRect
                } : {},
                chg: chg,
                eid: eid || 0,
                ...att > 0 ? {
                    att: att
                } : {}
            };
            return observation;
        });
        let rawEventObservations = windowEventEntries.map((entry)=>{
            const windowEventEntry = entry.data;
            const eventType = windowEventEntry.eventType;
            let evtId = eventTypeMap.get(eventType) || 0;
            if (evtId === 0) {
                evtId = nextEventTypeId;
                nextEventTypeId += 1;
                eventTypeMap.set(eventType, evtId);
                eventTypeMapEntriesMap[evtId] = eventType;
            }
            const eventObservation = {
                t: Math.round(entry.time - startTime),
                evt: evtId
            };
            return eventObservation;
        });
        // If the number of observations is greater than the maximum allowed, we need to trim the observations to the maximum allowed.
        // We do this by keeping the first observation, the SSR observation (if present), and the last MAX_OBSERVATIONS observations.
        // We then collect the referenced IDs from the remaining observations and remove the unreferenced entries from the maps
        if (rawObservations.length > $f9a35d0b4003c3cf$var$MAX_OBSERVATIONS) {
            const firstObservation = rawObservations[0];
            const lastObservations = rawObservations.slice(-$f9a35d0b4003c3cf$var$MAX_OBSERVATIONS);
            // Find the SSR observation by looking up the eid that corresponds to 'SSR' element name
            const ssrEid = targetNameToIdMap.get('SSR');
            const ssrObservation = ssrEid ? rawObservations.find((obs)=>obs.eid === ssrEid && obs !== firstObservation) : undefined;
            // Include SSR observation if it exists and is not already in the kept observations
            const ssrAlreadyIncluded = ssrObservation && lastObservations.some((obs)=>obs === ssrObservation);
            rawObservations = [
                firstObservation,
                ...ssrObservation && !ssrAlreadyIncluded ? [
                    ssrObservation
                ] : [],
                ...lastObservations
            ];
            // Collect referenced IDs from remaining observations
            const referencedEids = new Set();
            const referencedChgs = new Set();
            const referencedAtts = new Set();
            for (const observation of rawObservations){
                if (observation.eid > 0) referencedEids.add(observation.eid);
                if (typeof observation.chg === 'number' && observation.chg > 0) referencedChgs.add(observation.chg);
                if (observation.att !== undefined && observation.att > 0) referencedAtts.add(observation.att);
            }
            // Remove unreferenced entries from maps
            for (const eid of Object.keys(elementMapEntriesMap).map(Number))if (!referencedEids.has(eid)) {
                delete elementMapEntriesMap[eid];
                delete labelStacksMap[eid];
            }
            for (const chg of Object.keys(typeMapEntriesMap).map(Number))if (!referencedChgs.has(chg)) delete typeMapEntriesMap[chg];
            for (const att of Object.keys(attributeEntriesMap).map(Number))if (!referencedAtts.has(att)) delete attributeEntriesMap[att];
        }
        // If the number of event observations is greater than the maximum allowed, we need to trim the event observations to the maximum allowed.
        // We do this by keeping the first observation and the last MAX_OBSERVATIONS observations.
        // We then collect the referenced IDs from the remaining observations and remove the unreferenced entries from the maps
        if (rawEventObservations.length > $f9a35d0b4003c3cf$var$MAX_OBSERVATIONS) {
            const firstEventObservation = rawEventObservations[0];
            const lastEventObservations = rawEventObservations.slice(-$f9a35d0b4003c3cf$var$MAX_OBSERVATIONS);
            rawEventObservations = [
                firstEventObservation,
                ...lastEventObservations
            ];
            // Collect referenced IDs from remaining observations
            const referencedEvts = new Set();
            for (const observation of rawEventObservations)if (observation.evt > 0) referencedEvts.add(observation.evt);
            // Remove unreferenced entries from maps
            for (const evt of Object.keys(eventTypeMapEntriesMap).map(Number))if (!referencedEvts.has(evt)) delete eventTypeMapEntriesMap[evt];
        }
        // FedRAMP-Moderate scrubbing.
        //
        // In commercial environments the raw-handler payload includes:
        //   - `rawData.att` / `obs[].att`  → DOM attribute names from
        //     `MutationRecord.attributeName`. These are *names* (not values),
        //     but custom product attributes can in principle embed
        //     identifiers (e.g. `data-user-{id}-state`).
        //   - `rawData.lbl`                → UFO labelStacks. Generally
        //     curated product paths but in poorly-instrumented call sites
        //     could embed dynamic identifiers.
        //
        // Server-side TTVC reconstruction does not require these fields
        // (it is driven by timestamps, rectangles, and mutation kind),
        // so dropping them in FedRAMP is safe and removes residual PII risk.
        const isFedrampScrubbed = (0, $dXdid.isFedrampOverrideActive)();
        const scrubbedObservations = isFedrampScrubbed ? rawObservations.map(({ att: _att, ...rest })=>rest) : rawObservations;
        const result = {
            revision: this.revisionNo,
            clean: isVCClean,
            'metric:vc90': null,
            rawData: {
                obs: scrubbedObservations ?? undefined,
                eid: elementMapEntriesMap ?? undefined,
                chg: typeMapEntriesMap ?? undefined,
                att: isFedrampScrubbed ? undefined : attributeEntriesMap ?? undefined,
                evts: rawEventObservations.length > 0 ? rawEventObservations : undefined,
                evt: Object.keys(eventTypeMapEntriesMap).length > 0 ? eventTypeMapEntriesMap : undefined,
                lbl: isFedrampScrubbed ? undefined : Object.keys(labelStacksMap).length > 0 ? labelStacksMap : undefined,
                lblMode: isFedrampScrubbed ? undefined : Object.keys(labelStacksMap).length > 0 ? 'sentinel-v1' : undefined
            },
            abortReason: dirtyReason,
            abortTimestamp: getVCCleanStatusResult.abortTimestamp,
            viewport: {
                w: (0, $71YoW.default)(),
                h: (0, $2bz2Y.default)()
            }
        };
        return result;
    }
    constructor(){
        this.revisionNo = 'raw-handler';
    }
}

});

parcelRegister("6LN5u", function(module, exports) {
$parcel$export(module.exports, "default", () => $e1556d9e25c5afcc$export$2e2bcd8739ae039);

var $79qE1 = parcelRequire("79qE1");

var $bCSVH = parcelRequire("bCSVH");

var $2V5Fg = parcelRequire("2V5Fg");

var $3AhO2 = parcelRequire("3AhO2");

var $kJ0K6 = parcelRequire("kJ0K6");

var $ihS99 = parcelRequire("ihS99");

var $1w31F = parcelRequire("1w31F");

var $fnVxM = parcelRequire("fnVxM");

var $idMFp = parcelRequire("idMFp");

var $et3zn = parcelRequire("et3zn");

var $lgLxh = parcelRequire("lgLxh");

var $5TBjy = parcelRequire("5TBjy");

var $b8kGK = parcelRequire("b8kGK");

var $8xkMf = parcelRequire("8xkMf");
const $e1556d9e25c5afcc$var$createElementMutationsWatcher = (removedNodeRects, isWithinThirdPartySegment, isWithinSmartAnswersSegment, hasSameDeletedNode, timestamp, isTargetReactRoot, getSSRState, getSSRPlaceholderHandler)=>({ target: target, rect: rect })=>{
        if (getSSRState) {
            const ssrState = getSSRState();
            const SSRStateEnum = {
                normal: 1,
                waitingForFirstRender: 2,
                ignoring: 3
            };
            if (ssrState.state === SSRStateEnum.waitingForFirstRender && timestamp > ssrState.renderStart && isTargetReactRoot) {
                ssrState.state = SSRStateEnum.ignoring;
                if (ssrState.renderStop === -1) // arbitrary 500ms DOM update window
                ssrState.renderStop = timestamp + 500;
                return 'ssr-hydration';
            }
            if (ssrState.state === SSRStateEnum.ignoring && timestamp > ssrState.renderStart && isTargetReactRoot) {
                if (timestamp <= ssrState.renderStop) return 'ssr-hydration';
                else ssrState.state = SSRStateEnum.normal;
            }
        }
        if (getSSRPlaceholderHandler) {
            const ssrPlaceholderHandler = getSSRPlaceholderHandler();
            if (ssrPlaceholderHandler) {
                if ((ssrPlaceholderHandler.isPlaceholderV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.checkIfExistedAndSizeMatchingV3(target)) return 'mutation:ssr-placeholder';
                if ((ssrPlaceholderHandler.isPlaceholderReplacementV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.validateReactComponentMatchToPlaceholderV4(target)) return 'mutation:ssr-placeholder';
            }
        }
        if (hasSameDeletedNode && (0, $lgLxh.default)(target)) return 'mutation:remount';
        if ((0, $79qE1.isContainedWithinMediaWrapper)(target)) return 'mutation:media';
        if (isWithinThirdPartySegment) return 'mutation:third-party-element';
        if (isWithinSmartAnswersSegment) return 'mutation:smart-answers-element';
        const isInIgnoreLsMarker = (0, $lgLxh.default)(target);
        if (!isInIgnoreLsMarker) return 'mutation:element';
        const isRLLPlaceholder = (0, $3AhO2.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(rect);
        if (isRLLPlaceholder && isInIgnoreLsMarker) return 'mutation:rll-placeholder';
        const wasDeleted = removedNodeRects.some((nr)=>(0, $b8kGK.isSameRectDimensions)(nr, rect));
        if (wasDeleted && isInIgnoreLsMarker) return 'mutation:element-replacement';
        return 'mutation:element';
    };
const $e1556d9e25c5afcc$var$createElementMutationsWatcherNew = (removedNodeRects, isWithinThirdPartySegment, isWithinSmartAnswersSegment, hasSameDeletedNode, timestamp, isTargetReactRoot, getSSRState, getSSRPlaceholderHandler)=>({ target: target, rect: rect })=>{
        if (getSSRState) {
            const ssrState = getSSRState();
            const SSRStateEnum = {
                normal: 1,
                waitingForFirstRender: 2,
                ignoring: 3
            };
            if (ssrState.state === SSRStateEnum.waitingForFirstRender && timestamp > ssrState.renderStart && isTargetReactRoot) {
                ssrState.state = SSRStateEnum.ignoring;
                if (ssrState.renderStop === -1) // arbitrary 500ms DOM update window
                ssrState.renderStop = timestamp + 500;
                return {
                    type: 'ssr-hydration',
                    mutationData: {
                        timestamp: timestamp
                    }
                };
            }
            if (ssrState.state === SSRStateEnum.ignoring && timestamp > ssrState.renderStart && isTargetReactRoot) {
                if (timestamp <= ssrState.renderStop) return {
                    type: 'ssr-hydration',
                    mutationData: {
                        timestamp: timestamp
                    }
                };
                else ssrState.state = SSRStateEnum.normal;
            }
        }
        if (getSSRPlaceholderHandler) {
            const ssrPlaceholderHandler = getSSRPlaceholderHandler();
            if (ssrPlaceholderHandler) {
                if ((ssrPlaceholderHandler.isPlaceholderV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.checkIfExistedAndSizeMatchingV3(target)) return {
                    type: 'mutation:ssr-placeholder',
                    mutationData: {
                        timestamp: timestamp
                    }
                };
                if ((ssrPlaceholderHandler.isPlaceholderReplacementV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.validateReactComponentMatchToPlaceholderV4(target)) return {
                    type: 'mutation:ssr-placeholder',
                    mutationData: {
                        timestamp: timestamp
                    }
                };
            }
        }
        if (hasSameDeletedNode && (0, $lgLxh.default)(target)) return {
            type: 'mutation:remount',
            mutationData: {
                timestamp: timestamp
            }
        };
        if ((0, $79qE1.isContainedWithinMediaWrapper)(target)) return {
            type: 'mutation:media',
            mutationData: {
                timestamp: timestamp
            }
        };
        if (isWithinThirdPartySegment) return {
            type: 'mutation:third-party-element',
            mutationData: {
                timestamp: timestamp
            }
        };
        if (isWithinSmartAnswersSegment) return {
            type: 'mutation:smart-answers-element',
            mutationData: {
                timestamp: timestamp
            }
        };
        const isInIgnoreLsMarker = (0, $lgLxh.default)(target);
        if (!isInIgnoreLsMarker) return {
            type: 'mutation:element',
            mutationData: {
                timestamp: timestamp
            }
        };
        const isRLLPlaceholder = (0, $3AhO2.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(rect);
        if (isRLLPlaceholder && isInIgnoreLsMarker) return {
            type: 'mutation:rll-placeholder',
            mutationData: {
                timestamp: timestamp
            }
        };
        const wasDeleted = removedNodeRects.some((nr)=>(0, $b8kGK.isSameRectDimensions)(nr, rect));
        if (wasDeleted && isInIgnoreLsMarker) return {
            type: 'mutation:element-replacement',
            mutationData: {
                timestamp: timestamp
            }
        };
        return {
            type: 'mutation:element',
            mutationData: {
                timestamp: timestamp
            }
        };
    };
class $e1556d9e25c5afcc$export$2e2bcd8739ae039 {
    constructor({ onChange: onChange, getSSRState: getSSRState, getSSRPlaceholderHandler: getSSRPlaceholderHandler, trackLayoutShiftOffenders: trackLayoutShiftOffenders = false, searchPageConfig: searchPageConfig }){
        this.handleIntersectionEntry = ({ target: target, rect: rect, time: time, type: type, mutationData: mutationData })=>{
            if (!target) return;
            const visible = (0, $et3zn.isElementVisible)(target);
            const lastElementRect = this.mapVisibleNodeRects.get(target);
            this.mapVisibleNodeRects.set(target, rect);
            this.onChange({
                time: time,
                type: type,
                elementRef: new WeakRef(target),
                visible: visible,
                rect: rect,
                previousRect: lastElementRect,
                mutationData: mutationData
            });
        };
        this.handleChildListMutation = async ({ target: target, addedNodes: addedNodes, removedNodes: removedNodes, timestamp: timestamp })=>{
            const removedNodeRects = removedNodes.map((ref)=>{
                const n = ref.deref();
                if (!n) return;
                return this.mapVisibleNodeRects.get(n);
            });
            const targetNode = target.deref();
            for (const addedNodeRef of addedNodes){
                const addedNode = addedNodeRef.deref();
                if (!addedNode) continue;
                const hasSameDeletedNode = removedNodes.find((ref)=>{
                    const n = ref.deref();
                    if (!n || !addedNode) return false;
                    return n.isEqualNode(addedNode);
                });
                const { isWithin: isWithinThirdPartySegment } = (0, $fnVxM.default)(addedNode, 'UFOThirdPartySegment', this.mapIs3pResult);
                const isWithinSmartAnswersSegment = Boolean(this.shouldCheckSmartAnswersMutations() && (0, $idMFp.isContainedWithinSmartAnswers)(addedNode));
                const isTargetReactRoot = targetNode === this.getSSRState?.()?.reactRootElement;
                this.intersectionObserver?.watchAndTag(addedNode, (this.trackLayoutShiftOffenders ? $e1556d9e25c5afcc$var$createElementMutationsWatcherNew : $e1556d9e25c5afcc$var$createElementMutationsWatcher)(removedNodeRects, isWithinThirdPartySegment, isWithinSmartAnswersSegment, !!hasSameDeletedNode, timestamp, isTargetReactRoot, this.getSSRState, this.getSSRPlaceholderHandler));
            }
        };
        this.handleAttributeMutation = ({ target: target, attributeName: attributeName, oldValue: oldValue, newValue: newValue, timestamp: timestamp })=>{
            this.intersectionObserver?.watchAndTag(target, ({ target: target, rect: rect })=>{
                if ((0, $79qE1.isContainedWithinMediaWrapper)(target)) return {
                    type: 'mutation:media',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                const { isWithin: isWithinThirdPartySegment } = (0, $fnVxM.default)(target, 'UFOThirdPartySegment', this.mapIs3pResult);
                if (isWithinThirdPartySegment) return {
                    type: 'mutation:third-party-attribute',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                if (this.shouldCheckSmartAnswersMutations() && (0, $idMFp.isContainedWithinSmartAnswers)(target)) return {
                    type: 'mutation:smart-answers-attribute',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue
                    }
                };
                if ((0, $bCSVH.default)({
                    target: target,
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue
                })) return {
                    type: 'mutation:attribute:non-visual-style',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                if ((0, $2V5Fg.default)({
                    target: target,
                    attributeName: attributeName,
                    type: 'attributes'
                })) return {
                    type: 'mutation:attribute:non-visual-style',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                if ((0, $5TBjy.isInputNameMutation)({
                    target: target,
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue
                })) return {
                    type: 'mutation:attribute:non-visual-input-name',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                const isRLLPlaceholder = (0, $3AhO2.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(rect);
                if (isRLLPlaceholder) return {
                    type: 'mutation:rll-placeholder',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                const lastElementRect = this.mapVisibleNodeRects.get(target);
                if (lastElementRect && (0, $8xkMf.isSameRectSize)(rect, lastElementRect)) return {
                    type: 'mutation:attribute:no-layout-shift',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                return {
                    type: 'mutation:attribute',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
            });
        };
        this.handleLayoutShift = ({ time: time, changedRects: changedRects })=>{
            for (const changedRect of changedRects){
                const target = changedRect.node;
                if (target) {
                    const isSameCurrentAndPreviousRects = (0, $b8kGK.isSameRectDimensions)(changedRect.rect, changedRect.previousRect);
                    this.onChange({
                        time: time,
                        elementRef: new WeakRef(target),
                        visible: true,
                        rect: changedRect.rect,
                        previousRect: changedRect.previousRect,
                        type: isSameCurrentAndPreviousRects ? 'layout-shift:same-rect' : 'layout-shift'
                    });
                }
            }
        };
        this.shouldCheckSmartAnswersMutations = ()=>{
            return this.searchPageConfig?.enableSmartAnswersMutations && this.searchPageConfig?.searchPageRoute && window?.location?.pathname && window.location.pathname === this.searchPageConfig.searchPageRoute;
        };
        this.mapVisibleNodeRects = new WeakMap();
        this.mapIs3pResult = new WeakMap();
        this.onChange = onChange;
        this.isStarted = false;
        this.intersectionObserver = null;
        this.mutationObserver = null;
        this.performanceObserver = null;
        this.trackLayoutShiftOffenders = trackLayoutShiftOffenders;
        // Initialize SSR context functions
        this.getSSRState = getSSRState;
        this.getSSRPlaceholderHandler = getSSRPlaceholderHandler;
        this.searchPageConfig = searchPageConfig;
    }
    initializeObservers() {
        if (this.isStarted) return;
        this.intersectionObserver = (0, $kJ0K6.createIntersectionObserver)({
            onEntry: this.handleIntersectionEntry
        });
        this.mutationObserver = (0, $ihS99.default)({
            onChildListMutation: this.handleChildListMutation,
            onAttributeMutation: this.handleAttributeMutation
        });
        this.performanceObserver = (0, $1w31F.default)({
            onLayoutShift: this.handleLayoutShift
        });
    }
    start() {
        if (this.isStarted) return;
        this.initializeObservers();
        this.mutationObserver?.observe(document.body, {
            attributeOldValue: true,
            attributes: true,
            childList: true,
            subtree: true
        });
        this.performanceObserver?.observe({
            type: 'layout-shift',
            buffered: true,
            // @ts-ignore -error
            durationThreshold: 30
        });
        this.isStarted = true;
    }
    stop() {
        if (!this.isStarted) return;
        this.mutationObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        this.performanceObserver?.disconnect();
        this.isStarted = false;
        // Clean up caches when stopping
        (0, $fnVxM.cleanupCaches)(this.mapIs3pResult);
    }
}

});
parcelRegister("79qE1", function(module, exports) {
$parcel$export(module.exports, "isContainedWithinMediaWrapper", () => $29ceaf446aa74298$export$f61fbc3b9c4a9019);

var $7nlBq = parcelRequire("7nlBq");
function $29ceaf446aa74298$export$f61fbc3b9c4a9019(node) {
    while(node){
        if (node instanceof Element && node.hasAttribute((0, $7nlBq.MEDIA_WRAPPER_TAG))) return true;
        node = node.parentNode;
    }
    return false;
}

});
parcelRegister("7nlBq", function(module, exports) {
$parcel$export(module.exports, "MEDIA_WRAPPER_TAG", () => $5c5854fb9ccb0763$export$7674290405cc25b0);
$parcel$export(module.exports, "VcMediaWrapperProps", () => $5c5854fb9ccb0763$export$7028e9efe569888c);

var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");
const $5c5854fb9ccb0763$export$7674290405cc25b0 = 'data-media-vc-wrapper';
const $5c5854fb9ccb0763$export$7028e9efe569888c = {
    [$5c5854fb9ccb0763$export$7674290405cc25b0]: true
};
function $5c5854fb9ccb0763$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)("div", {
        ...$5c5854fb9ccb0763$export$7028e9efe569888c,
        children: children
    });
}

});


parcelRegister("2V5Fg", function(module, exports) {
$parcel$export(module.exports, "default", () => $5a74f8e7f9289f55$export$2e2bcd8739ae039);
/**
 * Checks if a mutation record represents a non-visual style change
 * @param mutation - The mutation record to check
 * @returns boolean indicating if this is a non-visual style mutation
 *
 * A mutation is considered non-visual if:
 * - The target has data-	vc-nvs="true" attribute
 * - The changed attribute is either 'class' or 'style'
 */ function $5a74f8e7f9289f55$var$isNonVisualStyleMutation({ target: target, attributeName: attributeName }) {
    if (!(target instanceof Element)) return false;
    if (attributeName !== 'class' && attributeName !== 'style') return false;
    if (target.getAttribute('data-vc-nvs') !== 'true') return false;
    return true;
}
var $5a74f8e7f9289f55$export$2e2bcd8739ae039 = $5a74f8e7f9289f55$var$isNonVisualStyleMutation;

});

parcelRegister("3AhO2", function(module, exports) {
$parcel$export(module.exports, "RLLPlaceholderHandlers", () => $aa719e76bafeced4$export$166779fc0f49d4df);
const $aa719e76bafeced4$var$GLOBAL_RLL_HANDLERS_KEY = '__REACT_UFO_RLL_PLACEHOLDER_HANDLERS__';
class $aa719e76bafeced4$export$166779fc0f49d4df {
    constructor(){
        this.placeholders = [];
        if (typeof window !== 'undefined' && typeof document !== 'undefined' && typeof window.document !== 'undefined') this.collectRLLPlaceholders();
    }
    /**
   * Gets the global singleton instance of RLLPlaceholderHandlers.
   * Creates the instance if it doesn't exist and stores it in globalThis.
   * @returns The singleton instance of RLLPlaceholderHandlers
   */ static getInstance() {
        if (typeof globalThis !== 'undefined') {
            if (!globalThis[$aa719e76bafeced4$var$GLOBAL_RLL_HANDLERS_KEY]) globalThis[$aa719e76bafeced4$var$GLOBAL_RLL_HANDLERS_KEY] = new $aa719e76bafeced4$export$166779fc0f49d4df();
            return globalThis[$aa719e76bafeced4$var$GLOBAL_RLL_HANDLERS_KEY];
        }
        // Fallback for environments without globalThis (should be rare)
        return new $aa719e76bafeced4$export$166779fc0f49d4df();
    }
    reset() {
        this.placeholders = [];
    }
    /**
   * Collects all React Loosely Lazy (RLL) placeholders from the DOM and caches their viewport intersecting rectangles.
   * RLL placeholders are marked with data-lazy-begin and data-lazy-end attributes on hidden input elements.
   * Performance optimized to batch getBoundingClientRect calls and minimize layout thrashing.
   * Only stores the intersecting portions of rectangles that are currently visible in the viewport.
   */ collectRLLPlaceholders() {
        if (typeof window === 'undefined' || typeof document === 'undefined' || typeof window.document === 'undefined') return;
        const beginElements = document.querySelectorAll('input[data-lazy-begin]');
        const beginCount = beginElements.length;
        if (beginCount === 0) return;
        // Performance optimization: pre-allocate array with estimated size
        const allElements = [];
        // Performance optimization: use traditional for loop instead of forEach
        for(let i = 0; i < beginCount; i++){
            const beginEl = beginElements[i];
            const id = beginEl.getAttribute('data-lazy-begin');
            if (!id) continue;
            const elements = this.refElements(beginEl, id);
            if (elements.length > 0) allElements.push(...elements);
        }
        // Second pass: batch all getBoundingClientRect calls to minimize reflow cycles
        const allElementsLength = allElements.length;
        if (allElementsLength > 0) {
            // Performance optimization: pre-allocate array with exact size
            const intersectingRects = [];
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;
            for(let i = 0; i < allElementsLength; i++){
                const rect = allElements[i].getBoundingClientRect();
                // Performance optimization: inline intersection calculation to avoid function call overhead
                const left = Math.max(rect.left, 0);
                const top = Math.max(rect.top, 0);
                const right = Math.min(rect.right, windowWidth);
                const bottom = Math.min(rect.bottom, windowHeight);
                // Check if there's a valid intersection with non-zero width and height
                if (left < right && top < bottom) intersectingRects.push(new DOMRect(left, top, right - left, bottom - top));
            }
            this.placeholders = intersectingRects;
        }
    }
    /**
   * Traverses DOM siblings to find all elements between RLL begin and end markers.
   * Based on the refElements pattern from react-loosely-lazy's platform/packages/async/react-loosely-lazy/src/collect/hydrate.ts
   * Performance optimized to minimize iterations and early exit conditions.
   *
   * @param fromEl - The input element with data-lazy-begin attribute
   * @param id - The placeholder ID to match against data-lazy-end
   * @returns Array of DOM elements between the begin/end markers
   */ refElements(fromEl, id) {
        const result = [];
        let el = fromEl.nextSibling;
        // Performance optimization: use while loop instead of recursive calls
        while(el){
            if (el.dataset?.lazyEnd === id) break;
            if (el.nodeType === Node.ELEMENT_NODE) result.push(el);
            el = el.nextSibling;
        }
        return result;
    }
    /**
   * Returns the cached intersecting viewport rectangles for all RLL placeholder elements.
   * @returns Array of DOMRect objects representing the intersecting portions of placeholders within the viewport
   */ getPlaceholders() {
        return this.placeholders;
    }
    /**
   * Checks if the given intersecting rectangle matches any of the cached RLL placeholder intersecting rectangles.
   * This is designed to be called from IntersectionObserver with the intersectionRect.
   * Performance optimized with early exits and minimal calculations.
   * @param intersectingRect - The intersecting rectangle from IntersectionObserver
   * @returns true if the intersecting rectangle matches a cached placeholder rectangle and hasn't exceeded match limit, false otherwise
   */ isRLLPlaceholderHydration(intersectingRect) {
        const placeholdersLength = this.placeholders.length;
        if (placeholdersLength === 0) return false;
        // Performance optimization: cache array length and use traditional for loop
        for(let i = 0; i < placeholdersLength; i++){
            const placeholderRect = this.placeholders[i];
            if (this.areRectsEqual(intersectingRect, placeholderRect)) return true;
        }
        return false;
    }
    /**
   * Compares two DOMRect objects for equality with ±1 pixel tolerance.
   * Performance optimized to minimize calculations and early exit on major differences.
   * @param rect1 - First rectangle to compare
   * @param rect2 - Second rectangle to compare
   * @returns true if rectangles are within 1 pixel tolerance for all properties
   */ areRectsEqual(rect1, rect2) {
        // Early exit for exact matches (most common case)
        if (rect1.left === rect2.left && rect1.top === rect2.top && rect1.right === rect2.right && rect1.bottom === rect2.bottom) return true;
        // Performance optimization: check largest differences first for early exit
        const leftDiff = rect1.left - rect2.left;
        if (leftDiff > 1 || leftDiff < -1) return false;
        const rightDiff = rect1.right - rect2.right;
        if (rightDiff > 1 || rightDiff < -1) return false;
        const topDiff = rect1.top - rect2.top;
        if (topDiff > 1 || topDiff < -1) return false;
        const bottomDiff = rect1.bottom - rect2.bottom;
        if (bottomDiff > 1 || bottomDiff < -1) return false;
        return true;
    }
}

});

parcelRegister("kJ0K6", function(module, exports) {
$parcel$export(module.exports, "createIntersectionObserver", () => $2ed708ae63c24039$export$c3799d33e0ae80a5);

var $nk3Yb = parcelRequire("nk3Yb");
function $2ed708ae63c24039$var$isValidEntry(entry) {
    return entry.isIntersecting && entry.intersectionRect.width > 0 && entry.intersectionRect.height > 0;
}
function $2ed708ae63c24039$export$c3799d33e0ae80a5({ onEntry: onEntry, onObserved: onObserved }) {
    if (!window || typeof window.IntersectionObserver !== 'function') return null;
    const callbacksPerElement = new WeakMap();
    const intersectionObserverCallback = (entries)=>{
        const validEntries = [];
        const startTime = performance.now();
        entries.forEach((entry)=>{
            if (!(entry.target instanceof HTMLElement)) return;
            const tagOrCallback = callbacksPerElement.get(entry.target);
            if ((0, $nk3Yb.isZeroDimensionRectangle)(entry.intersectionRect)) {
                const zeroDimensionRectangleTagCallback = (props)=>{
                    const tagOrCallbackResult = typeof tagOrCallback === 'function' ? tagOrCallback(props) : tagOrCallback;
                    // override as display-contents mutation
                    if (tagOrCallbackResult === 'mutation:element') return 'mutation:display-contents-children-element';
                    // override as display-contents mutation
                    if (tagOrCallbackResult && typeof tagOrCallbackResult !== 'string' && tagOrCallbackResult.type === 'mutation:attribute' && 'oldValue' in tagOrCallbackResult.mutationData) {
                        const { attributeName: attributeName, oldValue: oldValue, newValue: newValue } = tagOrCallbackResult.mutationData;
                        const isRoutingMutation = attributeName === 'style' && (!oldValue && newValue === 'display: none !important;' || oldValue === 'display: none !important;' && !newValue);
                        if (isRoutingMutation) return {
                            type: 'mutation:attribute:framework-routing',
                            mutationData: tagOrCallbackResult.mutationData
                        };
                        return {
                            type: 'mutation:display-contents-children-attribute',
                            mutationData: tagOrCallbackResult.mutationData
                        };
                    }
                    return tagOrCallbackResult;
                };
                for (const child of Array.from(entry.target.children)){
                    observer.observe(child);
                    callbacksPerElement.set(child, zeroDimensionRectangleTagCallback);
                }
                return;
            }
            if (!$2ed708ae63c24039$var$isValidEntry(entry)) return;
            let mutationTag = null;
            let mutationData = null;
            if (typeof tagOrCallback === 'function') {
                const tagOrCallbackResult = tagOrCallback({
                    target: entry.target,
                    rect: entry.intersectionRect
                });
                if (!tagOrCallbackResult) mutationTag = 'unknown';
                else if (typeof tagOrCallbackResult === 'string') mutationTag = tagOrCallbackResult;
                else {
                    mutationTag = tagOrCallbackResult.type;
                    mutationData = tagOrCallbackResult.mutationData;
                }
            } else if (typeof tagOrCallback === 'string') mutationTag = tagOrCallback;
            onEntry({
                target: entry.target,
                rect: entry.intersectionRect,
                time: entry.time,
                type: mutationTag ?? 'unknown',
                mutationData: mutationData
            });
            validEntries.push(new WeakRef(entry.target));
            callbacksPerElement.delete(entry.target);
            observer.unobserve(entry.target);
        });
        onObserved?.({
            time: startTime,
            elements: validEntries
        });
    };
    const observer = new IntersectionObserver(intersectionObserverCallback);
    return {
        disconnect: ()=>{
            observer.disconnect();
        },
        unobserve: (target)=>{
            observer.unobserve(target);
        },
        watchAndTag: (target, tagOrCallback)=>{
            callbacksPerElement.set(target, tagOrCallback);
            observer.observe(target);
        }
    };
}

});
parcelRegister("nk3Yb", function(module, exports) {
$parcel$export(module.exports, "isZeroDimensionRectangle", () => $f7c489f17fcf5329$export$80d6b07c2266a1c6);
function $f7c489f17fcf5329$export$80d6b07c2266a1c6(rect) {
    return rect.bottom === 0 && rect.top === 0 && rect.left === 0 && rect.right === 0 && rect.x === 0 && rect.y === 0 && rect.width === 0 && rect.height === 0;
}

});


parcelRegister("ihS99", function(module, exports) {
$parcel$export(module.exports, "default", () => $ab26818beccecabb$export$2e2bcd8739ae039);

var $9VxdV = parcelRequire("9VxdV");
function $ab26818beccecabb$var$createMutationObserver({ onAttributeMutation: onAttributeMutation, onChildListMutation: onChildListMutation, onMutationFinished: onMutationFinished }) {
    if (!window || typeof window.IntersectionObserver !== 'function') return null;
    const mutationObserverCallback = (mutations)=>{
        const targets = [];
        // Use nested Maps for O(1) batching performance
        // Short-lived Maps are safe since they're discarded after each callback
        const batchedMutations = new Map();
        for (const mut of mutations){
            if (!(mut.target instanceof HTMLElement)) continue;
            if ((0, $9VxdV.expVal)('cc_editor_vc_exclude_flags', 'isEnabled', false)) {
                // Intended for excluding out of band mutations such as tooltips on hover, and page flags
                // Currently being tested in Confluence
                // Skip elements with data-vc-oob attribute
                if (mut.target.dataset.vcOob) return;
            }
            if (mut.type === 'attributes') {
                /*
        	"MutationObserver was explicitly designed to work that way, but I can't now recall the reasoning.
        	I think it might have been something along the lines that for consistency every setAttribute call should create a record.
        	Conceptually there is after all a mutation: there is an old value replaced with a new one,
        	and whether or not they are the same doesn't really matter.
        	And Custom elements should work the same way as MutationObserver."
        	https://github.com/whatwg/dom/issues/520#issuecomment-336574796
        */ const oldValue = mut.oldValue ?? undefined;
                const newValue = mut.attributeName ? mut.target.getAttribute(mut.attributeName) : undefined;
                if (oldValue !== newValue) onAttributeMutation({
                    target: mut.target,
                    attributeName: mut.attributeName ?? 'unknown',
                    oldValue: oldValue,
                    newValue: newValue,
                    timestamp: mut.timestamp || performance.now()
                });
                continue;
            } else if (mut.type === 'childList') {
                // In chromium browser MutationRecord has timestamp field, which we should use.
                const timestamp = Math.round(mut.timestamp || performance.now());
                // Get or create timestamp bucket
                let timestampBucket = batchedMutations.get(timestamp);
                if (!timestampBucket) {
                    timestampBucket = new Map();
                    batchedMutations.set(timestamp, timestampBucket);
                }
                // Get or create target batch within timestamp bucket
                let batch = timestampBucket.get(mut.target);
                if (!batch) {
                    batch = {
                        target: new WeakRef(mut.target),
                        addedNodes: [],
                        removedNodes: [],
                        timestamp: timestamp
                    };
                    timestampBucket.set(mut.target, batch);
                }
                // Accumulate added nodes
                (mut.addedNodes ?? []).forEach((node)=>{
                    if (node instanceof HTMLElement) batch.addedNodes.push(new WeakRef(node));
                });
                // Accumulate removed nodes
                (mut.removedNodes ?? []).forEach((node)=>{
                    if (node instanceof HTMLElement) batch.removedNodes.push(new WeakRef(node));
                });
            }
            targets.push(mut.target);
        }
        // Process all batched childList mutations
        for (const timestampBucket of batchedMutations.values())for (const batch of timestampBucket.values())onChildListMutation({
            target: batch.target,
            addedNodes: batch.addedNodes,
            removedNodes: batch.removedNodes,
            timestamp: batch.timestamp
        });
        onMutationFinished?.({
            targets: targets
        });
    };
    const observer = new MutationObserver(mutationObserverCallback);
    return observer;
}
var $ab26818beccecabb$export$2e2bcd8739ae039 = $ab26818beccecabb$var$createMutationObserver;

});

parcelRegister("1w31F", function(module, exports) {
$parcel$export(module.exports, "default", () => $ce3c22e3ce7e9b98$export$2e2bcd8739ae039);
// The LayoutShiftAttribution API is returning the numbers on physical dimension
function $ce3c22e3ce7e9b98$export$5e3f54cad8cb65e2(rect) {
    if (typeof window.devicePixelRatio !== 'number') return rect;
    if (window.devicePixelRatio === 1) return rect;
    // eslint-disable-next-line compat/compat
    return new DOMRect(rect.x / window.devicePixelRatio, rect.y / window.devicePixelRatio, rect.width / window.devicePixelRatio, rect.height / window.devicePixelRatio);
}
function $ce3c22e3ce7e9b98$var$createPerformanceObserver({ onLayoutShift: onLayoutShift }) {
    if (!window || typeof window.PerformanceObserver !== 'function') return null;
    const performanceObserverCallback = (entries)=>{
        for (const entry of entries.getEntries())if (entry.entryType === 'layout-shift' && 'sources' in entry) {
            // see https://developer.mozilla.org/en-US/docs/Web/API/LayoutShiftAttribution for more info
            const changedRects = entry.sources.reduceRight((acc, attr)=>{
                acc.push({
                    rect: $ce3c22e3ce7e9b98$export$5e3f54cad8cb65e2(attr.currentRect),
                    previousRect: $ce3c22e3ce7e9b98$export$5e3f54cad8cb65e2(attr.previousRect),
                    node: attr.node
                });
                return acc;
            }, []);
            onLayoutShift({
                time: entry.startTime,
                changedRects: changedRects
            });
        }
    };
    const observer = new PerformanceObserver(performanceObserverCallback);
    return observer;
}
var $ce3c22e3ce7e9b98$export$2e2bcd8739ae039 = $ce3c22e3ce7e9b98$var$createPerformanceObserver;

});

parcelRegister("fnVxM", function(module, exports) {
$parcel$export(module.exports, "cleanupCaches", () => $b44574b471c06d91$export$6a35c3789c327630);
$parcel$export(module.exports, "default", () => $b44574b471c06d91$export$2e2bcd8739ae039);

var $3X3Vo = parcelRequire("3X3Vo");

var $irOPS = parcelRequire("irOPS");

var $5xFdU = parcelRequire("5xFdU");

var $7qH31 = parcelRequire("7qH31");
const $b44574b471c06d91$var$DEFAULT_MAX_LEVEL = 20;
const $b44574b471c06d91$var$INCREASED_DOM_WALK_MAX_LEVEL = 40;
const $b44574b471c06d91$var$INCREASED_FIBER_WALK_MAX_LEVEL = 40;
function $b44574b471c06d91$var$getDomWalkMaxLevel() {
    return (0, $3X3Vo.fg)('platform_ufo_3p_forge_detection_fix') ? $b44574b471c06d91$var$INCREASED_DOM_WALK_MAX_LEVEL : $b44574b471c06d91$var$DEFAULT_MAX_LEVEL;
}
function $b44574b471c06d91$var$getFiberWalkMaxLevel() {
    return (0, $3X3Vo.fg)('platform_ufo_3p_forge_detection_fix') ? $b44574b471c06d91$var$INCREASED_FIBER_WALK_MAX_LEVEL : $b44574b471c06d91$var$DEFAULT_MAX_LEVEL;
}
// Cache cleanup
let $b44574b471c06d91$var$callCount = 0;
const $b44574b471c06d91$var$CLEANUP_THRESHOLD = 50;
function $b44574b471c06d91$var$maybeCleanup(resultCache) {
    $b44574b471c06d91$var$callCount++;
    if ($b44574b471c06d91$var$callCount >= $b44574b471c06d91$var$CLEANUP_THRESHOLD && (0, $irOPS.default)(0.3)) $b44574b471c06d91$export$6a35c3789c327630(resultCache);
}
function $b44574b471c06d91$export$6a35c3789c327630(resultCache) {
    resultCache = new WeakMap();
    $b44574b471c06d91$var$callCount = 0;
    return resultCache;
}
function $b44574b471c06d91$export$2e2bcd8739ae039(node, targetComponentName, resultCache) {
    $b44574b471c06d91$var$maybeCleanup(resultCache);
    if (resultCache.has(node)) return {
        isWithin: resultCache.get(node) ?? false
    };
    let fiber = null;
    let checkedNodes = [];
    const domWalkMaxLevel = $b44574b471c06d91$var$getDomWalkMaxLevel();
    // Always use cached fiber strategy to handle non-React elements reliably
    fiber = (0, $7qH31.default)(node, domWalkMaxLevel, checkedNodes);
    if (!fiber) {
        checkedNodes.forEach((checkedNode)=>{
            resultCache.set(checkedNode, false);
        });
        return {
            isWithin: false
        };
    }
    const isWithin = (0, $5xFdU.default)(fiber, targetComponentName, $b44574b471c06d91$var$getFiberWalkMaxLevel());
    checkedNodes.forEach((checkedNode)=>{
        resultCache.set(checkedNode, isWithin);
    });
    return {
        isWithin: isWithin
    };
}

});
parcelRegister("5xFdU", function(module, exports) {
$parcel$export(module.exports, "default", () => $c371e907df1b3688$export$2e2bcd8739ae039);

var $kjdRc = parcelRequire("kjdRc");
function $c371e907df1b3688$export$2e2bcd8739ae039(fiber, targetComponentName, maxLevel) {
    // Stop when no more levels to traverse
    if (maxLevel <= 0) return false;
    if (!fiber) return false;
    const componentName = (0, $kjdRc.default)(fiber);
    if (componentName === targetComponentName) return true;
    // Recursively traverse up the fiber tree
    return $c371e907df1b3688$export$2e2bcd8739ae039(fiber.return, targetComponentName, maxLevel - 1);
}

});
parcelRegister("kjdRc", function(module, exports) {
$parcel$export(module.exports, "default", () => $150adeb43676d35e$export$2e2bcd8739ae039);
// Helper function to extract component name from fiber
function $150adeb43676d35e$export$2e2bcd8739ae039(fiber) {
    const type = fiber?.type;
    if (!type) return undefined;
    if (typeof type === 'function' || typeof type === 'object') return type.displayName || type.name;
    return undefined;
}

});


parcelRegister("7qH31", function(module, exports) {
$parcel$export(module.exports, "default", () => $95bb2a55c51a22b5$export$2e2bcd8739ae039);

var $jbX8F = parcelRequire("jbX8F");
function $95bb2a55c51a22b5$export$2e2bcd8739ae039(element, maxLevel, checkedNodes) {
    // Stop when no more levels to traverse
    if (maxLevel <= 0) return null;
    checkedNodes.push(element);
    const fiber = (0, $jbX8F.default)(element);
    if (fiber) return fiber;
    // Walk up the DOM tree to find the fiber
    const parent = element.parentElement;
    if (!parent) return null;
    // Recursively check parent
    return $95bb2a55c51a22b5$export$2e2bcd8739ae039(parent, maxLevel - 1, checkedNodes);
}

});
parcelRegister("jbX8F", function(module, exports) {
$parcel$export(module.exports, "default", () => $94a48b9baa16bc6f$export$2e2bcd8739ae039);
// Helper function to find React fiber on an element
function $94a48b9baa16bc6f$export$2e2bcd8739ae039(element) {
    // Use for...in loop instead of Object.keys().find() to avoid creating an array
    for(const key in element){
        if (key.startsWith('__reactFiber$') || key.startsWith('__reactInternalInstance$')) return element[key];
    }
    return null;
}

});



parcelRegister("idMFp", function(module, exports) {
$parcel$export(module.exports, "isContainedWithinSmartAnswers", () => $00479fa875f8d8d5$export$16c2770458939f21);

var $1iuUn = parcelRequire("1iuUn");
function $00479fa875f8d8d5$export$16c2770458939f21(node) {
    const doc = (0, $1iuUn.getDocument)();
    if (!doc) return false;
    const smartAnswersElement = doc.getElementById('search-page-smart-answers');
    if (!smartAnswersElement) return false;
    // When the node is the smart answer element, .contains() still returns true
    return smartAnswersElement.contains(node);
}

});
parcelRegister("1iuUn", function(module, exports) {
$parcel$export(module.exports, "getDocument", () => $ba305d794b4e4580$export$f65ca476c09acec0);
const $ba305d794b4e4580$export$f65ca476c09acec0 = ()=>{
    if (typeof document !== 'undefined') return document;
    return null;
};

});


parcelRegister("et3zn", function(module, exports) {
$parcel$export(module.exports, "isElementVisible", () => $84b664b661b7d7c4$export$e989c0fffaa6b27a);
function $84b664b661b7d7c4$export$e989c0fffaa6b27a(element) {
    if (!(element instanceof HTMLElement)) return true;
    try {
        const visible = element.checkVisibility({
            // @ts-ignore - visibilityProperty may not exist in all TS environments
            visibilityProperty: true,
            contentVisibilityAuto: true,
            opacityProperty: true
        });
        return visible;
    } catch  {
        // there is no support for checkVisibility
        return true;
    }
}

});

parcelRegister("lgLxh", function(module, exports) {
$parcel$export(module.exports, "default", () => $06a541a4fb227973$export$2e2bcd8739ae039);
/**
 * Check if the element is in the VC ignore if no layout shift marker.
 * @param element - The element to check.
 * @returns True if the element has the data-vc-ignore-if-no-layout-shift attribute == 'true or its parent has it, false otherwise.
 */ function $06a541a4fb227973$export$2e2bcd8739ae039(element) {
    if (!element) return false;
    return element.getAttribute('data-vc-ignore-if-no-layout-shift') === 'true' || $06a541a4fb227973$export$2e2bcd8739ae039(element.parentElement);
}

});

parcelRegister("5TBjy", function(module, exports) {
$parcel$export(module.exports, "isInputNameMutation", () => $bf92c67932afce29$export$80a5724ceedcfd3d);
// Detecting this is required due to a React/Chromium bug, where React itself triggers an attribute mutation for input elements
// Reference: https://atlassian.slack.com/archives/C08EK6TCUP6/p1764129900970719
function $bf92c67932afce29$export$80a5724ceedcfd3d({ target: target, attributeName: attributeName, oldValue: oldValue, newValue: newValue }) {
    return target instanceof HTMLInputElement && attributeName === 'name' && (oldValue === '' || newValue === '');
}

});

parcelRegister("b8kGK", function(module, exports) {
$parcel$export(module.exports, "isSameRectDimensions", () => $e03c8ec486bbb3e1$export$fde63bc968551821);
const $e03c8ec486bbb3e1$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX = 1;
function $e03c8ec486bbb3e1$export$fde63bc968551821(a, b) {
    if (!a || !b) return false;
    return Math.abs(a.width - b.width) <= $e03c8ec486bbb3e1$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.height - b.height) <= $e03c8ec486bbb3e1$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.x - b.x) <= $e03c8ec486bbb3e1$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.y - b.y) <= $e03c8ec486bbb3e1$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX;
}

});

parcelRegister("8xkMf", function(module, exports) {
$parcel$export(module.exports, "isSameRectSize", () => $2b3c3693329fafa4$export$597b41700f7dcd36);
const $2b3c3693329fafa4$var$SIZE_CHECK_TOLERANCE_MARGIN_IN_PX = 1;
function $2b3c3693329fafa4$export$597b41700f7dcd36(a, b) {
    if (!a || !b) return false;
    return Math.abs(a.width - b.width) <= $2b3c3693329fafa4$var$SIZE_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.height - b.height) <= $2b3c3693329fafa4$var$SIZE_CHECK_TOLERANCE_MARGIN_IN_PX;
}

});


parcelRegister("g1o6y", function(module, exports) {
$parcel$export(module.exports, "default", () => $d37f204762ad9e0d$export$2e2bcd8739ae039);

var $Hyfcf = parcelRequire("Hyfcf");
class $d37f204762ad9e0d$export$2e2bcd8739ae039 {
    constructor(opts){
        this.unbindFns = [];
        this.onEvent = opts.onEvent;
    }
    bindEvent(type) {
        const unbindCallback = (0, $Hyfcf.bind)(window, {
            type: type,
            listener: (event)=>{
                if (!event.isTrusted) return;
                this.onEvent({
                    time: event.timeStamp,
                    type: type,
                    event: event
                });
            },
            options: {
                passive: true,
                once: true
            }
        });
        this.unbindFns.push(unbindCallback);
    }
    /**
   * Binds a scroll listener on `document` using the capture phase.
   * The `scroll` event does not bubble, so listening on `window` only catches
   * document-level scrolls. By using `{ capture: true }` on `document`, we can
   * detect scroll events from any element in the DOM tree, including inner
   * scrollable containers (e.g. when the user drags a scrollbar).
   */ bindCaptureScrollEvent() {
        const unbindCallback = (0, $Hyfcf.bind)(document, {
            type: 'scroll',
            listener: (event)=>{
                if (!event.isTrusted) return;
                this.onEvent({
                    time: event.timeStamp,
                    type: 'scroll-container',
                    event: event
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        this.unbindFns.push(unbindCallback);
    }
    start() {
        this.bindEvent('wheel');
        this.bindEvent('scroll');
        this.bindEvent('keydown');
        this.bindEvent('resize');
        this.bindCaptureScrollEvent();
    }
    stop() {
        this.unbindFns.forEach((cb)=>{
            cb();
        });
        this.unbindFns = [];
    }
}

});



parcelRegister("kp8di", function(module, exports) {
$parcel$export(module.exports, "interactions", () => $4af1f68ffcab9e62$export$cc97b17ef9aeb088);
const $4af1f68ffcab9e62$export$cc97b17ef9aeb088 = new Map();

});

parcelRegister("2Sm5I", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca881ad46aafda13$export$2e2bcd8739ae039);

var $9oQne = parcelRequire("9oQne");

var $kp8di = parcelRequire("kp8di");

var $dWn9F = parcelRequire("dWn9F");
class $ca881ad46aafda13$export$2e2bcd8739ae039 {
    initializeVCObserver(options) {
        this.vcObserver = new (0, $9oQne.VCObserverWrapper)({
            ...options,
            isPostInteraction: true
        });
    }
    startVCObserver({ startTime: startTime }, interactionId) {
        if (this.eligibleToMeasure(interactionId)) this.vcObserver?.start({
            startTime: startTime
        });
    }
    stopVCObserver() {
        this.vcObserver?.stop();
    }
    // Check if the current interaction is eligible for measurement
    eligibleToMeasure(interactionId) {
        const interaction = (0, $kp8di.interactions).get(interactionId);
        return interaction?.type === 'page_load' || interaction?.type === 'transition';
    }
    updateFinishedInteraction(interaction) {
        if (interaction?.type === 'page_load' || interaction?.type === 'transition') this.finishedInteraction = interaction;
    }
    setLastInteractionFinishVCResult(result) {
        this.lastInteractionFinishVCResult = result;
    }
    sinkHandler(fn) {
        this.sinkHandlerFn = fn;
    }
    onInteractionComplete(id, data) {
        if (data.ufoName) {
            const updatedData = {
                ...data,
                vcObserver: this.vcObserver ?? undefined
            };
            this.sinkHandlerFn(id, updatedData, this.finishedInteraction, this.lastInteractionFinishVCResult);
        }
        this.stopVCObserver();
        (0, $dWn9F.remove)(id);
        this.reset();
    }
    reset() {
        this.stopVCObserver();
        if (this.finishedInteraction?.id) (0, $dWn9F.remove)(this.finishedInteraction.id);
        this.finishedInteraction = null;
        this.lastInteractionFinishVCResult = undefined;
    }
    stopAll(id) {
        (0, $dWn9F.remove)(id);
        this.reset();
    }
    constructor(){
        // Store the finished interaction (as non-3p interaction)
        this.finishedInteraction = null;
        // independent VC observer, that observes until `custom.post-interaction-logs` event is sent
        this.vcObserver = null;
        this.sinkHandlerFn = ()=>{};
    }
}

});

parcelRegister("ggIEI", function(module, exports) {
$parcel$export(module.exports, "default", () => $2fc1cb0fba887bde$export$2e2bcd8739ae039);

var $dXdid = parcelRequire("dXdid");

var $fubJS = parcelRequire("fubJS");

var $9oQne = parcelRequire("9oQne");
const $2fc1cb0fba887bde$var$POST_INTERACTION_LOG_SEND_DEFAULT_TIMEOUT = 3000;
class $2fc1cb0fba887bde$export$2e2bcd8739ae039 {
    initializeVCObserver(options) {
        this.vcObserver = new (0, $9oQne.VCObserverWrapper)({
            ...options,
            isPostInteraction: true
        });
    }
    startVCObserver({ startTime: startTime }) {
        this.vcObserver?.start({
            startTime: startTime
        });
    }
    stopVCObserver() {
        this.vcObserver?.stop();
    }
    setVCObserverSSRConfig(vcObserverSSRConfig) {
        this.vcObserverSSRConfig = vcObserverSSRConfig;
    }
    /**
   * Set the VC result as per the last interaction
   * Used to compare diffs of VC updates vs post interaction VC observer
   * @param result - VC result as calculated by UFO create payload
   */ setLastInteractionFinishVCResult(result) {
        this.lastInteractionFinishVCResult = result;
    }
    /**
   * Set the fn that would be invoked to process / send the observation data
   */ sinkHandler(sinkHandlerFn) {
        this.sinkHandlerFn = sinkHandlerFn;
    }
    /**
   * Reset state of the log
   */ reset() {
        this.lastInteractionFinish = null;
        this.reactProfilerTimings = [];
        this.holdInfo = [];
        if (this.sinkTimeoutId != null) {
            clearTimeout(this.sinkTimeoutId);
            this.sinkTimeoutId = null;
        }
        this.setVCObserverSSRConfig(null);
    }
    /**
   * Check if there is data in the log
   */ hasData() {
        return this.reactProfilerTimings?.length > 0;
    }
    /**
   * Send the log if there is data
   */ async sendPostInteractionLog() {
        if (!this.lastInteractionFinish || !this.sinkHandlerFn) {
            this.reset();
            this.vcObserver?.stop();
            return;
        }
        const pageVisibilityState = (0, $fubJS.getPageVisibilityState)(this.lastInteractionFinish.start, this.lastInteractionFinish.end);
        const isPageVisible = pageVisibilityState === 'visible';
        const config = (0, $dXdid.getConfig)();
        const postInteractionFinishVCResult = await this.vcObserver?.getVCResult({
            start: this.lastInteractionFinish.start,
            stop: performance.now(),
            tti: -1,
            // no need for TTI value here
            isEventAborted: !!this.lastInteractionFinish.abortReason,
            prefix: 'ufo',
            experienceKey: this.lastInteractionFinish.ufoName,
            interactionId: this.lastInteractionFinish.id,
            includeSSRInV3: config?.vc?.includeSSRInV3,
            includeSSRRatio: config?.vc?.includeSSRRatio,
            ...this.vcObserverSSRConfig,
            interactionType: this.lastInteractionFinish.type,
            isPageVisible: isPageVisible,
            interactionAbortReason: this.lastInteractionFinish.abortReason
        });
        this.vcObserver?.stop();
        this.sinkHandlerFn({
            lastInteractionFinish: this.lastInteractionFinish,
            reactProfilerTimings: this.reactProfilerTimings,
            postInteractionFinishVCResult: postInteractionFinishVCResult,
            lastInteractionFinishVCResult: this.lastInteractionFinishVCResult,
            postInteractionHoldInfo: this.holdInfo
        });
        this.reset();
    }
    /**
   * This fn should be invoked when an interaction has finished
   * Basic details about the finished interaction will be recorded
   * A timeout will be setup to send the post interaction observation after some time.
   */ onInteractionComplete({ ufoName: ufoName, start: start, end: end, id: id, abortReason: abortReason, abortedByInteractionName: abortedByInteractionName, routeName: routeName, type: type, experimentalTTAI: experimentalTTAI, experimentalVC90: experimentalVC90, errors: errors }) {
        this.lastInteractionFinish = {
            ufoName: ufoName,
            start: start,
            end: end,
            id: id,
            abortReason: abortReason,
            abortedByInteractionName: abortedByInteractionName,
            routeName: routeName,
            type: type,
            experimentalTTAI: experimentalTTAI,
            experimentalVC90: experimentalVC90,
            errors: errors
        };
        const timeout = (0, $dXdid.getConfig)()?.timeWindowForLateMutationsInMilliseconds || $2fc1cb0fba887bde$var$POST_INTERACTION_LOG_SEND_DEFAULT_TIMEOUT;
        this.sinkTimeoutId = window.setTimeout(async ()=>{
            await this.sendPostInteractionLog();
        }, timeout);
    }
    /**
   * This fn should be invoked when a React render happens after interaction has finished
   */ addProfilerTimings(labelStack, type, actualDuration, baseDuration, startTime, commitTime) {
        if (this.lastInteractionFinish != null) this.reactProfilerTimings.push({
            type: type,
            actualDuration: actualDuration,
            baseDuration: baseDuration,
            startTime: startTime,
            commitTime: commitTime,
            labelStack: labelStack
        });
    }
    addHoldInfo(labelStack, name, start) {
        this.holdInfo.push({
            name: name,
            labelStack: labelStack,
            start: start
        });
    }
    constructor(){
        /**
   * Basic info about interaction that has just finished
   */ this.lastInteractionFinish = null;
        /**
   * Array of observed react render timings
   */ this.reactProfilerTimings = [];
        /**
   * Store the scheduled sink timeout Id so that it can be cancelled when needed
   */ this.sinkTimeoutId = null;
        this.holdInfo = [];
        /**
   * independent VC observer, that observes until `custom.post-interaction-logs` event is sent
   */ this.vcObserver = null;
        this.vcObserverSSRConfig = null;
        /**
   * Handler function to process / send the observation data
   */ this.sinkHandlerFn = ()=>{};
    }
}

});


parcelRegister("4iBoC", function(module, exports) {
$parcel$export(module.exports, "attachAbortListeners", () => $2cdbb570f80c77b3$export$9010aa71841a6887);

var $Hyfcf = parcelRequire("Hyfcf");

var $lFncX = parcelRequire("lFncX");

var $etRaB = parcelRequire("etRaB");
function $2cdbb570f80c77b3$export$9010aa71841a6887(window, initialViewPort, callback) {
    const unbindWheel = (0, $Hyfcf.bind)(window, {
        type: (0, $lFncX.AbortEvent).wheel,
        listener: (e)=>{
            callback((0, $lFncX.AbortEvent).wheel, e.timeStamp);
        },
        options: {
            passive: true,
            once: true
        }
    });
    const unbindKeydown = (0, $Hyfcf.bind)(window, {
        type: (0, $lFncX.AbortEvent).keydown,
        listener: (e)=>{
            callback((0, $lFncX.AbortEvent).keydown, e.timeStamp);
        },
        options: {
            once: true
        }
    });
    const unbindResize = (0, $Hyfcf.bind)(window, {
        type: (0, $lFncX.AbortEvent).resize,
        listener: (e)=>{
            if ((0, $etRaB.getViewportWidth)() !== initialViewPort.w || (0, $etRaB.getViewportHeight)() !== initialViewPort.h) {
                callback((0, $lFncX.AbortEvent).resize, e.timeStamp);
                unbindResize();
            }
        }
    });
    return [
        unbindWheel,
        unbindKeydown,
        unbindResize
    ];
}

});
parcelRegister("lFncX", function(module, exports) {
$parcel$export(module.exports, "AbortEvent", () => $28ebf95b2cc4cebd$export$199edc0307b5587f);
const $28ebf95b2cc4cebd$export$199edc0307b5587f = {
    wheel: 'wheel',
    keydown: 'keydown',
    resize: 'resize'
};

});

parcelRegister("etRaB", function(module, exports) {
$parcel$export(module.exports, "getViewportWidth", () => $f6e047ffb2d0e58d$export$a497a1dcb4408212);
$parcel$export(module.exports, "getViewportHeight", () => $f6e047ffb2d0e58d$export$4f01c15d21ef9cc6);
function $f6e047ffb2d0e58d$export$a497a1dcb4408212(document = window.document) {
    let documentWidth;
    try {
        documentWidth = document.documentElement.clientWidth || 0;
    } catch  {
        documentWidth = 0;
    }
    return Math.max(documentWidth, window.innerWidth || 0);
}
function $f6e047ffb2d0e58d$export$4f01c15d21ef9cc6(document = window.document) {
    let documentHeight;
    try {
        documentHeight = document.documentElement.clientHeight || 0;
    } catch  {
        documentHeight = 0;
    }
    return Math.max(documentHeight, window.innerHeight || 0);
}

});


parcelRegister("fUPSA", function(module, exports) {
$parcel$export(module.exports, "getVCRevisionDebugDetails", () => $6c005d06ca9e1dcb$export$72e6dda9d5859230);
function $6c005d06ca9e1dcb$export$72e6dda9d5859230({ revision: revision, isClean: isClean, abortReason: abortReason, VCEntries: VCEntries, componentsLog: componentsLog, interactionId: interactionId }) {
    // Pre-sort VCEntries by time for efficient lookups
    const sortedVCEntries = [
        ...VCEntries
    ].sort((a, b)=>a.time - b.time);
    // Pre-calculate max viewport percentage up to each time for efficient lookups
    const maxViewportPercentageAtTime = new Map();
    let maxSoFar = 0;
    for (const entry of sortedVCEntries){
        maxSoFar = Math.max(maxSoFar, entry.vc);
        maxViewportPercentageAtTime.set(entry.time, maxSoFar);
    }
    // Helper function to find the biggest previous viewport percentage
    const getBiggestPreviousViewportPercentage = (targetTime)=>{
        // Binary search for the largest time <= targetTime
        let left = 0;
        let right = sortedVCEntries.length - 1;
        let result = -1;
        while(left <= right){
            const mid = Math.floor((left + right) / 2);
            if (sortedVCEntries[mid].time <= targetTime) {
                result = mid;
                left = mid + 1;
            } else right = mid - 1;
        }
        return result >= 0 ? maxViewportPercentageAtTime.get(sortedVCEntries[result].time) || null : null;
    };
    const allVcLogs = [];
    // Add regular VC entries
    for (const entry of VCEntries){
        const timeLogEntries = componentsLog[entry.time];
        allVcLogs.push({
            time: entry.time,
            viewportPercentage: entry.vc,
            entries: entry.elements.map((element)=>{
                const logEntry = timeLogEntries?.find((log)=>log.targetName === element);
                return {
                    elementName: element,
                    type: logEntry?.type,
                    rect: logEntry?.intersectionRect,
                    visible: true,
                    attributeName: logEntry?.attributeName,
                    oldValue: logEntry?.oldValue,
                    newValue: logEntry?.newValue,
                    ignoreReason: logEntry?.ignoreReason
                };
            })
        });
    }
    // Add ignored elements - only process timestamps that have ignored elements
    for (const [timestamp, timeLogEntries] of Object.entries(componentsLog)){
        const ignoredElements = timeLogEntries.filter((log)=>log.ignoreReason);
        if (ignoredElements.length === 0) continue;
        const time = Number(timestamp);
        const viewportPercentage = getBiggestPreviousViewportPercentage(time);
        allVcLogs.push({
            time: time,
            viewportPercentage: viewportPercentage,
            entries: ignoredElements.map((logEntry)=>({
                    elementName: logEntry.targetName,
                    type: logEntry.type,
                    rect: logEntry.intersectionRect,
                    visible: false,
                    attributeName: logEntry.attributeName,
                    oldValue: logEntry.oldValue,
                    newValue: logEntry.newValue,
                    ignoreReason: logEntry.ignoreReason
                }))
        });
    }
    // Sort once at the end
    allVcLogs.sort((a, b)=>a.time - b.time);
    return {
        revision: revision,
        isClean: isClean,
        abortReason: abortReason,
        vcLogs: allVcLogs,
        interactionId: interactionId
    };
}

});

parcelRegister("76Plu", function(module, exports) {
$parcel$export(module.exports, "getVCRevisionsData", () => $e26c895dd9bbab87$export$5c86a34c9becd6d0);

var $dXdid = parcelRequire("dXdid");

var $fubJS = parcelRequire("fubJS");
const $e26c895dd9bbab87$var$VCParts = [
    '25',
    '50',
    '75',
    '80',
    '85',
    '90',
    '95',
    '98',
    '99'
];
const $e26c895dd9bbab87$var$READONLY_EMPTY_ARRAY = Array.from({
    length: 0
});
// Helper function to create vcDetails object to avoid code duplication
function $e26c895dd9bbab87$var$createVCDetails(calculatedVC, shouldHaveVCmetric) {
    if (!shouldHaveVCmetric || !calculatedVC || !calculatedVC.VC || !calculatedVC.VCBox) return {};
    const details = {};
    const { VC: VC, VCBox: VCBox } = calculatedVC; // Destructure once to avoid repeated property access
    for (const key of $e26c895dd9bbab87$var$VCParts)details[key] = {
        t: VC[key] || -1,
        e: VCBox[key] || $e26c895dd9bbab87$var$READONLY_EMPTY_ARRAY
    };
    return details;
}
function $e26c895dd9bbab87$export$5c86a34c9becd6d0({ fullPrefix: fullPrefix, interaction: interaction, isVCClean: isVCClean, isEventAborted: isEventAborted, calculatedVC: calculatedVC, calculatedVCNext: calculatedVCNext, experienceKey: experienceKey, ratios: ratios }) {
    const pageVisibilityUpToTTAI = (0, $fubJS.getPageVisibilityState)(interaction.start, interaction.end);
    const isVisiblePageVisibleUpToTTAI = pageVisibilityUpToTTAI === 'visible';
    const shouldHaveVCmetric = isVCClean && !isEventAborted && isVisiblePageVisibleUpToTTAI;
    const availableVCRevisionPayloads = [];
    if ((0, $dXdid.isVCRevisionEnabled)('fy25.01', experienceKey)) {
        const revision = {
            revision: 'fy25.01',
            clean: isVCClean,
            'metric:vc90': shouldHaveVCmetric ? calculatedVC.VC['90'] : null,
            vcDetails: $e26c895dd9bbab87$var$createVCDetails(calculatedVC, shouldHaveVCmetric)
        };
        if (shouldHaveVCmetric) revision.ratios = ratios;
        availableVCRevisionPayloads.push(revision);
    }
    if ((0, $dXdid.isVCRevisionEnabled)('fy25.02', experienceKey)) {
        const revision = {
            revision: 'fy25.02',
            clean: isVCClean,
            'metric:vc90': shouldHaveVCmetric ? calculatedVCNext.VC['90'] : null,
            vcDetails: $e26c895dd9bbab87$var$createVCDetails(calculatedVCNext, shouldHaveVCmetric)
        };
        if (shouldHaveVCmetric) revision.ratios = ratios;
        availableVCRevisionPayloads.push(revision);
    }
    return {
        [`${fullPrefix}vc:rev`]: availableVCRevisionPayloads
    };
}

});

parcelRegister("fiBcB", function(module, exports) {
$parcel$export(module.exports, "Observers", () => $ddd2d51a20014e0c$export$b65d046240060e78);

var $dXdid = parcelRequire("dXdid");

var $79qE1 = parcelRequire("79qE1");

var $2V5Fg = parcelRequire("2V5Fg");

var $3AhO2 = parcelRequire("3AhO2");

var $7uaw7 = parcelRequire("7uaw7");
const $ddd2d51a20014e0c$var$state = {
    normal: 1,
    waitingForFirstRender: 2,
    ignoring: 3
};
function $ddd2d51a20014e0c$var$isElementVisible(target) {
    if (!target || typeof target.checkVisibility !== 'function') return true;
    const isVisible = target.checkVisibility({
        contentVisibilityAuto: true,
        opacityProperty: true,
        visibilityProperty: true
    });
    return isVisible;
}
class $ddd2d51a20014e0c$export$b65d046240060e78 {
    constructor(opts){
        this.observedMutations = new WeakMap();
        this.elementsInView = new Set();
        this.callbacks = new Set();
        this.totalTime = 0;
        this._startMeasureTimestamp = -1;
        this.ssr = {
            state: $ddd2d51a20014e0c$var$state.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        };
        this.selectorConfig = {
            id: false,
            testId: false,
            role: false,
            className: true,
            dataVC: true
        };
        this.subscribeResults = (cb)=>{
            this.callbacks.add(cb);
        };
        this.observeElement = (node, mutation, type, ignoreReason, attributeName, oldValue = null, newValue = null)=>{
            this.intersectionObserver?.observe(node);
            this.observedMutations.set(node, {
                mutation: mutation,
                ignoreReason: ignoreReason,
                type: type,
                attributeName: attributeName,
                oldValue: oldValue,
                newValue: newValue
            });
        };
        // Selector-config resolution is centralised in `getSelectorConfig()`.
        // It enforces FedRAMP-override > caller-override > centrally
        // configured > caller default, gated by
        // `platform_ufo_fedramp_overrides`. When the gate is OFF the helper
        // returns `opts.selectorConfig ?? config?.vc?.selectorConfig`, and we
        // fall back to the historical merge — byte-for-byte unchanged from
        // pre-FedRAMP behaviour.
        const resolved = (0, $dXdid.getSelectorConfig)(opts.selectorConfig, this.selectorConfig);
        this.selectorConfig = resolved ?? {
            ...this.selectorConfig,
            ...opts.selectorConfig
        };
        this.intersectionObserver = this.getIntersectionObserver();
        this.mutationObserver = this.getMutationObserver();
        // Use shared SSR placeholder handler if provided, otherwise create new one
        if (opts.ssrPlaceholderHandler) this.ssrPlaceholderHandler = opts.ssrPlaceholderHandler;
        else this.ssrPlaceholderHandler = new (0, $7uaw7.SSRPlaceholderHandlers)({
            enablePageLayoutPlaceholder: opts.SSRConfig?.enablePageLayoutPlaceholder
        });
    }
    isBrowserSupported() {
        return typeof window.IntersectionObserver === 'function' && typeof window.MutationObserver === 'function';
    }
    observe() {
        this.totalTime = 0;
        this.ssr = {
            state: $ddd2d51a20014e0c$var$state.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        };
        this.mutationObserver?.observe(document.body, {
            attributeFilter: [
                'hidden',
                'style',
                'src',
                'class'
            ],
            attributeOldValue: true,
            attributes: true,
            childList: true,
            subtree: true
        });
    }
    disconnect() {
        this.mutationObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        this.observedMutations = new WeakMap();
        this.elementsInView.clear();
        this.callbacks.clear();
        this.ssr.reactRootElement = null;
        this.ssrPlaceholderHandler.clear();
    }
    getTotalTime() {
        return this.totalTime;
    }
    setReactRootElement(element) {
        this.ssr.reactRootElement = element;
    }
    setReactRootRenderStart(startTime = performance.now()) {
        this.ssr.renderStart = startTime;
        this.ssr.state = $ddd2d51a20014e0c$var$state.waitingForFirstRender;
    }
    setReactRootRenderStop(stopTime = performance.now()) {
        this.ssr.renderStop = stopTime;
    }
    getMutationObserver() {
        if (!this.isBrowserSupported()) return null;
        return new MutationObserver((mutations)=>{
            this.measureStart();
            mutations.forEach((mutation)=>{
                // patching element if timestamp not automatically added
                // eslint-disable-next-line no-param-reassign
                mutation.timestamp = mutation.timestamp === undefined ? performance.now() : mutation.timestamp;
                let ignoreReason = '';
                if (this.ssr.state === $ddd2d51a20014e0c$var$state.waitingForFirstRender && mutation.timestamp > this.ssr.renderStart && mutation.target === this.ssr.reactRootElement) {
                    this.ssr.state = $ddd2d51a20014e0c$var$state.ignoring;
                    if (this.ssr.renderStop === -1) // arbitrary 500ms DOM update window
                    this.ssr.renderStop = mutation.timestamp + 500;
                    ignoreReason = 'ssr-hydration';
                }
                if (this.ssr.state === $ddd2d51a20014e0c$var$state.ignoring && mutation.timestamp > this.ssr.renderStart && mutation.target === this.ssr.reactRootElement) {
                    if (mutation.timestamp <= this.ssr.renderStop) ignoreReason = 'ssr-hydration';
                    else this.ssr.state = $ddd2d51a20014e0c$var$state.normal;
                }
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach((node)=>{
                        if ((0, $79qE1.isContainedWithinMediaWrapper)(node)) ignoreReason = 'image';
                        if (node instanceof HTMLElement) {
                            if (this.ssrPlaceholderHandler.isPlaceholder(node) || this.ssrPlaceholderHandler.isPlaceholderIgnored(node)) {
                                this.ssrPlaceholderHandler.checkIfExistedAndSizeMatching(node).then((result)=>{
                                    if (result === false) this.observeElement(node, mutation, 'html', ignoreReason);
                                });
                                return;
                            }
                            if (this.ssrPlaceholderHandler.isPlaceholderReplacement(node) || this.ssrPlaceholderHandler.isPlaceholderIgnored(node)) {
                                this.ssrPlaceholderHandler.validateReactComponentMatchToPlaceholder(node).then((result)=>{
                                    if (result === false) this.observeElement(node, mutation, 'html', ignoreReason);
                                });
                                return;
                            }
                            this.observeElement(node, mutation, 'html', ignoreReason);
                        }
                        if (node instanceof Text && node.parentElement != null) this.observeElement(node.parentElement, mutation, 'text', ignoreReason);
                    });
                    mutation.removedNodes.forEach((node)=>{
                        if (node instanceof Element) {
                            this.elementsInView.delete(node);
                            this.intersectionObserver?.unobserve(node);
                        }
                    });
                } else if (mutation.type === 'attributes') {
                    if (mutation.target instanceof HTMLElement) {
                        const attributeName = mutation.attributeName;
                        /*
            	"MutationObserver was explicitly designed to work that way, but I can't now recall the reasoning.
            	I think it might have been something along the lines that for consistency every setAttribute call should create a record.
            	Conceptually there is after all a mutation: there is an old value replaced with a new one,
            	and whether or not they are the same doesn't really matter.
            	And Custom elements should work the same way as MutationObserver."
            	https://github.com/whatwg/dom/issues/520#issuecomment-336574796
            */ const oldValue = mutation.oldValue ?? undefined;
                        const newValue = attributeName ? mutation.target.getAttribute(attributeName) : undefined;
                        if (oldValue !== newValue) {
                            if ((0, $2V5Fg.default)(mutation)) ignoreReason = 'non-visual-style';
                            if ((0, $79qE1.isContainedWithinMediaWrapper)(mutation.target)) ignoreReason = 'image';
                            this.observeElement(mutation.target, mutation, 'attr', ignoreReason, attributeName, oldValue, newValue);
                        }
                    }
                }
            });
        });
    }
    getElementName(element) {
        try {
            const tagName = element.localName;
            const dataVCAttr = element.getAttribute('data-vc');
            const dataVC = this.selectorConfig.dataVC && dataVCAttr ? `[data-vc="${dataVCAttr}"]` : '';
            const id = this.selectorConfig.id && element.id ? `#${element.id}` : '';
            let testId = this.selectorConfig.testId ? element.getAttribute('data-testid') || element.getAttribute('data-test-id') : '';
            testId = testId ? `[testid=${testId}]` : '';
            let role = this.selectorConfig.role ? element.getAttribute('role') : '';
            role = role ? `[role=${role}]` : '';
            let classList = this.selectorConfig.className ? Array.from(element.classList).join('.') : '';
            classList = classList === '' ? '' : `.${classList}`;
            const attrs = dataVC ? dataVC : [
                id,
                testId,
                role
            ].join('');
            let idString = '';
            if (attrs === '' && classList === '') {
                const parent = element.parentElement ? this.getElementName(element.parentElement) : 'unknown';
                idString = `${parent} > ${tagName}`;
            } else idString = [
                tagName,
                attrs || classList
            ].join('');
            return idString;
        } catch  {
            return 'error';
        }
    }
    getIntersectionObserver() {
        if (!this.isBrowserSupported()) return null;
        return new IntersectionObserver((entries)=>{
            this.measureStart();
            entries.forEach(({ isIntersecting: isIntersecting, intersectionRect: ir, target: target })=>{
                const data = this.observedMutations.get(target);
                this.observedMutations.delete(target);
                if (isIntersecting && ir.width > 0 && ir.height > 0) {
                    if (!(target instanceof HTMLElement)) return;
                    if (!data?.mutation) // ignore intersection report without recent mutation
                    return;
                    if (!$ddd2d51a20014e0c$var$isElementVisible(target)) data.ignoreReason = 'not-visible';
                    if ((0, $3AhO2.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(ir)) data.ignoreReason = 'rll-placeholder';
                    this.callbacks.forEach((callback)=>{
                        let elementName;
                        try {
                            elementName = this.getElementName(target);
                        } catch  {
                            elementName = 'error';
                        }
                        callback(data.mutation.timestamp || performance.now(), ir, elementName, target, data.type, data.ignoreReason, data.attributeName, data.oldValue, data.newValue);
                    });
                    this.elementsInView.add(target);
                } else this.elementsInView.delete(target);
            });
            this.measureStop();
        });
    }
    measureStart() {
        this._startMeasureTimestamp = performance.now();
    }
    measureStop() {
        if (this._startMeasureTimestamp === -1) return;
        this.totalTime += performance.now() - this._startMeasureTimestamp;
        this._startMeasureTimestamp = -1;
    }
}

});



parcelRegister("bCt4g", function(module, exports) {
$parcel$export(module.exports, "getPerformanceObserver", () => $7cd40b0ec6631fee$export$17afbba0f16b4b19);

var $dXdid = parcelRequire("dXdid");

var $dWn9F = parcelRequire("dWn9F");

var $f1j3F = parcelRequire("f1j3F");
let $7cd40b0ec6631fee$var$performanceEventObserver;
const $7cd40b0ec6631fee$var$DEFAULT_SELECTOR_CONFIG = {
    id: true,
    testId: true,
    role: true,
    className: true
};
/**
 * Resolve the SelectorConfig for the performance-observer code path.
 *
 * In FedRAMP Moderate environments (when `getSelectorConfig()` returns the
 * forced all-`false` config) we honour that override; otherwise we fall back
 * to the historical default that enables every selector.
 */ function $7cd40b0ec6631fee$var$resolveSelectorConfig() {
    return (0, $dXdid.getSelectorConfig)() ?? $7cd40b0ec6631fee$var$DEFAULT_SELECTOR_CONFIG;
}
function $7cd40b0ec6631fee$var$getTestIdName(memoizedProps) {
    if (memoizedProps['data-testid']) return `[data-testid=${memoizedProps['data-testid']}]`;
    else if (memoizedProps['data-test-id']) return `[data-test-id=${memoizedProps['data-testid']}]`;
    else if (memoizedProps['data-vc']) return `[data-vc=${memoizedProps['data-vc']}]`;
    return null;
}
function $7cd40b0ec6631fee$var$getUFOSegmentName(componentName, memoizedProps) {
    if (memoizedProps && memoizedProps['name']) return `UFOSegment[name=${memoizedProps['name']}]`;
    return componentName;
}
function $7cd40b0ec6631fee$var$getReactComponentHierarchy(element) {
    const componentHierarchy = [];
    // Function to traverse up the fiber tree
    function traverseFiber(fiber) {
        let currentFiber = fiber;
        while(currentFiber){
            if (currentFiber.type) {
                // Check if there's a display name or a function name
                const componentName = currentFiber.type.displayName || currentFiber.type.name;
                // checking when component name is bigger than the minimized name produced by react
                if (componentName && componentName.length > 2 && !componentName.includes('Listener') && !componentName.includes('Provider')) {
                    if (componentName === 'UFOSegment') {
                        componentHierarchy.push($7cd40b0ec6631fee$var$getUFOSegmentName(componentName, currentFiber.memoizedProps));
                        break;
                    }
                    componentHierarchy.push(componentName);
                }
            }
            if (currentFiber.memoizedProps) {
                const dataIdInfo = $7cd40b0ec6631fee$var$getTestIdName(currentFiber.memoizedProps);
                if (dataIdInfo) {
                    componentHierarchy.push(dataIdInfo);
                    currentFiber = null;
                    continue;
                }
            }
            currentFiber = currentFiber.return;
        }
    }
    // Access the reactFiber node from the HTML element
    const reactFiberKey = Object.keys(element).find((key)=>key.startsWith('__reactFiber$'));
    if (reactFiberKey) {
        const fiber = element[reactFiberKey];
        traverseFiber(fiber);
    }
    return componentHierarchy.reverse().join(' > ');
}
const $7cd40b0ec6631fee$export$17afbba0f16b4b19 = ()=>{
    $7cd40b0ec6631fee$var$performanceEventObserver = $7cd40b0ec6631fee$var$performanceEventObserver || new PerformanceObserver((entries)=>{
        const list = entries.getEntries();
        for (let entry of list)if (entry.name === 'click') $7cd40b0ec6631fee$export$e6be05b411ce21a6(entry);
    });
    return $7cd40b0ec6631fee$var$performanceEventObserver;
};
const $7cd40b0ec6631fee$export$e6be05b411ce21a6 = (entry)=>{
    const interaction = (0, $dWn9F.getActiveInteraction)();
    if (interaction?.type === 'press') {
        if (!interaction.responsiveness?.experimentalInputToNextPaint) {
            interaction.responsiveness = {
                ...interaction.responsiveness,
                experimentalInputToNextPaint: interaction.responsiveness?.experimentalInputToNextPaint || entry.duration,
                inputDelay: interaction.responsiveness?.inputDelay || entry.processingStart - entry.startTime
            };
            if (interaction.ufoName === 'unknown') {
                if (entry.target) {
                    const componentHierarchy = $7cd40b0ec6631fee$var$getReactComponentHierarchy(entry.target);
                    interaction.unknownElementHierarchy = componentHierarchy;
                }
                interaction.unknownElementName = (0, $f1j3F.default)($7cd40b0ec6631fee$var$resolveSelectorConfig(), entry.target);
            }
        }
    }
};

});
parcelRegister("f1j3F", function(module, exports) {
$parcel$export(module.exports, "default", () => $7fc157a9c4149f3d$export$2e2bcd8739ae039);
const $7fc157a9c4149f3d$var$nameCache = new WeakMap();
function $7fc157a9c4149f3d$var$getAttributeSelector(element, attributeName) {
    const attrValue = element.getAttribute(attributeName);
    if (!attrValue) return '';
    return `[${attributeName}="${attrValue}"]`;
}
function $7fc157a9c4149f3d$var$isValidSelector(selector) {
    try {
        document.querySelector(selector);
        return true;
    } catch  {
        return false;
    }
}
function $7fc157a9c4149f3d$var$isSelectorUnique(selector) {
    return document.querySelectorAll(selector).length === 1;
}
function $7fc157a9c4149f3d$var$getUniqueSelector(selectorConfig, element) {
    let currentElement = element;
    const parts = [];
    const MAX_DEPTH = 3;
    let currentDepth = 0;
    while(currentElement && currentElement.localName !== 'body' && currentDepth <= MAX_DEPTH){
        const tagName = currentElement.localName;
        let selectorPart = tagName;
        if (selectorConfig.id && currentElement.id && $7fc157a9c4149f3d$var$isValidSelector(`#${currentElement.id}`)) selectorPart += `#${currentElement.id}`;
        else if (selectorConfig.dataVC) selectorPart += $7fc157a9c4149f3d$var$getAttributeSelector(currentElement, 'data-vc');
        else if (selectorConfig.testId) selectorPart += $7fc157a9c4149f3d$var$getAttributeSelector(currentElement, 'data-testid') || $7fc157a9c4149f3d$var$getAttributeSelector(currentElement, 'data-test-id');
        else if (selectorConfig.role) selectorPart += $7fc157a9c4149f3d$var$getAttributeSelector(currentElement, 'role');
        else if (selectorConfig.className && currentElement.className) {
            const classNames = Array.from(currentElement.classList).join('.');
            if (classNames) {
                if ($7fc157a9c4149f3d$var$isValidSelector(`.${classNames}`)) selectorPart += `.${classNames}`;
            }
        }
        parts.unshift(selectorPart);
        const potentialSelector = parts.join(' > ').trim();
        if (potentialSelector && $7fc157a9c4149f3d$var$isSelectorUnique(potentialSelector)) return potentialSelector;
        currentElement = currentElement.parentElement;
        currentDepth++;
    }
    const potentialSelector = parts.join(' > ').trim();
    if (!potentialSelector) return 'unknown';
    else if (!$7fc157a9c4149f3d$var$isSelectorUnique(potentialSelector)) {
        const parentElement = element.parentElement;
        if (parentElement) return `${potentialSelector}:nth-child`; // NOTE: invalid DOM selector, but enough information for VC
    }
    return potentialSelector;
}
function $7fc157a9c4149f3d$var$getElementName(selectorConfig, element) {
    if (!(element instanceof HTMLElement)) return 'error';
    const cachedName = $7fc157a9c4149f3d$var$nameCache.get(element);
    if (cachedName) return cachedName;
    const uniqueSelector = $7fc157a9c4149f3d$var$getUniqueSelector(selectorConfig, element);
    $7fc157a9c4149f3d$var$nameCache.set(element, uniqueSelector);
    return uniqueSelector;
}
var $7fc157a9c4149f3d$export$2e2bcd8739ae039 = $7fc157a9c4149f3d$var$getElementName;

});


parcelRegister("CBD6A", function(module, exports) {
$parcel$export(module.exports, "createPressureStateReport", () => $4893ccc56ddd0620$export$1f0ff35da084986e);
$parcel$export(module.exports, "createMemoryStateReport", () => $4893ccc56ddd0620$export$3b47ebb9832b4e24);
$parcel$export(module.exports, "initialisePressureObserver", () => $4893ccc56ddd0620$export$117ebc554c6e9f2f);
$parcel$export(module.exports, "initialiseMemoryObserver", () => $4893ccc56ddd0620$export$a3271f53e91faab7);
const $4893ccc56ddd0620$var$BUFFER_MAX_LENGTH = 1000; // ensure we don't blow up this buffer
let $4893ccc56ddd0620$var$pressureRecordBuffer = [];
let $4893ccc56ddd0620$var$pressureObserver = null;
let $4893ccc56ddd0620$var$memoryRecordBuffer = [];
let $4893ccc56ddd0620$var$memoryInterval;
function $4893ccc56ddd0620$export$6c1060bed5fea050() {
    $4893ccc56ddd0620$var$pressureRecordBuffer.length = 0;
}
function $4893ccc56ddd0620$export$aa672c7221b183b0() {
    $4893ccc56ddd0620$var$memoryRecordBuffer.length = 0;
}
function $4893ccc56ddd0620$export$ec86686c1d2e65bc(filter) {
    $4893ccc56ddd0620$var$pressureRecordBuffer = $4893ccc56ddd0620$var$pressureRecordBuffer.filter(({ time: time })=>time > filter);
}
function $4893ccc56ddd0620$export$c0142ac82f5d0c28(filter) {
    $4893ccc56ddd0620$var$memoryRecordBuffer = $4893ccc56ddd0620$var$memoryRecordBuffer.filter(({ time: time })=>time > filter);
}
function $4893ccc56ddd0620$export$1f0ff35da084986e(start, end) {
    try {
        // To differentiate between the API not available, vs no PressureRecords added
        if (!('PressureObserver' in globalThis)) return null;
        const pressureStateCount = $4893ccc56ddd0620$var$pressureRecordBuffer.reduce((pressureReport, { time: time, state: state })=>{
            if (time >= start && time <= end) pressureReport[state] += 1;
            return pressureReport;
        }, {
            nominal: 0,
            fair: 0,
            serious: 0,
            critical: 0
        });
        const pressureStateTotal = Object.values(pressureStateCount).reduce((total, count)=>total + count) || 1;
        $4893ccc56ddd0620$export$ec86686c1d2e65bc(end);
        return {
            count: pressureStateCount,
            percentage: {
                nominal: Math.round(pressureStateCount.nominal / pressureStateTotal * 100),
                fair: Math.round(pressureStateCount.fair / pressureStateTotal * 100),
                serious: Math.round(pressureStateCount.serious / pressureStateTotal * 100),
                critical: Math.round(pressureStateCount.critical / pressureStateTotal * 100)
            }
        };
    } catch  {
        return null;
    }
}
function $4893ccc56ddd0620$var$convertBytesToMegabytes(bytes) {
    return Math.round(Math.round(bytes / 1048576 * 100) / 100);
}
function $4893ccc56ddd0620$export$3b47ebb9832b4e24(start, end) {
    try {
        if (!('memory' in performance)) return null;
        const accumulatedMemoryUsage = $4893ccc56ddd0620$var$memoryRecordBuffer.reduce((acc, snapshot)=>{
            if (snapshot.time >= start && snapshot.time <= end) {
                acc.totalJSHeapSize += snapshot.totalJSHeapSize;
                acc.usedJSHeapSize += snapshot.usedJSHeapSize;
                acc.snapshotCount += 1;
            }
            return acc;
        }, {
            totalJSHeapSize: 0,
            usedJSHeapSize: 0,
            snapshotCount: 0
        });
        const memoryStateReport = {
            jsHeapSizeLimitInMB: $4893ccc56ddd0620$var$convertBytesToMegabytes($4893ccc56ddd0620$var$memoryRecordBuffer[0].jsHeapSizeLimit),
            // just use the first record, since this value always remains the same over time
            avgTotalJSHeapSizeInMB: $4893ccc56ddd0620$var$convertBytesToMegabytes(accumulatedMemoryUsage.totalJSHeapSize / accumulatedMemoryUsage.snapshotCount),
            avgUsedJSHeapSizeInMB: $4893ccc56ddd0620$var$convertBytesToMegabytes(accumulatedMemoryUsage.usedJSHeapSize / accumulatedMemoryUsage.snapshotCount)
        };
        $4893ccc56ddd0620$export$c0142ac82f5d0c28(end);
        return memoryStateReport;
    } catch  {
        return null;
    }
}
function $4893ccc56ddd0620$export$117ebc554c6e9f2f() {
    try {
        if ('PressureObserver' in globalThis) {
            $4893ccc56ddd0620$var$pressureObserver = new PressureObserver((records)=>{
                if ($4893ccc56ddd0620$var$pressureRecordBuffer.length + records.length <= $4893ccc56ddd0620$var$BUFFER_MAX_LENGTH) $4893ccc56ddd0620$var$pressureRecordBuffer.push(...records);
            });
            $4893ccc56ddd0620$var$pressureObserver.observe('cpu', {
                sampleInterval: 100
            }).catch(()=>{
            // Silently handle permission policy restrictions or other observe failures
            // This prevents unhandled promise rejections from being reported to Sentry
            });
        }
    } catch  {
    /* do nothing, this is a best efforts metric */ }
}
function $4893ccc56ddd0620$export$a3271f53e91faab7() {
    try {
        // only set up the interval if `performance.memory` is available in the browser
        if ('memory' in performance) $4893ccc56ddd0620$var$memoryInterval = setInterval(()=>{
            // another check of `performance.memory` availability to satisfy typescript
            if ('memory' in performance) {
                const memory = performance.memory;
                if ($4893ccc56ddd0620$var$memoryRecordBuffer.length <= $4893ccc56ddd0620$var$BUFFER_MAX_LENGTH) $4893ccc56ddd0620$var$memoryRecordBuffer.push({
                    time: performance.now(),
                    jsHeapSizeLimit: memory.jsHeapSizeLimit,
                    totalJSHeapSize: memory.totalJSHeapSize,
                    usedJSHeapSize: memory.usedJSHeapSize
                });
            }
        }, 100);
    } catch  {
    /* do nothing, this is a best efforts metric */ }
}
function $4893ccc56ddd0620$export$10899ada382f2ae3() {
    clearInterval($4893ccc56ddd0620$var$memoryInterval);
}
function $4893ccc56ddd0620$export$b9fdd785f0fc1d40() {
    $4893ccc56ddd0620$var$pressureObserver?.disconnect();
}

});

parcelRegister("7Xuvn", function(module, exports) {
$parcel$export(module.exports, "sinkTerminalErrorHandler", () => $b91d7875320f1bb0$export$e5fa3ac6dc44efff);

var $4tluv = parcelRequire("4tluv");

var $3X3Vo = parcelRequire("3X3Vo");

var $3EjrT = parcelRequire("3EjrT");

var $f6Olw = parcelRequire("f6Olw");

var $dWn9F = parcelRequire("dWn9F");

var $g96Dv = parcelRequire("g96Dv");
let $b91d7875320f1bb0$var$sinkHandlerFn = ()=>{};
function $b91d7875320f1bb0$export$e5fa3ac6dc44efff(fn) {
    $b91d7875320f1bb0$var$sinkHandlerFn = fn;
}
const $b91d7875320f1bb0$var$RELAY_NETWORK_ERRORS_NAME = 'RelayNetwork';
const $b91d7875320f1bb0$export$1a949ef92fd30eca = (error)=>error.name === $b91d7875320f1bb0$var$RELAY_NETWORK_ERRORS_NAME;
const $b91d7875320f1bb0$var$isErrorObject = (error)=>typeof error === 'object' && error !== null;
const $b91d7875320f1bb0$var$getErrorStatusCode = (error)=>{
    if (!$b91d7875320f1bb0$var$isErrorObject(error)) return undefined;
    if ($b91d7875320f1bb0$export$1a949ef92fd30eca(error)) return error.source?.errors?.[0]?.extensions?.statusCode;
    if ('statusCode' in error && typeof error.statusCode === 'number') return error.statusCode;
    return undefined;
};
const $b91d7875320f1bb0$var$getErrorTraceId = (error)=>$b91d7875320f1bb0$var$isErrorObject(error) && 'traceId' in error && typeof error.traceId === 'string' ? error.traceId : undefined;
function $b91d7875320f1bb0$export$3e4fb24086cfb97a(error, additionalAttributes, labelStack) {
    if (additionalAttributes?.isClientNetworkError) // Exclude client network errors from being reported to UFO
    return;
    const activeInteraction = (0, $dWn9F.getActiveInteraction)();
    const currentTime = performance.now();
    const baseErrorData = {
        errorType: error.name || 'Error',
        errorMessage: error.message?.slice(0, 100) || 'Unknown error',
        timestamp: currentTime
    };
    const errorData = (0, $3X3Vo.fg)('platform_ufo_terminal_errors_fix_missing_data') ? {
        ...baseErrorData,
        statusCode: additionalAttributes?.statusCode ?? $b91d7875320f1bb0$var$getErrorStatusCode(error),
        // Fallback to traceId from error object if it exists (e.g. FetchError)
        traceId: (0, $3EjrT.getActiveTrace)()?.traceId ?? $b91d7875320f1bb0$var$getErrorTraceId(error),
        teamName: additionalAttributes?.teamName,
        packageName: additionalAttributes?.packageName,
        errorBoundaryId: additionalAttributes?.errorBoundaryId,
        errorHash: additionalAttributes?.errorHash,
        fallbackType: additionalAttributes?.fallbackType
    } : {
        ...baseErrorData,
        ...additionalAttributes
    };
    // Calculate time since previous interaction
    const timeSincePreviousInteraction = (0, $dWn9F.PreviousInteractionLog).timestamp != null ? currentTime - (0, $dWn9F.PreviousInteractionLog).timestamp : null;
    const context = {
        labelStack: labelStack ?? null,
        activeInteractionName: activeInteraction?.ufoName ?? null,
        activeInteractionId: activeInteraction?.id ?? null,
        activeInteractionType: activeInteraction?.type ?? null,
        previousInteractionId: (0, $dWn9F.PreviousInteractionLog).id ?? null,
        previousInteractionName: (0, $dWn9F.PreviousInteractionLog).name ?? null,
        previousInteractionType: (0, $dWn9F.PreviousInteractionLog).type ?? null,
        timeSincePreviousInteraction: timeSincePreviousInteraction,
        routeName: (0, $g96Dv.default).current ?? null
    };
    $b91d7875320f1bb0$var$sinkHandlerFn(errorData, context);
}
function $b91d7875320f1bb0$export$79ee0f0d40355053(error, additionalAttributes) {
    const interactionContext = (0, $f6Olw.useInteractionContext)();
    const hasReportedRef = (0, $4tluv.useRef)(false);
    (0, $4tluv.useEffect)(()=>{
        if (error && !hasReportedRef.current) {
            hasReportedRef.current = true;
            $b91d7875320f1bb0$export$3e4fb24086cfb97a(error, additionalAttributes, interactionContext?.labelStack);
        }
    }, [
        error,
        additionalAttributes,
        interactionContext?.labelStack
    ]);
}

});
parcelRegister("f6Olw", function(module, exports) {
$parcel$export(module.exports, "default", () => $25325e07183c19a7$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useInteractionContext", () => $25325e07183c19a7$export$11bcb6e9af2aca35);

var $4tluv = parcelRequire("4tluv");

var $cDSkE = parcelRequire("cDSkE");
var $25325e07183c19a7$export$2e2bcd8739ae039 = (0, $cDSkE.default);
function $25325e07183c19a7$export$11bcb6e9af2aca35() {
    return (0, $4tluv.useContext)((0, $cDSkE.default));
}

});

parcelRegister("g96Dv", function(module, exports) {
$parcel$export(module.exports, "default", () => $406d18253c069b38$export$2e2bcd8739ae039);
// The UFORouteName object is a global singleton
const $406d18253c069b38$var$UFORouteName = {
    current: null
};
var $406d18253c069b38$export$2e2bcd8739ae039 = $406d18253c069b38$var$UFORouteName;

});


parcelRegister("7j9k3", function(module, exports) {
$parcel$export(module.exports, "default", () => $70dcd1d4341e4ba5$export$2e2bcd8739ae039);

var $5Ktbc = parcelRequire("5Ktbc");

var $3X3Vo = parcelRequire("3X3Vo");
function $70dcd1d4341e4ba5$var$scheduleIdleCallback(work) {
    if (typeof window !== 'undefined' && typeof window.requestIdleCallback === 'function' && (0, $3X3Vo.fg)('ufo_payload_use_idle_callback')) window.requestIdleCallback(work);
    else (0, $5Ktbc.unstable_scheduleCallback)((0, $5Ktbc.unstable_IdlePriority), work);
}
var $70dcd1d4341e4ba5$export$2e2bcd8739ae039 = $70dcd1d4341e4ba5$var$scheduleIdleCallback;

});

parcelRegister("7SxnG", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = Promise.all([
    $20gJU("jOsRz"),
    $20gJU("48sXm")
]).then(()=>parcelRequire('14iGx'));

});
parcelRegister("20gJU", function(module, exports) {
"use strict";

function $175890f37c5da735$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("e7pPz")).resolve(id));
}
module.exports = $175890f37c5da735$var$load;

});
parcelRegister("e7pPz", function(module, exports) {
$parcel$export(module.exports, "register", () => $a475c191888531d0$export$6503ec6e8aabbaf, (v) => $a475c191888531d0$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $a475c191888531d0$export$f7ad0328861e2f03, (v) => $a475c191888531d0$export$f7ad0328861e2f03 = v);
var $a475c191888531d0$export$6503ec6e8aabbaf;
var $a475c191888531d0$export$f7ad0328861e2f03;
"use strict";
var $a475c191888531d0$var$mapping = new Map();
function $a475c191888531d0$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$a475c191888531d0$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $a475c191888531d0$var$resolve(id) {
    var resolved = $a475c191888531d0$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$a475c191888531d0$export$6503ec6e8aabbaf = $a475c191888531d0$var$register;
$a475c191888531d0$export$f7ad0328861e2f03 = $a475c191888531d0$var$resolve;

});



parcelRegister("9E4E1", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = Promise.all([
    $20gJU("jOsRz"),
    $20gJU("dAYgE")
]).then(()=>parcelRequire('8hSzo'));

});

parcelRegister("hg288", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = Promise.all([
    $20gJU("jOsRz"),
    $20gJU("dAYgE")
]).then(()=>parcelRequire('kfknl'));

});

parcelRegister("eDJTo", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = Promise.all([
    $20gJU("jOsRz"),
    $20gJU("dAYgE")
]).then(()=>parcelRequire('ij2o9'));

});


parcelRegister("c1YdO", function(module, exports) {
$parcel$export(module.exports, "default", () => $40b59d1d2930d43d$export$2e2bcd8739ae039);
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $40SCs = parcelRequire("40SCs");

var $irOPS = parcelRequire("irOPS");

var $dXdid = parcelRequire("dXdid");

var $3EjrT = parcelRequire("3EjrT");

var $kPZVD = parcelRequire("kPZVD");

var $dWn9F = parcelRequire("dWn9F");

var $g96Dv = parcelRequire("g96Dv");
const $40b59d1d2930d43d$var$AWAITING_PAGELOAD_NAME = 'awaiting_pageload_name';
function $40b59d1d2930d43d$var$traceUFOPageLoad(ufoName, routeName = ufoName) {
    if (!(0, $dXdid.isUFOEnabled)()) return;
    const activeInteraction = (0, $dWn9F.getActiveInteraction)();
    if (activeInteraction && !ufoName) return;
    (0, $g96Dv.default).current = routeName || null;
    const rate = ufoName ? (0, $dXdid.getInteractionRate)(ufoName, 'page_load') : 1;
    const enabledBySamplingRate = (0, $irOPS.default)(rate);
    if (enabledBySamplingRate && !activeInteraction) {
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const newId = (0, $40SCs.v4)();
        (0, $kPZVD.DefaultInteractionID).current = newId;
        (0, $dWn9F.addNewInteraction)(newId, ufoName || '', 'page_load', 0, rate, null, routeName, (0, $3EjrT.getActiveTrace)());
        if (!ufoName) // if no name is provided we add a hold to the interaction, it is removed if the name is provided while the interaction is holding
        (0, $dWn9F.addHoldByID)(newId, [], $40b59d1d2930d43d$var$AWAITING_PAGELOAD_NAME, $40b59d1d2930d43d$var$AWAITING_PAGELOAD_NAME, true);
    } else if (!enabledBySamplingRate && activeInteraction && activeInteraction.type === 'page_load') // if there is an active interaction it will be aborted without initialising a new one because the coinflip returned false
    (0, $dWn9F.abort)(activeInteraction.id, 'excluded_by_sampling');
    else if (ufoName && activeInteraction && !activeInteraction.ufoName && activeInteraction.type === 'page_load') {
        (0, $dWn9F.updatePageLoadInteractionName)(ufoName, routeName);
        (0, $dWn9F.removeHoldByID)(activeInteraction.id, $40b59d1d2930d43d$var$AWAITING_PAGELOAD_NAME);
    }
}
var $40b59d1d2930d43d$export$2e2bcd8739ae039 = $40b59d1d2930d43d$var$traceUFOPageLoad;
function $40b59d1d2930d43d$export$d0f99433cd4f4028(ufoName, routeName = ufoName) {
    if (!(0, $dXdid.isUFOEnabled)()) return;
    const interaction = (0, $dWn9F.getActiveInteraction)();
    if (!interaction || interaction.type !== 'page_load' && interaction.type !== 'transition') return;
    if (ufoName) {
        const rate = (0, $dXdid.getInteractionRate)(ufoName, 'page_load');
        (0, $dWn9F.updatePageLoadInteractionName)(ufoName, routeName);
        if ((0, $irOPS.default)(rate)) (0, $g96Dv.default).current = ufoName;
        else (0, $dWn9F.abort)(interaction.id, 'excluded_by_sampling');
    }
    (0, $dWn9F.removeHoldByID)(interaction.id, $40b59d1d2930d43d$var$AWAITING_PAGELOAD_NAME);
}

});

parcelRegister("dX6kP", function(module, exports) {
$parcel$export(module.exports, "analyticsClient", () => $3db39ce5777157b7$export$f1caacacb426dc27);
$parcel$export(module.exports, "useSendAnalyticEvent", () => $3db39ce5777157b7$export$48173b1537adccbd);

var $dBXpK = parcelRequire("dBXpK");
var $fBMYg = parcelRequire("fBMYg");

var $4tluv = parcelRequire("4tluv");

var $1QYE6 = parcelRequire("1QYE6");

var $22hwD = parcelRequire("22hwD");

var $6ascs = parcelRequire("6ascs");

const $3db39ce5777157b7$export$f1caacacb426dc27 = new (0, $dBXpK.default)({
    // local, dev, staging all get sent to the same staging environment
    // https://hello.atlassian.net/wiki/spaces/AAPT/pages/134328422/Analytics+Lesson+2+-+Sending+Events
    env: (0, (0, $fBMYg.envType).PROD),
    product: "rovoExtension"
}, {
    // Steps we could take to turn this off: https://hello.atlassian.net/wiki/spaces/I/pages/1217206437/Action+Required+api-private+is+broken+is+your+product+impacted
    useLegacyUrl: true,
    onNewSessionStarted: ()=>{
        (parcelRequire("1VhLk")).then((m)=>m.onAnalyticsWebClientSessionRotation());
    }
});
const $3db39ce5777157b7$export$48173b1537adccbd = ()=>{
    const userMetadata = (0, $6ascs.useAnalyticsUserMetadata)()?.userMetadata;
    const sendAnalyticEvent = (0, $4tluv.useCallback)(({ eventType: eventType, event: event, userId: userId })=>{
        const site = (0, $1QYE6.getSelectedSiteFromLocalStorage)();
        const payload = {
            ...event,
            attributes: {
                ...event.attributes,
                ...userMetadata
            }
        };
        if (site?.workspace.cloudId) $3db39ce5777157b7$export$f1caacacb426dc27.setTenantInfo((0, $fBMYg.tenantType).CLOUD_ID, site.workspace.cloudId);
        if (userId) $3db39ce5777157b7$export$f1caacacb426dc27.setUserInfo((0, $fBMYg.userType).ATLASSIAN_ACCOUNT, userId);
        // Use ui as the default type if the event doesn't have a type
        const type = eventType ?? "ui";
        switch(type){
            case "ui":
                if ($3db39ce5777157b7$var$isValidActionEvent(payload, type)) $3db39ce5777157b7$export$f1caacacb426dc27.sendUIEvent(payload).catch((error)=>{
                    (0, $22hwD.logError)({
                        error: error,
                        impact: "Failed to send UI analytics event"
                    });
                });
                break;
            case "screen":
                if (payload.name) $3db39ce5777157b7$export$f1caacacb426dc27.sendScreenEvent(payload).catch((error)=>{
                    (0, $22hwD.logError)({
                        error: error,
                        impact: "Failed to send screen analytics event"
                    });
                });
                break;
            case "track":
                if ($3db39ce5777157b7$var$isValidActionEvent(payload, type)) $3db39ce5777157b7$export$f1caacacb426dc27.sendTrackEvent(payload).catch((error)=>{
                    (0, $22hwD.logError)({
                        error: error,
                        impact: "Failed to send track analytics event"
                    });
                });
                break;
            case "operational":
                if ($3db39ce5777157b7$var$isValidActionEvent(payload, type)) $3db39ce5777157b7$export$f1caacacb426dc27.sendOperationalEvent(payload).catch((error)=>{
                    (0, $22hwD.logError)({
                        error: error,
                        impact: "Failed to send operational analytics event"
                    });
                });
                break;
        }
    }, [
        userMetadata
    ]);
    return sendAnalyticEvent;
};
function $3db39ce5777157b7$var$isValidActionEvent(payload, type) {
    if (!payload?.source || !payload.actionSubject || !payload.action) {
        const missingFields = [
            !payload?.source && "source",
            !payload?.actionSubject && "actionSubject",
            !payload?.action && "action"
        ].filter(Boolean);
        (0, $22hwD.logError)({
            error: new Error("Invalid analytics action event payload"),
            extra: {
                missingFields: missingFields,
                type: type,
                payload: payload
            }
        });
        return false;
    }
    return true;
}

});
parcelRegister("1QYE6", function(module, exports) {
$parcel$export(module.exports, "getSelectedSiteFromLocalStorage", () => $43a08c775d2b00b7$export$7972af24309c7242);
$parcel$export(module.exports, "useSendSiteChangeAnalytics", () => $43a08c775d2b00b7$export$9120fbebb13679dd);
$parcel$export(module.exports, "SiteProvider", () => $43a08c775d2b00b7$export$f12be7154ec345e8);
$parcel$export(module.exports, "useSite", () => $43a08c775d2b00b7$export$7870fa8e7cdd59f8);

var $4tluv = parcelRequire("4tluv");

var $hjYvo = parcelRequire("hjYvo");
parcelRequire("cDuOd");
var $fgIUF = parcelRequire("fgIUF");

var $bFW4F = parcelRequire("bFW4F");

var $e9gYt = parcelRequire("e9gYt");

var $f0dSY = parcelRequire("f0dSY");

var $dX6kP = parcelRequire("dX6kP");

var $lsxLV = parcelRequire("lsxLV");

var $hmQ4u = parcelRequire("hmQ4u");

var $9JAaz = parcelRequire("9JAaz");
function $43a08c775d2b00b7$export$7972af24309c7242() {
    const selectedSite = (0, $fgIUF.getLocalStorageItem)((0, $fgIUF.LocalStorageKey).SELECTED_SITE);
    if (!selectedSite) return;
    return {
        workspace: {
            cloudId: selectedSite.cloudId,
            organisationId: selectedSite.orgId
        },
        defaultSiteBaseUrl: selectedSite.baseUrl
    };
}
const $43a08c775d2b00b7$export$7c9ab0c846d0fe5b = (atlassianSite)=>{
    return {
        workspace: {
            cloudId: atlassianSite.cloudId,
            organisationId: atlassianSite.orgId
        },
        defaultSiteBaseUrl: atlassianSite.baseUrl
    };
};
const $43a08c775d2b00b7$export$f70c502b152f67e7 = (rovoEnabledSites = [], selectedSite)=>{
    // Add null check to prevent runtime errors
    if (!Array.isArray(rovoEnabledSites) || rovoEnabledSites.length === 0) return undefined;
    const foundSite = rovoEnabledSites.find((s)=>s.cloudId === selectedSite?.cloudId) ?? rovoEnabledSites.find((s)=>(0, $e9gYt.isHello)(s.cloudId)) ?? rovoEnabledSites[0];
    return foundSite;
};
const $43a08c775d2b00b7$var$SiteContext = /*#__PURE__*/ (0, $4tluv.createContext)(undefined);
const $43a08c775d2b00b7$export$9120fbebb13679dd = ({ accountId: accountId })=>{
    const sendAnalyticEvent = (0, $dX6kP.useSendAnalyticEvent)();
    const sendSiteChangeAnalytics = (0, $4tluv.useCallback)(({ site: site, caller: caller })=>{
        sendAnalyticEvent({
            eventType: "track",
            event: {
                action: "called setSiteStatesAndBroadcast",
                actionSubject: (0, $lsxLV.ANALYTICS_UI_SUBJECTS).SITE_SELECTOR,
                source: (0, $lsxLV.ANALYTICS_SCREEN_NAMES).EXTENSION_HOME_SCREEN,
                attributes: {
                    newValue: site,
                    trigger: caller
                }
            },
            userId: accountId
        });
    }, [
        accountId,
        sendAnalyticEvent
    ]);
    return sendSiteChangeAnalytics;
};
const $43a08c775d2b00b7$export$f12be7154ec345e8 = ({ children: children, userAccount: userAccount, onSiteChange: onSiteChange })=>{
    const lastSelectedSite = (0, $fgIUF.getLocalStorageItem)((0, $fgIUF.LocalStorageKey).SELECTED_SITE);
    const [selectedSite, setSelectedSite] = (0, $4tluv.useState)(lastSelectedSite ?? undefined);
    const publish = (0, $hjYvo.usePublish)("ai-mate");
    const { data: data, isLoading: isLoading } = (0, $bFW4F.useSitesWithRovoEnabled)(userAccount);
    const rovoEnabledSites = (0, $4tluv.useMemo)(()=>data?.results ?? [], [
        data
    ]);
    const handleSetSite = (0, $4tluv.useCallback)((site)=>{
        if (site) {
            (0, $fgIUF.setLocalStorageItem)((0, $fgIUF.LocalStorageKey).SELECTED_SITE, {
                cloudId: site.cloudId,
                baseUrl: site.baseUrl,
                orgId: site.orgId
            });
            // publish chat-draft to clear any conversationId (same window)
            publish({
                type: "chat-draft",
                source: "extension"
            });
            setSelectedSite(site);
            onSiteChange?.($43a08c775d2b00b7$export$7c9ab0c846d0fe5b(site));
        }
    }, [
        publish,
        onSiteChange
    ]);
    const atlassianSite = (0, $4tluv.useMemo)(()=>{
        return $43a08c775d2b00b7$export$f70c502b152f67e7(rovoEnabledSites, selectedSite);
    }, [
        rovoEnabledSites,
        selectedSite
    ]);
    const site = (0, $4tluv.useMemo)(()=>{
        return atlassianSite ? $43a08c775d2b00b7$export$7c9ab0c846d0fe5b(atlassianSite) : undefined;
    }, [
        atlassianSite
    ]);
    (0, $4tluv.useEffect)(()=>{
        if (site && atlassianSite) {
            const siteChanged = site.workspace.cloudId !== selectedSite?.cloudId;
            if (siteChanged) {
                // sets the selected site in local storage the first time the site is set
                if (!selectedSite) handleSetSite({
                    cloudId: site.workspace.cloudId,
                    baseUrl: site.defaultSiteBaseUrl,
                    siteName: atlassianSite.siteName,
                    orgId: site.workspace.organisationId
                });
                else onSiteChange?.(site);
            }
            // else just broadcast the config to the extension
            (0, $9JAaz.broadcastConfigToExtension)({
                workspace: {
                    cloudId: site.workspace.cloudId,
                    organisationId: site.workspace.organisationId
                },
                defaultSiteBaseUrl: site.defaultSiteBaseUrl
            });
        }
    }, [
        selectedSite,
        site,
        atlassianSite,
        handleSetSite,
        onSiteChange
    ]);
    const onLocalStorageChange = (0, $4tluv.useCallback)((value)=>{
        if (value) {
            // tells chat to clear any conversationId
            if (value.cloudId !== selectedSite?.cloudId) publish({
                type: "chat-draft",
                source: "extension"
            });
            setSelectedSite(value);
        }
    }, [
        publish,
        selectedSite
    ]);
    (0, $fgIUF.addLocalStorageEventListener)((0, $fgIUF.LocalStorageKey).SELECTED_SITE, onLocalStorageChange);
    (0, $4tluv.useEffect)(()=>{
        (0, $f0dSY.setSentryExperiments)();
        if (site) (0, $f0dSY.setSentrySiteId)(site.workspace.cloudId);
    }, [
        site
    ]);
    if (isLoading) // todo show loader here
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).Fragment, null);
    if (!site || !atlassianSite) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $hmQ4u.default), {
        metadata: data?.metadata,
        showNavigation: true,
        userAccount: userAccount
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement($43a08c775d2b00b7$var$SiteContext.Provider, {
        value: {
            site: site,
            atlassianSite: atlassianSite,
            handleSetSite: handleSetSite,
            rovoEnabledSites: rovoEnabledSites
        }
    }, children);
};
const $43a08c775d2b00b7$export$7870fa8e7cdd59f8 = (options = {})=>{
    const context = (0, $4tluv.useContext)($43a08c775d2b00b7$var$SiteContext);
    if (!options.allowUndefined && context === undefined) throw new Error("useSiteContext must be used within a SiteProvider");
    return context;
};

});
parcelRegister("hjYvo", function(module, exports) {
$parcel$export(module.exports, "useSubscribe", () => $2d5e13e01f59e04b$export$d3d523392640272);
$parcel$export(module.exports, "usePublish", () => $2d5e13e01f59e04b$export$d55c81786220731c);
$parcel$export(module.exports, "Subscriber", () => $2d5e13e01f59e04b$export$60959659b2c22881);

var $4tluv = parcelRequire("4tluv");
const $2d5e13e01f59e04b$var$ignoredTriggerLatestEvents = new Set([
    'editor-context-payload',
    'agent-changed',
    // Internal signals that must never overwrite the publish queue — they would
    // cause `triggerLatest` subscribers (e.g. PubSubListener) to replay them
    // instead of the real action event (e.g. open-browse-agent-modal) that
    // originally opened the chat.
    'smartlinks-subscription-changed',
    'smartlinks-context-payload'
]);
const $2d5e13e01f59e04b$var$createPubSub = ()=>{
    let subscribedEvents = {};
    let publishQueue = {};
    let wildcardEvents = [];
    let subIdCounter = 0;
    const generateSubId = ()=>{
        subIdCounter += 1;
        return subIdCounter.toString();
    };
    const subscribe = ({ topic: topic, triggerLatest: triggerLatest }, callback)=>{
        const events = subscribedEvents[topic] ?? [];
        const subId = generateSubId();
        const subExists = events.some(({ id: id })=>id === subId);
        // Push to Topic stack if not already there
        if (!subExists) {
            subscribedEvents = {
                ...subscribedEvents,
                [topic]: [
                    ...events,
                    {
                        callback: callback,
                        id: subId
                    }
                ]
            };
            // If this Topic already has a published event and `triggerLatest` is true, trigger the callback then clear the publishQueue for that Topic
            if (triggerLatest && !!publishQueue[topic]) {
                const payload = publishQueue[topic];
                callback(payload);
                delete publishQueue[topic];
            }
        }
        return ()=>{
            // Remove from Topic stack
            subscribedEvents = {
                ...subscribedEvents,
                [topic]: (subscribedEvents[topic] || []).filter(({ id: id })=>id !== subId)
            };
        };
    };
    const subscribeAll = (callback)=>{
        const subId = wildcardEvents.length.toString();
        wildcardEvents = [
            ...wildcardEvents,
            {
                callback: callback,
                id: subId
            }
        ];
        return ()=>{
            wildcardEvents = wildcardEvents.filter(({ id: id })=>id !== subId);
        };
    };
    const publish = (topic, payload)=>{
        /**
     * Log that this Topic received a published event, regardless of whether it has subscribers or not.
     * This ensures new subscribers can trigger their callback if `triggerLatest` is true, and the event hasn't already been triggered.
     */ // This `ignoredTriggerLatestEvents` is a quick fix to prevent triggering the latest event for certain events
        if (!$2d5e13e01f59e04b$var$ignoredTriggerLatestEvents.has(payload.type)) publishQueue[topic] = payload;
        // Notify `subscribeAll` subscribers as they are Topic agnostic
        wildcardEvents.forEach(({ callback: callback })=>callback(payload));
        const topicSubs = subscribedEvents[topic] || [];
        // If there are no subscribers for this Topic, nothing to do.
        if (!topicSubs.length) return;
        // Notify all Topic subscribers of this event
        topicSubs.forEach(({ callback: callback })=>callback(payload));
    };
    const flushQueue = ()=>{
        publishQueue = {};
    };
    return {
        subscribe: subscribe,
        subscribeAll: subscribeAll,
        publish: publish,
        flushQueue: flushQueue
    };
};
const $2d5e13e01f59e04b$var$pubSub = $2d5e13e01f59e04b$var$createPubSub();
const $2d5e13e01f59e04b$var$usePubSub = ()=>{
    return $2d5e13e01f59e04b$var$pubSub;
};
const $2d5e13e01f59e04b$export$d3d523392640272 = ({ topic: topic, triggerLatest: triggerLatest }, callback)=>{
    const { subscribe: subscribe } = $2d5e13e01f59e04b$var$usePubSub();
    const callbackRef = (0, $4tluv.useRef)(callback);
    callbackRef.current = callback;
    (0, $4tluv.useEffect)(()=>{
        const unsubscribe = subscribe({
            topic: topic,
            triggerLatest: triggerLatest
        }, (...args)=>callbackRef.current(...args));
        return unsubscribe;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        topic
    ]);
};
const $2d5e13e01f59e04b$export$2570c8aa24b6d327 = (callback)=>{
    const { subscribeAll: subscribeAll } = $2d5e13e01f59e04b$var$usePubSub();
    const callbackRef = (0, $4tluv.useRef)(callback);
    callbackRef.current = callback;
    (0, $4tluv.useEffect)(()=>{
        const unsubscribe = subscribeAll((...args)=>callbackRef.current(...args));
        return unsubscribe;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
};
const $2d5e13e01f59e04b$var$useFlushOnUnmount = (active = false)=>{
    const { flushQueue: flushQueue } = $2d5e13e01f59e04b$var$usePubSub();
    (0, $4tluv.useLayoutEffect)(()=>{
        return ()=>{
            if (active) flushQueue();
        };
    }, [
        active,
        flushQueue
    ]);
};
const $2d5e13e01f59e04b$export$d55c81786220731c = (topic)=>{
    const { publish: publish } = $2d5e13e01f59e04b$var$usePubSub();
    const publishFn = (0, $4tluv.useCallback)((payload)=>publish(topic, payload), [
        publish,
        topic
    ]);
    return publishFn;
};
const $2d5e13e01f59e04b$export$60959659b2c22881 = ({ topic: topic, triggerLatest: triggerLatest, onEvent: onEvent, flushQueueOnUnmount: flushQueueOnUnmount })=>{
    $2d5e13e01f59e04b$export$d3d523392640272({
        topic: topic,
        triggerLatest: triggerLatest
    }, onEvent);
    $2d5e13e01f59e04b$var$useFlushOnUnmount(flushQueueOnUnmount);
    return null;
};

});

parcelRegister("cDuOd", function(module, exports) {
$parcel$export(module.exports, "LocalStorageKey", () => (parcelRequire("fgIUF")).LocalStorageKey);
$parcel$export(module.exports, "setLocalStorageItem", () => (parcelRequire("fgIUF")).setLocalStorageItem);
$parcel$export(module.exports, "getLocalStorageItem", () => (parcelRequire("fgIUF")).getLocalStorageItem);
$parcel$export(module.exports, "addLocalStorageEventListener", () => (parcelRequire("fgIUF")).addLocalStorageEventListener);
$parcel$export(module.exports, "removeLocalStorageEventListener", () => (parcelRequire("fgIUF")).removeLocalStorageEventListener);

var $fgIUF = parcelRequire("fgIUF");

});
parcelRegister("fgIUF", function(module, exports) {
$parcel$export(module.exports, "LocalStorageKey", () => $3afebd2523c634f1$export$e9d9376124133876);
$parcel$export(module.exports, "setLocalStorageItem", () => $3afebd2523c634f1$export$5aa524d86254b4f);
$parcel$export(module.exports, "getLocalStorageItem", () => $3afebd2523c634f1$export$93d719890ad66653);
$parcel$export(module.exports, "addLocalStorageEventListener", () => $3afebd2523c634f1$export$589491e71aa37313);
$parcel$export(module.exports, "removeLocalStorageEventListener", () => $3afebd2523c634f1$export$cdd6e8ebb7bf8992);
$parcel$export(module.exports, "setLocalStorageItemRawString", () => $3afebd2523c634f1$export$20508c4c4ae90dc7);
$parcel$export(module.exports, "getLocalStorageItemRawString", () => $3afebd2523c634f1$export$6b4cb6748a03c9ca);
$parcel$export(module.exports, "addLocalStorageEventListenerRawString", () => $3afebd2523c634f1$export$69a4116e1ad84bc6);

var $22hwD = parcelRequire("22hwD");
var $3afebd2523c634f1$export$e9d9376124133876 = /*#__PURE__*/ function(LocalStorageKey) {
    LocalStorageKey["RECENT_WORK_ENABLED"] = "recent_work_enabled";
    LocalStorageKey["CALENDAR_ENABLED"] = "calendar_enabled";
    LocalStorageKey["CALENDAR_SELECTED"] = "calendar_selected";
    LocalStorageKey["SELECTED_SITE"] = "selected_site";
    LocalStorageKey["BOOKMARKS_ENABLED"] = "bookmark_enabled";
    LocalStorageKey["THEME_COLOR_MODE"] = "theme_color_mode";
    LocalStorageKey["ANNOUNCEMENT_BANNER"] = "announcement_banner";
    LocalStorageKey["ANNOUNCEMENTS_ENABLED"] = "announcements_enabled";
    LocalStorageKey["PLUGIN_FEEDBACK"] = "plugin_feedback_usage";
    LocalStorageKey["HAS_USER_ONBOARDED_ON_INSTALL"] = "has_user_onboarded_on_install";
    LocalStorageKey["BACKGROUND_PREVIEW_FILE_TYPE"] = "background_preview_file_type";
    LocalStorageKey["BACKGROUND_PREVIEW_URL"] = "background_preview_url";
    LocalStorageKey["CHROME_EXTENSION_DEBUG_DATA"] = "chrome_extension_debug_data";
    LocalStorageKey["IS_FULL_PAGE_CHAT"] = "is_full_page_chat";
    LocalStorageKey["WELCOME_HEADER_ENABLED"] = "welcome_header_enabled";
    LocalStorageKey["GLOBAL_CREATE_ENABLED"] = "global_create_enabled";
    LocalStorageKey["LOCAL_DEV_BANNER_ENABLED"] = "local_dev_banner_enabled";
    LocalStorageKey["SELECTED_NTP_AGENT"] = "selected_ntp_agent";
    LocalStorageKey["NTP_AGENT_SPOTLIGHT_DISMISSED"] = "ntp_agent_spotlight_dismissed";
    LocalStorageKey["NTP_AGENT_DROPDOWN_OPEN_COUNT"] = "ntp_agent_dropdown_open_count";
    return LocalStorageKey;
}({});
const $3afebd2523c634f1$export$5aa524d86254b4f = (key, value)=>{
    try {
        const valueString = value !== undefined ? JSON.stringify(value) : "";
        localStorage.setItem(key, valueString);
    } catch (error) {
        (0, $22hwD.logError)({
            error: error,
            impact: "Failed to save to local storage",
            extra: {
                key: key
            }
        });
    }
};
const $3afebd2523c634f1$export$93d719890ad66653 = (key, defaultValue)=>{
    try {
        const valueString = localStorage.getItem(key);
        if (!valueString && defaultValue !== undefined) {
            $3afebd2523c634f1$export$5aa524d86254b4f(key, defaultValue);
            return defaultValue;
        }
        return valueString && JSON.parse(valueString);
    } catch (error) {
        (0, $22hwD.logError)({
            error: error,
            impact: "Failed to retrieve from local storage",
            extra: {
                key: key
            }
        });
        return null;
    }
};
const $3afebd2523c634f1$export$589491e71aa37313 = (key, callback)=>{
    const callbackHandle = (event)=>{
        if (event.key !== key) return;
        try {
            const value = event.newValue ? JSON.parse(event.newValue) : undefined;
            callback(value);
        } catch (error) {
            (0, $22hwD.logError)({
                error: error,
                impact: "Failed to parse storage event value",
                extra: {
                    key: key
                }
            });
        }
    };
    const customEventCallbackHandle = (event)=>{
        if (event.detail.key !== key) return;
        try {
            callback(event.detail.newValue);
        } catch (error) {
            (0, $22hwD.logError)({
                error: error,
                impact: "Failed to parse custom storage event value",
                extra: {
                    key: key
                }
            });
        }
    };
    window.addEventListener("storage", callbackHandle);
    window.addEventListener("STORAGE_SAME_WINDOW", customEventCallbackHandle);
    const destroyStorageListener = ()=>$3afebd2523c634f1$export$cdd6e8ebb7bf8992(callbackHandle);
    const destroyCustomEventListener = ()=>$3afebd2523c634f1$var$removeCustomEventListener(customEventCallbackHandle);
    return ()=>{
        destroyStorageListener();
        destroyCustomEventListener();
    };
};
const $3afebd2523c634f1$export$cdd6e8ebb7bf8992 = (callbackHandle)=>{
    window.removeEventListener("storage", callbackHandle);
};
const $3afebd2523c634f1$var$removeCustomEventListener = (callbackHandle)=>{
    window.removeEventListener("STORAGE_SAME_WINDOW", callbackHandle);
};
const $3afebd2523c634f1$export$c12b7b0e1d99a309 = ()=>{
    localStorage.clear();
};
const $3afebd2523c634f1$export$20508c4c4ae90dc7 = (key, value)=>{
    try {
        localStorage.setItem(key, value);
    } catch (error) {
        (0, $22hwD.logError)({
            error: error,
            impact: "Failed to save raw string to local storage",
            extra: {
                key: key
            }
        });
    }
};
const $3afebd2523c634f1$export$6b4cb6748a03c9ca = (key)=>{
    try {
        return localStorage.getItem(key);
    } catch (error) {
        (0, $22hwD.logError)({
            error: error,
            impact: "Failed to retrieve raw string from local storage",
            extra: {
                key: key
            }
        });
        return null;
    }
};
const $3afebd2523c634f1$export$69a4116e1ad84bc6 = (key, callback)=>{
    const callbackHandle = (event)=>{
        if (event.key !== key || !event.newValue) return;
        callback(event.newValue);
    };
    window.addEventListener("storage", callbackHandle);
    return callbackHandle;
};

});
parcelRegister("22hwD", function(module, exports) {
$parcel$export(module.exports, "NamedError", () => $107b06f1fb575fbc$export$b63482fab140df79);
$parcel$export(module.exports, "logInfo", () => $107b06f1fb575fbc$export$89c0607256d35f0a);
$parcel$export(module.exports, "logWarn", () => $107b06f1fb575fbc$export$cc36178e946876e8);
$parcel$export(module.exports, "logError", () => $107b06f1fb575fbc$export$58da9968c3170cb1);

var $9QeFV = parcelRequire("9QeFV");
parcelRequire("iuDZJ");
var $dqHaj = parcelRequire("dqHaj");
class $107b06f1fb575fbc$export$b63482fab140df79 extends Error {
    constructor(name, cause){
        const originalError = cause instanceof Error ? cause : new Error(String(cause));
        super(originalError.message);
        this.name = name;
        this.cause = cause;
        if (originalError.stack) this.stack = originalError.stack;
    }
}
function $107b06f1fb575fbc$export$e7bd538fb0c5db1a(error) {
    // If it's already an Error instance, return as is
    if (error instanceof Error) return error;
    // Handle null/undefined explicitly
    if (error === null) return new Error("Error was null");
    if (error === undefined) return new Error("Error was undefined");
    // For objects, try to get a meaningful string representation
    if (typeof error === "object") try {
        return new Error(JSON.stringify(error));
    } catch  {
        return new Error("[Object cannot be stringified]");
    }
    // For other primitives, convert to string
    return new Error(String(error));
}
function $107b06f1fb575fbc$export$89c0607256d35f0a(msg, ...args) {
    if (0, $dqHaj.debugEnabled) // eslint-disable-next-line no-console
    console.log(msg, ...args);
    $9QeFV.captureEvent({
        message: msg,
        level: "info",
        extra: {
            ...args
        }
    });
}
function $107b06f1fb575fbc$export$cc36178e946876e8(msg, ...args) {
    if (0, $dqHaj.debugEnabled) // eslint-disable-next-line no-console
    console.warn(msg, ...args);
    $9QeFV.captureEvent({
        message: msg,
        level: "warning",
        extra: {
            ...args
        }
    });
}
function $107b06f1fb575fbc$export$58da9968c3170cb1({ error: error, impact: impact, extra: extra, tags: tags, context: context }) {
    const errorObject = $107b06f1fb575fbc$export$e7bd538fb0c5db1a(error);
    if (0, $dqHaj.debugEnabled) // eslint-disable-next-line no-console
    console.error(impact, errorObject, extra);
    $9QeFV.captureException(errorObject, {
        tags: {
            ...tags
        },
        extra: {
            impact: impact,
            ...extra ?? {}
        },
        contexts: {
            ...context
        }
    });
}

});
parcelRegister("iuDZJ", function(module, exports) {
$parcel$export(module.exports, "bifrostEnv", () => (parcelRequire("dqHaj")).bifrostEnv);
$parcel$export(module.exports, "bitbucketCommit", () => (parcelRequire("dqHaj")).bitbucketCommit);
$parcel$export(module.exports, "debugEnabled", () => (parcelRequire("dqHaj")).debugEnabled);
$parcel$export(module.exports, "getIdentityUrl", () => (parcelRequire("dqHaj")).getIdentityUrl);
$parcel$export(module.exports, "getRovoExtensionWebBaseUrl", () => (parcelRequire("dqHaj")).getRovoExtensionWebBaseUrl);
$parcel$export(module.exports, "getAtlassianHomeUrl", () => (parcelRequire("dqHaj")).getAtlassianHomeUrl);
$parcel$export(module.exports, "getAdminHubUrl", () => (parcelRequire("dqHaj")).getAdminHubUrl);
$parcel$export(module.exports, "getStudioUrl", () => (parcelRequire("dqHaj")).getStudioUrl);
$parcel$export(module.exports, "getLocale", () => (parcelRequire("dqHaj")).getLocale);
$parcel$export(module.exports, "getBuildInfo", () => (parcelRequire("dqHaj")).getBuildInfo);
$parcel$export(module.exports, "getSessionReplayAmplitudeApiKey", () => (parcelRequire("dqHaj")).getSessionReplayAmplitudeApiKey);
/* eslint-disable no-restricted-imports -- It's ok in this file as it is exporting for the rest of the application */ 
var $dqHaj = parcelRequire("dqHaj");

var $iy6x4 = parcelRequire("iy6x4");

});
parcelRegister("dqHaj", function(module, exports) {
$parcel$export(module.exports, "bifrostEnv", () => $ef0f6fe5ca24b5a5$export$8a2eb78ddfc0abf8);
$parcel$export(module.exports, "getSessionReplayAmplitudeApiKey", () => $ef0f6fe5ca24b5a5$export$5a7069e28eb595d3);
$parcel$export(module.exports, "bitbucketCommit", () => $ef0f6fe5ca24b5a5$export$3da246011bdfb8cb);
$parcel$export(module.exports, "extensionUrl", () => $ef0f6fe5ca24b5a5$export$3c5eeed6890748ce);
$parcel$export(module.exports, "debugEnabled", () => $ef0f6fe5ca24b5a5$export$342c99cc1e9bc5c6);
$parcel$export(module.exports, "getStatsigUrl", () => $ef0f6fe5ca24b5a5$export$8abe4c34290ae3e9);
$parcel$export(module.exports, "getSwitcherooUrl", () => $ef0f6fe5ca24b5a5$export$dbb5d9628153315c);
$parcel$export(module.exports, "getIdentityUrl", () => $ef0f6fe5ca24b5a5$export$4fa18e6b13122af5);
$parcel$export(module.exports, "getRovoExtensionWebBaseUrl", () => $ef0f6fe5ca24b5a5$export$69a484083d87faa2);
$parcel$export(module.exports, "getAtlassianHomeUrl", () => $ef0f6fe5ca24b5a5$export$69576aae579b51af);
$parcel$export(module.exports, "getAdminHubUrl", () => $ef0f6fe5ca24b5a5$export$631ba87ff5b9e288);
$parcel$export(module.exports, "getStudioUrl", () => $ef0f6fe5ca24b5a5$export$22f3f17829eee7e0);
$parcel$export(module.exports, "getLocale", () => $ef0f6fe5ca24b5a5$export$180605366c04f0cd);
$parcel$export(module.exports, "getBuildInfo", () => $ef0f6fe5ca24b5a5$export$4ea39b9726d98a51);
const $ef0f6fe5ca24b5a5$export$8a2eb78ddfc0abf8 = "prod";
const $ef0f6fe5ca24b5a5$export$5a7069e28eb595d3 = ()=>"4aa1cbd970f59a84661985c72484058f";
const $ef0f6fe5ca24b5a5$export$3da246011bdfb8cb = "48418549c9cebfe5bddc1bdf6c337abf8dba97be";
const $ef0f6fe5ca24b5a5$export$3c5eeed6890748ce = "chrome-extension://npbjhobkibekbklkghlhfhieggcggpdb";
const $ef0f6fe5ca24b5a5$export$342c99cc1e9bc5c6 = $ef0f6fe5ca24b5a5$export$8a2eb78ddfc0abf8 !== "prod";
const $ef0f6fe5ca24b5a5$export$8abe4c34290ae3e9 = (id, type)=>{
    switch(type){
        case "featureGate":
            return `https://console.statsig.com/gates/${id}`;
        case "experiment":
            return `https://console.statsig.com/experiments/${id}/setup`;
        case "dynamicConfig":
            return `https://console.statsig.com/dynamic_configs/${id}`;
        default:
            throw new Error(`Unknown Statsig resource type: ${type}`);
    }
};
const $ef0f6fe5ca24b5a5$export$dbb5d9628153315c = (id, type)=>{
    switch(type){
        case "flag":
            return `https://switcheroo.atlassian.com/ui/changes?flagSearch=${id}`;
        case "dynamicConfig":
            return `https://switcheroo.atlassian.com/ui/configurations?search=${id}`;
        default:
            throw new Error(`Unknown Switcheroo resource type: ${type}`);
    }
};
const $ef0f6fe5ca24b5a5$export$4fa18e6b13122af5 = ()=>{
    const stagingLoginUrl = "https://id.stg.internal.atlassian.com";
    const prodLoginUrl = "https://id.atlassian.com";
    const isProd = $ef0f6fe5ca24b5a5$export$8a2eb78ddfc0abf8 === "prod";
    if (isProd) return prodLoginUrl;
    return stagingLoginUrl;
};
const $ef0f6fe5ca24b5a5$export$69a484083d87faa2 = ()=>{
    const stagingBaseUrl = "https://rovo-extension-web.stg-east.frontend.public.atl-paas.net";
    const prodBaseUrl = "https://rovo-extension-web.atlassian.com";
    const isProd = $ef0f6fe5ca24b5a5$export$8a2eb78ddfc0abf8 === "prod";
    if (isProd) return prodBaseUrl;
    return stagingBaseUrl;
};
const $ef0f6fe5ca24b5a5$export$c7a04534f7a88653 = ()=>`${$ef0f6fe5ca24b5a5$export$69a484083d87faa2()}/gateway/api/graphql`;
const $ef0f6fe5ca24b5a5$export$69576aae579b51af = ()=>{
    const stagingAtlassianHomeUrl = "https://home.stg.atlassian.com";
    const prodAtlassianHomeUrl = "https://home.atlassian.com";
    const isProd = $ef0f6fe5ca24b5a5$export$8a2eb78ddfc0abf8 === "prod";
    if (isProd) return prodAtlassianHomeUrl;
    return stagingAtlassianHomeUrl;
};
const $ef0f6fe5ca24b5a5$export$631ba87ff5b9e288 = ()=>{
    const stagingAdminHubUrl = "https://admin.stg.atlassian.com";
    const prodAdminHubUrl = "https://admin.atlassian.com";
    const isProd = $ef0f6fe5ca24b5a5$export$8a2eb78ddfc0abf8 === "prod";
    if (isProd) return prodAdminHubUrl;
    return stagingAdminHubUrl;
};
const $ef0f6fe5ca24b5a5$export$22f3f17829eee7e0 = ()=>{
    const stagingStudioUrl = "https://atlassian-studio.stg-east.frontend.public.atl-paas.net";
    const prodStudioUrl = "https://studio.atlassian.com";
    const isProd = $ef0f6fe5ca24b5a5$export$8a2eb78ddfc0abf8 === "prod";
    if (isProd) return prodStudioUrl;
    return stagingStudioUrl;
};
const $ef0f6fe5ca24b5a5$export$180605366c04f0cd = ()=>{
    return navigator.language;
};
const $ef0f6fe5ca24b5a5$export$4ea39b9726d98a51 = ()=>{
    const environment = $ef0f6fe5ca24b5a5$export$8a2eb78ddfc0abf8;
    const version = "48418549c9cebfe5bddc1bdf6c337abf8dba97be";
    const buildNumber = "13969025";
    const buildUrl = buildNumber ? `https://bitbucket.org/atlassian/atlassian-frontend-monorepo/pipelines/results/${buildNumber}` : undefined;
    return {
        environment: environment,
        version: version,
        buildNumber: buildNumber,
        buildUrl: buildUrl
    };
};

});

parcelRegister("iy6x4", function(module, exports) {
// Only used in local development (atlaspack dev flow)
// These must stay in sync with WindowMessageType in extension-chrome/src/scripts/message-bus/windowMessages.ts
const $da9ef5297cb8516b$var$SESSION_COOKIE_MESSAGE_TYPES = {
    REQUEST: "GET_SESSION_COOKIE_REQUEST",
    RESPONSE: "GET_SESSION_COOKIE_RESPONSE"
};
function $da9ef5297cb8516b$export$1620d451ff8602ae() {
    const match = document.cookie.match(/cloud.session.token.stg=([^;]+)/);
    return match ? match[1] : null;
}
function $da9ef5297cb8516b$export$7835b8deb2269e9c() {
    const existingSessionCookie = $da9ef5297cb8516b$export$1620d451ff8602ae();
    if (existingSessionCookie) return Promise.resolve(existingSessionCookie);
    return new Promise((resolve)=>{
        const handleMessage = (event)=>{
            if (event.data.type === $da9ef5297cb8516b$var$SESSION_COOKIE_MESSAGE_TYPES.RESPONSE) {
                window.removeEventListener("message", handleMessage);
                const cookie = event.data.cookie;
                resolve(cookie);
            }
        };
        window.addEventListener("message", handleMessage);
        window.parent.postMessage({
            type: $da9ef5297cb8516b$var$SESSION_COOKIE_MESSAGE_TYPES.REQUEST
        }, "*");
        // Timeout after 2 seconds
        setTimeout(()=>{
            window.removeEventListener("message", handleMessage);
            resolve(null);
        }, 2000);
    });
}
async function $da9ef5297cb8516b$export$7bcce6168ef1fdde() {
    const cookie = await $da9ef5297cb8516b$export$7835b8deb2269e9c();
    if (!cookie) return;
    try {
        const response = await fetch(`${window.location.origin}/set-session-cookie?token=${cookie}`);
        if (response.ok) // eslint-disable-next-line no-console
        console.log("\uD83C\uDF6A Cookie set via /set-session-cookie endpoint");
        else // eslint-disable-next-line no-console
        console.error("Failed to set cookie via /set-session-cookie endpoint");
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Failed to set cookie via /set-session-cookie endpoint", error);
    }
}

});





parcelRegister("bFW4F", function(module, exports) {
$parcel$export(module.exports, "GatewayQueryKeys", () => $dea4808c67babfd0$export$f2e6cdf3896a09be);
$parcel$export(module.exports, "GatewayError", () => $dea4808c67babfd0$export$8ef93724ecb8bcb7);
$parcel$export(module.exports, "useSitesWithRovoEnabled", () => $dea4808c67babfd0$export$285ef510e139bb08);
$parcel$export(module.exports, "useSearchSiteResources", () => $dea4808c67babfd0$export$aa23cd1321ee74ce);
$parcel$export(module.exports, "useRovoEntitlement", () => $dea4808c67babfd0$export$66d5dd4be64dea43);
$parcel$export(module.exports, "useUserAccount", () => $dea4808c67babfd0$export$355b5a80a2683ecb);
$parcel$export(module.exports, "extendSession", () => $dea4808c67babfd0$export$d0caa90bfa1dd141);
$parcel$export(module.exports, "use3PConnectors", () => $dea4808c67babfd0$export$546fbc853a926d44);
$parcel$export(module.exports, "getOrgAdminPermissions", () => $dea4808c67babfd0$export$6a5a4d31a72d7723);
$parcel$export(module.exports, "getSiteAdminPermissions", () => $dea4808c67babfd0$export$2a8816ad92ca751f);
$parcel$export(module.exports, "useOrgAdminPermissions", () => $dea4808c67babfd0$export$f44446fc6da7bd74);
$parcel$export(module.exports, "useSiteAdminPermissions", () => $dea4808c67babfd0$export$4c22a3fb2ef39a6);
$parcel$export(module.exports, "getAnnouncementSettings", () => $dea4808c67babfd0$export$f59e5704f7811ae4);
$parcel$export(module.exports, "saveAnnouncementSettings", () => $dea4808c67babfd0$export$46fc2e3ce5326cef);
$parcel$export(module.exports, "getCompanyThemingSettings", () => $dea4808c67babfd0$export$ba27034f167f88dc);
$parcel$export(module.exports, "saveCompanyThemingSettings", () => $dea4808c67babfd0$export$96dd258aa592820);
$parcel$export(module.exports, "getMediaToken", () => $dea4808c67babfd0$export$6d8018625f2049f7);
$parcel$export(module.exports, "getRovoExtensionAdminSettings", () => $dea4808c67babfd0$export$23fbf0ea178eddd2);
$parcel$export(module.exports, "saveRovoExtensionAdminSettings", () => $dea4808c67babfd0$export$8eaf99e03c8b850a);

var $dD8yb = parcelRequire("dD8yb");

var $kwVgn = parcelRequire("kwVgn");

var $22hwD = parcelRequire("22hwD");

var $9aNsE = parcelRequire("9aNsE");

var $1ZAcM = parcelRequire("1ZAcM");
var $dea4808c67babfd0$export$f2e6cdf3896a09be = /*#__PURE__*/ function(GatewayQueryKeys) {
    GatewayQueryKeys["SEARCH_SITES_WITH_ROVO_ENABLED_WITH_METADATA_NEW"] = "searchSitesWithRovoEnabledWithMetadataNew";
    return GatewayQueryKeys;
}({});
class $dea4808c67babfd0$export$8ef93724ecb8bcb7 extends Error {
    constructor(error){
        super(error.errorMessage);
        this.errorType = error.errorType;
        this.statusCode = error.code;
    }
}
const $dea4808c67babfd0$var$fiveMinutesInMs = 300000; // five minutes, 60 seconds in a minutes, 1000 milliseconds in a second
const $dea4808c67babfd0$var$oneHourInMs = 3600000; // sixty minutes in an hour, 60 seconds in a minutes, 1000 milliseconds in a second
const $dea4808c67babfd0$var$oneDayInMs = 24 * $dea4808c67babfd0$var$oneHourInMs;
function $dea4808c67babfd0$export$285ef510e139bb08(userAccount, useQueryOptions) {
    return (0, $dD8yb.useQuery)({
        queryKey: [
            "searchSitesWithRovoEnabledWithMetadataNew",
            userAccount?.accountId
        ],
        ...useQueryOptions,
        queryFn: ()=>$dea4808c67babfd0$export$c8b284ba2f7ea5bc(),
        throwOnError (error) {
            (0, $22hwD.logError)({
                error: new (0, $22hwD.NamedError)("RovoEnabledSitesFetchError", error),
                impact: "Error fetching rovo enabled sites"
            });
            return false;
        },
        staleTime: $dea4808c67babfd0$var$fiveMinutesInMs,
        gcTime: $dea4808c67babfd0$var$oneHourInMs,
        retry: 1
    });
}
async function $dea4808c67babfd0$export$c8b284ba2f7ea5bc() {
    const sites = await $dea4808c67babfd0$var$getSearchSites();
    const siteMetadataList = sites.siteMetadata ?? [];
    const resourcesList = sites.resources ?? [];
    const rovoEnabledSitesMap = {};
    for(let i = 0; i < siteMetadataList.length; i++){
        const metadata = siteMetadataList[i];
        if (metadata.isRovoEnabled) rovoEnabledSitesMap[metadata.siteId] = {
            isRovoEnabled: true,
            orgId: metadata.orgId
        };
    }
    const rovoEnabledSites = new Map();
    for (const resource of resourcesList){
        const siteId = resource.id.split("/").pop() ?? "";
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        if (rovoEnabledSitesMap[siteId]?.isRovoEnabled) rovoEnabledSites.set(siteId, {
            cloudId: siteId,
            siteName: resource.siteName,
            baseUrl: resource.baseUrl,
            orgId: rovoEnabledSitesMap[siteId].orgId
        });
    }
    const metadata = {
        sitesFound: resourcesList.length,
        sitesWithRovoEnabled: rovoEnabledSites.size,
        rovoEnabledSitesMap: rovoEnabledSitesMap
    };
    if (!rovoEnabledSites.size) throw new Error("No sites returned from configuration endpoint \u2014 possible transient failure");
    return {
        results: Array.from(rovoEnabledSites.values()),
        metadata: metadata
    };
}
async function $dea4808c67babfd0$var$getSearchSites() {
    const url = "/gateway/api/xpsearch-aggregator/configuration/v1";
    const options = {
        method: "GET",
        credentials: "include"
    };
    const response = await (0, $9aNsE.request)({
        url: url,
        options: options
    });
    return response;
}
function $dea4808c67babfd0$export$aa23cd1321ee74ce() {
    return (0, $dD8yb.useQuery)({
        queryKey: [
            "searchSiteResources"
        ],
        queryFn: ()=>$dea4808c67babfd0$var$getSearchSites(),
        staleTime: $dea4808c67babfd0$var$fiveMinutesInMs,
        gcTime: $dea4808c67babfd0$var$oneHourInMs
    });
}
const $dea4808c67babfd0$export$66d5dd4be64dea43 = (cloudId, options)=>{
    return (0, $dD8yb.useQuery)({
        staleTime: 60000,
        // one minute
        ...options,
        queryFn: ()=>$dea4808c67babfd0$export$1486c04fa16d30fa(cloudId),
        queryKey: [
            "rovoEntitlement",
            cloudId
        ]
    });
};
async function $dea4808c67babfd0$export$1486c04fa16d30fa(cloudId) {
    const url = "/gateway/api/assist/rovo/v2/entitlement";
    const options = {
        method: "GET",
        credentials: "include",
        extraHeaders: new Headers({
            "X-Cloudid": cloudId
        })
    };
    const response = await (0, $9aNsE.request)({
        url: url,
        options: options
    });
    return response;
}
function $dea4808c67babfd0$export$355b5a80a2683ecb() {
    return (0, $dD8yb.useQuery)({
        queryKey: [
            "userAccount"
        ],
        queryFn: $dea4808c67babfd0$var$getUserAccount,
        retry: (retryAttempt, e)=>{
            if (e.errorType === (0, $9aNsE.RequestErrorType).AUTH_ERROR) return false;
            return retryAttempt < 3;
        },
        refetchOnWindowFocus: false
    });
}
async function $dea4808c67babfd0$var$getUserAccount() {
    const url = "/gateway/api/me";
    const options = {
        method: "GET",
        credentials: "include",
        extraHeaders: new Headers({
            Accept: "application/json"
        })
    };
    const response = await (0, $9aNsE.request)({
        url: url,
        options: options
    });
    const userAccount = {
        accountId: response.account_id,
        email: response.email,
        name: response.name,
        nickname: response.nickname,
        picture: response.picture
    };
    if (!(0, $1ZAcM.isUserAccount)(userAccount)) {
        (0, $22hwD.logError)({
            error: new Error("Invalid user account data"),
            extra: {
                userAccount: userAccount
            }
        });
        throw new Error("Invalid user account data");
    }
    return userAccount;
}
function $dea4808c67babfd0$export$d0caa90bfa1dd141() {
    const url = "/gateway/api/session/heartbeat";
    const options = {
        method: "POST",
        credentials: "include",
        extraHeaders: new Headers({})
    };
    (0, $9aNsE.request)({
        url: url,
        options: options
    }).catch(()=>{});
}
async function $dea4808c67babfd0$var$get3PConnectors(cloudId) {
    const url = `/gateway/api/third-party-configuration/connected-data-sources/${cloudId}`;
    const options = {
        method: "GET",
        credentials: "include",
        extraHeaders: new Headers({
            "Content-Type": "application/json",
            "X-Cloudid": cloudId
        })
    };
    const response = await (0, $9aNsE.request)({
        url: url,
        options: options
    });
    return response;
}
function $dea4808c67babfd0$var$mergeOptimistic3pConnectors(data) {
    if (!data) return data;
    // Do not clear the overlay when we see isUserOAuthed here: that data may be our own
    // optimistic update.
    return data.map((connector)=>(0, $kwVgn.isOptimisticallyConnected)(connector.outboundAuthUrl) ? {
            ...connector,
            isUserOAuthed: true
        } : connector);
}
function $dea4808c67babfd0$export$546fbc853a926d44(cloudId) {
    return (0, $dD8yb.useQuery)({
        queryKey: [
            "3PConnectors",
            cloudId
        ],
        queryFn: ()=>$dea4808c67babfd0$var$get3PConnectors(cloudId),
        enabled: Boolean(cloudId),
        select: $dea4808c67babfd0$var$mergeOptimistic3pConnectors
    });
}
async function $dea4808c67babfd0$export$6a5a4d31a72d7723(orgId, cloudId, accountId) {
    const response = await (0, $9aNsE.request)({
        url: "gateway/api/permissions/permitted",
        options: {
            method: "POST",
            credentials: "include",
            extraHeaders: new Headers({
                "Content-Type": "application/json",
                "X-Cloudid": cloudId
            }),
            body: JSON.stringify({
                resourceId: `ari:cloud:platform::org/${orgId}`,
                principalId: `ari:cloud:identity::user/${accountId}`,
                permissionId: "manage/org"
            })
        }
    });
    return response;
}
async function $dea4808c67babfd0$export$2a8816ad92ca751f(siteId, accountId, product) {
    const response = await (0, $9aNsE.request)({
        url: "gateway/api/permissions/permitted",
        options: {
            method: "POST",
            credentials: "include",
            extraHeaders: new Headers({
                "Content-Type": "application/json",
                "X-Cloudid": siteId
            }),
            body: JSON.stringify({
                resourceId: `ari:cloud:${product}::site/${siteId}`,
                principalId: `ari:cloud:identity::user/${accountId}`,
                permissionId: "manage"
            })
        }
    });
    return response;
}
function $dea4808c67babfd0$export$f44446fc6da7bd74({ orgId: orgId, cloudId: cloudId, accountId: accountId }) {
    return (0, $dD8yb.useQuery)({
        queryKey: [
            "orgAdminAccess",
            orgId,
            accountId
        ],
        queryFn: ()=>$dea4808c67babfd0$export$6a5a4d31a72d7723(orgId, cloudId, accountId),
        staleTime: $dea4808c67babfd0$var$oneDayInMs,
        gcTime: $dea4808c67babfd0$var$oneDayInMs,
        enabled: Boolean(orgId)
    });
}
function $dea4808c67babfd0$export$4c22a3fb2ef39a6({ siteId: siteId, accountId: accountId, product: product = "platform" }) {
    return (0, $dD8yb.useQuery)({
        queryKey: [
            "siteAdminAccess",
            siteId,
            accountId
        ],
        queryFn: ()=>$dea4808c67babfd0$export$2a8816ad92ca751f(siteId, accountId, product),
        staleTime: $dea4808c67babfd0$var$fiveMinutesInMs,
        gcTime: $dea4808c67babfd0$var$fiveMinutesInMs,
        enabled: Boolean(siteId)
    });
}
const $dea4808c67babfd0$var$SETTINGS_ERROR_MESSAGES = {
    NETWORK_ERROR: "Network connection failed",
    VALIDATION_ERROR: (context)=>`Invalid ${context} data`,
    SERVER_ERROR: "Server error occurred",
    UNKNOWN_ERROR: "Failed to save changes"
};
const $dea4808c67babfd0$var$getSettingsErrorType = (error)=>{
    if (error instanceof TypeError) // Network/connection errors (fetch failures, DNS issues, etc.)
    return (0, $1ZAcM.SettingsErrorType).NETWORK_ERROR;
    if (error && typeof error === "object" && ("status" in error || "statusCode" in error)) {
        // HTTP error with status code (check both status and statusCode for compatibility)
        const status = error.status ?? error.statusCode;
        if (status >= 400 && status < 500) return (0, $1ZAcM.SettingsErrorType).VALIDATION_ERROR;
        if (status >= 500) return (0, $1ZAcM.SettingsErrorType).SERVER_ERROR;
        return (0, $1ZAcM.SettingsErrorType).UNKNOWN_ERROR;
    }
    return (0, $1ZAcM.SettingsErrorType).UNKNOWN_ERROR;
};
const $dea4808c67babfd0$var$handleSaveSettingsError = (error, context)=>{
    const errorType = $dea4808c67babfd0$var$getSettingsErrorType(error);
    const errorKey = (0, $1ZAcM.SettingsErrorType)[errorType];
    const messageTemplate = $dea4808c67babfd0$var$SETTINGS_ERROR_MESSAGES[errorKey];
    const message = errorType === (0, $1ZAcM.SettingsErrorType).VALIDATION_ERROR ? messageTemplate(context) : messageTemplate;
    const settingsError = new $dea4808c67babfd0$export$8ef93724ecb8bcb7({
        errorMessage: message,
        code: errorType,
        errorType: (0, $9aNsE.RequestErrorType).OTHER_ERROR
    });
    throw settingsError;
};
async function $dea4808c67babfd0$export$f59e5704f7811ae4(siteId) {
    const settingKey = "rovo-extension-company-announcements";
    const encodedResourceAri = encodeURIComponent(`ari:cloud:rovo::site/${siteId}`);
    const url = `/gateway/api/rovo-extension-web/resource/${encodedResourceAri}/setting/${settingKey}`;
    const options = {
        method: (0, $9aNsE.HTTPMethod).GET,
        credentials: "include",
        extraHeaders: new Headers({
            Accept: "application/json",
            "X-CloudId": siteId
        })
    };
    const response = await (0, $9aNsE.request)({
        url: url,
        options: options
    });
    return response.data.announcements ?? [];
}
async function $dea4808c67babfd0$export$46fc2e3ce5326cef(siteId, data) {
    const settingKey = "rovo-extension-company-announcements";
    const encodedResourceAri = encodeURIComponent(`ari:cloud:rovo::site/${siteId}`);
    const url = `/gateway/api/rovo-extension-web/resource/${encodedResourceAri}/setting/${settingKey}`;
    const options = {
        method: (0, $9aNsE.HTTPMethod).PUT,
        credentials: "include",
        extraHeaders: new Headers({
            Accept: "application/json",
            "Content-Type": "application/json",
            "X-CloudId": siteId
        }),
        body: JSON.stringify(data)
    };
    try {
        const response = await (0, $9aNsE.request)({
            url: url,
            options: options
        });
        return response.data.announcements ?? [];
    } catch (error) {
        return $dea4808c67babfd0$var$handleSaveSettingsError(error, "announcement");
    }
}
async function $dea4808c67babfd0$export$ba27034f167f88dc(siteId) {
    const settingKey = "rovo-extension-company-theming";
    const encodedResourceAri = encodeURIComponent(`ari:cloud:rovo::site/${siteId}`);
    const url = `/gateway/api/rovo-extension-web/resource/${encodedResourceAri}/setting/${settingKey}`;
    const options = {
        method: (0, $9aNsE.HTTPMethod).GET,
        credentials: "include",
        extraHeaders: new Headers({
            Accept: "application/json",
            "X-CloudId": siteId
        })
    };
    const defaultCompanyThemingSettings = {
        fontColorLight: null,
        fontColorDark: null,
        navbarColorLight: null,
        navbarColorDark: null
    };
    const response = await (0, $9aNsE.request)({
        url: url,
        options: options
    });
    return response.data ?? defaultCompanyThemingSettings;
}
async function $dea4808c67babfd0$export$96dd258aa592820(siteId, data) {
    const settingKey = "rovo-extension-company-theming";
    const encodedResourceAri = encodeURIComponent(`ari:cloud:rovo::site/${siteId}`);
    const url = `/gateway/api/rovo-extension-web/resource/${encodedResourceAri}/setting/${settingKey}`;
    const options = {
        method: (0, $9aNsE.HTTPMethod).PUT,
        credentials: "include",
        extraHeaders: new Headers({
            Accept: "application/json",
            "Content-Type": "application/json",
            "X-CloudId": siteId
        }),
        body: JSON.stringify(data)
    };
    try {
        const response = await (0, $9aNsE.request)({
            url: url,
            options: options
        });
        return response.data;
    } catch (error) {
        return $dea4808c67babfd0$var$handleSaveSettingsError(error, "company theme");
    }
}
async function $dea4808c67babfd0$export$6d8018625f2049f7(siteId) {
    const response = await (0, $9aNsE.request)({
        url: "gateway/api/assist/rovo/v1/extension/media/token",
        options: {
            method: (0, $9aNsE.HTTPMethod).POST,
            credentials: "include",
            extraHeaders: new Headers({
                "X-Product": "rovo",
                "X-Experience-Id": "ai-mate",
                "X-Cloudid": siteId,
                "Content-Type": "application/json"
            }),
            body: JSON.stringify({
                collection: "rovo-extension"
            })
        }
    });
    return response;
}
async function $dea4808c67babfd0$export$23fbf0ea178eddd2(siteId) {
    const settingKey = "rovoextadminsettings";
    const encodedResourceAri = encodeURIComponent(`ari:cloud:rovo::site/${siteId}`);
    const url = `/gateway/api/rovo-extension-web/resource/${encodedResourceAri}/setting/${settingKey}`;
    const options = {
        method: (0, $9aNsE.HTTPMethod).GET,
        credentials: "include",
        extraHeaders: new Headers({
            Accept: "application/json",
            "X-CloudId": siteId
        })
    };
    const response = await (0, $9aNsE.request)({
        url: url,
        options: options
    });
    return response.data ?? {};
}
async function $dea4808c67babfd0$export$8eaf99e03c8b850a(siteId, data) {
    const settingKey = "rovoextadminsettings";
    const encodedResourceAri = encodeURIComponent(`ari:cloud:rovo::site/${siteId}`);
    const url = `/gateway/api/rovo-extension-web/resource/${encodedResourceAri}/setting/${settingKey}`;
    const options = {
        method: (0, $9aNsE.HTTPMethod).PUT,
        credentials: "include",
        extraHeaders: new Headers({
            Accept: "application/json",
            "Content-Type": "application/json",
            "X-CloudId": siteId
        }),
        body: JSON.stringify(data)
    };
    try {
        const response = await (0, $9aNsE.request)({
            url: url,
            options: options
        });
        return response.data;
    } catch (error) {
        return $dea4808c67babfd0$var$handleSaveSettingsError(error, "admin settings");
    }
}

});
parcelRegister("kwVgn", function(module, exports) {
$parcel$export(module.exports, "setOptimisticConnect", () => $230f5b54e748ff84$export$6593ecac7966ef1a);
$parcel$export(module.exports, "isOptimisticallyConnected", () => $230f5b54e748ff84$export$6bd24ca2088367e6);
/**
 * Tracks connectors we optimistically marked as connected after OAuth success,
 * so refetches (e.g. refetchOnWindowFocus) do not overwrite with stale server
 * data until the backend has propagated.
 */ const $230f5b54e748ff84$var$GRACE_MS = 10000;
const $230f5b54e748ff84$var$overlay = new Map();
function $230f5b54e748ff84$export$6593ecac7966ef1a(outboundAuthUrl) {
    $230f5b54e748ff84$var$overlay.set(outboundAuthUrl, Date.now());
}
function $230f5b54e748ff84$export$6bd24ca2088367e6(outboundAuthUrl) {
    const at = $230f5b54e748ff84$var$overlay.get(outboundAuthUrl);
    if (at == null) return false;
    if (Date.now() - at >= $230f5b54e748ff84$var$GRACE_MS) {
        $230f5b54e748ff84$export$c18dbba562c95dd(outboundAuthUrl);
        return false;
    }
    return true;
}
function $230f5b54e748ff84$export$c18dbba562c95dd(outboundAuthUrl) {
    $230f5b54e748ff84$var$overlay.delete(outboundAuthUrl);
}

});

parcelRegister("9aNsE", function(module, exports) {
$parcel$export(module.exports, "RequestErrorType", () => $a0a3285d23add2be$export$c0cc522fa83a630);
$parcel$export(module.exports, "HTTPMethod", () => $a0a3285d23add2be$export$f03a741ee867f39c);
$parcel$export(module.exports, "request", () => $a0a3285d23add2be$export$b5fe3f66a567bec0);

var $bFW4F = parcelRequire("bFW4F");
var $a0a3285d23add2be$export$c0cc522fa83a630 = /*#__PURE__*/ function(RequestErrorType) {
    RequestErrorType["AUTH_ERROR"] = "AUTH_ERROR";
    RequestErrorType["OTHER_ERROR"] = "OTHER_ERROR";
    return RequestErrorType;
}({});
var $a0a3285d23add2be$export$f03a741ee867f39c = /*#__PURE__*/ function(HTTPMethod) {
    HTTPMethod["GET"] = "GET";
    HTTPMethod["POST"] = "POST";
    HTTPMethod["PUT"] = "PUT";
    HTTPMethod["PATCH"] = "PATCH";
    HTTPMethod["DELETE"] = "DELETE";
    return HTTPMethod;
}({});
async function $a0a3285d23add2be$export$b5fe3f66a567bec0({ url: url, options: options }) {
    const isFormData = "body" in options && options.body instanceof FormData;
    const requestHeaders = $a0a3285d23add2be$var$buildHeaders({
        extraHeaders: options.extraHeaders,
        inferContentType: isFormData
    });
    const requestOptions = {
        method: options.method,
        headers: requestHeaders,
        credentials: options.credentials,
        body: options.method === "POST" || options.method === "PUT" || options.method === "PATCH" ? options.body : undefined
    };
    const response = await fetch(url, requestOptions);
    if (!response.ok) throw new (0, $bFW4F.GatewayError)({
        errorType: response.status === 401 || response.status === 403 ? "AUTH_ERROR" : "OTHER_ERROR",
        code: response.status,
        errorMessage: `${response.status} - Failed to ${options.method} ${url}`
    });
    if (response.headers.get("Content-Type")?.includes("application/json") ?? requestHeaders.get("Accept") === "application/json") return response.json();
    return response;
}
function $a0a3285d23add2be$var$buildHeaders({ extraHeaders: extraHeaders, inferContentType: inferContentType }) {
    const headers = new Headers();
    if (!inferContentType) headers.set("Content-Type", "application/json");
    extraHeaders?.forEach((value, key)=>{
        headers.set(key, value);
    });
    return headers;
}

});

parcelRegister("1ZAcM", function(module, exports) {
$parcel$export(module.exports, "isUserAccount", () => $17a9ac43c1700b1c$export$523b7140f1dfc1f0);
$parcel$export(module.exports, "SettingsErrorType", () => $17a9ac43c1700b1c$export$7ec6bbb46b9e5f23);
const $17a9ac43c1700b1c$export$523b7140f1dfc1f0 = (data)=>{
    return Boolean(data.accountId && data.email && data.name && data.nickname && data.picture);
};
var $17a9ac43c1700b1c$export$7ec6bbb46b9e5f23 = /*#__PURE__*/ function(SettingsErrorType) {
    SettingsErrorType[SettingsErrorType["NETWORK_ERROR"] = 1000] = "NETWORK_ERROR";
    SettingsErrorType[SettingsErrorType["VALIDATION_ERROR"] = 1001] = "VALIDATION_ERROR";
    SettingsErrorType[SettingsErrorType["SERVER_ERROR"] = 1002] = "SERVER_ERROR";
    SettingsErrorType[SettingsErrorType["UNKNOWN_ERROR"] = 1003] = "UNKNOWN_ERROR";
    return SettingsErrorType;
}({});

});


parcelRegister("e9gYt", function(module, exports) {
$parcel$export(module.exports, "isHello", () => $b0bcb443f0ff1d7d$export$8e3fc93123f96c19);
function $b0bcb443f0ff1d7d$export$8e3fc93123f96c19(cloudId) {
    return cloudId === "a436116f-02ce-4520-8fbb-7301462a1674";
}

});

parcelRegister("f0dSY", function(module, exports) {
$parcel$export(module.exports, "initializeSentry", () => $1c5e2247836c7d2a$export$1f7656c617418e15);
$parcel$export(module.exports, "setSentryUser", () => $1c5e2247836c7d2a$export$5ceec5c8be62fa1b);
$parcel$export(module.exports, "setSentrySiteId", () => $1c5e2247836c7d2a$export$90b57d32e0a1baf4);
$parcel$export(module.exports, "clearSentryUser", () => $1c5e2247836c7d2a$export$e3ad57e6f9f2f051);
$parcel$export(module.exports, "setSentryExperiments", () => $1c5e2247836c7d2a$export$68c09cda53c4724c);

var $55xCb = parcelRequire("55xCb");
var $65z9B = parcelRequire("65z9B");
var $9QeFV = parcelRequire("9QeFV");
parcelRequire("iuDZJ");
var $dqHaj = parcelRequire("dqHaj");

var $6jMOU = parcelRequire("6jMOU");

var $crLv5 = parcelRequire("crLv5");

var $LpV4F = parcelRequire("LpV4F");
const $1c5e2247836c7d2a$var$getSentryDsn = (env)=>{
    if (env === "dev") return "https://f53c67cb2614beaabdff4ee6a84aaa95@o55978.ingest.us.sentry.io/4507891849625600";
    return "https://9cf62308d0228b7d1d63b292839a8c37@o55978.ingest.us.sentry.io/4507891849625600";
};
const $1c5e2247836c7d2a$var$getRovoExtensionVersion = ()=>{
    const version = new URLSearchParams(window.location.search).get("version");
    return version ?? "unknown";
};
const $1c5e2247836c7d2a$export$c9336bd12880d863 = (value)=>{
    if (value === undefined || value === "") return value;
    return "[SANITIZED]";
};
const $1c5e2247836c7d2a$var$sensitiveParamKeys = Object.freeze([
    "rovoChatPrompt"
]);
const $1c5e2247836c7d2a$var$sanitizeQueryParams = (queryString)=>{
    if (!queryString) return;
    if (Array.isArray(queryString)) return queryString.map(([key, value])=>[
            key,
            $1c5e2247836c7d2a$var$sensitiveParamKeys.includes(key) ? $1c5e2247836c7d2a$export$c9336bd12880d863(value) ?? "" : value
        ]);
    else if (typeof queryString === "string") {
        const params = new URLSearchParams(queryString);
        $1c5e2247836c7d2a$var$sensitiveParamKeys.forEach((key)=>{
            if (params.has(key)) params.set(key, $1c5e2247836c7d2a$export$c9336bd12880d863(params.get(key) ?? "") ?? "");
        });
        return params.toString();
    }
    const sanitizedQuery = {};
    for (const [key, value] of Object.entries(queryString))sanitizedQuery[key] = $1c5e2247836c7d2a$var$sensitiveParamKeys.includes(key) ? $1c5e2247836c7d2a$export$c9336bd12880d863(value) ?? "" : value;
    return sanitizedQuery;
};
const $1c5e2247836c7d2a$var$sanitizeUrl = (url)=>{
    if (!url || !url.includes("?")) return url;
    const [baseUrl, queryString] = url.split("?");
    const sanitizedQueryString = $1c5e2247836c7d2a$var$sanitizeQueryParams(queryString);
    return sanitizedQueryString ? `${baseUrl}?${sanitizedQueryString}` : baseUrl;
};
const $1c5e2247836c7d2a$var$hasUserAccountKeys = (obj)=>{
    if (!obj || typeof obj !== "object") return false;
    const userAccountKeys = [
        "email",
        "name",
        "nickname",
        "picture"
    ];
    return userAccountKeys.some((key)=>key in obj);
};
const $1c5e2247836c7d2a$export$e958bec57fbab05f = (event)=>{
    const sanitizedEvent = {
        ...event
    };
    sanitizedEvent.contexts = {
        ...event.contexts,
        response: {
            ...event.contexts?.response,
            cookies: undefined,
            headers: undefined
        },
        "Atlassian Trace": {
            trace_id: event.contexts?.response?.headers?.["x-trace-id"],
            request_id: event.contexts?.response?.headers?.["atl-request-id"]
        }
    };
    if (sanitizedEvent.extra && $1c5e2247836c7d2a$var$hasUserAccountKeys(sanitizedEvent.extra)) sanitizedEvent.extra = {
        ...sanitizedEvent.extra,
        email: $1c5e2247836c7d2a$export$c9336bd12880d863(sanitizedEvent.extra.email),
        name: $1c5e2247836c7d2a$export$c9336bd12880d863(sanitizedEvent.extra.name),
        nickname: $1c5e2247836c7d2a$export$c9336bd12880d863(sanitizedEvent.extra.nickname),
        picture: $1c5e2247836c7d2a$export$c9336bd12880d863(sanitizedEvent.extra.picture)
    };
    if (event.request?.method) sanitizedEvent.message = `${event.contexts?.response?.status_code} - Failed to ${event.request.method} ${event.request.url ? new URL(event.request.url).pathname : ""}`;
    sanitizedEvent.request = {
        ...event.request,
        url: $1c5e2247836c7d2a$var$sanitizeUrl(event.request?.url),
        headers: {
            "User-Agent": event.request?.headers?.["User-Agent"] ?? ""
        },
        cookies: undefined,
        query_string: $1c5e2247836c7d2a$var$sanitizeQueryParams(event.request?.query_string)
    };
    if (sanitizedEvent.exception?.values) sanitizedEvent.exception.values = sanitizedEvent.exception.values.map((value)=>{
        if (value.type === "Error" && value.mechanism?.type === "http.client") return {
            ...value,
            value: sanitizedEvent.message
        };
        return value;
    });
    return sanitizedEvent;
};
const $1c5e2247836c7d2a$export$1f7656c617418e15 = ()=>{
    $65z9B.init({
        dsn: $1c5e2247836c7d2a$var$getSentryDsn((0, $dqHaj.bifrostEnv)),
        environment: (0, $dqHaj.bifrostEnv),
        release: `rovo-extension-frontend@${(0, $dqHaj.bitbucketCommit)}`,
        sendDefaultPii: true,
        integrations: [
            $55xCb.httpClientIntegration({
                failedRequestStatusCodes: [
                    [
                        400,
                        599
                    ]
                ]
            })
        ],
        beforeSend: (event)=>{
            const sanitizedEvent = $1c5e2247836c7d2a$export$e958bec57fbab05f(event);
            // Send error analytics before sending to Sentry
            try {
                (0, $6jMOU.sendErrorAnalytics)(sanitizedEvent);
            } catch  {
            // do nothing
            }
            return sanitizedEvent;
        },
        normalizeDepth: 5
    });
    $9QeFV.setTag("rovoExtensionVersion", $1c5e2247836c7d2a$var$getRovoExtensionVersion());
};
const $1c5e2247836c7d2a$export$5ceec5c8be62fa1b = (accountId)=>{
    $9QeFV.setUser({
        id: accountId
    });
};
const $1c5e2247836c7d2a$export$90b57d32e0a1baf4 = (siteId)=>{
    $9QeFV.setTag("siteId", siteId);
};
const $1c5e2247836c7d2a$export$e3ad57e6f9f2f051 = ()=>{
    $9QeFV.setUser(null);
};
const $1c5e2247836c7d2a$export$68c09cda53c4724c = ()=>{
    (0, $crLv5.activeExperiments).forEach((experiment)=>{
        const value = (0, $LpV4F.getExperimentNoExposure)({
            experimentName: experiment.experimentName,
            parameterName: experiment.parameterName,
            defaultValue: false
        });
        $9QeFV.setTag(`exp.${experiment.experimentName}`, value ? "enabled" : "disabled");
    });
};

});
parcelRegister("6jMOU", function(module, exports) {
$parcel$export(module.exports, "sendErrorAnalytics", () => $68a29dd5f0ffb3c0$export$552acb5702b97c64);

var $fBMYg = parcelRequire("fBMYg");

var $dX6kP = parcelRequire("dX6kP");

var $lsxLV = parcelRequire("lsxLV");
/**
 * Extracts relevant error information from Sentry event for analytics
 */ const $68a29dd5f0ffb3c0$var$extractErrorAttributes = (event)=>{
    const attributes = {
        environment: event.environment,
        userAgent: event.request?.headers?.["User-Agent"],
        extensionVersion: event.tags?.rovoExtensionVersion,
        siteId: event.tags?.siteId,
        userId: event.user?.id?.toString()
    };
    // Extract error type
    if (event.exception?.values?.[0]) {
        const exception = event.exception.values[0];
        attributes.errorType = exception.type;
    }
    if (event.contexts?.response) attributes.httpStatusCode = event.contexts.response.status_code;
    if (event.request?.method) {
        attributes.requestMethod = event.request.method;
        try {
            const url = event.request.url ? new URL(event.request.url).pathname : undefined;
            attributes.requestPath = url;
        } catch  {
        // Invalid URL, skip
        }
    }
    return attributes;
};
const $68a29dd5f0ffb3c0$export$552acb5702b97c64 = (event)=>{
    if (event.level !== "error" && event.level !== "fatal") return;
    const attributes = $68a29dd5f0ffb3c0$var$extractErrorAttributes(event);
    // Set tenant info if available
    if (attributes.siteId) (0, $dX6kP.analyticsClient).setTenantInfo((0, $fBMYg.tenantType).CLOUD_ID, attributes.siteId);
    // Set user info if available
    if (attributes.userId) (0, $dX6kP.analyticsClient).setUserInfo((0, $fBMYg.userType).ATLASSIAN_ACCOUNT, attributes.userId);
    // https://data-portal.internal.atlassian.com/analytics/registry/86838
    (0, $dX6kP.analyticsClient).sendTrackEvent({
        source: "rovoExtensionFrontend",
        action: "error",
        actionSubject: (0, $lsxLV.ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS).ROVO_EXTENSION_FRONTEND,
        attributes: {
            ...attributes
        }
    }).catch(()=>{
    // do nothing
    });
};

});
parcelRegister("lsxLV", function(module, exports) {
$parcel$export(module.exports, "ROVO_EXTENSION_PLATFORM_ANALYTICS", () => $7c29402520d56d84$export$c2b2aecd22d35334);
$parcel$export(module.exports, "ANALYTICS_SCREEN_NAMES", () => $7c29402520d56d84$export$4add0c56ef03fe82);
$parcel$export(module.exports, "ANALYTICS_UI_SUBJECTS", () => $7c29402520d56d84$export$dcf9e0440080ae77);
$parcel$export(module.exports, "ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS", () => $7c29402520d56d84$export$9fc73ca44f63e3f4);
$parcel$export(module.exports, "ANALYTICS_OPERATIONAL_EVENT_ACTION_SUBJECTS", () => $7c29402520d56d84$export$7157f0775e2fcec3);
var $7c29402520d56d84$export$c2b2aecd22d35334 = /*#__PURE__*/ function(ROVO_EXTENSION_PLATFORM_ANALYTICS) {
    ROVO_EXTENSION_PLATFORM_ANALYTICS["CHANNEL"] = "rovo-extension";
    ROVO_EXTENSION_PLATFORM_ANALYTICS["PRODUCT"] = "rovoExtension";
    return ROVO_EXTENSION_PLATFORM_ANALYTICS;
}({});
var $7c29402520d56d84$export$4add0c56ef03fe82 = /*#__PURE__*/ function(ANALYTICS_SCREEN_NAMES) {
    ANALYTICS_SCREEN_NAMES["EXTENSION_HOME_SCREEN"] = "extensionHomePage";
    ANALYTICS_SCREEN_NAMES["EXTENSION_OPTIONS_SCREEN"] = "extensionOptionsPage";
    ANALYTICS_SCREEN_NAMES["EXTENSION_NTP_LOGIN_SCREEN"] = "extensionNtpLogInPage";
    ANALYTICS_SCREEN_NAMES["EXTENSION_CHAT_LOGIN_SCREEN"] = "extensionChatLogInPage";
    ANALYTICS_SCREEN_NAMES["EXTENSION_NEW_WELCOME_SCREEN"] = "extensionNewWelcomePage";
    ANALYTICS_SCREEN_NAMES["EXTENSION_AUTO_LOGIN_SCREEN"] = "extensionAutoLoginScreen";
    ANALYTICS_SCREEN_NAMES["EXTENSION_REDIRECT_TO_IDENTITY_SCREEN"] = "extensionRedirectToIdentityScreen";
    ANALYTICS_SCREEN_NAMES["EXTENSION_AFTER_LOGIN_REDIRECT"] = "extensionAfterLoginRedirectScreen";
    ANALYTICS_SCREEN_NAMES["EXTENSION_AFTER_LOGOUT_REDIRECT"] = "extensionAfterLogoutRedirectScreen";
    ANALYTICS_SCREEN_NAMES["EXTENSION_CHAT_SCREEN"] = "extensionChatPage";
    ANALYTICS_SCREEN_NAMES["EXTENSION_POPUP_SCREEN"] = "extensionPopupPage";
    ANALYTICS_SCREEN_NAMES["EXTENSION_UNINSTALL_SCREEN"] = "extensionUninstallPage";
    ANALYTICS_SCREEN_NAMES["EXTENSION_ADMIN_OPTIONS_SCREEN"] = "extensionAdminOptionsScreen";
    ANALYTICS_SCREEN_NAMES["EXTENSION_WHATS_NEW_SCREEN"] = "extensionWhatsNewPage";
    ANALYTICS_SCREEN_NAMES["EXTENSION_CALENDAR_USER_AUTH_VIEW"] = "extensionCalendarUserAuthView";
    ANALYTICS_SCREEN_NAMES["EXTENSION_NO_ROVO_VIEW"] = "extensionNoRovoView";
    ANALYTICS_SCREEN_NAMES["EXTENSION_NO_SITE_VIEW"] = "extensionNoSiteView";
    ANALYTICS_SCREEN_NAMES["EXTENSION_ANNOUNCEMENT_VIEW"] = "extensionAnnouncementView";
    return ANALYTICS_SCREEN_NAMES;
}({});
var $7c29402520d56d84$export$dcf9e0440080ae77 = /*#__PURE__*/ function(ANALYTICS_UI_SUBJECTS) {
    ANALYTICS_UI_SUBJECTS["EXTENSION_CHAT_SEARCH_BAR"] = "extensionChatSearchBar";
    ANALYTICS_UI_SUBJECTS["EXTENSION_QUICK_FIND_SEARCH_BAR"] = "extensionQuickFindSearchBar";
    ANALYTICS_UI_SUBJECTS["EXTENSION_SEARCH_BAR_HOTKEY"] = "extensionSearchBarHotkey";
    ANALYTICS_UI_SUBJECTS["HOME_PAGE_CHAT_BUTTON"] = "homePageChatButton";
    ANALYTICS_UI_SUBJECTS["EXTENSION_LOGIN"] = "extensionLogIn";
    ANALYTICS_UI_SUBJECTS["SHORTCUTS_ITEM"] = "shortcutsItem";
    ANALYTICS_UI_SUBJECTS["SHORTCUTS_ADD_BUTTON"] = "shortcutsAddButton";
    ANALYTICS_UI_SUBJECTS["SHORTCUTS"] = "shortcuts";
    ANALYTICS_UI_SUBJECTS["NAV_BAR_CHAT_BUTTON"] = "navBarChatButton";
    ANALYTICS_UI_SUBJECTS["NAV_BAR_LOGO"] = "navBarLogo";
    ANALYTICS_UI_SUBJECTS["SITE_SELECTOR"] = "siteSelector";
    ANALYTICS_UI_SUBJECTS["FEEDBACK_BUTTON"] = "feedbackButton";
    ANALYTICS_UI_SUBJECTS["FEEDBACK_COLLECTOR"] = "feedbackCollector";
    ANALYTICS_UI_SUBJECTS["CHROME_APP_SHORTCUT"] = "chromeAppShortcut";
    ANALYTICS_UI_SUBJECTS["BOOKMARK"] = "bookmark";
    ANALYTICS_UI_SUBJECTS["DROPDOWN_BOOKMARK"] = "dropdownBookmark";
    ANALYTICS_UI_SUBJECTS["BOOKMARK_MANAGER_BUTTON"] = "bookmarkManagerButton";
    ANALYTICS_UI_SUBJECTS["BOOKMARKS_BAR_CLOSE_BUTTON"] = "bookmarksBarCloseButton";
    ANALYTICS_UI_SUBJECTS["APP_SWITCHER_BUTTON"] = "appSwitcherButton";
    ANALYTICS_UI_SUBJECTS["SHORTCUTS_CONFIG_MENU"] = "shortcutsConfigMenu";
    ANALYTICS_UI_SUBJECTS["SHORTCUTS_CONFIG_MENU_OPTION"] = "shortcutsConfigMenuOption";
    ANALYTICS_UI_SUBJECTS["SHORTCUTS_CONFIG_MENU_SAVE_BUTTON"] = "shortcutsConfigMenuSaveButton";
    ANALYTICS_UI_SUBJECTS["SHORTCUTS_EDIT_OPTIONS_MENU"] = "shortcutsEditOptionsMenu";
    ANALYTICS_UI_SUBJECTS["SHORTCUTS_EDIT_LINK_BUTTON"] = "shortcutsEditLinkButton";
    ANALYTICS_UI_SUBJECTS["SHORTCUT_ITEM_EDIT_MODAL"] = "shortcutItemEditModal";
    ANALYTICS_UI_SUBJECTS["PLUGIN_FEEDBACK_YES_BUTTON"] = "pluginFeedbackYesButton";
    ANALYTICS_UI_SUBJECTS["PLUGIN_FEEDBACK_NO_BUTTON"] = "pluginFeedbackNoButton";
    ANALYTICS_UI_SUBJECTS["PLUGIN_FEEDBACK_REVIEW_CONFIRM_BUTTON"] = "pluginFeedbackReviewConfirmButton";
    ANALYTICS_UI_SUBJECTS["PLUGIN_FEEDBACK_REVIEW_DISMISS_BUTTON"] = "pluginFeedbackReviewDismissButton";
    ANALYTICS_UI_SUBJECTS["LOGIN_BUTTON"] = "loginButton";
    ANALYTICS_UI_SUBJECTS["ANNOUNCEMENT_BANNER"] = "announcementBanner";
    ANALYTICS_UI_SUBJECTS["ROVO_CHAT_TAB"] = "rovoChatTab";
    ANALYTICS_UI_SUBJECTS["ROVO_SEARCH_TAB"] = "rovoSearchTab";
    ANALYTICS_UI_SUBJECTS["DEFAULT_SEARCH_TAB_OPTION"] = "defaultSearchTabUserOption";
    ANALYTICS_UI_SUBJECTS["RECENT_WORK_ROW"] = "recentWorkRow";
    ANALYTICS_UI_SUBJECTS["RECENT_WORK_DISMISS_BUTTON"] = "recentWorkDismissButton";
    ANALYTICS_UI_SUBJECTS["GLOBAL_CREATE_BUTTON"] = "globalCreateButton";
    ANALYTICS_UI_SUBJECTS["GLOBAL_CREATE_ITEM"] = "globalCreateItem";
    ANALYTICS_UI_SUBJECTS["OPEN_MENU_TAB_BUTTON"] = "openMenuTabButton";
    ANALYTICS_UI_SUBJECTS["CALENDAR_DISMISS_BUTTON"] = "calendarDismissButton";
    ANALYTICS_UI_SUBJECTS["CALENDAR_JOIN_MEETING_BUTTON"] = "calendarJoinMeetingButton";
    ANALYTICS_UI_SUBJECTS["CALENDAR_VIEW_MEETING_BUTTON"] = "calendarViewMeetingButton";
    ANALYTICS_UI_SUBJECTS["CALENDAR_DATE_PICKER"] = "calendarDatePicker";
    ANALYTICS_UI_SUBJECTS["CALENDAR_DATE_CHEVRON_BUTTON"] = "calendarDateChevronButton";
    ANALYTICS_UI_SUBJECTS["CALENDAR_SHOW_MORE_BUTTON"] = "calendarShowMoreButton";
    ANALYTICS_UI_SUBJECTS["CALENDAR_CONNECT_BUTTON"] = "calendarConnectButton";
    ANALYTICS_UI_SUBJECTS["CALENDAR_ADMIN_CONNECT_BUTTON"] = "calendarAdminConnectButton";
    ANALYTICS_UI_SUBJECTS["CALENDAR_EVENT_CARD"] = "calendarEventCard";
    ANALYTICS_UI_SUBJECTS["UNINSTALL_SURVEY"] = "uninstallSurvey";
    ANALYTICS_UI_SUBJECTS["NTP_CALENDAR_OPTION"] = "ntpCalendarOption";
    ANALYTICS_UI_SUBJECTS["ADMIN_OPTIONS_UPLOAD_BACKGROUND_BUTTON"] = "adminOptionsUploadBackgroundButton";
    ANALYTICS_UI_SUBJECTS["ADMIN_OPTIONS_REMOVE_BACKGROUND_BUTTON"] = "adminOptionsRemoveBackgroundButton";
    ANALYTICS_UI_SUBJECTS["ADMIN_OPTIONS_BACKGROUND_FILE_SELECTOR"] = "adminOptionsBackgroundFileSelector";
    ANALYTICS_UI_SUBJECTS["ADMIN_OPTIONS_UPLOAD_LOGO_BUTTON"] = "adminOptionsUploadLogoButton";
    ANALYTICS_UI_SUBJECTS["ADMIN_OPTIONS_REMOVE_LOGO_BUTTON"] = "adminOptionsRemoveLogoButton";
    ANALYTICS_UI_SUBJECTS["ADMIN_OPTIONS_LOGO_FILE_SELECTOR"] = "adminOptionsLogoFileSelector";
    ANALYTICS_UI_SUBJECTS["ADMIN_OPTIONS_CUSTOMIZE_LOGO_BEHAVIOR_BUTTON"] = "adminOptionsCustomizeLogoBehaviorButton";
    ANALYTICS_UI_SUBJECTS["ADMIN_OPTIONS_SITE_SELECTOR"] = "adminOptionsSiteSelector";
    ANALYTICS_UI_SUBJECTS["VIEW_PROFILE_BUTTON"] = "viewProfileButton";
    ANALYTICS_UI_SUBJECTS["WELCOME_PAGE_FEATURE_BUTTON"] = "welcomePageFeatureButton";
    ANALYTICS_UI_SUBJECTS["NEW_WELCOME_PAGE_GET_STARTED"] = "newWelcomePageGetStarted";
    ANALYTICS_UI_SUBJECTS["ADD_NEW_ANNOUNCEMENT_BUTTON"] = "addNewAnnouncementButton";
    ANALYTICS_UI_SUBJECTS["DELETE_ANNOUNCEMENT_BUTTON"] = "deleteAnnouncementButton";
    ANALYTICS_UI_SUBJECTS["SAVE_ANNOUNCEMENT_BUTTON"] = "saveAnnouncementButton";
    ANALYTICS_UI_SUBJECTS["MANAGE_ANNOUNCEMENTS"] = "manageAnnouncements";
    ANALYTICS_UI_SUBJECTS["HIDE_ANNOUNCEMENTS_BUTTON"] = "hideAnnouncementButton";
    ANALYTICS_UI_SUBJECTS["ANNOUNCEMENT_VIEW_WINDOW"] = "announcementViewWindow";
    ANALYTICS_UI_SUBJECTS["ANNOUNCEMENT_TOGGLE_BUTTON"] = "announcementToggleButton";
    ANALYTICS_UI_SUBJECTS["CONNECTOR_ICON_BUTTON"] = "connectorIconButton";
    ANALYTICS_UI_SUBJECTS["CONNECTOR_DROPDOWN"] = "connectorDropdown";
    ANALYTICS_UI_SUBJECTS["CONNECTOR_DROPDOWN_CONNECT"] = "connectorDropdownConnect";
    ANALYTICS_UI_SUBJECTS["SETTING_TOGGLE"] = "settingToggle";
    ANALYTICS_UI_SUBJECTS["SETTINGS_NAVIGATION_SECTION"] = "settingsNavigationSection";
    ANALYTICS_UI_SUBJECTS["NTP_AGENT_MENU"] = "ntpAgentMenu";
    ANALYTICS_UI_SUBJECTS["NTP_AGENT_MENU_OPTION"] = "ntpAgentMenuOption";
    ANALYTICS_UI_SUBJECTS["NTP_BROWSE_AGENTS_MODAL"] = "ntpBrowseAgentsModal";
    return ANALYTICS_UI_SUBJECTS;
}({});
var $7c29402520d56d84$export$9fc73ca44f63e3f4 = /*#__PURE__*/ function(ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS) {
    ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS["LOGIN"] = "login";
    ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS["LOGOUT"] = "logout";
    ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS["ADMIN_OPTIONS_BACKGROUND_UPLOAD"] = "adminOptionsBackgroundUpload";
    ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS["ADMIN_OPTIONS_BACKGROUND_REPLACE"] = "adminOptionsBackgroundReplace";
    ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS["ADMIN_OPTIONS_BACKGROUND_DELETE"] = "adminOptionsBackgroundDelete";
    ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS["ADMIN_OPTIONS_LOGO_DELETE"] = "adminOptionsLogoDelete";
    ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS["ADMIN_OPTIONS_LOGO_UPLOAD"] = "adminOptionsLogoUpload";
    ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS["ADMIN_OPTIONS_LOGO_REPLACE"] = "adminOptionsLogoReplace";
    ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS["ADMIN_OPTIONS_LOGO_BEHAVIOR"] = "adminOptionsLogoBehavior";
    ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS["CALENDAR_MEETING_JOIN"] = "calendarMeetingJoin";
    ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS["CALENDAR_MEETING_VIEW"] = "calendarMeetingView";
    ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS["CALENDAR_PICKER_NAVIGATE"] = "calendarPickerNavigate";
    ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS["CALENDAR_OAUTH"] = "calendarOAuth";
    ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS["RECENT_WORK_ROW"] = "recentWorkRow";
    ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS["SHORTCUTS_ITEM"] = "shortcutsItem";
    ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS["BOOKMARK"] = "bookmark";
    ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS["BOOKMARKS_BAR"] = "bookmarksBar";
    ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS["BOOKMARK_MANAGER"] = "bookmarkManager";
    ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS["CHROME_APPS"] = "chromeApps";
    ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS["WHATS_NEW"] = "whatsNew";
    ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS["CHAT_SIDEPANEL"] = "chatSidepanel";
    ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS["OPEN_OPTIONS"] = "openOptions";
    ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS["TOP_BAR"] = "topBar";
    ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS["PROFILE_CARD"] = "profileCard";
    ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS["PROFILE_PAGE"] = "profilePage";
    ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS["THEME"] = "theme";
    ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS["ROVO_EXTENSION_FRONTEND"] = "rovoExtensionFrontend";
    ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS["UPDATE_ANNOUNCEMENT"] = "updateAnnouncement";
    ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS["UPDATE_ANNOUNCEMENT_FAILED"] = "updateAnnouncementFailed";
    ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS["ANNOUNCEMENT_LOADED"] = "announcementLoaded";
    ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS["CUSTOM_FONT_COLOR"] = "customFontColor";
    ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS["CUSTOM_NAVBAR_COLOR"] = "customNavbarColor";
    ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS["WELCOME_POPOVER"] = "welcomePopover";
    return ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS;
}({});
var $7c29402520d56d84$export$7157f0775e2fcec3 = /*#__PURE__*/ function(ANALYTICS_OPERATIONAL_EVENT_ACTION_SUBJECTS) {
    ANALYTICS_OPERATIONAL_EVENT_ACTION_SUBJECTS["FG_CLIENT_INITIALIZATION"] = "featureGatesClientInitialization";
    return ANALYTICS_OPERATIONAL_EVENT_ACTION_SUBJECTS;
}({});

});


parcelRegister("crLv5", function(module, exports) {
$parcel$export(module.exports, "EXPERIMENTS", () => $f13eaaa8c1382374$export$c53b54969232d4cd);
$parcel$export(module.exports, "PARAMETERS", () => $f13eaaa8c1382374$export$24702c30ff8e6bf1);
$parcel$export(module.exports, "activeExperiments", () => $f13eaaa8c1382374$export$4b4e5a3c4cd2ff2);
$parcel$export(module.exports, "exposeUserToDomContextImprovementExperimentIfValid", () => $f13eaaa8c1382374$export$f348ccd895c668eb);
$parcel$export(module.exports, "isNtpSearchFiltersEnabled", () => $f13eaaa8c1382374$export$a188f9ad759dcff4);
$parcel$export(module.exports, "isNtpSearchFilters3pConnectorsEnabled", () => $f13eaaa8c1382374$export$7f9b7a8ac013bc30);
$parcel$export(module.exports, "getNtpAgentsDropdownTreatment", () => $f13eaaa8c1382374$export$4113791eea1b8db6);
$parcel$export(module.exports, "isSettingsAdminSiteControlsExperimentEnabled", () => $f13eaaa8c1382374$export$4ad2e7bfa0e7c66d);
$parcel$export(module.exports, "isCompanyThemingPreviewEnabledForSiteAdmins", () => $f13eaaa8c1382374$export$8ad55ea5c027b11a);
$parcel$export(module.exports, "logCompanyThemingPreviewForSiteAdminsExperimentExposure", () => $f13eaaa8c1382374$export$4146ccb7bf1c89a3);
$parcel$export(module.exports, "isDefaultToCustomLinksEnabled", () => $f13eaaa8c1382374$export$d904fdccf7c63330);
$parcel$export(module.exports, "isSessionReplayExperimentEnabled", () => $f13eaaa8c1382374$export$e4f403f34655e3fe);
$parcel$export(module.exports, "isFoundationUxBlitzEnabled", () => $f13eaaa8c1382374$export$ffa00c59d8e0b8d7);
$parcel$export(module.exports, "isPostOfficeProviderEnabled", () => $f13eaaa8c1382374$export$953cdb246e7e8331);
$parcel$export(module.exports, "isUserDefaultSettingsRevampEnabled", () => $f13eaaa8c1382374$export$8387cc104975f8f8);
$parcel$export(module.exports, "isNtpNotificationsBellEnabled", () => $f13eaaa8c1382374$export$61f978fc5ad9fc21);
$parcel$export(module.exports, "isNewlyWelcomedEnabled", () => $f13eaaa8c1382374$export$e2c0425f684eb7c);

var $LpV4F = parcelRequire("LpV4F");
var $f13eaaa8c1382374$export$c53b54969232d4cd = /*#__PURE__*/ function(EXPERIMENTS) {
    EXPERIMENTS["DOM_CONTEXT_IMPROVEMENT"] = "rovo_extension_dom_improvement";
    EXPERIMENTS["NTP_SEARCH_FILTERS"] = "ntp_search_filters";
    EXPERIMENTS["NTP_SEARCH_FILTERS_3P_CONNECTORS"] = "ntp_search_filters_3p_connectors";
    EXPERIMENTS["NTP_AGENTS_DROPDOWN"] = "rovo_extension_ntp_agents_dropdown";
    EXPERIMENTS["SITE_ADMIN_SETTINGS"] = "rovo-extension-site-admin-settings";
    EXPERIMENTS["SETTINGS_ADMIN_SITE_CONTROLS"] = "rovo-ext_settings_admin_site_controls";
    EXPERIMENTS["SESSION_REPLAY"] = "rovo-extension-session-replay";
    EXPERIMENTS["DEFAULT_TO_CUSTOM_LINKS"] = "rovo_extension_default_to_custom_links";
    EXPERIMENTS["EXTENSION_CTA_SITE_HOME"] = "extension-cta-site-home";
    EXPERIMENTS["FOUNDATION_UX_BLITZ"] = "rovo-ext_foundation_ux_blitz";
    EXPERIMENTS["POST_OFFICE_PROVIDER"] = "rovo-ext_post_office_provider_no_harm_exp";
    EXPERIMENTS["USER_DEFAULT_SETTINGS_REVAMP"] = "rovo-ext_user_default_settings_revamp";
    EXPERIMENTS["NTP_NOTIFICATIONS_BELL"] = "rovo-extension-ntp-notifications-bell";
    EXPERIMENTS["ONBOARDING_BENEFIT_PHASE_1"] = "rovo-extension-onboarding-benefit-phase-1";
    return EXPERIMENTS;
}({});
var $f13eaaa8c1382374$export$24702c30ff8e6bf1 = /*#__PURE__*/ function(PARAMETERS) {
    PARAMETERS["isEnabled"] = "enabled";
    PARAMETERS["isDomContextImprovementEnabled"] = "rovo_extension_dom_context_improvement_enabled";
    PARAMETERS["isNtpSearchFiltersEnabled"] = "is_search_filters_enabled";
    PARAMETERS["is3pConnectorEnabled"] = "is3pConnectorEnabled";
    PARAMETERS["ntpAgentsDropdownTreatment"] = "treatment";
    PARAMETERS["isSettingsUiRevampEnabled"] = "is_settings_ui_revamp_enabled";
    PARAMETERS["isSettingsAdminSiteControlsEnabled"] = "is_settings_admin_site_controls_enabled";
    PARAMETERS["isEnabledForSiteAdmins"] = "isEnabledForSiteAdmins";
    PARAMETERS["isSessionReplayEnabled"] = "isSessionReplayEnabled";
    PARAMETERS["isDefaultToCustomLinksEnabled"] = "isEnabled";
    PARAMETERS["isAbleToViewCTA"] = "isAbleToViewCTA";
    PARAMETERS["isFoundationUxBlitzEnabled"] = "is_foundation_ux_blitz_enabled";
    PARAMETERS["isPostOfficeProviderEnabled"] = "isEnabled";
    PARAMETERS["isUserDefaultSettingsRevamp"] = "isUserDefaultSettingsRevamp";
    PARAMETERS["isNotificationsEnabled"] = "notificationsEnabled";
    PARAMETERS["newlyWelcomed"] = "newlyWelcomed";
    return PARAMETERS;
}({});
const $f13eaaa8c1382374$export$4b4e5a3c4cd2ff2 = [
    {
        experimentName: "rovo_extension_dom_improvement",
        parameterName: "rovo_extension_dom_context_improvement_enabled"
    },
    {
        experimentName: "ntp_search_filters",
        parameterName: "is_search_filters_enabled"
    },
    {
        experimentName: "ntp_search_filters_3p_connectors",
        parameterName: "is3pConnectorEnabled"
    },
    {
        experimentName: "rovo_extension_ntp_agents_dropdown",
        parameterName: "treatment"
    },
    {
        experimentName: "rovo-ext_settings_admin_site_controls",
        parameterName: "is_settings_admin_site_controls_enabled"
    },
    {
        experimentName: "rovo-extension-site-admin-settings",
        parameterName: "isEnabledForSiteAdmins"
    },
    {
        experimentName: "rovo-extension-session-replay",
        parameterName: "isSessionReplayEnabled"
    },
    {
        experimentName: "rovo_extension_default_to_custom_links",
        parameterName: "isEnabled"
    },
    {
        experimentName: "extension-cta-site-home",
        parameterName: "isAbleToViewCTA"
    },
    {
        experimentName: "rovo-ext_foundation_ux_blitz",
        parameterName: "is_foundation_ux_blitz_enabled"
    },
    {
        experimentName: "rovo-ext_post_office_provider_no_harm_exp",
        parameterName: "isEnabled"
    },
    {
        experimentName: "rovo-ext_user_default_settings_revamp",
        parameterName: "isUserDefaultSettingsRevamp"
    },
    {
        experimentName: "rovo-extension-ntp-notifications-bell",
        parameterName: "notificationsEnabled"
    },
    {
        experimentName: "rovo-extension-onboarding-benefit-phase-1",
        parameterName: "newlyWelcomed"
    }
];
const $f13eaaa8c1382374$export$a074a2ace5357488 = ()=>{
    return (0, $LpV4F.getExperiment)({
        experimentName: "rovo_extension_dom_improvement",
        parameterName: "rovo_extension_dom_context_improvement_enabled",
        defaultValue: false
    });
};
const $f13eaaa8c1382374$export$f348ccd895c668eb = (isSidebar)=>{
    if (isSidebar) return $f13eaaa8c1382374$export$a074a2ace5357488();
    return false;
};
const $f13eaaa8c1382374$export$a188f9ad759dcff4 = ()=>{
    return (0, $LpV4F.getExperiment)({
        experimentName: "ntp_search_filters",
        parameterName: "is_search_filters_enabled",
        defaultValue: false
    });
};
const $f13eaaa8c1382374$export$7f9b7a8ac013bc30 = ()=>{
    return (0, $LpV4F.getExperiment)({
        experimentName: "ntp_search_filters_3p_connectors",
        parameterName: "is3pConnectorEnabled",
        defaultValue: false
    });
};
const $f13eaaa8c1382374$export$4113791eea1b8db6 = ()=>{
    return (0, $LpV4F.getExperiment)({
        experimentName: "rovo_extension_ntp_agents_dropdown",
        parameterName: "treatment",
        defaultValue: "control"
    });
};
const $f13eaaa8c1382374$export$4ad2e7bfa0e7c66d = ()=>{
    return (0, $LpV4F.getExperiment)({
        experimentName: "rovo-ext_settings_admin_site_controls",
        parameterName: "is_settings_admin_site_controls_enabled",
        defaultValue: false
    });
};
const $f13eaaa8c1382374$export$8ad55ea5c027b11a = ()=>{
    return (0, $LpV4F.getExperimentNoExposure)({
        experimentName: "rovo-extension-site-admin-settings",
        parameterName: "isEnabledForSiteAdmins",
        defaultValue: false
    });
};
const $f13eaaa8c1382374$export$4146ccb7bf1c89a3 = ()=>{
    (0, $LpV4F.manuallyLogExposure)("rovo-extension-site-admin-settings");
};
const $f13eaaa8c1382374$export$d904fdccf7c63330 = ()=>{
    return (0, $LpV4F.getExperiment)({
        experimentName: "rovo_extension_default_to_custom_links",
        parameterName: "isEnabled",
        defaultValue: false
    });
};
const $f13eaaa8c1382374$export$e4f403f34655e3fe = ()=>{
    return (0, $LpV4F.getExperiment)({
        experimentName: "rovo-extension-session-replay",
        parameterName: "isSessionReplayEnabled",
        defaultValue: false
    });
};
const $f13eaaa8c1382374$export$ae1773d66c7b75d4 = ()=>{
    return (0, $LpV4F.getExperiment)({
        experimentName: "extension-cta-site-home",
        parameterName: "isAbleToViewCTA",
        defaultValue: false
    });
};
const $f13eaaa8c1382374$export$ffa00c59d8e0b8d7 = ()=>{
    return (0, $LpV4F.getExperiment)({
        experimentName: "rovo-ext_foundation_ux_blitz",
        parameterName: "is_foundation_ux_blitz_enabled",
        defaultValue: false
    });
};
const $f13eaaa8c1382374$export$953cdb246e7e8331 = ()=>{
    return (0, $LpV4F.getExperiment)({
        experimentName: "rovo-ext_post_office_provider_no_harm_exp",
        parameterName: "isEnabled",
        defaultValue: false
    });
};
const $f13eaaa8c1382374$export$8387cc104975f8f8 = ()=>{
    return (0, $LpV4F.getExperiment)({
        experimentName: "rovo-ext_user_default_settings_revamp",
        parameterName: "isUserDefaultSettingsRevamp",
        defaultValue: false
    });
};
const $f13eaaa8c1382374$export$61f978fc5ad9fc21 = ()=>{
    return (0, $LpV4F.getExperiment)({
        experimentName: "rovo-extension-ntp-notifications-bell",
        parameterName: "notificationsEnabled",
        defaultValue: false
    });
};
const $f13eaaa8c1382374$export$e2c0425f684eb7c = ()=>{
    return (0, $LpV4F.getExperiment)({
        experimentName: "rovo-extension-onboarding-benefit-phase-1",
        parameterName: "newlyWelcomed",
        defaultValue: false
    });
};

});
parcelRegister("LpV4F", function(module, exports) {
$parcel$export(module.exports, "getExperiment", () => $fba07258a93afe84$export$2f86411d819a755e);
$parcel$export(module.exports, "getExperimentNoExposure", () => $fba07258a93afe84$export$e7f1197dcc92c6cd);
$parcel$export(module.exports, "manuallyLogExposure", () => $fba07258a93afe84$export$e3afcb8f6255381d);

var $lVHOI = parcelRequire("lVHOI");
const $fba07258a93afe84$export$2f86411d819a755e = ({ experimentName: experimentName, parameterName: parameterName, defaultValue: defaultValue, options: options })=>{
    return (0, $lVHOI.default).getExperimentValue(experimentName, parameterName, defaultValue, options);
};
const $fba07258a93afe84$export$e7f1197dcc92c6cd = ({ experimentName: experimentName, parameterName: parameterName, defaultValue: defaultValue })=>{
    return (0, $lVHOI.default).getExperimentValue(experimentName, parameterName, defaultValue, {
        fireExperimentExposure: false
    });
};
const $fba07258a93afe84$export$e3afcb8f6255381d = (experimentName)=>{
    (0, $lVHOI.default).manuallyLogExperimentExposure(experimentName);
};

});



parcelRegister("hmQ4u", function(module, exports) {
$parcel$export(module.exports, "default", () => $9f872f4916d4a3d7$export$2e2bcd8739ae039);

var $kbKpL = parcelRequire("kbKpL");
var $kfPot = parcelRequire("kfPot");

var $ku0Cg = parcelRequire("ku0Cg");

var $4cZqh = parcelRequire("4cZqh");

var $4tluv = parcelRequire("4tluv");

var $2X3dI = parcelRequire("2X3dI");

var $lIP59 = parcelRequire("lIP59");

var $f6Olw = parcelRequire("f6Olw");

var $8RBNz = parcelRequire("8RBNz");

var $dDtM2 = parcelRequire("dDtM2");

var $lsxLV = parcelRequire("lsxLV");

var $dX6kP = parcelRequire("dX6kP");

var $bFW4F = parcelRequire("bFW4F");

var $9A7Rq = parcelRequire("9A7Rq");

var $5w8e3 = parcelRequire("5w8e3");
const $9f872f4916d4a3d7$var$errorStyles = (0, $kfPot.xcss)({
    marginTop: "space.800",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textWrap: "wrap",
    textAlign: "center"
});
const $9f872f4916d4a3d7$var$textStyles = (0, $kfPot.xcss)({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    rowGap: "space.050",
    marginBottom: "space.200"
});
const $9f872f4916d4a3d7$var$errorMessageStyles = (0, $kfPot.xcss)({
    font: "font.heading.xxlarge",
    fontWeight: "font.weight.medium"
});
const $9f872f4916d4a3d7$var$subtextStyles = (0, $kfPot.xcss)({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    rowGap: "space.250",
    font: "font.body"
});
const $9f872f4916d4a3d7$var$linkStyles = (0, $kfPot.xcss)({
    color: "color.text",
    textDecoration: "underline",
    ":hover": {
        textDecoration: "none",
        color: "color.text"
    }
});
const $9f872f4916d4a3d7$var$RovoDisabledError = ({ userAccount: userAccount, metadata: metadata, showNavigation: showNavigation = false })=>{
    const sendAnalyticEvent = (0, $dX6kP.useSendAnalyticEvent)();
    const queryClient = (0, $4cZqh.useQueryClient)();
    const [isLoading, setIsLoading] = (0, $4tluv.useState)(false);
    const ufoContext = (0, $f6Olw.useInteractionContext)();
    const handleReload = async ()=>{
        setIsLoading(true);
        const releaseHold = ufoContext?.hold("rovo-disabled-reload");
        try {
            await queryClient.invalidateQueries({
                queryKey: [
                    (0, $bFW4F.GatewayQueryKeys).SEARCH_SITES_WITH_ROVO_ENABLED_WITH_METADATA_NEW
                ]
            });
        } finally{
            setIsLoading(false);
            releaseHold?.();
        }
    };
    // https://data-portal.internal.atlassian.com/analytics/registry/87408
    (0, $4tluv.useEffect)(()=>{
        sendAnalyticEvent({
            eventType: "screen",
            event: {
                name: (0, $lsxLV.ANALYTICS_SCREEN_NAMES).EXTENSION_NO_ROVO_VIEW,
                attributes: {
                    ...metadata
                }
            },
            userId: userAccount?.accountId
        });
    }, [
        sendAnalyticEvent,
        userAccount?.accountId,
        metadata
    ]);
    const errorContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $kbKpL.default), {
        xcss: $9f872f4916d4a3d7$var$errorStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $8RBNz.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $kbKpL.default), {
        xcss: $9f872f4916d4a3d7$var$textStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $kbKpL.default), {
        xcss: $9f872f4916d4a3d7$var$errorMessageStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $lIP59.default), (0, $dDtM2.messages).rovoDisabledError)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $kbKpL.default), {
        xcss: $9f872f4916d4a3d7$var$subtextStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $kbKpL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $lIP59.default), (0, $dDtM2.messages).rovoDisabledErrorSubheader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $2X3dI.default), {
        href: "https://www.atlassian.com/software/rovo",
        target: "_parent",
        xcss: $9f872f4916d4a3d7$var$linkStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $lIP59.default), (0, $dDtM2.messages).rovoDisabledErrorLink)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $ku0Cg.default), {
        appearance: "primary",
        isLoading: isLoading,
        onClick: handleReload
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $lIP59.default), (0, $dDtM2.messages).reloadButtonLabel)));
    const shouldShowHeader = showNavigation && userAccount?.accountId && !(0, $9A7Rq.isNarrowWindow)();
    return shouldShowHeader ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $5w8e3.default), {
        site: undefined,
        testId: "rovo-disabled-top-navigation",
        userAccount: userAccount
    }, errorContent) : errorContent;
};
var $9f872f4916d4a3d7$export$2e2bcd8739ae039 = $9f872f4916d4a3d7$var$RovoDisabledError;

});
parcelRegister("ku0Cg", function(module, exports) {
$parcel$export(module.exports, "default", () => $f992fccf4603d116$export$2e2bcd8739ae039);

var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $cpPps = parcelRequire("cpPps");

var $fu5fM = parcelRequire("fu5fM");

var $kAcdt = parcelRequire("kAcdt");
/**
 * __Button__
 *
 * A button triggers an event or action.
 *
 * - [Examples](https://atlassian.design/components/button/examples)
 * - [Code](https://atlassian.design/components/button/code)
 * - [Usage](https://atlassian.design/components/button/usage)
 */ const $f992fccf4603d116$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).forwardRef(function Button({ analyticsContext: analyticsContext, appearance: appearance, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, autoFocus: autoFocus, children: children, iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled, isLoading: isLoading = false, isSelected: isSelected, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId, type: type = 'button', ...unsafeRest }, ref) {
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    return /*#__PURE__*/ (0, $2iln5.jsxs)((0, $cpPps.default), {
        analyticsContext: analyticsContext,
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        hasIconBefore: Boolean(iconBefore),
        hasIconAfter: Boolean(iconAfter),
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "Button",
        type: type,
        interactionName: interactionName,
        ...saferRest,
        children: [
            iconBefore && /*#__PURE__*/ (0, $2iln5.jsx)((0, $fu5fM.default), {
                type: "icon",
                position: "before",
                isLoading: isLoading,
                children: /*#__PURE__*/ (0, $2iln5.jsx)((0, $kAcdt.default), {
                    icon: iconBefore
                })
            }),
            children && /*#__PURE__*/ (0, $2iln5.jsx)((0, $fu5fM.default), {
                isLoading: isLoading,
                children: children
            }),
            iconAfter && /*#__PURE__*/ (0, $2iln5.jsx)((0, $fu5fM.default), {
                type: "icon",
                position: "after",
                isLoading: isLoading,
                children: /*#__PURE__*/ (0, $2iln5.jsx)((0, $kAcdt.default), {
                    icon: iconAfter
                })
            })
        ]
    });
}));
$f992fccf4603d116$var$Button.displayName = 'Button';
var $f992fccf4603d116$export$2e2bcd8739ae039 = $f992fccf4603d116$var$Button;

});
parcelRegister("cpPps", function(module, exports) {
$parcel$export(module.exports, "default", () => $aa77d1cb00a3b61d$export$2e2bcd8739ae039);
/* button-base.tsx generated by @compiled/babel-plugin v0.36.1 */ /* button-base.tsx generated by @compiled/babel-plugin v0.36.1 */ /* button-base.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");

var $jAkMr = parcelRequire("jAkMr");

var $4tluv = parcelRequire("4tluv");

var $klNPa = parcelRequire("klNPa");

var $hHj16 = parcelRequire("hHj16");

var $eL2h4 = parcelRequire("eL2h4");

var $fEY94 = parcelRequire("fEY94");

var $3X3Vo = parcelRequire("3X3Vo");

var $dgwv0 = parcelRequire("dgwv0");

var $k7gbB = parcelRequire("k7gbB");

var $5ryMt = parcelRequire("5ryMt");

var $d7JhT = parcelRequire("d7JhT");

var $3WMLe = parcelRequire("3WMLe");

var $7TBuF = parcelRequire("7TBuF");
const $aa77d1cb00a3b61d$var$LOADING_LABEL = ', Loading';
const $aa77d1cb00a3b61d$var$styles = {
    base: "_2rkofajl _11c8fhey _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    baseT26Shape: "_2rko1qi0",
    linkDecorationUnset: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _syaz1gmx _30l31gmx _9h8h1gmx",
    sharedDisabled: "_bfhkby5v _irr3by5v _1di6by5v",
    spacingCompact: "_1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    spacingCompactT26Shape: "_2rko12b0",
    circle: "_2rko1rr0",
    fullWidth: "_1bsb1osq",
    loading: "_80om15jw",
    iconButton: "_4t3iviql _1bsbviql _y4tize3t _bozgze3t",
    iconButtonCompact: "_4t3i1k8s _1bsb1k8s",
    buttonIconBefore: "_bozgutpp _gy1p12x7",
    buttonIconAfter: "_y4tiutpp _gy1p12x7",
    splitButton: "_g0pbb4wl",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t",
    navigationSplitButton: "_1bsb1tcg _bfhksm61 _y4ti12x7 _bozg12x7"
};
const $aa77d1cb00a3b61d$var$defaultStyles = {
    root: "_bfhksm61 _syazazsu _8l3m1l7x _aetrb3bt _1053azsu _f8pjazsu _30l3azsu _9h8hazsu",
    interactive: "_irr31dpa _30l3azsu _1di6fcek _9h8hazsu",
    disabled: "_bfhk1j28 _8l3mbk0g _irr31j28 _1di61j28"
};
const $aa77d1cb00a3b61d$var$primaryStyles = {
    root: "_bfhk1856 _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr3hf2y _9h8h15cr _1di6g6ey"
};
const $aa77d1cb00a3b61d$var$warningStyles = {
    root: "_bfhk1kmu _syaz1yd3 _10531yd3 _f8pj1yd3 _30l31yd3 _9h8h1yd3",
    interactive: "_30l31yd3 _irr31spp _9h8h1yd3 _1di64m4m"
};
const $aa77d1cb00a3b61d$var$dangerStyles = {
    root: "_bfhkybec _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr3s9hg _9h8h15cr _1di613a9"
};
const $aa77d1cb00a3b61d$var$discoveryStyles = {
    root: "_bfhku5tj _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr3fqeg _9h8h15cr _1di61f1m"
};
const $aa77d1cb00a3b61d$var$subtleStyles = {
    root: "_bfhksm61 _syazazsu _1053azsu _f8pjazsu _30l3azsu _9h8hazsu",
    interactive: "_irr31dpa _30l3azsu _1di6fcek _9h8hazsu",
    disabled: "_bfhk1j28 _8l3mbk0g _irr31j28 _1di61j28"
};
const $aa77d1cb00a3b61d$var$selectedStyles = {
    root: "_bfhk15s3 _syaz6x5g _8l3mq98m _aetrb3bt _10536x5g _f8pj6x5g _30l36x5g _9h8h6x5g",
    insideSplitButton: "_1pbycs5v",
    interactive: "_irr3ufnl _30l36x5g _1di6nozp _9h8h6x5g",
    warning: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3",
    danger: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3",
    discovery: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3"
};
/**
 * __button base__
 *
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ const $aa77d1cb00a3b61d$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).forwardRef(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
({ appearance: propAppearance, autoFocus: autoFocus = false, isDisabled: propIsDisabled = false, isLoading: isLoading = false, isSelected: propIsSelected = false, isIconButton: isIconButton = false, isCircle: isCircle = false, hasIconBefore: hasIconBefore = false, hasIconAfter: hasIconAfter = false, shouldFitContainer: shouldFitContainer = false, spacing: propSpacing = 'default', ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, children: children, interactionName: interactionName, onClick: onClick, onMouseDown: onMouseDown, onMouseDownCapture: onMouseDownCapture, onMouseUp: onMouseUp, onMouseUpCapture: onMouseUpCapture, onKeyDown: onKeyDown, onKeyDownCapture: onKeyDownCapture, onKeyUp: onKeyUp, onKeyUpCapture: onKeyUpCapture, onTouchStart: onTouchStart, onTouchStartCapture: onTouchStartCapture, onTouchEnd: onTouchEnd, onTouchEndCapture: onTouchEndCapture, onPointerDown: onPointerDown, onPointerDownCapture: onPointerDownCapture, onPointerUp: onPointerUp, onPointerUpCapture: onPointerUpCapture, onClickCapture: onClickCapture, testId: testId, analyticsContext: analyticsContext, componentName: componentName, role: role, onMouseOver: onMouseOver, onMouseOut: onMouseOut, onFocus: onFocus, onBlur: onBlur, onMouseMove: onMouseMove, type: type, ...unsafeRest }, ref)=>{
    const localRef = (0, $4tluv.useRef)(null);
    const splitButtonContext = (0, $d7JhT.useSplitButtonContext)();
    const loadingLabelId = (0, $fEY94.useId)();
    const isSplitButton = Boolean(splitButtonContext);
    const isNavigationSplitButton = splitButtonContext?.isNavigationSplitButton || false;
    const isDefaultAppearanceSplitButton = splitButtonContext?.appearance === 'default';
    const appearance = isDefaultAppearanceSplitButton ? 'subtle' : propAppearance || splitButtonContext?.appearance || 'default';
    const spacing = splitButtonContext?.spacing || propSpacing;
    const isDisabled = splitButtonContext?.isDisabled || propIsDisabled;
    const isInteractive = !isDisabled && !isLoading;
    // Also treat loading buttons as disabled
    const isEffectivelyDisabled = isDisabled || isLoading;
    const isSelected = propIsSelected && !isDisabled;
    (0, $eL2h4.default)(localRef, autoFocus);
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $dgwv0.default), {
        ...saferRest,
        componentName: componentName || 'button',
        analyticsContext: analyticsContext,
        role: role,
        ref: (0, $hHj16.default)([
            localRef,
            ref
        ]),
        xcss: (0, $klNPa.cx)($aa77d1cb00a3b61d$var$styles.base, (0, $3X3Vo.fg)('platform-dst-shape-theme-default') && $aa77d1cb00a3b61d$var$styles.baseT26Shape, appearance === 'default' && $aa77d1cb00a3b61d$var$defaultStyles.root, appearance === 'default' && isInteractive && $aa77d1cb00a3b61d$var$defaultStyles.interactive, appearance === 'primary' && $aa77d1cb00a3b61d$var$primaryStyles.root, appearance === 'primary' && isInteractive && $aa77d1cb00a3b61d$var$primaryStyles.interactive, appearance === 'warning' && $aa77d1cb00a3b61d$var$warningStyles.root, appearance === 'warning' && isInteractive && $aa77d1cb00a3b61d$var$warningStyles.interactive, appearance === 'danger' && $aa77d1cb00a3b61d$var$dangerStyles.root, appearance === 'danger' && isInteractive && $aa77d1cb00a3b61d$var$dangerStyles.interactive, appearance === 'discovery' && $aa77d1cb00a3b61d$var$discoveryStyles.root, appearance === 'discovery' && isInteractive && $aa77d1cb00a3b61d$var$discoveryStyles.interactive, appearance === 'subtle' && $aa77d1cb00a3b61d$var$subtleStyles.root, appearance === 'subtle' && isInteractive && $aa77d1cb00a3b61d$var$subtleStyles.interactive, $aa77d1cb00a3b61d$var$styles.linkDecorationUnset, isSelected && $aa77d1cb00a3b61d$var$selectedStyles.root, isSelected && isSplitButton && $aa77d1cb00a3b61d$var$selectedStyles.insideSplitButton, isSelected && isInteractive && $aa77d1cb00a3b61d$var$selectedStyles.interactive, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'danger' && $aa77d1cb00a3b61d$var$selectedStyles.danger, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'warning' && $aa77d1cb00a3b61d$var$selectedStyles.warning, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'discovery' && $aa77d1cb00a3b61d$var$selectedStyles.discovery, isDisabled && $aa77d1cb00a3b61d$var$styles.disabled, isDisabled && appearance !== 'default' && appearance !== 'subtle' && $aa77d1cb00a3b61d$var$styles.sharedDisabled, isDisabled && appearance === 'default' && $aa77d1cb00a3b61d$var$defaultStyles.disabled, isCircle && !isSplitButton && $aa77d1cb00a3b61d$var$styles.circle, spacing === 'compact' && $aa77d1cb00a3b61d$var$styles.spacingCompact, spacing === 'compact' && (0, $3X3Vo.fg)('platform-dst-shape-theme-default') && $aa77d1cb00a3b61d$var$styles.spacingCompactT26Shape, shouldFitContainer && $aa77d1cb00a3b61d$var$styles.fullWidth, hasIconBefore && $aa77d1cb00a3b61d$var$styles.buttonIconBefore, hasIconAfter && $aa77d1cb00a3b61d$var$styles.buttonIconAfter, isIconButton && $aa77d1cb00a3b61d$var$styles.iconButton, isIconButton && spacing === 'compact' && $aa77d1cb00a3b61d$var$styles.iconButtonCompact, isLoading && $aa77d1cb00a3b61d$var$styles.loading, isSplitButton && $aa77d1cb00a3b61d$var$styles.splitButton, isNavigationSplitButton && $aa77d1cb00a3b61d$var$styles.navigationSplitButton),
        isDisabled: (0, $3X3Vo.fg)('platform-dst_fix_not_focusable_loading_button') ? isDisabled : isEffectivelyDisabled,
        ...(0, $3X3Vo.fg)('platform-dst_fix_not_focusable_loading_button') && {
            'aria-live': 'polite'
        },
        ...isLoading && (0, $3X3Vo.fg)('platform-dst_fix_not_focusable_loading_button') && {
            'aria-disabled': true
        },
        "aria-label": isLoading && ariaLabel && !ariaLabelledBy ? `${ariaLabel} ${$aa77d1cb00a3b61d$var$LOADING_LABEL}` : ariaLabel,
        "aria-labelledby": isLoading && ariaLabelledBy ? `${ariaLabelledBy} ${loadingLabelId}` : ariaLabelledBy,
        onClick: onClick,
        ...(0, $3WMLe.default)(isEffectivelyDisabled, {
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onTouchStartCapture: onTouchStartCapture,
            onTouchEndCapture: onTouchEndCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onClickCapture: onClickCapture
        }),
        testId: testId,
        onMouseOver: onMouseOver,
        onFocus: onFocus,
        onMouseMove: onMouseMove,
        onBlur: onBlur,
        type: type,
        interactionName: interactionName,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onKeyDown: onKeyDown,
        onMouseOut: onMouseOut,
        onKeyUp: onKeyUp,
        onTouchStart: onTouchStart,
        onTouchEnd: onTouchEnd,
        onPointerDown: onPointerDown,
        onPointerUp: onPointerUp,
        children: /*#__PURE__*/ (0, $2iln5.jsxs)((0, $5ryMt.SplitButtonContext).Provider, {
            value: undefined,
            children: [
                children,
                isLoading && /*#__PURE__*/ (0, $2iln5.jsx)("span", {
                    className: (0, $jAkMr.default)([
                        $aa77d1cb00a3b61d$var$styles.loadingOverlay
                    ]),
                    children: (0, $7TBuF.default)({
                        spacing: spacing,
                        appearance: appearance,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        testId: testId
                    })
                }),
                isLoading && (ariaLabelledBy || !ariaLabel) && /*#__PURE__*/ (0, $2iln5.jsx)((0, $k7gbB.default), {
                    id: loadingLabelId,
                    children: $aa77d1cb00a3b61d$var$LOADING_LABEL
                })
            ]
        })
    });
});
var $aa77d1cb00a3b61d$export$2e2bcd8739ae039 = $aa77d1cb00a3b61d$var$ButtonBase;

});
parcelRegister("jAkMr", function(module, exports) {
$parcel$export(module.exports, "default", () => $e4217faad9b380f0$export$2e2bcd8739ae039);
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $e4217faad9b380f0$var$ATOMIC_GROUP_LENGTH = 5;
function $e4217faad9b380f0$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $e4217faad9b380f0$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});

parcelRegister("5ryMt", function(module, exports) {
$parcel$export(module.exports, "SplitButtonContext", () => $8370be502598839c$export$4b86304b2c0d7e71);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $4tluv = parcelRequire("4tluv");
const $8370be502598839c$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $4tluv.createContext)(undefined);

});

parcelRegister("d7JhT", function(module, exports) {
$parcel$export(module.exports, "useSplitButtonContext", () => $b3523f8a5f36b746$export$47e2c6fdb142d947);

var $4tluv = parcelRequire("4tluv");

var $5ryMt = parcelRequire("5ryMt");
const $b3523f8a5f36b746$export$47e2c6fdb142d947 = ()=>{
    const context = (0, $4tluv.useContext)((0, $5ryMt.SplitButtonContext));
    if (!context) return undefined;
    if (context.appearance === 'navigation') {
        const newContext = {
            spacing: 'default',
            appearance: 'subtle',
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    const splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};

});

parcelRegister("3WMLe", function(module, exports) {
$parcel$export(module.exports, "default", () => $393a4b34609c34de$export$2e2bcd8739ae039);
function $393a4b34609c34de$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
const $393a4b34609c34de$var$tabKeyCode = 9;
function $393a4b34609c34de$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $393a4b34609c34de$var$tabKeyCode) return;
    $393a4b34609c34de$var$abort(event);
}
function $393a4b34609c34de$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $393a4b34609c34de$var$abort,
        onMouseUpCapture: $393a4b34609c34de$var$abort,
        onKeyDownCapture: $393a4b34609c34de$var$onKey,
        onKeyUpCapture: $393a4b34609c34de$var$onKey,
        onTouchStartCapture: $393a4b34609c34de$var$abort,
        onTouchEndCapture: $393a4b34609c34de$var$abort,
        onPointerDownCapture: $393a4b34609c34de$var$abort,
        onPointerUpCapture: $393a4b34609c34de$var$abort,
        onClickCapture: $393a4b34609c34de$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $393a4b34609c34de$var$abort
    } : events;
}

});

parcelRegister("7TBuF", function(module, exports) {
$parcel$export(module.exports, "default", () => $7e999adb4acfb532$export$2e2bcd8739ae039);

var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $jJcBA = parcelRequire("jJcBA");
function $7e999adb4acfb532$var$getIconSpacing(spacing) {
    switch(spacing){
        case 'compact':
            return 'small';
        default:
            return 'medium';
    }
}
function $7e999adb4acfb532$var$getSpinnerAppearance({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected }) {
    if (isDisabled || isSelected) return 'inherit';
    if (appearance === 'primary' || appearance === 'danger' || appearance === 'discovery') return 'invert';
    return 'inherit';
}
function $7e999adb4acfb532$export$2e2bcd8739ae039({ appearance: appearance, spacing: spacing, isDisabled: isDisabled, isSelected: isSelected, testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $jJcBA.default), {
        size: $7e999adb4acfb532$var$getIconSpacing(spacing),
        appearance: $7e999adb4acfb532$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        testId: testId ? `${testId}--loading-spinner` : undefined
    });
}

});


parcelRegister("fu5fM", function(module, exports) {
$parcel$export(module.exports, "default", () => $7e0f4af1f776638d$export$2e2bcd8739ae039);
/* content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");

var $jAkMr = parcelRequire("jAkMr");
parcelRequire("4tluv");
const $7e0f4af1f776638d$var$styles = {
    text: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _1bto1l2s _o5721q9c",
    icon: "_1e0c1txw _16jlidpf _1o9zidpf _1wpz1h6o _1wybidpf _vwz4idpf _uiztglyw",
    common: "_v564g17y",
    fade: "_tzy4idpf"
};
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ const $7e0f4af1f776638d$var$Content = ({ children: children, type: type = 'text', isLoading: isLoading })=>{
    return /*#__PURE__*/ (0, $2iln5.jsx)("span", {
        className: (0, $jAkMr.default)([
            $7e0f4af1f776638d$var$styles.common,
            type === 'text' && $7e0f4af1f776638d$var$styles.text,
            type === 'icon' && $7e0f4af1f776638d$var$styles.icon,
            isLoading && $7e0f4af1f776638d$var$styles.fade
        ]),
        children: children
    });
};
var $7e0f4af1f776638d$export$2e2bcd8739ae039 = $7e0f4af1f776638d$var$Content;

});

parcelRegister("kAcdt", function(module, exports) {
$parcel$export(module.exports, "default", () => $1e5bbb86720b8d72$export$2e2bcd8739ae039);

var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $3X3Vo = parcelRequire("3X3Vo");
function $1e5bbb86720b8d72$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === 'function' // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 */ const $1e5bbb86720b8d72$var$IconRenderer = ({ icon: Icon })=>{
    const isRenderProp = $1e5bbb86720b8d72$var$isIconRenderProp(Icon);
    let iconProps = {
        label: '',
        color: 'currentColor',
        size: (0, $3X3Vo.fg)('platform_dst_button_chevron_sizing') ? (iconName)=>iconName.startsWith('Chevron') ? 'small' : 'medium' : undefined
    };
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $2iln5.Fragment), {
        children: isRenderProp ? Icon(iconProps) : /*#__PURE__*/ (0, $2iln5.jsx)(Icon, {
            ...iconProps
        })
    });
};
var $1e5bbb86720b8d72$export$2e2bcd8739ae039 = $1e5bbb86720b8d72$var$IconRenderer;

});


parcelRegister("8RBNz", function(module, exports) {
$parcel$export(module.exports, "default", () => $1e72fe1fa4fff3f0$export$2e2bcd8739ae039);

var $4tluv = parcelRequire("4tluv");

var $9KBmj = parcelRequire("9KBmj");

var $l7fij = parcelRequire("l7fij");

var $1yr2r = parcelRequire("1yr2r");
const $1e72fe1fa4fff3f0$var$ErrorSearchNoResultIllustration = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement("div", {
        style: {
            width: "275px",
            height: "275px"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $9KBmj.default), {
        alt: "Error",
        src: (0, (/*@__PURE__*/$parcel$interopDefault($l7fij))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($1yr2r)))
    }));
var $1e72fe1fa4fff3f0$export$2e2bcd8739ae039 = $1e72fe1fa4fff3f0$var$ErrorSearchNoResultIllustration;

});
parcelRegister("l7fij", function(module, exports) {
module.exports = new URL("light.a00ae47b.svg", import.meta.url).toString();

});

parcelRegister("1yr2r", function(module, exports) {
module.exports = new URL("dark.5ca83755.svg", import.meta.url).toString();

});


parcelRegister("9A7Rq", function(module, exports) {
$parcel$export(module.exports, "isNarrowWindow", () => $7d983ae5a67592a9$export$37afcf3a4bc9baab);

var $gEFgM = parcelRequire("gEFgM");
const $7d983ae5a67592a9$export$37afcf3a4bc9baab = ()=>window.innerWidth <= (0, $gEFgM.S_BREAKPOINT);

});
parcelRegister("gEFgM", function(module, exports) {
$parcel$export(module.exports, "S_BREAKPOINT", () => $f3f3f0fccc8b99e7$export$5cbddc7791c72241);

var $4tluv = parcelRequire("4tluv");
const $f3f3f0fccc8b99e7$export$f0bb0390451181cf = 767; // <= 767px
const $f3f3f0fccc8b99e7$export$5cbddc7791c72241 = 1023; // 768-1023px
const $f3f3f0fccc8b99e7$export$b5a622e4c6afebbe = 1439; // 1024-1439px
const $f3f3f0fccc8b99e7$export$ff773012c79069c9 = 1767; // 1440p-1767x
function $f3f3f0fccc8b99e7$export$74514a3460910744() {
    const [windowSizeWidth, setWindowSize] = (0, $4tluv.useState)(undefined);
    const [breakpoint, setBreakpoint] = (0, $4tluv.useState)("XL");
    (0, $4tluv.useEffect)(()=>{
        function handleResize() {
            setWindowSize(document.documentElement.clientWidth);
            if (window.innerWidth <= $f3f3f0fccc8b99e7$export$f0bb0390451181cf) setBreakpoint("XS");
            else if (window.innerWidth <= $f3f3f0fccc8b99e7$export$5cbddc7791c72241) setBreakpoint("S");
            else if (window.innerWidth <= $f3f3f0fccc8b99e7$export$b5a622e4c6afebbe) setBreakpoint("M");
            else if (window.innerWidth <= $f3f3f0fccc8b99e7$export$ff773012c79069c9) setBreakpoint("L");
            else setBreakpoint("XL");
        }
        // Add event listener
        window.addEventListener("resize", handleResize);
        // Call handler right away so state gets updated with initial window size
        handleResize();
        // Remove event listener on cleanup
        return ()=>window.removeEventListener("resize", handleResize);
    }, []); // Empty array ensures that effect is only run on mount
    return {
        windowSizeWidth: windowSizeWidth,
        breakpoint: breakpoint
    };
}

});


parcelRegister("5w8e3", function(module, exports) {
$parcel$export(module.exports, "default", () => $5617884d005c84a9$export$2e2bcd8739ae039);

var $4tluv = parcelRequire("4tluv");

var $8n7En = parcelRequire("8n7En");
var $f9HkP = parcelRequire("f9HkP");
var $1CC9j = parcelRequire("1CC9j");
var $4JbNr = parcelRequire("4JbNr");
var $cfh8W = parcelRequire("cfh8W");

var $jSXMn = parcelRequire("jSXMn");

var $b6kD3 = parcelRequire("b6kD3");

var $jqltP = parcelRequire("jqltP");

var $gN3lo = parcelRequire("gN3lo");
/**
 * A lightweight top bar layout that only shows the company logo and profile.
 * Used in contexts where we don't need the full navigation features.
 */ const $5617884d005c84a9$var$ProfileOnlyTopBarLayout = ({ userAccount: userAccount, site: site, children: children, testId: testId = "profile-only-top-navigation" })=>{
    const customNavbarColor = (0, $b6kD3.useCompanyThemingNavbarColor)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $f9HkP.Root), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $1CC9j.TopNav), {
        testId: testId,
        UNSAFE_theme: {
            backgroundColor: (0, $jSXMn.parseHex)(customNavbarColor),
            highlightColor: (0, $jSXMn.parseHex)(customNavbarColor)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $cfh8W.TopNavStart), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $gN3lo.ExtensionTopBarCompanyLogo), {
        site: site,
        userAccount: userAccount
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $4JbNr.TopNavEnd), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $jqltP.Profile), {
        showWhatsNewButton: false,
        site: site,
        userAccount: userAccount
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $8n7En.Main), null, children));
};
var $5617884d005c84a9$export$2e2bcd8739ae039 = $5617884d005c84a9$var$ProfileOnlyTopBarLayout;

});
parcelRegister("b6kD3", function(module, exports) {
$parcel$export(module.exports, "useCompanyThemingFontColor", () => $ea9dfdce1bcf6891$export$9bc017cf4e473db4);
$parcel$export(module.exports, "useCompanyThemingNavbarColor", () => $ea9dfdce1bcf6891$export$44ce6761be442ae9);

var $ii4ep = parcelRequire("ii4ep");

var $kc9pJ = parcelRequire("kc9pJ");
const $ea9dfdce1bcf6891$export$9bc017cf4e473db4 = ()=>{
    const { data: companyThemingSettings } = (0, $ii4ep.useCompanyThemingSettings)();
    const resolvedTheme = (0, $kc9pJ.useResolvedTheme)();
    const fontColor = resolvedTheme === "light" ? companyThemingSettings?.fontColorLight : companyThemingSettings?.fontColorDark;
    return fontColor ?? "";
};
const $ea9dfdce1bcf6891$export$44ce6761be442ae9 = ()=>{
    const { data: companyThemingSettings } = (0, $ii4ep.useCompanyThemingSettings)();
    const resolvedTheme = (0, $kc9pJ.useResolvedTheme)();
    const navbarColor = resolvedTheme === "light" ? companyThemingSettings?.navbarColorLight : companyThemingSettings?.navbarColorDark;
    return navbarColor ?? "";
};

});
parcelRegister("ii4ep", function(module, exports) {
$parcel$export(module.exports, "setCachedThemingSettings", () => $4cedf723395debfd$export$3e978c690fdba065);
$parcel$export(module.exports, "useCompanyThemingSettings", () => $4cedf723395debfd$export$452fdb4ed6f4cf76);

var $dD8yb = parcelRequire("dD8yb");

var $bFW4F = parcelRequire("bFW4F");

var $22hwD = parcelRequire("22hwD");

var $1QYE6 = parcelRequire("1QYE6");

var $bI4fx = parcelRequire("bI4fx");
const $4cedf723395debfd$var$THIRTY_MINUTES_MS = 1800000;
/**
 * Checks chrome.storage.local for cached company theming settings via message bus
 */ function $4cedf723395debfd$var$getCachedThemingSettings(siteId) {
    return new Promise((resolve)=>{
        const timeoutId = setTimeout(()=>{
            window.removeEventListener("message", messageHandler);
            resolve(null);
        }, 2000);
        const messageHandler = (event)=>{
            if (event.data.type === "GET_COMPANY_THEMING_CACHE_RESPONSE") {
                clearTimeout(timeoutId);
                window.removeEventListener("message", messageHandler);
                resolve(event.data.data);
            }
        };
        window.addEventListener("message", messageHandler, false);
        (0, $bI4fx.postMessageToParent)({
            type: "GET_COMPANY_THEMING_CACHE",
            siteId: siteId
        });
    });
}
function $4cedf723395debfd$export$3e978c690fdba065(siteId, themingSettings) {
    (0, $bI4fx.postMessageToParent)({
        type: "SET_COMPANY_THEMING_CACHE",
        siteId: siteId,
        themingSettings: themingSettings
    });
}
/**
 * Fetches company theming settings with chrome.storage.local caching
 * - First checks cache, returns if fresh (< 30 min old)
 * - If stale/missing, fetches from API and updates cache
 */ async function $4cedf723395debfd$var$fetchThemingSettingsWithCache(siteId) {
    const cachedData = await $4cedf723395debfd$var$getCachedThemingSettings(siteId);
    if (cachedData !== null) return cachedData;
    const freshData = await (0, $bFW4F.getCompanyThemingSettings)(siteId);
    $4cedf723395debfd$export$3e978c690fdba065(siteId, freshData);
    return freshData;
}
function $4cedf723395debfd$export$452fdb4ed6f4cf76() {
    const siteContext = (0, $1QYE6.useSite)({
        allowUndefined: true
    });
    const siteId = siteContext?.site.workspace.cloudId;
    return (0, $dD8yb.useQuery)({
        queryKey: [
            "companyThemingSettings",
            siteId
        ],
        queryFn: ()=>$4cedf723395debfd$var$fetchThemingSettingsWithCache(siteId),
        enabled: !!siteId,
        throwOnError (error) {
            (0, $22hwD.logError)({
                error: error,
                impact: "Error fetching company theming settings"
            });
            return false;
        },
        staleTime: $4cedf723395debfd$var$THIRTY_MINUTES_MS,
        gcTime: $4cedf723395debfd$var$THIRTY_MINUTES_MS * 2,
        refetchOnWindowFocus: false,
        retry: (failureCount, error)=>{
            if (error.statusCode === 429) return false;
            return failureCount < 2;
        }
    });
}

});
parcelRegister("bI4fx", function(module, exports) {
$parcel$export(module.exports, "postMessageToParent", () => $3ab263d3af3d1132$export$a4c9d94f3c8b4b41);
$parcel$export(module.exports, "requestDomContext", () => $3ab263d3af3d1132$export$5f4f1566b18cbae3);

var $lVHOI = parcelRequire("lVHOI");

var $dqHaj = parcelRequire("dqHaj");

var $TrAR1 = parcelRequire("TrAR1");
function $3ab263d3af3d1132$export$a4c9d94f3c8b4b41(message) {
    const isSafePostWindowEnabled = (0, $lVHOI.default).checkGate((0, $TrAR1.STATSIG_FEATURE_GATES).SAFE_POST_WINDOW);
    if (isSafePostWindowEnabled) window.parent.postMessage(message, (0, $dqHaj.extensionUrl));
    else window.parent.postMessage(message, "*");
}
function $3ab263d3af3d1132$export$5f4f1566b18cbae3() {
    $3ab263d3af3d1132$export$a4c9d94f3c8b4b41({
        type: "REQUEST_DOM_CONTEXT",
        payload: {
            getDomContext: true
        }
    });
}

});
parcelRegister("TrAR1", function(module, exports) {
$parcel$export(module.exports, "STATSIG_FEATURE_GATES", () => $dd638642df7d5f32$export$1a1480a7981d844f);
$parcel$export(module.exports, "STATSIG_DYNAMIC_CONFIGS", () => $dd638642df7d5f32$export$c5d819d8db6dd067);
var $dd638642df7d5f32$export$1a1480a7981d844f = /*#__PURE__*/ function(STATSIG_FEATURE_GATES) {
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/gates/rovo-ext_announcement_banner_enabled
    // FG for toggling announcement banner. Please don't remove it.
    STATSIG_FEATURE_GATES["ANNOUNCEMENT_BANNER_ENABLED"] = "rovo-ext_announcement_banner_enabled";
    // https://switcheroo.atlassian.com/ui/gates/558015fa-530c-4edd-9680-73da3160e8bf/key/rovo-ext_bannerman_enabled
    // FG for toggling Bannerman dynamic banner system. Please don't remove it.
    STATSIG_FEATURE_GATES["BANNERMAN_ENABLED"] = "rovo-ext_bannerman_enabled";
    // https://switcheroo.atlassian.com/ui/gates/cdebb45e-466d-4e00-8dc8-c8b914ba27f3/key/rovo-ext_ntp_calendar_widget_enabled
    STATSIG_FEATURE_GATES["NTP_CALENDAR_WIDGET_ENABLED"] = "rovo-ext_ntp_calendar_widget_enabled";
    // https://switcheroo.atlassian.com/ui/gates/43c7705c-5d94-4fbd-99cb-cc02861da827/key/rovo-ext-feature-gate-by-extension-version
    STATSIG_FEATURE_GATES["FEATURE_GATE_BY_EXTENSION_VERSION"] = "rovo-ext-feature-gate-by-extension-version";
    // https://switcheroo.atlassian.com/ui/gates/ff6bc152-83cf-429c-bd05-1df4a24d8d5f/key/hide_rovo_extension_ntp_welcome_header
    STATSIG_FEATURE_GATES["SHOW_ROVO_EXTENSION_NTP_WELCOME_HEADER"] = "hide_rovo_extension_ntp_welcome_header";
    // https://switcheroo.atlassian.com/ui/gates/d10cc0f3-f68b-436b-93d5-7f40ecfcd670/key/rovo_extension_safe_post_window
    STATSIG_FEATURE_GATES["SAFE_POST_WINDOW"] = "rovo_extension_safe_post_window";
    // https://switcheroo.atlassian.com/ui/gates/7d3cc87f-78fe-4ed1-a528-69b2f6eb937f/key/platform-dst-shape-theme-default
    STATSIG_FEATURE_GATES["PLATFORM_DST_SHAPE_THEME_DEFAULT"] = "platform-dst-shape-theme-default";
    //https://switcheroo.atlassian.com/ui/gates/7c652b22-efe3-4db0-a485-cc9d6e988569/key/navx_uc_rovo_extension_platform_creation_enabled
    /**
   * Controls cross-app creation for team/goal/project
   * Not intended to release for all. Internal testing within NavX Team
   */ STATSIG_FEATURE_GATES["NAVX_PLATFORM_CREATION_ENABLED"] = "navx_uc_rovo_extension_platform_creation_enabled";
    // https://switcheroo.atlassian.com/ui/gates/8b4bfbc9-5a3f-4e75-a159-4831aba1e35a/key/rovo-ext_settings_admin_dom_context_toggle
    // Controls visibility of the admin DOM content access toggle and whether the admin setting
    // can override DOM context behavior. Relies on rovo_extension_dom_context_improvement & is_settings_admin_site_controls_enabled
    // being enabled to work.
    STATSIG_FEATURE_GATES["SETTINGS_ADMIN_DOM_CONTEXT_TOGGLE"] = "rovo-ext_settings_admin_dom_context_toggle";
    // SBS (Side-by-Side) evaluation gates
    /** Master on/off gate for the SBS evaluation system. */ STATSIG_FEATURE_GATES["SBS_ENABLED"] = "rovo-ext_sbs_enabled";
    /** Whether this user has ChatGPT Enterprise access and is eligible for ChatGPT SBS pairings. */ STATSIG_FEATURE_GATES["SBS_CHATGPT_ELIGIBLE"] = "rovo-ext_sbs_chatgpt_eligible";
    // https://switcheroo.atlassian.com/ui/gates/457e7f19-4339-40d9-aaed-e165657788a1/key/rovo-ext_custom-ntp-logo-custom-behavior
    STATSIG_FEATURE_GATES["NTP_LOGO_CUSTOM_BEHAVIOR"] = "rovo-ext_custom-ntp-logo-custom-behavior";
    return STATSIG_FEATURE_GATES;
}({});
var $dd638642df7d5f32$export$c5d819d8db6dd067 = /*#__PURE__*/ function(STATSIG_DYNAMIC_CONFIGS) {
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/dynamic_configs/rovo-ext_debug_menu_config
    STATSIG_DYNAMIC_CONFIGS["DEBUG_MENU_CONFIG"] = "rovo-ext_debug_menu_config";
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/dynamic_configs/rovo_extension_demo_search_config
    STATSIG_DYNAMIC_CONFIGS["DEMO_SEARCH_CONFIG"] = "rovo_extension_demo_search_config";
    return STATSIG_DYNAMIC_CONFIGS;
}({});

});



parcelRegister("kc9pJ", function(module, exports) {
$parcel$export(module.exports, "useResolvedTheme", () => $c4e271175ecbc176$export$2a99b39f322aac1c);

var $4tluv = parcelRequire("4tluv");

var $kA1Vr = parcelRequire("kA1Vr");
/**
 * Detects the browser's native theme preference.
 * Listens for changes via `prefers-color-scheme` media query.
 *
 * @returns The browser's native theme: "light" | "dark"
 */ const $c4e271175ecbc176$var$useBrowserThemePreference = ()=>{
    const [theme, setTheme] = (0, $4tluv.useState)(()=>{
        return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
    });
    (0, $4tluv.useEffect)(()=>{
        const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
        const handleChange = (e)=>{
            setTheme(e.matches ? "dark" : "light");
        };
        mediaQuery.addEventListener("change", handleChange);
        return ()=>mediaQuery.removeEventListener("change", handleChange);
    }, []);
    return theme;
};
const $c4e271175ecbc176$export$2a99b39f322aac1c = ()=>{
    const { localThemeColorMode: localThemeColorMode } = (0, $kA1Vr.useThemeContext)();
    const browserTheme = $c4e271175ecbc176$var$useBrowserThemePreference();
    return localThemeColorMode === "auto" ? browserTheme : localThemeColorMode;
};

});
parcelRegister("kA1Vr", function(module, exports) {
$parcel$export(module.exports, "ThemeProvider", () => $7344e2acf380820b$export$d8964aec282183a3);
$parcel$export(module.exports, "useThemeContext", () => $7344e2acf380820b$export$c4281ec44b929e6);

var $1aTSX = parcelRequire("1aTSX");

var $4tluv = parcelRequire("4tluv");

var $fgIUF = parcelRequire("fgIUF");

var $22hwD = parcelRequire("22hwD");

var $bI4fx = parcelRequire("bI4fx");
const $7344e2acf380820b$var$ThemeContext = /*#__PURE__*/ (0, $4tluv.createContext)(null);
const $7344e2acf380820b$var$useThemeLogic = ()=>{
    const [themeColorMode, setThemeColorMode] = (0, $4tluv.useState)((0, $fgIUF.getLocalStorageItem)((0, $fgIUF.LocalStorageKey).THEME_COLOR_MODE, "auto") ?? "auto");
    const setLocalThemeColorMode = (newTheme)=>{
        setThemeColorMode(newTheme);
        (0, $fgIUF.setLocalStorageItem)((0, $fgIUF.LocalStorageKey).THEME_COLOR_MODE, newTheme);
        // Always post message to parent for theme changes (visual refresh enabled)
        (0, $bI4fx.postMessageToParent)({
            type: "SET_SIDEPANEL_THEME",
            theme: newTheme
        });
    };
    (0, $4tluv.useEffect)(()=>{
        // for custom background color
        document.body.classList.remove("theme-light", "theme-dark");
        document.documentElement.classList.remove("theme-light", "theme-dark");
        if (themeColorMode === "light" || themeColorMode === "dark") {
            document.body.classList.add(`theme-${themeColorMode}`);
            document.documentElement.classList.add(`theme-${themeColorMode}`);
        }
        // for sub-components theme
        (0, $1aTSX.default)({
            light: "light",
            dark: "dark",
            colorMode: themeColorMode,
            typography: "typography"
        }).catch(()=>{
            (0, $22hwD.logInfo)("Failed to set global theme.");
        });
    }, [
        themeColorMode
    ]);
    return {
        localThemeColorMode: themeColorMode,
        setLocalThemeColorMode: setLocalThemeColorMode
    };
};
const $7344e2acf380820b$export$d8964aec282183a3 = ({ children: children })=>{
    const theme = $7344e2acf380820b$var$useThemeLogic();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement($7344e2acf380820b$var$ThemeContext.Provider, {
        value: theme
    }, children);
};
const $7344e2acf380820b$export$c4281ec44b929e6 = ()=>{
    const context = (0, $4tluv.useContext)($7344e2acf380820b$var$ThemeContext);
    if (!context) throw new Error("useTheme must be used within a ThemeProvider");
    return context;
};

});
parcelRegister("1aTSX", function(module, exports) {
$parcel$export(module.exports, "default", () => $73e63b9fd1073d80$export$2e2bcd8739ae039);

var $3X3Vo = parcelRequire("3X3Vo");

var $xG0ax = parcelRequire("xG0ax");

var $9KKWI = parcelRequire("9KKWI");

var $4laSa = parcelRequire("4laSa");

var $7c04u = parcelRequire("7c04u");

var $dVuZ5 = parcelRequire("dVuZ5");

var $6raEH = parcelRequire("6raEH");

var $duxx7 = parcelRequire("duxx7");

/**
 * Sets the theme globally at runtime. This updates the `data-theme` and `data-color-mode` attributes on your page's <html> tag.
 *
 * @param {Object<string, string>} themeState The themes and color mode that should be applied.
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.contrastMode The contrast mode theme to be applied. If set to `auto`, the theme applied will be determined by the OS setting.set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.motion The motion theme to be applied.
 * @param {string} themeState.shape The shape theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 * @param {function} themeLoader Callback function used to override the default theme loading functionality.
 *
 * @returns A Promise of an unbind function, that can be used to stop listening for changes to system theme.
 *
 * @example
 * ```
 * setGlobalTheme({colorMode: 'auto', light: 'light', dark: 'dark', spacing: 'spacing'});
 * ```
 */ const $73e63b9fd1073d80$var$setGlobalTheme = async (nextThemeState = {}, themeLoader)=>{
    let { colorMode: colorMode = (0, $9KKWI.themeStateDefaults)['colorMode'], contrastMode: contrastMode = (0, $9KKWI.themeStateDefaults)['contrastMode'], dark: dark = (0, $9KKWI.themeStateDefaults)['dark'], light: light = (0, $9KKWI.themeStateDefaults)['light'], shape: shape = (0, $9KKWI.themeStateDefaults)['shape'](), spacing: spacing = (0, $9KKWI.themeStateDefaults)['spacing'], typography: typography = (0, $9KKWI.themeStateDefaults)['typography'], motion: motion = (0, $9KKWI.themeStateDefaults)['motion'](), UNSAFE_themeOptions: UNSAFE_themeOptions = (0, $9KKWI.themeStateDefaults)['UNSAFE_themeOptions'] } = typeof nextThemeState === 'function' ? nextThemeState({
        ...(0, $9KKWI.themeStateDefaults),
        typography: (0, $9KKWI.themeStateDefaults)['typography'],
        shape: (0, $9KKWI.themeStateDefaults)['shape'](),
        motion: (0, $9KKWI.themeStateDefaults)['motion'](),
        ...(0, $xG0ax.default)()
    }) : nextThemeState;
    // CLEANUP: Remove. This blocks application of increased contrast themes
    // without the feature flag enabled.
    if (!(0, $3X3Vo.fg)('platform_increased-contrast-themes')) {
        if (light === 'light-increased-contrast') light = 'light';
        if (dark === 'dark-increased-contrast') dark = 'dark';
    }
    const themeState = {
        colorMode: colorMode,
        contrastMode: contrastMode,
        dark: dark,
        light: light,
        shape: shape,
        spacing: spacing,
        typography: typography,
        motion: motion,
        UNSAFE_themeOptions: themeLoader ? undefined : UNSAFE_themeOptions
    };
    // Determine what to load and loading strategy
    let themePreferences = (0, $6raEH.getThemePreferences)(themeState);
    const loadingStrategy = themeLoader ? themeLoader : (0, $duxx7.loadAndAppendThemeCss);
    // Load standard themes
    const loadingTasks = themePreferences.map(async (themeId)=>await loadingStrategy(themeId));
    // Load custom themes if needed
    if (!themeLoader && UNSAFE_themeOptions && (0, $4laSa.isValidBrandHex)(UNSAFE_themeOptions?.brandColor)) {
        const mode = colorMode || (0, $9KKWI.themeStateDefaults)['colorMode'];
        const attrOfMissingCustomStyles = (0, $dVuZ5.findMissingCustomStyleElements)(UNSAFE_themeOptions, mode);
        if (attrOfMissingCustomStyles.length > 0) // Load custom theme styles
        loadingTasks.push((async ()=>{
            const { loadAndAppendCustomThemeCss: loadAndAppendCustomThemeCss } = await (parcelRequire("8Gi5d"));
            loadAndAppendCustomThemeCss({
                colorMode: attrOfMissingCustomStyles.length === 2 ? 'auto' : // only load the missing custom theme styles
                attrOfMissingCustomStyles[0],
                UNSAFE_themeOptions: UNSAFE_themeOptions
            });
        })());
    }
    await Promise.all(loadingTasks);
    // Load override themes after standard themes
    const themeOverridePreferences = (0, $6raEH.getThemeOverridePreferences)(themeState);
    for (const themeId of themeOverridePreferences)await loadingStrategy(themeId);
    const autoUnbind = (0, $7c04u.default)(themeState);
    return autoUnbind;
};
var $73e63b9fd1073d80$export$2e2bcd8739ae039 = $73e63b9fd1073d80$var$setGlobalTheme;

});
parcelRegister("xG0ax", function(module, exports) {
$parcel$export(module.exports, "default", () => $b91eba75a4904a18$export$2e2bcd8739ae039);

var $e5lMD = parcelRequire("e5lMD");

var $9KKWI = parcelRequire("9KKWI");

var $drJ5V = parcelRequire("drJ5V");
const $b91eba75a4904a18$var$isThemeColorMode = (colorMode)=>{
    return (0, $9KKWI.themeColorModes).find((mode)=>mode === colorMode) !== undefined;
};
const $b91eba75a4904a18$var$getGlobalTheme = ()=>{
    if (typeof document === 'undefined') return {};
    const element = document.documentElement;
    const colorMode = element.getAttribute((0, $e5lMD.COLOR_MODE_ATTRIBUTE)) || '';
    const theme = element.getAttribute((0, $e5lMD.THEME_DATA_ATTRIBUTE)) || '';
    return {
        ...(0, $drJ5V.themeStringToObject)(theme),
        ...$b91eba75a4904a18$var$isThemeColorMode(colorMode) && {
            colorMode: colorMode
        }
    };
};
var $b91eba75a4904a18$export$2e2bcd8739ae039 = $b91eba75a4904a18$var$getGlobalTheme;

});
parcelRegister("e5lMD", function(module, exports) {
$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", () => $8b3b023f8fa7f910$export$4ef52930e33717cd);
$parcel$export(module.exports, "SUBTREE_THEME_ATTRIBUTE", () => $8b3b023f8fa7f910$export$cb374d25ded7f6ab);
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", () => $8b3b023f8fa7f910$export$a00eac3f8684bcd0);
$parcel$export(module.exports, "CONTRAST_MODE_ATTRIBUTE", () => $8b3b023f8fa7f910$export$2112803007239c61);
$parcel$export(module.exports, "CUSTOM_THEME_ATTRIBUTE", () => $8b3b023f8fa7f910$export$352e418ed5b6193a);
$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", () => $8b3b023f8fa7f910$export$9d7b58831ae93caa);
const $8b3b023f8fa7f910$export$4ef52930e33717cd = 'data-theme';
const $8b3b023f8fa7f910$export$cb374d25ded7f6ab = 'data-subtree-theme';
const $8b3b023f8fa7f910$export$a00eac3f8684bcd0 = 'data-color-mode';
const $8b3b023f8fa7f910$export$2112803007239c61 = 'data-contrast-mode';
const $8b3b023f8fa7f910$export$352e418ed5b6193a = 'data-custom-theme';
const $8b3b023f8fa7f910$export$6f0c6fb8c80fcc92 = 'ds';
const $8b3b023f8fa7f910$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
const $8b3b023f8fa7f910$export$dddac1532e822863 = `--${$8b3b023f8fa7f910$export$6f0c6fb8c80fcc92}-token-not-found`;
const $8b3b023f8fa7f910$export$9d7b58831ae93caa = `--${$8b3b023f8fa7f910$export$6f0c6fb8c80fcc92}-elevation-surface-current`;

});

parcelRegister("9KKWI", function(module, exports) {
$parcel$export(module.exports, "themeColorModes", () => $ccdd75238a27fbb7$export$83993de8eb66733);
$parcel$export(module.exports, "themeIds", () => $ccdd75238a27fbb7$export$7d43e72a58e3283f);
$parcel$export(module.exports, "themeStateDefaults", () => $ccdd75238a27fbb7$export$9aedcfa7336a207);
$parcel$export(module.exports, "default", () => $ccdd75238a27fbb7$export$2e2bcd8739ae039);

var $3X3Vo = parcelRequire("3X3Vo");
const $ccdd75238a27fbb7$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];
/**
 * Contrast preferences: The system contrast preference
 */ const $ccdd75238a27fbb7$var$themeContrastModes = [
    'more',
    'no-preference',
    'auto'
];
const $ccdd75238a27fbb7$export$7d43e72a58e3283f = [
    'light-increased-contrast',
    'light',
    'light-future',
    'dark',
    'dark-future',
    'dark-increased-contrast',
    'spacing',
    'shape',
    'typography',
    'motion'
];
/**
 * Theme override ids: the equivalent of themeIds for theme overrides.
 * Theme overrides are temporary and there may not be any defined at times.
 */ const $ccdd75238a27fbb7$var$themeOverrideIds = [];
const $ccdd75238a27fbb7$export$92ba366331403db2 = [
    ...$ccdd75238a27fbb7$export$7d43e72a58e3283f,
    ...$ccdd75238a27fbb7$var$themeOverrideIds
];
const $ccdd75238a27fbb7$var$themeConfig = {
    'atlassian-light': {
        id: 'light',
        displayName: 'Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-light-future': {
        id: 'light-future',
        displayName: 'Future Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light'
    },
    'atlassian-light-increased-contrast': {
        id: 'light-increased-contrast',
        displayName: 'Light Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        extends: 'light',
        increasesContrastFor: 'light'
    },
    'atlassian-dark': {
        id: 'dark',
        displayName: 'Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-dark-future': {
        id: 'dark-future',
        displayName: 'Future Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'light'
    },
    'atlassian-dark-increased-contrast': {
        id: 'dark-increased-contrast',
        displayName: 'Dark Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        extends: 'dark',
        increasesContrastFor: 'dark'
    },
    'atlassian-spacing': {
        id: 'spacing',
        displayName: 'Atlassian Spacing',
        palette: 'spacingScale',
        attributes: {
            type: 'spacing'
        }
    },
    'atlassian-typography': {
        id: 'typography',
        displayName: 'Atlassian Typography',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-shape': {
        id: 'shape',
        displayName: 'Shape',
        palette: 'shapePalette',
        attributes: {
            type: 'shape'
        }
    },
    'atlassian-motion': {
        id: 'motion',
        displayName: 'Motion',
        palette: 'motionPalette',
        attributes: {
            type: 'motion'
        }
    }
};
function $ccdd75238a27fbb7$var$getShapeDefault() {
    if ((0, $3X3Vo.fg)('platform-dst-shape-theme-default')) return 'shape';
    return undefined;
}
function $ccdd75238a27fbb7$var$getMotionDefault() {
    if ((0, $3X3Vo.fg)('platform-dst-motion-theme-default')) return 'motion';
    return undefined;
}
const $ccdd75238a27fbb7$export$9aedcfa7336a207 = {
    colorMode: 'auto',
    contrastMode: 'auto',
    dark: 'dark',
    light: 'light',
    shape: $ccdd75238a27fbb7$var$getShapeDefault,
    spacing: 'spacing',
    typography: 'typography',
    motion: $ccdd75238a27fbb7$var$getMotionDefault,
    UNSAFE_themeOptions: undefined
};
var $ccdd75238a27fbb7$export$2e2bcd8739ae039 = $ccdd75238a27fbb7$var$themeConfig;

});

parcelRegister("drJ5V", function(module, exports) {
$parcel$export(module.exports, "themeStringToObject", () => $1b6e33935fbded55$export$f19b488f7c0547ee);
$parcel$export(module.exports, "themeObjectToString", () => $1b6e33935fbded55$export$62c37ab81302621a);

var $9KKWI = parcelRequire("9KKWI");
const $1b6e33935fbded55$var$themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape',
    'motion'
];
const $1b6e33935fbded55$var$customThemeOptions = 'UNSAFE_themeOptions';
const $1b6e33935fbded55$var$isThemeKind = (themeKind)=>{
    return $1b6e33935fbded55$var$themeKinds.find((kind)=>kind === themeKind) !== undefined;
};
const $1b6e33935fbded55$var$isThemeIds = (themeId)=>{
    return (0, $9KKWI.themeIds).find((id)=>id === themeId) !== undefined;
};
const $1b6e33935fbded55$var$isColorMode = (modeId)=>{
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};
const $1b6e33935fbded55$export$f19b488f7c0547ee = (themeState)=>{
    return themeState.split(' ')// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    .map((theme)=>theme.split(/:(.*)/s)).reduce((themeObject, [kind, id])=>{
        if (kind === 'colorMode' && $1b6e33935fbded55$var$isColorMode(id)) themeObject[kind] = id;
        if ($1b6e33935fbded55$var$isThemeKind(kind) && $1b6e33935fbded55$var$isThemeIds(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $1b6e33935fbded55$var$customThemeOptions) try {
            themeObject[$1b6e33935fbded55$var$customThemeOptions] = JSON.parse(id);
        } catch  {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};
const $1b6e33935fbded55$export$62c37ab81302621a = (themeState)=>Object.entries(themeState).reduce((themeString, [kind, id])=>{
        if (// colorMode theme state
        kind === 'colorMode' && typeof id === 'string' && $1b6e33935fbded55$var$isColorMode(id) || // custom theme state
        kind === $1b6e33935fbded55$var$customThemeOptions && typeof id === 'object' || // other theme states
        $1b6e33935fbded55$var$isThemeKind(kind) && typeof id === 'string' && $1b6e33935fbded55$var$isThemeIds(id)) return themeString + `${themeString ? ' ' : ''}` + `${kind}:${typeof id === 'object' ? JSON.stringify(id) : id}`;
        return themeString;
    }, '');

});


parcelRegister("4laSa", function(module, exports) {
$parcel$export(module.exports, "isValidBrandHex", () => $11bb3a822b67d7f9$export$53031ac1ecb71f44);
$parcel$export(module.exports, "rgbToHex", () => $11bb3a822b67d7f9$export$34d09c4a771c46ef);
$parcel$export(module.exports, "hexToRgbA", () => $11bb3a822b67d7f9$export$b36dbdb4f463f05c);
$parcel$export(module.exports, "hexToRgb", () => $11bb3a822b67d7f9$export$5a544e13ad4e1fa5);
$parcel$export(module.exports, "hexToHSL", () => $11bb3a822b67d7f9$export$47ea145a83f50dc0);
$parcel$export(module.exports, "HSLToRGB", () => $11bb3a822b67d7f9$export$1ff93e992dd58bec);
$parcel$export(module.exports, "relativeLuminanceW3C", () => $11bb3a822b67d7f9$export$e770b01b744f3745);
$parcel$export(module.exports, "getContrastRatio", () => $11bb3a822b67d7f9$export$d061e26956a60b0a);
$parcel$export(module.exports, "deltaE", () => $11bb3a822b67d7f9$export$e8ddad763b4bebf9);
// valid hex color with 6 digits
const $11bb3a822b67d7f9$export$53031ac1ecb71f44 = (hex)=>/^#[0-9A-F]{6}$/i.test(hex);
// valid hex color with 4, 6 or 8 digits
const $11bb3a822b67d7f9$var$isValidHex = (hex)=>/^#([A-Fa-f0-9]{3,4}){1,2}$/.test(hex);
function $11bb3a822b67d7f9$export$34d09c4a771c46ef(r, g, b) {
    return '#' + (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1);
}
function $11bb3a822b67d7f9$export$1212645cf40ebf71(hex) {
    if (hex.length === 9) {
        const int = parseInt(hex.slice(7, 9), 16) / 255;
        return Number(parseFloat(int.toString()).toFixed(2));
    }
    return 1;
}
function $11bb3a822b67d7f9$export$b36dbdb4f463f05c(hex) {
    if (!$11bb3a822b67d7f9$var$isValidHex(hex)) throw new Error('Invalid HEX');
    let c;
    c = hex.substring(1).split('');
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = '0x' + c.join('');
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255,
        $11bb3a822b67d7f9$export$1212645cf40ebf71(hex)
    ];
}
function $11bb3a822b67d7f9$export$5a544e13ad4e1fa5(hex) {
    if (!$11bb3a822b67d7f9$var$isValidHex(hex)) throw new Error('Invalid HEX');
    let c;
    c = hex.substring(1).split('');
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = '0x' + c.join('');
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255
    ];
}
function $11bb3a822b67d7f9$export$47ea145a83f50dc0(hex) {
    if (!$11bb3a822b67d7f9$var$isValidHex(hex)) throw new Error('Invalid HEX');
    let r = 0, g = 0, b = 0;
    if (hex.length === 4) {
        r = '0x' + hex[1] + hex[1];
        g = '0x' + hex[2] + hex[2];
        b = '0x' + hex[3] + hex[3];
    } else if (hex.length === 7) {
        r = '0x' + hex[1] + hex[2];
        g = '0x' + hex[3] + hex[4];
        b = '0x' + hex[5] + hex[6];
    }
    // Then to HSL
    r /= 255;
    g /= 255;
    b /= 255;
    let cmin = Math.min(r, g, b), cmax = Math.max(r, g, b), delta = cmax - cmin, h = 0, s = 0, l = 0;
    if (delta === 0) h = 0;
    else if (cmax === r) h = (g - b) / delta % 6;
    else if (cmax === g) h = (b - r) / delta + 2;
    else h = (r - g) / delta + 4;
    h = Math.round(h * 60);
    if (h < 0) h += 360;
    l = (cmax + cmin) / 2;
    s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
    s = +(s * 100).toFixed(1);
    l = +(l * 100).toFixed(1);
    return [
        h,
        s,
        l
    ];
}
function $11bb3a822b67d7f9$export$1ff93e992dd58bec(h, s, l) {
    s /= 100;
    l /= 100;
    const k = (n)=>(n + h / 30) % 12;
    const a = s * Math.min(l, 1 - l);
    const f = (n)=>l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
    return [
        255 * f(0),
        255 * f(8),
        255 * f(4)
    ];
}
function $11bb3a822b67d7f9$export$e770b01b744f3745(r, g, b) {
    const RsRGB = r / 255;
    const GsRGB = g / 255;
    const BsRGB = b / 255;
    const R = RsRGB <= 0.03928 ? RsRGB / 12.92 : Math.pow((RsRGB + 0.055) / 1.055, 2.4);
    const G = GsRGB <= 0.03928 ? GsRGB / 12.92 : Math.pow((GsRGB + 0.055) / 1.055, 2.4);
    const B = BsRGB <= 0.03928 ? BsRGB / 12.92 : Math.pow((BsRGB + 0.055) / 1.055, 2.4);
    // For the sRGB colorspace, the relative luminance of a color is defined as:
    const L = 0.2126 * R + 0.7152 * G + 0.0722 * B;
    return L;
}
function $11bb3a822b67d7f9$export$d061e26956a60b0a(foreground, background) {
    if (!$11bb3a822b67d7f9$var$isValidHex(foreground) || !$11bb3a822b67d7f9$var$isValidHex(background)) throw new Error('Invalid HEX');
    const foregroundRgb = $11bb3a822b67d7f9$export$5a544e13ad4e1fa5(foreground);
    const backgroundRgb = $11bb3a822b67d7f9$export$5a544e13ad4e1fa5(background);
    const foregroundLuminance = $11bb3a822b67d7f9$export$e770b01b744f3745(foregroundRgb[0], foregroundRgb[1], foregroundRgb[2]);
    const backgroundLuminance = $11bb3a822b67d7f9$export$e770b01b744f3745(backgroundRgb[0], backgroundRgb[1], backgroundRgb[2]);
    // calculate the color contrast ratio
    var brightest = Math.max(foregroundLuminance, backgroundLuminance);
    var darkest = Math.min(foregroundLuminance, backgroundLuminance);
    return (brightest + 0.05) / (darkest + 0.05);
}
function $11bb3a822b67d7f9$export$e8ddad763b4bebf9(rgbA, rgbB) {
    let labA = $11bb3a822b67d7f9$var$rgbToLab(rgbA);
    let labB = $11bb3a822b67d7f9$var$rgbToLab(rgbB);
    let deltaL = labA[0] - labB[0];
    let deltaA = labA[1] - labB[1];
    let deltaB = labA[2] - labB[2];
    let c1 = Math.sqrt(labA[1] * labA[1] + labA[2] * labA[2]);
    let c2 = Math.sqrt(labB[1] * labB[1] + labB[2] * labB[2]);
    let deltaC = c1 - c2;
    let deltaH = deltaA * deltaA + deltaB * deltaB - deltaC * deltaC;
    deltaH = deltaH < 0 ? 0 : Math.sqrt(deltaH);
    let sc = 1.0 + 0.045 * c1;
    let sh = 1.0 + 0.015 * c1;
    let deltaLKlsl = deltaL / 1.0;
    let deltaCkcsc = deltaC / sc;
    let deltaHkhsh = deltaH / sh;
    let i = deltaLKlsl * deltaLKlsl + deltaCkcsc * deltaCkcsc + deltaHkhsh * deltaHkhsh;
    return i < 0 ? 0 : Math.sqrt(i);
}
function $11bb3a822b67d7f9$var$rgbToLab(rgb) {
    let r = rgb[0] / 255, g = rgb[1] / 255, b = rgb[2] / 255, x, y, z;
    r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
    g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
    b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
    x = (r * 0.4124 + g * 0.3576 + b * 0.1805) / 0.95047;
    y = (r * 0.2126 + g * 0.7152 + b * 0.0722) / 1.0;
    z = (r * 0.0193 + g * 0.1192 + b * 0.9505) / 1.08883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    return [
        116 * y - 16,
        500 * (x - y),
        200 * (y - z)
    ];
}

});

parcelRegister("7c04u", function(module, exports) {
$parcel$export(module.exports, "default", () => $82db369934f7d4b8$export$2e2bcd8739ae039);

var $3X3Vo = parcelRequire("3X3Vo");

var $jXZTR = parcelRequire("jXZTR");

var $kLmT6 = parcelRequire("kLmT6");

var $l9Ilw = parcelRequire("l9Ilw");
function $82db369934f7d4b8$export$2e2bcd8739ae039(themeState) {
    if (themeState.colorMode === 'auto') {
        // Set colorMode based on the user preference
        themeState.colorMode = (0, $kLmT6.default).getColorMode();
        // Bind a listener (if one doesn't already exist) to keep colorMode updated
        (0, $kLmT6.default).bind();
    } else (0, $kLmT6.default).unbind();
    if ((0, $3X3Vo.fg)('platform_increased-contrast-themes')) {
        if (themeState.contrastMode === 'auto') {
            // Set contrastMode based on the user preference
            themeState.contrastMode = (0, $l9Ilw.default).getContrastMode();
            // Bind a listener (if one doesn't already exist) to keep contrastMode updated
            (0, $l9Ilw.default).bind();
        } else (0, $l9Ilw.default).unbind();
    }
    const themeAttributes = (0, $jXZTR.default)(themeState);
    Object.entries(themeAttributes).forEach(([key, value])=>{
        document.documentElement.setAttribute(key, value);
    });
    return ()=>{
        (0, $kLmT6.default).unbind();
        if ((0, $3X3Vo.fg)('platform_increased-contrast-themes')) (0, $l9Ilw.default).unbind();
    };
}

});
parcelRegister("jXZTR", function(module, exports) {
$parcel$export(module.exports, "default", () => $0dcf884d7868be69$export$2e2bcd8739ae039);

var $3X3Vo = parcelRequire("3X3Vo");

var $e5lMD = parcelRequire("e5lMD");

var $9KKWI = parcelRequire("9KKWI");

var $drJ5V = parcelRequire("drJ5V");

var $4laSa = parcelRequire("4laSa");

var $hsiyI = parcelRequire("hsiyI");
const $0dcf884d7868be69$var$defaultColorMode = 'light';
const $0dcf884d7868be69$var$defaultContrastMode = 'no-preference';
/**
 * Server-side rendering utility. Generates the valid HTML attributes for a given theme.
 * Note: this utility does not handle automatic theme switching.
 *
 * @param {Object<string, string>} themeOptions - Theme options object
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.motion The motion theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 *
 * @returns {Object} Object of HTML attributes to be applied to the document root
 */ const $0dcf884d7868be69$var$getThemeHtmlAttrs = ({ colorMode: colorMode = (0, $9KKWI.themeStateDefaults)['colorMode'], dark: dark = (0, $9KKWI.themeStateDefaults)['dark'], light: light = (0, $9KKWI.themeStateDefaults)['light'], contrastMode: contrastMode = (0, $9KKWI.themeStateDefaults)['contrastMode'], motion: motion = (0, $9KKWI.themeStateDefaults)['motion'](), shape: shape = (0, $9KKWI.themeStateDefaults)['shape'](), spacing: spacing = (0, $9KKWI.themeStateDefaults)['spacing'], typography: typography = (0, $9KKWI.themeStateDefaults)['typography'], UNSAFE_themeOptions: UNSAFE_themeOptions = (0, $9KKWI.themeStateDefaults)['UNSAFE_themeOptions'] } = {})=>{
    const themeAttribute = (0, $drJ5V.themeObjectToString)({
        dark: dark,
        light: light,
        motion: motion,
        shape: shape,
        spacing: spacing,
        typography: typography
    });
    let result = {
        [(0, $e5lMD.THEME_DATA_ATTRIBUTE)]: themeAttribute,
        [(0, $e5lMD.COLOR_MODE_ATTRIBUTE)]: colorMode === 'auto' ? $0dcf884d7868be69$var$defaultColorMode : colorMode
    };
    if ((0, $3X3Vo.fg)('platform_increased-contrast-themes')) result = {
        ...result,
        // CLEANUP: Move this to the initial `result` assignment above
        [(0, $e5lMD.CONTRAST_MODE_ATTRIBUTE)]: contrastMode === 'auto' ? $0dcf884d7868be69$var$defaultContrastMode : contrastMode
    };
    if (UNSAFE_themeOptions && (0, $4laSa.isValidBrandHex)(UNSAFE_themeOptions.brandColor)) {
        const optionString = JSON.stringify(UNSAFE_themeOptions);
        const uniqueId = (0, $hsiyI.hash)(optionString);
        result[0, $e5lMD.CUSTOM_THEME_ATTRIBUTE] = uniqueId;
    }
    return result;
};
var $0dcf884d7868be69$export$2e2bcd8739ae039 = $0dcf884d7868be69$var$getThemeHtmlAttrs;

});
parcelRegister("hsiyI", function(module, exports) {
$parcel$export(module.exports, "hash", () => $edd885a2552a03a9$export$d6af199866bfb566);
const $edd885a2552a03a9$export$d6af199866bfb566 = (str)=>{
    let hash = 0;
    for(let i = 0; i < str.length; i++){
        const char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([
        hash
    ])[0].toString(36);
};

});


parcelRegister("kLmT6", function(module, exports) {
$parcel$export(module.exports, "default", () => $a2d86c72289878d4$export$2e2bcd8739ae039);

var $Hyfcf = parcelRequire("Hyfcf");

var $e5lMD = parcelRequire("e5lMD");

var $duxx7 = parcelRequire("duxx7");
const $a2d86c72289878d4$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system theme changes. Should be bound
 * to an event listener listening on the '(prefers-color-scheme: dark)' query
 * @param e The event representing a change in system theme.
 */ function $a2d86c72289878d4$var$checkNativeListener(e) {
    const element = document.documentElement;
    element.setAttribute((0, $e5lMD.COLOR_MODE_ATTRIBUTE), e.matches ? 'dark' : 'light');
}
const $a2d86c72289878d4$var$darkModeMql = $a2d86c72289878d4$var$isMatchMediaAvailable && window.matchMedia((0, $duxx7.darkModeMediaQuery));
class $a2d86c72289878d4$var$ColorModeObserver {
    getColorMode() {
        if (!$a2d86c72289878d4$var$darkModeMql) return 'light';
        return $a2d86c72289878d4$var$darkModeMql?.matches ? 'dark' : 'light';
    }
    bind() {
        if ($a2d86c72289878d4$var$darkModeMql && this.unbindThemeChangeListener === null) this.unbindThemeChangeListener = (0, $Hyfcf.bind)($a2d86c72289878d4$var$darkModeMql, {
            type: 'change',
            listener: $a2d86c72289878d4$var$checkNativeListener
        });
    }
    unbind() {
        if (this.unbindThemeChangeListener) {
            this.unbindThemeChangeListener();
            this.unbindThemeChangeListener = null;
        }
    }
    constructor(){
        this.unbindThemeChangeListener = null;
    }
}
/**
 * A singleton color mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ const $a2d86c72289878d4$var$SingletonColorModeObserver = new $a2d86c72289878d4$var$ColorModeObserver();
var $a2d86c72289878d4$export$2e2bcd8739ae039 = $a2d86c72289878d4$var$SingletonColorModeObserver;

});
parcelRegister("duxx7", function(module, exports) {
$parcel$export(module.exports, "loadAndAppendThemeCss", () => $39d79a3e28f259dc$export$26cd7ae85c7144e5);
$parcel$export(module.exports, "darkModeMediaQuery", () => $39d79a3e28f259dc$export$bb1e815119d30f8b);
$parcel$export(module.exports, "moreContrastMediaQuery", () => $39d79a3e28f259dc$export$8662df6937d86fcb);

var $hXG9T = parcelRequire("hXG9T");

var $e5lMD = parcelRequire("e5lMD");
const $39d79a3e28f259dc$export$26cd7ae85c7144e5 = async (themeId)=>{
    if (document.head.querySelector(`style[${(0, $e5lMD.THEME_DATA_ATTRIBUTE)}="${themeId}"]:not([${(0, $e5lMD.CUSTOM_THEME_ATTRIBUTE)}])`)) return;
    // Gracefully handles falsy values like `null` and `undefined` when maker ignore TS
    // to avoid loading default themes.
    if (!themeId) return;
    const themeCss = await $39d79a3e28f259dc$export$8a48286ed7df6720(themeId);
    const style = document.createElement('style');
    style.textContent = themeCss;
    style.dataset.theme = themeId;
    document.head.appendChild(style);
};
const $39d79a3e28f259dc$export$8a48286ed7df6720 = async (themeId)=>{
    const { default: themeCss } = await (0, $hXG9T.default)[themeId]();
    return themeCss;
};
const $39d79a3e28f259dc$export$bb1e815119d30f8b = '(prefers-color-scheme: dark)';
const $39d79a3e28f259dc$export$8662df6937d86fcb = '(prefers-contrast: more)';

});
parcelRegister("hXG9T", function(module, exports) {
$parcel$export(module.exports, "default", () => $6cbf35bd4ec426ce$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This file contains a dynamic import for each theme this package exports.
 * Themes are loaded asynchronously at runtime to minimise the amount of CSS we send to the client.
 * This allows users to compose their themes and only use the tokens that are requested.
 * When a new theme is created, the import should automatically be added to the map
 *
 * @codegen <<SignedSource::a20c72d683b08b594c5be4160eec5f78>>
 * @codegenCommand yarn build tokens
 */ 









const $6cbf35bd4ec426ce$var$themeImportsMap = {
    'light': ()=>(parcelRequire("9xq5n")),
    'light-future': ()=>(parcelRequire("6YAVN")),
    'light-increased-contrast': ()=>(parcelRequire("fvUgf")),
    'dark': ()=>(parcelRequire("lseoc")),
    'dark-future': ()=>(parcelRequire("bkmxH")),
    'dark-increased-contrast': ()=>(parcelRequire("gCPpF")),
    'spacing': ()=>(parcelRequire("jsCtD")),
    'typography': ()=>(parcelRequire("lEFWl")),
    'shape': ()=>(parcelRequire("5TRJA")),
    'motion': ()=>(parcelRequire("3oyPj"))
};
var $6cbf35bd4ec426ce$export$2e2bcd8739ae039 = $6cbf35bd4ec426ce$var$themeImportsMap;

});
parcelRegister("9xq5n", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("9IoVT").then(()=>parcelRequire('1gQmm'));

});

parcelRegister("6YAVN", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("8udjg").then(()=>parcelRequire('chtoL'));

});

parcelRegister("fvUgf", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("9IoVT").then(()=>parcelRequire('hmVFE'));

});

parcelRegister("lseoc", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("9IoVT").then(()=>parcelRequire('1o1kU'));

});

parcelRegister("bkmxH", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("8udjg").then(()=>parcelRequire('2IxzU'));

});

parcelRegister("gCPpF", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("9IoVT").then(()=>parcelRequire('6hba7'));

});

parcelRegister("jsCtD", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("8udjg").then(()=>parcelRequire('2fLzC'));

});

parcelRegister("lEFWl", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("8udjg").then(()=>parcelRequire('g34hM'));

});

parcelRegister("5TRJA", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("8udjg").then(()=>parcelRequire('j3K6f'));

});

parcelRegister("3oyPj", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("8udjg").then(()=>parcelRequire('blW4M'));

});




parcelRegister("l9Ilw", function(module, exports) {
$parcel$export(module.exports, "default", () => $67c8074918e845bc$export$2e2bcd8739ae039);

var $Hyfcf = parcelRequire("Hyfcf");

var $e5lMD = parcelRequire("e5lMD");

var $duxx7 = parcelRequire("duxx7");
const $67c8074918e845bc$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system contrast preference changes. Should be bound
 * to an event listener listening on the '(prefers-contrast: more)' query
 * @param e The event representing a change in system theme.
 */ function $67c8074918e845bc$var$checkNativeListener(e) {
    const element = document.documentElement;
    element.setAttribute((0, $e5lMD.CONTRAST_MODE_ATTRIBUTE), e.matches ? 'more' : 'no-preference');
}
const $67c8074918e845bc$var$contrastModeMql = $67c8074918e845bc$var$isMatchMediaAvailable && window.matchMedia((0, $duxx7.moreContrastMediaQuery));
class $67c8074918e845bc$var$ContrastModeObserver {
    getContrastMode() {
        if (!$67c8074918e845bc$var$contrastModeMql) return 'no-preference';
        return $67c8074918e845bc$var$contrastModeMql?.matches ? 'more' : 'no-preference';
    }
    bind() {
        if ($67c8074918e845bc$var$contrastModeMql && this.unbindContrastChangeListener === null) this.unbindContrastChangeListener = (0, $Hyfcf.bind)($67c8074918e845bc$var$contrastModeMql, {
            type: 'change',
            listener: $67c8074918e845bc$var$checkNativeListener
        });
    }
    unbind() {
        if (this.unbindContrastChangeListener) {
            this.unbindContrastChangeListener();
            this.unbindContrastChangeListener = null;
        }
    }
    constructor(){
        this.unbindContrastChangeListener = null;
    }
}
/**
 * A singleton contrast mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ const $67c8074918e845bc$var$SingletonContrastModeObserver = new $67c8074918e845bc$var$ContrastModeObserver();
var $67c8074918e845bc$export$2e2bcd8739ae039 = $67c8074918e845bc$var$SingletonContrastModeObserver;

});


parcelRegister("dVuZ5", function(module, exports) {
$parcel$export(module.exports, "findMissingCustomStyleElements", () => $55a6909398ec556f$export$bd1ac9300b0e885a);
$parcel$export(module.exports, "limitSizeOfCustomStyleElements", () => $55a6909398ec556f$export$e7ae172320e03461);
$parcel$export(module.exports, "reduceTokenMap", () => $55a6909398ec556f$export$e673f367da2ff23e);

var $a5gMf = parcelRequire("a5gMf");

var $e5lMD = parcelRequire("e5lMD");

var $hsiyI = parcelRequire("hsiyI");
function $55a6909398ec556f$export$bd1ac9300b0e885a(UNSAFE_themeOptions, mode) {
    const optionString = JSON.stringify(UNSAFE_themeOptions);
    const uniqueId = (0, $hsiyI.hash)(optionString);
    const attrOfMissingCustomStyles = [];
    (mode === 'auto' ? [
        'light',
        'dark'
    ] : [
        mode
    ]).forEach((themeId)=>{
        const element = document.head.querySelector(`style[${(0, $e5lMD.CUSTOM_THEME_ATTRIBUTE)}="${uniqueId}"][${(0, $e5lMD.THEME_DATA_ATTRIBUTE)}="${themeId}"]`);
        if (element) // Append the existing custom styles to take precedence over others
        document.head.appendChild(element);
        else attrOfMissingCustomStyles.push(themeId);
    });
    return attrOfMissingCustomStyles;
}
function $55a6909398ec556f$export$e7ae172320e03461(sizeThreshold) {
    const styleTags = [
        ...Array.from(document.head.querySelectorAll(`style[${(0, $e5lMD.CUSTOM_THEME_ATTRIBUTE)}][${(0, $e5lMD.THEME_DATA_ATTRIBUTE)}]`))
    ];
    if (styleTags.length < sizeThreshold) return;
    styleTags.slice(0, styleTags.length - (sizeThreshold - 1)).forEach((element)=>element.remove());
}
function $55a6909398ec556f$export$e673f367da2ff23e(tokenMap, themeRamp) {
    return Object.entries(tokenMap).reduce((acc, [key, value])=>{
        const cssVar = (0, $a5gMf.default)[key];
        return cssVar ? `${acc}\n  ${cssVar}: ${typeof value === 'string' ? value : themeRamp[value]};` : acc;
    }, '');
}

});
parcelRegister("a5gMf", function(module, exports) {
$parcel$export(module.exports, "default", () => $b559cd876c1743ed$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a1de8a9439d40392e3e4945ecf9d9214>>
 * @codegenCommand yarn build tokens
 */ const $b559cd876c1743ed$var$tokens = {
    'motion.avatar.enter': '--ds-avatar-enter',
    'motion.avatar.exit': '--ds-avatar-exit',
    'motion.avatar.hovered': '--ds-avatar-hovered',
    'motion.blanket.enter': '--ds-blanket-enter',
    'motion.blanket.exit': '--ds-blanket-exit',
    'motion.duration.instant': '--ds-duration-instant',
    'motion.duration.long': '--ds-duration-long',
    'motion.duration.medium': '--ds-duration-medium',
    'motion.duration.short': '--ds-duration-short',
    'motion.duration.xlong': '--ds-duration-xlong',
    'motion.duration.xshort': '--ds-duration-xshort',
    'motion.duration.xxlong': '--ds-duration-xxlong',
    'motion.duration.xxshort': '--ds-duration-xxshort',
    'motion.easing.in.practical': '--ds-easing-in-practical',
    'motion.easing.inout.bold': '--ds-easing-inout-bold',
    'motion.easing.out.practical': '--ds-easing-out-practical',
    'motion.easing.out.bold': '--ds-easing-out-bold',
    'motion.easing.spring': '--ds-easing-spring',
    'motion.flag.enter': '--ds-flag-enter',
    'motion.flag.exit': '--ds-flag-exit',
    'motion.flag.reposition': '--ds-flag-reposition',
    'motion.keyframe.fade.in': '--ds-keyframe-fade-in',
    'motion.keyframe.fade.out': '--ds-keyframe-fade-out',
    'motion.keyframe.scale.in.medium': '--ds-keyframe-scale-in-medium',
    'motion.keyframe.scale.in.small': '--ds-keyframe-scale-in-small',
    'motion.keyframe.scale.out.medium': '--ds-keyframe-scale-out-medium',
    'motion.keyframe.scale.out.small': '--ds-keyframe-scale-out-small',
    'motion.keyframe.slide.in.bottom.short': '--ds-keyframe-slide-in-bottom-short',
    'motion.keyframe.slide.in.left.half': '--ds-keyframe-slide-in-left-half',
    'motion.keyframe.slide.in.left.short': '--ds-keyframe-slide-in-left-short',
    'motion.keyframe.slide.in.right.short': '--ds-keyframe-slide-in-right-short',
    'motion.keyframe.slide.in.top.short': '--ds-keyframe-slide-in-top-short',
    'motion.keyframe.slide.out.bottom.short': '--ds-keyframe-slide-out-bottom-short',
    'motion.keyframe.slide.out.left.half': '--ds-keyframe-slide-out-left-half',
    'motion.keyframe.slide.out.left.short': '--ds-keyframe-slide-out-left-short',
    'motion.keyframe.slide.out.right.short': '--ds-keyframe-slide-out-right-short',
    'motion.keyframe.slide.out.top.short': '--ds-keyframe-slide-out-top-short',
    'motion.modal.enter': '--ds-modal-enter',
    'motion.modal.exit': '--ds-modal-exit',
    'motion.popup.enter.bottom': '--ds-popup-enter-bottom',
    'motion.popup.enter.left': '--ds-popup-enter-left',
    'motion.popup.enter.right': '--ds-popup-enter-right',
    'motion.popup.enter.top': '--ds-popup-enter-top',
    'motion.popup.exit.bottom': '--ds-popup-exit-bottom',
    'motion.popup.exit.left': '--ds-popup-exit-left',
    'motion.popup.exit.right': '--ds-popup-exit-right',
    'motion.popup.exit.top': '--ds-popup-exit-top',
    'motion.spotlight.enter': '--ds-spotlight-enter',
    'motion.spotlight.exit': '--ds-spotlight-exit',
    'color.text': '--ds-text',
    'color.text.accent.lime': '--ds-text-accent-lime',
    'color.text.accent.lime.bolder': '--ds-text-accent-lime-bolder',
    'color.text.accent.red': '--ds-text-accent-red',
    'color.text.accent.red.bolder': '--ds-text-accent-red-bolder',
    'color.text.accent.orange': '--ds-text-accent-orange',
    'color.text.accent.orange.bolder': '--ds-text-accent-orange-bolder',
    'color.text.accent.yellow': '--ds-text-accent-yellow',
    'color.text.accent.yellow.bolder': '--ds-text-accent-yellow-bolder',
    'color.text.accent.green': '--ds-text-accent-green',
    'color.text.accent.green.bolder': '--ds-text-accent-green-bolder',
    'color.text.accent.teal': '--ds-text-accent-teal',
    'color.text.accent.teal.bolder': '--ds-text-accent-teal-bolder',
    'color.text.accent.blue': '--ds-text-accent-blue',
    'color.text.accent.blue.bolder': '--ds-text-accent-blue-bolder',
    'color.text.accent.purple': '--ds-text-accent-purple',
    'color.text.accent.purple.bolder': '--ds-text-accent-purple-bolder',
    'color.text.accent.magenta': '--ds-text-accent-magenta',
    'color.text.accent.magenta.bolder': '--ds-text-accent-magenta-bolder',
    'color.text.accent.gray': '--ds-text-accent-gray',
    'color.text.accent.gray.bolder': '--ds-text-accent-gray-bolder',
    'color.text.disabled': '--ds-text-disabled',
    'color.text.inverse': '--ds-text-inverse',
    'color.text.selected': '--ds-text-selected',
    'color.text.brand': '--ds-text-brand',
    'color.text.danger': '--ds-text-danger',
    'color.text.danger.bolder': '--ds-text-danger-bolder',
    'color.text.warning': '--ds-text-warning',
    'color.text.warning.inverse': '--ds-text-warning-inverse',
    'color.text.warning.bolder': '--ds-text-warning-bolder',
    'color.text.success': '--ds-text-success',
    'color.text.success.bolder': '--ds-text-success-bolder',
    'color.text.discovery': '--ds-text-discovery',
    'color.text.discovery.bolder': '--ds-text-discovery-bolder',
    'color.text.information': '--ds-text-information',
    'color.text.information.bolder': '--ds-text-information-bolder',
    'color.text.subtlest': '--ds-text-subtlest',
    'color.text.subtle': '--ds-text-subtle',
    'color.link': '--ds-link',
    'color.link.pressed': '--ds-link-pressed',
    'color.link.visited': '--ds-link-visited',
    'color.link.visited.pressed': '--ds-link-visited-pressed',
    'color.icon': '--ds-icon',
    'color.icon.accent.lime': '--ds-icon-accent-lime',
    'color.icon.accent.red': '--ds-icon-accent-red',
    'color.icon.accent.orange': '--ds-icon-accent-orange',
    'color.icon.accent.yellow': '--ds-icon-accent-yellow',
    'color.icon.accent.green': '--ds-icon-accent-green',
    'color.icon.accent.teal': '--ds-icon-accent-teal',
    'color.icon.accent.blue': '--ds-icon-accent-blue',
    'color.icon.accent.purple': '--ds-icon-accent-purple',
    'color.icon.accent.magenta': '--ds-icon-accent-magenta',
    'color.icon.accent.gray': '--ds-icon-accent-gray',
    'color.icon.disabled': '--ds-icon-disabled',
    'color.icon.inverse': '--ds-icon-inverse',
    'color.icon.selected': '--ds-icon-selected',
    'color.icon.brand': '--ds-icon-brand',
    'color.icon.danger': '--ds-icon-danger',
    'color.icon.warning': '--ds-icon-warning',
    'color.icon.warning.inverse': '--ds-icon-warning-inverse',
    'color.icon.success': '--ds-icon-success',
    'color.icon.discovery': '--ds-icon-discovery',
    'color.icon.information': '--ds-icon-information',
    'color.icon.subtlest': '--ds-icon-subtlest',
    'color.icon.subtle': '--ds-icon-subtle',
    'color.border': '--ds-border',
    'color.border.accent.lime': '--ds-border-accent-lime',
    'color.border.accent.red': '--ds-border-accent-red',
    'color.border.accent.orange': '--ds-border-accent-orange',
    'color.border.accent.yellow': '--ds-border-accent-yellow',
    'color.border.accent.green': '--ds-border-accent-green',
    'color.border.accent.teal': '--ds-border-accent-teal',
    'color.border.accent.blue': '--ds-border-accent-blue',
    'color.border.accent.purple': '--ds-border-accent-purple',
    'color.border.accent.magenta': '--ds-border-accent-magenta',
    'color.border.accent.gray': '--ds-border-accent-gray',
    'color.border.disabled': '--ds-border-disabled',
    'color.border.focused': '--ds-border-focused',
    'color.border.input': '--ds-border-input',
    'color.border.inverse': '--ds-border-inverse',
    'color.border.selected': '--ds-border-selected',
    'color.border.brand': '--ds-border-brand',
    'color.border.danger': '--ds-border-danger',
    'color.border.warning': '--ds-border-warning',
    'color.border.success': '--ds-border-success',
    'color.border.discovery': '--ds-border-discovery',
    'color.border.information': '--ds-border-information',
    'color.border.bold': '--ds-border-bold',
    'color.background.accent.lime.subtlest': '--ds-background-accent-lime-subtlest',
    'color.background.accent.lime.subtlest.hovered': '--ds-background-accent-lime-subtlest-hovered',
    'color.background.accent.lime.subtlest.pressed': '--ds-background-accent-lime-subtlest-pressed',
    'color.background.accent.lime.subtler': '--ds-background-accent-lime-subtler',
    'color.background.accent.lime.subtler.hovered': '--ds-background-accent-lime-subtler-hovered',
    'color.background.accent.lime.subtler.pressed': '--ds-background-accent-lime-subtler-pressed',
    'color.background.accent.lime.subtle': '--ds-background-accent-lime-subtle',
    'color.background.accent.lime.subtle.hovered': '--ds-background-accent-lime-subtle-hovered',
    'color.background.accent.lime.subtle.pressed': '--ds-background-accent-lime-subtle-pressed',
    'color.background.accent.lime.bolder': '--ds-background-accent-lime-bolder',
    'color.background.accent.lime.bolder.hovered': '--ds-background-accent-lime-bolder-hovered',
    'color.background.accent.lime.bolder.pressed': '--ds-background-accent-lime-bolder-pressed',
    'color.background.accent.red.subtlest': '--ds-background-accent-red-subtlest',
    'color.background.accent.red.subtlest.hovered': '--ds-background-accent-red-subtlest-hovered',
    'color.background.accent.red.subtlest.pressed': '--ds-background-accent-red-subtlest-pressed',
    'color.background.accent.red.subtler': '--ds-background-accent-red-subtler',
    'color.background.accent.red.subtler.hovered': '--ds-background-accent-red-subtler-hovered',
    'color.background.accent.red.subtler.pressed': '--ds-background-accent-red-subtler-pressed',
    'color.background.accent.red.subtle': '--ds-background-accent-red-subtle',
    'color.background.accent.red.subtle.hovered': '--ds-background-accent-red-subtle-hovered',
    'color.background.accent.red.subtle.pressed': '--ds-background-accent-red-subtle-pressed',
    'color.background.accent.red.bolder': '--ds-background-accent-red-bolder',
    'color.background.accent.red.bolder.hovered': '--ds-background-accent-red-bolder-hovered',
    'color.background.accent.red.bolder.pressed': '--ds-background-accent-red-bolder-pressed',
    'color.background.accent.orange.subtlest': '--ds-background-accent-orange-subtlest',
    'color.background.accent.orange.subtlest.hovered': '--ds-background-accent-orange-subtlest-hovered',
    'color.background.accent.orange.subtlest.pressed': '--ds-background-accent-orange-subtlest-pressed',
    'color.background.accent.orange.subtler': '--ds-background-accent-orange-subtler',
    'color.background.accent.orange.subtler.hovered': '--ds-background-accent-orange-subtler-hovered',
    'color.background.accent.orange.subtler.pressed': '--ds-background-accent-orange-subtler-pressed',
    'color.background.accent.orange.subtle': '--ds-background-accent-orange-subtle',
    'color.background.accent.orange.subtle.hovered': '--ds-background-accent-orange-subtle-hovered',
    'color.background.accent.orange.subtle.pressed': '--ds-background-accent-orange-subtle-pressed',
    'color.background.accent.orange.bolder': '--ds-background-accent-orange-bolder',
    'color.background.accent.orange.bolder.hovered': '--ds-background-accent-orange-bolder-hovered',
    'color.background.accent.orange.bolder.pressed': '--ds-background-accent-orange-bolder-pressed',
    'color.background.accent.yellow.subtlest': '--ds-background-accent-yellow-subtlest',
    'color.background.accent.yellow.subtlest.hovered': '--ds-background-accent-yellow-subtlest-hovered',
    'color.background.accent.yellow.subtlest.pressed': '--ds-background-accent-yellow-subtlest-pressed',
    'color.background.accent.yellow.subtler': '--ds-background-accent-yellow-subtler',
    'color.background.accent.yellow.subtler.hovered': '--ds-background-accent-yellow-subtler-hovered',
    'color.background.accent.yellow.subtler.pressed': '--ds-background-accent-yellow-subtler-pressed',
    'color.background.accent.yellow.subtle': '--ds-background-accent-yellow-subtle',
    'color.background.accent.yellow.subtle.hovered': '--ds-background-accent-yellow-subtle-hovered',
    'color.background.accent.yellow.subtle.pressed': '--ds-background-accent-yellow-subtle-pressed',
    'color.background.accent.yellow.bolder': '--ds-background-accent-yellow-bolder',
    'color.background.accent.yellow.bolder.hovered': '--ds-background-accent-yellow-bolder-hovered',
    'color.background.accent.yellow.bolder.pressed': '--ds-background-accent-yellow-bolder-pressed',
    'color.background.accent.green.subtlest': '--ds-background-accent-green-subtlest',
    'color.background.accent.green.subtlest.hovered': '--ds-background-accent-green-subtlest-hovered',
    'color.background.accent.green.subtlest.pressed': '--ds-background-accent-green-subtlest-pressed',
    'color.background.accent.green.subtler': '--ds-background-accent-green-subtler',
    'color.background.accent.green.subtler.hovered': '--ds-background-accent-green-subtler-hovered',
    'color.background.accent.green.subtler.pressed': '--ds-background-accent-green-subtler-pressed',
    'color.background.accent.green.subtle': '--ds-background-accent-green-subtle',
    'color.background.accent.green.subtle.hovered': '--ds-background-accent-green-subtle-hovered',
    'color.background.accent.green.subtle.pressed': '--ds-background-accent-green-subtle-pressed',
    'color.background.accent.green.bolder': '--ds-background-accent-green-bolder',
    'color.background.accent.green.bolder.hovered': '--ds-background-accent-green-bolder-hovered',
    'color.background.accent.green.bolder.pressed': '--ds-background-accent-green-bolder-pressed',
    'color.background.accent.teal.subtlest': '--ds-background-accent-teal-subtlest',
    'color.background.accent.teal.subtlest.hovered': '--ds-background-accent-teal-subtlest-hovered',
    'color.background.accent.teal.subtlest.pressed': '--ds-background-accent-teal-subtlest-pressed',
    'color.background.accent.teal.subtler': '--ds-background-accent-teal-subtler',
    'color.background.accent.teal.subtler.hovered': '--ds-background-accent-teal-subtler-hovered',
    'color.background.accent.teal.subtler.pressed': '--ds-background-accent-teal-subtler-pressed',
    'color.background.accent.teal.subtle': '--ds-background-accent-teal-subtle',
    'color.background.accent.teal.subtle.hovered': '--ds-background-accent-teal-subtle-hovered',
    'color.background.accent.teal.subtle.pressed': '--ds-background-accent-teal-subtle-pressed',
    'color.background.accent.teal.bolder': '--ds-background-accent-teal-bolder',
    'color.background.accent.teal.bolder.hovered': '--ds-background-accent-teal-bolder-hovered',
    'color.background.accent.teal.bolder.pressed': '--ds-background-accent-teal-bolder-pressed',
    'color.background.accent.blue.subtlest': '--ds-background-accent-blue-subtlest',
    'color.background.accent.blue.subtlest.hovered': '--ds-background-accent-blue-subtlest-hovered',
    'color.background.accent.blue.subtlest.pressed': '--ds-background-accent-blue-subtlest-pressed',
    'color.background.accent.blue.subtler': '--ds-background-accent-blue-subtler',
    'color.background.accent.blue.subtler.hovered': '--ds-background-accent-blue-subtler-hovered',
    'color.background.accent.blue.subtler.pressed': '--ds-background-accent-blue-subtler-pressed',
    'color.background.accent.blue.subtle': '--ds-background-accent-blue-subtle',
    'color.background.accent.blue.subtle.hovered': '--ds-background-accent-blue-subtle-hovered',
    'color.background.accent.blue.subtle.pressed': '--ds-background-accent-blue-subtle-pressed',
    'color.background.accent.blue.bolder': '--ds-background-accent-blue-bolder',
    'color.background.accent.blue.bolder.hovered': '--ds-background-accent-blue-bolder-hovered',
    'color.background.accent.blue.bolder.pressed': '--ds-background-accent-blue-bolder-pressed',
    'color.background.accent.purple.subtlest': '--ds-background-accent-purple-subtlest',
    'color.background.accent.purple.subtlest.hovered': '--ds-background-accent-purple-subtlest-hovered',
    'color.background.accent.purple.subtlest.pressed': '--ds-background-accent-purple-subtlest-pressed',
    'color.background.accent.purple.subtler': '--ds-background-accent-purple-subtler',
    'color.background.accent.purple.subtler.hovered': '--ds-background-accent-purple-subtler-hovered',
    'color.background.accent.purple.subtler.pressed': '--ds-background-accent-purple-subtler-pressed',
    'color.background.accent.purple.subtle': '--ds-background-accent-purple-subtle',
    'color.background.accent.purple.subtle.hovered': '--ds-background-accent-purple-subtle-hovered',
    'color.background.accent.purple.subtle.pressed': '--ds-background-accent-purple-subtle-pressed',
    'color.background.accent.purple.bolder': '--ds-background-accent-purple-bolder',
    'color.background.accent.purple.bolder.hovered': '--ds-background-accent-purple-bolder-hovered',
    'color.background.accent.purple.bolder.pressed': '--ds-background-accent-purple-bolder-pressed',
    'color.background.accent.magenta.subtlest': '--ds-background-accent-magenta-subtlest',
    'color.background.accent.magenta.subtlest.hovered': '--ds-background-accent-magenta-subtlest-hovered',
    'color.background.accent.magenta.subtlest.pressed': '--ds-background-accent-magenta-subtlest-pressed',
    'color.background.accent.magenta.subtler': '--ds-background-accent-magenta-subtler',
    'color.background.accent.magenta.subtler.hovered': '--ds-background-accent-magenta-subtler-hovered',
    'color.background.accent.magenta.subtler.pressed': '--ds-background-accent-magenta-subtler-pressed',
    'color.background.accent.magenta.subtle': '--ds-background-accent-magenta-subtle',
    'color.background.accent.magenta.subtle.hovered': '--ds-background-accent-magenta-subtle-hovered',
    'color.background.accent.magenta.subtle.pressed': '--ds-background-accent-magenta-subtle-pressed',
    'color.background.accent.magenta.bolder': '--ds-background-accent-magenta-bolder',
    'color.background.accent.magenta.bolder.hovered': '--ds-background-accent-magenta-bolder-hovered',
    'color.background.accent.magenta.bolder.pressed': '--ds-background-accent-magenta-bolder-pressed',
    'color.background.accent.gray.subtlest': '--ds-background-accent-gray-subtlest',
    'color.background.accent.gray.subtlest.hovered': '--ds-background-accent-gray-subtlest-hovered',
    'color.background.accent.gray.subtlest.pressed': '--ds-background-accent-gray-subtlest-pressed',
    'color.background.accent.gray.subtler': '--ds-background-accent-gray-subtler',
    'color.background.accent.gray.subtler.hovered': '--ds-background-accent-gray-subtler-hovered',
    'color.background.accent.gray.subtler.pressed': '--ds-background-accent-gray-subtler-pressed',
    'color.background.accent.gray.subtle': '--ds-background-accent-gray-subtle',
    'color.background.accent.gray.subtle.hovered': '--ds-background-accent-gray-subtle-hovered',
    'color.background.accent.gray.subtle.pressed': '--ds-background-accent-gray-subtle-pressed',
    'color.background.accent.gray.bolder': '--ds-background-accent-gray-bolder',
    'color.background.accent.gray.bolder.hovered': '--ds-background-accent-gray-bolder-hovered',
    'color.background.accent.gray.bolder.pressed': '--ds-background-accent-gray-bolder-pressed',
    'color.background.disabled': '--ds-background-disabled',
    'color.background.input': '--ds-background-input',
    'color.background.input.hovered': '--ds-background-input-hovered',
    'color.background.input.pressed': '--ds-background-input-pressed',
    'color.background.inverse.subtle': '--ds-background-inverse-subtle',
    'color.background.inverse.subtle.hovered': '--ds-background-inverse-subtle-hovered',
    'color.background.inverse.subtle.pressed': '--ds-background-inverse-subtle-pressed',
    'color.background.neutral': '--ds-background-neutral',
    'color.background.neutral.hovered': '--ds-background-neutral-hovered',
    'color.background.neutral.pressed': '--ds-background-neutral-pressed',
    'color.background.neutral.subtle': '--ds-background-neutral-subtle',
    'color.background.neutral.subtle.hovered': '--ds-background-neutral-subtle-hovered',
    'color.background.neutral.subtle.pressed': '--ds-background-neutral-subtle-pressed',
    'color.background.neutral.bold': '--ds-background-neutral-bold',
    'color.background.neutral.bold.hovered': '--ds-background-neutral-bold-hovered',
    'color.background.neutral.bold.pressed': '--ds-background-neutral-bold-pressed',
    'color.background.selected': '--ds-background-selected',
    'color.background.selected.hovered': '--ds-background-selected-hovered',
    'color.background.selected.pressed': '--ds-background-selected-pressed',
    'color.background.selected.bold': '--ds-background-selected-bold',
    'color.background.selected.bold.hovered': '--ds-background-selected-bold-hovered',
    'color.background.selected.bold.pressed': '--ds-background-selected-bold-pressed',
    'color.background.brand.subtlest': '--ds-background-brand-subtlest',
    'color.background.brand.subtlest.hovered': '--ds-background-brand-subtlest-hovered',
    'color.background.brand.subtlest.pressed': '--ds-background-brand-subtlest-pressed',
    'color.background.brand.bold': '--ds-background-brand-bold',
    'color.background.brand.bold.hovered': '--ds-background-brand-bold-hovered',
    'color.background.brand.bold.pressed': '--ds-background-brand-bold-pressed',
    'color.background.brand.boldest': '--ds-background-brand-boldest',
    'color.background.brand.boldest.hovered': '--ds-background-brand-boldest-hovered',
    'color.background.brand.boldest.pressed': '--ds-background-brand-boldest-pressed',
    'color.background.danger': '--ds-background-danger',
    'color.background.danger.hovered': '--ds-background-danger-hovered',
    'color.background.danger.pressed': '--ds-background-danger-pressed',
    'color.background.danger.subtler': '--ds-background-danger-subtler',
    'color.background.danger.subtler.hovered': '--ds-background-danger-subtler-hovered',
    'color.background.danger.subtler.pressed': '--ds-background-danger-subtler-pressed',
    'color.background.danger.bold': '--ds-background-danger-bold',
    'color.background.danger.bold.hovered': '--ds-background-danger-bold-hovered',
    'color.background.danger.bold.pressed': '--ds-background-danger-bold-pressed',
    'color.background.warning': '--ds-background-warning',
    'color.background.warning.hovered': '--ds-background-warning-hovered',
    'color.background.warning.pressed': '--ds-background-warning-pressed',
    'color.background.warning.subtler': '--ds-background-warning-subtler',
    'color.background.warning.subtler.hovered': '--ds-background-warning-subtler-hovered',
    'color.background.warning.subtler.pressed': '--ds-background-warning-subtler-pressed',
    'color.background.warning.bold': '--ds-background-warning-bold',
    'color.background.warning.bold.hovered': '--ds-background-warning-bold-hovered',
    'color.background.warning.bold.pressed': '--ds-background-warning-bold-pressed',
    'color.background.success': '--ds-background-success',
    'color.background.success.hovered': '--ds-background-success-hovered',
    'color.background.success.pressed': '--ds-background-success-pressed',
    'color.background.success.subtler': '--ds-background-success-subtler',
    'color.background.success.subtler.hovered': '--ds-background-success-subtler-hovered',
    'color.background.success.subtler.pressed': '--ds-background-success-subtler-pressed',
    'color.background.success.bold': '--ds-background-success-bold',
    'color.background.success.bold.hovered': '--ds-background-success-bold-hovered',
    'color.background.success.bold.pressed': '--ds-background-success-bold-pressed',
    'color.background.discovery': '--ds-background-discovery',
    'color.background.discovery.hovered': '--ds-background-discovery-hovered',
    'color.background.discovery.pressed': '--ds-background-discovery-pressed',
    'color.background.discovery.subtler': '--ds-background-discovery-subtler',
    'color.background.discovery.subtler.hovered': '--ds-background-discovery-subtler-hovered',
    'color.background.discovery.subtler.pressed': '--ds-background-discovery-subtler-pressed',
    'color.background.discovery.bold': '--ds-background-discovery-bold',
    'color.background.discovery.bold.hovered': '--ds-background-discovery-bold-hovered',
    'color.background.discovery.bold.pressed': '--ds-background-discovery-bold-pressed',
    'color.background.information': '--ds-background-information',
    'color.background.information.hovered': '--ds-background-information-hovered',
    'color.background.information.pressed': '--ds-background-information-pressed',
    'color.background.information.subtler': '--ds-background-information-subtler',
    'color.background.information.subtler.hovered': '--ds-background-information-subtler-hovered',
    'color.background.information.subtler.pressed': '--ds-background-information-subtler-pressed',
    'color.background.information.bold': '--ds-background-information-bold',
    'color.background.information.bold.hovered': '--ds-background-information-bold-hovered',
    'color.background.information.bold.pressed': '--ds-background-information-bold-pressed',
    'color.blanket': '--ds-blanket',
    'color.blanket.selected': '--ds-blanket-selected',
    'color.blanket.danger': '--ds-blanket-danger',
    'color.interaction.hovered': '--ds-interaction-hovered',
    'color.interaction.pressed': '--ds-interaction-pressed',
    'color.skeleton': '--ds-skeleton',
    'color.skeleton.subtle': '--ds-skeleton-subtle',
    'color.chart.categorical.1': '--ds-chart-categorical-1',
    'color.chart.categorical.1.hovered': '--ds-chart-categorical-1-hovered',
    'color.chart.categorical.2': '--ds-chart-categorical-2',
    'color.chart.categorical.2.hovered': '--ds-chart-categorical-2-hovered',
    'color.chart.categorical.3': '--ds-chart-categorical-3',
    'color.chart.categorical.3.hovered': '--ds-chart-categorical-3-hovered',
    'color.chart.categorical.4': '--ds-chart-categorical-4',
    'color.chart.categorical.4.hovered': '--ds-chart-categorical-4-hovered',
    'color.chart.categorical.5': '--ds-chart-categorical-5',
    'color.chart.categorical.5.hovered': '--ds-chart-categorical-5-hovered',
    'color.chart.categorical.6': '--ds-chart-categorical-6',
    'color.chart.categorical.6.hovered': '--ds-chart-categorical-6-hovered',
    'color.chart.categorical.7': '--ds-chart-categorical-7',
    'color.chart.categorical.7.hovered': '--ds-chart-categorical-7-hovered',
    'color.chart.categorical.8': '--ds-chart-categorical-8',
    'color.chart.categorical.8.hovered': '--ds-chart-categorical-8-hovered',
    'color.chart.lime.bold': '--ds-chart-lime-bold',
    'color.chart.lime.bold.hovered': '--ds-chart-lime-bold-hovered',
    'color.chart.lime.bolder': '--ds-chart-lime-bolder',
    'color.chart.lime.bolder.hovered': '--ds-chart-lime-bolder-hovered',
    'color.chart.lime.boldest': '--ds-chart-lime-boldest',
    'color.chart.lime.boldest.hovered': '--ds-chart-lime-boldest-hovered',
    'color.chart.neutral': '--ds-chart-neutral',
    'color.chart.neutral.hovered': '--ds-chart-neutral-hovered',
    'color.chart.red.bold': '--ds-chart-red-bold',
    'color.chart.red.bold.hovered': '--ds-chart-red-bold-hovered',
    'color.chart.red.bolder': '--ds-chart-red-bolder',
    'color.chart.red.bolder.hovered': '--ds-chart-red-bolder-hovered',
    'color.chart.red.boldest': '--ds-chart-red-boldest',
    'color.chart.red.boldest.hovered': '--ds-chart-red-boldest-hovered',
    'color.chart.orange.bold': '--ds-chart-orange-bold',
    'color.chart.orange.bold.hovered': '--ds-chart-orange-bold-hovered',
    'color.chart.orange.bolder': '--ds-chart-orange-bolder',
    'color.chart.orange.bolder.hovered': '--ds-chart-orange-bolder-hovered',
    'color.chart.orange.boldest': '--ds-chart-orange-boldest',
    'color.chart.orange.boldest.hovered': '--ds-chart-orange-boldest-hovered',
    'color.chart.yellow.bold': '--ds-chart-yellow-bold',
    'color.chart.yellow.bold.hovered': '--ds-chart-yellow-bold-hovered',
    'color.chart.yellow.bolder': '--ds-chart-yellow-bolder',
    'color.chart.yellow.bolder.hovered': '--ds-chart-yellow-bolder-hovered',
    'color.chart.yellow.boldest': '--ds-chart-yellow-boldest',
    'color.chart.yellow.boldest.hovered': '--ds-chart-yellow-boldest-hovered',
    'color.chart.green.bold': '--ds-chart-green-bold',
    'color.chart.green.bold.hovered': '--ds-chart-green-bold-hovered',
    'color.chart.green.bolder': '--ds-chart-green-bolder',
    'color.chart.green.bolder.hovered': '--ds-chart-green-bolder-hovered',
    'color.chart.green.boldest': '--ds-chart-green-boldest',
    'color.chart.green.boldest.hovered': '--ds-chart-green-boldest-hovered',
    'color.chart.teal.bold': '--ds-chart-teal-bold',
    'color.chart.teal.bold.hovered': '--ds-chart-teal-bold-hovered',
    'color.chart.teal.bolder': '--ds-chart-teal-bolder',
    'color.chart.teal.bolder.hovered': '--ds-chart-teal-bolder-hovered',
    'color.chart.teal.boldest': '--ds-chart-teal-boldest',
    'color.chart.teal.boldest.hovered': '--ds-chart-teal-boldest-hovered',
    'color.chart.blue.bold': '--ds-chart-blue-bold',
    'color.chart.blue.bold.hovered': '--ds-chart-blue-bold-hovered',
    'color.chart.blue.bolder': '--ds-chart-blue-bolder',
    'color.chart.blue.bolder.hovered': '--ds-chart-blue-bolder-hovered',
    'color.chart.blue.boldest': '--ds-chart-blue-boldest',
    'color.chart.blue.boldest.hovered': '--ds-chart-blue-boldest-hovered',
    'color.chart.purple.bold': '--ds-chart-purple-bold',
    'color.chart.purple.bold.hovered': '--ds-chart-purple-bold-hovered',
    'color.chart.purple.bolder': '--ds-chart-purple-bolder',
    'color.chart.purple.bolder.hovered': '--ds-chart-purple-bolder-hovered',
    'color.chart.purple.boldest': '--ds-chart-purple-boldest',
    'color.chart.purple.boldest.hovered': '--ds-chart-purple-boldest-hovered',
    'color.chart.magenta.bold': '--ds-chart-magenta-bold',
    'color.chart.magenta.bold.hovered': '--ds-chart-magenta-bold-hovered',
    'color.chart.magenta.bolder': '--ds-chart-magenta-bolder',
    'color.chart.magenta.bolder.hovered': '--ds-chart-magenta-bolder-hovered',
    'color.chart.magenta.boldest': '--ds-chart-magenta-boldest',
    'color.chart.magenta.boldest.hovered': '--ds-chart-magenta-boldest-hovered',
    'color.chart.gray.bold': '--ds-chart-gray-bold',
    'color.chart.gray.bold.hovered': '--ds-chart-gray-bold-hovered',
    'color.chart.gray.bolder': '--ds-chart-gray-bolder',
    'color.chart.gray.bolder.hovered': '--ds-chart-gray-bolder-hovered',
    'color.chart.gray.boldest': '--ds-chart-gray-boldest',
    'color.chart.gray.boldest.hovered': '--ds-chart-gray-boldest-hovered',
    'color.chart.brand': '--ds-chart-brand',
    'color.chart.brand.hovered': '--ds-chart-brand-hovered',
    'color.chart.danger': '--ds-chart-danger',
    'color.chart.danger.hovered': '--ds-chart-danger-hovered',
    'color.chart.danger.bold': '--ds-chart-danger-bold',
    'color.chart.danger.bold.hovered': '--ds-chart-danger-bold-hovered',
    'color.chart.warning': '--ds-chart-warning',
    'color.chart.warning.hovered': '--ds-chart-warning-hovered',
    'color.chart.warning.bold': '--ds-chart-warning-bold',
    'color.chart.warning.bold.hovered': '--ds-chart-warning-bold-hovered',
    'color.chart.success': '--ds-chart-success',
    'color.chart.success.hovered': '--ds-chart-success-hovered',
    'color.chart.success.bold': '--ds-chart-success-bold',
    'color.chart.success.bold.hovered': '--ds-chart-success-bold-hovered',
    'color.chart.discovery': '--ds-chart-discovery',
    'color.chart.discovery.hovered': '--ds-chart-discovery-hovered',
    'color.chart.discovery.bold': '--ds-chart-discovery-bold',
    'color.chart.discovery.bold.hovered': '--ds-chart-discovery-bold-hovered',
    'color.chart.information': '--ds-chart-information',
    'color.chart.information.hovered': '--ds-chart-information-hovered',
    'color.chart.information.bold': '--ds-chart-information-bold',
    'color.chart.information.bold.hovered': '--ds-chart-information-bold-hovered',
    'elevation.surface': '--ds-surface',
    'elevation.surface.hovered': '--ds-surface-hovered',
    'elevation.surface.pressed': '--ds-surface-pressed',
    'elevation.surface.overlay': '--ds-surface-overlay',
    'elevation.surface.overlay.hovered': '--ds-surface-overlay-hovered',
    'elevation.surface.overlay.pressed': '--ds-surface-overlay-pressed',
    'elevation.surface.raised': '--ds-surface-raised',
    'elevation.surface.raised.hovered': '--ds-surface-raised-hovered',
    'elevation.surface.raised.pressed': '--ds-surface-raised-pressed',
    'elevation.surface.sunken': '--ds-surface-sunken',
    'elevation.shadow.overflow': '--ds-shadow-overflow',
    'elevation.shadow.overflow.perimeter': '--ds-shadow-overflow-perimeter',
    'elevation.shadow.overflow.spread': '--ds-shadow-overflow-spread',
    'elevation.shadow.overlay': '--ds-shadow-overlay',
    'elevation.shadow.raised': '--ds-shadow-raised',
    'opacity.disabled': '--ds-opacity-disabled',
    'opacity.loading': '--ds-opacity-loading',
    'utility.UNSAFE.transparent': '--ds-UNSAFE-transparent',
    'utility.elevation.surface.current': '--ds-elevation-surface-current',
    'space.0': '--ds-space-0',
    'space.025': '--ds-space-025',
    'space.050': '--ds-space-050',
    'space.075': '--ds-space-075',
    'space.100': '--ds-space-100',
    'space.150': '--ds-space-150',
    'space.200': '--ds-space-200',
    'space.250': '--ds-space-250',
    'space.300': '--ds-space-300',
    'space.400': '--ds-space-400',
    'space.500': '--ds-space-500',
    'space.600': '--ds-space-600',
    'space.800': '--ds-space-800',
    'space.1000': '--ds-space-1000',
    'space.negative.025': '--ds-space-negative-025',
    'space.negative.050': '--ds-space-negative-050',
    'space.negative.075': '--ds-space-negative-075',
    'space.negative.100': '--ds-space-negative-100',
    'space.negative.150': '--ds-space-negative-150',
    'space.negative.200': '--ds-space-negative-200',
    'space.negative.250': '--ds-space-negative-250',
    'space.negative.300': '--ds-space-negative-300',
    'space.negative.400': '--ds-space-negative-400',
    'font.heading.xxlarge': '--ds-font-heading-xxlarge',
    'font.heading.xlarge': '--ds-font-heading-xlarge',
    'font.heading.large': '--ds-font-heading-large',
    'font.heading.medium': '--ds-font-heading-medium',
    'font.heading.small': '--ds-font-heading-small',
    'font.heading.xsmall': '--ds-font-heading-xsmall',
    'font.heading.xxsmall': '--ds-font-heading-xxsmall',
    'font.body.large': '--ds-font-body-large',
    'font.body': '--ds-font-body',
    'font.body.small': '--ds-font-body-small',
    'font.metric.large': '--ds-font-metric-large',
    'font.metric.medium': '--ds-font-metric-medium',
    'font.metric.small': '--ds-font-metric-small',
    'font.code': '--ds-font-code',
    'font.weight.regular': '--ds-font-weight-regular',
    'font.weight.medium': '--ds-font-weight-medium',
    'font.weight.semibold': '--ds-font-weight-semibold',
    'font.weight.bold': '--ds-font-weight-bold',
    'font.family.heading': '--ds-font-family-heading',
    'font.family.body': '--ds-font-family-body',
    'font.family.code': '--ds-font-family-code',
    'font.family.brand.heading': '--ds-font-family-brand-heading',
    'font.family.brand.body': '--ds-font-family-brand-body',
    'radius.xsmall': '--ds-radius-xsmall',
    'radius.small': '--ds-radius-small',
    'radius.medium': '--ds-radius-medium',
    'radius.large': '--ds-radius-large',
    'radius.xlarge': '--ds-radius-xlarge',
    'radius.xxlarge': '--ds-radius-xxlarge',
    'radius.full': '--ds-radius-full',
    'radius.tile': '--ds-radius-tile',
    'border.width': '--ds-border-width',
    'border.width.selected': '--ds-border-width-selected',
    'border.width.focused': '--ds-border-width-focused'
};
var $b559cd876c1743ed$export$2e2bcd8739ae039 = $b559cd876c1743ed$var$tokens;

});


parcelRegister("6raEH", function(module, exports) {
$parcel$export(module.exports, "getThemePreferences", () => $05a150faab16ea39$export$dd6aeb7c823fc03d);
$parcel$export(module.exports, "getThemeOverridePreferences", () => $05a150faab16ea39$export$5d76d7014f4a5d08);

var $3X3Vo = parcelRequire("3X3Vo");

var $axjZ2 = parcelRequire("axjZ2");
const $05a150faab16ea39$export$dd6aeb7c823fc03d = (themeState)=>{
    const { colorMode: colorMode, contrastMode: contrastMode, dark: dark, light: light, shape: shape, spacing: spacing, typography: typography, motion: motion } = themeState;
    const autoColorModeThemes = [
        light,
        dark
    ];
    const themePreferences = [];
    if (colorMode === 'auto') {
        if (contrastMode !== 'no-preference' && (0, $3X3Vo.fg)('platform_increased-contrast-themes')) autoColorModeThemes.forEach((normalTheme)=>{
            const increasedContrastTheme = (0, $axjZ2.default)(normalTheme);
            if (increasedContrastTheme) autoColorModeThemes.push(increasedContrastTheme);
        });
        themePreferences.push(...autoColorModeThemes);
    } else {
        themePreferences.push(themeState[colorMode]);
        if (contrastMode !== 'no-preference' && (0, $3X3Vo.fg)('platform_increased-contrast-themes')) {
            const increasedContrastTheme = (0, $axjZ2.default)(themeState[colorMode]);
            if (increasedContrastTheme) themePreferences.push(increasedContrastTheme);
        }
    }
    [
        shape,
        spacing,
        typography,
        motion
    ].forEach((themeId)=>{
        if (themeId) themePreferences.push(themeId);
    });
    return [
        ...new Set(themePreferences)
    ];
};
const $05a150faab16ea39$export$5d76d7014f4a5d08 = (_themeState)=>{
    const themeOverridePreferences = [];
    return [
        ...new Set(themeOverridePreferences)
    ];
};

});
parcelRegister("axjZ2", function(module, exports) {
$parcel$export(module.exports, "default", () => $6f4c109dce76ce83$export$2e2bcd8739ae039);

var $9KKWI = parcelRequire("9KKWI");
function $6f4c109dce76ce83$export$2e2bcd8739ae039(themeId) {
    return Object.entries((0, $9KKWI.default)).find(([, { increasesContrastFor: increasesContrastFor }])=>{
        return increasesContrastFor === themeId;
    })?.[1].id;
}

});


parcelRegister("8Gi5d", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("8udjg").then(()=>parcelRequire('8Z1Wd'));

});





parcelRegister("jqltP", function(module, exports) {
$parcel$export(module.exports, "Profile", () => $22f25ba18ab8de37$export$5120f2d0b8d4cab8);

var $6jDHc = parcelRequire("6jDHc");

var $4tluv = parcelRequire("4tluv");

var $lIP59 = parcelRequire("lIP59");

var $kbKpL = parcelRequire("kbKpL");
var $hT0yS = parcelRequire("hT0yS");
var $kfPot = parcelRequire("kfPot");

var $2ICGb = parcelRequire("2ICGb");
var $jdECH = parcelRequire("jdECH");

var $lndDO = parcelRequire("lndDO");

var $2HNL3 = parcelRequire("2HNL3");
parcelRequire("3mxm3");
var $bfivG = parcelRequire("bfivG");

var $lsxLV = parcelRequire("lsxLV");

var $dX6kP = parcelRequire("dX6kP");

var $kA1Vr = parcelRequire("kA1Vr");
parcelRequire("iuDZJ");
var $dqHaj = parcelRequire("dqHaj");

var $9ALFH = parcelRequire("9ALFH");

var $5DgeC = parcelRequire("5DgeC");

var $3yHBw = parcelRequire("3yHBw");

var $jPKf9 = parcelRequire("jPKf9");

var $fgIUF = parcelRequire("fgIUF");
parcelRequire("atGCc");
var $8VUj0 = parcelRequire("8VUj0");
const $22f25ba18ab8de37$var$blockStyles = (0, $kfPot.xcss)({
    borderRadius: "radius.xsmall"
});
const $22f25ba18ab8de37$var$profileContainerStyles = (0, $kfPot.xcss)({
    cursor: "pointer"
});
const $22f25ba18ab8de37$export$5120f2d0b8d4cab8 = ({ userAccount: userAccount, site: site, showWhatsNewButton: showWhatsNewButton })=>{
    const currentScreenName = (0, $jPKf9.useCurrentScreenName)();
    const rovoLogoutUrl = `${(0, $dqHaj.getRovoExtensionWebBaseUrl)()}/extension/log-out`;
    const LAST_SEEN_ID = "lastSeenAnnouncementId";
    const navigate = (0, $bfivG.useNavigate)();
    const { localThemeColorMode: localThemeColorMode, setLocalThemeColorMode: setLocalThemeColorMode } = (0, $kA1Vr.useThemeContext)();
    const sendAnalyticEvent = (0, $dX6kP.useSendAnalyticEvent)();
    const [isFeedbackModalOpen, setIsFeedbackModalOpen] = (0, $4tluv.useState)(false);
    const showFeedbackButton = userAccount.accountId && site;
    const handleFeedbackClick = ()=>{
        setIsFeedbackModalOpen(true);
        // https://data-portal.internal.atlassian.com/analytics/registry/73849
        sendAnalyticEvent({
            eventType: "ui",
            event: {
                action: "click",
                actionSubject: (0, $lsxLV.ANALYTICS_UI_SUBJECTS).FEEDBACK_BUTTON,
                source: currentScreenName
            },
            userId: userAccount.accountId
        });
    };
    const handleWhatsNewClick = ()=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/77235
        sendAnalyticEvent({
            eventType: "ui",
            event: {
                action: "click",
                source: currentScreenName,
                actionSubject: (0, $lsxLV.ANALYTICS_UI_SUBJECTS).OPEN_MENU_TAB_BUTTON
            },
            userId: userAccount.accountId
        });
        if ((0, $9ALFH.announcements).length > 0) (0, $fgIUF.setLocalStorageItemRawString)(LAST_SEEN_ID, (0, $9ALFH.announcements)[0].id);
        // https://data-portal.internal.atlassian.com/analytics/registry/79796
        sendAnalyticEvent({
            eventType: "track",
            event: {
                action: "navigate",
                actionSubject: (0, $lsxLV.ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS).WHATS_NEW,
                source: currentScreenName
            },
            userId: userAccount.accountId
        });
        navigate("/extension/menu");
    };
    const profileUrl = site ? `${(0, $dqHaj.getAtlassianHomeUrl)()}/o/${site.workspace.organisationId}/people/${userAccount.accountId}?cloudId=${site.workspace.cloudId}` : `${(0, $dqHaj.getAtlassianHomeUrl)()}/people/me`;
    const handleViewProfileClick = (event)=>{
        // The default behavior will load the profile page as an iframe, which we want to avoid.
        event.preventDefault();
        window.open(profileUrl, "_blank");
    };
    const handleThemeChange = (theme)=>{
        setLocalThemeColorMode(theme);
        // https://data-portal.internal.atlassian.com/analytics/registry/86671
        sendAnalyticEvent({
            eventType: "track",
            event: {
                action: "switched",
                actionSubject: (0, $lsxLV.ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS).THEME,
                source: currentScreenName
            },
            userId: userAccount.accountId
        });
    };
    const extraMenuItems = [
        showWhatsNewButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $2ICGb.default), {
            key: "whats-new",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lndDO))), {
                label: "Menu"
            }),
            onClick: handleWhatsNewClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $lIP59.default), (0, $5DgeC.messages).whatsNew)),
        showFeedbackButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $2ICGb.default), {
            key: "give-feedback",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2HNL3))), {
                label: "feedback"
            }),
            onClick: handleFeedbackClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $lIP59.default), (0, $5DgeC.messages).giveFeedback))
    ].filter(Boolean);
    const finalMenuItems = extraMenuItems.length > 0 ? [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $jdECH.default), {
            key: "extra-menu-items",
            hasSeparator: true
        }, extraMenuItems)
    ] : [];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $8VUj0.SessionReplayUGC), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $kbKpL.default), {
        testId: "profile-container",
        xcss: $22f25ba18ab8de37$var$blockStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $hT0yS.default), {
        alignInline: "end",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $kbKpL.default), {
        xcss: $22f25ba18ab8de37$var$profileContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $6jDHc.AccountMenuNav3), {
        currentTheme: localThemeColorMode,
        email: userAccount.email,
        extraMenuItems: finalMenuItems,
        logOutLink: rovoLogoutUrl,
        name: userAccount.name,
        onThemeChange: handleThemeChange,
        onViewProfileClick: handleViewProfileClick,
        picture: userAccount.picture,
        testId: "account-menu",
        viewProfileLink: profileUrl
    }))))), showFeedbackButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $3yHBw.default), {
        setShowModal: (showModal)=>setIsFeedbackModalOpen(showModal),
        showModal: isFeedbackModalOpen,
        site: site,
        userAccount: userAccount
    }));
};

});
parcelRegister("6jDHc", function(module, exports) {
$parcel$export(module.exports, "AccountMenuNav3", () => $e5831d8516280fad$export$4ff56e5cf713dc64);

var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $dvRHa = parcelRequire("dvRHa");

var $488Th = parcelRequire("488Th");

var $2dkkV = parcelRequire("2dkkV");
const $e5831d8516280fad$export$4ff56e5cf713dc64 = (props)=>{
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $2dkkV.AccountMenu), {
        ...props,
        AccountMenuLoggedOutState: (0, $dvRHa.AccountMenuLoggedOutStateNav3),
        AccountMenuTrigger: (0, $488Th.AccountMenuTriggerNav3)
    });
};

});
parcelRegister("dvRHa", function(module, exports) {
$parcel$export(module.exports, "AccountMenuLoggedOutStateNav3", () => $d862257b09eabc79$export$5e6158d2118ae4aa);

var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $7AQ8L = parcelRequire("7AQ8L");

var $6UA3t = parcelRequire("6UA3t");

var $5aeBt = parcelRequire("5aeBt");

var $grmgp = parcelRequire("grmgp");
const $d862257b09eabc79$export$5e6158d2118ae4aa = ({ testId: testId, logInLink: logInLink })=>/*#__PURE__*/ (0, $2iln5.jsx)((0, $7AQ8L.Profile), {
        testId: testId,
        href: logInLink,
        onClick: (event, analytics)=>{
            analytics.update({
                actionSubjectId: 'logInLink'
            }).fire((0, $5aeBt.NAVIGATION_CHANNEL));
        },
        tooltip: (0, $grmgp.logInTooltip),
        icon: /*#__PURE__*/ (0, $2iln5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6UA3t))), {
            color: "currentColor",
            label: ""
        })
    });

});
parcelRegister("6UA3t", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::af5bdeaecdb0e37d55178bb1e6c281ad>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $014c735e2ad53ec8$var$_react = $014c735e2ad53ec8$var$_interopRequireDefault((parcelRequire("4tluv")));

var $014c735e2ad53ec8$var$_baseNew = $014c735e2ad53ec8$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $014c735e2ad53ec8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LogIn".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for log in.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $014c735e2ad53ec8$var$LogInIcon = (props)=>/*#__PURE__*/ $014c735e2ad53ec8$var$_react.default.createElement($014c735e2ad53ec8$var$_baseNew.default, Object.assign({
        name: "LogInIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13 2.5H8V1h5a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H8v-1.5h5a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5M7.44 7.25 5.22 5.03l1.06-1.06 3.5 3.5a.75.75 0 0 1 0 1.06l-3.5 3.5-1.06-1.06 2.22-2.22H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$014c735e2ad53ec8$var$LogInIcon.displayName = 'LogInIcon';
var $014c735e2ad53ec8$var$_default = module.exports.default = $014c735e2ad53ec8$var$LogInIcon;

});
parcelRegister("7KZ3Q", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("9ib1m")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("9ib1m")).Icon);

var $9ib1m = parcelRequire("9ib1m");

});
parcelRegister("9ib1m", function(module, exports) {
$parcel$export(module.exports, "Icon", () => $784e77453c36f746$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $784e77453c36f746$export$2e2bcd8739ae039);
/* icon-new.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $jAkMr = parcelRequire("jAkMr");
const $784e77453c36f746$var$svgStyles = null;
const $784e77453c36f746$var$iconStyles = null;
const $784e77453c36f746$var$smallIconStyles = null;
const $784e77453c36f746$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ const $784e77453c36f746$var$baseHcmStyles = null;
const $784e77453c36f746$var$scaleSize = null;
const $784e77453c36f746$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
const $784e77453c36f746$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
const $784e77453c36f746$var$paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
};
const $784e77453c36f746$export$f04a61298a47a40f = /*#__PURE__*/ (0, $4tluv.memo)(function Icon(props) {
    const { color: color = 'currentColor', testId: testId, label: label, dangerouslySetGlyph: // Used to set icon dimensions/behaviour in codegen
    // Used to set icon glyphs in codegen
    dangerouslySetGlyph, shouldScale: // Used with iconTile to scale icon up and down
    shouldScale, spacing: spacing = 'none', name: name } = props;
    const dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    let size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            const newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    const baseSize = 16;
    const viewBoxPadding = $784e77453c36f746$var$paddingMap[size][spacing];
    const viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ (0, $2iln5.jsx)("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $jAkMr.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            size === 'small' && "_vwz4utpp"
        ]),
        children: /*#__PURE__*/ (0, $2iln5.jsx)("svg", {
            fill: "none",
            // Adjusting the viewBox allows the icon padding to scale with the contents of the SVG, which
            // we want for Icon Tile
            viewBox: `${0 - viewBoxPadding} ${0 - viewBoxPadding} ${viewBoxSize} ${viewBoxSize}`,
            role: "presentation",
            dangerouslySetInnerHTML: dangerouslySetInnerHTML,
            className: (0, $jAkMr.default)([
                "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
                shouldScale ? "_1bsb1kw7 _4t3i1kw7" : size === 'small' ? $784e77453c36f746$var$coreSizeSmall[spacing] : $784e77453c36f746$var$coreSizeMedium[spacing]
            ])
        })
    });
});
var $784e77453c36f746$export$2e2bcd8739ae039 = $784e77453c36f746$export$f04a61298a47a40f;

});



parcelRegister("5aeBt", function(module, exports) {
$parcel$export(module.exports, "NAVIGATION_CHANNEL", () => $86773363c2bbeed8$export$515664faa1398f37);
$parcel$export(module.exports, "ANALYTICS_CONTEXT", () => $86773363c2bbeed8$export$3cbe56a0cabcff38);
const $86773363c2bbeed8$export$515664faa1398f37 = 'navigation';
const $86773363c2bbeed8$export$3cbe56a0cabcff38 = {
    source: 'atlassianAccountMenu',
    componentName: 'atlassianAccountMenu',
    packageName: undefined,
    packageVersion: undefined
};

});

parcelRegister("grmgp", function(module, exports) {
$parcel$export(module.exports, "logInTooltip", () => $61ed83424bc7d202$export$b495e6c63a3a03c1);

var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $9KeuJ = parcelRequire("9KeuJ");
const $61ed83424bc7d202$export$b495e6c63a3a03c1 = /*#__PURE__*/ (0, $2iln5.jsx)((0, $9KeuJ.default), {
    id: "identity.account-menu.account-menu-logged-out-state.log-in",
    defaultMessage: "Log in",
    description: "Tooltip for log in button when user is logged out"
});

});
parcelRegister("9KeuJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $7183a7417fd68607$export$2e2bcd8739ae039);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $fvB0y = parcelRequire("fvB0y");

var $4tluv = parcelRequire("4tluv");

var $7Yd05 = parcelRequire("7Yd05");

var $8N0QD = parcelRequire("8N0QD");
function $7183a7417fd68607$var$areEqual(prevProps, nextProps) {
    var values = prevProps.values, otherProps = (0, $fvB0y.__rest)(prevProps, [
        "values"
    ]);
    var nextValues = nextProps.values, nextOtherProps = (0, $fvB0y.__rest)(nextProps, [
        "values"
    ]);
    return (0, $7Yd05.shallowEqual)(nextValues, values) && (0, $7Yd05.shallowEqual)(otherProps, nextOtherProps);
}
function $7183a7417fd68607$var$FormattedMessage(props) {
    var intl = (0, $8N0QD.default)();
    var formatMessage = intl.formatMessage, _a = intl.textComponent, Text = _a === void 0 ? $4tluv.Fragment : _a;
    var id = props.id, description = props.description, defaultMessage = props.defaultMessage, values = props.values, children = props.children, _b = props.tagName, Component = _b === void 0 ? Text : _b, ignoreTag = props.ignoreTag;
    var descriptor = {
        id: id,
        description: description,
        defaultMessage: defaultMessage
    };
    var nodes = formatMessage(descriptor, values, {
        ignoreTag: ignoreTag
    });
    if (typeof children === 'function') return children(Array.isArray(nodes) ? nodes : [
        nodes
    ]);
    if (Component) return $4tluv.createElement(Component, null, $4tluv.Children.toArray(nodes));
    return $4tluv.createElement($4tluv.Fragment, null, nodes);
}
$7183a7417fd68607$var$FormattedMessage.displayName = 'FormattedMessage';
var $7183a7417fd68607$var$MemoizedFormattedMessage = $4tluv.memo($7183a7417fd68607$var$FormattedMessage, $7183a7417fd68607$var$areEqual);
$7183a7417fd68607$var$MemoizedFormattedMessage.displayName = 'MemoizedFormattedMessage';
var $7183a7417fd68607$export$2e2bcd8739ae039 = $7183a7417fd68607$var$MemoizedFormattedMessage;

});
parcelRegister("7Yd05", function(module, exports) {
$parcel$export(module.exports, "invariantIntlContext", () => $5cd8389ecfca47e5$export$45c4bbf6e55bba1f);
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", () => $5cd8389ecfca47e5$export$b52f8d6fc0d47415);
$parcel$export(module.exports, "assignUniqueKeysToParts", () => $5cd8389ecfca47e5$export$cfec03d26465fa63);
$parcel$export(module.exports, "shallowEqual", () => $5cd8389ecfca47e5$export$d36bdfa510afb180);

var $fvB0y = parcelRequire("fvB0y");

var $4tluv = parcelRequire("4tluv");

var $dZcBX = parcelRequire("dZcBX");

var $llr7m = parcelRequire("llr7m");
function $5cd8389ecfca47e5$export$45c4bbf6e55bba1f(intl) {
    (0, $dZcBX.invariant)(intl, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
var $5cd8389ecfca47e5$export$b52f8d6fc0d47415 = (0, $fvB0y.__assign)((0, $fvB0y.__assign)({}, (0, $llr7m.DEFAULT_INTL_CONFIG)), {
    textComponent: $4tluv.Fragment
});
function $5cd8389ecfca47e5$export$cfec03d26465fa63(formatXMLElementFn) {
    return function(parts) {
        // eslint-disable-next-line prefer-rest-params
        return formatXMLElementFn($4tluv.Children.toArray(parts));
    };
}
function $5cd8389ecfca47e5$export$d36bdfa510afb180(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(var i = 0; i < len; i++){
        var key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}

});
parcelRegister("dZcBX", function(module, exports) {
$parcel$export(module.exports, "invariant", () => $a2eac12c03431a97$export$f5708dca728d7177);

var $fvB0y = parcelRequire("fvB0y");

var $i32L6 = parcelRequire("i32L6");
function $a2eac12c03431a97$export$f535bb00660c42db(x) {
    // Cannot count string length via Number.toString because it may use scientific notation
    // for very small or very large numbers.
    return Math.floor(Math.log(x) * Math.LOG10E);
}
function $a2eac12c03431a97$export$76d90c956114f2c2(s, times) {
    if (typeof s.repeat === 'function') return s.repeat(times);
    var arr = new Array(times);
    for(var i = 0; i < arr.length; i++)arr[i] = s;
    return arr.join('');
}
function $a2eac12c03431a97$export$489176b9ebc725cc(map, pl, field, value) {
    if (!map.get(pl)) map.set(pl, Object.create(null));
    var slots = map.get(pl);
    slots[field] = value;
}
function $a2eac12c03431a97$export$d21499e79b5c28e2(map, pl, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var k = _a[_i];
        $a2eac12c03431a97$export$489176b9ebc725cc(map, pl, k, props[k]);
    }
}
function $a2eac12c03431a97$export$3fae2929ed23c202(map, pl, field) {
    return $a2eac12c03431a97$export$ca4e2274c058dd9f(map, pl, field)[field];
}
function $a2eac12c03431a97$export$ca4e2274c058dd9f(map, pl) {
    var fields = [];
    for(var _i = 2; _i < arguments.length; _i++)fields[_i - 2] = arguments[_i];
    var slots = map.get(pl);
    if (!slots) throw new TypeError("".concat(pl, " InternalSlot has not been initialized"));
    return fields.reduce(function(all, f) {
        all[f] = slots[f];
        return all;
    }, Object.create(null));
}
function $a2eac12c03431a97$export$25c75e09b890f24e(patternPart) {
    return patternPart.type === 'literal';
}
function $a2eac12c03431a97$export$fdab3c20aae16ddf(target, name, _a) {
    var value = _a.value;
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: false,
        writable: true,
        value: value
    });
}
function $a2eac12c03431a97$export$e4e12d57dd938668(target, name, value) {
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: true,
        writable: true,
        value: value
    });
}
var $a2eac12c03431a97$export$9049a02e759202e4 = /-u(?:-[0-9a-z]{2,8})+/gi;
function $a2eac12c03431a97$export$f5708dca728d7177(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}
var $a2eac12c03431a97$export$a99e4aaac79eeead = (0, $i32L6.memoize)(function() {
    var _a;
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $fvB0y.__spreadArray)([
        void 0
    ], args, false)))();
}, {
    strategy: (0, $i32L6.strategies).variadic
});
var $a2eac12c03431a97$export$b479a1a2d8754359 = (0, $i32L6.memoize)(function() {
    var _a;
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $fvB0y.__spreadArray)([
        void 0
    ], args, false)))();
}, {
    strategy: (0, $i32L6.strategies).variadic
});
var $a2eac12c03431a97$export$569bb3095db8432e = (0, $i32L6.memoize)(function() {
    var _a;
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $fvB0y.__spreadArray)([
        void 0
    ], args, false)))();
}, {
    strategy: (0, $i32L6.strategies).variadic
});
var $a2eac12c03431a97$export$e124bc7d23dd0e5a = (0, $i32L6.memoize)(function() {
    var _a;
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return new ((_a = Intl.Locale).bind.apply(_a, (0, $fvB0y.__spreadArray)([
        void 0
    ], args, false)))();
}, {
    strategy: (0, $i32L6.strategies).variadic
});
var $a2eac12c03431a97$export$a1209f8c6068edc3 = (0, $i32L6.memoize)(function() {
    var _a;
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return new ((_a = Intl.ListFormat).bind.apply(_a, (0, $fvB0y.__spreadArray)([
        void 0
    ], args, false)))();
}, {
    strategy: (0, $i32L6.strategies).variadic
});

});
parcelRegister("i32L6", function(module, exports) {
$parcel$export(module.exports, "memoize", () => $d23aa59fd72800dc$export$fc10aeed3a532e2a);
$parcel$export(module.exports, "strategies", () => $d23aa59fd72800dc$export$c5491a8691a23b9e);
//
// Main
//
function $d23aa59fd72800dc$export$fc10aeed3a532e2a(fn, options) {
    var cache = options && options.cache ? options.cache : $d23aa59fd72800dc$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $d23aa59fd72800dc$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $d23aa59fd72800dc$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $d23aa59fd72800dc$var$isPrimitive(value) {
    return value == null || typeof value === 'number' || typeof value === 'boolean'; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $d23aa59fd72800dc$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $d23aa59fd72800dc$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $d23aa59fd72800dc$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $d23aa59fd72800dc$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $d23aa59fd72800dc$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $d23aa59fd72800dc$var$monadic : $d23aa59fd72800dc$var$variadic;
    return $d23aa59fd72800dc$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $d23aa59fd72800dc$var$strategyVariadic(fn, options) {
    return $d23aa59fd72800dc$var$assemble(fn, this, $d23aa59fd72800dc$var$variadic, options.cache.create(), options.serializer);
}
function $d23aa59fd72800dc$var$strategyMonadic(fn, options) {
    return $d23aa59fd72800dc$var$assemble(fn, this, $d23aa59fd72800dc$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $d23aa59fd72800dc$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
function $d23aa59fd72800dc$var$ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
$d23aa59fd72800dc$var$ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
$d23aa59fd72800dc$var$ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var $d23aa59fd72800dc$var$cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new $d23aa59fd72800dc$var$ObjectWithoutPrototypeCache();
    }
};
var $d23aa59fd72800dc$export$c5491a8691a23b9e = {
    variadic: $d23aa59fd72800dc$var$strategyVariadic,
    monadic: $d23aa59fd72800dc$var$strategyMonadic
};

});


parcelRegister("llr7m", function(module, exports) {
$parcel$export(module.exports, "filterProps", () => $04029719753624c5$export$d697c39a2985a4c);
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", () => $04029719753624c5$export$b52f8d6fc0d47415);
$parcel$export(module.exports, "createIntlCache", () => $04029719753624c5$export$51c4f4e973f2dc00);
$parcel$export(module.exports, "createFormatters", () => $04029719753624c5$export$c3f4cd5551df13fd);
$parcel$export(module.exports, "getNamedFormat", () => $04029719753624c5$export$4ee1db8ce44a209b);

var $fvB0y = parcelRequire("fvB0y");
parcelRequire("h8OVS");
var $b9HTl = parcelRequire("b9HTl");

var $2cnzA = parcelRequire("2cnzA");

var $gYfDQ = parcelRequire("gYfDQ");
function $04029719753624c5$export$d697c39a2985a4c(props, allowlist, defaults) {
    if (defaults === void 0) defaults = {};
    return allowlist.reduce(function(filtered, name) {
        if (name in props) filtered[name] = props[name];
        else if (name in defaults) filtered[name] = defaults[name];
        return filtered;
    }, {});
}
var $04029719753624c5$var$defaultErrorHandler = function(error) {};
var $04029719753624c5$var$defaultWarnHandler = function(warning) {};
var $04029719753624c5$export$b52f8d6fc0d47415 = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: 'en',
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: $04029719753624c5$var$defaultErrorHandler,
    onWarn: $04029719753624c5$var$defaultWarnHandler
};
function $04029719753624c5$export$51c4f4e973f2dc00() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {}
    };
}
function $04029719753624c5$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $04029719753624c5$export$c3f4cd5551df13fd(cache) {
    if (cache === void 0) cache = $04029719753624c5$export$51c4f4e973f2dc00();
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    var ListFormat = Intl.ListFormat;
    var DisplayNames = Intl.DisplayNames;
    var getDateTimeFormat = (0, $2cnzA.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $fvB0y.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $04029719753624c5$var$createFastMemoizeCache(cache.dateTime),
        strategy: (0, $2cnzA.strategies).variadic
    });
    var getNumberFormat = (0, $2cnzA.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $fvB0y.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $04029719753624c5$var$createFastMemoizeCache(cache.number),
        strategy: (0, $2cnzA.strategies).variadic
    });
    var getPluralRules = (0, $2cnzA.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $fvB0y.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $04029719753624c5$var$createFastMemoizeCache(cache.pluralRules),
        strategy: (0, $2cnzA.strategies).variadic
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: (0, $2cnzA.memoize)(function(message, locales, overrideFormats, opts) {
            return new (0, $b9HTl.IntlMessageFormat)(message, locales, overrideFormats, (0, $fvB0y.__assign)({
                formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules
                }
            }, opts || {}));
        }, {
            cache: $04029719753624c5$var$createFastMemoizeCache(cache.message),
            strategy: (0, $2cnzA.strategies).variadic
        }),
        getRelativeTimeFormat: (0, $2cnzA.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, (0, $fvB0y.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $04029719753624c5$var$createFastMemoizeCache(cache.relativeTime),
            strategy: (0, $2cnzA.strategies).variadic
        }),
        getPluralRules: getPluralRules,
        getListFormat: (0, $2cnzA.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (ListFormat.bind.apply(ListFormat, (0, $fvB0y.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $04029719753624c5$var$createFastMemoizeCache(cache.list),
            strategy: (0, $2cnzA.strategies).variadic
        }),
        getDisplayNames: (0, $2cnzA.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (DisplayNames.bind.apply(DisplayNames, (0, $fvB0y.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $04029719753624c5$var$createFastMemoizeCache(cache.displayNames),
            strategy: (0, $2cnzA.strategies).variadic
        })
    };
}
function $04029719753624c5$export$4ee1db8ce44a209b(formats, type, name, onError) {
    var formatType = formats && formats[type];
    var format;
    if (formatType) format = formatType[name];
    if (format) return format;
    onError(new (0, $gYfDQ.UnsupportedFormatterError)("No ".concat(type, " format named: ").concat(name)));
}

});
parcelRegister("h8OVS", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "ErrorCode", () => (parcelRequire("IShqa")).ErrorCode);
$parcel$export(module.exports, "FormatError", () => (parcelRequire("IShqa")).FormatError);
$parcel$export(module.exports, "isFormatXMLElementFn", () => (parcelRequire("3D21m")).isFormatXMLElementFn);
$parcel$export(module.exports, "IntlMessageFormat", () => (parcelRequire("b9HTl")).IntlMessageFormat);
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $b9HTl = parcelRequire("b9HTl");
parcelRequire("IShqa");
parcelRequire("3D21m");
var $c7aab1229d744ca9$export$2e2bcd8739ae039 = (0, $b9HTl.IntlMessageFormat);

});
parcelRegister("b9HTl", function(module, exports) {
$parcel$export(module.exports, "IntlMessageFormat", () => $81f294eefa23f5fa$export$d342343268debc40);
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $fvB0y = parcelRequire("fvB0y");

var $kjBEd = parcelRequire("kjBEd");

var $9Sshd = parcelRequire("9Sshd");

var $3D21m = parcelRequire("3D21m");
// -- MessageFormat --------------------------------------------------------
function $81f294eefa23f5fa$var$mergeConfig(c1, c2) {
    if (!c2) return c1;
    return (0, $fvB0y.__assign)((0, $fvB0y.__assign)((0, $fvB0y.__assign)({}, c1 || {}), c2 || {}), Object.keys(c1).reduce(function(all, k) {
        all[k] = (0, $fvB0y.__assign)((0, $fvB0y.__assign)({}, c1[k]), c2[k] || {});
        return all;
    }, {}));
}
function $81f294eefa23f5fa$var$mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce(function(all, k) {
        all[k] = $81f294eefa23f5fa$var$mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0, $fvB0y.__assign)({}, defaultConfig));
}
function $81f294eefa23f5fa$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $81f294eefa23f5fa$var$createDefaultFormatters(cache) {
    if (cache === void 0) cache = {
        number: {},
        dateTime: {},
        pluralRules: {}
    };
    return {
        getNumberFormat: (0, $kjBEd.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $fvB0y.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $81f294eefa23f5fa$var$createFastMemoizeCache(cache.number),
            strategy: (0, $kjBEd.strategies).variadic
        }),
        getDateTimeFormat: (0, $kjBEd.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $fvB0y.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $81f294eefa23f5fa$var$createFastMemoizeCache(cache.dateTime),
            strategy: (0, $kjBEd.strategies).variadic
        }),
        getPluralRules: (0, $kjBEd.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $fvB0y.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $81f294eefa23f5fa$var$createFastMemoizeCache(cache.pluralRules),
            strategy: (0, $kjBEd.strategies).variadic
        })
    };
}
var $81f294eefa23f5fa$export$d342343268debc40 = /** @class */ function() {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        if (locales === void 0) locales = IntlMessageFormat.defaultLocale;
        var _this = this;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {}
        };
        this.format = function(values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) return parts[0].value;
            var result = parts.reduce(function(all, part) {
                if (!all.length || part.type !== (0, $3D21m.PART_TYPE).literal || typeof all[all.length - 1] !== 'string') all.push(part.value);
                else all[all.length - 1] += part.value;
                return all;
            }, []);
            if (result.length <= 1) return result[0] || '';
            return result;
        };
        this.formatToParts = function(values) {
            return (0, $3D21m.formatToParts)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function() {
            var _a;
            return {
                locale: ((_a = _this.resolvedLocale) === null || _a === void 0 ? void 0 : _a.toString()) || Intl.NumberFormat.supportedLocalesOf(_this.locales)[0]
            };
        };
        this.getAst = function() {
            return _this.ast;
        };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === 'string') {
            this.message = message;
            if (!IntlMessageFormat.__parse) throw new TypeError('IntlMessageFormat.__parse must be set to process `message` of type `string`');
            var _a = opts || {}, formatters = _a.formatters, parseOpts = (0, $fvB0y.__rest)(_a, [
                "formatters"
            ]);
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, (0, $fvB0y.__assign)((0, $fvB0y.__assign)({}, parseOpts), {
                locale: this.resolvedLocale
            }));
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError('A message must be provided as a String or AST.');
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = $81f294eefa23f5fa$var$mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters = opts && opts.formatters || $81f294eefa23f5fa$var$createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function() {
            if (!IntlMessageFormat.memoizedDefaultLocale) IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function(locales) {
        if (typeof Intl.Locale === 'undefined') return;
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
        return new Intl.Locale(typeof locales === 'string' ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = (0, $9Sshd.parse);
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0
            },
            currency: {
                style: 'currency'
            },
            percent: {
                style: 'percent'
            }
        },
        date: {
            short: {
                month: 'numeric',
                day: 'numeric',
                year: '2-digit'
            },
            medium: {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
            },
            long: {
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            },
            full: {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            }
        },
        time: {
            short: {
                hour: 'numeric',
                minute: 'numeric'
            },
            medium: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },
            long: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            },
            full: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            }
        }
    };
    return IntlMessageFormat;
}();

});
parcelRegister("kjBEd", function(module, exports) {
$parcel$export(module.exports, "memoize", () => $eca2c9073032c453$export$fc10aeed3a532e2a);
$parcel$export(module.exports, "strategies", () => $eca2c9073032c453$export$c5491a8691a23b9e);
//
// Main
//
function $eca2c9073032c453$export$fc10aeed3a532e2a(fn, options) {
    var cache = options && options.cache ? options.cache : $eca2c9073032c453$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $eca2c9073032c453$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $eca2c9073032c453$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $eca2c9073032c453$var$isPrimitive(value) {
    return value == null || typeof value === 'number' || typeof value === 'boolean'; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $eca2c9073032c453$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $eca2c9073032c453$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $eca2c9073032c453$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $eca2c9073032c453$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $eca2c9073032c453$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $eca2c9073032c453$var$monadic : $eca2c9073032c453$var$variadic;
    return $eca2c9073032c453$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $eca2c9073032c453$var$strategyVariadic(fn, options) {
    return $eca2c9073032c453$var$assemble(fn, this, $eca2c9073032c453$var$variadic, options.cache.create(), options.serializer);
}
function $eca2c9073032c453$var$strategyMonadic(fn, options) {
    return $eca2c9073032c453$var$assemble(fn, this, $eca2c9073032c453$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $eca2c9073032c453$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
function $eca2c9073032c453$var$ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
$eca2c9073032c453$var$ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
$eca2c9073032c453$var$ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var $eca2c9073032c453$var$cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new $eca2c9073032c453$var$ObjectWithoutPrototypeCache();
    }
};
var $eca2c9073032c453$export$c5491a8691a23b9e = {
    variadic: $eca2c9073032c453$var$strategyVariadic,
    monadic: $eca2c9073032c453$var$strategyMonadic
};

});

parcelRegister("9Sshd", function(module, exports) {
$parcel$export(module.exports, "isArgumentElement", () => (parcelRequire("T96Ke")).isArgumentElement);
$parcel$export(module.exports, "isDateElement", () => (parcelRequire("T96Ke")).isDateElement);
$parcel$export(module.exports, "isDateTimeSkeleton", () => (parcelRequire("T96Ke")).isDateTimeSkeleton);
$parcel$export(module.exports, "isLiteralElement", () => (parcelRequire("T96Ke")).isLiteralElement);
$parcel$export(module.exports, "isNumberElement", () => (parcelRequire("T96Ke")).isNumberElement);
$parcel$export(module.exports, "isNumberSkeleton", () => (parcelRequire("T96Ke")).isNumberSkeleton);
$parcel$export(module.exports, "isPluralElement", () => (parcelRequire("T96Ke")).isPluralElement);
$parcel$export(module.exports, "isPoundElement", () => (parcelRequire("T96Ke")).isPoundElement);
$parcel$export(module.exports, "isSelectElement", () => (parcelRequire("T96Ke")).isSelectElement);
$parcel$export(module.exports, "isTagElement", () => (parcelRequire("T96Ke")).isTagElement);
$parcel$export(module.exports, "isTimeElement", () => (parcelRequire("T96Ke")).isTimeElement);
$parcel$export(module.exports, "parse", () => $730f17583b301905$export$98e6a39c04603d36);

var $fvB0y = parcelRequire("fvB0y");

var $c10uv = parcelRequire("c10uv");

var $fCS20 = parcelRequire("fCS20");

var $T96Ke = parcelRequire("T96Ke");
function $730f17583b301905$var$pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, $T96Ke.isSelectElement)(el) || (0, $T96Ke.isPluralElement)(el)) for(var k in el.options){
            delete el.options[k].location;
            $730f17583b301905$var$pruneLocation(el.options[k].value);
        }
        else if ((0, $T96Ke.isNumberElement)(el) && (0, $T96Ke.isNumberSkeleton)(el.style)) delete el.style.location;
        else if (((0, $T96Ke.isDateElement)(el) || (0, $T96Ke.isTimeElement)(el)) && (0, $T96Ke.isDateTimeSkeleton)(el.style)) delete el.style.location;
        else if ((0, $T96Ke.isTagElement)(el)) $730f17583b301905$var$pruneLocation(el.children);
    });
}
function $730f17583b301905$export$98e6a39c04603d36(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, $fvB0y.__assign)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, $fCS20.Parser)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, $c10uv.ErrorKind)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) $730f17583b301905$var$pruneLocation(result.val);
    return result.val;
}
var $730f17583b301905$export$d3c1bfa0f7d806e9 = (0, $fCS20.Parser);

});
parcelRegister("c10uv", function(module, exports) {
$parcel$export(module.exports, "ErrorKind", () => $8bf5f5904af01826$export$896afd8541959ee5);
var $8bf5f5904af01826$export$896afd8541959ee5;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})($8bf5f5904af01826$export$896afd8541959ee5 || ($8bf5f5904af01826$export$896afd8541959ee5 = {}));

});

parcelRegister("fCS20", function(module, exports) {
$parcel$export(module.exports, "Parser", () => $b604511b8f61f8fb$export$7acfa6ed01010e37);

var $fvB0y = parcelRequire("fvB0y");

var $c10uv = parcelRequire("c10uv");

var $T96Ke = parcelRequire("T96Ke");

var $cYBNz = parcelRequire("cYBNz");
parcelRequire("eteeo");
var $la2wd = parcelRequire("la2wd");
var $k9E32 = parcelRequire("k9E32");

var $5paJl = parcelRequire("5paJl");
var $b604511b8f61f8fb$var$_a;
var $b604511b8f61f8fb$var$SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, $cYBNz.SPACE_SEPARATOR_REGEX).source, "*"));
var $b604511b8f61f8fb$var$SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, $cYBNz.SPACE_SEPARATOR_REGEX).source, "*$"));
function $b604511b8f61f8fb$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var $b604511b8f61f8fb$var$hasNativeStartsWith = !!String.prototype.startsWith && '_a'.startsWith('a', 1);
var $b604511b8f61f8fb$var$hasNativeFromCodePoint = !!String.fromCodePoint;
var $b604511b8f61f8fb$var$hasNativeFromEntries = !!Object.fromEntries;
var $b604511b8f61f8fb$var$hasNativeCodePointAt = !!String.prototype.codePointAt;
var $b604511b8f61f8fb$var$hasTrimStart = !!String.prototype.trimStart;
var $b604511b8f61f8fb$var$hasTrimEnd = !!String.prototype.trimEnd;
var $b604511b8f61f8fb$var$hasNativeIsSafeInteger = !!Number.isSafeInteger;
var $b604511b8f61f8fb$var$isSafeInteger = $b604511b8f61f8fb$var$hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === 'number' && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var $b604511b8f61f8fb$var$REGEX_SUPPORTS_U_AND_Y = true;
try {
    var $b604511b8f61f8fb$var$re = $b604511b8f61f8fb$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ $b604511b8f61f8fb$var$REGEX_SUPPORTS_U_AND_Y = (($b604511b8f61f8fb$var$_a = $b604511b8f61f8fb$var$re.exec('a')) === null || $b604511b8f61f8fb$var$_a === void 0 ? void 0 : $b604511b8f61f8fb$var$_a[0]) === 'a';
} catch (_) {
    $b604511b8f61f8fb$var$REGEX_SUPPORTS_U_AND_Y = false;
}
var $b604511b8f61f8fb$var$startsWith = $b604511b8f61f8fb$var$hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var $b604511b8f61f8fb$var$fromCodePoint = $b604511b8f61f8fb$var$hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = '';
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + ' is not a valid code point');
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var $b604511b8f61f8fb$var$fromEntries = // native
$b604511b8f61f8fb$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var $b604511b8f61f8fb$var$codePointAt = $b604511b8f61f8fb$var$hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var $b604511b8f61f8fb$var$trimStart = $b604511b8f61f8fb$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($b604511b8f61f8fb$var$SPACE_SEPARATOR_START_REGEX, '');
};
var $b604511b8f61f8fb$var$trimEnd = $b604511b8f61f8fb$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($b604511b8f61f8fb$var$SPACE_SEPARATOR_END_REGEX, '');
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function $b604511b8f61f8fb$var$RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var $b604511b8f61f8fb$var$matchIdentifierAtIndex;
if ($b604511b8f61f8fb$var$REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var $b604511b8f61f8fb$var$IDENTIFIER_PREFIX_RE_1 = $b604511b8f61f8fb$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    $b604511b8f61f8fb$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        $b604511b8f61f8fb$var$IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = $b604511b8f61f8fb$var$IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : '';
    };
} else // IE11
$b604511b8f61f8fb$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = $b604511b8f61f8fb$var$codePointAt(s, index);
        if (c === undefined || $b604511b8f61f8fb$var$_isWhiteSpace(c) || $b604511b8f61f8fb$var$_isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return $b604511b8f61f8fb$var$fromCodePoint.apply(void 0, match);
};
var $b604511b8f61f8fb$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error('parser can only be used once');
        return this.parseMessage(0, '', false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal')) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, $T96Ke.TYPE).pound,
                    location: $b604511b8f61f8fb$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, $c10uv.ErrorKind).UNMATCHED_CLOSING_TAG, $b604511b8f61f8fb$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && $b604511b8f61f8fb$var$_isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf('/>')) // Self closing tag
        return {
            val: {
                type: (0, $T96Ke.TYPE).literal,
                value: "<".concat(tagName, "/>"),
                location: $b604511b8f61f8fb$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf('>')) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf('</')) {
                if (this.isEOF() || !$b604511b8f61f8fb$var$_isAlpha(this.char())) return this.error((0, $c10uv.ErrorKind).INVALID_TAG, $b604511b8f61f8fb$var$createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, $c10uv.ErrorKind).UNMATCHED_CLOSING_TAG, $b604511b8f61f8fb$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf('>')) return this.error((0, $c10uv.ErrorKind).INVALID_TAG, $b604511b8f61f8fb$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, $T96Ke.TYPE).tag,
                        value: tagName,
                        children: children,
                        location: $b604511b8f61f8fb$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, $c10uv.ErrorKind).UNCLOSED_TAG, $b604511b8f61f8fb$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, $c10uv.ErrorKind).INVALID_TAG, $b604511b8f61f8fb$var$createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && $b604511b8f61f8fb$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = '';
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = $b604511b8f61f8fb$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, $T96Ke.TYPE).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !$b604511b8f61f8fb$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return '<';
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === 'plural' || parentArgType === 'selectordinal') break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return $b604511b8f61f8fb$var$fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal') || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return $b604511b8f61f8fb$var$fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $c10uv.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $b604511b8f61f8fb$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, $c10uv.ErrorKind).EMPTY_ARGUMENT, $b604511b8f61f8fb$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, $c10uv.ErrorKind).MALFORMED_ARGUMENT, $b604511b8f61f8fb$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $c10uv.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $b604511b8f61f8fb$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, $T96Ke.TYPE).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: $b604511b8f61f8fb$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, $c10uv.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $b604511b8f61f8fb$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, $c10uv.ErrorKind).MALFORMED_ARGUMENT, $b604511b8f61f8fb$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = $b604511b8f61f8fb$var$matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = $b604511b8f61f8fb$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case '':
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, $c10uv.ErrorKind).EXPECT_ARGUMENT_TYPE, $b604511b8f61f8fb$var$createLocation(typeStartPosition, typeEndPosition));
            case 'number':
            case 'date':
            case 'time':
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(',')) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = $b604511b8f61f8fb$var$trimEnd(result.val);
                    if (style.length === 0) return this.error((0, $c10uv.ErrorKind).EXPECT_ARGUMENT_STYLE, $b604511b8f61f8fb$var$createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = $b604511b8f61f8fb$var$createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = $b604511b8f61f8fb$var$createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && $b604511b8f61f8fb$var$startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, '::', 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = $b604511b8f61f8fb$var$trimStart(styleAndLocation.style.slice(2));
                    if (argType === 'number') {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, $T96Ke.TYPE).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, $c10uv.ErrorKind).EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, $5paJl.getBestPattern)(skeleton, this.locale);
                        var style = {
                            type: (0, $T96Ke.SKELETON_TYPE).dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, $la2wd.parseDateTimeSkeleton)(dateTimePattern) : {}
                        };
                        var type = argType === 'date' ? (0, $T96Ke.TYPE).date : (0, $T96Ke.TYPE).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === 'number' ? (0, $T96Ke.TYPE).number : argType === 'date' ? (0, $T96Ke.TYPE).date : (0, $T96Ke.TYPE).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case 'plural':
            case 'selectordinal':
            case 'select':
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(',')) return this.error((0, $c10uv.ErrorKind).EXPECT_SELECT_ARGUMENT_OPTIONS, $b604511b8f61f8fb$var$createLocation(typeEndPosition_1, (0, $fvB0y.__assign)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== 'select' && identifierAndLocation.value === 'offset') {
                    if (!this.bumpIf(':')) return this.error((0, $c10uv.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $b604511b8f61f8fb$var$createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, $c10uv.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, $c10uv.ErrorKind).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = $b604511b8f61f8fb$var$createLocation(openingBracePosition, this.clonePosition());
                if (argType === 'select') return {
                    val: {
                        type: (0, $T96Ke.TYPE).select,
                        value: value,
                        options: $b604511b8f61f8fb$var$fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, $T96Ke.TYPE).plural,
                        value: value,
                        options: $b604511b8f61f8fb$var$fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === 'plural' ? 'cardinal' : 'ordinal',
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, $c10uv.ErrorKind).INVALID_ARGUMENT_TYPE, $b604511b8f61f8fb$var$createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, $c10uv.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $b604511b8f61f8fb$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, $c10uv.ErrorKind).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $b604511b8f61f8fb$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, $k9E32.parseNumberSkeletonFromString)(skeleton);
        } catch (e) {
            return this.error((0, $c10uv.ErrorKind).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, $T96Ke.SKELETON_TYPE).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $k9E32.parseNumberSkeleton)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== 'select' && this.bumpIf('=')) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, $c10uv.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, $c10uv.ErrorKind).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $b604511b8f61f8fb$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === 'select' ? (0, $c10uv.ErrorKind).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, $c10uv.ErrorKind).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === 'other') hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf('{')) return this.error(parentArgType === 'select' ? (0, $c10uv.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, $c10uv.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $b604511b8f61f8fb$var$createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $b604511b8f61f8fb$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === 'select' ? (0, $c10uv.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, $c10uv.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, $b604511b8f61f8fb$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, $c10uv.ErrorKind).MISSING_OTHER_CLAUSE, $b604511b8f61f8fb$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf('+')) ;
        else if (this.bumpIf('-')) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = $b604511b8f61f8fb$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!$b604511b8f61f8fb$var$isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error('out of bound');
        var code = $b604511b8f61f8fb$var$codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if ($b604511b8f61f8fb$var$startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && $b604511b8f61f8fb$var$_isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function $b604511b8f61f8fb$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $b604511b8f61f8fb$var$_isAlphaOrSlash(codepoint) {
    return $b604511b8f61f8fb$var$_isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function $b604511b8f61f8fb$var$_isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $b604511b8f61f8fb$var$_isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $b604511b8f61f8fb$var$_isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}

});
parcelRegister("T96Ke", function(module, exports) {
$parcel$export(module.exports, "TYPE", () => $0a5c33c9077467f5$export$b87f371cbc396fcf);
$parcel$export(module.exports, "SKELETON_TYPE", () => $0a5c33c9077467f5$export$906452485466fa53);
$parcel$export(module.exports, "isLiteralElement", () => $0a5c33c9077467f5$export$cfa10c5697238752);
$parcel$export(module.exports, "isArgumentElement", () => $0a5c33c9077467f5$export$4f55724281bdfaf9);
$parcel$export(module.exports, "isNumberElement", () => $0a5c33c9077467f5$export$e11187b219e191e1);
$parcel$export(module.exports, "isDateElement", () => $0a5c33c9077467f5$export$32d811605da75f40);
$parcel$export(module.exports, "isTimeElement", () => $0a5c33c9077467f5$export$34ec46f596b1702f);
$parcel$export(module.exports, "isSelectElement", () => $0a5c33c9077467f5$export$dcfe1c11d168b5a1);
$parcel$export(module.exports, "isPluralElement", () => $0a5c33c9077467f5$export$6c796d116f0a4fbc);
$parcel$export(module.exports, "isPoundElement", () => $0a5c33c9077467f5$export$c0ece297bdd0c082);
$parcel$export(module.exports, "isTagElement", () => $0a5c33c9077467f5$export$5c83de34745812b);
$parcel$export(module.exports, "isNumberSkeleton", () => $0a5c33c9077467f5$export$3f9a19cd4152eda3);
$parcel$export(module.exports, "isDateTimeSkeleton", () => $0a5c33c9077467f5$export$7680c41f1a55f4cf);
var $0a5c33c9077467f5$export$b87f371cbc396fcf;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})($0a5c33c9077467f5$export$b87f371cbc396fcf || ($0a5c33c9077467f5$export$b87f371cbc396fcf = {}));
var $0a5c33c9077467f5$export$906452485466fa53;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})($0a5c33c9077467f5$export$906452485466fa53 || ($0a5c33c9077467f5$export$906452485466fa53 = {}));
function $0a5c33c9077467f5$export$cfa10c5697238752(el) {
    return el.type === $0a5c33c9077467f5$export$b87f371cbc396fcf.literal;
}
function $0a5c33c9077467f5$export$4f55724281bdfaf9(el) {
    return el.type === $0a5c33c9077467f5$export$b87f371cbc396fcf.argument;
}
function $0a5c33c9077467f5$export$e11187b219e191e1(el) {
    return el.type === $0a5c33c9077467f5$export$b87f371cbc396fcf.number;
}
function $0a5c33c9077467f5$export$32d811605da75f40(el) {
    return el.type === $0a5c33c9077467f5$export$b87f371cbc396fcf.date;
}
function $0a5c33c9077467f5$export$34ec46f596b1702f(el) {
    return el.type === $0a5c33c9077467f5$export$b87f371cbc396fcf.time;
}
function $0a5c33c9077467f5$export$dcfe1c11d168b5a1(el) {
    return el.type === $0a5c33c9077467f5$export$b87f371cbc396fcf.select;
}
function $0a5c33c9077467f5$export$6c796d116f0a4fbc(el) {
    return el.type === $0a5c33c9077467f5$export$b87f371cbc396fcf.plural;
}
function $0a5c33c9077467f5$export$c0ece297bdd0c082(el) {
    return el.type === $0a5c33c9077467f5$export$b87f371cbc396fcf.pound;
}
function $0a5c33c9077467f5$export$5c83de34745812b(el) {
    return el.type === $0a5c33c9077467f5$export$b87f371cbc396fcf.tag;
}
function $0a5c33c9077467f5$export$3f9a19cd4152eda3(el) {
    return !!(el && typeof el === 'object' && el.type === $0a5c33c9077467f5$export$906452485466fa53.number);
}
function $0a5c33c9077467f5$export$7680c41f1a55f4cf(el) {
    return !!(el && typeof el === 'object' && el.type === $0a5c33c9077467f5$export$906452485466fa53.dateTime);
}
function $0a5c33c9077467f5$export$f0ac572c1121c662(value) {
    return {
        type: $0a5c33c9077467f5$export$b87f371cbc396fcf.literal,
        value: value
    };
}
function $0a5c33c9077467f5$export$425e864b0ba114f1(value, style) {
    return {
        type: $0a5c33c9077467f5$export$b87f371cbc396fcf.number,
        value: value,
        style: style
    };
}

});

parcelRegister("cYBNz", function(module, exports) {
$parcel$export(module.exports, "SPACE_SEPARATOR_REGEX", () => $972868a590d2b2a8$export$523451f94304dd6c);
// @generated from regex-gen.ts
var $972868a590d2b2a8$export$523451f94304dd6c = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var $972868a590d2b2a8$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;

});

parcelRegister("eteeo", function(module, exports) {
$parcel$export(module.exports, "parseDateTimeSkeleton", () => (parcelRequire("la2wd")).parseDateTimeSkeleton);
$parcel$export(module.exports, "parseNumberSkeleton", () => (parcelRequire("k9E32")).parseNumberSkeleton);
$parcel$export(module.exports, "parseNumberSkeletonFromString", () => (parcelRequire("k9E32")).parseNumberSkeletonFromString);
parcelRequire("la2wd");
parcelRequire("k9E32");

});
parcelRegister("la2wd", function(module, exports) {
$parcel$export(module.exports, "parseDateTimeSkeleton", () => $f67c7c4920ab95b2$export$f7b99fb377fe69fa);
/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */ var $f67c7c4920ab95b2$var$DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function $f67c7c4920ab95b2$export$f7b99fb377fe69fa(skeleton) {
    var result = {};
    skeleton.replace($f67c7c4920ab95b2$var$DATE_TIME_REGEX, function(match) {
        var len = match.length;
        switch(match[0]){
            // Era
            case 'G':
                result.era = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            // Year
            case 'y':
                result.year = len === 2 ? '2-digit' : 'numeric';
                break;
            case 'Y':
            case 'u':
            case 'U':
            case 'r':
                throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
            // Quarter
            case 'q':
            case 'Q':
                throw new RangeError('`q/Q` (quarter) patterns are not supported');
            // Month
            case 'M':
            case 'L':
                result.month = [
                    'numeric',
                    '2-digit',
                    'short',
                    'long',
                    'narrow'
                ][len - 1];
                break;
            // Week
            case 'w':
            case 'W':
                throw new RangeError('`w/W` (week) patterns are not supported');
            case 'd':
                result.day = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'D':
            case 'F':
            case 'g':
                throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
            // Weekday
            case 'E':
                result.weekday = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            case 'e':
                if (len < 4) throw new RangeError('`e..eee` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            case 'c':
                if (len < 4) throw new RangeError('`c..ccc` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            // Period
            case 'a':
                result.hour12 = true;
                break;
            case 'b':
            case 'B':
                throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
            // Hour
            case 'h':
                result.hourCycle = 'h12';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'H':
                result.hourCycle = 'h23';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'K':
                result.hourCycle = 'h11';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'k':
                result.hourCycle = 'h24';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'j':
            case 'J':
            case 'C':
                throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
            // Minute
            case 'm':
                result.minute = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            // Second
            case 's':
                result.second = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'S':
            case 'A':
                throw new RangeError('`S/A` (second) patterns are not supported, use `s` instead');
            // Zone
            case 'z':
                result.timeZoneName = len < 4 ? 'short' : 'long';
                break;
            case 'Z':
            case 'O':
            case 'v':
            case 'V':
            case 'X':
            case 'x':
                throw new RangeError('`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead');
        }
        return '';
    });
    return result;
}

});

parcelRegister("k9E32", function(module, exports) {
$parcel$export(module.exports, "parseNumberSkeletonFromString", () => $eac3b69f24872dd4$export$71cee2f16fba2480);
$parcel$export(module.exports, "parseNumberSkeleton", () => $eac3b69f24872dd4$export$47c6f8480bda3e11);

var $fvB0y = parcelRequire("fvB0y");

var $6KRvY = parcelRequire("6KRvY");
function $eac3b69f24872dd4$export$71cee2f16fba2480(skeleton) {
    if (skeleton.length === 0) throw new Error('Number skeleton cannot be empty');
    // Parse the skeleton
    var stringTokens = skeleton.split((0, $6KRvY.WHITE_SPACE_REGEX)).filter(function(x) {
        return x.length > 0;
    });
    var tokens = [];
    for(var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++){
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split('/');
        if (stemAndOptions.length === 0) throw new Error('Invalid number skeleton');
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for(var _a = 0, options_1 = options; _a < options_1.length; _a++){
            var option = options_1[_a];
            if (option.length === 0) throw new Error('Invalid number skeleton');
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
function $eac3b69f24872dd4$var$icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, '');
}
var $eac3b69f24872dd4$var$FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var $eac3b69f24872dd4$var$SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var $eac3b69f24872dd4$var$INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var $eac3b69f24872dd4$var$CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function $eac3b69f24872dd4$var$parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === 'r') result.roundingPriority = 'morePrecision';
    else if (str[str.length - 1] === 's') result.roundingPriority = 'lessPrecision';
    str.replace($eac3b69f24872dd4$var$SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== 'string') {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === '+') result.minimumSignificantDigits = g1.length;
        else if (g1[0] === '#') result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === 'string' ? g2.length : 0);
        }
        return '';
    });
    return result;
}
function $eac3b69f24872dd4$var$parseSign(str) {
    switch(str){
        case 'sign-auto':
            return {
                signDisplay: 'auto'
            };
        case 'sign-accounting':
        case '()':
            return {
                currencySign: 'accounting'
            };
        case 'sign-always':
        case '+!':
            return {
                signDisplay: 'always'
            };
        case 'sign-accounting-always':
        case '()!':
            return {
                signDisplay: 'always',
                currencySign: 'accounting'
            };
        case 'sign-except-zero':
        case '+?':
            return {
                signDisplay: 'exceptZero'
            };
        case 'sign-accounting-except-zero':
        case '()?':
            return {
                signDisplay: 'exceptZero',
                currencySign: 'accounting'
            };
        case 'sign-never':
        case '+_':
            return {
                signDisplay: 'never'
            };
    }
}
function $eac3b69f24872dd4$var$parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === 'E' && stem[1] === 'E') {
        result = {
            notation: 'engineering'
        };
        stem = stem.slice(2);
    } else if (stem[0] === 'E') {
        result = {
            notation: 'scientific'
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === '+!') {
            result.signDisplay = 'always';
            stem = stem.slice(2);
        } else if (signDisplay === '+?') {
            result.signDisplay = 'exceptZero';
            stem = stem.slice(2);
        }
        if (!$eac3b69f24872dd4$var$CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error('Malformed concise eng/scientific notation');
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function $eac3b69f24872dd4$var$parseNotationOptions(opt) {
    var result = {};
    var signOpts = $eac3b69f24872dd4$var$parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
function $eac3b69f24872dd4$export$47c6f8480bda3e11(tokens) {
    var result = {};
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        switch(token.stem){
            case 'percent':
            case '%':
                result.style = 'percent';
                continue;
            case '%x100':
                result.style = 'percent';
                result.scale = 100;
                continue;
            case 'currency':
                result.style = 'currency';
                result.currency = token.options[0];
                continue;
            case 'group-off':
            case ',_':
                result.useGrouping = false;
                continue;
            case 'precision-integer':
            case '.':
                result.maximumFractionDigits = 0;
                continue;
            case 'measure-unit':
            case 'unit':
                result.style = 'unit';
                result.unit = $eac3b69f24872dd4$var$icuUnitToEcma(token.options[0]);
                continue;
            case 'compact-short':
            case 'K':
                result.notation = 'compact';
                result.compactDisplay = 'short';
                continue;
            case 'compact-long':
            case 'KK':
                result.notation = 'compact';
                result.compactDisplay = 'long';
                continue;
            case 'scientific':
                result = (0, $fvB0y.__assign)((0, $fvB0y.__assign)((0, $fvB0y.__assign)({}, result), {
                    notation: 'scientific'
                }), token.options.reduce(function(all, opt) {
                    return (0, $fvB0y.__assign)((0, $fvB0y.__assign)({}, all), $eac3b69f24872dd4$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'engineering':
                result = (0, $fvB0y.__assign)((0, $fvB0y.__assign)((0, $fvB0y.__assign)({}, result), {
                    notation: 'engineering'
                }), token.options.reduce(function(all, opt) {
                    return (0, $fvB0y.__assign)((0, $fvB0y.__assign)({}, all), $eac3b69f24872dd4$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'notation-simple':
                result.notation = 'standard';
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case 'unit-width-narrow':
                result.currencyDisplay = 'narrowSymbol';
                result.unitDisplay = 'narrow';
                continue;
            case 'unit-width-short':
                result.currencyDisplay = 'code';
                result.unitDisplay = 'short';
                continue;
            case 'unit-width-full-name':
                result.currencyDisplay = 'name';
                result.unitDisplay = 'long';
                continue;
            case 'unit-width-iso-code':
                result.currencyDisplay = 'symbol';
                continue;
            case 'scale':
                result.scale = parseFloat(token.options[0]);
                continue;
            case 'rounding-mode-floor':
                result.roundingMode = 'floor';
                continue;
            case 'rounding-mode-ceiling':
                result.roundingMode = 'ceil';
                continue;
            case 'rounding-mode-down':
                result.roundingMode = 'trunc';
                continue;
            case 'rounding-mode-up':
                result.roundingMode = 'expand';
                continue;
            case 'rounding-mode-half-even':
                result.roundingMode = 'halfEven';
                continue;
            case 'rounding-mode-half-down':
                result.roundingMode = 'halfTrunc';
                continue;
            case 'rounding-mode-half-up':
                result.roundingMode = 'halfExpand';
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case 'integer-width':
                if (token.options.length > 1) throw new RangeError('integer-width stems only accept a single optional option');
                token.options[0].replace($eac3b69f24872dd4$var$INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error('We currently do not support maximum integer digits');
                    else if (g5) throw new Error('We currently do not support exact integer digits');
                    return '';
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if ($eac3b69f24872dd4$var$CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if ($eac3b69f24872dd4$var$FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError('Fraction-precision stems only accept a single optional option');
            token.stem.replace($eac3b69f24872dd4$var$FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === '*') result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === '#') result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return '';
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === 'w') result = (0, $fvB0y.__assign)((0, $fvB0y.__assign)({}, result), {
                trailingZeroDisplay: 'stripIfInteger'
            });
            else if (opt) result = (0, $fvB0y.__assign)((0, $fvB0y.__assign)({}, result), $eac3b69f24872dd4$var$parseSignificantPrecision(opt));
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if ($eac3b69f24872dd4$var$SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0, $fvB0y.__assign)((0, $fvB0y.__assign)({}, result), $eac3b69f24872dd4$var$parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = $eac3b69f24872dd4$var$parseSign(token.stem);
        if (signOpts) result = (0, $fvB0y.__assign)((0, $fvB0y.__assign)({}, result), signOpts);
        var conciseScientificAndEngineeringOpts = $eac3b69f24872dd4$var$parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = (0, $fvB0y.__assign)((0, $fvB0y.__assign)({}, result), conciseScientificAndEngineeringOpts);
    }
    return result;
}

});
parcelRegister("6KRvY", function(module, exports) {
$parcel$export(module.exports, "WHITE_SPACE_REGEX", () => $4eb08cd791a8f6d6$export$2b8db14d8bcaece7);
// @generated from regex-gen.ts
var $4eb08cd791a8f6d6$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

});



parcelRegister("5paJl", function(module, exports) {
$parcel$export(module.exports, "getBestPattern", () => $3ef79c616455c08c$export$29c5368be8904d27);

var $9cOVu = parcelRequire("9cOVu");
function $3ef79c616455c08c$export$29c5368be8904d27(skeleton, locale) {
    var skeletonCopy = '';
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === 'j') {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = 'a';
            var hourChar = $3ef79c616455c08c$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == 'H' || hourChar == 'k') dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === 'J') skeletonCopy += 'H';
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function $3ef79c616455c08c$var$getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case 'h24':
            return 'k';
        case 'h23':
            return 'H';
        case 'h12':
            return 'h';
        case 'h11':
            return 'K';
        default:
            throw new Error('Invalid hourCycle');
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== 'root') regionTag = locale.maximize().region;
    var hourCycles = (0, $9cOVu.timeData)[regionTag || ''] || (0, $9cOVu.timeData)[languageTag || ''] || (0, $9cOVu.timeData)["".concat(languageTag, "-001")] || (0, $9cOVu.timeData)['001'];
    return hourCycles[0];
}

});
parcelRegister("9cOVu", function(module, exports) {
$parcel$export(module.exports, "timeData", () => $6b3cbcf3680d4a3f$export$a8c9209db4084317);
// @generated from time-data-gen.ts
// prettier-ignore  
var $6b3cbcf3680d4a3f$export$a8c9209db4084317 = {
    "001": [
        "H",
        "h"
    ],
    "419": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AS": [
        "h",
        "H"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "AX": [
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BI": [
        "H",
        "h"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "BO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "BQ": [
        "H"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BT": [
        "h",
        "H"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BY": [
        "H",
        "h"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CL": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CP": [
        "H"
    ],
    "CR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CU": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "CW": [
        "H",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CZ": [
        "H"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "DK": [
        "H"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EC": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "FI": [
        "H"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FO": [
        "H",
        "h"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GH": [
        "h",
        "H"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GL": [
        "H",
        "h"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GT": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HN": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "HU": [
        "H",
        "h"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ID": [
        "H"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IN": [
        "h",
        "H"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "IS": [
        "H"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JP": [
        "H",
        "K",
        "h"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LS": [
        "h",
        "H"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MG": [
        "H",
        "h"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ML": [
        "H"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MT": [
        "H",
        "h"
    ],
    "MU": [
        "H",
        "h"
    ],
    "MV": [
        "H",
        "h"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MX": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NE": [
        "H"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NI": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "NO": [
        "H",
        "h"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "PL": [
        "H",
        "h"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "PW": [
        "h",
        "H"
    ],
    "PY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "RU": [
        "H"
    ],
    "RW": [
        "H",
        "h"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SE": [
        "H"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "SO": [
        "h",
        "H"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "SV": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TH": [
        "H",
        "h"
    ],
    "TJ": [
        "H",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TM": [
        "H",
        "h"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VN": [
        "H",
        "h"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "WS": [
        "h",
        "H"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZW": [
        "H",
        "h"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-HK": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-IL": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "en-MY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ]
};

});




parcelRegister("3D21m", function(module, exports) {
$parcel$export(module.exports, "PART_TYPE", () => $2a4694ea9e338afb$export$49694c2877b44c57);
$parcel$export(module.exports, "isFormatXMLElementFn", () => $2a4694ea9e338afb$export$df0c12a2d414a163);
$parcel$export(module.exports, "formatToParts", () => $2a4694ea9e338afb$export$275d4a3bb5f66fda);
parcelRequire("9Sshd");
var $T96Ke = parcelRequire("T96Ke");

var $IShqa = parcelRequire("IShqa");
var $2a4694ea9e338afb$export$49694c2877b44c57;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})($2a4694ea9e338afb$export$49694c2877b44c57 || ($2a4694ea9e338afb$export$49694c2877b44c57 = {}));
function $2a4694ea9e338afb$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== $2a4694ea9e338afb$export$49694c2877b44c57.literal || part.type !== $2a4694ea9e338afb$export$49694c2877b44c57.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $2a4694ea9e338afb$export$df0c12a2d414a163(el) {
    return typeof el === 'function';
}
function $2a4694ea9e338afb$export$275d4a3bb5f66fda(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, $T96Ke.isLiteralElement)(els[0])) return [
        {
            type: $2a4694ea9e338afb$export$49694c2877b44c57.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, $T96Ke.isLiteralElement)(el)) {
            result.push({
                type: $2a4694ea9e338afb$export$49694c2877b44c57.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, $T96Ke.isPoundElement)(el)) {
            if (typeof currentPluralValue === 'number') result.push({
                type: $2a4694ea9e338afb$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new (0, $IShqa.MissingValueError)(varName, originalMessage);
        var value = values[varName];
        if ((0, $T96Ke.isArgumentElement)(el)) {
            if (!value || typeof value === 'string' || typeof value === 'number') value = typeof value === 'string' || typeof value === 'number' ? String(value) : '';
            result.push({
                type: typeof value === 'string' ? $2a4694ea9e338afb$export$49694c2877b44c57.literal : $2a4694ea9e338afb$export$49694c2877b44c57.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, $T96Ke.isDateElement)(el)) {
            var style = typeof el.style === 'string' ? formats.date[el.style] : (0, $T96Ke.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $2a4694ea9e338afb$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $T96Ke.isTimeElement)(el)) {
            var style = typeof el.style === 'string' ? formats.time[el.style] : (0, $T96Ke.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: $2a4694ea9e338afb$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $T96Ke.isNumberElement)(el)) {
            var style = typeof el.style === 'string' ? formats.number[el.style] : (0, $T96Ke.isNumberSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: $2a4694ea9e338afb$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $T96Ke.isTagElement)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!$2a4694ea9e338afb$export$df0c12a2d414a163(formatFn)) throw new (0, $IShqa.InvalidValueTypeError)(value_1, 'function', originalMessage);
            var parts = $2a4694ea9e338afb$export$275d4a3bb5f66fda(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === 'string' ? $2a4694ea9e338afb$export$49694c2877b44c57.literal : $2a4694ea9e338afb$export$49694c2877b44c57.object,
                    value: c
                };
            }));
        }
        if ((0, $T96Ke.isSelectElement)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new (0, $IShqa.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $2a4694ea9e338afb$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $T96Ke.isPluralElement)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new (0, $IShqa.FormatError)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $IShqa.ErrorCode).MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new (0, $IShqa.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $2a4694ea9e338afb$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return $2a4694ea9e338afb$var$mergeLiteral(result);
}

});
parcelRegister("IShqa", function(module, exports) {
$parcel$export(module.exports, "ErrorCode", () => $086e370cae217857$export$d4e71bc0b80dc0fb);
$parcel$export(module.exports, "FormatError", () => $086e370cae217857$export$7369836851cc1329);
$parcel$export(module.exports, "InvalidValueError", () => $086e370cae217857$export$565c3afc07dfa382);
$parcel$export(module.exports, "InvalidValueTypeError", () => $086e370cae217857$export$cbc0db47c750f7c9);
$parcel$export(module.exports, "MissingValueError", () => $086e370cae217857$export$8bfc137e4d23fdf0);

var $fvB0y = parcelRequire("fvB0y");
var $086e370cae217857$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})($086e370cae217857$export$d4e71bc0b80dc0fb || ($086e370cae217857$export$d4e71bc0b80dc0fb = {}));
var $086e370cae217857$export$7369836851cc1329 = /** @class */ function(_super) {
    (0, $fvB0y.__extends)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
var $086e370cae217857$export$565c3afc07dfa382 = /** @class */ function(_super) {
    (0, $fvB0y.__extends)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, "Invalid values for \"".concat(variableId, "\": \"").concat(value, "\". Options are \"").concat(Object.keys(options).join('", "'), "\""), $086e370cae217857$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}($086e370cae217857$export$7369836851cc1329);
var $086e370cae217857$export$cbc0db47c750f7c9 = /** @class */ function(_super) {
    (0, $fvB0y.__extends)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, "Value for \"".concat(value, "\" must be of type ").concat(type), $086e370cae217857$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}($086e370cae217857$export$7369836851cc1329);
var $086e370cae217857$export$8bfc137e4d23fdf0 = /** @class */ function(_super) {
    (0, $fvB0y.__extends)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, "The intl string context variable \"".concat(variableId, "\" was not provided to the string \"").concat(originalMessage, "\""), $086e370cae217857$export$d4e71bc0b80dc0fb.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}($086e370cae217857$export$7369836851cc1329);

});




parcelRegister("2cnzA", function(module, exports) {
$parcel$export(module.exports, "memoize", () => $199efcdaf8a58a2c$export$fc10aeed3a532e2a);
$parcel$export(module.exports, "strategies", () => $199efcdaf8a58a2c$export$c5491a8691a23b9e);
//
// Main
//
function $199efcdaf8a58a2c$export$fc10aeed3a532e2a(fn, options) {
    var cache = options && options.cache ? options.cache : $199efcdaf8a58a2c$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $199efcdaf8a58a2c$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $199efcdaf8a58a2c$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $199efcdaf8a58a2c$var$isPrimitive(value) {
    return value == null || typeof value === 'number' || typeof value === 'boolean'; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $199efcdaf8a58a2c$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $199efcdaf8a58a2c$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $199efcdaf8a58a2c$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $199efcdaf8a58a2c$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $199efcdaf8a58a2c$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $199efcdaf8a58a2c$var$monadic : $199efcdaf8a58a2c$var$variadic;
    return $199efcdaf8a58a2c$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $199efcdaf8a58a2c$var$strategyVariadic(fn, options) {
    return $199efcdaf8a58a2c$var$assemble(fn, this, $199efcdaf8a58a2c$var$variadic, options.cache.create(), options.serializer);
}
function $199efcdaf8a58a2c$var$strategyMonadic(fn, options) {
    return $199efcdaf8a58a2c$var$assemble(fn, this, $199efcdaf8a58a2c$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $199efcdaf8a58a2c$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
function $199efcdaf8a58a2c$var$ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
$199efcdaf8a58a2c$var$ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
$199efcdaf8a58a2c$var$ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var $199efcdaf8a58a2c$var$cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new $199efcdaf8a58a2c$var$ObjectWithoutPrototypeCache();
    }
};
var $199efcdaf8a58a2c$export$c5491a8691a23b9e = {
    variadic: $199efcdaf8a58a2c$var$strategyVariadic,
    monadic: $199efcdaf8a58a2c$var$strategyMonadic
};

});

parcelRegister("gYfDQ", function(module, exports) {
$parcel$export(module.exports, "IntlErrorCode", () => $c5ae6204fb785680$export$557d6acb76e8a244);
$parcel$export(module.exports, "IntlError", () => $c5ae6204fb785680$export$c016d36112f6ddf8);
$parcel$export(module.exports, "UnsupportedFormatterError", () => $c5ae6204fb785680$export$549f97e137a05c90);
$parcel$export(module.exports, "InvalidConfigError", () => $c5ae6204fb785680$export$3ca04dd7fb305893);
$parcel$export(module.exports, "MissingDataError", () => $c5ae6204fb785680$export$c1eaf877d81384b6);
$parcel$export(module.exports, "IntlFormatError", () => $c5ae6204fb785680$export$e3b7eee1dbc44895);
$parcel$export(module.exports, "MessageFormatError", () => $c5ae6204fb785680$export$74a601a3d3f31621);
$parcel$export(module.exports, "MissingTranslationError", () => $c5ae6204fb785680$export$2ddcb436d0aa3688);

var $fvB0y = parcelRequire("fvB0y");
var $c5ae6204fb785680$export$557d6acb76e8a244;
(function(IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
})($c5ae6204fb785680$export$557d6acb76e8a244 || ($c5ae6204fb785680$export$557d6acb76e8a244 = {}));
var $c5ae6204fb785680$export$c016d36112f6ddf8 = /** @class */ function(_super) {
    (0, $fvB0y.__extends)(IntlError, _super);
    function IntlError(code, message, exception) {
        var _this = this;
        var err = exception ? exception instanceof Error ? exception : new Error(String(exception)) : undefined;
        _this = _super.call(this, "[@formatjs/intl Error ".concat(code, "] ").concat(message, "\n").concat(err ? "\n".concat(err.message, "\n").concat(err.stack) : '')) || this;
        _this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === 'function') // @ts-ignore just so we don't need to declare dep on @types/node
        Error.captureStackTrace(_this, IntlError);
        return _this;
    }
    return IntlError;
}(Error);
var $c5ae6204fb785680$export$549f97e137a05c90 = /** @class */ function(_super) {
    (0, $fvB0y.__extends)(UnsupportedFormatterError, _super);
    function UnsupportedFormatterError(message, exception) {
        return _super.call(this, $c5ae6204fb785680$export$557d6acb76e8a244.UNSUPPORTED_FORMATTER, message, exception) || this;
    }
    return UnsupportedFormatterError;
}($c5ae6204fb785680$export$c016d36112f6ddf8);
var $c5ae6204fb785680$export$3ca04dd7fb305893 = /** @class */ function(_super) {
    (0, $fvB0y.__extends)(InvalidConfigError, _super);
    function InvalidConfigError(message, exception) {
        return _super.call(this, $c5ae6204fb785680$export$557d6acb76e8a244.INVALID_CONFIG, message, exception) || this;
    }
    return InvalidConfigError;
}($c5ae6204fb785680$export$c016d36112f6ddf8);
var $c5ae6204fb785680$export$c1eaf877d81384b6 = /** @class */ function(_super) {
    (0, $fvB0y.__extends)(MissingDataError, _super);
    function MissingDataError(message, exception) {
        return _super.call(this, $c5ae6204fb785680$export$557d6acb76e8a244.MISSING_DATA, message, exception) || this;
    }
    return MissingDataError;
}($c5ae6204fb785680$export$c016d36112f6ddf8);
var $c5ae6204fb785680$export$e3b7eee1dbc44895 = /** @class */ function(_super) {
    (0, $fvB0y.__extends)(IntlFormatError, _super);
    function IntlFormatError(message, locale, exception) {
        var _this = _super.call(this, $c5ae6204fb785680$export$557d6acb76e8a244.FORMAT_ERROR, "".concat(message, "\nLocale: ").concat(locale, "\n"), exception) || this;
        _this.locale = locale;
        return _this;
    }
    return IntlFormatError;
}($c5ae6204fb785680$export$c016d36112f6ddf8);
var $c5ae6204fb785680$export$74a601a3d3f31621 = /** @class */ function(_super) {
    (0, $fvB0y.__extends)(MessageFormatError, _super);
    function MessageFormatError(message, locale, descriptor, exception) {
        var _this = _super.call(this, "".concat(message, "\nMessageID: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.id, "\nDefault Message: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage, "\nDescription: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.description, "\n"), locale, exception) || this;
        _this.descriptor = descriptor;
        _this.locale = locale;
        return _this;
    }
    return MessageFormatError;
}($c5ae6204fb785680$export$e3b7eee1dbc44895);
var $c5ae6204fb785680$export$2ddcb436d0aa3688 = /** @class */ function(_super) {
    (0, $fvB0y.__extends)(MissingTranslationError, _super);
    function MissingTranslationError(descriptor, locale) {
        var _this = _super.call(this, $c5ae6204fb785680$export$557d6acb76e8a244.MISSING_TRANSLATION, "Missing message: \"".concat(descriptor.id, "\" for locale \"").concat(locale, "\", using ").concat(descriptor.defaultMessage ? "default message (".concat(typeof descriptor.defaultMessage === 'string' ? descriptor.defaultMessage : descriptor.defaultMessage.map(function(e) {
            var _a;
            return (_a = e.value) !== null && _a !== void 0 ? _a : JSON.stringify(e);
        }).join(), ")") : 'id', " as fallback.")) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MissingTranslationError;
}($c5ae6204fb785680$export$c016d36112f6ddf8);

});



parcelRegister("8N0QD", function(module, exports) {
$parcel$export(module.exports, "default", () => $66638eb6451d0cc9$export$2e2bcd8739ae039);

var $4tluv = parcelRequire("4tluv");

var $7Yd05 = parcelRequire("7Yd05");

var $60jme = parcelRequire("60jme");
function $66638eb6451d0cc9$export$2e2bcd8739ae039() {
    var intl = $4tluv.useContext((0, $60jme.Context));
    (0, $7Yd05.invariantIntlContext)(intl);
    return intl;
}

});
parcelRegister("60jme", function(module, exports) {
$parcel$export(module.exports, "Provider", () => $45f1c227afba5999$export$2881499e37b75b9a);
$parcel$export(module.exports, "Context", () => $45f1c227afba5999$export$841858b892ce1f4c);
$parcel$export(module.exports, "default", () => $45f1c227afba5999$export$2e2bcd8739ae039);

var $fvB0y = parcelRequire("fvB0y");

var $523n4 = parcelRequire("523n4");

var $4tluv = parcelRequire("4tluv");

var $7Yd05 = parcelRequire("7Yd05");
function $45f1c227afba5999$var$getDisplayName(Component) {
    return Component.displayName || Component.name || 'Component';
}
// This is primarily dealing with packaging systems where multiple copies of react-intl
// might exist
var $45f1c227afba5999$var$IntlContext = typeof window !== 'undefined' && !window.__REACT_INTL_BYPASS_GLOBAL_CONTEXT__ ? window.__REACT_INTL_CONTEXT__ || (window.__REACT_INTL_CONTEXT__ = $4tluv.createContext(null)) : $4tluv.createContext(null);
var $45f1c227afba5999$var$IntlConsumer = $45f1c227afba5999$var$IntlContext.Consumer, $45f1c227afba5999$var$IntlProvider = $45f1c227afba5999$var$IntlContext.Provider;
var $45f1c227afba5999$export$2881499e37b75b9a = $45f1c227afba5999$var$IntlProvider;
var $45f1c227afba5999$export$841858b892ce1f4c = $45f1c227afba5999$var$IntlContext;
function $45f1c227afba5999$export$2e2bcd8739ae039(WrappedComponent, options) {
    var _a = options || {}, _b = _a.intlPropName, intlPropName = _b === void 0 ? 'intl' : _b, _c = _a.forwardRef, forwardRef = _c === void 0 ? false : _c, _d = _a.enforceContext, enforceContext = _d === void 0 ? true : _d;
    var WithIntl = function(props) {
        return $4tluv.createElement($45f1c227afba5999$var$IntlConsumer, null, function(intl) {
            var _a;
            if (enforceContext) (0, $7Yd05.invariantIntlContext)(intl);
            var intlProp = (_a = {}, _a[intlPropName] = intl, _a);
            return $4tluv.createElement(WrappedComponent, (0, $fvB0y.__assign)({}, props, intlProp, {
                ref: forwardRef ? props.forwardedRef : null
            }));
        });
    };
    WithIntl.displayName = "injectIntl(".concat($45f1c227afba5999$var$getDisplayName(WrappedComponent), ")");
    WithIntl.WrappedComponent = WrappedComponent;
    if (forwardRef) return (0, (/*@__PURE__*/$parcel$interopDefault($523n4)))(// @ts-expect-error
    $4tluv.forwardRef(function(props, ref) {
        return $4tluv.createElement(WithIntl, (0, $fvB0y.__assign)({}, props, {
            forwardedRef: ref
        }));
    }), WrappedComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($523n4)))(WithIntl, WrappedComponent);
}

});





parcelRegister("488Th", function(module, exports) {
$parcel$export(module.exports, "AccountMenuTriggerNav3", () => $f50c138527f1fd61$export$89d857133932d6aa);
/* nav3.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");

var $jAkMr = parcelRequire("jAkMr");

var $4tluv = parcelRequire("4tluv");

var $8N0QD = parcelRequire("8N0QD");

var $7AQ8L = parcelRequire("7AQ8L");

var $eKPYN = parcelRequire("eKPYN");

var $gcMg7 = parcelRequire("gcMg7");

var $jD2WP = parcelRequire("jD2WP");
const $f50c138527f1fd61$var$imgStyles = null;
const $f50c138527f1fd61$export$89d857133932d6aa = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).forwardRef(({ picture: picture, email: email, trustPicture: trustPicture = false, ...props }, ref)=>{
    const intl = (0, $8N0QD.default)();
    const state = (0, $gcMg7.useImageState)(picture || '');
    const tooltip = intl.formatMessage((0, $jD2WP.messages).triggerTooltip);
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $7AQ8L.Profile), {
        ...props,
        ref: ref,
        tooltip: email || tooltip,
        icon: picture && (trustPicture || state === 'loaded') ? /*#__PURE__*/ (0, $2iln5.jsx)("img", {
            src: picture,
            alt: tooltip,
            className: (0, $jAkMr.default)([
                "_2rko1rr0 _1bsb1ejb _4t3i1ejb"
            ])
        }) : /*#__PURE__*/ (0, $2iln5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eKPYN))), {
            color: "currentColor",
            label: tooltip,
            spacing: "spacious"
        })
    });
});

});
parcelRegister("eKPYN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e5a2b32fe863ac429d199dc8b174e3b3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $abddaea42f0bf404$var$_react = $abddaea42f0bf404$var$_interopRequireDefault((parcelRequire("4tluv")));

var $abddaea42f0bf404$var$_baseNew = $abddaea42f0bf404$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $abddaea42f0bf404$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PersonAvatar".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for user avatar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $abddaea42f0bf404$var$PersonAvatarIcon = (props)=>/*#__PURE__*/ $abddaea42f0bf404$var$_react.default.createElement($abddaea42f0bf404$var$_baseNew.default, Object.assign({
        name: "PersonAvatarIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 0 0-4.148 11.505A2.75 2.75 0 0 1 6.5 11h3c1.26 0 2.323.848 2.648 2.005A6.5 6.5 0 0 0 8 1.5m2.75 12.392v-.142c0-.69-.56-1.25-1.25-1.25h-3c-.69 0-1.25.56-1.25 1.25v.142l.06.027c.82.373 1.73.581 2.69.581s1.87-.208 2.69-.58q.03-.016.06-.028M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-3.5a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-3.5 2a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" clip-rule="evenodd"/>`
    }, props));
$abddaea42f0bf404$var$PersonAvatarIcon.displayName = 'PersonAvatarIcon';
var $abddaea42f0bf404$var$_default = module.exports.default = $abddaea42f0bf404$var$PersonAvatarIcon;

});

parcelRegister("gcMg7", function(module, exports) {
$parcel$export(module.exports, "useImageState", () => $f6120d294e8664a0$export$2c1df3428fc3264c);

var $4tluv = parcelRequire("4tluv");
const $f6120d294e8664a0$export$2c1df3428fc3264c = (src)=>{
    const [state, setState] = (0, $4tluv.useState)('pending');
    const imgRef = (0, $4tluv.useRef)();
    (0, $4tluv.useEffect)(()=>{
        if (!imgRef.current) {
            imgRef.current = new Image();
            imgRef.current.onload = ()=>setState('loaded');
            imgRef.current.onerror = ()=>setState('error');
        }
        setState('pending');
        imgRef.current.src = src;
    }, [
        src
    ]);
    return state;
};

});

parcelRegister("jD2WP", function(module, exports) {
$parcel$export(module.exports, "messages", () => $3dae549e470a6b1e$export$defe85febe8b728c);

var $DII3D = parcelRequire("DII3D");
const $3dae549e470a6b1e$export$defe85febe8b728c = (0, $DII3D.defineMessages)({
    triggerTooltip: {
        id: 'identity.account-menu.account-menu-popup.skeleton.tooltip',
        defaultMessage: 'Account',
        description: 'Tooltip and alt-text for the account menu item'
    }
});

});
parcelRegister("DII3D", function(module, exports) {
$parcel$export(module.exports, "defineMessages", () => $077653078e761679$export$1adfeb024f5185b);
$parcel$export(module.exports, "defineMessage", () => $077653078e761679$export$747d244ee58120dd);
$parcel$export(module.exports, "FormattedDate", () => $077653078e761679$export$40ae3194919d16b);
$parcel$export(module.exports, "FormattedTime", () => $077653078e761679$export$5b390a54f8a846f7);
$parcel$export(module.exports, "FormattedNumber", () => $077653078e761679$export$db80edc1e6b2f63d);
$parcel$export(module.exports, "FormattedList", () => $077653078e761679$export$f52b44e459e6e71d);
$parcel$export(module.exports, "FormattedDisplayName", () => $077653078e761679$export$c2336ea5aaab92fa);
$parcel$export(module.exports, "FormattedDateParts", () => $077653078e761679$export$7fdc7d2c91ce149b);
$parcel$export(module.exports, "FormattedTimeParts", () => $077653078e761679$export$ec35873761676c2a);
$parcel$export(module.exports, "FormattedDateTimeRange", () => (parcelRequire("2o0fk")).default);
$parcel$export(module.exports, "FormattedMessage", () => (parcelRequire("9KeuJ")).default);
$parcel$export(module.exports, "FormattedPlural", () => (parcelRequire("fgAxl")).default);
$parcel$export(module.exports, "FormattedRelativeTime", () => (parcelRequire("99bjV")).default);
$parcel$export(module.exports, "IntlContext", () => (parcelRequire("60jme")).Context);
$parcel$export(module.exports, "IntlProvider", () => (parcelRequire("9XHz1")).default);
$parcel$export(module.exports, "RawIntlProvider", () => (parcelRequire("60jme")).Provider);
$parcel$export(module.exports, "createIntl", () => (parcelRequire("k8Jlo")).createIntl);
$parcel$export(module.exports, "injectIntl", () => (parcelRequire("60jme")).default);
$parcel$export(module.exports, "useIntl", () => (parcelRequire("8N0QD")).default);
$parcel$export(module.exports, "createIntlCache", () => (parcelRequire("llr7m")).createIntlCache);
$parcel$export(module.exports, "UnsupportedFormatterError", () => (parcelRequire("gYfDQ")).UnsupportedFormatterError);
$parcel$export(module.exports, "InvalidConfigError", () => (parcelRequire("gYfDQ")).InvalidConfigError);
$parcel$export(module.exports, "MissingDataError", () => (parcelRequire("gYfDQ")).MissingDataError);
$parcel$export(module.exports, "MessageFormatError", () => (parcelRequire("gYfDQ")).MessageFormatError);
$parcel$export(module.exports, "MissingTranslationError", () => (parcelRequire("gYfDQ")).MissingTranslationError);
$parcel$export(module.exports, "ReactIntlErrorCode", () => (parcelRequire("gYfDQ")).IntlErrorCode);
$parcel$export(module.exports, "ReactIntlError", () => (parcelRequire("gYfDQ")).IntlError);
$parcel$export(module.exports, "FormattedNumberParts", () => (parcelRequire("eOUtE")).FormattedNumberParts);
$parcel$export(module.exports, "FormattedListParts", () => (parcelRequire("eOUtE")).FormattedListParts);

var $eOUtE = parcelRequire("eOUtE");

var $60jme = parcelRequire("60jme");

var $8N0QD = parcelRequire("8N0QD");

var $9XHz1 = parcelRequire("9XHz1");

var $k8Jlo = parcelRequire("k8Jlo");

var $99bjV = parcelRequire("99bjV");

var $fgAxl = parcelRequire("fgAxl");

var $9KeuJ = parcelRequire("9KeuJ");

var $2o0fk = parcelRequire("2o0fk");

var $llr7m = parcelRequire("llr7m");
var $gYfDQ = parcelRequire("gYfDQ");
function $077653078e761679$export$1adfeb024f5185b(msgs) {
    return msgs;
}
function $077653078e761679$export$747d244ee58120dd(msg) {
    return msg;
}
var $077653078e761679$export$40ae3194919d16b = (0, $eOUtE.createFormattedComponent)('formatDate');
var $077653078e761679$export$5b390a54f8a846f7 = (0, $eOUtE.createFormattedComponent)('formatTime');
var $077653078e761679$export$db80edc1e6b2f63d = (0, $eOUtE.createFormattedComponent)('formatNumber');
var $077653078e761679$export$f52b44e459e6e71d = (0, $eOUtE.createFormattedComponent)('formatList');
var $077653078e761679$export$c2336ea5aaab92fa = (0, $eOUtE.createFormattedComponent)('formatDisplayName');
var $077653078e761679$export$7fdc7d2c91ce149b = (0, $eOUtE.createFormattedDateTimePartsComponent)('formatDate');
var $077653078e761679$export$ec35873761676c2a = (0, $eOUtE.createFormattedDateTimePartsComponent)('formatTime');

});
parcelRegister("eOUtE", function(module, exports) {
$parcel$export(module.exports, "FormattedNumberParts", () => $aca18b66d565e27f$export$54d4989ed3eea1ea);
$parcel$export(module.exports, "FormattedListParts", () => $aca18b66d565e27f$export$5ac259c7da6d2188);
$parcel$export(module.exports, "createFormattedDateTimePartsComponent", () => $aca18b66d565e27f$export$7448277f6036d2ab);
$parcel$export(module.exports, "createFormattedComponent", () => $aca18b66d565e27f$export$b37e14176d001dec);

var $fvB0y = parcelRequire("fvB0y");

var $4tluv = parcelRequire("4tluv");

var $8N0QD = parcelRequire("8N0QD");
var $aca18b66d565e27f$var$DisplayName;
(function(DisplayName) {
    DisplayName["formatDate"] = "FormattedDate";
    DisplayName["formatTime"] = "FormattedTime";
    DisplayName["formatNumber"] = "FormattedNumber";
    DisplayName["formatList"] = "FormattedList";
    // Note that this DisplayName is the locale display name, not to be confused with
    // the name of the enum, which is for React component display name in dev tools.
    DisplayName["formatDisplayName"] = "FormattedDisplayName";
})($aca18b66d565e27f$var$DisplayName || ($aca18b66d565e27f$var$DisplayName = {}));
var $aca18b66d565e27f$var$DisplayNameParts;
(function(DisplayNameParts) {
    DisplayNameParts["formatDate"] = "FormattedDateParts";
    DisplayNameParts["formatTime"] = "FormattedTimeParts";
    DisplayNameParts["formatNumber"] = "FormattedNumberParts";
    DisplayNameParts["formatList"] = "FormattedListParts";
})($aca18b66d565e27f$var$DisplayNameParts || ($aca18b66d565e27f$var$DisplayNameParts = {}));
var $aca18b66d565e27f$export$54d4989ed3eea1ea = function(props) {
    var intl = (0, $8N0QD.default)();
    var value = props.value, children = props.children, formatProps = (0, $fvB0y.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatNumberToParts(value, formatProps));
};
$aca18b66d565e27f$export$54d4989ed3eea1ea.displayName = 'FormattedNumberParts';
var $aca18b66d565e27f$export$5ac259c7da6d2188 = function(props) {
    var intl = (0, $8N0QD.default)();
    var value = props.value, children = props.children, formatProps = (0, $fvB0y.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatListToParts(value, formatProps));
};
$aca18b66d565e27f$export$54d4989ed3eea1ea.displayName = 'FormattedNumberParts';
function $aca18b66d565e27f$export$7448277f6036d2ab(name) {
    var ComponentParts = function(props) {
        var intl = (0, $8N0QD.default)();
        var value = props.value, children = props.children, formatProps = (0, $fvB0y.__rest)(props, [
            "value",
            "children"
        ]);
        var date = typeof value === 'string' ? new Date(value || 0) : value;
        var formattedParts = name === 'formatDate' ? intl.formatDateToParts(date, formatProps) : intl.formatTimeToParts(date, formatProps);
        return children(formattedParts);
    };
    ComponentParts.displayName = $aca18b66d565e27f$var$DisplayNameParts[name];
    return ComponentParts;
}
function $aca18b66d565e27f$export$b37e14176d001dec(name) {
    var Component = function(props) {
        var intl = (0, $8N0QD.default)();
        var value = props.value, children = props.children, formatProps = (0, $fvB0y.__rest)(props, [
            "value",
            "children"
        ]);
        // TODO: fix TS type definition for localeMatcher upstream
        var formattedValue = intl[name](value, formatProps);
        if (typeof children === 'function') return children(formattedValue);
        var Text = intl.textComponent || $4tluv.Fragment;
        return $4tluv.createElement(Text, null, formattedValue);
    };
    Component.displayName = $aca18b66d565e27f$var$DisplayName[name];
    return Component;
}

});

parcelRegister("9XHz1", function(module, exports) {
$parcel$export(module.exports, "default", () => $740b6aa35223e47f$export$2e2bcd8739ae039);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $fvB0y = parcelRequire("fvB0y");

var $llr7m = parcelRequire("llr7m");

var $4tluv = parcelRequire("4tluv");

var $7Yd05 = parcelRequire("7Yd05");

var $60jme = parcelRequire("60jme");

var $k8Jlo = parcelRequire("k8Jlo");
function $740b6aa35223e47f$var$processIntlConfig(config) {
    return {
        locale: config.locale,
        timeZone: config.timeZone,
        fallbackOnEmptyString: config.fallbackOnEmptyString,
        formats: config.formats,
        textComponent: config.textComponent,
        messages: config.messages,
        defaultLocale: config.defaultLocale,
        defaultFormats: config.defaultFormats,
        onError: config.onError,
        onWarn: config.onWarn,
        wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment,
        defaultRichTextElements: config.defaultRichTextElements
    };
}
var $740b6aa35223e47f$var$IntlProvider = /** @class */ function(_super) {
    (0, $fvB0y.__extends)(IntlProvider, _super);
    function IntlProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = (0, $llr7m.createIntlCache)();
        _this.state = {
            cache: _this.cache,
            intl: (0, $k8Jlo.createIntl)($740b6aa35223e47f$var$processIntlConfig(_this.props), _this.cache),
            prevConfig: $740b6aa35223e47f$var$processIntlConfig(_this.props)
        };
        return _this;
    }
    IntlProvider.getDerivedStateFromProps = function(props, _a) {
        var prevConfig = _a.prevConfig, cache = _a.cache;
        var config = $740b6aa35223e47f$var$processIntlConfig(props);
        if (!(0, $7Yd05.shallowEqual)(prevConfig, config)) return {
            intl: (0, $k8Jlo.createIntl)(config, cache),
            prevConfig: config
        };
        return null;
    };
    IntlProvider.prototype.render = function() {
        (0, $7Yd05.invariantIntlContext)(this.state.intl);
        return $4tluv.createElement((0, $60jme.Provider), {
            value: this.state.intl
        }, this.props.children);
    };
    IntlProvider.displayName = 'IntlProvider';
    IntlProvider.defaultProps = (0, $7Yd05.DEFAULT_INTL_CONFIG);
    return IntlProvider;
}($4tluv.PureComponent);
var $740b6aa35223e47f$export$2e2bcd8739ae039 = $740b6aa35223e47f$var$IntlProvider;

});
parcelRegister("k8Jlo", function(module, exports) {
$parcel$export(module.exports, "createIntl", () => $ea97ba64bfd6e70e$export$7e4cbedfdd7b4c0d);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $fvB0y = parcelRequire("fvB0y");

var $461qk = parcelRequire("461qk");
var $69xPp = parcelRequire("69xPp");

var $4tluv = parcelRequire("4tluv");

var $7Yd05 = parcelRequire("7Yd05");

var $3D21m = parcelRequire("3D21m");
function $ea97ba64bfd6e70e$var$assignUniqueKeysToFormatXMLElementFnArgument(values) {
    if (!values) return values;
    return Object.keys(values).reduce(function(acc, k) {
        var v = values[k];
        acc[k] = (0, $3D21m.isFormatXMLElementFn)(v) ? (0, $7Yd05.assignUniqueKeysToParts)(v) : v;
        return acc;
    }, {});
}
var $ea97ba64bfd6e70e$var$formatMessage = function(config, formatters, descriptor, rawValues) {
    var rest = [];
    for(var _i = 4; _i < arguments.length; _i++)rest[_i - 4] = arguments[_i];
    var values = $ea97ba64bfd6e70e$var$assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
    var chunks = (0, $69xPp.formatMessage).apply(void 0, (0, $fvB0y.__spreadArray)([
        config,
        formatters,
        descriptor,
        values
    ], rest, false));
    if (Array.isArray(chunks)) return $4tluv.Children.toArray(chunks);
    return chunks;
};
var $ea97ba64bfd6e70e$export$7e4cbedfdd7b4c0d = function(_a, cache) {
    var rawDefaultRichTextElements = _a.defaultRichTextElements, config = (0, $fvB0y.__rest)(_a, [
        "defaultRichTextElements"
    ]);
    var defaultRichTextElements = $ea97ba64bfd6e70e$var$assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
    var coreIntl = (0, $461qk.createIntl)((0, $fvB0y.__assign)((0, $fvB0y.__assign)((0, $fvB0y.__assign)({}, (0, $7Yd05.DEFAULT_INTL_CONFIG)), config), {
        defaultRichTextElements: defaultRichTextElements
    }), cache);
    var resolvedConfig = {
        locale: coreIntl.locale,
        timeZone: coreIntl.timeZone,
        fallbackOnEmptyString: coreIntl.fallbackOnEmptyString,
        formats: coreIntl.formats,
        defaultLocale: coreIntl.defaultLocale,
        defaultFormats: coreIntl.defaultFormats,
        messages: coreIntl.messages,
        onError: coreIntl.onError,
        defaultRichTextElements: defaultRichTextElements
    };
    return (0, $fvB0y.__assign)((0, $fvB0y.__assign)({}, coreIntl), {
        formatMessage: $ea97ba64bfd6e70e$var$formatMessage.bind(null, resolvedConfig, // @ts-expect-error fix this
        coreIntl.formatters),
        // @ts-expect-error fix this
        $t: $ea97ba64bfd6e70e$var$formatMessage.bind(null, resolvedConfig, coreIntl.formatters)
    });
};

});
parcelRegister("461qk", function(module, exports) {
$parcel$export(module.exports, "createIntl", () => $2fb8d3a784fad9e6$export$7e4cbedfdd7b4c0d);

var $fvB0y = parcelRequire("fvB0y");

var $llr7m = parcelRequire("llr7m");

var $gYfDQ = parcelRequire("gYfDQ");

var $ivX3l = parcelRequire("ivX3l");

var $a6JhC = parcelRequire("a6JhC");

var $1q1p7 = parcelRequire("1q1p7");

var $6AOze = parcelRequire("6AOze");

var $69xPp = parcelRequire("69xPp");

var $grF3X = parcelRequire("grF3X");

var $lwlBb = parcelRequire("lwlBb");
function $2fb8d3a784fad9e6$var$messagesContainString(messages) {
    var firstMessage = messages ? messages[Object.keys(messages)[0]] : undefined;
    return typeof firstMessage === 'string';
}
function $2fb8d3a784fad9e6$var$verifyConfigMessages(config) {
    if (config.onWarn && config.defaultRichTextElements && $2fb8d3a784fad9e6$var$messagesContainString(config.messages || {})) config.onWarn("[@formatjs/intl] \"defaultRichTextElements\" was specified but \"message\" was not pre-compiled. \nPlease consider using \"@formatjs/cli\" to pre-compile your messages for performance.\nFor more details see https://formatjs.io/docs/getting-started/message-distribution");
}
function $2fb8d3a784fad9e6$export$7e4cbedfdd7b4c0d(config, cache) {
    var formatters = (0, $llr7m.createFormatters)(cache);
    var resolvedConfig = (0, $fvB0y.__assign)((0, $fvB0y.__assign)({}, (0, $llr7m.DEFAULT_INTL_CONFIG)), config);
    var locale = resolvedConfig.locale, defaultLocale = resolvedConfig.defaultLocale, onError = resolvedConfig.onError;
    if (!locale) {
        if (onError) onError(new (0, $gYfDQ.InvalidConfigError)("\"locale\" was not configured, using \"".concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl/api#intlshape for more details")));
        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        resolvedConfig.locale = resolvedConfig.defaultLocale || 'en';
    } else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $gYfDQ.MissingDataError)("Missing locale data for locale: \"".concat(locale, "\" in Intl.NumberFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details")));
    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $gYfDQ.MissingDataError)("Missing locale data for locale: \"".concat(locale, "\" in Intl.DateTimeFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details")));
    $2fb8d3a784fad9e6$var$verifyConfigMessages(resolvedConfig);
    return (0, $fvB0y.__assign)((0, $fvB0y.__assign)({}, resolvedConfig), {
        formatters: formatters,
        formatNumber: (0, $ivX3l.formatNumber).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatNumberToParts: (0, $ivX3l.formatNumberToParts).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatRelativeTime: (0, $a6JhC.formatRelativeTime).bind(null, resolvedConfig, formatters.getRelativeTimeFormat),
        formatDate: (0, $1q1p7.formatDate).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateToParts: (0, $1q1p7.formatDateToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTime: (0, $1q1p7.formatTime).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateTimeRange: (0, $1q1p7.formatDateTimeRange).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTimeToParts: (0, $1q1p7.formatTimeToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatPlural: (0, $6AOze.formatPlural).bind(null, resolvedConfig, formatters.getPluralRules),
        // @ts-expect-error TODO: will get to this later
        formatMessage: (0, $69xPp.formatMessage).bind(null, resolvedConfig, formatters),
        // @ts-expect-error TODO: will get to this later
        $t: (0, $69xPp.formatMessage).bind(null, resolvedConfig, formatters),
        formatList: (0, $grF3X.formatList).bind(null, resolvedConfig, formatters.getListFormat),
        formatListToParts: (0, $grF3X.formatListToParts).bind(null, resolvedConfig, formatters.getListFormat),
        formatDisplayName: (0, $lwlBb.formatDisplayName).bind(null, resolvedConfig, formatters.getDisplayNames)
    });
}

});
parcelRegister("ivX3l", function(module, exports) {
$parcel$export(module.exports, "formatNumber", () => $d7a8edeb1e73ebea$export$f5dd818bff069720);
$parcel$export(module.exports, "formatNumberToParts", () => $d7a8edeb1e73ebea$export$6871080848f10b2f);

var $gYfDQ = parcelRequire("gYfDQ");

var $llr7m = parcelRequire("llr7m");
var $d7a8edeb1e73ebea$var$NUMBER_FORMAT_OPTIONS = [
    'style',
    'currency',
    'unit',
    'unitDisplay',
    'useGrouping',
    'minimumIntegerDigits',
    'minimumFractionDigits',
    'maximumFractionDigits',
    'minimumSignificantDigits',
    'maximumSignificantDigits',
    // ES2020 NumberFormat
    'compactDisplay',
    'currencyDisplay',
    'currencySign',
    'notation',
    'signDisplay',
    'unit',
    'unitDisplay',
    'numberingSystem',
    // ES2023 NumberFormat
    'trailingZeroDisplay',
    'roundingPriority',
    'roundingIncrement',
    'roundingMode'
];
function $d7a8edeb1e73ebea$export$a7f9565e3c81cd54(_a, getNumberFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = format && (0, $llr7m.getNamedFormat)(formats, 'number', format, onError) || {};
    var filteredOptions = (0, $llr7m.filterProps)(options, $d7a8edeb1e73ebea$var$NUMBER_FORMAT_OPTIONS, defaults);
    return getNumberFormat(locale, filteredOptions);
}
function $d7a8edeb1e73ebea$export$f5dd818bff069720(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $d7a8edeb1e73ebea$export$a7f9565e3c81cd54(config, getNumberFormat, options).format(value);
    } catch (e) {
        config.onError(new (0, $gYfDQ.IntlFormatError)('Error formatting number.', config.locale, e));
    }
    return String(value);
}
function $d7a8edeb1e73ebea$export$6871080848f10b2f(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $d7a8edeb1e73ebea$export$a7f9565e3c81cd54(config, getNumberFormat, options).formatToParts(value);
    } catch (e) {
        config.onError(new (0, $gYfDQ.IntlFormatError)('Error formatting number.', config.locale, e));
    }
    return [];
}

});

parcelRegister("a6JhC", function(module, exports) {
$parcel$export(module.exports, "formatRelativeTime", () => $75bd973d6a7b9c86$export$b4ea3b48dcf921f6);

var $llr7m = parcelRequire("llr7m");

var $IShqa = parcelRequire("IShqa");

var $gYfDQ = parcelRequire("gYfDQ");
var $75bd973d6a7b9c86$var$RELATIVE_TIME_FORMAT_OPTIONS = [
    'numeric',
    'style'
];
function $75bd973d6a7b9c86$var$getFormatter(_a, getRelativeTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = !!format && (0, $llr7m.getNamedFormat)(formats, 'relative', format, onError) || {};
    var filteredOptions = (0, $llr7m.filterProps)(options, $75bd973d6a7b9c86$var$RELATIVE_TIME_FORMAT_OPTIONS, defaults);
    return getRelativeTimeFormat(locale, filteredOptions);
}
function $75bd973d6a7b9c86$export$b4ea3b48dcf921f6(config, getRelativeTimeFormat, value, unit, options) {
    if (options === void 0) options = {};
    if (!unit) unit = 'second';
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    if (!RelativeTimeFormat) config.onError(new (0, $IShqa.FormatError)("Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-relativetimeformat\"\n", (0, $IShqa.ErrorCode).MISSING_INTL_API));
    try {
        return $75bd973d6a7b9c86$var$getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
    } catch (e) {
        config.onError(new (0, $gYfDQ.IntlFormatError)('Error formatting relative time.', config.locale, e));
    }
    return String(value);
}

});

parcelRegister("1q1p7", function(module, exports) {
$parcel$export(module.exports, "formatDate", () => $10894ef816054fd6$export$3ae94a2503e890a1);
$parcel$export(module.exports, "formatTime", () => $10894ef816054fd6$export$3203edd9e5edd663);
$parcel$export(module.exports, "formatDateTimeRange", () => $10894ef816054fd6$export$a7fc3a91cb2ec376);
$parcel$export(module.exports, "formatDateToParts", () => $10894ef816054fd6$export$dc1f059bce486b1);
$parcel$export(module.exports, "formatTimeToParts", () => $10894ef816054fd6$export$af6e5d7a5c73edeb);

var $fvB0y = parcelRequire("fvB0y");

var $llr7m = parcelRequire("llr7m");

var $gYfDQ = parcelRequire("gYfDQ");
var $10894ef816054fd6$var$DATE_TIME_FORMAT_OPTIONS = [
    'formatMatcher',
    'timeZone',
    'hour12',
    'weekday',
    'era',
    'year',
    'month',
    'day',
    'hour',
    'minute',
    'second',
    'timeZoneName',
    'hourCycle',
    'dateStyle',
    'timeStyle',
    'calendar',
    // 'dayPeriod',
    'numberingSystem',
    'fractionalSecondDigits'
];
function $10894ef816054fd6$export$a7f9565e3c81cd54(_a, type, getDateTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError, timeZone = _a.timeZone;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = (0, $fvB0y.__assign)((0, $fvB0y.__assign)({}, timeZone && {
        timeZone: timeZone
    }), format && (0, $llr7m.getNamedFormat)(formats, type, format, onError));
    var filteredOptions = (0, $llr7m.filterProps)(options, $10894ef816054fd6$var$DATE_TIME_FORMAT_OPTIONS, defaults);
    if (type === 'time' && !filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second && !filteredOptions.timeStyle && !filteredOptions.dateStyle) // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = (0, $fvB0y.__assign)((0, $fvB0y.__assign)({}, filteredOptions), {
        hour: 'numeric',
        minute: 'numeric'
    });
    return getDateTimeFormat(locale, filteredOptions);
}
function $10894ef816054fd6$export$3ae94a2503e890a1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $10894ef816054fd6$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $gYfDQ.IntlFormatError)('Error formatting date.', config.locale, e));
    }
    return String(date);
}
function $10894ef816054fd6$export$3203edd9e5edd663(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $10894ef816054fd6$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $gYfDQ.IntlFormatError)('Error formatting time.', config.locale, e));
    }
    return String(date);
}
function $10894ef816054fd6$export$a7fc3a91cb2ec376(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var from = _a[0], to = _a[1], _b = _a[2], options = _b === void 0 ? {} : _b;
    var timeZone = config.timeZone, locale = config.locale, onError = config.onError;
    var filteredOptions = (0, $llr7m.filterProps)(options, $10894ef816054fd6$var$DATE_TIME_FORMAT_OPTIONS, timeZone ? {
        timeZone: timeZone
    } : {});
    try {
        return getDateTimeFormat(locale, filteredOptions).formatRange(from, to);
    } catch (e) {
        onError(new (0, $gYfDQ.IntlFormatError)('Error formatting date time range.', config.locale, e));
    }
    return String(from);
}
function $10894ef816054fd6$export$dc1f059bce486b1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $10894ef816054fd6$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $gYfDQ.IntlFormatError)('Error formatting date.', config.locale, e));
    }
    return [];
}
function $10894ef816054fd6$export$af6e5d7a5c73edeb(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $10894ef816054fd6$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $gYfDQ.IntlFormatError)('Error formatting time.', config.locale, e));
    }
    return [];
}

});

parcelRegister("6AOze", function(module, exports) {
$parcel$export(module.exports, "formatPlural", () => $4ccd547dc84f99e7$export$bbbd05c900f3568d);

var $llr7m = parcelRequire("llr7m");

var $gYfDQ = parcelRequire("gYfDQ");

var $IShqa = parcelRequire("IShqa");
var $4ccd547dc84f99e7$var$PLURAL_FORMAT_OPTIONS = [
    'type'
];
function $4ccd547dc84f99e7$export$bbbd05c900f3568d(_a, getPluralRules, value, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    if (!Intl.PluralRules) onError(new (0, $IShqa.FormatError)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $IShqa.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $llr7m.filterProps)(options, $4ccd547dc84f99e7$var$PLURAL_FORMAT_OPTIONS);
    try {
        return getPluralRules(locale, filteredOptions).select(value);
    } catch (e) {
        onError(new (0, $gYfDQ.IntlFormatError)('Error formatting plural.', locale, e));
    }
    return 'other';
}

});

parcelRegister("69xPp", function(module, exports) {
$parcel$export(module.exports, "formatMessage", () => $47add2e5e7418454$export$25868d1e8e76735f);

var $fvB0y = parcelRequire("fvB0y");

var $dZcBX = parcelRequire("dZcBX");
parcelRequire("h8OVS");
var $b9HTl = parcelRequire("b9HTl");

var $gYfDQ = parcelRequire("gYfDQ");
parcelRequire("67ylO");
var $2NQso = parcelRequire("2NQso");
function $47add2e5e7418454$var$setTimeZoneInOptions(opts, timeZone) {
    return Object.keys(opts).reduce(function(all, k) {
        all[k] = (0, $fvB0y.__assign)({
            timeZone: timeZone
        }, opts[k]);
        return all;
    }, {});
}
function $47add2e5e7418454$var$deepMergeOptions(opts1, opts2) {
    var keys = Object.keys((0, $fvB0y.__assign)((0, $fvB0y.__assign)({}, opts1), opts2));
    return keys.reduce(function(all, k) {
        all[k] = (0, $fvB0y.__assign)((0, $fvB0y.__assign)({}, opts1[k] || {}), opts2[k] || {});
        return all;
    }, {});
}
function $47add2e5e7418454$var$deepMergeFormatsAndSetTimeZone(f1, timeZone) {
    if (!timeZone) return f1;
    var mfFormats = (0, $b9HTl.IntlMessageFormat).formats;
    return (0, $fvB0y.__assign)((0, $fvB0y.__assign)((0, $fvB0y.__assign)({}, mfFormats), f1), {
        date: $47add2e5e7418454$var$deepMergeOptions($47add2e5e7418454$var$setTimeZoneInOptions(mfFormats.date, timeZone), $47add2e5e7418454$var$setTimeZoneInOptions(f1.date || {}, timeZone)),
        time: $47add2e5e7418454$var$deepMergeOptions($47add2e5e7418454$var$setTimeZoneInOptions(mfFormats.time, timeZone), $47add2e5e7418454$var$setTimeZoneInOptions(f1.time || {}, timeZone))
    });
}
var $47add2e5e7418454$export$25868d1e8e76735f = function(_a, state, messageDescriptor, values, opts) {
    var locale = _a.locale, formats = _a.formats, messages = _a.messages, defaultLocale = _a.defaultLocale, defaultFormats = _a.defaultFormats, fallbackOnEmptyString = _a.fallbackOnEmptyString, onError = _a.onError, timeZone = _a.timeZone, defaultRichTextElements = _a.defaultRichTextElements;
    if (messageDescriptor === void 0) messageDescriptor = {
        id: ''
    };
    var msgId = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
    // `id` is a required field of a Message Descriptor.
    (0, $dZcBX.invariant)(!!msgId, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
    var id = String(msgId);
    var message = // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    messages && Object.prototype.hasOwnProperty.call(messages, id) && messages[id];
    // IMPORTANT: Hot path if `message` is AST with a single literal node
    if (Array.isArray(message) && message.length === 1 && message[0].type === (0, $2NQso.TYPE).literal) return message[0].value;
    // IMPORTANT: Hot path straight lookup for performance
    if (!values && message && typeof message === 'string' && !defaultRichTextElements) return message.replace(/'\{(.*?)\}'/gi, "{$1}");
    values = (0, $fvB0y.__assign)((0, $fvB0y.__assign)({}, defaultRichTextElements), values || {});
    formats = $47add2e5e7418454$var$deepMergeFormatsAndSetTimeZone(formats, timeZone);
    defaultFormats = $47add2e5e7418454$var$deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
    if (!message) {
        if (fallbackOnEmptyString === false && message === '') return message;
        if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) // This prevents warnings from littering the console in development
        // when no `messages` are passed into the <IntlProvider> for the
        // default locale.
        onError(new (0, $gYfDQ.MissingTranslationError)(messageDescriptor, locale));
        if (defaultMessage) try {
            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
            return formatter.format(values);
        } catch (e) {
            onError(new (0, $gYfDQ.MessageFormatError)("Error formatting default message for: \"".concat(id, "\", rendering default message verbatim"), locale, messageDescriptor, e));
            return typeof defaultMessage === 'string' ? defaultMessage : id;
        }
        return id;
    }
    // We have the translated message
    try {
        var formatter = state.getMessageFormat(message, locale, formats, (0, $fvB0y.__assign)({
            formatters: state
        }, opts || {}));
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $gYfDQ.MessageFormatError)("Error formatting message: \"".concat(id, "\", using ").concat(defaultMessage ? 'default message' : 'id', " as fallback."), locale, messageDescriptor, e));
    }
    if (defaultMessage) try {
        var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $gYfDQ.MessageFormatError)("Error formatting the default message for: \"".concat(id, "\", rendering message verbatim"), locale, messageDescriptor, e));
    }
    if (typeof message === 'string') return message;
    if (typeof defaultMessage === 'string') return defaultMessage;
    return id;
};

});
parcelRegister("67ylO", function(module, exports) {
$parcel$export(module.exports, "isDateElement", () => (parcelRequire("2NQso")).isDateElement);
$parcel$export(module.exports, "isDateTimeSkeleton", () => (parcelRequire("2NQso")).isDateTimeSkeleton);
$parcel$export(module.exports, "isNumberElement", () => (parcelRequire("2NQso")).isNumberElement);
$parcel$export(module.exports, "isNumberSkeleton", () => (parcelRequire("2NQso")).isNumberSkeleton);
$parcel$export(module.exports, "isPluralElement", () => (parcelRequire("2NQso")).isPluralElement);
$parcel$export(module.exports, "isSelectElement", () => (parcelRequire("2NQso")).isSelectElement);
$parcel$export(module.exports, "isTagElement", () => (parcelRequire("2NQso")).isTagElement);
$parcel$export(module.exports, "isTimeElement", () => (parcelRequire("2NQso")).isTimeElement);
$parcel$export(module.exports, "TYPE", () => (parcelRequire("2NQso")).TYPE);

var $fvB0y = parcelRequire("fvB0y");

var $5q8ab = parcelRequire("5q8ab");

var $9WNI3 = parcelRequire("9WNI3");

var $2NQso = parcelRequire("2NQso");
function $474e0adbea1db05b$var$pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, $2NQso.isSelectElement)(el) || (0, $2NQso.isPluralElement)(el)) for(var k in el.options){
            delete el.options[k].location;
            $474e0adbea1db05b$var$pruneLocation(el.options[k].value);
        }
        else if ((0, $2NQso.isNumberElement)(el) && (0, $2NQso.isNumberSkeleton)(el.style)) delete el.style.location;
        else if (((0, $2NQso.isDateElement)(el) || (0, $2NQso.isTimeElement)(el)) && (0, $2NQso.isDateTimeSkeleton)(el.style)) delete el.style.location;
        else if ((0, $2NQso.isTagElement)(el)) $474e0adbea1db05b$var$pruneLocation(el.children);
    });
}
function $474e0adbea1db05b$export$98e6a39c04603d36(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, $fvB0y.__assign)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, $9WNI3.Parser)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, $5q8ab.ErrorKind)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) $474e0adbea1db05b$var$pruneLocation(result.val);
    return result.val;
}
var $474e0adbea1db05b$export$d3c1bfa0f7d806e9 = (0, $9WNI3.Parser);

});
parcelRegister("5q8ab", function(module, exports) {
$parcel$export(module.exports, "ErrorKind", () => $3f25b68539a39b49$export$896afd8541959ee5);
var $3f25b68539a39b49$export$896afd8541959ee5;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})($3f25b68539a39b49$export$896afd8541959ee5 || ($3f25b68539a39b49$export$896afd8541959ee5 = {}));

});

parcelRegister("9WNI3", function(module, exports) {
$parcel$export(module.exports, "Parser", () => $73e01720680584da$export$7acfa6ed01010e37);

var $fvB0y = parcelRequire("fvB0y");

var $5q8ab = parcelRequire("5q8ab");

var $2NQso = parcelRequire("2NQso");

var $6cvw1 = parcelRequire("6cvw1");
parcelRequire("atRmT");
var $fPUv5 = parcelRequire("fPUv5");
var $i6zp8 = parcelRequire("i6zp8");

var $4ak3d = parcelRequire("4ak3d");
var $73e01720680584da$var$_a;
var $73e01720680584da$var$SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, $6cvw1.SPACE_SEPARATOR_REGEX).source, "*"));
var $73e01720680584da$var$SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, $6cvw1.SPACE_SEPARATOR_REGEX).source, "*$"));
function $73e01720680584da$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var $73e01720680584da$var$hasNativeStartsWith = !!String.prototype.startsWith && '_a'.startsWith('a', 1);
var $73e01720680584da$var$hasNativeFromCodePoint = !!String.fromCodePoint;
var $73e01720680584da$var$hasNativeFromEntries = !!Object.fromEntries;
var $73e01720680584da$var$hasNativeCodePointAt = !!String.prototype.codePointAt;
var $73e01720680584da$var$hasTrimStart = !!String.prototype.trimStart;
var $73e01720680584da$var$hasTrimEnd = !!String.prototype.trimEnd;
var $73e01720680584da$var$hasNativeIsSafeInteger = !!Number.isSafeInteger;
var $73e01720680584da$var$isSafeInteger = $73e01720680584da$var$hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === 'number' && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var $73e01720680584da$var$REGEX_SUPPORTS_U_AND_Y = true;
try {
    var $73e01720680584da$var$re = $73e01720680584da$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ $73e01720680584da$var$REGEX_SUPPORTS_U_AND_Y = (($73e01720680584da$var$_a = $73e01720680584da$var$re.exec('a')) === null || $73e01720680584da$var$_a === void 0 ? void 0 : $73e01720680584da$var$_a[0]) === 'a';
} catch (_) {
    $73e01720680584da$var$REGEX_SUPPORTS_U_AND_Y = false;
}
var $73e01720680584da$var$startsWith = $73e01720680584da$var$hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var $73e01720680584da$var$fromCodePoint = $73e01720680584da$var$hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = '';
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + ' is not a valid code point');
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var $73e01720680584da$var$fromEntries = // native
$73e01720680584da$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var $73e01720680584da$var$codePointAt = $73e01720680584da$var$hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var $73e01720680584da$var$trimStart = $73e01720680584da$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($73e01720680584da$var$SPACE_SEPARATOR_START_REGEX, '');
};
var $73e01720680584da$var$trimEnd = $73e01720680584da$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($73e01720680584da$var$SPACE_SEPARATOR_END_REGEX, '');
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function $73e01720680584da$var$RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var $73e01720680584da$var$matchIdentifierAtIndex;
if ($73e01720680584da$var$REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var $73e01720680584da$var$IDENTIFIER_PREFIX_RE_1 = $73e01720680584da$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    $73e01720680584da$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        $73e01720680584da$var$IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = $73e01720680584da$var$IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : '';
    };
} else // IE11
$73e01720680584da$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = $73e01720680584da$var$codePointAt(s, index);
        if (c === undefined || $73e01720680584da$var$_isWhiteSpace(c) || $73e01720680584da$var$_isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return $73e01720680584da$var$fromCodePoint.apply(void 0, match);
};
var $73e01720680584da$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error('parser can only be used once');
        return this.parseMessage(0, '', false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal')) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, $2NQso.TYPE).pound,
                    location: $73e01720680584da$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, $5q8ab.ErrorKind).UNMATCHED_CLOSING_TAG, $73e01720680584da$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && $73e01720680584da$var$_isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf('/>')) // Self closing tag
        return {
            val: {
                type: (0, $2NQso.TYPE).literal,
                value: "<".concat(tagName, "/>"),
                location: $73e01720680584da$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf('>')) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf('</')) {
                if (this.isEOF() || !$73e01720680584da$var$_isAlpha(this.char())) return this.error((0, $5q8ab.ErrorKind).INVALID_TAG, $73e01720680584da$var$createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, $5q8ab.ErrorKind).UNMATCHED_CLOSING_TAG, $73e01720680584da$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf('>')) return this.error((0, $5q8ab.ErrorKind).INVALID_TAG, $73e01720680584da$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, $2NQso.TYPE).tag,
                        value: tagName,
                        children: children,
                        location: $73e01720680584da$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, $5q8ab.ErrorKind).UNCLOSED_TAG, $73e01720680584da$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, $5q8ab.ErrorKind).INVALID_TAG, $73e01720680584da$var$createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && $73e01720680584da$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = '';
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = $73e01720680584da$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, $2NQso.TYPE).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !$73e01720680584da$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return '<';
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === 'plural' || parentArgType === 'selectordinal') break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return $73e01720680584da$var$fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal') || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return $73e01720680584da$var$fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $5q8ab.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $73e01720680584da$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, $5q8ab.ErrorKind).EMPTY_ARGUMENT, $73e01720680584da$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, $5q8ab.ErrorKind).MALFORMED_ARGUMENT, $73e01720680584da$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $5q8ab.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $73e01720680584da$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, $2NQso.TYPE).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: $73e01720680584da$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, $5q8ab.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $73e01720680584da$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, $5q8ab.ErrorKind).MALFORMED_ARGUMENT, $73e01720680584da$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = $73e01720680584da$var$matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = $73e01720680584da$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case '':
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, $5q8ab.ErrorKind).EXPECT_ARGUMENT_TYPE, $73e01720680584da$var$createLocation(typeStartPosition, typeEndPosition));
            case 'number':
            case 'date':
            case 'time':
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(',')) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = $73e01720680584da$var$trimEnd(result.val);
                    if (style.length === 0) return this.error((0, $5q8ab.ErrorKind).EXPECT_ARGUMENT_STYLE, $73e01720680584da$var$createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = $73e01720680584da$var$createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = $73e01720680584da$var$createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && $73e01720680584da$var$startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, '::', 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = $73e01720680584da$var$trimStart(styleAndLocation.style.slice(2));
                    if (argType === 'number') {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, $2NQso.TYPE).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, $5q8ab.ErrorKind).EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, $4ak3d.getBestPattern)(skeleton, this.locale);
                        var style = {
                            type: (0, $2NQso.SKELETON_TYPE).dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, $fPUv5.parseDateTimeSkeleton)(dateTimePattern) : {}
                        };
                        var type = argType === 'date' ? (0, $2NQso.TYPE).date : (0, $2NQso.TYPE).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === 'number' ? (0, $2NQso.TYPE).number : argType === 'date' ? (0, $2NQso.TYPE).date : (0, $2NQso.TYPE).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case 'plural':
            case 'selectordinal':
            case 'select':
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(',')) return this.error((0, $5q8ab.ErrorKind).EXPECT_SELECT_ARGUMENT_OPTIONS, $73e01720680584da$var$createLocation(typeEndPosition_1, (0, $fvB0y.__assign)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== 'select' && identifierAndLocation.value === 'offset') {
                    if (!this.bumpIf(':')) return this.error((0, $5q8ab.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $73e01720680584da$var$createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, $5q8ab.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, $5q8ab.ErrorKind).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = $73e01720680584da$var$createLocation(openingBracePosition, this.clonePosition());
                if (argType === 'select') return {
                    val: {
                        type: (0, $2NQso.TYPE).select,
                        value: value,
                        options: $73e01720680584da$var$fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, $2NQso.TYPE).plural,
                        value: value,
                        options: $73e01720680584da$var$fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === 'plural' ? 'cardinal' : 'ordinal',
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, $5q8ab.ErrorKind).INVALID_ARGUMENT_TYPE, $73e01720680584da$var$createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, $5q8ab.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $73e01720680584da$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, $5q8ab.ErrorKind).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $73e01720680584da$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, $i6zp8.parseNumberSkeletonFromString)(skeleton);
        } catch (e) {
            return this.error((0, $5q8ab.ErrorKind).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, $2NQso.SKELETON_TYPE).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $i6zp8.parseNumberSkeleton)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== 'select' && this.bumpIf('=')) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, $5q8ab.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, $5q8ab.ErrorKind).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $73e01720680584da$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === 'select' ? (0, $5q8ab.ErrorKind).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, $5q8ab.ErrorKind).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === 'other') hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf('{')) return this.error(parentArgType === 'select' ? (0, $5q8ab.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, $5q8ab.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $73e01720680584da$var$createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $73e01720680584da$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === 'select' ? (0, $5q8ab.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, $5q8ab.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, $73e01720680584da$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, $5q8ab.ErrorKind).MISSING_OTHER_CLAUSE, $73e01720680584da$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf('+')) ;
        else if (this.bumpIf('-')) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = $73e01720680584da$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!$73e01720680584da$var$isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error('out of bound');
        var code = $73e01720680584da$var$codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if ($73e01720680584da$var$startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && $73e01720680584da$var$_isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function $73e01720680584da$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $73e01720680584da$var$_isAlphaOrSlash(codepoint) {
    return $73e01720680584da$var$_isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function $73e01720680584da$var$_isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $73e01720680584da$var$_isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $73e01720680584da$var$_isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}

});
parcelRegister("2NQso", function(module, exports) {
$parcel$export(module.exports, "TYPE", () => $20a8d941d9ef3b0c$export$b87f371cbc396fcf);
$parcel$export(module.exports, "SKELETON_TYPE", () => $20a8d941d9ef3b0c$export$906452485466fa53);
$parcel$export(module.exports, "isNumberElement", () => $20a8d941d9ef3b0c$export$e11187b219e191e1);
$parcel$export(module.exports, "isDateElement", () => $20a8d941d9ef3b0c$export$32d811605da75f40);
$parcel$export(module.exports, "isTimeElement", () => $20a8d941d9ef3b0c$export$34ec46f596b1702f);
$parcel$export(module.exports, "isSelectElement", () => $20a8d941d9ef3b0c$export$dcfe1c11d168b5a1);
$parcel$export(module.exports, "isPluralElement", () => $20a8d941d9ef3b0c$export$6c796d116f0a4fbc);
$parcel$export(module.exports, "isTagElement", () => $20a8d941d9ef3b0c$export$5c83de34745812b);
$parcel$export(module.exports, "isNumberSkeleton", () => $20a8d941d9ef3b0c$export$3f9a19cd4152eda3);
$parcel$export(module.exports, "isDateTimeSkeleton", () => $20a8d941d9ef3b0c$export$7680c41f1a55f4cf);
var $20a8d941d9ef3b0c$export$b87f371cbc396fcf;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})($20a8d941d9ef3b0c$export$b87f371cbc396fcf || ($20a8d941d9ef3b0c$export$b87f371cbc396fcf = {}));
var $20a8d941d9ef3b0c$export$906452485466fa53;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})($20a8d941d9ef3b0c$export$906452485466fa53 || ($20a8d941d9ef3b0c$export$906452485466fa53 = {}));
function $20a8d941d9ef3b0c$export$cfa10c5697238752(el) {
    return el.type === $20a8d941d9ef3b0c$export$b87f371cbc396fcf.literal;
}
function $20a8d941d9ef3b0c$export$4f55724281bdfaf9(el) {
    return el.type === $20a8d941d9ef3b0c$export$b87f371cbc396fcf.argument;
}
function $20a8d941d9ef3b0c$export$e11187b219e191e1(el) {
    return el.type === $20a8d941d9ef3b0c$export$b87f371cbc396fcf.number;
}
function $20a8d941d9ef3b0c$export$32d811605da75f40(el) {
    return el.type === $20a8d941d9ef3b0c$export$b87f371cbc396fcf.date;
}
function $20a8d941d9ef3b0c$export$34ec46f596b1702f(el) {
    return el.type === $20a8d941d9ef3b0c$export$b87f371cbc396fcf.time;
}
function $20a8d941d9ef3b0c$export$dcfe1c11d168b5a1(el) {
    return el.type === $20a8d941d9ef3b0c$export$b87f371cbc396fcf.select;
}
function $20a8d941d9ef3b0c$export$6c796d116f0a4fbc(el) {
    return el.type === $20a8d941d9ef3b0c$export$b87f371cbc396fcf.plural;
}
function $20a8d941d9ef3b0c$export$c0ece297bdd0c082(el) {
    return el.type === $20a8d941d9ef3b0c$export$b87f371cbc396fcf.pound;
}
function $20a8d941d9ef3b0c$export$5c83de34745812b(el) {
    return el.type === $20a8d941d9ef3b0c$export$b87f371cbc396fcf.tag;
}
function $20a8d941d9ef3b0c$export$3f9a19cd4152eda3(el) {
    return !!(el && typeof el === 'object' && el.type === $20a8d941d9ef3b0c$export$906452485466fa53.number);
}
function $20a8d941d9ef3b0c$export$7680c41f1a55f4cf(el) {
    return !!(el && typeof el === 'object' && el.type === $20a8d941d9ef3b0c$export$906452485466fa53.dateTime);
}
function $20a8d941d9ef3b0c$export$f0ac572c1121c662(value) {
    return {
        type: $20a8d941d9ef3b0c$export$b87f371cbc396fcf.literal,
        value: value
    };
}
function $20a8d941d9ef3b0c$export$425e864b0ba114f1(value, style) {
    return {
        type: $20a8d941d9ef3b0c$export$b87f371cbc396fcf.number,
        value: value,
        style: style
    };
}

});

parcelRegister("6cvw1", function(module, exports) {
$parcel$export(module.exports, "SPACE_SEPARATOR_REGEX", () => $483c4f63c99d34a7$export$523451f94304dd6c);
// @generated from regex-gen.ts
var $483c4f63c99d34a7$export$523451f94304dd6c = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var $483c4f63c99d34a7$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;

});

parcelRegister("atRmT", function(module, exports) {
$parcel$export(module.exports, "parseDateTimeSkeleton", () => (parcelRequire("fPUv5")).parseDateTimeSkeleton);
$parcel$export(module.exports, "parseNumberSkeleton", () => (parcelRequire("i6zp8")).parseNumberSkeleton);
$parcel$export(module.exports, "parseNumberSkeletonFromString", () => (parcelRequire("i6zp8")).parseNumberSkeletonFromString);
parcelRequire("fPUv5");
parcelRequire("i6zp8");

});
parcelRegister("fPUv5", function(module, exports) {
$parcel$export(module.exports, "parseDateTimeSkeleton", () => $b877724303f3a3b4$export$f7b99fb377fe69fa);
/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */ var $b877724303f3a3b4$var$DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function $b877724303f3a3b4$export$f7b99fb377fe69fa(skeleton) {
    var result = {};
    skeleton.replace($b877724303f3a3b4$var$DATE_TIME_REGEX, function(match) {
        var len = match.length;
        switch(match[0]){
            // Era
            case 'G':
                result.era = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            // Year
            case 'y':
                result.year = len === 2 ? '2-digit' : 'numeric';
                break;
            case 'Y':
            case 'u':
            case 'U':
            case 'r':
                throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
            // Quarter
            case 'q':
            case 'Q':
                throw new RangeError('`q/Q` (quarter) patterns are not supported');
            // Month
            case 'M':
            case 'L':
                result.month = [
                    'numeric',
                    '2-digit',
                    'short',
                    'long',
                    'narrow'
                ][len - 1];
                break;
            // Week
            case 'w':
            case 'W':
                throw new RangeError('`w/W` (week) patterns are not supported');
            case 'd':
                result.day = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'D':
            case 'F':
            case 'g':
                throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
            // Weekday
            case 'E':
                result.weekday = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            case 'e':
                if (len < 4) throw new RangeError('`e..eee` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            case 'c':
                if (len < 4) throw new RangeError('`c..ccc` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            // Period
            case 'a':
                result.hour12 = true;
                break;
            case 'b':
            case 'B':
                throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
            // Hour
            case 'h':
                result.hourCycle = 'h12';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'H':
                result.hourCycle = 'h23';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'K':
                result.hourCycle = 'h11';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'k':
                result.hourCycle = 'h24';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'j':
            case 'J':
            case 'C':
                throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
            // Minute
            case 'm':
                result.minute = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            // Second
            case 's':
                result.second = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'S':
            case 'A':
                throw new RangeError('`S/A` (second) patterns are not supported, use `s` instead');
            // Zone
            case 'z':
                result.timeZoneName = len < 4 ? 'short' : 'long';
                break;
            case 'Z':
            case 'O':
            case 'v':
            case 'V':
            case 'X':
            case 'x':
                throw new RangeError('`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead');
        }
        return '';
    });
    return result;
}

});

parcelRegister("i6zp8", function(module, exports) {
$parcel$export(module.exports, "parseNumberSkeletonFromString", () => $d2e4401ab8ee30f9$export$71cee2f16fba2480);
$parcel$export(module.exports, "parseNumberSkeleton", () => $d2e4401ab8ee30f9$export$47c6f8480bda3e11);

var $fvB0y = parcelRequire("fvB0y");

var $gnSqf = parcelRequire("gnSqf");
function $d2e4401ab8ee30f9$export$71cee2f16fba2480(skeleton) {
    if (skeleton.length === 0) throw new Error('Number skeleton cannot be empty');
    // Parse the skeleton
    var stringTokens = skeleton.split((0, $gnSqf.WHITE_SPACE_REGEX)).filter(function(x) {
        return x.length > 0;
    });
    var tokens = [];
    for(var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++){
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split('/');
        if (stemAndOptions.length === 0) throw new Error('Invalid number skeleton');
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for(var _a = 0, options_1 = options; _a < options_1.length; _a++){
            var option = options_1[_a];
            if (option.length === 0) throw new Error('Invalid number skeleton');
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
function $d2e4401ab8ee30f9$var$icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, '');
}
var $d2e4401ab8ee30f9$var$FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var $d2e4401ab8ee30f9$var$SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var $d2e4401ab8ee30f9$var$INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var $d2e4401ab8ee30f9$var$CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function $d2e4401ab8ee30f9$var$parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === 'r') result.roundingPriority = 'morePrecision';
    else if (str[str.length - 1] === 's') result.roundingPriority = 'lessPrecision';
    str.replace($d2e4401ab8ee30f9$var$SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== 'string') {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === '+') result.minimumSignificantDigits = g1.length;
        else if (g1[0] === '#') result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === 'string' ? g2.length : 0);
        }
        return '';
    });
    return result;
}
function $d2e4401ab8ee30f9$var$parseSign(str) {
    switch(str){
        case 'sign-auto':
            return {
                signDisplay: 'auto'
            };
        case 'sign-accounting':
        case '()':
            return {
                currencySign: 'accounting'
            };
        case 'sign-always':
        case '+!':
            return {
                signDisplay: 'always'
            };
        case 'sign-accounting-always':
        case '()!':
            return {
                signDisplay: 'always',
                currencySign: 'accounting'
            };
        case 'sign-except-zero':
        case '+?':
            return {
                signDisplay: 'exceptZero'
            };
        case 'sign-accounting-except-zero':
        case '()?':
            return {
                signDisplay: 'exceptZero',
                currencySign: 'accounting'
            };
        case 'sign-never':
        case '+_':
            return {
                signDisplay: 'never'
            };
    }
}
function $d2e4401ab8ee30f9$var$parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === 'E' && stem[1] === 'E') {
        result = {
            notation: 'engineering'
        };
        stem = stem.slice(2);
    } else if (stem[0] === 'E') {
        result = {
            notation: 'scientific'
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === '+!') {
            result.signDisplay = 'always';
            stem = stem.slice(2);
        } else if (signDisplay === '+?') {
            result.signDisplay = 'exceptZero';
            stem = stem.slice(2);
        }
        if (!$d2e4401ab8ee30f9$var$CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error('Malformed concise eng/scientific notation');
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function $d2e4401ab8ee30f9$var$parseNotationOptions(opt) {
    var result = {};
    var signOpts = $d2e4401ab8ee30f9$var$parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
function $d2e4401ab8ee30f9$export$47c6f8480bda3e11(tokens) {
    var result = {};
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        switch(token.stem){
            case 'percent':
            case '%':
                result.style = 'percent';
                continue;
            case '%x100':
                result.style = 'percent';
                result.scale = 100;
                continue;
            case 'currency':
                result.style = 'currency';
                result.currency = token.options[0];
                continue;
            case 'group-off':
            case ',_':
                result.useGrouping = false;
                continue;
            case 'precision-integer':
            case '.':
                result.maximumFractionDigits = 0;
                continue;
            case 'measure-unit':
            case 'unit':
                result.style = 'unit';
                result.unit = $d2e4401ab8ee30f9$var$icuUnitToEcma(token.options[0]);
                continue;
            case 'compact-short':
            case 'K':
                result.notation = 'compact';
                result.compactDisplay = 'short';
                continue;
            case 'compact-long':
            case 'KK':
                result.notation = 'compact';
                result.compactDisplay = 'long';
                continue;
            case 'scientific':
                result = (0, $fvB0y.__assign)((0, $fvB0y.__assign)((0, $fvB0y.__assign)({}, result), {
                    notation: 'scientific'
                }), token.options.reduce(function(all, opt) {
                    return (0, $fvB0y.__assign)((0, $fvB0y.__assign)({}, all), $d2e4401ab8ee30f9$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'engineering':
                result = (0, $fvB0y.__assign)((0, $fvB0y.__assign)((0, $fvB0y.__assign)({}, result), {
                    notation: 'engineering'
                }), token.options.reduce(function(all, opt) {
                    return (0, $fvB0y.__assign)((0, $fvB0y.__assign)({}, all), $d2e4401ab8ee30f9$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'notation-simple':
                result.notation = 'standard';
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case 'unit-width-narrow':
                result.currencyDisplay = 'narrowSymbol';
                result.unitDisplay = 'narrow';
                continue;
            case 'unit-width-short':
                result.currencyDisplay = 'code';
                result.unitDisplay = 'short';
                continue;
            case 'unit-width-full-name':
                result.currencyDisplay = 'name';
                result.unitDisplay = 'long';
                continue;
            case 'unit-width-iso-code':
                result.currencyDisplay = 'symbol';
                continue;
            case 'scale':
                result.scale = parseFloat(token.options[0]);
                continue;
            case 'rounding-mode-floor':
                result.roundingMode = 'floor';
                continue;
            case 'rounding-mode-ceiling':
                result.roundingMode = 'ceil';
                continue;
            case 'rounding-mode-down':
                result.roundingMode = 'trunc';
                continue;
            case 'rounding-mode-up':
                result.roundingMode = 'expand';
                continue;
            case 'rounding-mode-half-even':
                result.roundingMode = 'halfEven';
                continue;
            case 'rounding-mode-half-down':
                result.roundingMode = 'halfTrunc';
                continue;
            case 'rounding-mode-half-up':
                result.roundingMode = 'halfExpand';
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case 'integer-width':
                if (token.options.length > 1) throw new RangeError('integer-width stems only accept a single optional option');
                token.options[0].replace($d2e4401ab8ee30f9$var$INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error('We currently do not support maximum integer digits');
                    else if (g5) throw new Error('We currently do not support exact integer digits');
                    return '';
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if ($d2e4401ab8ee30f9$var$CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if ($d2e4401ab8ee30f9$var$FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError('Fraction-precision stems only accept a single optional option');
            token.stem.replace($d2e4401ab8ee30f9$var$FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === '*') result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === '#') result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return '';
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === 'w') result = (0, $fvB0y.__assign)((0, $fvB0y.__assign)({}, result), {
                trailingZeroDisplay: 'stripIfInteger'
            });
            else if (opt) result = (0, $fvB0y.__assign)((0, $fvB0y.__assign)({}, result), $d2e4401ab8ee30f9$var$parseSignificantPrecision(opt));
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if ($d2e4401ab8ee30f9$var$SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0, $fvB0y.__assign)((0, $fvB0y.__assign)({}, result), $d2e4401ab8ee30f9$var$parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = $d2e4401ab8ee30f9$var$parseSign(token.stem);
        if (signOpts) result = (0, $fvB0y.__assign)((0, $fvB0y.__assign)({}, result), signOpts);
        var conciseScientificAndEngineeringOpts = $d2e4401ab8ee30f9$var$parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = (0, $fvB0y.__assign)((0, $fvB0y.__assign)({}, result), conciseScientificAndEngineeringOpts);
    }
    return result;
}

});
parcelRegister("gnSqf", function(module, exports) {
$parcel$export(module.exports, "WHITE_SPACE_REGEX", () => $bed9027be1c4bff8$export$2b8db14d8bcaece7);
// @generated from regex-gen.ts
var $bed9027be1c4bff8$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

});



parcelRegister("4ak3d", function(module, exports) {
$parcel$export(module.exports, "getBestPattern", () => $3087a64b97308f3b$export$29c5368be8904d27);

var $enac1 = parcelRequire("enac1");
function $3087a64b97308f3b$export$29c5368be8904d27(skeleton, locale) {
    var skeletonCopy = '';
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === 'j') {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = 'a';
            var hourChar = $3087a64b97308f3b$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == 'H' || hourChar == 'k') dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === 'J') skeletonCopy += 'H';
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function $3087a64b97308f3b$var$getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case 'h24':
            return 'k';
        case 'h23':
            return 'H';
        case 'h12':
            return 'h';
        case 'h11':
            return 'K';
        default:
            throw new Error('Invalid hourCycle');
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== 'root') regionTag = locale.maximize().region;
    var hourCycles = (0, $enac1.timeData)[regionTag || ''] || (0, $enac1.timeData)[languageTag || ''] || (0, $enac1.timeData)["".concat(languageTag, "-001")] || (0, $enac1.timeData)['001'];
    return hourCycles[0];
}

});
parcelRegister("enac1", function(module, exports) {
$parcel$export(module.exports, "timeData", () => $a76b1ebebaf770fe$export$a8c9209db4084317);
// @generated from time-data-gen.ts
// prettier-ignore  
var $a76b1ebebaf770fe$export$a8c9209db4084317 = {
    "001": [
        "H",
        "h"
    ],
    "419": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AS": [
        "h",
        "H"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "AX": [
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BI": [
        "H",
        "h"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "BO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "BQ": [
        "H"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BT": [
        "h",
        "H"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BY": [
        "H",
        "h"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CL": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CP": [
        "H"
    ],
    "CR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CU": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "CW": [
        "H",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CZ": [
        "H"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "DK": [
        "H"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EC": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "FI": [
        "H"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FO": [
        "H",
        "h"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GH": [
        "h",
        "H"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GL": [
        "H",
        "h"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GT": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HN": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "HU": [
        "H",
        "h"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ID": [
        "H"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IN": [
        "h",
        "H"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "IS": [
        "H"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JP": [
        "H",
        "K",
        "h"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LS": [
        "h",
        "H"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MG": [
        "H",
        "h"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ML": [
        "H"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MT": [
        "H",
        "h"
    ],
    "MU": [
        "H",
        "h"
    ],
    "MV": [
        "H",
        "h"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MX": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NE": [
        "H"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NI": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "NO": [
        "H",
        "h"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "PL": [
        "H",
        "h"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "PW": [
        "h",
        "H"
    ],
    "PY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "RU": [
        "H"
    ],
    "RW": [
        "H",
        "h"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SE": [
        "H"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "SO": [
        "h",
        "H"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "SV": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TH": [
        "H",
        "h"
    ],
    "TJ": [
        "H",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TM": [
        "H",
        "h"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VN": [
        "H",
        "h"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "WS": [
        "h",
        "H"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZW": [
        "H",
        "h"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-HK": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-IL": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "en-MY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ]
};

});





parcelRegister("grF3X", function(module, exports) {
$parcel$export(module.exports, "formatList", () => $bf8f0530ca58d25e$export$e8b8be48b45905bb);
$parcel$export(module.exports, "formatListToParts", () => $bf8f0530ca58d25e$export$6f284aad1934db69);

var $fvB0y = parcelRequire("fvB0y");

var $llr7m = parcelRequire("llr7m");

var $IShqa = parcelRequire("IShqa");

var $gYfDQ = parcelRequire("gYfDQ");
var $bf8f0530ca58d25e$var$LIST_FORMAT_OPTIONS = [
    'type',
    'style'
];
var $bf8f0530ca58d25e$var$now = Date.now();
function $bf8f0530ca58d25e$var$generateToken(i) {
    return "".concat($bf8f0530ca58d25e$var$now, "_").concat(i, "_").concat($bf8f0530ca58d25e$var$now);
}
function $bf8f0530ca58d25e$export$e8b8be48b45905bb(opts, getListFormat, values, options) {
    if (options === void 0) options = {};
    var results = $bf8f0530ca58d25e$export$6f284aad1934db69(opts, getListFormat, values, options).reduce(function(all, el) {
        var val = el.value;
        if (typeof val !== 'string') all.push(val);
        else if (typeof all[all.length - 1] === 'string') all[all.length - 1] += val;
        else all.push(val);
        return all;
    }, []);
    return results.length === 1 ? results[0] : results.length === 0 ? '' : results;
}
function $bf8f0530ca58d25e$export$6f284aad1934db69(_a, getListFormat, values, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    var ListFormat = Intl.ListFormat;
    if (!ListFormat) onError(new (0, $IShqa.FormatError)("Intl.ListFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-listformat\"\n", (0, $IShqa.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $llr7m.filterProps)(options, $bf8f0530ca58d25e$var$LIST_FORMAT_OPTIONS);
    try {
        var richValues_1 = {};
        var serializedValues = values.map(function(v, i) {
            if (typeof v === 'object') {
                var id = $bf8f0530ca58d25e$var$generateToken(i);
                richValues_1[id] = v;
                return id;
            }
            return String(v);
        });
        return getListFormat(locale, filteredOptions).formatToParts(serializedValues).map(function(part) {
            return part.type === 'literal' ? part : (0, $fvB0y.__assign)((0, $fvB0y.__assign)({}, part), {
                value: richValues_1[part.value] || part.value
            });
        });
    } catch (e) {
        onError(new (0, $gYfDQ.IntlFormatError)('Error formatting list.', locale, e));
    }
    // @ts-ignore
    return values;
}

});

parcelRegister("lwlBb", function(module, exports) {
$parcel$export(module.exports, "formatDisplayName", () => $faad572b7c5118f1$export$62fe1a4d9e891fa2);

var $llr7m = parcelRequire("llr7m");

var $IShqa = parcelRequire("IShqa");

var $gYfDQ = parcelRequire("gYfDQ");
var $faad572b7c5118f1$var$DISPLAY_NAMES_OPTONS = [
    'style',
    'type',
    'fallback',
    'languageDisplay'
];
function $faad572b7c5118f1$export$62fe1a4d9e891fa2(_a, getDisplayNames, value, options) {
    var locale = _a.locale, onError = _a.onError;
    var DisplayNames = Intl.DisplayNames;
    if (!DisplayNames) onError(new (0, $IShqa.FormatError)("Intl.DisplayNames is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-displaynames\"\n", (0, $IShqa.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $llr7m.filterProps)(options, $faad572b7c5118f1$var$DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    } catch (e) {
        onError(new (0, $gYfDQ.IntlFormatError)('Error formatting display name.', locale, e));
    }
}

});




parcelRegister("99bjV", function(module, exports) {
$parcel$export(module.exports, "default", () => $6a8dbc4a76919f66$export$2e2bcd8739ae039);

var $fvB0y = parcelRequire("fvB0y");

var $4tluv = parcelRequire("4tluv");

var $dZcBX = parcelRequire("dZcBX");

var $8N0QD = parcelRequire("8N0QD");
var $6a8dbc4a76919f66$var$MINUTE = 60;
var $6a8dbc4a76919f66$var$HOUR = 3600;
var $6a8dbc4a76919f66$var$DAY = 86400;
function $6a8dbc4a76919f66$var$selectUnit(seconds) {
    var absValue = Math.abs(seconds);
    if (absValue < $6a8dbc4a76919f66$var$MINUTE) return 'second';
    if (absValue < $6a8dbc4a76919f66$var$HOUR) return 'minute';
    if (absValue < $6a8dbc4a76919f66$var$DAY) return 'hour';
    return 'day';
}
function $6a8dbc4a76919f66$var$getDurationInSeconds(unit) {
    switch(unit){
        case 'second':
            return 1;
        case 'minute':
            return $6a8dbc4a76919f66$var$MINUTE;
        case 'hour':
            return $6a8dbc4a76919f66$var$HOUR;
        default:
            return $6a8dbc4a76919f66$var$DAY;
    }
}
function $6a8dbc4a76919f66$var$valueToSeconds(value, unit) {
    if (!value) return 0;
    switch(unit){
        case 'second':
            return value;
        case 'minute':
            return value * $6a8dbc4a76919f66$var$MINUTE;
        default:
            return value * $6a8dbc4a76919f66$var$HOUR;
    }
}
var $6a8dbc4a76919f66$var$INCREMENTABLE_UNITS = [
    'second',
    'minute',
    'hour'
];
function $6a8dbc4a76919f66$var$canIncrement(unit) {
    if (unit === void 0) unit = 'second';
    return $6a8dbc4a76919f66$var$INCREMENTABLE_UNITS.indexOf(unit) > -1;
}
var $6a8dbc4a76919f66$var$SimpleFormattedRelativeTime = function(props) {
    var _a = (0, $8N0QD.default)(), formatRelativeTime = _a.formatRelativeTime, Text = _a.textComponent;
    var children = props.children, value = props.value, unit = props.unit, otherProps = (0, $fvB0y.__rest)(props, [
        "children",
        "value",
        "unit"
    ]);
    var formattedRelativeTime = formatRelativeTime(value || 0, unit, otherProps);
    if (typeof children === 'function') return children(formattedRelativeTime);
    if (Text) return $4tluv.createElement(Text, null, formattedRelativeTime);
    return $4tluv.createElement($4tluv.Fragment, null, formattedRelativeTime);
};
var $6a8dbc4a76919f66$var$FormattedRelativeTime = function(_a) {
    var _b = _a.value, value = _b === void 0 ? 0 : _b, _c = _a.unit, unit = _c === void 0 ? 'second' : _c, updateIntervalInSeconds = _a.updateIntervalInSeconds, otherProps = (0, $fvB0y.__rest)(_a, [
        "value",
        "unit",
        "updateIntervalInSeconds"
    ]);
    (0, $dZcBX.invariant)(!updateIntervalInSeconds || !!(updateIntervalInSeconds && $6a8dbc4a76919f66$var$canIncrement(unit)), 'Cannot schedule update with unit longer than hour');
    var _d = $4tluv.useState(), prevUnit = _d[0], setPrevUnit = _d[1];
    var _e = $4tluv.useState(0), prevValue = _e[0], setPrevValue = _e[1];
    var _f = $4tluv.useState(0), currentValueInSeconds = _f[0], setCurrentValueInSeconds = _f[1];
    var updateTimer;
    if (unit !== prevUnit || value !== prevValue) {
        setPrevValue(value || 0);
        setPrevUnit(unit);
        setCurrentValueInSeconds($6a8dbc4a76919f66$var$canIncrement(unit) ? $6a8dbc4a76919f66$var$valueToSeconds(value, unit) : 0);
    }
    $4tluv.useEffect(function() {
        function clearUpdateTimer() {
            clearTimeout(updateTimer);
        }
        clearUpdateTimer();
        // If there's no interval and we cannot increment this unit, do nothing
        if (!updateIntervalInSeconds || !$6a8dbc4a76919f66$var$canIncrement(unit)) return clearUpdateTimer;
        // Figure out the next interesting time
        var nextValueInSeconds = currentValueInSeconds - updateIntervalInSeconds;
        var nextUnit = $6a8dbc4a76919f66$var$selectUnit(nextValueInSeconds);
        // We've reached the max auto incrementable unit, don't schedule another update
        if (nextUnit === 'day') return clearUpdateTimer;
        var unitDuration = $6a8dbc4a76919f66$var$getDurationInSeconds(nextUnit);
        var remainder = nextValueInSeconds % unitDuration;
        var prevInterestingValueInSeconds = nextValueInSeconds - remainder;
        var nextInterestingValueInSeconds = prevInterestingValueInSeconds >= currentValueInSeconds ? prevInterestingValueInSeconds - unitDuration : prevInterestingValueInSeconds;
        var delayInSeconds = Math.abs(nextInterestingValueInSeconds - currentValueInSeconds);
        if (currentValueInSeconds !== nextInterestingValueInSeconds) updateTimer = setTimeout(function() {
            return setCurrentValueInSeconds(nextInterestingValueInSeconds);
        }, delayInSeconds * 1e3);
        return clearUpdateTimer;
    }, [
        currentValueInSeconds,
        updateIntervalInSeconds,
        unit
    ]);
    var currentValue = value || 0;
    var currentUnit = unit;
    if ($6a8dbc4a76919f66$var$canIncrement(unit) && typeof currentValueInSeconds === 'number' && updateIntervalInSeconds) {
        currentUnit = $6a8dbc4a76919f66$var$selectUnit(currentValueInSeconds);
        var unitDuration = $6a8dbc4a76919f66$var$getDurationInSeconds(currentUnit);
        currentValue = Math.round(currentValueInSeconds / unitDuration);
    }
    return $4tluv.createElement($6a8dbc4a76919f66$var$SimpleFormattedRelativeTime, (0, $fvB0y.__assign)({
        value: currentValue,
        unit: currentUnit
    }, otherProps));
};
$6a8dbc4a76919f66$var$FormattedRelativeTime.displayName = 'FormattedRelativeTime';
var $6a8dbc4a76919f66$export$2e2bcd8739ae039 = $6a8dbc4a76919f66$var$FormattedRelativeTime;

});

parcelRegister("fgAxl", function(module, exports) {
$parcel$export(module.exports, "default", () => $b1d4b116a0328329$export$2e2bcd8739ae039);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $4tluv = parcelRequire("4tluv");

var $8N0QD = parcelRequire("8N0QD");
var $b1d4b116a0328329$var$FormattedPlural = function(props) {
    var _a = (0, $8N0QD.default)(), formatPlural = _a.formatPlural, Text = _a.textComponent;
    var value = props.value, other = props.other, children = props.children;
    var pluralCategory = formatPlural(value, props);
    var formattedPlural = props[pluralCategory] || other;
    if (typeof children === 'function') return children(formattedPlural);
    if (Text) return $4tluv.createElement(Text, null, formattedPlural);
    // Work around @types/react where React.FC cannot return string
    return formattedPlural;
};
$b1d4b116a0328329$var$FormattedPlural.displayName = 'FormattedPlural';
var $b1d4b116a0328329$export$2e2bcd8739ae039 = $b1d4b116a0328329$var$FormattedPlural;

});

parcelRegister("2o0fk", function(module, exports) {
$parcel$export(module.exports, "default", () => $1bce038d17d8b3ac$export$2e2bcd8739ae039);

var $fvB0y = parcelRequire("fvB0y");

var $4tluv = parcelRequire("4tluv");

var $8N0QD = parcelRequire("8N0QD");
var $1bce038d17d8b3ac$var$FormattedDateTimeRange = function(props) {
    var intl = (0, $8N0QD.default)();
    var from = props.from, to = props.to, children = props.children, formatProps = (0, $fvB0y.__rest)(props, [
        "from",
        "to",
        "children"
    ]);
    var formattedValue = intl.formatDateTimeRange(from, to, formatProps);
    if (typeof children === 'function') return children(formattedValue);
    var Text = intl.textComponent || $4tluv.Fragment;
    return $4tluv.createElement(Text, null, formattedValue);
};
$1bce038d17d8b3ac$var$FormattedDateTimeRange.displayName = 'FormattedDateTimeRange';
var $1bce038d17d8b3ac$export$2e2bcd8739ae039 = $1bce038d17d8b3ac$var$FormattedDateTimeRange;

});




parcelRegister("2dkkV", function(module, exports) {
$parcel$export(module.exports, "AccountMenu", () => $b28157bd148fdc8d$export$ff20d75d5eda4388);

var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $6r4PX = parcelRequire("6r4PX");

var $5aeBt = parcelRequire("5aeBt");

var $81zfU = parcelRequire("81zfU");

var $gRZTE = parcelRequire("gRZTE");

var $e2DOV = parcelRequire("e2DOV");
const $b28157bd148fdc8d$export$ff20d75d5eda4388 = ({ testId: testId, globalColorMode: globalColorMode, name: name, picture: picture, email: email, managedBy: managedBy, manageProfileLink: manageProfileLink, viewProfileLink: viewProfileLink, onViewProfileClick: onViewProfileClick, switchAccountLink: switchAccountLink, logOutLink: logOutLink, logInLink: logInLink, onThemeChange: onThemeChange, currentTheme: currentTheme, extraMenuItems: extraMenuItems, trustPicture: trustPicture = false, onLogoutClick: onLogoutClick, onThemeSwitcherOpenChange: onThemeSwitcherOpenChange, AccountMenuLoggedOutState: AccountMenuLoggedOutState, AccountMenuTrigger: AccountMenuTrigger })=>/*#__PURE__*/ (0, $2iln5.jsx)((0, $6r4PX.NavigationAnalyticsContext), {
        data: (0, $5aeBt.ANALYTICS_CONTEXT),
        children: /*#__PURE__*/ (0, $2iln5.jsx)((0, $gRZTE.AccountMenuIntlProvider), {
            children: logInLink ? /*#__PURE__*/ (0, $2iln5.jsx)(AccountMenuLoggedOutState, {
                testId: testId && `${testId}--logged-out-state`,
                logInLink: logInLink
            }) : /*#__PURE__*/ (0, $2iln5.jsx)((0, $e2DOV.AccountMenuPopup), {
                testId: testId,
                picture: picture,
                trustPicture: trustPicture,
                email: email,
                AccountMenuTrigger: AccountMenuTrigger,
                content: ({ onClose: closePopup })=>/*#__PURE__*/ (0, $2iln5.jsx)((0, $81zfU.AccountMenuContent), {
                        testId: testId && `${testId}--content`,
                        closePopup: closePopup,
                        globalColorMode: globalColorMode,
                        name: name,
                        picture: picture,
                        email: email,
                        managedBy: managedBy,
                        manageProfileLink: manageProfileLink,
                        viewProfileLink: viewProfileLink,
                        onViewProfileClick: onViewProfileClick,
                        switchAccountLink: switchAccountLink,
                        logOutLink: logOutLink,
                        onThemeChange: onThemeChange,
                        currentTheme: currentTheme,
                        extraMenuItems: extraMenuItems,
                        onLogoutClick: onLogoutClick,
                        onThemeSwitcherOpenChange: onThemeSwitcherOpenChange
                    })
            })
        })
    });

});
parcelRegister("81zfU", function(module, exports) {
$parcel$export(module.exports, "AccountMenuContent", () => $55964581a2712edd$export$49c2771125e1e9f1);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $jAkMr = parcelRequire("jAkMr");

var $9KeuJ = parcelRequire("9KeuJ");

var $he8Cl = parcelRequire("he8Cl");

var $8ik9q = parcelRequire("8ik9q");

var $cmQJ8 = parcelRequire("cmQJ8");

var $1XAxy = parcelRequire("1XAxy");

var $kJVAj = parcelRequire("kJVAj");

var $bt5fG = parcelRequire("bt5fG");

var $a6epy = parcelRequire("a6epy");
var $jbQJo = parcelRequire("jbQJo");
var $jdECH = parcelRequire("jdECH");

var $3X3Vo = parcelRequire("3X3Vo");

var $95DsM = parcelRequire("95DsM");

var $5aeBt = parcelRequire("5aeBt");

var $5ZJiX = parcelRequire("5ZJiX");

var $aRHKU = parcelRequire("aRHKU");
const $55964581a2712edd$export$49c2771125e1e9f1 = ({ testId: testId, closePopup: closePopup, name: name, picture: picture, email: email, managedBy: managedBy, manageProfileLink: manageProfileLink, viewProfileLink: viewProfileLink, onViewProfileClick: onViewProfileClick, switchAccountLink: switchAccountLink, logOutLink: logOutLink, onThemeChange: onThemeChange, currentTheme: currentTheme, globalColorMode: globalColorMode, extraMenuItems: extraMenuItems = null, onLogoutClick: onLogoutClick, onThemeSwitcherOpenChange: onThemeSwitcherOpenChange })=>{
    const themeSwitcherProps = onThemeChange && currentTheme;
    const shouldRenderProfileThemeSwitcherSection = Boolean(viewProfileLink || manageProfileLink || themeSwitcherProps);
    return /*#__PURE__*/ (0, $2iln5.jsx)($55964581a2712edd$var$Container, {
        "data-testid": testId,
        children: /*#__PURE__*/ (0, $2iln5.jsxs)((0, $jbQJo.default), {
            children: [
                /*#__PURE__*/ (0, $2iln5.jsx)((0, $jdECH.default), {
                    children: /*#__PURE__*/ (0, $2iln5.jsx)((0, $5ZJiX.AccountDetails), {
                        testId: testId && `${testId}--details`,
                        name: name,
                        picture: picture,
                        email: email,
                        managedBy: managedBy
                    })
                }),
                shouldRenderProfileThemeSwitcherSection && /*#__PURE__*/ (0, $2iln5.jsxs)((0, $jdECH.default), {
                    children: [
                        viewProfileLink && /*#__PURE__*/ (0, $2iln5.jsx)($55964581a2712edd$var$ViewProfileLink, {
                            onClick: onViewProfileClick,
                            testId: testId && `${testId}--view-profile`,
                            href: viewProfileLink,
                            closePopup: closePopup
                        }),
                        manageProfileLink && /*#__PURE__*/ (0, $2iln5.jsx)($55964581a2712edd$var$ManageProfileLink, {
                            testId: testId && `${testId}--manage-profile`,
                            href: manageProfileLink,
                            closePopup: closePopup
                        }),
                        themeSwitcherProps && ((0, $3X3Vo.fg)('replace-account-menu-theme-switcher') ? /*#__PURE__*/ (0, $2iln5.jsx)((0, $95DsM.ThemeSwitcher), {
                            testId: testId && `${testId}--theme-switcher`,
                            onThemeChange: onThemeChange,
                            currentColorMode: currentTheme,
                            accountColorMode: globalColorMode ?? undefined,
                            onOpenChange: onThemeSwitcherOpenChange,
                            appearancePreferencesLink: globalColorMode !== undefined ? manageProfileLink?.replace(/(%2F|\/)manage-profile[^&]*/g, '$1manage-profile$1appearance-preferences') : undefined
                        }) : /*#__PURE__*/ (0, $2iln5.jsx)((0, $aRHKU.ThemeSwitcher), {
                            testId: testId && `${testId}--theme-switcher`,
                            onThemeChange: onThemeChange,
                            currentTheme: currentTheme,
                            globalColorMode: globalColorMode,
                            onThemeSwitcherOpenChange: onThemeSwitcherOpenChange,
                            appearancePreferencesLink: globalColorMode !== undefined ? manageProfileLink?.replace(/(%2F|\/)manage-profile[^&]*/g, '$1manage-profile$1appearance-preferences') : undefined
                        }))
                    ]
                }),
                extraMenuItems,
                /*#__PURE__*/ (0, $2iln5.jsxs)((0, $jdECH.default), {
                    hasSeparator: shouldRenderProfileThemeSwitcherSection,
                    children: [
                        switchAccountLink && /*#__PURE__*/ (0, $2iln5.jsx)($55964581a2712edd$var$SwitchAccountLink, {
                            testId: testId && `${testId}--switch-account`,
                            href: switchAccountLink,
                            closePopup: closePopup
                        }),
                        /*#__PURE__*/ (0, $2iln5.jsx)($55964581a2712edd$var$LogOutLink, {
                            testId: testId && `${testId}--log-out`,
                            href: logOutLink,
                            closePopup: closePopup,
                            onClick: onLogoutClick
                        })
                    ]
                })
            ]
        })
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $55964581a2712edd$var$Container = /*#__PURE__*/ (0, $4tluv.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2iln5.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $jAkMr.default)([
            "_vchhusvi _1ul9ko4j",
            __cmplp.className
        ])
    });
});
const $55964581a2712edd$var$ViewProfileLink = ({ testId: testId, href: href, onClick: onClick, closePopup: closePopup })=>/*#__PURE__*/ (0, $2iln5.jsx)($55964581a2712edd$var$Link, {
        testId: testId,
        href: href,
        onClick: onClick,
        icon: /*#__PURE__*/ (0, $2iln5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kJVAj))), {
            color: "currentColor",
            label: ""
        }),
        closePopup: closePopup,
        actionSubjectId: "viewProfileLink",
        children: /*#__PURE__*/ (0, $2iln5.jsx)((0, $9KeuJ.default), {
            id: "identity.account-menu.account-details.view-profile-tooltip",
            defaultMessage: "Profile",
            description: "Text shown when hovering over profile information"
        })
    });
const $55964581a2712edd$var$ManageProfileLink = ({ testId: testId, href: href, closePopup: closePopup })=>/*#__PURE__*/ (0, $2iln5.jsx)($55964581a2712edd$var$Link, {
        testId: testId,
        href: href,
        icon: /*#__PURE__*/ (0, $2iln5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bt5fG))), {
            color: "currentColor",
            label: ""
        }),
        closePopup: closePopup,
        actionSubjectId: "manageProfileLink",
        target: "_blank",
        rel: "noopener",
        children: /*#__PURE__*/ (0, $2iln5.jsx)((0, $9KeuJ.default), {
            id: "identity.account-menu.account-details.manage-profile-link",
            defaultMessage: "Account settings",
            description: "Text for link to account management page"
        })
    });
const $55964581a2712edd$var$SwitchAccountLink = ({ testId: testId, href: href, closePopup: closePopup })=>/*#__PURE__*/ (0, $2iln5.jsx)($55964581a2712edd$var$Link, {
        testId: testId,
        icon: /*#__PURE__*/ (0, $2iln5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1XAxy))), {
            color: "currentColor",
            label: ""
        }),
        href: href,
        closePopup: closePopup,
        actionSubjectId: "switchAccountLink",
        children: /*#__PURE__*/ (0, $2iln5.jsx)((0, $9KeuJ.default), {
            id: "identity.account-menu.account-menu-content.switch-account-button",
            defaultMessage: "Switch account",
            description: "Label for button in account menu to switch to another another account"
        })
    });
const $55964581a2712edd$var$LogOutLink = ({ testId: testId, href: href, closePopup: closePopup, onClick: onClick })=>/*#__PURE__*/ (0, $2iln5.jsx)($55964581a2712edd$var$Link, {
        testId: testId,
        icon: /*#__PURE__*/ (0, $2iln5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cmQJ8))), {
            color: "currentColor",
            label: ""
        }),
        href: href,
        closePopup: closePopup,
        actionSubjectId: "logOutLink",
        onClick: onClick,
        children: /*#__PURE__*/ (0, $2iln5.jsx)((0, $9KeuJ.default), {
            id: "identity.account-menu.account-menu-content.log-out-button",
            defaultMessage: "Log out",
            description: "Label for button in account menu to log out"
        })
    });
const $55964581a2712edd$var$Link = ({ testId: testId, closePopup: closePopup, icon: icon, href: href, onClick: onClick, actionSubjectId: actionSubjectId, children: children, ...props })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $8ik9q.useAnalyticsEvents)();
    const handleClick = (0, $4tluv.useCallback)((event)=>{
        const analyticsEvent = createAnalyticsEvent({
            eventType: (0, $he8Cl.UI_EVENT_TYPE),
            action: 'clicked',
            actionSubject: 'menuLinkItem',
            actionSubjectId: actionSubjectId
        });
        const clone = analyticsEvent.clone();
        if (clone) clone.fire((0, $5aeBt.NAVIGATION_CHANNEL));
        onClick?.(event, analyticsEvent);
        closePopup?.(event);
    }, [
        createAnalyticsEvent,
        onClick,
        closePopup,
        actionSubjectId
    ]);
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $a6epy.default), {
        testId: testId,
        iconBefore: icon,
        href: href,
        onClick: handleClick,
        ...props,
        children: children
    });
};

});
parcelRegister("8ik9q", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", () => $0cd1b0cc5dfad216$export$5bf35293e545f20c);

var $7ahwD = parcelRequire("7ahwD");

var $aLedp = parcelRequire("aLedp");

var $dAjGy = parcelRequire("dAjGy");
function $0cd1b0cc5dfad216$export$5bf35293e545f20c() {
    const analyticsContext = (0, $dAjGy.useAnalyticsContext)();
    const createAnalyticsEvent = (0, $7ahwD.useCallbackOne)((payload)=>{
        return new (0, $aLedp.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("7ahwD", function(module, exports) {
$parcel$export(module.exports, "useCallbackOne", () => $53770fc01536f7e7$export$33752cf3ee811995);
$parcel$export(module.exports, "useMemo", () => $53770fc01536f7e7$export$1538c33de8887b59);
$parcel$export(module.exports, "useCallback", () => $53770fc01536f7e7$export$35808ee640e87ca7);

var $4tluv = parcelRequire("4tluv");
function $53770fc01536f7e7$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (newInputs[i] !== lastInputs[i]) return false;
    }
    return true;
}
function $53770fc01536f7e7$export$b6feb8998cd9b342(getResult, inputs) {
    var initial = (0, $4tluv.useState)(function() {
        return {
            inputs: inputs,
            result: getResult()
        };
    })[0];
    var isFirstRun = (0, $4tluv.useRef)(true);
    var committed = (0, $4tluv.useRef)(initial);
    var useCache = isFirstRun.current || Boolean(inputs && committed.current.inputs && $53770fc01536f7e7$var$areInputsEqual(inputs, committed.current.inputs));
    var cache = useCache ? committed.current : {
        inputs: inputs,
        result: getResult()
    };
    (0, $4tluv.useEffect)(function() {
        isFirstRun.current = false;
        committed.current = cache;
    }, [
        cache
    ]);
    return cache.result;
}
function $53770fc01536f7e7$export$33752cf3ee811995(callback, inputs) {
    return $53770fc01536f7e7$export$b6feb8998cd9b342(function() {
        return callback;
    }, inputs);
}
var $53770fc01536f7e7$export$1538c33de8887b59 = $53770fc01536f7e7$export$b6feb8998cd9b342;
var $53770fc01536f7e7$export$35808ee640e87ca7 = $53770fc01536f7e7$export$33752cf3ee811995;

});

parcelRegister("aLedp", function(module, exports) {
$parcel$export(module.exports, "isUIAnalyticsEvent", () => $4e87cd33f5bd2d79$export$35f8383928ba8d7);
$parcel$export(module.exports, "default", () => $4e87cd33f5bd2d79$export$2e2bcd8739ae039);
/// <reference types="node" />

var $ec6IP = parcelRequire("ec6IP");
const $4e87cd33f5bd2d79$export$35f8383928ba8d7 = (obj)=>obj instanceof $4e87cd33f5bd2d79$export$2e2bcd8739ae039 || !!obj?._isUIAnalyticsEvent || // Backwards compatibility with older analytics-next packages
    obj?.constructor?.name === 'UIAnalyticsEvent';
class $4e87cd33f5bd2d79$export$2e2bcd8739ae039 extends (0, $ec6IP.default) {
    constructor(props){
        super(props), this._isUIAnalyticsEvent = true, this.clone = ()=>{
            if (this.hasFired) return null;
            const context = [
                ...this.context
            ];
            const handlers = [
                ...this.handlers
            ];
            /**
     * A hacky "deep clone" of the object. This is limited in that it wont
     * support functions, regexs, Maps, Sets, etc, but none of those need to
     * be represented in our payload.
     */ const payload = JSON.parse(JSON.stringify(this.payload));
            return new $4e87cd33f5bd2d79$export$2e2bcd8739ae039({
                context: context,
                handlers: handlers,
                payload: payload
            });
        }, this.fire = (channel)=>{
            if (this.hasFired) return;
            this.handlers.forEach((handler)=>handler(this, channel));
            this.hasFired = true;
        };
        this.context = props.context || [];
        this.handlers = props.handlers || [];
        this.hasFired = false;
    }
    update(updater) {
        if (this.hasFired) return this;
        return super.update(updater);
    }
}

});
parcelRegister("ec6IP", function(module, exports) {
$parcel$export(module.exports, "isAnalyticsEvent", () => $8a1bf2997ed0125c$export$ad4be5c2ec28cecf);
$parcel$export(module.exports, "default", () => $8a1bf2997ed0125c$export$2e2bcd8739ae039);
const $8a1bf2997ed0125c$export$ad4be5c2ec28cecf = (obj)=>obj instanceof $8a1bf2997ed0125c$export$2e2bcd8739ae039 || !!obj?._isAnalyticsEvent || // Backwards compatibility with older analytics-next packages
    obj?.constructor?.name === 'AnalyticsEvent';
class $8a1bf2997ed0125c$export$2e2bcd8739ae039 {
    constructor(props){
        this._isAnalyticsEvent = true;
        this.clone = ()=>{
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            const payload = {
                ...this.payload
            };
            return new $8a1bf2997ed0125c$export$2e2bcd8739ae039({
                payload: payload
            });
        };
        this.payload = props.payload;
    }
    update(updater) {
        if (typeof updater === 'function') this.payload = updater(this.payload);
        if (typeof updater === 'object') this.payload = {
            ...this.payload,
            ...updater
        };
        return this;
    }
}

});


parcelRegister("dAjGy", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsContext", () => $663bfda520126c9f$export$d1f587f82ad51c4);

var $4tluv = parcelRequire("4tluv");

var $fz2Rk = parcelRequire("fz2Rk");
const $663bfda520126c9f$export$d1f587f82ad51c4 = ()=>{
    return (0, $4tluv.useContext)((0, $fz2Rk.default));
};

});
parcelRegister("fz2Rk", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $b54c57ab88e3d11a$export$2e2bcd8739ae039);

var $9aaes = parcelRequire("9aaes");
var $b54c57ab88e3d11a$export$2e2bcd8739ae039 = (0, $9aaes.default);

});
parcelRegister("9aaes", function(module, exports) {
$parcel$export(module.exports, "default", () => $6abcfc1c0102583e$export$2e2bcd8739ae039);

var $4tluv = parcelRequire("4tluv");
var $6abcfc1c0102583e$var$AnalyticsNextContext = (0, $4tluv.createContext)({
    getAtlaskitAnalyticsContext: function() {
        return [];
    },
    getAtlaskitAnalyticsEventHandlers: function() {
        return [];
    }
});
var $6abcfc1c0102583e$export$2e2bcd8739ae039 = $6abcfc1c0102583e$var$AnalyticsNextContext;

});




parcelRegister("cmQJ8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::282b63b14f5d8b9b1a4035ff1652d30e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9010709466fb718f$var$_react = $9010709466fb718f$var$_interopRequireDefault((parcelRequire("4tluv")));

var $9010709466fb718f$var$_baseNew = $9010709466fb718f$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $9010709466fb718f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LogOut".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for log out.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9010709466fb718f$var$LogOutIcon = (props)=>/*#__PURE__*/ $9010709466fb718f$var$_react.default.createElement($9010709466fb718f$var$_baseNew.default, Object.assign({
        name: "LogOutIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5h5V1H3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h5v-1.5H3a.5.5 0 0 1-.5-.5V3a.5.5 0 0 1 .5-.5m11.78 4.97-3.5-3.5-1.06 1.06 2.22 2.22H6v1.5h6.44l-2.22 2.22 1.06 1.06 3.5-3.5a.75.75 0 0 0 0-1.06" clip-rule="evenodd"/>`
    }, props));
$9010709466fb718f$var$LogOutIcon.displayName = 'LogOutIcon';
var $9010709466fb718f$var$_default = module.exports.default = $9010709466fb718f$var$LogOutIcon;

});

parcelRegister("1XAxy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a53e84608f4cc80b860fc333251d7715>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $16d7a54295336cef$var$_react = $16d7a54295336cef$var$_interopRequireDefault((parcelRequire("4tluv")));

var $16d7a54295336cef$var$_baseNew = $16d7a54295336cef$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $16d7a54295336cef$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PeopleGroup".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a group or collection of people or users.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $16d7a54295336cef$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $16d7a54295336cef$var$_react.default.createElement($16d7a54295336cef$var$_baseNew.default, Object.assign({
        name: "PeopleGroupIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9 4.5a2 2 0 1 1 4 0 2 2 0 0 1-4 0M11 1a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7M3 5.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0M4 3a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M2.625 9A2.625 2.625 0 0 0 0 11.625V13h1.5v-1.375c0-.621.504-1.125 1.125-1.125H5V9zM6 12.5A3.5 3.5 0 0 1 9.5 9h3a3.5 3.5 0 0 1 3.5 3.5V14h-1.5v-1.5a2 2 0 0 0-2-2h-3a2 2 0 0 0-2 2V14H6z" clip-rule="evenodd"/>`
    }, props));
$16d7a54295336cef$var$PeopleGroupIcon.displayName = 'PeopleGroupIcon';
var $16d7a54295336cef$var$_default = module.exports.default = $16d7a54295336cef$var$PeopleGroupIcon;

});

parcelRegister("kJVAj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fc4353a18034f564a0b3573d4163ea60>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f194adbb49428514$var$_react = $f194adbb49428514$var$_interopRequireDefault((parcelRequire("4tluv")));

var $f194adbb49428514$var$_baseNew = $f194adbb49428514$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $f194adbb49428514$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Person".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f194adbb49428514$var$PersonIcon = (props)=>/*#__PURE__*/ $f194adbb49428514$var$_react.default.createElement($f194adbb49428514$var$_baseNew.default, Object.assign({
        name: "PersonIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m-2 9a3.75 3.75 0 0 1 3.75-3.75h4.5A3.75 3.75 0 0 1 14 13v2h-1.5v-2a2.25 2.25 0 0 0-2.25-2.25h-4.5A2.25 2.25 0 0 0 3.5 13v2H2z" clip-rule="evenodd"/>`
    }, props));
$f194adbb49428514$var$PersonIcon.displayName = 'PersonIcon';
var $f194adbb49428514$var$_default = module.exports.default = $f194adbb49428514$var$PersonIcon;

});

parcelRegister("bt5fG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e6207a690a69d1b6395dc313a9a74c2f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $85967a0e914304ce$var$_react = $85967a0e914304ce$var$_interopRequireDefault((parcelRequire("4tluv")));

var $85967a0e914304ce$var$_baseNew = $85967a0e914304ce$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $85967a0e914304ce$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Settings".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for any object or user settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $85967a0e914304ce$var$SettingsIcon = (props)=>/*#__PURE__*/ $85967a0e914304ce$var$_react.default.createElement($85967a0e914304ce$var$_baseNew.default, Object.assign({
        name: "SettingsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.058.462A.75.75 0 0 1 6.75 0h2.5a.75.75 0 0 1 .692.462l1.026 2.462 2.578-.374a.75.75 0 0 1 .757.367l1.25 2.166a.75.75 0 0 1-.049.824L13.937 8l1.567 2.093c.18.24.2.565.05.825l-1.25 2.165a.75.75 0 0 1-.758.367l-2.578-.374-1.026 2.463A.75.75 0 0 1 9.25 16h-2.5a.75.75 0 0 1-.692-.461l-1.026-2.463-2.578.374a.75.75 0 0 1-.757-.367l-1.25-2.165a.75.75 0 0 1 .049-.825L2.063 8 .496 5.907a.75.75 0 0 1-.05-.824l1.25-2.166a.75.75 0 0 1 .758-.367l2.578.374zM7.25 1.5l-.871 2.09c-.242.58-.845.923-1.467.833l-2.17-.315-.749 1.296L3.32 7.176c.366.488.366 1.16 0 1.648l-1.327 1.772.749 1.296 2.17-.315a1.375 1.375 0 0 1 1.467.832L7.25 14.5h1.5l.871-2.09c.242-.58.845-.923 1.467-.833l2.17.315.749-1.296-1.327-1.772a1.375 1.375 0 0 1 0-1.648l1.327-1.772-.749-1.296-2.17.315A1.375 1.375 0 0 1 9.62 3.59L8.75 1.5zm.75 5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0" clip-rule="evenodd"/>`
    }, props));
$85967a0e914304ce$var$SettingsIcon.displayName = 'SettingsIcon';
var $85967a0e914304ce$var$_default = module.exports.default = $85967a0e914304ce$var$SettingsIcon;

});

parcelRegister("5ZJiX", function(module, exports) {
$parcel$export(module.exports, "AccountDetails", () => $9274efb413e8d3f8$export$66e04d0aacdb3b2);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $jAkMr = parcelRequire("jAkMr");
var $fuAjD = parcelRequire("fuAjD");

var $9KeuJ = parcelRequire("9KeuJ");

var $kJVAj = parcelRequire("kJVAj");

var $bZmu5 = parcelRequire("bZmu5");

var $3mriI = parcelRequire("3mriI");

var $6Bc1Y = parcelRequire("6Bc1Y");
const $9274efb413e8d3f8$export$66e04d0aacdb3b2 = ({ testId: testId, name: name, picture: picture, email: email, managedBy: managedBy })=>/*#__PURE__*/ (0, $2iln5.jsxs)($9274efb413e8d3f8$var$Container, {
        "data-testid": testId,
        children: [
            managedBy && /*#__PURE__*/ (0, $2iln5.jsxs)($9274efb413e8d3f8$var$ManagedBy, {
                children: [
                    /*#__PURE__*/ (0, $2iln5.jsx)($9274efb413e8d3f8$var$PersonIconWrapper, {
                        children: /*#__PURE__*/ (0, $2iln5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kJVAj))), {
                            color: "currentColor",
                            label: ""
                        })
                    }),
                    /*#__PURE__*/ (0, $2iln5.jsx)((0, $9KeuJ.default), {
                        id: "identity.account-menu.account-menu-details.managed-account",
                        defaultMessage: "This account is managed by <b>{managedBy}</b>",
                        description: "Label showing the user which organisation manages their Atlassian account",
                        values: {
                            b: (text)=>/*#__PURE__*/ (0, $2iln5.jsx)((0, $bZmu5.default), {
                                    as: "strong",
                                    size: "small",
                                    color: "inherit",
                                    children: text
                                }),
                            managedBy: managedBy
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2iln5.jsx)($9274efb413e8d3f8$var$Content, {
                hasHeader: !!managedBy,
                children: /*#__PURE__*/ (0, $2iln5.jsx)($9274efb413e8d3f8$var$Profile, {
                    testId: testId,
                    name: name,
                    picture: picture,
                    email: email
                })
            })
        ]
    });
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9274efb413e8d3f8$var$Container = /*#__PURE__*/ (0, $4tluv.forwardRef)(({ as: C = "section", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2iln5.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $jAkMr.default)([
            "_1e0c1txw _2lx21bp4 _19pkidpf _2hwxu2gc _otyridpf _18u0u2gc",
            __cmplp.className
        ])
    });
});
const $9274efb413e8d3f8$var$ManagedBy = /*#__PURE__*/ (0, $4tluv.forwardRef)(({ as: C = "small", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2iln5.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $jAkMr.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0cp8ho _ca0qv77o _u5f3u2gc _n3tdv77o _19bvu2gc _y3gn1h6o _13lifajl _qrwqfajl _mrkbidpf _1o0zidpf _bfhk19ip _syazazsu",
            __cmplp.className
        ])
    });
});
const $9274efb413e8d3f8$var$PersonIconWrapper = /*#__PURE__*/ (0, $4tluv.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2iln5.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $jAkMr.default)([
            "_2hwx1b66 _nbgx1crf _1f021crf",
            __cmplp.className
        ])
    });
});
const $9274efb413e8d3f8$var$Content = /*#__PURE__*/ (0, $4tluv.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasHeader: hasHeader, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, $2iln5.jsx)(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1xsu82h": (0, $fuAjD.default)(__cmplp.hasHeader ? `0 0 ${"var(--ds-radius-small, 3px)"} ${"var(--ds-radius-small, 3px)"}` : "var(--ds-radius-small, 3px)")
        },
        ref: __cmplr,
        className: (0, $jAkMr.default)([
            "_2rko107z _1e0c1txw _2lx21bp4 _bfhkhfxm",
            __cmplp.className
        ])
    });
});
const $9274efb413e8d3f8$var$Profile = ({ name: name, email: email, picture: picture, testId: testId })=>/*#__PURE__*/ (0, $2iln5.jsxs)($9274efb413e8d3f8$var$ProfileWrapper, {
        children: [
            /*#__PURE__*/ (0, $2iln5.jsx)((0, $3mriI.ProfilePicture), {
                src: picture,
                testId: testId && `${testId}--picture`
            }),
            /*#__PURE__*/ (0, $2iln5.jsxs)($9274efb413e8d3f8$var$NameAndEmail, {
                children: [
                    /*#__PURE__*/ (0, $2iln5.jsx)($9274efb413e8d3f8$var$DisplayName, {
                        "data-testid": testId && `${testId}--name`,
                        children: name || /*#__PURE__*/ (0, $2iln5.jsx)((0, $6Bc1Y.SkeletonText), {
                            length: "6em"
                        })
                    }),
                    /*#__PURE__*/ (0, $2iln5.jsx)($9274efb413e8d3f8$var$EmailAddress, {
                        "data-testid": testId && `${testId}--email`,
                        children: email || /*#__PURE__*/ (0, $2iln5.jsx)((0, $6Bc1Y.SkeletonText), {
                            length: "10em"
                        })
                    })
                ]
            })
        ]
    });
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9274efb413e8d3f8$var$ProfileWrapper = /*#__PURE__*/ (0, $4tluv.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2iln5.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $jAkMr.default)([
            "_1e0c1txw _2lx2vrvc _19pkpxbi _2hwxpxbi _otyrpxbi _18u0pxbi",
            __cmplp.className
        ])
    });
});
const $9274efb413e8d3f8$var$NameAndEmail = /*#__PURE__*/ (0, $4tluv.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2iln5.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $jAkMr.default)([
            "_1e0c1txw _2lx21bp4 _19pk1wug _2hwxidpf _otyr1wug _18u0pxbi",
            __cmplp.className
        ])
    });
});
const $9274efb413e8d3f8$var$DisplayName = /*#__PURE__*/ (0, $4tluv.forwardRef)(({ as: C = "h3", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2iln5.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $jAkMr.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syazi7uo",
            __cmplp.className
        ])
    });
});
const $9274efb413e8d3f8$var$EmailAddress = /*#__PURE__*/ (0, $4tluv.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2iln5.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $jAkMr.default)([
            "_19pkv77o _syaz1rpy _k48pi7a9",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fuAjD", function(module, exports) {
$parcel$export(module.exports, "default", () => $b475d3e56fe31160$export$2e2bcd8739ae039);
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $b475d3e56fe31160$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return 'var(--c-, )';
}

});

parcelRegister("3mriI", function(module, exports) {
$parcel$export(module.exports, "ProfilePicture", () => $74e21bba6b9db0cb$export$2d75367b6e042d67);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line no-restricted-imports

var $2iln5 = parcelRequire("2iln5");

var $jAkMr = parcelRequire("jAkMr");
parcelRequire("4tluv");

var $3yCbE = parcelRequire("3yCbE");

var $eKPYN = parcelRequire("eKPYN");

var $fYX4U = parcelRequire("fYX4U");

var $gcMg7 = parcelRequire("gcMg7");
const $74e21bba6b9db0cb$var$styles = {
    imgContainer: "_1bsbvbgk _4t3ivbgk _mezjvbgk _w8l5vbgk _bna7vbgk _1752vbgk",
    imgContainerSkeleton: "_2rko1rr0 _bfhki8nm",
    img: "_2rko1rr0 _1e0c1ule"
};
const $74e21bba6b9db0cb$export$2d75367b6e042d67 = ({ testId: testId, src: src })=>{
    const state = (0, $gcMg7.useImageState)(src || '');
    const displayImage = src && state === 'loaded';
    const displayFallback = src && state === 'error';
    const displaySkeleton = !displayImage && !displayFallback;
    return /*#__PURE__*/ (0, $2iln5.jsxs)((0, $fYX4U.default), {
        testId: testId,
        xcss: (0, $3yCbE.cx)($74e21bba6b9db0cb$var$styles.imgContainer, displaySkeleton && $74e21bba6b9db0cb$var$styles.imgContainerSkeleton),
        children: [
            displayImage && /*#__PURE__*/ (0, $2iln5.jsx)("img", {
                "data-testid": testId && `${testId}--img`,
                src: src,
                alt: "",
                className: (0, $jAkMr.default)([
                    $74e21bba6b9db0cb$var$styles.img
                ])
            }),
            displayFallback && /*#__PURE__*/ (0, $2iln5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eKPYN))), {
                spacing: "spacious",
                testId: testId && `${testId}--fallback`,
                label: "",
                color: "var(--ds-text-subtlest, #6B6E76)"
            })
        ]
    });
};

});
parcelRegister("3yCbE", function(module, exports) {
$parcel$export(module.exports, "cx", () => $29722b30100693d5$export$a274e22fb40f762e);

var $jAkMr = parcelRequire("jAkMr");
const $29722b30100693d5$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $jAkMr.default)(actualStyles);
};

});


parcelRegister("6Bc1Y", function(module, exports) {
$parcel$export(module.exports, "SkeletonText", () => $ffdcc52d1986bb45$export$cb6ddd830302c2a8);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $jAkMr = parcelRequire("jAkMr");

var $iWyYU = parcelRequire("iWyYU");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $ffdcc52d1986bb45$var$SkeletonWrapper = /*#__PURE__*/ (0, $4tluv.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2iln5.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $jAkMr.default)([
            "_1e0c1o8l",
            __cmplp.className
        ])
    });
});
const $ffdcc52d1986bb45$export$cb6ddd830302c2a8 = ({ length: length })=>/*#__PURE__*/ (0, $2iln5.jsx)($ffdcc52d1986bb45$var$SkeletonWrapper, {
        children: /*#__PURE__*/ (0, $2iln5.jsx)((0, $iWyYU.default), {
            width: length,
            height: "1em",
            borderRadius: "0.5em"
        })
    });

});


parcelRegister("aRHKU", function(module, exports) {
$parcel$export(module.exports, "ThemeSwitcher", () => $dbaa073e899fc9fb$export$9d63163ee2173b37);

var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $DII3D = parcelRequire("DII3D");
var $9KeuJ = parcelRequire("9KeuJ");

var $8A9Bk = parcelRequire("8A9Bk");
var $fuaCP = parcelRequire("fuaCP");
var $e5Dvj = parcelRequire("e5Dvj");
var $60Q9s = parcelRequire("60Q9s");

var $kFokV = parcelRequire("kFokV");

var $eyvg7 = parcelRequire("eyvg7");

var $5x2FD = parcelRequire("5x2FD");

var $2ICGb = parcelRequire("2ICGb");

var $da7v4 = parcelRequire("da7v4");
var $fm1L8 = parcelRequire("fm1L8");
var $bZmu5 = parcelRequire("bZmu5");

var $qCXg3 = parcelRequire("qCXg3");

var $dTdif = parcelRequire("dTdif");

var $lD37q = parcelRequire("lD37q");
const $dbaa073e899fc9fb$export$9d63163ee2173b37 = ({ testId: testId, onThemeChange: onThemeChange, currentTheme: currentTheme, globalColorMode: globalColorMode, appearancePreferencesLink: appearancePreferencesLink, onThemeSwitcherOpenChange: onThemeSwitcherOpenChange })=>{
    return /*#__PURE__*/ (0, $2iln5.jsxs)((0, $2iln5.Fragment), {
        children: [
            $dbaa073e899fc9fb$var$themeOptions.map(({ value: value, thumbnail: thumbnail })=>/*#__PURE__*/ (0, $2iln5.jsx)("link", {
                    rel: "preload",
                    href: thumbnail,
                    as: "image"
                }, value)),
            /*#__PURE__*/ (0, $2iln5.jsxs)((0, $8A9Bk.default), {
                testId: testId,
                placement: "auto-start",
                onOpenChange: onThemeSwitcherOpenChange,
                trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, $2iln5.jsx)((0, $2ICGb.default), {
                        ref: triggerRef,
                        onClick: (event)=>event.stopPropagation(),
                        iconBefore: /*#__PURE__*/ (0, $2iln5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5x2FD))), {
                            color: "currentColor",
                            label: ""
                        }),
                        iconAfter: /*#__PURE__*/ (0, $2iln5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kFokV))), {
                            color: "currentColor",
                            label: "",
                            size: "small"
                        }),
                        ...props,
                        children: /*#__PURE__*/ (0, $2iln5.jsx)((0, $9KeuJ.default), {
                            id: "identity.account-menu.theme-switcher.theme-button",
                            defaultMessage: "Theme",
                            description: "Label for button in the account menu to switch to a different theme"
                        })
                    }),
                shouldRenderToParent: false,
                children: [
                    $dbaa073e899fc9fb$var$themeOptions.map(({ label: label, value: value, thumbnail: thumbnail })=>{
                        const isSynced = globalColorMode !== undefined && globalColorMode === value;
                        const isSelected = currentTheme === value;
                        return /*#__PURE__*/ (0, $2iln5.jsx)((0, $60Q9s.default), {
                            testId: `${testId}--radio-${value}`,
                            id: value,
                            onClick: ()=>onThemeChange(value),
                            isSelected: isSelected,
                            children: /*#__PURE__*/ (0, $2iln5.jsxs)((0, $da7v4.default), {
                                space: "space.150",
                                alignBlock: "center",
                                children: [
                                    /*#__PURE__*/ (0, $2iln5.jsx)("img", {
                                        src: thumbnail,
                                        width: 64,
                                        height: 48,
                                        alt: ""
                                    }),
                                    /*#__PURE__*/ (0, $2iln5.jsxs)((0, $fm1L8.default), {
                                        space: "space.025",
                                        children: [
                                            label,
                                            isSynced && /*#__PURE__*/ (0, $2iln5.jsx)((0, $bZmu5.default), {
                                                size: "small",
                                                color: "color.text.subtlest",
                                                children: /*#__PURE__*/ (0, $2iln5.jsx)((0, $9KeuJ.default), {
                                                    ...$dbaa073e899fc9fb$var$messages.syncedAcrossApps
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        }, value);
                    }),
                    appearancePreferencesLink && /*#__PURE__*/ (0, $2iln5.jsx)((0, $e5Dvj.default), {
                        hasSeparator: true,
                        children: /*#__PURE__*/ (0, $2iln5.jsx)((0, $fuaCP.default), {
                            href: appearancePreferencesLink,
                            target: "_blank",
                            rel: "noopener",
                            testId: testId && `${testId}--personalize`,
                            elemAfter: /*#__PURE__*/ (0, $2iln5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eyvg7))), {
                                color: "currentColor",
                                label: "",
                                size: "small"
                            }),
                            children: /*#__PURE__*/ (0, $2iln5.jsx)((0, $9KeuJ.default), {
                                ...$dbaa073e899fc9fb$var$messages.personalize
                            })
                        })
                    })
                ]
            })
        ]
    });
};
const $dbaa073e899fc9fb$var$messages = (0, $DII3D.defineMessages)({
    light: {
        id: 'identity.account-menu.theme-switcher.light.option',
        defaultMessage: 'Light',
        description: 'Label for the theme switcher light option'
    },
    dark: {
        id: 'identity.account-menu.theme-switcher.dark.option',
        defaultMessage: 'Dark',
        description: 'Label for the theme switcher dark option'
    },
    matchBrowser: {
        id: 'identity.account-menu.theme-switcher.match-browser.option',
        defaultMessage: 'Match browser',
        description: 'Label for the theme switcher match browser option'
    },
    syncedAcrossApps: {
        id: 'identity.account-menu.theme-switcher.synced-across-apps',
        defaultMessage: 'Synced across apps',
        description: 'Indicates the theme option is synced with global account settings across all apps'
    },
    personalize: {
        id: 'identity.account-menu.theme-switcher.personalize',
        defaultMessage: 'Personalize',
        description: 'Link to personalize settings in the theme switcher menu'
    }
});
const $dbaa073e899fc9fb$var$themeOptions = [
    {
        label: /*#__PURE__*/ (0, $2iln5.jsx)((0, $9KeuJ.default), {
            ...$dbaa073e899fc9fb$var$messages.light
        }),
        value: 'light',
        thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($dTdif)))
    },
    {
        label: /*#__PURE__*/ (0, $2iln5.jsx)((0, $9KeuJ.default), {
            ...$dbaa073e899fc9fb$var$messages.dark
        }),
        value: 'dark',
        thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($qCXg3)))
    },
    {
        label: /*#__PURE__*/ (0, $2iln5.jsx)((0, $9KeuJ.default), {
            ...$dbaa073e899fc9fb$var$messages.matchBrowser
        }),
        value: 'auto',
        thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($lD37q)))
    }
];

});
parcelRegister("kFokV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fbc9eb298cfdac722b50cf5246108693>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f0ba83afe0d6bcec$var$_react = $f0ba83afe0d6bcec$var$_interopRequireDefault((parcelRequire("4tluv")));

var $f0ba83afe0d6bcec$var$_baseNew = $f0ba83afe0d6bcec$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $f0ba83afe0d6bcec$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Next page of pagination results, collapsed tree item, expand tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f0ba83afe0d6bcec$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $f0ba83afe0d6bcec$var$_react.default.createElement($f0ba83afe0d6bcec$var$_baseNew.default, Object.assign({
        name: "ChevronRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m6.03 1.47 6 6a.75.75 0 0 1 .052 1.004l-.052.056-6 6-1.06-1.06L10.44 8 4.97 2.53z"/>`
    }, props));
$f0ba83afe0d6bcec$var$ChevronRightIcon.displayName = 'ChevronRightIcon';
var $f0ba83afe0d6bcec$var$_default = module.exports.default = $f0ba83afe0d6bcec$var$ChevronRightIcon;

});

parcelRegister("eyvg7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6b603e49d606132e091f78e8fc1c638c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a98c7d11f2a8c971$var$_react = $a98c7d11f2a8c971$var$_interopRequireDefault((parcelRequire("4tluv")));

var $a98c7d11f2a8c971$var$_baseNew = $a98c7d11f2a8c971$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $a98c7d11f2a8c971$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LinkExternal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links that open up a new tab.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a98c7d11f2a8c971$var$LinkExternalIcon = (props)=>/*#__PURE__*/ $a98c7d11f2a8c971$var$_react.default.createElement($a98c7d11f2a8c971$var$_baseNew.default, Object.assign({
        name: "LinkExternalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5v-3H15v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h3v1.5zM10 1h4.25a.75.75 0 0 1 .75.75V6h-1.5V3.56L7.53 9.53 6.47 8.47l5.97-5.97H10z" clip-rule="evenodd"/>`
    }, props));
$a98c7d11f2a8c971$var$LinkExternalIcon.displayName = 'LinkExternalIcon';
var $a98c7d11f2a8c971$var$_default = module.exports.default = $a98c7d11f2a8c971$var$LinkExternalIcon;

});

parcelRegister("5x2FD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c1d2d6708d394f801c1e7c6452a7750c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $40721b1e6374e578$var$_react = $40721b1e6374e578$var$_interopRequireDefault((parcelRequire("4tluv")));

var $40721b1e6374e578$var$_baseNew = $40721b1e6374e578$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $40721b1e6374e578$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Theme".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for representing themes and theme switching.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $40721b1e6374e578$var$ThemeIcon = (props)=>/*#__PURE__*/ $40721b1e6374e578$var$_react.default.createElement($40721b1e6374e578$var$_baseNew.default, Object.assign({
        name: "ThemeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m7.25-5H8a5 5 0 0 1 0 10h-.75z" clip-rule="evenodd"/>`
    }, props));
$40721b1e6374e578$var$ThemeIcon.displayName = 'ThemeIcon';
var $40721b1e6374e578$var$_default = module.exports.default = $40721b1e6374e578$var$ThemeIcon;

});

parcelRegister("qCXg3", function(module, exports) {
module.exports = new URL("dark-mode.c2768bcf.svg", import.meta.url).toString();

});

parcelRegister("dTdif", function(module, exports) {
module.exports = new URL("light-mode.e7c3914f.svg", import.meta.url).toString();

});

parcelRegister("lD37q", function(module, exports) {
module.exports = new URL("match-browser.a2bb9bea.svg", import.meta.url).toString();

});



parcelRegister("gRZTE", function(module, exports) {
$parcel$export(module.exports, "AccountMenuIntlProvider", () => $571a4d9aac9087f8$export$6c1f1571e3dd1b34);

var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $9XHz1 = parcelRequire("9XHz1");
var $8N0QD = parcelRequire("8N0QD");

var $2ZorX = parcelRequire("2ZorX");

var $hcSxw = parcelRequire("hcSxw");
const $571a4d9aac9087f8$export$6c1f1571e3dd1b34 = ({ children: children })=>{
    const { locale: locale } = (0, $8N0QD.default)();
    const messages = $571a4d9aac9087f8$var$useMessages(locale);
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $9XHz1.default), {
        locale: locale,
        messages: messages,
        onError: (err)=>{
            // Do not spam local devloop with missing translation errors
            //
            // See: https://github.com/formatjs/formatjs/issues/465#issuecomment-643887472
            // Note the default error handler: https://github.com/formatjs/formatjs/blob/d0b80fd9a814d1427b73577aebb7ccdb80b9ae94/packages/intl/src/utils.ts#L43
            if ($hcSxw?.env?.NODE_ENV !== 'production' && err?.code !== 'MISSING_TRANSLATION') // eslint-disable-next-line no-console
            console.error(err);
        },
        children: children
    });
};
const $571a4d9aac9087f8$var$useMessages = (locale)=>{
    const [messages, setMessages] = (0, $4tluv.useState)();
    (0, $4tluv.useEffect)(()=>{
        if (/^en(-US)?$/i.exec(locale)) // Use fallback messages, which are already US English
        setMessages(undefined);
        else {
            let cancelled = false;
            $571a4d9aac9087f8$var$loadMessages(locale).catch((_error)=>undefined) // TODO: Log error somehow (analytics?)
            .then((messages)=>{
                if (!cancelled) setMessages(messages);
            });
            return ()=>{
                cancelled = true;
            };
        }
    }, [
        locale,
        setMessages
    ]);
    return messages;
};
const $571a4d9aac9087f8$var$loadMessages = async (locale)=>{
    let [language, region = ''] = locale.split('-', 2);
    language = language.toLowerCase();
    region = region.toUpperCase();
    return (await ((0, $2ZorX.default)[`${language}_${region}`] || (0, $2ZorX.default)[language])?.())?.default;
};

});
parcelRegister("2ZorX", function(module, exports) {
$parcel$export(module.exports, "default", () => $19f2650ad693f577$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated by scripts/generate-i18n-index.ts.
 * DO NOT UPDATE IT BY HAND. Instead, run yarn generate-i18n-index.
 */ 










































const $19f2650ad693f577$var$lazyMessages = {
    cs: ()=>(parcelRequire("eD224")),
    cs_CZ: ()=>(parcelRequire("5azV5")),
    da: ()=>(parcelRequire("I6Ayo")),
    da_DK: ()=>(parcelRequire("63AuW")),
    de: ()=>(parcelRequire("6fvhd")),
    de_DE: ()=>(parcelRequire("cle5O")),
    en_GB: ()=>(parcelRequire("7tigL")),
    en_ZZ: ()=>(parcelRequire("IRwqj")),
    es: ()=>(parcelRequire("jbD8D")),
    fi: ()=>(parcelRequire("ao7eE")),
    fi_FI: ()=>(parcelRequire("aN0Sp")),
    fr: ()=>(parcelRequire("3Ihvy")),
    fr_FR: ()=>(parcelRequire("fvlqh")),
    hu: ()=>(parcelRequire("lH27D")),
    hu_HU: ()=>(parcelRequire("4q0om")),
    it: ()=>(parcelRequire("lT55s")),
    it_IT: ()=>(parcelRequire("2gMvW")),
    ja: ()=>(parcelRequire("djgBp")),
    ja_JP: ()=>(parcelRequire("buMcc")),
    ko: ()=>(parcelRequire("jS3JX")),
    ko_KR: ()=>(parcelRequire("cSnGq")),
    nb: ()=>(parcelRequire("iQSef")),
    nb_NO: ()=>(parcelRequire("8cvxy")),
    nl: ()=>(parcelRequire("lAryQ")),
    nl_NL: ()=>(parcelRequire("eheCy")),
    pl: ()=>(parcelRequire("1VweV")),
    pl_PL: ()=>(parcelRequire("bOujm")),
    pt_BR: ()=>(parcelRequire("9Ulww")),
    ru: ()=>(parcelRequire("cCK5x")),
    ru_RU: ()=>(parcelRequire("C4Ou8")),
    sv: ()=>(parcelRequire("kJizD")),
    sv_SE: ()=>(parcelRequire("gfVBi")),
    th: ()=>(parcelRequire("32KsE")),
    th_TH: ()=>(parcelRequire("jYQ49")),
    tr: ()=>(parcelRequire("kWc56")),
    tr_TR: ()=>(parcelRequire("bP8rN")),
    uk: ()=>(parcelRequire("jQbOM")),
    uk_UA: ()=>(parcelRequire("91YPc")),
    vi: ()=>(parcelRequire("c1HQb")),
    vi_VN: ()=>(parcelRequire("iZxyh")),
    zh: ()=>(parcelRequire("bI4O1")),
    zh_CN: ()=>(parcelRequire("iE1uP")),
    zh_TW: ()=>(parcelRequire("gydMZ"))
};
var $19f2650ad693f577$export$2e2bcd8739ae039 = $19f2650ad693f577$var$lazyMessages;

});
parcelRegister("eD224", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = Promise.all([
    $20gJU("jOsRz"),
    $20gJU("dAYgE")
]).then(()=>parcelRequire('gjsm7'));

});

parcelRegister("5azV5", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = Promise.all([
    $20gJU("jOsRz"),
    $20gJU("dAYgE")
]).then(()=>parcelRequire('ejpZD'));

});

parcelRegister("I6Ayo", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = Promise.all([
    $20gJU("jOsRz"),
    $20gJU("dAYgE")
]).then(()=>parcelRequire('hpHR5'));

});

parcelRegister("63AuW", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("9vW80").then(()=>parcelRequire('gFcH0'));

});

parcelRegister("6fvhd", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = Promise.all([
    $20gJU("jOsRz"),
    $20gJU("dAYgE")
]).then(()=>parcelRequire('1BRQa'));

});

parcelRegister("cle5O", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = Promise.all([
    $20gJU("jOsRz"),
    $20gJU("dAYgE")
]).then(()=>parcelRequire('4qR3y'));

});

parcelRegister("7tigL", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = Promise.all([
    $20gJU("jOsRz"),
    $20gJU("dAYgE")
]).then(()=>parcelRequire('dJMSf'));

});

parcelRegister("IRwqj", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = Promise.all([
    $20gJU("jOsRz"),
    $20gJU("dAYgE")
]).then(()=>parcelRequire('evK3E'));

});

parcelRegister("jbD8D", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = Promise.all([
    $20gJU("jOsRz"),
    $20gJU("dAYgE")
]).then(()=>parcelRequire('8X2Wu'));

});

parcelRegister("ao7eE", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = Promise.all([
    $20gJU("jOsRz"),
    $20gJU("dAYgE")
]).then(()=>parcelRequire('hUkho'));

});

parcelRegister("aN0Sp", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = Promise.all([
    $20gJU("jOsRz"),
    $20gJU("dAYgE")
]).then(()=>parcelRequire('26SeZ'));

});

parcelRegister("3Ihvy", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = Promise.all([
    $20gJU("jOsRz"),
    $20gJU("dAYgE")
]).then(()=>parcelRequire('jTT0l'));

});

parcelRegister("fvlqh", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = Promise.all([
    $20gJU("jOsRz"),
    $20gJU("dAYgE")
]).then(()=>parcelRequire('iU3z7'));

});

parcelRegister("lH27D", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = Promise.all([
    $20gJU("jOsRz"),
    $20gJU("dAYgE")
]).then(()=>parcelRequire('k75bK'));

});

parcelRegister("4q0om", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = Promise.all([
    $20gJU("jOsRz"),
    $20gJU("dAYgE")
]).then(()=>parcelRequire('517gW'));

});

parcelRegister("lT55s", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = Promise.all([
    $20gJU("jOsRz"),
    $20gJU("dAYgE")
]).then(()=>parcelRequire('t2l2U'));

});

parcelRegister("2gMvW", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("9vW80").then(()=>parcelRequire('i55EM'));

});

parcelRegister("djgBp", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = Promise.all([
    $20gJU("jOsRz"),
    $20gJU("dAYgE")
]).then(()=>parcelRequire('aMTqc'));

});

parcelRegister("buMcc", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = Promise.all([
    $20gJU("jOsRz"),
    $20gJU("dAYgE")
]).then(()=>parcelRequire('dwOYC'));

});

parcelRegister("jS3JX", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = Promise.all([
    $20gJU("jOsRz"),
    $20gJU("dAYgE")
]).then(()=>parcelRequire('6y9W3'));

});

parcelRegister("cSnGq", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = Promise.all([
    $20gJU("jOsRz"),
    $20gJU("dAYgE")
]).then(()=>parcelRequire('a8aPF'));

});

parcelRegister("iQSef", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = Promise.all([
    $20gJU("jOsRz"),
    $20gJU("dAYgE")
]).then(()=>parcelRequire('dTUG9'));

});

parcelRegister("8cvxy", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("9vW80").then(()=>parcelRequire('iEkQ1'));

});

parcelRegister("lAryQ", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = Promise.all([
    $20gJU("jOsRz"),
    $20gJU("dAYgE")
]).then(()=>parcelRequire('1SC2q'));

});

parcelRegister("eheCy", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = Promise.all([
    $20gJU("jOsRz"),
    $20gJU("dAYgE")
]).then(()=>parcelRequire('d5x25'));

});

parcelRegister("1VweV", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = Promise.all([
    $20gJU("jOsRz"),
    $20gJU("dAYgE")
]).then(()=>parcelRequire('3adW8'));

});

parcelRegister("bOujm", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = Promise.all([
    $20gJU("jOsRz"),
    $20gJU("dAYgE")
]).then(()=>parcelRequire('4Kemq'));

});

parcelRegister("9Ulww", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = Promise.all([
    $20gJU("jOsRz"),
    $20gJU("dAYgE")
]).then(()=>parcelRequire('fTOdm'));

});

parcelRegister("cCK5x", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = Promise.all([
    $20gJU("jOsRz"),
    $20gJU("dAYgE")
]).then(()=>parcelRequire('6vzxX'));

});

parcelRegister("C4Ou8", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = Promise.all([
    $20gJU("jOsRz"),
    $20gJU("dAYgE")
]).then(()=>parcelRequire('gqp8E'));

});

parcelRegister("kJizD", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = Promise.all([
    $20gJU("jOsRz"),
    $20gJU("dAYgE")
]).then(()=>parcelRequire('kK8M6'));

});

parcelRegister("gfVBi", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("9vW80").then(()=>parcelRequire('hqOV4'));

});

parcelRegister("32KsE", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = Promise.all([
    $20gJU("jOsRz"),
    $20gJU("dAYgE")
]).then(()=>parcelRequire('3TxNC'));

});

parcelRegister("jYQ49", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = Promise.all([
    $20gJU("jOsRz"),
    $20gJU("dAYgE")
]).then(()=>parcelRequire('eitPE'));

});

parcelRegister("kWc56", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = Promise.all([
    $20gJU("jOsRz"),
    $20gJU("dAYgE")
]).then(()=>parcelRequire('g7mJC'));

});

parcelRegister("bP8rN", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = Promise.all([
    $20gJU("jOsRz"),
    $20gJU("dAYgE")
]).then(()=>parcelRequire('7JF7D'));

});

parcelRegister("jQbOM", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = Promise.all([
    $20gJU("jOsRz"),
    $20gJU("dAYgE")
]).then(()=>parcelRequire('8EdhD'));

});

parcelRegister("91YPc", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = Promise.all([
    $20gJU("jOsRz"),
    $20gJU("dAYgE")
]).then(()=>parcelRequire('8Rgeb'));

});

parcelRegister("c1HQb", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = Promise.all([
    $20gJU("jOsRz"),
    $20gJU("dAYgE")
]).then(()=>parcelRequire('eHxA0'));

});

parcelRegister("iZxyh", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = Promise.all([
    $20gJU("jOsRz"),
    $20gJU("dAYgE")
]).then(()=>parcelRequire('h7x7S'));

});

parcelRegister("bI4O1", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = Promise.all([
    $20gJU("jOsRz"),
    $20gJU("dAYgE")
]).then(()=>parcelRequire('4mGMB'));

});

parcelRegister("iE1uP", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = Promise.all([
    $20gJU("jOsRz"),
    $20gJU("dAYgE")
]).then(()=>parcelRequire('9MiQV'));

});

parcelRegister("gydMZ", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = Promise.all([
    $20gJU("jOsRz"),
    $20gJU("dAYgE")
]).then(()=>parcelRequire('eWrMw'));

});



parcelRegister("e2DOV", function(module, exports) {
$parcel$export(module.exports, "AccountMenuPopup", () => $2c970ed0c86c3386$export$473cb05bf335b0e1);

var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $he8Cl = parcelRequire("he8Cl");

var $coxel = parcelRequire("coxel");

var $3X3Vo = parcelRequire("3X3Vo");

var $cJTli = parcelRequire("cJTli");

var $5aeBt = parcelRequire("5aeBt");
const $2c970ed0c86c3386$export$473cb05bf335b0e1 = ({ testId: testId, picture: picture, email: email, content: content, trustPicture: trustPicture = false, AccountMenuTrigger: AccountMenuTrigger })=>{
    const [isOpen, setIsOpen] = (0, $4tluv.useState)(false);
    const close = (0, $coxel.useCallbackWithAnalytics)(()=>setIsOpen(false), {
        eventType: (0, $he8Cl.UI_EVENT_TYPE),
        action: 'closed',
        actionSubject: 'popup',
        actionSubjectId: 'accountMenu'
    }, (0, $5aeBt.NAVIGATION_CHANNEL));
    const open = (0, $coxel.useCallbackWithAnalytics)(()=>setIsOpen(true), {
        eventType: (0, $he8Cl.UI_EVENT_TYPE),
        action: 'opened',
        actionSubject: 'popup',
        actionSubjectId: 'accountMenu'
    }, (0, $5aeBt.NAVIGATION_CHANNEL));
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $cJTli.default), {
        isOpen: isOpen,
        onClose: close,
        testId: testId,
        placement: "bottom",
        trigger: (triggerProps)=>/*#__PURE__*/ (0, $2iln5.jsx)(AccountMenuTrigger, {
                onClick: isOpen ? close : open,
                testId: testId && `${testId}--trigger`,
                picture: picture,
                email: email,
                trustPicture: trustPicture,
                ...triggerProps
            }),
        content: content,
        shouldRenderToParent: (0, $3X3Vo.fg)('should-render-to-parent-should-be-true-identity-ki')
    });
};

});
parcelRegister("coxel", function(module, exports) {
$parcel$export(module.exports, "useCallbackWithAnalytics", () => $5ae3d1f610d242a3$export$53c2b9c37c40e0d8);

var $4tluv = parcelRequire("4tluv");

var $8ik9q = parcelRequire("8ik9q");

var $8lhHD = parcelRequire("8lhHD");
const $5ae3d1f610d242a3$export$53c2b9c37c40e0d8 = (method, payload, channel)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $8ik9q.useAnalyticsEvents)();
    const methodRef = (0, $8lhHD.useTrackedRef)(method);
    const payloadRef = (0, $8lhHD.useTrackedRef)(payload);
    return (0, $4tluv.useCallback)((...args)=>{
        const pload = typeof payloadRef.current === 'function' ? payloadRef.current(...args) : payloadRef.current;
        createAnalyticsEvent(pload).fire(channel);
        methodRef.current(...args);
    }, [
        createAnalyticsEvent,
        methodRef,
        payloadRef,
        channel
    ]);
};

});
parcelRegister("8lhHD", function(module, exports) {
$parcel$export(module.exports, "useTrackedRef", () => $6604bb4699d273f1$export$1d27a74659855e44);

var $4tluv = parcelRequire("4tluv");
const $6604bb4699d273f1$export$1d27a74659855e44 = (value)=>{
    const ref = (0, $4tluv.useRef)(value);
    ref.current = value;
    return ref;
};

});





parcelRegister("lndDO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0a07179b7f5702563b15bc18315c2436>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f8f653c969638b9d$var$_react = $f8f653c969638b9d$var$_interopRequireDefault((parcelRequire("4tluv")));

var $f8f653c969638b9d$var$_baseNew = $f8f653c969638b9d$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $f8f653c969638b9d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Megaphone".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: feedback in apps.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f8f653c969638b9d$var$MegaphoneIcon = (props)=>/*#__PURE__*/ $f8f653c969638b9d$var$_react.default.createElement($f8f653c969638b9d$var$_baseNew.default, Object.assign({
        name: "MegaphoneIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 3.096a.5.5 0 0 0-.685-.465L7.5 4.756v4.736l5.315 2.126a.5.5 0 0 0 .685-.465zM5 13a.5.5 0 0 0 .5.5H6v-2.75H5zM2.5 8.75a.5.5 0 0 0 .5.5h3V5H3a.5.5 0 0 0-.5.5zM15 11.152a2 2 0 0 1-2.743 1.857L7.5 11.107v3.143a.75.75 0 0 1-.75.75H5.5a2 2 0 0 1-2-2v-2.25H3a2 2 0 0 1-2-2V5.5a2 2 0 0 1 2-2h3.605l5.652-2.261A2 2 0 0 1 15 3.096z"/>`
    }, props));
$f8f653c969638b9d$var$MegaphoneIcon.displayName = 'MegaphoneIcon';
var $f8f653c969638b9d$var$_default = module.exports.default = $f8f653c969638b9d$var$MegaphoneIcon;

});

parcelRegister("2HNL3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e0442f8372c8ab0b117b1651de731ee9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1f8631d2b5bc3df4$var$_react = $1f8631d2b5bc3df4$var$_interopRequireDefault((parcelRequire("4tluv")));

var $1f8631d2b5bc3df4$var$_baseNew = $1f8631d2b5bc3df4$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $1f8631d2b5bc3df4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Feedback".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1f8631d2b5bc3df4$var$FeedbackIcon = (props)=>/*#__PURE__*/ $1f8631d2b5bc3df4$var$_react.default.createElement($1f8631d2b5bc3df4$var$_baseNew.default, Object.assign({
        name: "FeedbackIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6.221l-4.064 2.63A.75.75 0 0 1 1 15V9.5h1.5v4.121l3.093-2A.75.75 0 0 1 6 11.5h7a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2.75a.5.5 0 0 0 .5.5h5.44L7.22 5.03l1.06-1.06 2.5 2.5a.75.75 0 0 1 0 1.06l-2.5 2.5-1.06-1.06 1.22-1.22H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$1f8631d2b5bc3df4$var$FeedbackIcon.displayName = 'FeedbackIcon';
var $1f8631d2b5bc3df4$var$_default = module.exports.default = $1f8631d2b5bc3df4$var$FeedbackIcon;

});

parcelRegister("9ALFH", function(module, exports) {
$parcel$export(module.exports, "announcements", () => $ff3f4e519ae5d302$export$d7f3895e994ed5c7);
parcelRequire("4tluv");

var $c7n79 = parcelRequire("c7n79");

var $dDkso = parcelRequire("dDkso");
const $ff3f4e519ae5d302$export$d7f3895e994ed5c7 = [
    {
        id: "announcement-2025-06-17",
        date: "2025-06-17",
        ...(0, $dDkso.ThemingAnnouncementData)
    },
    {
        id: "announcement-2025-03-25",
        date: "2025-03-25",
        ...(0, $c7n79.ShortCutAnnouncementData)
    }
]; // Note for developers:
 /*
When adding new announcements:
1. Add them at the TOP of the array
2. Use the format "announcement-YYYY-MM-DD" for IDs
3. Ensure images are imported from the assets directory
4. Place images in: src/assets/images/
5. The most recent announcement will trigger the "NEW" badge for users
*/ 

});
parcelRegister("c7n79", function(module, exports) {
$parcel$export(module.exports, "ShortCutAnnouncementData", () => $f16410cbb2244670$export$3fcaac43a559316e);

var $kbKpL = parcelRequire("kbKpL");
var $hT0yS = parcelRequire("hT0yS");
var $eojIt = parcelRequire("eojIt");

var $4tluv = parcelRequire("4tluv");

var $9KBmj = parcelRequire("9KBmj");

var $lIP59 = parcelRequire("lIP59");
var $7Ywk8 = parcelRequire("7Ywk8");

var $67Flg = parcelRequire("67Flg");

var $afq8D = parcelRequire("afq8D");

var $1ELgd = parcelRequire("1ELgd");

var $14tdF = parcelRequire("14tdF");

var $96ixn = parcelRequire("96ixn");

var $6cghZ = parcelRequire("6cghZ");

var $cQo2G = parcelRequire("cQo2G");

var $5bP6K = parcelRequire("5bP6K");

var $i9BIV = parcelRequire("i9BIV");
const $f16410cbb2244670$var$ShortcutAnnouncement = ()=>{
    const { formatMessage: formatMessage } = (0, $7Ywk8.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $kbKpL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $kbKpL.default), {
        xcss: (0, $afq8D.MediaStyles)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $hT0yS.default), {
        alignBlock: "stretch",
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $9KBmj.default), {
        alt: formatMessage((0, $1ELgd.messages).shortcutGifAlt),
        src: (0, (/*@__PURE__*/$parcel$interopDefault($14tdF))),
        width: "65%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $eojIt.default), {
        space: "space.100",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $9KBmj.default), {
        alt: formatMessage((0, $1ELgd.messages).chatShortcutAlt),
        src: (0, $i9BIV.isMacOs)() ? (0, (/*@__PURE__*/$parcel$interopDefault($96ixn))) : (0, (/*@__PURE__*/$parcel$interopDefault($cQo2G)))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $9KBmj.default), {
        alt: formatMessage((0, $1ELgd.messages).searchShortcutAlt),
        src: (0, $i9BIV.isMacOs)() ? (0, (/*@__PURE__*/$parcel$interopDefault($6cghZ))) : (0, (/*@__PURE__*/$parcel$interopDefault($5bP6K)))
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $kbKpL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $lIP59.default), (0, $1ELgd.messages).shortcutIntro), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $eojIt.default), {
        as: "ul"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement("b", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $lIP59.default), (0, $1ELgd.messages).chatTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $eojIt.default), {
        as: "ul"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement("li", null, (0, $i9BIV.isMacOs)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $lIP59.default), (0, $1ELgd.messages).macChatAccess) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $lIP59.default), (0, $1ELgd.messages).windowsChatAccess)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement("b", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $lIP59.default), (0, $1ELgd.messages).searchTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $eojIt.default), {
        as: "ul"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement("b", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $lIP59.default), (0, $1ELgd.messages).searchAnytimeTitle)), "\xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $lIP59.default), (0, $1ELgd.messages).searchAnytimeDesc)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement("b", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $lIP59.default), (0, $1ELgd.messages).searchNewTabTitle)), "\xa0", (0, $i9BIV.isMacOs)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $lIP59.default), (0, $1ELgd.messages).searchNewTabMacDesc) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $lIP59.default), (0, $1ELgd.messages).searchNewTabWindowsDesc)))))));
};
const $f16410cbb2244670$export$3fcaac43a559316e = {
    title: (0, $1ELgd.messages).shortcutTitle.defaultMessage,
    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement($f16410cbb2244670$var$ShortcutAnnouncement, null),
    tags: [
        (0, $67Flg.CATEGORIES).AI_SEARCH,
        (0, $67Flg.CATEGORIES).CHAT,
        (0, $67Flg.CATEGORIES).EXTENSION
    ]
};
var $f16410cbb2244670$export$2e2bcd8739ae039 = $f16410cbb2244670$var$ShortcutAnnouncement;

});
parcelRegister("67Flg", function(module, exports) {
$parcel$export(module.exports, "CATEGORIES", () => $e91e5d07501f2aed$export$a513ea61a7bee91c);
$parcel$export(module.exports, "default", () => $e91e5d07501f2aed$export$2e2bcd8739ae039);

var $4tluv = parcelRequire("4tluv");

var $lIP59 = parcelRequire("lIP59");

var $kbKpL = parcelRequire("kbKpL");
var $eojIt = parcelRequire("eojIt");
var $kfPot = parcelRequire("kfPot");

var $dff6Q = parcelRequire("dff6Q");

var $2dnyN = parcelRequire("2dnyN");
parcelRequire("1wxU2");
var $cyDwo = parcelRequire("cyDwo");
const $e91e5d07501f2aed$var$SidebarContainerStyles = (0, $kfPot.xcss)({
    position: "sticky",
    top: "space.500",
    maxHeight: "100vh",
    overflowY: "auto"
});
const $e91e5d07501f2aed$var$ButtonWrapperStyles = (isSelected)=>(0, $kfPot.xcss)({
        width: "100%",
        paddingBlock: "space.150",
        paddingInline: "space.200",
        backgroundColor: isSelected ? "color.background.selected" : "elevation.surface",
        font: "font.body",
        textAlign: "left",
        cursor: "pointer",
        ":hover": {
            backgroundColor: isSelected ? "color.background.selected.hovered" : "color.background.neutral.hovered"
        }
    });
const $e91e5d07501f2aed$var$CategoriesContainerStyles = (0, $kfPot.xcss)({
    maxHeight: "calc(100vh - 100px)",
    overflowY: "auto"
});
var $e91e5d07501f2aed$export$a513ea61a7bee91c = /*#__PURE__*/ function(CATEGORIES) {
    CATEGORIES["ALL"] = "All";
    CATEGORIES["AI_SEARCH"] = "AI Search";
    CATEGORIES["CHAT"] = "Chat";
    CATEGORIES["AGENT_STUDIO"] = "Agent Studio";
    CATEGORIES["EXTENSION"] = "Extension";
    return CATEGORIES;
}({});
const $e91e5d07501f2aed$var$DISPLAYED_CATEGORIES_LABEL = {
    ALL: (0, $2dnyN.messages).allCategoryLabel,
    AI_SEARCH: (0, $2dnyN.messages).aiSearchCategoryLabel,
    CHAT: (0, $2dnyN.messages).chatCategoryLabel,
    AGENT_STUDIO: (0, $2dnyN.messages).agentStudioCategoryLabel,
    EXTENSION: (0, $2dnyN.messages).extensionCategoryLabel
};
const $e91e5d07501f2aed$var$convertSpaceToUnderscore = (str)=>str.replace(/\s+/g, "_").toUpperCase();
const $e91e5d07501f2aed$var$CategorySidebar = ({ announcements: announcements, selectedCategory: selectedCategory, onCategorySelect: onCategorySelect })=>{
    const announcementTags = announcements.flatMap((announ)=>announ.tags);
    const categories = Array.from(new Set(announcementTags));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $kbKpL.default), {
        xcss: $e91e5d07501f2aed$var$SidebarContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $kbKpL.default), {
        xcss: $e91e5d07501f2aed$var$CategoriesContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $cyDwo.default), {
        name: "category-buttons"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $eojIt.default), {
        space: "space.200"
    }, categories.map((category, index)=>{
        const categoryKey = $e91e5d07501f2aed$var$convertSpaceToUnderscore(category);
        const categoryString = $e91e5d07501f2aed$var$DISPLAYED_CATEGORIES_LABEL[categoryKey];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $cyDwo.default), {
            key: index,
            name: "category-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $kbKpL.default), {
            onClick: ()=>onCategorySelect(category),
            xcss: $e91e5d07501f2aed$var$ButtonWrapperStyles(selectedCategory === category)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $dff6Q.default), {
            appearance: "subtle",
            spacing: "none"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $lIP59.default), categoryString))));
    })))));
};
var $e91e5d07501f2aed$export$2e2bcd8739ae039 = $e91e5d07501f2aed$var$CategorySidebar;

});
parcelRegister("dff6Q", function(module, exports) {
$parcel$export(module.exports, "default", () => $5bbc3e19eb937144$export$2e2bcd8739ae039);

var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $ccErM = parcelRequire("ccErM");

var $9xsIZ = parcelRequire("9xsIZ");

var $h47Ub = parcelRequire("h47Ub");

var $30n6g = parcelRequire("30n6g");
const $5bbc3e19eb937144$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
/**
 * __Button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new`
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A button triggers an event or action. They let users know what will happen next.
 *
 * - [Examples](https://atlassian.design/components/button/button-legacy/examples)
 * - [Code](https://atlassian.design/components/button/button-legacy/code)
 * - [Usage](https://atlassian.design/components/button/button-legacy/usage)
 */ const $5bbc3e19eb937144$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).forwardRef(function Button({ appearance: appearance = 'default', children: children, iconBefore: iconBefore, iconAfter: iconAfter, isSelected: isSelected = false, onMouseDown: providedOnMouseDown = (0, $ccErM.default), onMouseUp: providedOnMouseUp = (0, $ccErM.default), shouldFitContainer: shouldFitContainer = false, spacing: spacing = 'default', ...rest }, ref) {
    const isOnlySingleIcon = (0, $30n6g.default)({
        children: children,
        iconBefore: iconBefore,
        iconAfter: iconAfter
    });
    const [isActive, setIsActive] = (0, $4tluv.useState)(false);
    // Wrap onMouseDown / onMouseUp to manually trigger active state
    // in Firefox
    const onMouseDown = (0, $4tluv.useCallback)((event)=>{
        providedOnMouseDown(event);
        if ($5bbc3e19eb937144$var$isFirefox) setIsActive(true);
    }, [
        providedOnMouseDown,
        setIsActive
    ]);
    const onMouseUp = (0, $4tluv.useCallback)((event)=>{
        providedOnMouseUp(event);
        if ($5bbc3e19eb937144$var$isFirefox) setIsActive(false);
    }, [
        providedOnMouseUp,
        setIsActive
    ]);
    const buttonCss = (0, $4tluv.useMemo)(()=>(0, $h47Ub.getCss)({
            appearance: appearance,
            spacing: spacing,
            isSelected: isSelected,
            shouldFitContainer: shouldFitContainer,
            isOnlySingleIcon: isOnlySingleIcon
        }), [
        appearance,
        spacing,
        isSelected,
        shouldFitContainer,
        isOnlySingleIcon
    ]);
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $9xsIZ.default), {
        ...rest,
        ref: ref,
        appearance: appearance,
        buttonCss: buttonCss,
        children: children,
        // Due to how click events are set, we need to set active styles
        // manually in Firefox and wrap onMouseDown/onMouseUp
        "data-firefox-is-active": isActive ? true : undefined,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isSelected: isSelected,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        spacing: spacing
    });
}));
// Tools including enzyme rely on components having a display name
$5bbc3e19eb937144$var$Button.displayName = 'Button';
var $5bbc3e19eb937144$export$2e2bcd8739ae039 = $5bbc3e19eb937144$var$Button;

});
parcelRegister("9xsIZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $4e17730f1a278a32$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $4tluv = parcelRequire("4tluv");

var $ft5N0 = parcelRequire("ft5N0");

var $wYkfM = parcelRequire("wYkfM");

var $ccErM = parcelRequire("ccErM");

var $eL2h4 = parcelRequire("eL2h4");

var $i83eE = parcelRequire("i83eE");

var $cDSkE = parcelRequire("cDSkE");

var $5xZ7U = parcelRequire("5xZ7U");

var $ioYTM = parcelRequire("ioYTM");

var $3KjCU = parcelRequire("3KjCU");

var $bxrm7 = parcelRequire("bxrm7");

var $h8v80 = parcelRequire("h8v80");

var $4sg7i = parcelRequire("4sg7i");
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
const $4e17730f1a278a32$var$noPointerEventsOnChildrenCss = {
    '> *': {
        pointerEvents: 'none'
    }
};
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out, feature flag
 * platform-visual-refresh-icons is cleaned up,
 * and we bump Button to set padding based on the new icons.
 */ const $4e17730f1a278a32$var$iconBeforeSpacingFixStyle = (0, $ft5N0.css)({
    '--ds--button--new-icon-padding-end': "var(--ds-space-025, 2px)",
    '--ds--button--new-icon-padding-start': "var(--ds-space-050, 4px)",
    marginInlineStart: "var(--ds-space-negative-025, -2px)"
});
const $4e17730f1a278a32$var$iconAfterSpacingFixStyle = (0, $ft5N0.css)({
    '--ds--button--new-icon-padding-end': "var(--ds-space-050, 4px)",
    '--ds--button--new-icon-padding-start': "var(--ds-space-025, 2px)",
    marginInlineEnd: "var(--ds-space-negative-025, -2px)"
});
const $4e17730f1a278a32$var$getSpacingFix = (children, spacingStyles)=>{
    if (!children || (0, $h8v80.getIfVisuallyHiddenChildren)(children)) return null;
    return spacingStyles;
};
const $4e17730f1a278a32$var$getChildren = (children, childrenStyles)=>{
    if ((0, $h8v80.getIfVisuallyHiddenChildren)(children)) return children;
    return children ? /*#__PURE__*/ (0, $ft5N0.jsx)("span", {
        css: childrenStyles
    }, children) : null;
};
const $4e17730f1a278a32$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).forwardRef(function ButtonBase(props, ref) {
    const { analyticsContext: // I don't think analytics should be in button, but for now it is
    analyticsContext, appearance: appearance = 'default', autoFocus: autoFocus = false, buttonCss: buttonCss, children: children, className: className, href: href, // use the provided component prop,
    // else default to anchor if there is a href, and button if there is no href
    component: Component = href ? 'a' : 'button', iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled = false, isSelected: isSelected = false, onBlur: onBlur, onClick: providedOnClick = (0, $ccErM.default), onFocus: onFocus, onMouseDown: providedOnMouseDown = (0, $ccErM.default), overlay: overlay, shouldFitContainer: // Pulling out so it doesn't spread on rendered component
    shouldFitContainer, spacing: spacing = 'default', tabIndex: tabIndex = 0, type: type = !href ? 'button' : undefined, testId: testId, ...rest } = props;
    const ourRef = (0, $4tluv.useRef)();
    const setRef = (0, $4tluv.useCallback)((node)=>{
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === 'function') {
            ref(node);
            return;
        }
        // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $eL2h4.default)(ourRef, autoFocus);
    const interactionContext = (0, $4tluv.useContext)((0, $cDSkE.default));
    const handleClick = (0, $4tluv.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const onClick = (0, $wYkfM.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: 'button',
        packageName: undefined,
        packageVersion: undefined,
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    const onMouseDown = (0, $4tluv.useCallback)((event)=>{
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, $4tluv.useEffect)(()=>{
        const el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    const hasOverlay = Boolean(overlay);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const fadeStyles = (0, $ft5N0.css)((0, $3KjCU.getFadingCss)({
        hasOverlay: hasOverlay
    }));
    const isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067.
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === 'warning') spinnerHackCss = {
        '[data-theme] & circle': {
            stroke: `${isSelected || isDisabled ? "var(--ds-icon-subtle, #505258)" : "var(--ds-icon-warning-inverse, #292A2E)"} !important`
        }
    };
    return /*#__PURE__*/ (0, $ft5N0.jsx)((0, $i83eE.default), null, /*#__PURE__*/ (0, $ft5N0.jsx)(Component, {
        ...rest,
        ref: setRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $4e17730f1a278a32$var$noPointerEventsOnChildrenCss
        ],
        // using undefined so that the property doesn't exist when false
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        // Adding a tab index so element is always focusable, even when not a <button> or <a>
        // Disabling focus via keyboard navigation when disabled
        // as this is standard button behaviour
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type,
        ...(0, $5xZ7U.default)({
            isInteractive: isInteractive
        })
    }, iconBefore ? /*#__PURE__*/ (0, $ft5N0.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $bxrm7.getIconStyle)({
                spacing: spacing
            }),
            $4e17730f1a278a32$var$getSpacingFix(children, $4e17730f1a278a32$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, $4e17730f1a278a32$var$getChildren(children, [
        fadeStyles,
        (0, $ioYTM.getContentStyle)({
            spacing: spacing
        })
    ]), iconAfter ? /*#__PURE__*/ (0, $ft5N0.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $bxrm7.getIconStyle)({
                spacing: spacing
            }),
            $4e17730f1a278a32$var$getSpacingFix(children, $4e17730f1a278a32$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? /*#__PURE__*/ (0, $ft5N0.jsx)("span", {
        css: [
            (0, $4sg7i.overlayCss),
            spinnerHackCss
        ]
    }, overlay) : null));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4e17730f1a278a32$export$2e2bcd8739ae039 = $4e17730f1a278a32$var$ButtonBase;

});
parcelRegister("ft5N0", function(module, exports) {
$parcel$export(module.exports, "createElement", () => $b42e0e176e027d49$export$c8a8987d4410bf2d);
$parcel$export(module.exports, "Global", () => $b42e0e176e027d49$export$98f03c5d19621d70);
$parcel$export(module.exports, "css", () => $b42e0e176e027d49$export$dbf350e5966cf602);
$parcel$export(module.exports, "keyframes", () => $b42e0e176e027d49$export$d25ddfdf17c3ad3e);
$parcel$export(module.exports, "ClassNames", () => $b42e0e176e027d49$export$9b9c0f9d9f3552b8);
$parcel$export(module.exports, "jsx", () => $b42e0e176e027d49$export$c8a8987d4410bf2d);
$parcel$export(module.exports, "CacheProvider", () => (parcelRequire("goxRc")).C);
$parcel$export(module.exports, "ThemeContext", () => (parcelRequire("goxRc")).T);
$parcel$export(module.exports, "ThemeProvider", () => (parcelRequire("goxRc")).a);
$parcel$export(module.exports, "__unsafe_useEmotionCache", () => (parcelRequire("goxRc"))._);
$parcel$export(module.exports, "useTheme", () => (parcelRequire("goxRc")).u);
$parcel$export(module.exports, "withEmotionCache", () => (parcelRequire("goxRc")).w);
$parcel$export(module.exports, "withTheme", () => (parcelRequire("goxRc")).b);

var $goxRc = parcelRequire("goxRc");

var $4tluv = parcelRequire("4tluv");

var $g4E5y = parcelRequire("g4E5y");

var $jbcP2 = parcelRequire("jbcP2");

var $gS9xC = parcelRequire("gS9xC");
parcelRequire("eGUYL");
parcelRequire("iXMid");
parcelRequire("bCXZb");

parcelRequire("523n4");
var $b42e0e176e027d49$var$pkg = {
    name: "@emotion/react",
    version: "11.11.4",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "import": "./dist/emotion-react.cjs.mjs",
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
            types: {
                "import": "./macro.d.mts",
                "default": "./macro.d.ts"
            },
            "default": "./macro.js"
        }
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.*"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.11.0",
        "@emotion/cache": "^11.11.0",
        "@emotion/serialize": "^1.1.3",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
        "@emotion/utils": "^1.2.1",
        "@emotion/weak-memoize": "^0.3.1",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.11.2",
        "@emotion/css-prettifier": "1.1.3",
        "@emotion/server": "11.11.0",
        "@emotion/styled": "11.11.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": {
                    types: {
                        "import": "./macro.d.mts",
                        "default": "./macro.d.ts"
                    },
                    "default": "./macro.js"
                }
            }
        }
    }
};
var $b42e0e176e027d49$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $goxRc.h).call(props, 'css')) // $FlowFixMe
    return $4tluv.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $goxRc.E);
    createElementArgArray[1] = (0, $goxRc.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return $4tluv.createElement.apply(null, createElementArgArray);
};
var $b42e0e176e027d49$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $b42e0e176e027d49$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $goxRc.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $gS9xC.serializeStyles)([
        styles
    ], undefined, $4tluv.useContext((0, $goxRc.T)));
    if (!(0, $goxRc.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $4tluv.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $4tluv.useRef();
    (0, $jbcP2.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $jbcP2.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $g4E5y.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $b42e0e176e027d49$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $gS9xC.serializeStyles)(args);
}
var $b42e0e176e027d49$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $b42e0e176e027d49$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $b42e0e176e027d49$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $b42e0e176e027d49$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $g4E5y.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $b42e0e176e027d49$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $jbcP2.useInsertionEffectAlwaysWithSyncFallback)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $g4E5y.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
var $b42e0e176e027d49$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $goxRc.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $gS9xC.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $g4E5y.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $b42e0e176e027d49$var$merge(cache.registered, css, $b42e0e176e027d49$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $4tluv.useContext((0, $goxRc.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $4tluv.createElement($4tluv.Fragment, null, /*#__PURE__*/ $4tluv.createElement($b42e0e176e027d49$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var $b42e0e176e027d49$var$isBrowser, $b42e0e176e027d49$var$isTestEnv, $b42e0e176e027d49$var$globalContext, $b42e0e176e027d49$var$globalKey;

});
parcelRegister("goxRc", function(module, exports) {
$parcel$export(module.exports, "i", () => $bef92684cf255db0$export$23f2a1d2818174ef);
$parcel$export(module.exports, "h", () => $bef92684cf255db0$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "C", () => $bef92684cf255db0$export$e7094788287c5e9b);
$parcel$export(module.exports, "_", () => $bef92684cf255db0$export$71511d61b312f219);
$parcel$export(module.exports, "w", () => $bef92684cf255db0$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "T", () => $bef92684cf255db0$export$971d5caa766a69d7);
$parcel$export(module.exports, "u", () => $bef92684cf255db0$export$3b14a55fb2447963);
$parcel$export(module.exports, "a", () => $bef92684cf255db0$export$407448d2b89b1813);
$parcel$export(module.exports, "b", () => $bef92684cf255db0$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "c", () => $bef92684cf255db0$export$db3b6bfb95261072);
$parcel$export(module.exports, "E", () => $bef92684cf255db0$export$a9c23c6ac3fc3eca);

var $4tluv = parcelRequire("4tluv");

var $eGUYL = parcelRequire("eGUYL");

var $iXMid = parcelRequire("iXMid");

var $bCXZb = parcelRequire("bCXZb");

var $3gAf0 = parcelRequire("3gAf0");

var $g4E5y = parcelRequire("g4E5y");

var $gS9xC = parcelRequire("gS9xC");

var $jbcP2 = parcelRequire("jbcP2");
var $bef92684cf255db0$export$23f2a1d2818174ef = true;
var $bef92684cf255db0$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $bef92684cf255db0$var$EmotionCacheContext = /* #__PURE__ */ $4tluv.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $eGUYL.default)({
    key: 'css'
}) : null);
var $bef92684cf255db0$export$e7094788287c5e9b = $bef92684cf255db0$var$EmotionCacheContext.Provider;
var $bef92684cf255db0$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $4tluv.useContext)($bef92684cf255db0$var$EmotionCacheContext);
};
var $bef92684cf255db0$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $4tluv.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $4tluv.useContext)($bef92684cf255db0$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$bef92684cf255db0$export$23f2a1d2818174ef) $bef92684cf255db0$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $4tluv.useContext)($bef92684cf255db0$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $eGUYL.default)({
                key: 'css'
            });
            return /*#__PURE__*/ $4tluv.createElement($bef92684cf255db0$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $bef92684cf255db0$export$971d5caa766a69d7 = /* #__PURE__ */ $4tluv.createContext({});
var $bef92684cf255db0$export$3b14a55fb2447963 = function useTheme() {
    return $4tluv.useContext($bef92684cf255db0$export$971d5caa766a69d7);
};
var $bef92684cf255db0$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $iXMid.default)({}, outerTheme, theme);
};
var $bef92684cf255db0$var$createCacheWithTheme = /* #__PURE__ */ (0, $bCXZb.default)(function(outerTheme) {
    return (0, $bCXZb.default)(function(theme) {
        return $bef92684cf255db0$var$getTheme(outerTheme, theme);
    });
});
var $bef92684cf255db0$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $4tluv.useContext($bef92684cf255db0$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $bef92684cf255db0$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $4tluv.createElement($bef92684cf255db0$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $bef92684cf255db0$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var render = function render(props, ref) {
        var theme = $4tluv.useContext($bef92684cf255db0$export$971d5caa766a69d7);
        return /*#__PURE__*/ $4tluv.createElement(Component, (0, $iXMid.default)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ $4tluv.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $3gAf0.default)(WithTheme, Component);
}
var $bef92684cf255db0$var$getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split('.');
    return parts[parts.length - 1];
};
var $bef92684cf255db0$var$getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return $bef92684cf255db0$var$getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return $bef92684cf255db0$var$getLastPart(match[1]);
    return undefined;
};
var $bef92684cf255db0$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    'renderWithHooks',
    'processChild',
    'finishClassComponent',
    'renderToString'
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $bef92684cf255db0$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, '-');
};
var $bef92684cf255db0$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split('\n');
    for(var i = 0; i < lines.length; i++){
        var functionName = $bef92684cf255db0$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($bef92684cf255db0$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $bef92684cf255db0$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $bef92684cf255db0$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $bef92684cf255db0$var$labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var $bef92684cf255db0$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($bef92684cf255db0$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$bef92684cf255db0$var$typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var $bef92684cf255db0$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $g4E5y.registerStyles)(cache, serialized, isStringTag);
    (0, $jbcP2.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $g4E5y.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $bef92684cf255db0$var$Emotion = /* #__PURE__ */ $bef92684cf255db0$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$bef92684cf255db0$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $g4E5y.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $gS9xC.serializeStyles)(registeredStyles, undefined, $4tluv.useContext($bef92684cf255db0$export$971d5caa766a69d7));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($bef92684cf255db0$export$dda1d9f60106f0e9.call(props, key) && key !== 'css' && key !== $bef92684cf255db0$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ $4tluv.createElement($4tluv.Fragment, null, /*#__PURE__*/ $4tluv.createElement($bef92684cf255db0$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $4tluv.createElement(WrappedComponent, newProps));
});
var $bef92684cf255db0$export$a9c23c6ac3fc3eca = $bef92684cf255db0$var$Emotion;

});
parcelRegister("eGUYL", function(module, exports) {
$parcel$export(module.exports, "default", () => $ab212fc62e376710$export$2e2bcd8739ae039);

var $duh1I = parcelRequire("duh1I");

var $bEBdP = parcelRequire("bEBdP");
var $3cJUx = parcelRequire("3cJUx");
var $bHsV8 = parcelRequire("bHsV8");
var $7OJ6h = parcelRequire("7OJ6h");
var $fpv30 = parcelRequire("fpv30");
var $jKOmY = parcelRequire("jKOmY");
parcelRequire("bCXZb");
parcelRequire("infHZ");
var $ab212fc62e376710$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $bEBdP.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $bEBdP.token)(character)) break;
        (0, $bEBdP.next)();
    }
    return (0, $bEBdP.slice)(begin, (0, $bEBdP.position));
};
var $ab212fc62e376710$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $bEBdP.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $bEBdP.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $ab212fc62e376710$var$identifierWithPointTracking((0, $bEBdP.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $bEBdP.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $bEBdP.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $3cJUx.from)(character);
    }
    while (character = (0, $bEBdP.next)());
    return parsed;
};
var $ab212fc62e376710$var$getRules = function getRules(value, points) {
    return (0, $bEBdP.dealloc)($ab212fc62e376710$var$toRules((0, $bEBdP.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $ab212fc62e376710$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $ab212fc62e376710$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$ab212fc62e376710$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $ab212fc62e376710$var$fixedElements.set(element, true);
    var points = [];
    var rules = $ab212fc62e376710$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $ab212fc62e376710$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
var $ab212fc62e376710$var$ignoreFlag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';
var $ab212fc62e376710$var$isIgnoringComment = function isIgnoringComment(element) {
    return element.type === 'comm' && element.children.indexOf($ab212fc62e376710$var$ignoreFlag) > -1;
};
var $ab212fc62e376710$var$createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== 'rule' || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if ($ab212fc62e376710$var$isIgnoringComment(node)) return;
                    break;
                }
            }
        }
    };
};
var $ab212fc62e376710$var$isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var $ab212fc62e376710$var$isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!$ab212fc62e376710$var$isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var $ab212fc62e376710$var$nullifyElement = function nullifyElement(element) {
    element.type = '';
    element.value = '';
    element["return"] = '';
    element.children = '';
    element.props = '';
};
var $ab212fc62e376710$var$incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!$ab212fc62e376710$var$isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        $ab212fc62e376710$var$nullifyElement(element);
    } else if ($ab212fc62e376710$var$isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        $ab212fc62e376710$var$nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function $ab212fc62e376710$var$prefix(value, length) {
    switch((0, $3cJUx.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $7OJ6h.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $7OJ6h.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $7OJ6h.WEBKIT) + value + (0, $7OJ6h.MOZ) + value + (0, $7OJ6h.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $7OJ6h.WEBKIT) + value + (0, $7OJ6h.MS) + value + value;
        // order
        case 6165:
            return (0, $7OJ6h.WEBKIT) + value + (0, $7OJ6h.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $7OJ6h.WEBKIT) + value + (0, $3cJUx.replace)(value, /(\w+).+(:[^]+)/, (0, $7OJ6h.WEBKIT) + 'box-$1$2' + (0, $7OJ6h.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $7OJ6h.WEBKIT) + value + (0, $7OJ6h.MS) + 'flex-item-' + (0, $3cJUx.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $7OJ6h.WEBKIT) + value + (0, $7OJ6h.MS) + 'flex-line-pack' + (0, $3cJUx.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $7OJ6h.WEBKIT) + value + (0, $7OJ6h.MS) + (0, $3cJUx.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $7OJ6h.WEBKIT) + value + (0, $7OJ6h.MS) + (0, $3cJUx.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $7OJ6h.WEBKIT) + 'box-' + (0, $3cJUx.replace)(value, '-grow', '') + (0, $7OJ6h.WEBKIT) + value + (0, $7OJ6h.MS) + (0, $3cJUx.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $7OJ6h.WEBKIT) + (0, $3cJUx.replace)(value, /([^-])(transform)/g, '$1' + (0, $7OJ6h.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $3cJUx.replace)((0, $3cJUx.replace)((0, $3cJUx.replace)(value, /(zoom-|grab)/, (0, $7OJ6h.WEBKIT) + '$1'), /(image-set)/, (0, $7OJ6h.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $3cJUx.replace)(value, /(image-set\([^]*)/, (0, $7OJ6h.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $3cJUx.replace)((0, $3cJUx.replace)(value, /(.+:)(flex-)?(.*)/, (0, $7OJ6h.WEBKIT) + 'box-pack:$3' + (0, $7OJ6h.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $7OJ6h.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $3cJUx.replace)(value, /(.+)-inline(.+)/, (0, $7OJ6h.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $3cJUx.strlen)(value) - 1 - length > 6) switch((0, $3cJUx.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $3cJUx.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $3cJUx.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $7OJ6h.WEBKIT) + '$2-$3' + '$1' + (0, $7OJ6h.MOZ) + ((0, $3cJUx.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $3cJUx.indexof)(value, 'stretch') ? $ab212fc62e376710$var$prefix((0, $3cJUx.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $3cJUx.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $3cJUx.charat)(value, (0, $3cJUx.strlen)(value) - 3 - (~(0, $3cJUx.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $3cJUx.replace)(value, ':', ':' + (0, $7OJ6h.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $3cJUx.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $7OJ6h.WEBKIT) + ((0, $3cJUx.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $7OJ6h.WEBKIT) + '$2$3' + '$1' + (0, $7OJ6h.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $3cJUx.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $7OJ6h.WEBKIT) + value + (0, $7OJ6h.MS) + (0, $3cJUx.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $7OJ6h.WEBKIT) + value + (0, $7OJ6h.MS) + (0, $3cJUx.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $7OJ6h.WEBKIT) + value + (0, $7OJ6h.MS) + (0, $3cJUx.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $7OJ6h.WEBKIT) + value + (0, $7OJ6h.MS) + value + value;
    }
    return value;
}
var $ab212fc62e376710$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $7OJ6h.DECLARATION:
                element["return"] = $ab212fc62e376710$var$prefix(element.value, element.length);
                break;
            case 0, $7OJ6h.KEYFRAMES:
                return (0, $jKOmY.serialize)([
                    (0, $bEBdP.copy)(element, {
                        value: (0, $3cJUx.replace)(element.value, '@', '@' + (0, $7OJ6h.WEBKIT))
                    })
                ], callback);
            case 0, $7OJ6h.RULESET:
                if (element.length) return (0, $3cJUx.combine)(element.props, function(value) {
                    switch((0, $3cJUx.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $jKOmY.serialize)([
                                (0, $bEBdP.copy)(element, {
                                    props: [
                                        (0, $3cJUx.replace)(value, /:(read-\w+)/, ':' + (0, $7OJ6h.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $jKOmY.serialize)([
                                (0, $bEBdP.copy)(element, {
                                    props: [
                                        (0, $3cJUx.replace)(value, /:(plac\w+)/, ':' + (0, $7OJ6h.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $bEBdP.copy)(element, {
                                    props: [
                                        (0, $3cJUx.replace)(value, /:(plac\w+)/, ':' + (0, $7OJ6h.MOZ) + '$1')
                                    ]
                                }),
                                (0, $bEBdP.copy)(element, {
                                    props: [
                                        (0, $3cJUx.replace)(value, /:(plac\w+)/, (0, $7OJ6h.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $ab212fc62e376710$var$defaultStylisPlugins = [
    $ab212fc62e376710$var$prefixer
];
var $ab212fc62e376710$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $ab212fc62e376710$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
        var attrib = node.getAttribute("data-emotion").split(' '); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $ab212fc62e376710$var$compat,
        $ab212fc62e376710$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $jKOmY.stringify),
        (0, $fpv30.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $fpv30.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $jKOmY.serialize)((0, $bHsV8.compile)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $duh1I.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("duh1I", function(module, exports) {
$parcel$export(module.exports, "StyleSheet", () => $9d1b48d562a00cda$export$9d753cd7ae895cce);
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $9d1b48d562a00cda$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $9d1b48d562a00cda$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $9d1b48d562a00cda$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($9d1b48d562a00cda$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = $9d1b48d562a00cda$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("bEBdP", function(module, exports) {
$parcel$export(module.exports, "position", () => $87c04da55f9fdf46$export$5880b8b5730aff45);
$parcel$export(module.exports, "node", () => $87c04da55f9fdf46$export$35059013cd4a06db);
$parcel$export(module.exports, "copy", () => $87c04da55f9fdf46$export$784d13d8ee351f07);
$parcel$export(module.exports, "char", () => $87c04da55f9fdf46$export$eba6f6f03b0a92e7);
$parcel$export(module.exports, "prev", () => $87c04da55f9fdf46$export$232faf9add678146);
$parcel$export(module.exports, "next", () => $87c04da55f9fdf46$export$48cfd1e771a65c4f);
$parcel$export(module.exports, "peek", () => $87c04da55f9fdf46$export$4d3fb11e950abb9e);
$parcel$export(module.exports, "caret", () => $87c04da55f9fdf46$export$e88cb2efb12ae807);
$parcel$export(module.exports, "slice", () => $87c04da55f9fdf46$export$58adb3bec8346d0f);
$parcel$export(module.exports, "token", () => $87c04da55f9fdf46$export$9e1725a4cfeada27);
$parcel$export(module.exports, "alloc", () => $87c04da55f9fdf46$export$2de70f21292aac9e);
$parcel$export(module.exports, "dealloc", () => $87c04da55f9fdf46$export$45918ac1574455b1);
$parcel$export(module.exports, "delimit", () => $87c04da55f9fdf46$export$410ac95b9ec204b8);
$parcel$export(module.exports, "tokenize", () => $87c04da55f9fdf46$export$660b2ee2d4fb4eff);
$parcel$export(module.exports, "whitespace", () => $87c04da55f9fdf46$export$7af1228ff777d175);
$parcel$export(module.exports, "identifier", () => $87c04da55f9fdf46$export$c2ab62c7bf24634);
$parcel$export(module.exports, "escaping", () => $87c04da55f9fdf46$export$955ba06d119e085e);
$parcel$export(module.exports, "commenter", () => $87c04da55f9fdf46$export$4254d4e2b3745c4c);

var $3cJUx = parcelRequire("3cJUx");
var $87c04da55f9fdf46$export$53f1d5ea8de3d7c = 1;
var $87c04da55f9fdf46$export$4e0c71f277ca26b3 = 1;
var $87c04da55f9fdf46$export$f24224f1c91d8156 = 0;
var $87c04da55f9fdf46$export$5880b8b5730aff45 = 0;
var $87c04da55f9fdf46$export$c0306caf338ac095 = 0;
var $87c04da55f9fdf46$export$30a86d91af8ff6e6 = '';
function $87c04da55f9fdf46$export$35059013cd4a06db(value, root, parent, type, props, children, length) {
    return {
        value: value,
        root: root,
        parent: parent,
        type: type,
        props: props,
        children: children,
        line: $87c04da55f9fdf46$export$53f1d5ea8de3d7c,
        column: $87c04da55f9fdf46$export$4e0c71f277ca26b3,
        length: length,
        return: ''
    };
}
function $87c04da55f9fdf46$export$784d13d8ee351f07(root, props) {
    return (0, $3cJUx.assign)($87c04da55f9fdf46$export$35059013cd4a06db('', null, null, '', null, null, 0), root, {
        length: -root.length
    }, props);
}
function $87c04da55f9fdf46$export$eba6f6f03b0a92e7() {
    return $87c04da55f9fdf46$export$c0306caf338ac095;
}
function $87c04da55f9fdf46$export$232faf9add678146() {
    $87c04da55f9fdf46$export$c0306caf338ac095 = $87c04da55f9fdf46$export$5880b8b5730aff45 > 0 ? (0, $3cJUx.charat)($87c04da55f9fdf46$export$30a86d91af8ff6e6, --$87c04da55f9fdf46$export$5880b8b5730aff45) : 0;
    if ($87c04da55f9fdf46$export$4e0c71f277ca26b3--, $87c04da55f9fdf46$export$c0306caf338ac095 === 10) $87c04da55f9fdf46$export$4e0c71f277ca26b3 = 1, $87c04da55f9fdf46$export$53f1d5ea8de3d7c--;
    return $87c04da55f9fdf46$export$c0306caf338ac095;
}
function $87c04da55f9fdf46$export$48cfd1e771a65c4f() {
    $87c04da55f9fdf46$export$c0306caf338ac095 = $87c04da55f9fdf46$export$5880b8b5730aff45 < $87c04da55f9fdf46$export$f24224f1c91d8156 ? (0, $3cJUx.charat)($87c04da55f9fdf46$export$30a86d91af8ff6e6, $87c04da55f9fdf46$export$5880b8b5730aff45++) : 0;
    if ($87c04da55f9fdf46$export$4e0c71f277ca26b3++, $87c04da55f9fdf46$export$c0306caf338ac095 === 10) $87c04da55f9fdf46$export$4e0c71f277ca26b3 = 1, $87c04da55f9fdf46$export$53f1d5ea8de3d7c++;
    return $87c04da55f9fdf46$export$c0306caf338ac095;
}
function $87c04da55f9fdf46$export$4d3fb11e950abb9e() {
    return (0, $3cJUx.charat)($87c04da55f9fdf46$export$30a86d91af8ff6e6, $87c04da55f9fdf46$export$5880b8b5730aff45);
}
function $87c04da55f9fdf46$export$e88cb2efb12ae807() {
    return $87c04da55f9fdf46$export$5880b8b5730aff45;
}
function $87c04da55f9fdf46$export$58adb3bec8346d0f(begin, end) {
    return (0, $3cJUx.substr)($87c04da55f9fdf46$export$30a86d91af8ff6e6, begin, end);
}
function $87c04da55f9fdf46$export$9e1725a4cfeada27(type) {
    switch(type){
        // \0 \t \n \r \s whitespace token
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        // ! + , / > @ ~ isolate token
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        // ; { } breakpoint token
        case 59:
        case 123:
        case 125:
            return 4;
        // : accompanied token
        case 58:
            return 3;
        // " ' ( [ opening delimit token
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        // ) ] closing delimit token
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $87c04da55f9fdf46$export$2de70f21292aac9e(value) {
    return $87c04da55f9fdf46$export$53f1d5ea8de3d7c = $87c04da55f9fdf46$export$4e0c71f277ca26b3 = 1, $87c04da55f9fdf46$export$f24224f1c91d8156 = (0, $3cJUx.strlen)($87c04da55f9fdf46$export$30a86d91af8ff6e6 = value), $87c04da55f9fdf46$export$5880b8b5730aff45 = 0, [];
}
function $87c04da55f9fdf46$export$45918ac1574455b1(value) {
    return $87c04da55f9fdf46$export$30a86d91af8ff6e6 = '', value;
}
function $87c04da55f9fdf46$export$410ac95b9ec204b8(type) {
    return (0, $3cJUx.trim)($87c04da55f9fdf46$export$58adb3bec8346d0f($87c04da55f9fdf46$export$5880b8b5730aff45 - 1, $87c04da55f9fdf46$export$c889f2fcc19dbf12(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
}
function $87c04da55f9fdf46$export$660b2ee2d4fb4eff(value) {
    return $87c04da55f9fdf46$export$45918ac1574455b1($87c04da55f9fdf46$export$5f8c09e3ae6f64e1($87c04da55f9fdf46$export$2de70f21292aac9e(value)));
}
function $87c04da55f9fdf46$export$7af1228ff777d175(type) {
    while($87c04da55f9fdf46$export$c0306caf338ac095 = $87c04da55f9fdf46$export$4d3fb11e950abb9e())if ($87c04da55f9fdf46$export$c0306caf338ac095 < 33) $87c04da55f9fdf46$export$48cfd1e771a65c4f();
    else break;
    return $87c04da55f9fdf46$export$9e1725a4cfeada27(type) > 2 || $87c04da55f9fdf46$export$9e1725a4cfeada27($87c04da55f9fdf46$export$c0306caf338ac095) > 3 ? '' : ' ';
}
function $87c04da55f9fdf46$export$5f8c09e3ae6f64e1(children) {
    while($87c04da55f9fdf46$export$48cfd1e771a65c4f())switch($87c04da55f9fdf46$export$9e1725a4cfeada27($87c04da55f9fdf46$export$c0306caf338ac095)){
        case 0:
            (0, $3cJUx.append)($87c04da55f9fdf46$export$c2ab62c7bf24634($87c04da55f9fdf46$export$5880b8b5730aff45 - 1), children);
            break;
        case 2:
            (0, $3cJUx.append)($87c04da55f9fdf46$export$410ac95b9ec204b8($87c04da55f9fdf46$export$c0306caf338ac095), children);
            break;
        default:
            (0, $3cJUx.append)((0, $3cJUx.from)($87c04da55f9fdf46$export$c0306caf338ac095), children);
    }
    return children;
}
function $87c04da55f9fdf46$export$955ba06d119e085e(index, count) {
    while(--count && $87c04da55f9fdf46$export$48cfd1e771a65c4f())// not 0-9 A-F a-f
    if ($87c04da55f9fdf46$export$c0306caf338ac095 < 48 || $87c04da55f9fdf46$export$c0306caf338ac095 > 102 || $87c04da55f9fdf46$export$c0306caf338ac095 > 57 && $87c04da55f9fdf46$export$c0306caf338ac095 < 65 || $87c04da55f9fdf46$export$c0306caf338ac095 > 70 && $87c04da55f9fdf46$export$c0306caf338ac095 < 97) break;
    return $87c04da55f9fdf46$export$58adb3bec8346d0f(index, $87c04da55f9fdf46$export$e88cb2efb12ae807() + (count < 6 && $87c04da55f9fdf46$export$4d3fb11e950abb9e() == 32 && $87c04da55f9fdf46$export$48cfd1e771a65c4f() == 32));
}
function $87c04da55f9fdf46$export$c889f2fcc19dbf12(type) {
    while($87c04da55f9fdf46$export$48cfd1e771a65c4f())switch($87c04da55f9fdf46$export$c0306caf338ac095){
        // ] ) " '
        case type:
            return $87c04da55f9fdf46$export$5880b8b5730aff45;
        // " '
        case 34:
        case 39:
            if (type !== 34 && type !== 39) $87c04da55f9fdf46$export$c889f2fcc19dbf12($87c04da55f9fdf46$export$c0306caf338ac095);
            break;
        // (
        case 40:
            if (type === 41) $87c04da55f9fdf46$export$c889f2fcc19dbf12(type);
            break;
        // \
        case 92:
            $87c04da55f9fdf46$export$48cfd1e771a65c4f();
            break;
    }
    return $87c04da55f9fdf46$export$5880b8b5730aff45;
}
function $87c04da55f9fdf46$export$4254d4e2b3745c4c(type, index) {
    while($87c04da55f9fdf46$export$48cfd1e771a65c4f())// //
    if (type + $87c04da55f9fdf46$export$c0306caf338ac095 === 57) break;
    else if (type + $87c04da55f9fdf46$export$c0306caf338ac095 === 84 && $87c04da55f9fdf46$export$4d3fb11e950abb9e() === 47) break;
    return '/*' + $87c04da55f9fdf46$export$58adb3bec8346d0f(index, $87c04da55f9fdf46$export$5880b8b5730aff45 - 1) + '*' + (0, $3cJUx.from)(type === 47 ? type : $87c04da55f9fdf46$export$48cfd1e771a65c4f());
}
function $87c04da55f9fdf46$export$c2ab62c7bf24634(index) {
    while(!$87c04da55f9fdf46$export$9e1725a4cfeada27($87c04da55f9fdf46$export$4d3fb11e950abb9e()))$87c04da55f9fdf46$export$48cfd1e771a65c4f();
    return $87c04da55f9fdf46$export$58adb3bec8346d0f(index, $87c04da55f9fdf46$export$5880b8b5730aff45);
}

});
parcelRegister("3cJUx", function(module, exports) {
$parcel$export(module.exports, "abs", () => $25561b0312c6290e$export$2335f513bbd82c6d);
$parcel$export(module.exports, "from", () => $25561b0312c6290e$export$6788812c4e6611e6);
$parcel$export(module.exports, "assign", () => $25561b0312c6290e$export$e6e34fd1f2686227);
$parcel$export(module.exports, "hash", () => $25561b0312c6290e$export$d6af199866bfb566);
$parcel$export(module.exports, "charat", () => $25561b0312c6290e$export$a9db5e087081082d);
$parcel$export(module.exports, "trim", () => $25561b0312c6290e$export$87c2784dc9fc4ab);
$parcel$export(module.exports, "match", () => $25561b0312c6290e$export$4659b591c19bdf3d);
$parcel$export(module.exports, "replace", () => $25561b0312c6290e$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "indexof", () => $25561b0312c6290e$export$f8e21b1e77979a08);
$parcel$export(module.exports, "substr", () => $25561b0312c6290e$export$2f35ab04d2335697);
$parcel$export(module.exports, "strlen", () => $25561b0312c6290e$export$36776f635604f274);
$parcel$export(module.exports, "sizeof", () => $25561b0312c6290e$export$f9084667e487ed46);
$parcel$export(module.exports, "append", () => $25561b0312c6290e$export$10d8903dec122b9d);
$parcel$export(module.exports, "combine", () => $25561b0312c6290e$export$1be1fc439b849fdf);
/**
 * @param {number}
 * @return {number}
 */ var $25561b0312c6290e$export$2335f513bbd82c6d = Math.abs;
var $25561b0312c6290e$export$6788812c4e6611e6 = String.fromCharCode;
var $25561b0312c6290e$export$e6e34fd1f2686227 = Object.assign;
function $25561b0312c6290e$export$d6af199866bfb566(value, length) {
    return $25561b0312c6290e$export$a9db5e087081082d(value, 0) ^ 45 ? (((length << 2 ^ $25561b0312c6290e$export$a9db5e087081082d(value, 0)) << 2 ^ $25561b0312c6290e$export$a9db5e087081082d(value, 1)) << 2 ^ $25561b0312c6290e$export$a9db5e087081082d(value, 2)) << 2 ^ $25561b0312c6290e$export$a9db5e087081082d(value, 3) : 0;
}
function $25561b0312c6290e$export$87c2784dc9fc4ab(value) {
    return value.trim();
}
function $25561b0312c6290e$export$4659b591c19bdf3d(value, pattern) {
    return (value = pattern.exec(value)) ? value[0] : value;
}
function $25561b0312c6290e$export$77ad94ebf1c2b9ed(value, pattern, replacement) {
    return value.replace(pattern, replacement);
}
function $25561b0312c6290e$export$f8e21b1e77979a08(value, search) {
    return value.indexOf(search);
}
function $25561b0312c6290e$export$a9db5e087081082d(value, index) {
    return value.charCodeAt(index) | 0;
}
function $25561b0312c6290e$export$2f35ab04d2335697(value, begin, end) {
    return value.slice(begin, end);
}
function $25561b0312c6290e$export$36776f635604f274(value) {
    return value.length;
}
function $25561b0312c6290e$export$f9084667e487ed46(value) {
    return value.length;
}
function $25561b0312c6290e$export$10d8903dec122b9d(value, array) {
    return array.push(value), value;
}
function $25561b0312c6290e$export$1be1fc439b849fdf(array, callback) {
    return array.map(callback).join('');
}

});


parcelRegister("bHsV8", function(module, exports) {
$parcel$export(module.exports, "compile", () => $884a24dd434281dd$export$ef7acd7185315e22);

var $7OJ6h = parcelRequire("7OJ6h");

var $3cJUx = parcelRequire("3cJUx");

var $bEBdP = parcelRequire("bEBdP");
function $884a24dd434281dd$export$ef7acd7185315e22(value) {
    return (0, $bEBdP.dealloc)($884a24dd434281dd$export$98e6a39c04603d36('', null, null, null, [
        ''
    ], value = (0, $bEBdP.alloc)(value), 0, [
        0
    ], value));
}
function $884a24dd434281dd$export$98e6a39c04603d36(value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
    var index = 0;
    var offset = 0;
    var length = pseudo;
    var atrule = 0;
    var property = 0;
    var previous = 0;
    var variable = 1;
    var scanning = 1;
    var ampersand = 1;
    var character = 0;
    var type = '';
    var props = rules;
    var children = rulesets;
    var reference = rule;
    var characters = type;
    while(scanning)switch(previous = character, character = (0, $bEBdP.next)()){
        // (
        case 40:
            if (previous != 108 && (0, $3cJUx.charat)(characters, length - 1) == 58) {
                if ((0, $3cJUx.indexof)(characters += (0, $3cJUx.replace)((0, $bEBdP.delimit)(character), '&', '&\f'), '&\f') != -1) ampersand = -1;
                break;
            }
        // " ' [
        case 34:
        case 39:
        case 91:
            characters += (0, $bEBdP.delimit)(character);
            break;
        // \t \n \r \s
        case 9:
        case 10:
        case 13:
        case 32:
            characters += (0, $bEBdP.whitespace)(previous);
            break;
        // \
        case 92:
            characters += (0, $bEBdP.escaping)((0, $bEBdP.caret)() - 1, 7);
            continue;
        // /
        case 47:
            switch((0, $bEBdP.peek)()){
                case 42:
                case 47:
                    (0, $3cJUx.append)($884a24dd434281dd$export$4a34f930e789283c((0, $bEBdP.commenter)((0, $bEBdP.next)(), (0, $bEBdP.caret)()), root, parent), declarations);
                    break;
                default:
                    characters += '/';
            }
            break;
        // {
        case 123 * variable:
            points[index++] = (0, $3cJUx.strlen)(characters) * ampersand;
        // } ; \0
        case 125 * variable:
        case 59:
        case 0:
            switch(character){
                // \0 }
                case 0:
                case 125:
                    scanning = 0;
                // ;
                case 59 + offset:
                    if (ampersand == -1) characters = (0, $3cJUx.replace)(characters, /\f/g, '');
                    if (property > 0 && (0, $3cJUx.strlen)(characters) - length) (0, $3cJUx.append)(property > 32 ? $884a24dd434281dd$export$f8483753829ec8f3(characters + ';', rule, parent, length - 1) : $884a24dd434281dd$export$f8483753829ec8f3((0, $3cJUx.replace)(characters, ' ', '') + ';', rule, parent, length - 2), declarations);
                    break;
                // @ ;
                case 59:
                    characters += ';';
                // { rule/at-rule
                default:
                    (0, $3cJUx.append)(reference = $884a24dd434281dd$export$3307ffa7023ede1e(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets);
                    if (character === 123) {
                        if (offset === 0) $884a24dd434281dd$export$98e6a39c04603d36(characters, root, reference, reference, props, rulesets, length, points, children);
                        else switch(atrule === 99 && (0, $3cJUx.charat)(characters, 3) === 110 ? 100 : atrule){
                            // d l m s
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $884a24dd434281dd$export$98e6a39c04603d36(value, reference, reference, rule && (0, $3cJUx.append)($884a24dd434281dd$export$3307ffa7023ede1e(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children);
                                break;
                            default:
                                $884a24dd434281dd$export$98e6a39c04603d36(characters, reference, reference, reference, [
                                    ''
                                ], children, 0, points, children);
                        }
                    }
            }
            index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
            break;
        // :
        case 58:
            length = 1 + (0, $3cJUx.strlen)(characters), property = previous;
        default:
            if (variable < 1) {
                if (character == 123) --variable;
                else if (character == 125 && variable++ == 0 && (0, $bEBdP.prev)() == 125) continue;
            }
            switch(characters += (0, $3cJUx.from)(character), character * variable){
                // &
                case 38:
                    ampersand = offset > 0 ? 1 : (characters += '\f', -1);
                    break;
                // ,
                case 44:
                    points[index++] = ((0, $3cJUx.strlen)(characters) - 1) * ampersand, ampersand = 1;
                    break;
                // @
                case 64:
                    // -
                    if ((0, $bEBdP.peek)() === 45) characters += (0, $bEBdP.delimit)((0, $bEBdP.next)());
                    atrule = (0, $bEBdP.peek)(), offset = length = (0, $3cJUx.strlen)(type = characters += (0, $bEBdP.identifier)((0, $bEBdP.caret)())), character++;
                    break;
                // -
                case 45:
                    if (previous === 45 && (0, $3cJUx.strlen)(characters) == 2) variable = 0;
            }
    }
    return rulesets;
}
function $884a24dd434281dd$export$3307ffa7023ede1e(value, root, parent, index, offset, rules, points, type, props, children, length) {
    var post = offset - 1;
    var rule = offset === 0 ? rules : [
        ''
    ];
    var size = (0, $3cJUx.sizeof)(rule);
    for(var i = 0, j = 0, k = 0; i < index; ++i)for(var x = 0, y = (0, $3cJUx.substr)(value, post + 1, post = (0, $3cJUx.abs)(j = points[i])), z = value; x < size; ++x)if (z = (0, $3cJUx.trim)(j > 0 ? rule[x] + ' ' + y : (0, $3cJUx.replace)(y, /&\f/g, rule[x]))) props[k++] = z;
    return (0, $bEBdP.node)(value, root, parent, offset === 0 ? (0, $7OJ6h.RULESET) : type, props, children, length);
}
function $884a24dd434281dd$export$4a34f930e789283c(value, root, parent) {
    return (0, $bEBdP.node)(value, root, parent, (0, $7OJ6h.COMMENT), (0, $3cJUx.from)((0, $bEBdP.char)()), (0, $3cJUx.substr)(value, 2, -2), 0);
}
function $884a24dd434281dd$export$f8483753829ec8f3(value, root, parent, length) {
    return (0, $bEBdP.node)(value, root, parent, (0, $7OJ6h.DECLARATION), (0, $3cJUx.substr)(value, 0, length), (0, $3cJUx.substr)(value, length + 1, -1), length);
}

});
parcelRegister("7OJ6h", function(module, exports) {
$parcel$export(module.exports, "MS", () => $5b102fde52a70f8b$export$71ad59f2e432cfe8);
$parcel$export(module.exports, "MOZ", () => $5b102fde52a70f8b$export$2c0f367103c8d01c);
$parcel$export(module.exports, "WEBKIT", () => $5b102fde52a70f8b$export$39dfd62a25e0fe93);
$parcel$export(module.exports, "COMMENT", () => $5b102fde52a70f8b$export$a29989082612d0d9);
$parcel$export(module.exports, "RULESET", () => $5b102fde52a70f8b$export$aa3a2e812ca8570d);
$parcel$export(module.exports, "DECLARATION", () => $5b102fde52a70f8b$export$527d108ccf083c2b);
$parcel$export(module.exports, "IMPORT", () => $5b102fde52a70f8b$export$a763edbf796b780a);
$parcel$export(module.exports, "KEYFRAMES", () => $5b102fde52a70f8b$export$b44a8529a35fcb60);
$parcel$export(module.exports, "LAYER", () => $5b102fde52a70f8b$export$d773506282b3cfe6);
var $5b102fde52a70f8b$export$71ad59f2e432cfe8 = '-ms-';
var $5b102fde52a70f8b$export$2c0f367103c8d01c = '-moz-';
var $5b102fde52a70f8b$export$39dfd62a25e0fe93 = '-webkit-';
var $5b102fde52a70f8b$export$a29989082612d0d9 = 'comm';
var $5b102fde52a70f8b$export$aa3a2e812ca8570d = 'rule';
var $5b102fde52a70f8b$export$527d108ccf083c2b = 'decl';
var $5b102fde52a70f8b$export$d3d35020fa5b54f0 = '@page';
var $5b102fde52a70f8b$export$500415a86c544f73 = '@media';
var $5b102fde52a70f8b$export$a763edbf796b780a = '@import';
var $5b102fde52a70f8b$export$2790aeb8b4e5c826 = '@charset';
var $5b102fde52a70f8b$export$1cc683e23b84b133 = '@viewport';
var $5b102fde52a70f8b$export$9447a5efea57e862 = '@supports';
var $5b102fde52a70f8b$export$ef011b4e114b1fba = '@document';
var $5b102fde52a70f8b$export$6aad947bda0f3f46 = '@namespace';
var $5b102fde52a70f8b$export$b44a8529a35fcb60 = '@keyframes';
var $5b102fde52a70f8b$export$2c16de31893252e6 = '@font-face';
var $5b102fde52a70f8b$export$3d846dd52e150c6f = '@counter-style';
var $5b102fde52a70f8b$export$22314bfbb57653fe = '@font-feature-values';
var $5b102fde52a70f8b$export$d773506282b3cfe6 = '@layer';

});


parcelRegister("fpv30", function(module, exports) {
$parcel$export(module.exports, "middleware", () => $b381462f5e954778$export$5a7767152ae0305f);
$parcel$export(module.exports, "rulesheet", () => $b381462f5e954778$export$38bcb760f1d4871c);

var $7OJ6h = parcelRequire("7OJ6h");

var $3cJUx = parcelRequire("3cJUx");

var $bEBdP = parcelRequire("bEBdP");

var $jKOmY = parcelRequire("jKOmY");

var $4YzK3 = parcelRequire("4YzK3");
function $b381462f5e954778$export$5a7767152ae0305f(collection) {
    var length = (0, $3cJUx.sizeof)(collection);
    return function(element, index, children, callback) {
        var output = '';
        for(var i = 0; i < length; i++)output += collection[i](element, index, children, callback) || '';
        return output;
    };
}
function $b381462f5e954778$export$38bcb760f1d4871c(callback) {
    return function(element) {
        if (!element.root) {
            if (element = element.return) callback(element);
        }
    };
}
function $b381462f5e954778$export$e08c7d021b829b7a(element, index, children, callback) {
    if (element.length > -1) {
        if (!element.return) switch(element.type){
            case 0, $7OJ6h.DECLARATION:
                element.return = (0, $4YzK3.prefix)(element.value, element.length, children);
                return;
            case 0, $7OJ6h.KEYFRAMES:
                return (0, $jKOmY.serialize)([
                    (0, $bEBdP.copy)(element, {
                        value: (0, $3cJUx.replace)(element.value, '@', '@' + (0, $7OJ6h.WEBKIT))
                    })
                ], callback);
            case 0, $7OJ6h.RULESET:
                if (element.length) return (0, $3cJUx.combine)(element.props, function(value) {
                    switch((0, $3cJUx.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $jKOmY.serialize)([
                                (0, $bEBdP.copy)(element, {
                                    props: [
                                        (0, $3cJUx.replace)(value, /:(read-\w+)/, ':' + (0, $7OJ6h.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $jKOmY.serialize)([
                                (0, $bEBdP.copy)(element, {
                                    props: [
                                        (0, $3cJUx.replace)(value, /:(plac\w+)/, ':' + (0, $7OJ6h.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $bEBdP.copy)(element, {
                                    props: [
                                        (0, $3cJUx.replace)(value, /:(plac\w+)/, ':' + (0, $7OJ6h.MOZ) + '$1')
                                    ]
                                }),
                                (0, $bEBdP.copy)(element, {
                                    props: [
                                        (0, $3cJUx.replace)(value, /:(plac\w+)/, (0, $7OJ6h.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
}
function $b381462f5e954778$export$76a88f7de6507443(element) {
    switch(element.type){
        case 0, $7OJ6h.RULESET:
            element.props = element.props.map(function(value) {
                return (0, $3cJUx.combine)((0, $bEBdP.tokenize)(value), function(value, index, children) {
                    switch((0, $3cJUx.charat)(value, 0)){
                        // \f
                        case 12:
                            return (0, $3cJUx.substr)(value, 1, (0, $3cJUx.strlen)(value));
                        // \0 ( + > ~
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return value;
                        // :
                        case 58:
                            if (children[++index] === 'global') children[index] = '', children[++index] = '\f' + (0, $3cJUx.substr)(children[index], index = 1, -1);
                        // \s
                        case 32:
                            return index === 1 ? '' : value;
                        default:
                            switch(index){
                                case 0:
                                    element = value;
                                    return (0, $3cJUx.sizeof)(children) > 1 ? '' : value;
                                case index = (0, $3cJUx.sizeof)(children) - 1:
                                case 2:
                                    return index === 2 ? value + element + element : value + element;
                                default:
                                    return value;
                            }
                    }
                });
            });
    }
}

});
parcelRegister("jKOmY", function(module, exports) {
$parcel$export(module.exports, "serialize", () => $e6196287fb32af0c$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "stringify", () => $e6196287fb32af0c$export$fac44ee5b035f737);

var $7OJ6h = parcelRequire("7OJ6h");

var $3cJUx = parcelRequire("3cJUx");
function $e6196287fb32af0c$export$dfdc1655ccc5b9cb(children, callback) {
    var output = '';
    var length = (0, $3cJUx.sizeof)(children);
    for(var i = 0; i < length; i++)output += callback(children[i], i, children, callback) || '';
    return output;
}
function $e6196287fb32af0c$export$fac44ee5b035f737(element, index, children, callback) {
    switch(element.type){
        case 0, $7OJ6h.LAYER:
            if (element.children.length) break;
        case 0, $7OJ6h.IMPORT:
        case 0, $7OJ6h.DECLARATION:
            return element.return = element.return || element.value;
        case 0, $7OJ6h.COMMENT:
            return '';
        case 0, $7OJ6h.KEYFRAMES:
            return element.return = element.value + '{' + $e6196287fb32af0c$export$dfdc1655ccc5b9cb(element.children, callback) + '}';
        case 0, $7OJ6h.RULESET:
            element.value = element.props.join(',');
    }
    return (0, $3cJUx.strlen)(children = $e6196287fb32af0c$export$dfdc1655ccc5b9cb(element.children, callback)) ? element.return = element.value + '{' + children + '}' : '';
}

});

parcelRegister("4YzK3", function(module, exports) {
$parcel$export(module.exports, "prefix", () => $39f87d9b9c6c92f8$export$82e9f45cca5ba907);

var $7OJ6h = parcelRequire("7OJ6h");

var $3cJUx = parcelRequire("3cJUx");
function $39f87d9b9c6c92f8$export$82e9f45cca5ba907(value, length, children) {
    switch((0, $3cJUx.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $7OJ6h.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $7OJ6h.WEBKIT) + value + value;
        // tab-size
        case 4789:
            return (0, $7OJ6h.MOZ) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $7OJ6h.WEBKIT) + value + (0, $7OJ6h.MOZ) + value + (0, $7OJ6h.MS) + value + value;
        // writing-mode
        case 5936:
            switch((0, $3cJUx.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $7OJ6h.WEBKIT) + value + (0, $7OJ6h.MS) + (0, $3cJUx.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $7OJ6h.WEBKIT) + value + (0, $7OJ6h.MS) + (0, $3cJUx.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $7OJ6h.WEBKIT) + value + (0, $7OJ6h.MS) + (0, $3cJUx.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
        // flex, flex-direction, scroll-snap-type, writing-mode
        case 6828:
        case 4268:
        case 2903:
            return (0, $7OJ6h.WEBKIT) + value + (0, $7OJ6h.MS) + value + value;
        // order
        case 6165:
            return (0, $7OJ6h.WEBKIT) + value + (0, $7OJ6h.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $7OJ6h.WEBKIT) + value + (0, $3cJUx.replace)(value, /(\w+).+(:[^]+)/, (0, $7OJ6h.WEBKIT) + 'box-$1$2' + (0, $7OJ6h.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $7OJ6h.WEBKIT) + value + (0, $7OJ6h.MS) + 'flex-item-' + (0, $3cJUx.replace)(value, /flex-|-self/g, '') + (!(0, $3cJUx.match)(value, /flex-|baseline/) ? (0, $7OJ6h.MS) + 'grid-row-' + (0, $3cJUx.replace)(value, /flex-|-self/g, '') : '') + value;
        // align-content
        case 4675:
            return (0, $7OJ6h.WEBKIT) + value + (0, $7OJ6h.MS) + 'flex-line-pack' + (0, $3cJUx.replace)(value, /align-content|flex-|-self/g, '') + value;
        // flex-shrink
        case 5548:
            return (0, $7OJ6h.WEBKIT) + value + (0, $7OJ6h.MS) + (0, $3cJUx.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $7OJ6h.WEBKIT) + value + (0, $7OJ6h.MS) + (0, $3cJUx.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $7OJ6h.WEBKIT) + 'box-' + (0, $3cJUx.replace)(value, '-grow', '') + (0, $7OJ6h.WEBKIT) + value + (0, $7OJ6h.MS) + (0, $3cJUx.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $7OJ6h.WEBKIT) + (0, $3cJUx.replace)(value, /([^-])(transform)/g, '$1' + (0, $7OJ6h.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $3cJUx.replace)((0, $3cJUx.replace)((0, $3cJUx.replace)(value, /(zoom-|grab)/, (0, $7OJ6h.WEBKIT) + '$1'), /(image-set)/, (0, $7OJ6h.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $3cJUx.replace)(value, /(image-set\([^]*)/, (0, $7OJ6h.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $3cJUx.replace)((0, $3cJUx.replace)(value, /(.+:)(flex-)?(.*)/, (0, $7OJ6h.WEBKIT) + 'box-pack:$3' + (0, $7OJ6h.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $7OJ6h.WEBKIT) + value + value;
        // justify-self
        case 4200:
            if (!(0, $3cJUx.match)(value, /flex-|baseline/)) return (0, $7OJ6h.MS) + 'grid-column-align' + (0, $3cJUx.substr)(value, length) + value;
            break;
        // grid-template-(columns|rows)
        case 2592:
        case 3360:
            return (0, $7OJ6h.MS) + (0, $3cJUx.replace)(value, 'template-', '') + value;
        // grid-(row|column)-start
        case 4384:
        case 3616:
            if (children && children.some(function(element, index) {
                return length = index, (0, $3cJUx.match)(element.props, /grid-\w+-end/);
            })) return ~(0, $3cJUx.indexof)(value + (children = children[length].value), 'span') ? value : (0, $7OJ6h.MS) + (0, $3cJUx.replace)(value, '-start', '') + value + (0, $7OJ6h.MS) + 'grid-row-span:' + (~(0, $3cJUx.indexof)(children, 'span') ? (0, $3cJUx.match)(children, /\d+/) : +(0, $3cJUx.match)(children, /\d+/) - +(0, $3cJUx.match)(value, /\d+/)) + ';';
            return (0, $7OJ6h.MS) + (0, $3cJUx.replace)(value, '-start', '') + value;
        // grid-(row|column)-end
        case 4896:
        case 4128:
            return children && children.some(function(element) {
                return (0, $3cJUx.match)(element.props, /grid-\w+-start/);
            }) ? value : (0, $7OJ6h.MS) + (0, $3cJUx.replace)((0, $3cJUx.replace)(value, '-end', '-span'), 'span ', '') + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $3cJUx.replace)(value, /(.+)-inline(.+)/, (0, $7OJ6h.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $3cJUx.strlen)(value) - 1 - length > 6) switch((0, $3cJUx.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $3cJUx.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $3cJUx.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $7OJ6h.WEBKIT) + '$2-$3' + '$1' + (0, $7OJ6h.MOZ) + ((0, $3cJUx.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $3cJUx.indexof)(value, 'stretch') ? $39f87d9b9c6c92f8$export$82e9f45cca5ba907((0, $3cJUx.replace)(value, 'stretch', 'fill-available'), length, children) + value : value;
            }
            break;
        // grid-(column|row)
        case 5152:
        case 5920:
            return (0, $3cJUx.replace)(value, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(_, a, b, c, d, e, f) {
                return (0, $7OJ6h.MS) + a + ':' + b + f + (c ? (0, $7OJ6h.MS) + a + '-span:' + (d ? e : +e - +b) + f : '') + value;
            });
        // position: sticky
        case 4949:
            // stick(y)?
            if ((0, $3cJUx.charat)(value, length + 6) === 121) return (0, $3cJUx.replace)(value, ':', ':' + (0, $7OJ6h.WEBKIT)) + value;
            break;
        // display: (flex|inline-flex|grid|inline-grid)
        case 6444:
            switch((0, $3cJUx.charat)(value, (0, $3cJUx.charat)(value, 14) === 45 ? 18 : 11)){
                // (inline-)?fle(x)
                case 120:
                    return (0, $3cJUx.replace)(value, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, '$1' + (0, $7OJ6h.WEBKIT) + ((0, $3cJUx.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $7OJ6h.WEBKIT) + '$2$3' + '$1' + (0, $7OJ6h.MS) + '$2box$3') + value;
                // (inline-)?gri(d)
                case 100:
                    return (0, $3cJUx.replace)(value, ':', ':' + (0, $7OJ6h.MS)) + value;
            }
            break;
        // scroll-margin, scroll-margin-(top|right|bottom|left)
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return (0, $3cJUx.replace)(value, 'scroll-', 'scroll-snap-') + value;
    }
    return value;
}

});


parcelRegister("bCXZb", function(module, exports) {
$parcel$export(module.exports, "default", () => $8771c63f34da586f$export$2e2bcd8739ae039);
var $8771c63f34da586f$export$2e2bcd8739ae039 = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("infHZ", function(module, exports) {
function $d6068f5dcdcdb337$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("iXMid", function(module, exports) {
$parcel$export(module.exports, "default", () => $03900d341e633ef8$export$2e2bcd8739ae039);
function $03900d341e633ef8$export$2e2bcd8739ae039() {
    return $03900d341e633ef8$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $03900d341e633ef8$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("3gAf0", function(module, exports) {
$parcel$export(module.exports, "default", () => $260efa6d8c598eb5$export$2e2bcd8739ae039);

var $523n4 = parcelRequire("523n4");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $260efa6d8c598eb5$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($523n4)))(targetComponent, sourceComponent);
};

});

parcelRegister("g4E5y", function(module, exports) {
$parcel$export(module.exports, "getRegisteredStyles", () => $bb3c1dd2ea6f11e2$export$95d99596f328fd52);
$parcel$export(module.exports, "registerStyles", () => $bb3c1dd2ea6f11e2$export$580009a5da2a8b4b);
$parcel$export(module.exports, "insertStyles", () => $bb3c1dd2ea6f11e2$export$6f077d94b33a01aa);
var $bb3c1dd2ea6f11e2$var$isBrowser = true;
function $bb3c1dd2ea6f11e2$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $bb3c1dd2ea6f11e2$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $bb3c1dd2ea6f11e2$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $bb3c1dd2ea6f11e2$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $bb3c1dd2ea6f11e2$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});

parcelRegister("gS9xC", function(module, exports) {
$parcel$export(module.exports, "serializeStyles", () => $c489172fa91b776a$export$6321afa313b251b5);

var $lVwbS = parcelRequire("lVwbS");

var $hqNUk = parcelRequire("hqNUk");

var $hyTA0 = parcelRequire("hyTA0");
var $c489172fa91b776a$var$isDevelopment = false;
var $c489172fa91b776a$var$hyphenateRegex = /[A-Z]|^ms/g;
var $c489172fa91b776a$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $c489172fa91b776a$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $c489172fa91b776a$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $c489172fa91b776a$var$processStyleName = /* #__PURE__ */ (0, $hyTA0.default)(function(styleName) {
    return $c489172fa91b776a$var$isCustomProperty(styleName) ? styleName : styleName.replace($c489172fa91b776a$var$hyphenateRegex, '-$&').toLowerCase();
});
var $c489172fa91b776a$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($c489172fa91b776a$var$animationRegex, function(match, p1, p2) {
                $c489172fa91b776a$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $c489172fa91b776a$var$cursor
                };
                return p1;
            });
    }
    if ((0, $hqNUk.default)[key] !== 1 && !$c489172fa91b776a$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $c489172fa91b776a$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $c489172fa91b776a$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $c489172fa91b776a$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $c489172fa91b776a$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $c489172fa91b776a$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $c489172fa91b776a$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $c489172fa91b776a$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $c489172fa91b776a$var$cursor;
                var result = interpolation(mergedProps);
                $c489172fa91b776a$var$cursor = previousCursor;
                return $c489172fa91b776a$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $c489172fa91b776a$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $c489172fa91b776a$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($c489172fa91b776a$var$isProcessableValue(asString)) string += $c489172fa91b776a$var$processStyleName(key) + ":" + $c489172fa91b776a$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $c489172fa91b776a$var$isDevelopment) throw new Error($c489172fa91b776a$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($c489172fa91b776a$var$isProcessableValue(value[_i])) string += $c489172fa91b776a$var$processStyleName(key) + ":" + $c489172fa91b776a$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $c489172fa91b776a$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $c489172fa91b776a$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $c489172fa91b776a$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $c489172fa91b776a$var$cursor;
function $c489172fa91b776a$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $c489172fa91b776a$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $c489172fa91b776a$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $c489172fa91b776a$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $c489172fa91b776a$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $c489172fa91b776a$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $lVwbS.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $c489172fa91b776a$var$cursor
    };
}

});
parcelRegister("lVwbS", function(module, exports) {
$parcel$export(module.exports, "default", () => $ff67e436f034bdb3$export$2e2bcd8739ae039);
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $ff67e436f034bdb3$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("hqNUk", function(module, exports) {
$parcel$export(module.exports, "default", () => $cb0b93f9eb8091ef$export$2e2bcd8739ae039);
var $cb0b93f9eb8091ef$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});

parcelRegister("hyTA0", function(module, exports) {
$parcel$export(module.exports, "default", () => $cc90b99af7d6e964$export$2e2bcd8739ae039);
function $cc90b99af7d6e964$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("jbcP2", function(module, exports) {
$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", () => $df68fd99ded2c938$export$db21c7ffa21794e7);
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", () => $df68fd99ded2c938$export$811a713a7276cb9d);

var $4tluv = parcelRequire("4tluv");
var $df68fd99ded2c938$var$syncFallback = function syncFallback(create) {
    return create();
};
var $df68fd99ded2c938$var$useInsertionEffect = false;
var $df68fd99ded2c938$export$db21c7ffa21794e7 = $df68fd99ded2c938$var$useInsertionEffect || $df68fd99ded2c938$var$syncFallback;
var $df68fd99ded2c938$export$811a713a7276cb9d = $df68fd99ded2c938$var$useInsertionEffect || $4tluv.useLayoutEffect;

});



parcelRegister("wYkfM", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafEventHandler", () => $afe4e59ecbb39b93$export$a4687b0234b40e28);

var $4tluv = parcelRequire("4tluv");

var $8ik9q = parcelRequire("8ik9q");

var $8lhHD = parcelRequire("8lhHD");
function $afe4e59ecbb39b93$export$a4687b0234b40e28({ fn: fn, action: action, componentName: componentName, actionSubject: actionSubject, packageName: packageName, packageVersion: packageVersion, analyticsData: analyticsData }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $8ik9q.useAnalyticsEvents)();
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    const dataRef = (0, $8lhHD.useTrackedRef)(analyticsData);
    const fnRef = (0, $8lhHD.useTrackedRef)(fn);
    const handler = (0, $4tluv.useCallback)((value)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        const context = {
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion,
            ...dataRef.current
        };
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        const clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});

parcelRegister("5xZ7U", function(module, exports) {
$parcel$export(module.exports, "default", () => $2f1d9a7b6fbb3d3d$export$2e2bcd8739ae039);
function $2f1d9a7b6fbb3d3d$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
const $2f1d9a7b6fbb3d3d$var$tabKeyCode = 9;
function $2f1d9a7b6fbb3d3d$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $2f1d9a7b6fbb3d3d$var$tabKeyCode) return;
    $2f1d9a7b6fbb3d3d$var$abort(event);
}
const $2f1d9a7b6fbb3d3d$var$block = {
    onMouseDownCapture: $2f1d9a7b6fbb3d3d$var$abort,
    onMouseUpCapture: $2f1d9a7b6fbb3d3d$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $2f1d9a7b6fbb3d3d$var$onKey,
    onKeyUpCapture: $2f1d9a7b6fbb3d3d$var$onKey,
    onTouchStartCapture: $2f1d9a7b6fbb3d3d$var$abort,
    onTouchEndCapture: $2f1d9a7b6fbb3d3d$var$abort,
    onPointerDownCapture: $2f1d9a7b6fbb3d3d$var$abort,
    onPointerUpCapture: $2f1d9a7b6fbb3d3d$var$abort,
    onClickCapture: $2f1d9a7b6fbb3d3d$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $2f1d9a7b6fbb3d3d$var$abort
};
const $2f1d9a7b6fbb3d3d$var$doNotBlock = {};
function $2f1d9a7b6fbb3d3d$export$2e2bcd8739ae039({ isInteractive: isInteractive }) {
    return isInteractive ? $2f1d9a7b6fbb3d3d$var$doNotBlock : $2f1d9a7b6fbb3d3d$var$block;
}

});

parcelRegister("ioYTM", function(module, exports) {
$parcel$export(module.exports, "getContentStyle", () => $d39239a6c71d5281$export$7ad0316cc0dd65a);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $ft5N0 = parcelRequire("ft5N0");
function $d39239a6c71d5281$export$7ad0316cc0dd65a({ spacing: spacing }) {
    return (0, $ft5N0.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : '0 2px',
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    });
}

});

parcelRegister("3KjCU", function(module, exports) {
$parcel$export(module.exports, "getFadingCss", () => $f0a60a704616a51a$export$1b5827d324e945b1);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $ft5N0 = parcelRequire("ft5N0");
function $f0a60a704616a51a$export$1b5827d324e945b1({ hasOverlay: hasOverlay }) {
    return (0, $ft5N0.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: hasOverlay ? 0 : 1,
        transition: 'opacity 0.3s'
    });
}

});

parcelRegister("bxrm7", function(module, exports) {
$parcel$export(module.exports, "getIconStyle", () => $0d1d1920c137bbba$export$864eea3f4ec3368f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $ft5N0 = parcelRequire("ft5N0");
function $0d1d1920c137bbba$export$864eea3f4ec3368f({ spacing: spacing }) {
    return (0, $ft5N0.css)({
        display: 'flex',
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : `0 2px`,
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: 'center',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 0,
        userSelect: 'none'
    });
}

});

parcelRegister("h8v80", function(module, exports) {
$parcel$export(module.exports, "getIfVisuallyHiddenChildren", () => $d00440afcf3712b1$export$20bbd2efb0d734c4);

var $4tluv = parcelRequire("4tluv");

var $k7gbB = parcelRequire("k7gbB");
const $d00440afcf3712b1$export$20bbd2efb0d734c4 = (children)=>{
    return children && /*#__PURE__*/ (0, $4tluv.isValidElement)(children) && children.type === (0, $k7gbB.default);
};

});

parcelRegister("4sg7i", function(module, exports) {
$parcel$export(module.exports, "overlayCss", () => $da5b4140d649ecac$export$1a9fe1b84c876bb5);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
const $da5b4140d649ecac$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
};

});


parcelRegister("h47Ub", function(module, exports) {
$parcel$export(module.exports, "getCss", () => $fe0a09e88b545be3$export$955358618f994a11);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3X3Vo = parcelRequire("3X3Vo");
const $fe0a09e88b545be3$var$gridSize = 8;
const $fe0a09e88b545be3$var$HAS_DISABLED_BACKGROUND = [
    'default',
    'primary',
    'danger',
    'warning'
];
const $fe0a09e88b545be3$var$heights = {
    default: `${32 / 14}em`,
    // 32px
    compact: `${24 / 14}em`,
    none: 'auto'
};
const $fe0a09e88b545be3$var$lineHeights = {
    default: $fe0a09e88b545be3$var$heights.default,
    compact: $fe0a09e88b545be3$var$heights.compact,
    none: 'inherit'
};
const $fe0a09e88b545be3$var$padding = {
    // 10px gutter
    default: `0 ${$fe0a09e88b545be3$var$gridSize + $fe0a09e88b545be3$var$gridSize / 4}px`,
    compact: `0 ${$fe0a09e88b545be3$var$gridSize + $fe0a09e88b545be3$var$gridSize / 4}px`,
    none: '0'
};
const $fe0a09e88b545be3$var$singleIconPadding = {
    // 2px gutter
    compact: `0 ${$fe0a09e88b545be3$var$gridSize / 4}px`,
    default: `0 ${$fe0a09e88b545be3$var$gridSize / 4}px`,
    none: '0'
};
const $fe0a09e88b545be3$var$verticalAlign = {
    default: 'middle',
    compact: 'middle',
    none: 'baseline'
};
const $fe0a09e88b545be3$var$defaultAfterStyles = {
    borderRadius: 'inherit',
    inset: "var(--ds-space-0, 0px)",
    borderStyle: 'solid',
    borderWidth: "var(--ds-border-width, 1px)",
    pointerEvents: 'none',
    position: 'absolute'
};
const $fe0a09e88b545be3$var$defaultStyles = {
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: "var(--ds-text, #292A2E)",
    '&::after': {
        ...$fe0a09e88b545be3$var$defaultAfterStyles,
        content: '""',
        borderColor: "var(--ds-border, #0B120E24)"
    },
    '&:hover': {
        background: "var(--ds-background-neutral-hovered, #0B120E24)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-pressed, #080F214A)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:active': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    }
};
const $fe0a09e88b545be3$var$primaryStyles = {
    background: "var(--ds-background-brand-bold, #1868DB)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-brand-bold-hovered, #1558BC)"
    },
    '&:active': {
        background: "var(--ds-background-brand-bold-pressed, #144794)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-brand-bold, #1868DB)"
    }
};
const $fe0a09e88b545be3$var$linkStyles = {
    background: 'transparent',
    color: "var(--ds-link, #1868DB)",
    '&:hover': {
        color: "var(--ds-link, #1868DB)",
        textDecoration: 'underline'
    },
    '&:active': {
        color: "var(--ds-link-pressed, #1558BC)",
        textDecoration: 'underline'
    }
};
const $fe0a09e88b545be3$var$subtleStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #505258)",
    '&:hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #0515240F)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-subtle-pressed, #0B120E24)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: 'transparent'
    }
};
const $fe0a09e88b545be3$var$subtleLinkStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #505258)",
    '&:hover': {
        background: 'transparent',
        color: "var(--ds-text-subtle, #505258)",
        textDecoration: 'underline'
    },
    '&:active': {
        background: 'transparent',
        color: "var(--ds-text, #292A2E)",
        textDecoration: 'underline'
    }
};
const $fe0a09e88b545be3$var$warningStyles = {
    background: "var(--ds-background-warning-bold, #FBC828)",
    color: "var(--ds-text-warning-inverse, #292A2E)",
    '&:hover': {
        background: "var(--ds-background-warning-bold-hovered, #FCA700)"
    },
    '&:active': {
        background: "var(--ds-background-warning-bold-pressed, #F68909)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-warning-bold, #FBC828)"
    }
};
const $fe0a09e88b545be3$var$dangerStyles = {
    background: "var(--ds-background-danger-bold, #C9372C)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-danger-bold-hovered, #AE2E24)"
    },
    '&:active': {
        background: "var(--ds-background-danger-bold-pressed, #872821)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-danger-bold, #C9372C)"
    }
};
const $fe0a09e88b545be3$var$selectedStyles = {
    background: "var(--ds-background-selected, #E9F2FE)",
    color: "var(--ds-text-selected, #1868DB)",
    '&:not([disabled])::after': {
        ...$fe0a09e88b545be3$var$defaultAfterStyles,
        content: '""',
        borderColor: "var(--ds-border-selected, #1868DB)"
    }
};
const $fe0a09e88b545be3$var$hasOverlayStyles = {
    '&[data-has-overlay="true"]': {
        cursor: 'default',
        textDecoration: 'none'
    }
};
function $fe0a09e88b545be3$export$955358618f994a11({ appearance: appearance, spacing: spacing, isSelected: isSelected, shouldFitContainer: shouldFitContainer, isOnlySingleIcon: isOnlySingleIcon }) {
    return {
        // 0px margin added to css-reset
        alignItems: 'baseline',
        borderWidth: 0,
        borderRadius: (0, $3X3Vo.fg)('platform-dst-shape-theme-default') ? "var(--ds-radius-medium, 6px)" : "var(--ds-radius-small, 3px)",
        boxSizing: 'border-box',
        display: 'inline-flex',
        fontSize: 'inherit',
        fontStyle: 'normal',
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: 'inherit',
        fontWeight: "var(--ds-font-weight-medium, 500)",
        // margin for button has been applied to css reset
        maxWidth: '100%',
        // Needed to position overlay
        position: 'relative',
        textAlign: 'center',
        textDecoration: 'none',
        transition: 'background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
        whiteSpace: 'nowrap',
        cursor: 'pointer',
        height: $fe0a09e88b545be3$var$heights[spacing],
        lineHeight: $fe0a09e88b545be3$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $fe0a09e88b545be3$var$singleIconPadding[spacing] : $fe0a09e88b545be3$var$padding[spacing],
        verticalAlign: $fe0a09e88b545be3$var$verticalAlign[spacing],
        width: shouldFitContainer ? '100%' : 'auto',
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: 'center',
        ...isSelected ? $fe0a09e88b545be3$var$selectedStyles : {
            ...appearance === 'default' && $fe0a09e88b545be3$var$defaultStyles,
            ...appearance === 'primary' && $fe0a09e88b545be3$var$primaryStyles,
            ...appearance === 'link' && $fe0a09e88b545be3$var$linkStyles,
            ...appearance === 'subtle' && $fe0a09e88b545be3$var$subtleStyles,
            ...appearance === 'subtle-link' && $fe0a09e88b545be3$var$subtleLinkStyles,
            ...appearance === 'warning' && $fe0a09e88b545be3$var$warningStyles,
            ...appearance === 'danger' && $fe0a09e88b545be3$var$dangerStyles,
            '&[disabled]': {
                color: "var(--ds-text-disabled, #080F214A)",
                backgroundColor: $fe0a09e88b545be3$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #17171708)" : 'transparent',
                cursor: 'not-allowed',
                textDecoration: 'none',
                '&:hovered': {
                    backgroundColor: $fe0a09e88b545be3$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #17171708)" : 'transparent'
                },
                '&:active': {
                    backgroundColor: $fe0a09e88b545be3$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #17171708)" : 'transparent'
                }
            },
            ...$fe0a09e88b545be3$var$hasOverlayStyles
        },
        '&::-moz-focus-inner': {
            border: 0,
            margin: 0,
            padding: 0
        }
    };
}

});

parcelRegister("30n6g", function(module, exports) {
$parcel$export(module.exports, "default", () => $44628747aa6f59dd$export$2e2bcd8739ae039);

var $h8v80 = parcelRequire("h8v80");
function $44628747aa6f59dd$export$2e2bcd8739ae039({ children: children, iconBefore: iconBefore, iconAfter: iconAfter }) {
    if ((0, $h8v80.getIfVisuallyHiddenChildren)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}

});


parcelRegister("2dnyN", function(module, exports) {
$parcel$export(module.exports, "messages", () => $47958c9cf24c1f3f$export$defe85febe8b728c);

var $38Fhe = parcelRequire("38Fhe");
const $47958c9cf24c1f3f$export$defe85febe8b728c = (0, $38Fhe.defineMessages)({
    loadingMessage: {
        id: "rovo-extension.menu-page.loading-message",
        defaultMessage: "Loading...",
        description: "Message displayed when the menu page is loading."
    },
    menuHeadingMessage: {
        id: "rovo-extension.menu-page.menu-heading-message",
        defaultMessage: "What's new in Rovo",
        description: "Message displayed on heading of menu page."
    },
    menuSubheadingMessage: {
        id: "rovo-extension.menu-page.menu-subheading-message",
        defaultMessage: "Discover the latest updates and new features in Rovo",
        description: "Message displayed on subheading of menu page."
    },
    allCategoryLabel: {
        id: "rovo-extension.menu-page.all-category-label",
        defaultMessage: "All",
        description: "The text is shown as a category filter tab or sidebar item in the menu page that, when selected, displays all available features across every category."
    },
    aiSearchCategoryLabel: {
        id: "rovo-extension.menu-page.ai-search-category-label",
        defaultMessage: "AI Search",
        description: "The text is shown as a category filter tab or sidebar item in the menu page that, when selected, filters the feature list to show only AI Search-related features."
    },
    chatCategoryLabel: {
        id: "rovo-extension.menu-page.chat-category-label",
        defaultMessage: "Chat",
        description: "The text is shown as a category filter tab or sidebar item in the menu page that, when selected, filters the feature list to show only Chat-related features."
    },
    agentStudioCategoryLabel: {
        id: "rovo-extension.menu-page.agent-studio-category-label",
        defaultMessage: "Agent Studio",
        description: "Label displayed for Agent Studio category"
    },
    extensionCategoryLabel: {
        id: "rovo-extension.menu-page.extension-category-label",
        defaultMessage: "Extension",
        description: "The text is shown as a category filter tab or sidebar item in the menu page that, when selected, filters the feature list to show only browser extension-specific features."
    },
    announcementAriaLabel: {
        id: "rovo-extension.menu-page.announcements.aria-label",
        defaultMessage: "Announcement: {title}",
        description: "Aria label for announcement on menu page. Title will be replaced with the actual announcement title."
    }
});

});


parcelRegister("afq8D", function(module, exports) {
$parcel$export(module.exports, "MediaStyles", () => $961ffb54c1c96f2c$export$2850b44a08bd83be);
$parcel$export(module.exports, "default", () => $961ffb54c1c96f2c$export$2e2bcd8739ae039);

var $4tluv = parcelRequire("4tluv");

var $kbKpL = parcelRequire("kbKpL");
var $hT0yS = parcelRequire("hT0yS");
var $eojIt = parcelRequire("eojIt");
var $kfPot = parcelRequire("kfPot");

var $caeHC = parcelRequire("caeHC");

var $dff6Q = parcelRequire("dff6Q");

var $7Ywk8 = parcelRequire("7Ywk8");

var $2dnyN = parcelRequire("2dnyN");
parcelRequire("1wxU2");
var $cyDwo = parcelRequire("cyDwo");
const $961ffb54c1c96f2c$var$AnnouncementCardStyles = (0, $kfPot.xcss)({
    backgroundColor: "elevation.surface",
    borderRadius: "radius.large",
    padding: "space.400",
    marginBottom: "space.400",
    boxShadow: "elevation.shadow.raised",
    cursor: "pointer",
    transition: "box-shadow 0.3s ease",
    ":hover": {
        boxShadow: "elevation.shadow.overlay"
    }
});
const $961ffb54c1c96f2c$var$InlineStyles = (0, $kfPot.xcss)({
    display: "flex",
    gap: "space.100",
    flexWrap: "wrap"
});
const $961ffb54c1c96f2c$var$HeadingSmallTextStyles = (0, $kfPot.xcss)({
    font: "font.heading.medium",
    fontWeight: "font.weight.medium",
    marginBottom: "space.200"
});
const $961ffb54c1c96f2c$var$BodyTextStyles = (0, $kfPot.xcss)({
    font: "font.body",
    marginBottom: "space.200"
});
const $961ffb54c1c96f2c$export$2850b44a08bd83be = (0, $kfPot.xcss)({
    maxWidth: "100%",
    height: "auto",
    borderRadius: "radius.small",
    marginBottom: "space.300"
});
const $961ffb54c1c96f2c$var$LinkButtonStyles = (0, $kfPot.xcss)({
    marginRight: "space.100",
    marginBottom: "space.100"
});
const $961ffb54c1c96f2c$var$DateStyles = (0, $kfPot.xcss)({
    font: "font.body.small",
    color: "color.text.subtlest"
});
const $961ffb54c1c96f2c$var$AnnouncementCard = ({ announcement: announcement, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $7Ywk8.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $kbKpL.default), {
        "aria-label": formatMessage((0, $2dnyN.messages).announcementAriaLabel, {
            title: announcement.title
        }),
        onClick: onClick,
        role: "button",
        tabIndex: 0,
        xcss: $961ffb54c1c96f2c$var$AnnouncementCardStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $eojIt.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $cyDwo.default), {
        name: "announcement-header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $hT0yS.default), {
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $kbKpL.default), {
        color: "color.text",
        xcss: $961ffb54c1c96f2c$var$HeadingSmallTextStyles
    }, announcement.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $kbKpL.default), {
        xcss: $961ffb54c1c96f2c$var$InlineStyles
    }, announcement.tags.map((tag)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $caeHC.default), {
            key: tag,
            appearance: "new",
            isBold: true
        }, tag.toUpperCase()))))), announcement.media && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $cyDwo.default), {
        name: "announcement-media"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $kbKpL.default), {
        alt: announcement.media.alt ?? "",
        as: "img",
        src: announcement.media.url.default,
        xcss: $961ffb54c1c96f2c$export$2850b44a08bd83be
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $cyDwo.default), {
        name: "announcement-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $kbKpL.default), {
        xcss: $961ffb54c1c96f2c$var$BodyTextStyles
    }, announcement.content)), announcement.links && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $cyDwo.default), {
        name: "announcement-links"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $kbKpL.default), {
        xcss: $961ffb54c1c96f2c$var$InlineStyles
    }, announcement.links.map((link, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $kbKpL.default), {
            key: index,
            xcss: $961ffb54c1c96f2c$var$LinkButtonStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $dff6Q.default), {
            appearance: "default",
            href: link.url,
            rel: "noopener noreferrer",
            target: "_blank"
        }, link.text))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $kbKpL.default), {
        xcss: $961ffb54c1c96f2c$var$DateStyles
    }, announcement.date)));
};
var $961ffb54c1c96f2c$export$2e2bcd8739ae039 = $961ffb54c1c96f2c$var$AnnouncementCard;

});

parcelRegister("1ELgd", function(module, exports) {
$parcel$export(module.exports, "messages", () => $9c6b8ee42d53ba5f$export$defe85febe8b728c);

var $38Fhe = parcelRequire("38Fhe");
const $9c6b8ee42d53ba5f$export$defe85febe8b728c = (0, $38Fhe.defineMessages)({
    shortcutTitle: {
        id: "rovo-extension.announcements.shortcuts.title",
        defaultMessage: "Extension shortcuts: Search and Chat even faster",
        description: "The text is shown as the main heading of an announcement card or modal introducing keyboard shortcut features for the Rovo browser extension, specifically for Search and Chat actions."
    },
    shortcutIntro: {
        id: "rovo-extension.announcements.shortcuts.intro",
        defaultMessage: "You can now use keyboard shortcuts to quickly access the best features in the extension.",
        description: "Introduction text for shortcuts announcement"
    },
    chatTitle: {
        id: "rovo-extension.announcements.shortcuts.chat.title",
        defaultMessage: "Chat",
        description: "The text is shown as a section heading within the shortcuts announcement, labelling the Chat shortcut subsection that describes how to open the Rovo chat feature."
    },
    macChatAccess: {
        id: "rovo-extension.announcements.shortcuts.mac-chat-access",
        defaultMessage: "Access your extension-powered Chat at any time by pressing CMD + Shift + Y.",
        description: "Chat shortcut instructions for Mac OS users"
    },
    windowsChatAccess: {
        id: "rovo-extension.announcements.shortcuts.windows-chat-access",
        defaultMessage: "Access your extension-powered Chat at any time by pressing CTRL + Shift + Y.",
        description: "Chat shortcut instructions for windows users"
    },
    searchTitle: {
        id: "rovo-extension.announcements.shortcuts.search.title",
        defaultMessage: "Search",
        description: "The text is shown as a section heading within the shortcuts announcement, labelling the Search shortcut subsection that describes how to use Rovo-powered search."
    },
    searchAnytimeTitle: {
        id: "rovo-extension.announcements.shortcuts.search.anytime.title",
        defaultMessage: "Anytime, anywhere",
        description: "The text is shown as a sub-heading within the Search shortcuts announcement section, introducing the feature that lets users search from anywhere in the browser at any time."
    },
    searchAnytimeDesc: {
        id: "rovo-extension.announcements.shortcuts.search.anytime.description",
        defaultMessage: "From the address bar: Press r + space to perform a Rovo-powered search instantly.",
        description: 'The text is shown as a descriptive paragraph within the shortcuts announcement, explaining to users how to trigger a Rovo-powered search from the browser address bar using the "r + space" keyboard shortcut.'
    },
    searchNewTabTitle: {
        id: "rovo-extension.announcements.shortcuts.search.newtab.title",
        defaultMessage: "In your new tab Rovo page",
        description: "The text is shown as a sub-heading within the Search shortcuts announcement section, introducing the search shortcut available on the Rovo new tab page."
    },
    searchNewTabMacDesc: {
        id: "rovo-extension.announcements.shortcuts.search.newtab.mac-description",
        defaultMessage: "If you're not in the address bar (you can hit tab to focus out of this), press CMD + B to jump into the Search box.",
        description: "Description for new tab search feature for mac users"
    },
    searchNewTabWindowsDesc: {
        id: "rovo-extension.announcements.shortcuts.search.newtab.windows-description",
        defaultMessage: "If you're not in the address bar (you can hit tab to focus out of this), press CTRL + B to jump into the Search box.",
        description: "Description for new tab search feature for windows users"
    },
    shortcutGifAlt: {
        id: "rovo-extension.announcements.shortcuts.images.shortcut-gif",
        defaultMessage: "How to use search shortcut",
        description: "The text is used as the alt attribute for an animated GIF image shown in the shortcuts announcement, demonstrating how to use the search shortcut keyboard combination."
    },
    chatShortcutAlt: {
        id: "rovo-extension.announcements.shortcuts.images.chat-shortcut",
        defaultMessage: "Chat shortcut",
        description: "The text is used as the alt attribute for an image shown in the shortcuts announcement, illustrating the keyboard shortcut keys used to open the Rovo chat feature."
    },
    searchShortcutAlt: {
        id: "rovo-extension.announcements.shortcuts.images.search-shortcut",
        defaultMessage: "Search shortcut",
        description: "The text is used as the alt attribute for an image shown in the shortcuts announcement, illustrating the keyboard shortcut keys used to trigger a Rovo-powered search."
    },
    themingTitle: {
        id: "rovo-extension.announcements.theming.title",
        defaultMessage: "Company theming for your Rovo sites",
        description: "The text is shown as the main heading of an announcement card or modal that introduces the company theming feature, allowing organisations to customise the appearance of their Rovo new tab page."
    },
    themingIntro: {
        id: "rovo-extension.announcements.theming.intro",
        defaultMessage: "<bold>Company Theming for the Rovo Browser Extension is Now Live!</bold>",
        description: "Introduction text for theming announcement"
    },
    themingDescriptionFirstSection: {
        id: "rovo-extension.announcements.theming.description.1",
        defaultMessage: "Imagine transforming your Rovo new tab page with a touch of your company's distinctive style. Organization administrators can customize the navigation of the Rovo new tab by adding a unique company logo and background.",
        description: "The text is shown as the first descriptive paragraph in the company theming announcement modal, introducing the concept of customising the Rovo new tab page with company branding."
    },
    themingDescriptionSecondSection: {
        id: "rovo-extension.announcements.theming.description.2",
        defaultMessage: "This enhancement goes beyond aesthetics; it highlights how your company is integrating AI into everyday workflows.",
        description: "The text is shown as the second descriptive paragraph in the company theming announcement modal, explaining that the theming feature also signals the company's adoption of AI in daily workflows."
    },
    themingDescriptionThirdSection: {
        id: "rovo-extension.announcements.theming.description.3",
        defaultMessage: "You can find this feature in the admin console settings located on the extension options page, <bold>accessible to all organization administrators</bold>. <link>Find more directions here</link>.",
        description: "Last section of theming description with bold text and link"
    },
    themingImageBeforeAlt: {
        id: "rovo-extension.announcements.theming.images.alt",
        defaultMessage: "Preview of the Rovo Browser Extension new tab page before theming",
        description: "The text is used as the alt attribute for an image in the theming announcement showing the Rovo browser extension new tab page in its default appearance before any company theming has been applied."
    },
    themingImageAfterAlt: {
        id: "rovo-extension.announcements.theming.images.alt",
        defaultMessage: "Preview of the Rovo Browser Extension after theming",
        description: "The text is used as the alt attribute for an image in the theming announcement showing the Rovo browser extension new tab page after company theming colours and branding have been applied."
    }
});

});

parcelRegister("14tdF", function(module, exports) {
module.exports = new URL("shortcut.81f036d5.gif", import.meta.url).toString();

});

parcelRegister("96ixn", function(module, exports) {
module.exports = new URL("chat_shortcut_mac.b00550ed.png", import.meta.url).toString();

});

parcelRegister("6cghZ", function(module, exports) {
module.exports = new URL("search_shortcut_mac.e576f54b.png", import.meta.url).toString();

});

parcelRegister("cQo2G", function(module, exports) {
module.exports = new URL("chat_shortcut_windows.6416e7a0.png", import.meta.url).toString();

});

parcelRegister("5bP6K", function(module, exports) {
module.exports = new URL("search_shortcut_windows.e0978f2a.png", import.meta.url).toString();

});

parcelRegister("i9BIV", function(module, exports) {
$parcel$export(module.exports, "isMacOs", () => $8ea0c380148ece2f$export$c5e71f489eb3970b);
const $8ea0c380148ece2f$export$c5e71f489eb3970b = ()=>/Mac/i.test(window.navigator.userAgent);

});


parcelRegister("dDkso", function(module, exports) {
$parcel$export(module.exports, "ThemingAnnouncementData", () => $d92e6ba7defe4170$export$9c183be060963bec);

var $4tluv = parcelRequire("4tluv");

var $kbKpL = parcelRequire("kbKpL");
var $hT0yS = parcelRequire("hT0yS");
var $eojIt = parcelRequire("eojIt");
var $cYEgx = parcelRequire("cYEgx");
var $kfPot = parcelRequire("kfPot");

var $9KBmj = parcelRequire("9KBmj");

var $7Ywk8 = parcelRequire("7Ywk8");

var $67Flg = parcelRequire("67Flg");

var $1ELgd = parcelRequire("1ELgd");

var $6Ehns = parcelRequire("6Ehns");

var $b5XqH = parcelRequire("b5XqH");
const $d92e6ba7defe4170$var$contentStyles = (0, $kfPot.xcss)({
    marginTop: "space.200"
});
const $d92e6ba7defe4170$var$ImageStyles = (0, $kfPot.xcss)({
    width: "100%"
});
const $d92e6ba7defe4170$export$eeda29ad50ff5bb = ()=>{
    const { formatMessage: formatMessage } = (0, $7Ywk8.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $kbKpL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $hT0yS.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $kbKpL.default), {
        xcss: $d92e6ba7defe4170$var$ImageStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $9KBmj.default), {
        alt: formatMessage((0, $1ELgd.messages).themingImageBeforeAlt),
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6Ehns)))
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $kbKpL.default), {
        xcss: $d92e6ba7defe4170$var$ImageStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $9KBmj.default), {
        alt: formatMessage((0, $1ELgd.messages).themingImageAfterAlt),
        src: (0, (/*@__PURE__*/$parcel$interopDefault($b5XqH)))
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $eojIt.default), {
        space: "space.200",
        xcss: $d92e6ba7defe4170$var$contentStyles
    }, formatMessage((0, $1ELgd.messages).themingIntro, {
        bold: (text)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement("b", null, text)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $eojIt.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $cYEgx.default), null, formatMessage((0, $1ELgd.messages).themingDescriptionFirstSection)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $cYEgx.default), null, formatMessage((0, $1ELgd.messages).themingDescriptionSecondSection)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $cYEgx.default), null, formatMessage((0, $1ELgd.messages).themingDescriptionThirdSection, {
        bold: (text)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement("b", null, text),
        link: (text)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement("a", {
                href: "https://community.atlassian.com/forums/Atlassian-AI-Rovo-articles/Brand-Rovo-as-your-company-s-search-amp-chat-company-theming-now/ba-p/3040952",
                rel: "noopener noreferrer",
                target: "_blank"
            }, text)
    })))));
};
const $d92e6ba7defe4170$export$9c183be060963bec = {
    title: (0, $1ELgd.messages).themingTitle.defaultMessage,
    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement($d92e6ba7defe4170$export$eeda29ad50ff5bb, null),
    tags: [
        (0, $67Flg.CATEGORIES).EXTENSION
    ]
};
var $d92e6ba7defe4170$export$2e2bcd8739ae039 = $d92e6ba7defe4170$export$eeda29ad50ff5bb;

});
parcelRegister("6Ehns", function(module, exports) {
module.exports = new URL("theming_before.77c0996c.png", import.meta.url).toString();

});

parcelRegister("b5XqH", function(module, exports) {
module.exports = new URL("theming_after.c6f8c1c8.png", import.meta.url).toString();

});



parcelRegister("5DgeC", function(module, exports) {
$parcel$export(module.exports, "messages", () => $6b64ad8ad790c586$export$defe85febe8b728c);

var $38Fhe = parcelRequire("38Fhe");
const $6b64ad8ad790c586$export$defe85febe8b728c = (0, $38Fhe.defineMessages)({
    whatsNew: {
        id: "rovo-extension.profile.whats-new-button.label",
        defaultMessage: "What's New",
        description: "Label for the 'What's new' button in the profile menu"
    },
    giveFeedback: {
        id: "rovo-extension.profile.give-feedback-button.label",
        defaultMessage: "Give feedback",
        description: "Label for the 'Give feedback' button in the profile menu"
    }
});

});

parcelRegister("3yHBw", function(module, exports) {
$parcel$export(module.exports, "default", () => $f40feef796d9633c$export$2e2bcd8739ae039);

var $202P8 = parcelRequire("202P8");

var $bqso3 = parcelRequire("bqso3");

var $4tluv = parcelRequire("4tluv");

var $kijvt = parcelRequire("kijvt");

var $lIP59 = parcelRequire("lIP59");
parcelRequire("iuDZJ");
var $dqHaj = parcelRequire("dqHaj");

var $cGfIx = parcelRequire("cGfIx");

var $e9gYt = parcelRequire("e9gYt");

var $hAM4Q = parcelRequire("hAM4Q");

var $lsxLV = parcelRequire("lsxLV");

var $dX6kP = parcelRequire("dX6kP");

var $53tof = parcelRequire("53tof");

const $f40feef796d9633c$var$AkFeedbackCollector = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).lazy(()=>(parcelRequire("fhbod")).then((module)=>{
        return {
            default: module.default
        };
    }));

const $f40feef796d9633c$var$AkFeedbackFlag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).lazy(()=>(parcelRequire("fhbod")).then(({ FeedbackFlag: FeedbackFlag })=>{
        return {
            default: FeedbackFlag
        };
    }));
const $f40feef796d9633c$export$d897f55d9ef86c2 = (feedback)=>{
    const summary = `[CHROME - ${(0, $dqHaj.bifrostEnv)}] ` + feedback;
    if (summary.length >= 255) return summary.substring(0, 250) + "...";
    return `Environment: ${0, $dqHaj.bifrostEnv}\n${summary}`;
};
const $f40feef796d9633c$export$2466210fe8715900 = (browserManifestVersion, site, userAccount)=>{
    const feedbackContext = {
        version: (0, $dqHaj.bitbucketCommit),
        release: browserManifestVersion,
        source: (0, $cGfIx.SOURCE),
        userId: userAccount.accountId,
        cloudId: site.workspace.cloudId,
        isHello: (0, $e9gYt.isHello)(site.workspace.cloudId),
        environment: (0, $dqHaj.bifrostEnv)
    };
    return JSON.stringify(feedbackContext);
};
const $f40feef796d9633c$var$FeedbackModal = ({ site: site, userAccount: userAccount, showModal: showModal, setShowModal: setShowModal })=>{
    const { browserManifestVersion: browserManifestVersion } = (0, $hAM4Q.useManifestVersion)();
    const [description, setDescription] = (0, $4tluv.useState)("");
    const [displayFlag, setDisplayFlag] = (0, $4tluv.useState)(false);
    const sendAnalyticEvent = (0, $dX6kP.useSendAnalyticEvent)();
    const hideFlag = ()=>setDisplayFlag(false);
    const onSubmit = ()=>{
        setDisplayFlag(true);
        // https://data-portal.internal.atlassian.com/analytics/registry/73850
        sendAnalyticEvent({
            eventType: "ui",
            event: {
                action: "submitFeedback",
                actionSubject: (0, $lsxLV.ANALYTICS_UI_SUBJECTS).FEEDBACK_COLLECTOR,
                source: (0, $lsxLV.ANALYTICS_SCREEN_NAMES).EXTENSION_HOME_SCREEN
            },
            userId: userAccount.accountId
        });
    };
    const close = ()=>{
        setShowModal(false);
        setDescription("");
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).Fragment, null, showModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $4tluv.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement($f40feef796d9633c$var$AkFeedbackCollector, {
        additionalFields: [
            {
                id: (0, $cGfIx.FEEDBACK_CONTEXT_FIELD_ID),
                value: $f40feef796d9633c$export$2466210fe8715900(browserManifestVersion, site, userAccount)
            }
        ],
        atlassianAccountId: userAccount.accountId,
        customContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $202P8.default), {
            defaultValue: "",
            isRequired: true,
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $lIP59.default), (0, $53tof.messages).feedbackCollectorLabel),
            name: "description-field"
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $bqso3.default), {
                ...fieldProps,
                minimumRows: 6,
                name: "feedback-collector-description",
                onChange: (e)=>setDescription(e.target.value),
                placeholder: "",
                value: description
            }))),
        descriptionDefaultValue: description,
        email: userAccount.email,
        entrypointId: (0, $cGfIx.ENTRYPOINT_ID),
        locale: (0, $dqHaj.getLocale)(),
        name: userAccount.name,
        onClose: close,
        onSubmit: onSubmit,
        showDefaultTextFields: false,
        showTypeField: false,
        summaryDefaultValue: $f40feef796d9633c$export$d897f55d9ef86c2(description)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $kijvt.default), {
        onDismissed: hideFlag
    }, displayFlag && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $4tluv.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement($f40feef796d9633c$var$AkFeedbackFlag, {
        locale: (0, $dqHaj.getLocale)()
    }))));
};
var $f40feef796d9633c$export$2e2bcd8739ae039 = $f40feef796d9633c$var$FeedbackModal;

});
parcelRegister("cGfIx", function(module, exports) {
$parcel$export(module.exports, "ENTRYPOINT_ID", () => $a91d43cde40226d0$export$25dc0a1e75f58d8f);
$parcel$export(module.exports, "FEEDBACK_CONTEXT_FIELD_ID", () => $a91d43cde40226d0$export$7d5d4c32f29189c3);
$parcel$export(module.exports, "SOURCE", () => $a91d43cde40226d0$export$83c8d7110915321e);
// Feedbacks will be sent to Plex's feedback project
// https://customerfeedback.atlassian.net/jira/servicedesk/projects/SANDSF/queues/custom/108
const $a91d43cde40226d0$export$25dc0a1e75f58d8f = "9b88e53b-d04d-4f1c-ae85-6d7f59d1ca7a";
const $a91d43cde40226d0$export$7d5d4c32f29189c3 = "customfield_10047";
const $a91d43cde40226d0$export$83c8d7110915321e = "rovo-extension";

});

parcelRegister("hAM4Q", function(module, exports) {
$parcel$export(module.exports, "useManifestVersion", () => $92f29700b4baddbf$export$d1a9989589baf7f6);
// Store the manifest version at module level to persist across navigation
let $92f29700b4baddbf$var$cachedManifestVersion = null;
function $92f29700b4baddbf$export$d1a9989589baf7f6() {
    if ($92f29700b4baddbf$var$cachedManifestVersion === null) {
        const { search: search } = window.location;
        $92f29700b4baddbf$var$cachedManifestVersion = new URLSearchParams(search).get("version") ?? "0.0";
    }
    const browserManifestVersion = $92f29700b4baddbf$var$cachedManifestVersion;
    const isNewerThan = (version)=>$92f29700b4baddbf$var$isGreaterThanCompareVersion(version, browserManifestVersion);
    return {
        browserManifestVersion: browserManifestVersion,
        isNewerThan: isNewerThan
    };
}
// Checks if the current version is greater than the comparison version
const $92f29700b4baddbf$var$isGreaterThanCompareVersion = (comparisonVersion, currentVersion)=>{
    const compareParts = comparisonVersion.split(".").map(Number);
    const currentParts = currentVersion.split(".").map(Number);
    for(let i = 0; i < 3; i++){
        const compareValue = compareParts[i] ?? 0;
        const currentValue = currentParts[i] ?? 0;
        if (currentValue > compareValue) return true;
        if (currentValue < compareValue) return false;
    }
    return false; // Versions equal
};

});

parcelRegister("53tof", function(module, exports) {
$parcel$export(module.exports, "messages", () => $37cd1038405fb930$export$defe85febe8b728c);

var $38Fhe = parcelRequire("38Fhe");
const $37cd1038405fb930$export$defe85febe8b728c = (0, $38Fhe.defineMessages)({
    giveFeedback: {
        id: "rovo-extension.feedback.give-feedback-button.label",
        defaultMessage: "Give feedback",
        description: "The text is shown on a button in the Rovo extension interface that, when clicked, opens a feedback form or modal allowing the user to submit feedback about the extension."
    },
    feedbackCollectorLabel: {
        id: "rovo-extension.feedback.feedback-collector.label",
        defaultMessage: "Let us know what's on your mind",
        description: "The text is shown as the introductory label or heading at the top of the feedback collector form or modal, prompting the user to share their thoughts about the Rovo extension."
    },
    areYouEnjoying: {
        id: "rovo-extension.feedback.are-you-enjoying.label",
        defaultMessage: "Are you enjoying the Rovo Chrome plugin?",
        description: "Label for the question asking if the user is enjoying the Rovo Chrome plugin."
    },
    shareYourThoughts: {
        id: "rovo-extension.feedback.share-your-thoughts.label",
        defaultMessage: "Share your thoughts",
        description: "Label for the title of the feedback modal."
    },
    yes: {
        id: "rovo-extension.feedback.yes.label",
        defaultMessage: "Yes",
        description: "Label for the 'Yes' button in the feedback modal."
    },
    no: {
        id: "rovo-extension.feedback.no.label",
        defaultMessage: "No",
        description: "Label for the 'No' button in the feedback modal."
    },
    reviewConfirmationTitle: {
        id: "rovo-extension.feedback.review-confirmation-title",
        defaultMessage: "Thanks for the feedback!",
        description: "Title for the review step shown in the feedback flag after user clicks Yes."
    },
    reviewConfirmationBody: {
        id: "rovo-extension.feedback.review-confirmation-body",
        defaultMessage: "Want to leave a quick review in the Chrome Web Store?",
        description: "Body text for the review step asking user to leave a Chrome Web Store review."
    },
    reviewConfirmationConfirm: {
        id: "rovo-extension.feedback.review-confirmation-confirm",
        defaultMessage: "Leave a review",
        description: "Label for the confirm button in the review step that opens Chrome Web Store."
    },
    reviewConfirmationDismiss: {
        id: "rovo-extension.feedback.review-confirmation-dismiss",
        defaultMessage: "Not now",
        description: "Label for the dismiss button in the review step of the feedback flag."
    }
});

});

parcelRegister("fhbod", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = Promise.all([
    $20gJU("jOsRz"),
    $20gJU("6y1PR"),
    $20gJU("5937K")
]).then(()=>parcelRequire('dLMAQ'));

});


parcelRegister("jPKf9", function(module, exports) {
$parcel$export(module.exports, "useCurrentScreenName", () => $2ca03d226d0eebdb$export$ac619b093bd74b42);
parcelRequire("3mxm3");
var $bfivG = parcelRequire("bfivG");

var $lsxLV = parcelRequire("lsxLV");
const $2ca03d226d0eebdb$var$extensionPathToScreenNameMap = {
    "/extension": (0, $lsxLV.ANALYTICS_SCREEN_NAMES).EXTENSION_HOME_SCREEN,
    "/extension/menu": (0, $lsxLV.ANALYTICS_SCREEN_NAMES).EXTENSION_WHATS_NEW_SCREEN,
    "/extension/options": (0, $lsxLV.ANALYTICS_SCREEN_NAMES).EXTENSION_OPTIONS_SCREEN,
    "/extension/rovo-chat": (0, $lsxLV.ANALYTICS_SCREEN_NAMES).EXTENSION_CHAT_SCREEN
};
const $2ca03d226d0eebdb$var$isValidExtensionPath = (path)=>{
    return path in $2ca03d226d0eebdb$var$extensionPathToScreenNameMap;
};
const $2ca03d226d0eebdb$export$ac619b093bd74b42 = ()=>{
    const location = (0, $bfivG.useLocation)();
    const normalizedPath = location.pathname.replace(/\/$/, ""); // Remove trailing slash
    return $2ca03d226d0eebdb$var$isValidExtensionPath(normalizedPath) ? $2ca03d226d0eebdb$var$extensionPathToScreenNameMap[normalizedPath] : "unknown";
};

});

parcelRegister("atGCc", function(module, exports) {
$parcel$export(module.exports, "SessionReplayUGC", () => (parcelRequire("8VUj0")).SessionReplayUGC);

var $8VUj0 = parcelRequire("8VUj0");

});
parcelRegister("8VUj0", function(module, exports) {
$parcel$export(module.exports, "SessionReplayUGC", () => $d95646efdf60abd0$export$dd7e8131d58a5e73);

var $4tluv = parcelRequire("4tluv");
const $d95646efdf60abd0$export$dd7e8131d58a5e73 = ({ as: Component = "div", children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement(Component, {
        className: "amp-mask"
    }, children);
};

});



parcelRegister("gN3lo", function(module, exports) {
$parcel$export(module.exports, "ExtensionTopBarCompanyLogo", () => $20e2344e7517fc5c$export$37e6c72980c86988);

var $4tluv = parcelRequire("4tluv");

var $9KBmj = parcelRequire("9KBmj");

var $2VaCp = parcelRequire("2VaCp");

var $2X3dI = parcelRequire("2X3dI");
var $kfPot = parcelRequire("kfPot");

var $7qmv7 = parcelRequire("7qmv7");

var $7Ywk8 = parcelRequire("7Ywk8");

var $2vAyx = parcelRequire("2vAyx");

var $lHN9r = parcelRequire("lHN9r");

var $e9vmu = parcelRequire("e9vmu");

var $dX6kP = parcelRequire("dX6kP");

var $jPKf9 = parcelRequire("jPKf9");

var $lsxLV = parcelRequire("lsxLV");

var $bfivG = parcelRequire("bfivG");

var $kvcqg = parcelRequire("kvcqg");

var $056A9 = parcelRequire("056A9");

var $b0UAF = parcelRequire("b0UAF");
parcelRequire("jMN8E");
var $hZQIF = parcelRequire("hZQIF");

var $9NbMC = parcelRequire("9NbMC");

var $TrAR1 = parcelRequire("TrAR1");
const $20e2344e7517fc5c$var$logoStyles = (0, $kfPot.xcss)({
    height: "var(--ds-space-300, 24px)"
});
const $20e2344e7517fc5c$export$37e6c72980c86988 = ({ userAccount: userAccount, site: site })=>{
    const sendAnalyticEvent = (0, $dX6kP.useSendAnalyticEvent)();
    const currentScreenName = (0, $jPKf9.useCurrentScreenName)();
    const handleLogoClick = (0, $4tluv.useCallback)((e, logoType)=>{
        // Prevent anchor's default navigation to avoid full page reload when using React Router
        e.preventDefault();
        // https://data-portal.internal.atlassian.com/analytics/registry/86536
        sendAnalyticEvent({
            eventType: "ui",
            event: {
                action: "click",
                actionSubject: (0, $lsxLV.ANALYTICS_UI_SUBJECTS).NAV_BAR_LOGO,
                source: currentScreenName,
                attributes: {
                    logoType: logoType
                }
            },
            userId: userAccount.accountId
        });
    }, [
        currentScreenName,
        sendAnalyticEvent,
        userAccount.accountId
    ]);
    if (!site) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement($20e2344e7517fc5c$var$DefaultCompanyIcon, {
        isRovoLLMEnabled: false,
        onLogoClick: handleLogoClick
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement($20e2344e7517fc5c$var$CompanyIcon, {
        onLogoClick: handleLogoClick,
        site: site
    });
};
const $20e2344e7517fc5c$var$CompanyIcon = ({ site: site, onLogoClick: onLogoClick })=>{
    const { data: themeFileMetadata, isLoading: isLoading } = (0, $2vAyx.useNtpThemeFileMetadata)({
        siteId: site.workspace.cloudId
    });
    const { isRovoLLMEnabled: isRovoLLMEnabled } = (0, $b0UAF.useEntitlementCheck)();
    (0, $056A9.useQueryInvalidationBroadcast)([
        "getNtpThemeFileMetadata",
        site.workspace.cloudId
    ], true);
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).Fragment, null);
    const logoThemeMetadata = themeFileMetadata?.find((m)=>m.themeFileType === (0, $lHN9r.ThemeFileType).LOGO);
    if (logoThemeMetadata) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement($20e2344e7517fc5c$var$CustomCompanyIcon, {
        isRovoLLMEnabled: isRovoLLMEnabled,
        onLogoClick: onLogoClick,
        s3Etag: logoThemeMetadata.s3Etag,
        site: site
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement($20e2344e7517fc5c$var$DefaultCompanyIcon, {
        isRovoLLMEnabled: isRovoLLMEnabled,
        onLogoClick: onLogoClick
    });
};
const $20e2344e7517fc5c$var$DefaultCompanyIcon = ({ onLogoClick: onLogoClick, isRovoLLMEnabled: isRovoLLMEnabled })=>{
    const { formatMessage: formatMessage } = (0, $7Ywk8.default)();
    const isOnHomePage = !!(0, $bfivG.useMatch)("/extension");
    const { navigateToChat: navigateToChat, navigateToHome: navigateToHome } = (0, $kvcqg.useExtensionNavigation)();
    const rovoIcon = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $7qmv7.RovoIcon), {
            shouldUseHexLogo: true,
            ...props
        });
    const rovoLogo = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $7qmv7.RovoLogo), {
            shouldUseHexLogo: true,
            ...props
        });
    const handleDefaultLogoClick = (e)=>{
        onLogoClick(e, "default");
        if (isOnHomePage && isRovoLLMEnabled) navigateToChat();
        else navigateToHome();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $2VaCp.NavLogo), {
        href: "/extension",
        icon: rovoIcon,
        label: formatMessage((0, $e9vmu.messages).homeLabel),
        logo: rovoLogo,
        onClick: handleDefaultLogoClick
    });
};
const $20e2344e7517fc5c$var$CustomCompanyIcon = ({ s3Etag: s3Etag, site: site, onLogoClick: onLogoClick, isRovoLLMEnabled: isRovoLLMEnabled })=>{
    const { formatMessage: formatMessage } = (0, $7Ywk8.default)();
    const { navigateToHome: navigateToHome, navigateToChatWithPrompt: navigateToChatWithPrompt } = (0, $kvcqg.useExtensionNavigation)();
    const { remoteAdminSettings: remoteAdminSettings } = (0, $hZQIF.useSettings)();
    const checkFeatureGate = (0, $9NbMC.useCheckStatSigFeatureGate)();
    const isCustomLogoBehaviorEnabled = checkFeatureGate((0, $TrAR1.STATSIG_FEATURE_GATES).NTP_LOGO_CUSTOM_BEHAVIOR);
    const isOnHomePage = !!(0, $bfivG.useMatch)("/extension");
    const handleCustomLogoClick = (e)=>{
        onLogoClick(e, "custom");
        if (isOnHomePage && isCustomLogoBehaviorEnabled) {
            const companyQuery = remoteAdminSettings.customLogoCompanyQuery?.trim();
            const companyLink = remoteAdminSettings.customLogoCompanyLink?.trim();
            if (companyQuery && isRovoLLMEnabled) {
                navigateToChatWithPrompt(companyQuery);
                return;
            } else if (companyLink) {
                window.parent.location.href = companyLink;
                return;
            }
        }
        navigateToHome();
    };
    const { data: logoFileData, isLoading: isLoading } = (0, $2vAyx.useNtpThemeFile)({
        siteId: site.workspace.cloudId,
        fileType: (0, $lHN9r.ThemeFileType).LOGO,
        s3Etag: s3Etag
    });
    const [isImageLoaded, setIsImageLoaded] = (0, $4tluv.useState)(false);
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).Fragment, null);
    if (!logoFileData?.url) // Fallback on default
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement($20e2344e7517fc5c$var$DefaultCompanyIcon, {
        isRovoLLMEnabled: isRovoLLMEnabled,
        onLogoClick: onLogoClick
    });
    const ImageComponent = (props)=>isImageLoaded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $9KBmj.default), {
            alt: formatMessage((0, $e9vmu.messages).companyLogoAlt),
            src: logoFileData.url,
            style: {
                height: "var(--ds-space-300, 24px)"
            },
            ...props
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $9KBmj.default), {
            alt: formatMessage((0, $e9vmu.messages).companyLogoAlt),
            onLoad: ()=>setIsImageLoaded(true),
            src: logoFileData.url,
            style: {
                display: "none"
            },
            ...props
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $2X3dI.default), {
        "aria-label": formatMessage((0, $e9vmu.messages).homeLabel),
        href: "/extension",
        onClick: handleCustomLogoClick,
        xcss: $20e2344e7517fc5c$var$logoStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement(ImageComponent, null));
};

});
parcelRegister("2vAyx", function(module, exports) {
$parcel$export(module.exports, "ThemeValidationError", () => $4b1b5a4456d678f2$export$a8709ca93ec22f7a);
$parcel$export(module.exports, "uploadThemeImage", () => $4b1b5a4456d678f2$export$669ef9f41d56c75f);
$parcel$export(module.exports, "deleteThemeImage", () => $4b1b5a4456d678f2$export$8468f01ff043a3ba);
$parcel$export(module.exports, "updateThemeImage", () => $4b1b5a4456d678f2$export$e33cd16006ce448e);
$parcel$export(module.exports, "useNtpThemeFileMetadata", () => $4b1b5a4456d678f2$export$be984cb06a349554);
$parcel$export(module.exports, "useNtpThemeFile", () => $4b1b5a4456d678f2$export$64eb611b14b2dff3);

var $dD8yb = parcelRequire("dD8yb");

var $9aNsE = parcelRequire("9aNsE");

var $lHN9r = parcelRequire("lHN9r");
class $4b1b5a4456d678f2$export$a8709ca93ec22f7a extends Error {
    constructor(message){
        super(message);
        this.name = "ThemeValidationError";
        this.type = (0, $lHN9r.ThemeErrorType).VALIDATION_ERROR;
        // ES5 does not fully support subclassing built-in types, instanceof operator doesn't function as expected for custom classes that extend built-in types like Error.
        // Explicitly setting prototype ensures instanceof correctly identifies instances of custom class and its superclasses
        Object.setPrototypeOf(this, $4b1b5a4456d678f2$export$a8709ca93ec22f7a.prototype);
    }
}
async function $4b1b5a4456d678f2$export$669ef9f41d56c75f({ file: file, fileType: fileType, siteId: siteId }) {
    if (!Object.values((0, $lHN9r.AllowedImageType)).includes(file.type)) throw new $4b1b5a4456d678f2$export$a8709ca93ec22f7a("File must be PNG, JPEG, or GIF");
    const formData = new FormData();
    formData.append("file", file);
    const response = await (0, $9aNsE.request)({
        url: `gateway/api/assist/rovo/v1/extension/theme/file/${fileType}`,
        options: {
            method: (0, $9aNsE.HTTPMethod).POST,
            credentials: "include",
            extraHeaders: new Headers({
                "X-Product": "rovo",
                "X-Experience-Id": "ai-mate",
                "X-Cloudid": siteId
            }),
            body: formData
        }
    });
    return response;
}
async function $4b1b5a4456d678f2$export$8468f01ff043a3ba({ fileType: fileType, siteId: siteId }) {
    await (0, $9aNsE.request)({
        url: `gateway/api/assist/rovo/v1/extension/theme/file/${fileType}`,
        options: {
            method: (0, $9aNsE.HTTPMethod).DELETE,
            credentials: "include",
            extraHeaders: new Headers({
                "X-Product": "rovo",
                "X-Experience-Id": "ai-mate",
                "X-Cloudid": siteId
            })
        }
    });
}
async function $4b1b5a4456d678f2$export$e33cd16006ce448e({ file: file, fileType: fileType, siteId: siteId }) {
    if (!Object.values((0, $lHN9r.AllowedImageType)).includes(file.type)) throw new $4b1b5a4456d678f2$export$a8709ca93ec22f7a("File must be PNG, JPEG, or GIF");
    const formData = new FormData();
    formData.append("file", file);
    const response = await (0, $9aNsE.request)({
        url: `gateway/api/assist/rovo/v1/extension/theme/file/${fileType}`,
        options: {
            method: (0, $9aNsE.HTTPMethod).PUT,
            credentials: "include",
            extraHeaders: new Headers({
                "X-Product": "rovo",
                "X-Experience-Id": "ai-mate",
                "X-Cloudid": siteId
            }),
            body: formData
        }
    });
    return response;
}
async function $4b1b5a4456d678f2$var$getNtpThemeFileMetadata(siteId) {
    const response = await (0, $9aNsE.request)({
        url: "gateway/api/assist/rovo/v1/extension/theme/file/metadata",
        options: {
            method: "GET",
            credentials: "include",
            extraHeaders: new Headers({
                "X-Product": "rovo",
                "X-Experience-Id": "ai-mate",
                "X-Cloudid": siteId
            })
        }
    });
    return response;
}
function $4b1b5a4456d678f2$export$be984cb06a349554({ siteId: siteId }) {
    const queryFn = ()=>$4b1b5a4456d678f2$var$getNtpThemeFileMetadata(siteId);
    return (0, $dD8yb.useQuery)({
        queryKey: [
            "getNtpThemeFileMetadata",
            siteId
        ],
        queryFn: queryFn,
        refetchOnWindowFocus: false,
        enabled: true
    });
}
async function $4b1b5a4456d678f2$var$getNtpThemeFile({ siteId: siteId, fileType: fileType, s3Etag: s3Etag }) {
    const response = await (0, $9aNsE.request)({
        url: `gateway/api/assist/rovo/v1/extension/theme/file/${fileType}`,
        options: {
            method: "GET",
            credentials: "include",
            extraHeaders: new Headers({
                "Content-Type": "image",
                "X-Product": "rovo",
                "X-Experience-Id": "ai-mate",
                "X-Cloudid": siteId,
                "X-ETag": s3Etag
            })
        }
    });
    const reader = response.body.getReader();
    const chunks = [];
    const blob = await reader.read().then(async function process({ done: done, value: value }) {
        if (done) return new Blob(chunks);
        chunks.push(value);
        return reader.read().then(process);
    });
    const url = URL.createObjectURL(blob);
    return {
        url: url
    };
}
function $4b1b5a4456d678f2$export$64eb611b14b2dff3({ siteId: siteId, fileType: fileType, s3Etag: s3Etag }) {
    return (0, $dD8yb.useQuery)({
        queryKey: [
            "getNtpThemeFile",
            siteId,
            fileType,
            s3Etag
        ],
        queryFn: ()=>$4b1b5a4456d678f2$var$getNtpThemeFile({
                siteId: siteId,
                fileType: fileType,
                s3Etag: s3Etag
            }),
        refetchOnWindowFocus: false
    });
}

});
parcelRegister("lHN9r", function(module, exports) {
$parcel$export(module.exports, "ThemeFileType", () => $5b5dd0d32edc83ba$export$dd66fc48c3b68388);
$parcel$export(module.exports, "AllowedImageType", () => $5b5dd0d32edc83ba$export$efe490cbd0256876);
$parcel$export(module.exports, "ThemeErrorType", () => $5b5dd0d32edc83ba$export$bea1b160bc7d7c5b);
var $5b5dd0d32edc83ba$export$dd66fc48c3b68388 = /*#__PURE__*/ function(ThemeFileType) {
    ThemeFileType["BACKGROUND"] = "BACKGROUND";
    ThemeFileType["DARK_BACKGROUND"] = "DARKBACKGROUND";
    ThemeFileType["LOGO"] = "LOGO";
    return ThemeFileType;
}({});
var $5b5dd0d32edc83ba$export$efe490cbd0256876 = /*#__PURE__*/ function(AllowedImageType) {
    AllowedImageType["PNG"] = "image/png";
    AllowedImageType["JPEG"] = "image/jpeg";
    AllowedImageType["GIF"] = "image/gif";
    return AllowedImageType;
}({});
var $5b5dd0d32edc83ba$export$bea1b160bc7d7c5b = /*#__PURE__*/ function(ThemeErrorType) {
    ThemeErrorType["VALIDATION_ERROR"] = "VALIDATION_ERROR";
    return ThemeErrorType;
}({});

});


parcelRegister("e9vmu", function(module, exports) {
$parcel$export(module.exports, "messages", () => $8c5952f9266aa28d$export$defe85febe8b728c);

var $38Fhe = parcelRequire("38Fhe");
const $8c5952f9266aa28d$export$defe85febe8b728c = (0, $38Fhe.defineMessages)({
    companyLogoAlt: {
        id: "rovo-extension.navigation.company-logo.alt",
        defaultMessage: "Company logo",
        description: "The text is used as the alt attribute for the company logo image shown in the top navigation bar of the Rovo new tab page when an organisation has configured their company branding."
    },
    homeLabel: {
        id: "rovo-extension.navigation.home.label",
        defaultMessage: "Home",
        description: "The text is used as an aria-label or visible label for the Home navigation item in the top navigation bar of the Rovo extension, which takes the user back to the main new tab page."
    },
    siteNavigationLabel: {
        id: "rovo-extension.navigation.site.label",
        defaultMessage: "site",
        description: "Label for site navigation component. Label is used for screenreaders only, not rendered in UI. Here, site refers to the Atlassian organization the user is on."
    },
    siteIconLabel: {
        id: "rovo-extension.navigation.site-icon.label",
        defaultMessage: "site",
        description: "Label for site icon in site switcher. Label is used for screenreaders only, not rendered in UI. Here, site refers to the Atlassian organization the user is on. Icon is the ADS office building icon."
    },
    appSwitcherTooltip: {
        id: "rovo-extension.navigation.app-switcher.tooltip",
        defaultMessage: "Switch to...",
        description: "The text is shown as a tooltip on the app switcher icon button in the top navigation bar of the Rovo extension, indicating that clicking it will allow the user to switch between Atlassian products."
    }
});

});

parcelRegister("kvcqg", function(module, exports) {
$parcel$export(module.exports, "useExtensionNavigation", () => $5ff1dabdd9a7cbf0$export$525656442beacd31);
parcelRequire("3mxm3");
var $bfivG = parcelRequire("bfivG");

var $bI4fx = parcelRequire("bI4fx");
// Capture the initial pathname at module load time (before React Router changes it)
let $5ff1dabdd9a7cbf0$var$initialPathname = typeof window !== "undefined" ? window.location.pathname : "/extension";
function $5ff1dabdd9a7cbf0$export$a7b3e8fb508d50bd(pathname) {
    $5ff1dabdd9a7cbf0$var$initialPathname = pathname;
}
function $5ff1dabdd9a7cbf0$export$1f865db7b7fcff3f() {
    return $5ff1dabdd9a7cbf0$var$initialPathname === "/extension";
}
function $5ff1dabdd9a7cbf0$export$525656442beacd31() {
    const navigate = (0, $bfivG.useNavigate)();
    const navigateToHome = ()=>{
        if ($5ff1dabdd9a7cbf0$export$1f865db7b7fcff3f()) navigate("/extension");
        else // In non-NTP contexts (like options), ask the parent page to open the NTP via full page refresh.
        // This is necessary to ensure we properly initialize window message event listeners via ntp.js
        (0, $bI4fx.postMessageToParent)({
            type: "NAVIGATE_TO_HOME"
        });
    };
    const navigateToOptionsPage = ()=>{
        navigate("/extension/options");
    };
    const navigateToChat = ()=>{
        navigate("/extension/rovo-chat?fullPageChat=true");
    };
    const navigateToChatWithPrompt = (prompt)=>{
        const encodedPrompt = encodeURIComponent(prompt);
        navigate(`/extension/rovo-chat?rovoChatPathway=chat&rovoChatPrompt=${encodedPrompt}&fullPageChat=true`);
    };
    return {
        navigateToHome: navigateToHome,
        navigateToOptionsPage: navigateToOptionsPage,
        navigateToChat: navigateToChat,
        navigateToChatWithPrompt: navigateToChatWithPrompt
    };
}

});

parcelRegister("056A9", function(module, exports) {
$parcel$export(module.exports, "useQueryInvalidationBroadcast", () => $3555b665f89f05cf$export$8e80384d8b3de2d);

var $4tluv = parcelRequire("4tluv");

var $4cZqh = parcelRequire("4cZqh");

var $22hwD = parcelRequire("22hwD");
const $3555b665f89f05cf$var$CHANNEL_NAME = "query-cache-invalidation";
function $3555b665f89f05cf$export$8e80384d8b3de2d(queryKey, listen = false) {
    const queryClient = (0, $4cZqh.useQueryClient)();
    const queryKeyRef = (0, $4tluv.useRef)(queryKey);
    const channelRef = (0, $4tluv.useRef)(null);
    // Keep queryKey ref updated
    (0, $4tluv.useEffect)(()=>{
        queryKeyRef.current = queryKey;
    }, [
        queryKey
    ]);
    // Set up listener for invalidation messages from other tabs
    (0, $4tluv.useEffect)(()=>{
        if (!listen) return;
        try {
            channelRef.current = new BroadcastChannel($3555b665f89f05cf$var$CHANNEL_NAME);
        } catch (error) {
            (0, $22hwD.logError)({
                error: error,
                impact: "Failed to create BroadcastChannel for query invalidation",
                extra: {
                    channelName: $3555b665f89f05cf$var$CHANNEL_NAME
                }
            });
            return;
        }
        const handleMessage = (event)=>{
            if (event.data.type === "INVALIDATE_QUERY" && Array.isArray(event.data.queryKey)) {
                // Check if this message is for our query key
                const messageKey = JSON.stringify(event.data.queryKey);
                const ourKey = JSON.stringify(queryKeyRef.current);
                if (messageKey === ourKey) queryClient.invalidateQueries({
                    queryKey: event.data.queryKey
                }).catch((error)=>{
                    (0, $22hwD.logError)({
                        error: error,
                        impact: "Failed to invalidate query cache from broadcast",
                        extra: {
                            queryKey: event.data.queryKey
                        }
                    });
                });
            }
        };
        channelRef.current.addEventListener("message", handleMessage);
        return ()=>{
            if (channelRef.current) {
                channelRef.current.removeEventListener("message", handleMessage);
                channelRef.current.close();
                channelRef.current = null;
            }
        };
    }, [
        listen,
        queryClient
    ]);
    // Function to broadcast invalidation to other tabs
    const broadcastInvalidation = (0, $4tluv.useCallback)(()=>{
        try {
            const channel = new BroadcastChannel($3555b665f89f05cf$var$CHANNEL_NAME);
            channel.postMessage({
                type: "INVALIDATE_QUERY",
                queryKey: queryKeyRef.current,
                timestamp: Date.now()
            });
            channel.close();
        } catch (error) {
            (0, $22hwD.logError)({
                error: error,
                impact: "Failed to broadcast query invalidation to other tabs",
                extra: {
                    queryKey: queryKeyRef.current
                }
            });
        }
    }, []);
    return {
        broadcastInvalidation: broadcastInvalidation
    };
}

});

parcelRegister("b0UAF", function(module, exports) {
$parcel$export(module.exports, "useEntitlementCheck", () => $7e5010d2d976a390$export$45b3e3e13efd78c7);

var $4tluv = parcelRequire("4tluv");

var $frEQt = parcelRequire("frEQt");

var $7Ywk8 = parcelRequire("7Ywk8");

var $4cZqh = parcelRequire("4cZqh");

var $bFW4F = parcelRequire("bFW4F");

var $1QYE6 = parcelRequire("1QYE6");

var $9JAaz = parcelRequire("9JAaz");

var $2bRmU = parcelRequire("2bRmU");
const $7e5010d2d976a390$var$errorState = {
    shownFlag: false
};
const $7e5010d2d976a390$export$45b3e3e13efd78c7 = ()=>{
    const { site: site } = (0, $1QYE6.useSite)();
    const { showFlag: showFlag } = (0, $frEQt.useFlags)();
    const queryClient = (0, $4cZqh.useQueryClient)();
    const { data: rovoEntitlement, error: error, isLoading: isLoading } = (0, $bFW4F.useRovoEntitlement)(site.workspace.cloudId);
    const { formatMessage: formatMessage } = (0, $7Ywk8.default)();
    (0, $4tluv.useEffect)(()=>{
        if (error && !$7e5010d2d976a390$var$errorState.shownFlag) {
            $7e5010d2d976a390$var$errorState.shownFlag = true;
            showFlag({
                title: formatMessage((0, $2bRmU.messages).entitlementCheckFailedFlagTitle),
                description: formatMessage((0, $2bRmU.messages).entitlementCheckFailedFlagDescription),
                appearance: "error",
                actions: [
                    {
                        content: formatMessage((0, $2bRmU.messages).entitlementCheckFailedFlagAction),
                        onClick: async ()=>{
                            await queryClient.invalidateQueries({
                                queryKey: [
                                    "rovoEntitlement",
                                    site.workspace.cloudId
                                ]
                            });
                            window.location.reload();
                        }
                    }
                ]
            });
        }
    }, [
        error,
        showFlag,
        queryClient,
        site.workspace.cloudId,
        formatMessage
    ]);
    (0, $4tluv.useEffect)(()=>{
        if (rovoEntitlement) (0, $9JAaz.broadcastEntitlementToExtension)(rovoEntitlement.isRovoLLMEnabled);
    }, [
        rovoEntitlement
    ]);
    return {
        isRovoLLMEnabled: rovoEntitlement?.isRovoLLMEnabled ?? false,
        isLoading: isLoading
    };
};

});
parcelRegister("9JAaz", function(module, exports) {
$parcel$export(module.exports, "broadcastConfigToExtension", () => $f02ad6548406da52$export$19d3f038df2cba24);
$parcel$export(module.exports, "broadcastEntitlementToExtension", () => $f02ad6548406da52$export$efabda5991991ee8);

var $bI4fx = parcelRequire("bI4fx");
function $f02ad6548406da52$export$19d3f038df2cba24(site) {
    (0, $bI4fx.postMessageToParent)({
        type: "SITE_DATA_UPDATE",
        value: site && {
            baseUrl: site.defaultSiteBaseUrl,
            cloudId: site.workspace.cloudId,
            orgId: site.workspace.organisationId
        }
    });
}
function $f02ad6548406da52$export$efabda5991991ee8(isRovoLLMEnabled) {
    (0, $bI4fx.postMessageToParent)({
        type: "ENTITLEMENT_DATA_UPDATE",
        value: {
            isRovoLLMEnabled: isRovoLLMEnabled
        }
    });
}
function $f02ad6548406da52$export$2764600b87a6588d(a, b) {
    if (!a && !b) return true;
    if (!a || !b) return false;
    return a.workspace.cloudId === b.workspace.cloudId && a.workspace.organisationId === b.workspace.organisationId && a.defaultSiteBaseUrl === b.defaultSiteBaseUrl;
}
function $f02ad6548406da52$export$dd6ffe7a6a2a2431(a, b) {
    return a === b || a?.cloudId === b?.workspace.cloudId && a?.orgId === b?.workspace.organisationId && a?.baseUrl === b?.defaultSiteBaseUrl;
}

});

parcelRegister("2bRmU", function(module, exports) {
$parcel$export(module.exports, "messages", () => $280c5846829aee26$export$defe85febe8b728c);

var $38Fhe = parcelRequire("38Fhe");
const $280c5846829aee26$export$defe85febe8b728c = (0, $38Fhe.defineMessages)({
    entitlementCheckFailedFlagTitle: {
        id: "rovo-extension.hook.entitlement-check-failed-flag-title",
        defaultMessage: "Failed to retrieve Rovo access",
        description: "Title for the entitlement check failed flag"
    },
    entitlementCheckFailedFlagDescription: {
        id: "rovo-extension.hook.entitlement-check-failed-flag-description",
        defaultMessage: "Something went wrong when checking your access to Rovo. Click 'Try again' to access AI chat.",
        description: "Description for the entitlement check failed flag"
    },
    entitlementCheckFailedFlagAction: {
        id: "rovo-extension.hook.entitlement-check-failed-flag-action",
        defaultMessage: "Try again",
        description: "Action for the entitlement check failed flag"
    }
});

});


parcelRegister("jMN8E", function(module, exports) {
$parcel$export(module.exports, "SettingsProvider", () => (parcelRequire("hZQIF")).SettingsProvider);
$parcel$export(module.exports, "useSettings", () => (parcelRequire("hZQIF")).useSettings);

var $hZQIF = parcelRequire("hZQIF");

});
parcelRegister("hZQIF", function(module, exports) {
$parcel$export(module.exports, "SettingsProvider", () => $cdf5305077045ce8$export$e134aa690da9cc14);
$parcel$export(module.exports, "useSettings", () => $cdf5305077045ce8$export$9115b42802a3e44f);

var $4tluv = parcelRequire("4tluv");

var $2kUCE = parcelRequire("2kUCE");
var $dD8yb = parcelRequire("dD8yb");
var $4cZqh = parcelRequire("4cZqh");

var $crLv5 = parcelRequire("crLv5");

var $1QYE6 = parcelRequire("1QYE6");

var $22hwD = parcelRequire("22hwD");

var $bI4fx = parcelRequire("bI4fx");

var $bFW4F = parcelRequire("bFW4F");

var $9feau = parcelRequire("9feau");
parcelRequire("cDuOd");
var $fgIUF = parcelRequire("fgIUF");

var $gLHVH = parcelRequire("gLHVH");

var $id9ES = parcelRequire("id9ES");
var $cdf5305077045ce8$export$422cbc209f7199c9 = /*#__PURE__*/ function(SettingsQueryKeys) {
    SettingsQueryKeys["REMOTE_ADMIN_SETTINGS"] = "remoteAdminSettings";
    return SettingsQueryKeys;
}({});
/**
 * Checks chrome.storage.local for cached remote admin settings via message bus
 */ function $cdf5305077045ce8$var$getCachedRemoteAdminSettings(siteId) {
    return new Promise((resolve)=>{
        const timeoutId = setTimeout(()=>{
            window.removeEventListener("message", messageHandler);
            resolve(null);
        }, 2000);
        const messageHandler = (event)=>{
            if (event.data.type === "GET_REMOTE_ADMIN_SETTINGS_CACHE_RESPONSE") {
                clearTimeout(timeoutId);
                window.removeEventListener("message", messageHandler);
                resolve(event.data.data);
            }
        };
        window.addEventListener("message", messageHandler, false);
        (0, $bI4fx.postMessageToParent)({
            type: "GET_REMOTE_ADMIN_SETTINGS_CACHE",
            siteId: siteId
        });
    });
}
/**
 * Updates the chrome.storage.local cache with new settings
 */ function $cdf5305077045ce8$var$setCachedRemoteAdminSettings(siteId, settings) {
    (0, $bI4fx.postMessageToParent)({
        type: "SET_REMOTE_ADMIN_SETTINGS_CACHE",
        siteId: siteId,
        settings: settings
    });
}
/**
 * Clears the chrome.storage.local cache to force a fresh API fetch
 * Returns a promise that resolves after a short delay to allow the message to be processed
 */ function $cdf5305077045ce8$var$clearCachedRemoteAdminSettings(siteId) {
    (0, $bI4fx.postMessageToParent)({
        type: "CLEAR_REMOTE_ADMIN_SETTINGS_CACHE",
        siteId: siteId
    });
    // Wait a short time for the message to be processed by the parent
    return new Promise((resolve)=>setTimeout(resolve, 100));
}
/**
 * Fetches remote admin settings with chrome.storage.local caching
 */ async function $cdf5305077045ce8$var$fetchRemoteAdminSettingsWithCache(siteId) {
    const cachedData = await $cdf5305077045ce8$var$getCachedRemoteAdminSettings(siteId);
    if (cachedData !== null) return cachedData;
    const freshData = await (0, $bFW4F.getRovoExtensionAdminSettings)(siteId);
    $cdf5305077045ce8$var$setCachedRemoteAdminSettings(siteId, freshData);
    return freshData;
}
const $cdf5305077045ce8$var$SettingsContext = /*#__PURE__*/ (0, $4tluv.createContext)(undefined);
const $cdf5305077045ce8$export$e134aa690da9cc14 = ({ children: children })=>{
    const isSettingsAdminSiteControlsEnabled = (0, $crLv5.isSettingsAdminSiteControlsExperimentEnabled)();
    const [chromeStoredSettings, setChromeStoredSettings] = (0, $4tluv.useState)((0, $id9ES.DEFAULT_CHROME_STORED_SETTINGS));
    (0, $4tluv.useEffect)(()=>{
        if (!isSettingsAdminSiteControlsEnabled) return;
        const messageHandler = (event)=>{
            switch(event.data.type){
                case "GET_OPTIONS_RESPONSE":
                case "SET_OPTIONS_RESPONSE":
                    setChromeStoredSettings((prev)=>({
                            ...prev,
                            ...event.data.options
                        }));
                    break;
                default:
                    break;
            }
        };
        window.addEventListener("message", messageHandler, false);
        (0, $bI4fx.postMessageToParent)({
            type: "GET_OPTIONS"
        });
        return ()=>{
            window.removeEventListener("message", messageHandler);
        };
    }, [
        isSettingsAdminSiteControlsEnabled
    ]);
    const updateChromeStoredSetting = (0, $4tluv.useCallback)((params)=>{
        if (!isSettingsAdminSiteControlsEnabled) return;
        setChromeStoredSettings((prev)=>({
                ...prev,
                [params.key]: params.value
            }));
        (0, $bI4fx.postMessageToParent)({
            type: "SET_OPTIONS",
            updated: {
                [params.key]: params.value
            }
        });
    }, [
        isSettingsAdminSiteControlsEnabled
    ]);
    const [welcomeHeaderEnabled, setWelcomeHeaderEnabled] = (0, $gLHVH.useStateWithSync)((0, $fgIUF.LocalStorageKey).WELCOME_HEADER_ENABLED, true, isSettingsAdminSiteControlsEnabled);
    const [globalCreateEnabled, setGlobalCreateEnabled] = (0, $gLHVH.useStateWithSync)((0, $fgIUF.LocalStorageKey).GLOBAL_CREATE_ENABLED, true, isSettingsAdminSiteControlsEnabled);
    const [localDevBannerEnabled, setLocalDevBannerEnabled] = (0, $gLHVH.useStateWithSync)((0, $fgIUF.LocalStorageKey).LOCAL_DEV_BANNER_ENABLED, true, isSettingsAdminSiteControlsEnabled);
    const [calendarEnabled, setCalendarEnabled] = (0, $gLHVH.useStateWithSync)((0, $fgIUF.LocalStorageKey).CALENDAR_ENABLED, false, isSettingsAdminSiteControlsEnabled);
    const [recentWorkEnabled, setRecentWorkEnabled] = (0, $gLHVH.useStateWithSync)((0, $fgIUF.LocalStorageKey).RECENT_WORK_ENABLED, true, isSettingsAdminSiteControlsEnabled);
    const [bookmarksEnabled, setBookmarksEnabled] = (0, $gLHVH.useStateWithSync)((0, $fgIUF.LocalStorageKey).BOOKMARKS_ENABLED, true, isSettingsAdminSiteControlsEnabled);
    const [announcementsEnabled, setAnnouncementsEnabled] = (0, $gLHVH.useStateWithSync)((0, $fgIUF.LocalStorageKey).ANNOUNCEMENTS_ENABLED, true, isSettingsAdminSiteControlsEnabled);
    const localStoredSettings = (0, $4tluv.useMemo)(()=>({
            [(0, $fgIUF.LocalStorageKey).WELCOME_HEADER_ENABLED]: welcomeHeaderEnabled,
            [(0, $fgIUF.LocalStorageKey).GLOBAL_CREATE_ENABLED]: globalCreateEnabled,
            [(0, $fgIUF.LocalStorageKey).LOCAL_DEV_BANNER_ENABLED]: localDevBannerEnabled,
            [(0, $fgIUF.LocalStorageKey).CALENDAR_ENABLED]: calendarEnabled,
            [(0, $fgIUF.LocalStorageKey).RECENT_WORK_ENABLED]: recentWorkEnabled,
            [(0, $fgIUF.LocalStorageKey).BOOKMARKS_ENABLED]: bookmarksEnabled,
            [(0, $fgIUF.LocalStorageKey).ANNOUNCEMENTS_ENABLED]: announcementsEnabled
        }), [
        welcomeHeaderEnabled,
        globalCreateEnabled,
        localDevBannerEnabled,
        calendarEnabled,
        recentWorkEnabled,
        bookmarksEnabled,
        announcementsEnabled
    ]);
    const updateLocalStoredSetting = (0, $4tluv.useCallback)((params)=>{
        // Consumers must gate usage; keep this safe even if accidentally called.
        if (!isSettingsAdminSiteControlsEnabled) return;
        switch(params.key){
            case (0, $fgIUF.LocalStorageKey).WELCOME_HEADER_ENABLED:
                setWelcomeHeaderEnabled(params.value);
                return;
            case (0, $fgIUF.LocalStorageKey).GLOBAL_CREATE_ENABLED:
                setGlobalCreateEnabled(params.value);
                return;
            case (0, $fgIUF.LocalStorageKey).LOCAL_DEV_BANNER_ENABLED:
                setLocalDevBannerEnabled(params.value);
                return;
            case (0, $fgIUF.LocalStorageKey).CALENDAR_ENABLED:
                setCalendarEnabled(params.value);
                return;
            case (0, $fgIUF.LocalStorageKey).RECENT_WORK_ENABLED:
                setRecentWorkEnabled(params.value);
                return;
            case (0, $fgIUF.LocalStorageKey).BOOKMARKS_ENABLED:
                setBookmarksEnabled(params.value);
                return;
            case (0, $fgIUF.LocalStorageKey).ANNOUNCEMENTS_ENABLED:
                setAnnouncementsEnabled(params.value);
                return;
            default:
                return;
        }
    }, [
        isSettingsAdminSiteControlsEnabled,
        setWelcomeHeaderEnabled,
        setGlobalCreateEnabled,
        setLocalDevBannerEnabled,
        setCalendarEnabled,
        setRecentWorkEnabled,
        setBookmarksEnabled,
        setAnnouncementsEnabled
    ]);
    const siteContext = (0, $1QYE6.useSite)({
        allowUndefined: true
    });
    const siteId = siteContext ? siteContext.site.workspace.cloudId : undefined;
    const queryClient = (0, $4cZqh.useQueryClient)();
    const [remoteAdminSettingsMutationError, setRemoteAdminSettingsMutationError] = (0, $4tluv.useState)(null);
    const { data: remoteAdminSettings = (0, $id9ES.DEFAULT_REMOTE_ADMIN_SETTINGS), isLoading: isLoadingRemoteAdminSettings, error: queryErrorRaw } = (0, $dD8yb.useQuery)({
        queryKey: [
            "remoteAdminSettings",
            siteId
        ],
        queryFn: ()=>{
            if (!siteId) throw new Error("siteId is required to fetch remote admin settings");
            return $cdf5305077045ce8$var$fetchRemoteAdminSettingsWithCache(siteId);
        },
        enabled: isSettingsAdminSiteControlsEnabled && !!siteId,
        staleTime: 60000,
        // Re-check chrome.storage to hand off caching decisions
        gcTime: Infinity,
        refetchOnWindowFocus: false,
        retry: 1,
        throwOnError: false
    });
    const previousErrorRef = (0, $4tluv.useRef)(null);
    // Handle error logging once when error state changes
    (0, $4tluv.useEffect)(()=>{
        if (queryErrorRaw && queryErrorRaw !== previousErrorRef.current) {
            (0, $22hwD.logError)({
                error: queryErrorRaw,
                impact: "Failed to fetch remote admin settings"
            });
            previousErrorRef.current = queryErrorRaw;
        }
    }, [
        queryErrorRaw
    ]);
    const remoteAdminSettingsQueryError = (0, $4tluv.useMemo)(()=>{
        if (!queryErrorRaw) return null;
        return new (0, $9feau.RemoteAdminSettingsError)({
            type: (0, $9feau.RemoteAdminSettingsErrorType).QUERY_ERROR,
            originalError: queryErrorRaw
        });
    }, [
        queryErrorRaw
    ]);
    const mutation = (0, $2kUCE.useMutation)({
        mutationFn: async (data)=>{
            if (!siteId) throw new Error("siteId is required to update remote admin settings");
            return (0, $bFW4F.saveRovoExtensionAdminSettings)(siteId, data);
        },
        onMutate: async (newData)=>{
            // Cancel any outgoing refetches to avoid overwriting optimistic update
            await queryClient.cancelQueries({
                queryKey: [
                    "remoteAdminSettings",
                    siteId
                ]
            });
            // Snapshot the previous value.
            // NOTE: React Query cache may be empty on first load; keep a concrete fallback so we can always rollback.
            const previousSettingsFromCache = queryClient.getQueryData([
                "remoteAdminSettings",
                siteId
            ]);
            const previousSettings = previousSettingsFromCache ?? (0, $id9ES.DEFAULT_REMOTE_ADMIN_SETTINGS);
            // Optimistically update to the new value
            const optimisticSettings = {
                ...previousSettings,
                ...newData
            };
            queryClient.setQueryData([
                "remoteAdminSettings",
                siteId
            ], optimisticSettings);
            // Return context with the previous value for rollback
            return {
                previousSettings: previousSettings
            };
        },
        onError: (originalError, newData, context)=>{
            // Rollback to previous value on error
            queryClient.setQueryData([
                "remoteAdminSettings",
                siteId
            ], context?.previousSettings ?? (0, $id9ES.DEFAULT_REMOTE_ADMIN_SETTINGS));
            const settingKey = Object.keys(newData)[0];
            const error = new (0, $9feau.RemoteAdminSettingsError)({
                type: (0, $9feau.RemoteAdminSettingsErrorType).MUTATION_ERROR,
                originalError: originalError,
                context: {
                    settingKey: settingKey,
                    attemptedValue: Object.values(newData)[0],
                    previousValue: context?.previousSettings?.[settingKey]
                }
            });
            setRemoteAdminSettingsMutationError(error);
            (0, $22hwD.logError)({
                error: originalError,
                impact: "Failed to update remote admin settings"
            });
        },
        onSuccess: (data)=>{
            // Update chrome.storage.local so other tabs immediately see the new settings
            if (siteId) $cdf5305077045ce8$var$setCachedRemoteAdminSettings(siteId, data);
        },
        onSettled: ()=>{
            // Refetch to ensure we have the latest data
            queryClient.invalidateQueries({
                queryKey: [
                    "remoteAdminSettings",
                    siteId
                ]
            });
        }
    });
    const updateRemoteAdminSettings = (0, $4tluv.useCallback)(async (params)=>{
        if (!isSettingsAdminSiteControlsEnabled || !siteId) return;
        // Clear previous mutation error when starting a new mutation
        setRemoteAdminSettingsMutationError(null);
        try {
            await mutation.mutateAsync({
                [params.key]: params.value
            });
        } catch  {
        // Error is handled by onError callback, but we need to catch it here
        // to prevent unhandled promise rejection
        }
    }, [
        isSettingsAdminSiteControlsEnabled,
        siteId,
        mutation
    ]);
    const refreshRemoteAdminSettings = (0, $4tluv.useCallback)(async ()=>{
        if (!isSettingsAdminSiteControlsEnabled || !siteId) return;
        // Step 1: Clear chrome.storage.local cache and wait for it to be processed
        await $cdf5305077045ce8$var$clearCachedRemoteAdminSettings(siteId);
        // Step 2: Invalidate React Query state, triggering a refetch
        await queryClient.invalidateQueries({
            queryKey: [
                "remoteAdminSettings",
                siteId
            ]
        });
    }, [
        isSettingsAdminSiteControlsEnabled,
        siteId,
        queryClient
    ]);
    const effectiveRemoteAdminSettings = (0, $4tluv.useMemo)(()=>({
            ...(0, $id9ES.DEFAULT_REMOTE_ADMIN_SETTINGS),
            ...remoteAdminSettings
        }), [
        remoteAdminSettings
    ]);
    const syncAdminControlledFeaturesToChrome = (0, $4tluv.useCallback)((settings)=>{
        const definitionsAppEnabled = settings.controlledUserGdocsDefinitionsEnabled !== false;
        (0, $bI4fx.postMessageToParent)({
            type: "SET_ADMIN_CONTROLLED_FEATURES",
            features: {
                definitionsAppEnabled: definitionsAppEnabled
            }
        });
    }, []);
    (0, $4tluv.useEffect)(()=>{
        if (isLoadingRemoteAdminSettings) return;
        syncAdminControlledFeaturesToChrome(effectiveRemoteAdminSettings);
    }, [
        effectiveRemoteAdminSettings,
        isLoadingRemoteAdminSettings,
        syncAdminControlledFeaturesToChrome
    ]);
    const previousControlledUserNtpEnabledRef = (0, $4tluv.useRef)(undefined);
    const previousControlledUserCompanionEnabledRef = (0, $4tluv.useRef)(undefined);
    const previousControlledUserCompanyAnnouncementsRef = (0, $4tluv.useRef)(undefined);
    (0, $4tluv.useEffect)(()=>{
        if (isLoadingRemoteAdminSettings) return;
        const currentNtp = effectiveRemoteAdminSettings.controlledUserNtpEnabled;
        const previousNtp = previousControlledUserNtpEnabledRef.current;
        // Admin disables NTP for all users (transition to false)
        if (currentNtp === false && previousNtp !== false) (0, $bI4fx.postMessageToParent)({
            type: "SET_OPTIONS",
            updated: {
                ntpEnabled: false
            }
        });
        // Admin re-enables NTP for all users (false -> true/undefined)
        if (previousNtp === false && currentNtp !== false) (0, $bI4fx.postMessageToParent)({
            type: "SET_OPTIONS",
            updated: {
                ntpEnabled: (0, $id9ES.DEFAULT_USER_SETTINGS).ntpEnabled
            }
        });
        previousControlledUserNtpEnabledRef.current = currentNtp;
    }, [
        effectiveRemoteAdminSettings.controlledUserNtpEnabled,
        isLoadingRemoteAdminSettings
    ]);
    (0, $4tluv.useEffect)(()=>{
        if (isLoadingRemoteAdminSettings) return;
        const currentCompanion = effectiveRemoteAdminSettings.controlledUserRovoCompanionEnabled;
        const previousCompanion = previousControlledUserCompanionEnabledRef.current;
        // Admin disables Companion for all users (transition to false)
        if (currentCompanion === false && previousCompanion !== false) (0, $bI4fx.postMessageToParent)({
            type: "SET_OPTIONS",
            updated: {
                rovoCompanionEnabled: false
            }
        });
        // Admin re-enables Companion for all users (false -> true/undefined)
        if (previousCompanion === false && currentCompanion !== false) (0, $bI4fx.postMessageToParent)({
            type: "SET_OPTIONS",
            updated: {
                rovoCompanionEnabled: (0, $id9ES.DEFAULT_USER_SETTINGS).rovoCompanionEnabled
            }
        });
        previousControlledUserCompanionEnabledRef.current = currentCompanion;
    }, [
        effectiveRemoteAdminSettings.controlledUserRovoCompanionEnabled,
        isLoadingRemoteAdminSettings
    ]);
    (0, $4tluv.useEffect)(()=>{
        if (isLoadingRemoteAdminSettings) return;
        const currentAnnouncements = effectiveRemoteAdminSettings.controlledUserCompanyAnnouncements;
        const previousAnnouncements = previousControlledUserCompanyAnnouncementsRef.current;
        // Admin disables Company Announcements for all users (transition to false)
        if (currentAnnouncements === false && previousAnnouncements !== false) setAnnouncementsEnabled(false);
        // Admin re-enables Company Announcements for all users (false -> true/undefined)
        if (previousAnnouncements === false && currentAnnouncements !== false) setAnnouncementsEnabled((0, $id9ES.DEFAULT_LOCAL_STORED_SETTINGS)[(0, $fgIUF.LocalStorageKey).ANNOUNCEMENTS_ENABLED]);
        previousControlledUserCompanyAnnouncementsRef.current = currentAnnouncements;
    }, [
        effectiveRemoteAdminSettings.controlledUserCompanyAnnouncements,
        isLoadingRemoteAdminSettings,
        setAnnouncementsEnabled
    ]);
    const contextValue = (0, $4tluv.useMemo)(()=>({
            remoteAdminSettings: effectiveRemoteAdminSettings,
            updateRemoteAdminSettings: updateRemoteAdminSettings,
            refreshRemoteAdminSettings: refreshRemoteAdminSettings,
            isLoadingRemoteAdminSettings: isLoadingRemoteAdminSettings,
            remoteAdminSettingsQueryError: remoteAdminSettingsQueryError,
            remoteAdminSettingsMutationError: remoteAdminSettingsMutationError,
            localStoredSettings: localStoredSettings,
            updateLocalStoredSetting: updateLocalStoredSetting,
            chromeStoredSettings: chromeStoredSettings,
            updateChromeStoredSetting: updateChromeStoredSetting
        }), [
        effectiveRemoteAdminSettings,
        updateRemoteAdminSettings,
        refreshRemoteAdminSettings,
        isLoadingRemoteAdminSettings,
        remoteAdminSettingsQueryError,
        remoteAdminSettingsMutationError,
        localStoredSettings,
        updateLocalStoredSetting,
        chromeStoredSettings,
        updateChromeStoredSetting
    ]);
    // If feature gate is disabled, still provide context but with defaults
    if (!isSettingsAdminSiteControlsEnabled) {
        const defaultValue = {
            remoteAdminSettings: (0, $id9ES.DEFAULT_REMOTE_ADMIN_SETTINGS),
            updateRemoteAdminSettings: async ()=>{},
            refreshRemoteAdminSettings: async ()=>{},
            isLoadingRemoteAdminSettings: false,
            remoteAdminSettingsQueryError: null,
            remoteAdminSettingsMutationError: null,
            localStoredSettings: (0, $id9ES.DEFAULT_LOCAL_STORED_SETTINGS),
            updateLocalStoredSetting: ()=>{},
            chromeStoredSettings: (0, $id9ES.DEFAULT_CHROME_STORED_SETTINGS),
            updateChromeStoredSetting: ()=>{}
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement($cdf5305077045ce8$var$SettingsContext.Provider, {
            value: defaultValue
        }, children);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement($cdf5305077045ce8$var$SettingsContext.Provider, {
        value: contextValue
    }, children);
};
const $cdf5305077045ce8$export$9115b42802a3e44f = ()=>{
    const context = (0, $4tluv.useContext)($cdf5305077045ce8$var$SettingsContext);
    if (context === undefined) throw new Error("useSettings must be used within a SettingsProvider");
    return context;
};

});
parcelRegister("9feau", function(module, exports) {
$parcel$export(module.exports, "RemoteAdminSettingsErrorType", () => $7eda3013cc83a601$export$473f48a3ea5b378f);
$parcel$export(module.exports, "RemoteAdminSettingsError", () => $7eda3013cc83a601$export$26868db8586b4283);
var $7eda3013cc83a601$export$473f48a3ea5b378f = /*#__PURE__*/ function(RemoteAdminSettingsErrorType) {
    RemoteAdminSettingsErrorType["QUERY_ERROR"] = "QUERY_ERROR";
    RemoteAdminSettingsErrorType["MUTATION_ERROR"] = "MUTATION_ERROR";
    return RemoteAdminSettingsErrorType;
}({});
class $7eda3013cc83a601$export$26868db8586b4283 extends Error {
    constructor({ type: type, originalError: originalError, context: context }){
        super(originalError.message);
        this.name = "RemoteAdminSettingsError";
        this.type = type;
        this.originalError = originalError;
        this.timestamp = Date.now();
        this.context = context;
    }
}

});

parcelRegister("gLHVH", function(module, exports) {
$parcel$export(module.exports, "useStateWithSync", () => $095771bc639797f5$export$5d79a5c424614073);

var $4tluv = parcelRequire("4tluv");

var $22hwD = parcelRequire("22hwD");
function $095771bc639797f5$export$5d79a5c424614073(key, initialValue, isEnabled = true // TODO: remove this when flag is removed https://hello.jira.atlassian.cloud/browse/ASIMO-2163
) {
    // Create a unique channel name for this key
    const channelName = `state-sync-${key}`;
    const channelRef = (0, $4tluv.useRef)(null);
    // Helper function to safely parse JSON from localStorage
    const getStoredValue = (0, $4tluv.useCallback)(()=>{
        if (!isEnabled) return initialValue;
        try {
            const item = localStorage.getItem(key);
            if (item === null) return initialValue;
            return JSON.parse(item);
        } catch (error) {
            (0, $22hwD.logError)({
                error: error,
                impact: "useStateWithSync: Failed to parse localStorage value",
                extra: {
                    key: key
                }
            });
            return initialValue;
        }
    }, [
        key,
        initialValue,
        isEnabled
    ]);
    // Initialize state with value from localStorage or initialValue
    const [state, setState] = (0, $4tluv.useState)(getStoredValue);
    const setStoredValue = (0, $4tluv.useCallback)((value)=>{
        try {
            if (value === undefined) localStorage.removeItem(key);
            else localStorage.setItem(key, JSON.stringify(value));
        } catch (error) {
            (0, $22hwD.logError)({
                error: error,
                impact: "useStateWithSync: Failed to store value in localStorage",
                extra: {
                    key: key
                }
            });
        }
    }, [
        key
    ]);
    // Custom setter that updates both state and localStorage, and broadcasts the change
    const setStateWithSync = (0, $4tluv.useCallback)((value)=>{
        setState((prevState)=>{
            const newValue = typeof value === "function" ? value(prevState) : value;
            if (!isEnabled) return newValue;
            // Store in localStorage
            setStoredValue(newValue);
            // Broadcast the change to other tabs
            if (channelRef.current) try {
                channelRef.current.postMessage({
                    key: key,
                    value: newValue,
                    timestamp: Date.now()
                });
            } catch (error) {
                (0, $22hwD.logError)({
                    error: error,
                    impact: "useStateWithSync: Failed to broadcast message",
                    extra: {
                        key: key
                    }
                });
            }
            return newValue;
        });
    }, [
        key,
        setStoredValue,
        isEnabled
    ]);
    // Set up BroadcastChannel for cross-tab synchronization
    (0, $4tluv.useEffect)(()=>{
        if (!isEnabled) return;
        // Create the BroadcastChannel
        try {
            channelRef.current = new BroadcastChannel(channelName);
        } catch (error) {
            (0, $22hwD.logError)({
                error: error,
                impact: "useStateWithSync: Failed to create BroadcastChannel",
                extra: {
                    channelName: channelName
                }
            });
            return;
        }
        // Listen for messages from other tabs
        const handleMessage = (event)=>{
            const { key: messageKey, value: value } = event.data;
            // Only update if the message is for our key
            if (messageKey === key) setState(value);
        };
        // Add the message listener
        channelRef.current.addEventListener("message", handleMessage);
        // Cleanup function
        return ()=>{
            if (channelRef.current) {
                channelRef.current.removeEventListener("message", handleMessage);
                channelRef.current.close();
                channelRef.current = null;
            }
        };
    }, [
        key,
        channelName,
        isEnabled
    ]);
    return [
        state,
        setStateWithSync
    ];
}

});

parcelRegister("id9ES", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_USER_SETTINGS", () => $ce2307f4e12abcd3$export$77a705a84867edc0);
$parcel$export(module.exports, "DEFAULT_CHROME_STORED_SETTINGS", () => $ce2307f4e12abcd3$export$aade23df1b04ff57);
$parcel$export(module.exports, "DEFAULT_REMOTE_ADMIN_SETTINGS", () => $ce2307f4e12abcd3$export$83bdfcdff5be99ba);
$parcel$export(module.exports, "DEFAULT_LOCAL_STORED_SETTINGS", () => $ce2307f4e12abcd3$export$8da2810e49f51041);
parcelRequire("cDuOd");
var $fgIUF = parcelRequire("fgIUF");
const $ce2307f4e12abcd3$export$77a705a84867edc0 = {
    ntpEnabled: true,
    rovoCompanionEnabled: false,
    gdocsDefinitionsEnabled: false
};
const $ce2307f4e12abcd3$export$aade23df1b04ff57 = {
    ntpEnabled: true,
    topSitesEnabled: true,
    // A.K.A "Custom links"
    rovoCompanionEnabled: true,
    gdocsDefinitionsEnabled: true
};
const $ce2307f4e12abcd3$export$83bdfcdff5be99ba = {
    controlledUserNtpEnabled: true,
    controlledUserRovoCompanionEnabled: true,
    controlledUserGdocsDefinitionsEnabled: true,
    controlledUserDomContentEnabled: true,
    controlledUserCompanyAnnouncements: true
};
const $ce2307f4e12abcd3$export$8da2810e49f51041 = {
    [(0, $fgIUF.LocalStorageKey).WELCOME_HEADER_ENABLED]: true,
    [(0, $fgIUF.LocalStorageKey).GLOBAL_CREATE_ENABLED]: true,
    [(0, $fgIUF.LocalStorageKey).LOCAL_DEV_BANNER_ENABLED]: true,
    [(0, $fgIUF.LocalStorageKey).CALENDAR_ENABLED]: false,
    [(0, $fgIUF.LocalStorageKey).RECENT_WORK_ENABLED]: true,
    [(0, $fgIUF.LocalStorageKey).BOOKMARKS_ENABLED]: true,
    [(0, $fgIUF.LocalStorageKey).ANNOUNCEMENTS_ENABLED]: true
};

});



parcelRegister("9NbMC", function(module, exports) {
$parcel$export(module.exports, "StatSigInitialization", () => $3b4b724c5ed68853$export$6d222e25f24bf52e);
$parcel$export(module.exports, "useCheckStatSigFeatureGate", () => $3b4b724c5ed68853$export$a206847220e68830);
$parcel$export(module.exports, "useCheckStatsigGetAllFeatureGates", () => $3b4b724c5ed68853$export$7b88a4f26e43ec9a);
$parcel$export(module.exports, "useStatsigBooleanDynamicConfig", () => $3b4b724c5ed68853$export$f88e8f22c22ee285);
$parcel$export(module.exports, "useStatsigStringDynamicConfig", () => $3b4b724c5ed68853$export$90a9516121173515);
$parcel$export(module.exports, "useListDynamicConfigs", () => $3b4b724c5ed68853$export$5b20d03d8c798d4b);

var $4tluv = parcelRequire("4tluv");

var $ekfIA = parcelRequire("ekfIA");

var $lVHOI = parcelRequire("lVHOI");

var $f6Olw = parcelRequire("f6Olw");

var $7PVsI = parcelRequire("7PVsI");

var $lKdQo = parcelRequire("lKdQo");
parcelRequire("iuDZJ");
var $dqHaj = parcelRequire("dqHaj");

var $22hwD = parcelRequire("22hwD");

var $TrAR1 = parcelRequire("TrAR1");

var $lFK5D = parcelRequire("lFK5D");

var $hAM4Q = parcelRequire("hAM4Q");

var $dX6kP = parcelRequire("dX6kP");

var $lsxLV = parcelRequire("lsxLV");

var $3Dil2 = parcelRequire("3Dil2");

var $dqHaj = parcelRequire("dqHaj");
const $3b4b724c5ed68853$var$isProd = (0, $dqHaj.bifrostEnv) === "prod";
let $3b4b724c5ed68853$var$configClientInstance = null;
async function $3b4b724c5ed68853$var$initializeConfigClient(identifiers) {
    try {
        const ffsBaseUrl = $3b4b724c5ed68853$var$isProd ? "https://api.atlassian.com/flags" : "https://api.stg.atlassian.com/flags";
        $3b4b724c5ed68853$var$configClientInstance = await (0, $ekfIA.ConfigClient).fetch({
            ffsBaseUrl: ffsBaseUrl,
            ffsApiKey: "ebe2c06b-b4ec-4545-82a1-da3ae7cad15b",
            context: {
                namespace: "rovo-extension_web",
                identifiers: identifiers,
                metadata: {
                    environment: (0, $dqHaj.bifrostEnv)
                }
            }
        });
    } catch (error) {
        (0, $22hwD.logError)({
            error: error,
            impact: "Failed to initialize config client"
        });
    } finally{
        (0, $3Dil2.statsigStore).emitChange();
    }
}
const $3b4b724c5ed68853$export$8beae2bb7cabc6fd = ()=>$3b4b724c5ed68853$var$configClientInstance;
function $3b4b724c5ed68853$export$6d222e25f24bf52e({ site: site, children: children, userAccount: userAccount, analyticsAnonymousId: analyticsAnonymousId, onInitialized: onInitialized }) {
    const atlassianAccountId = userAccount?.accountId;
    const ufoContext = (0, $f6Olw.useInteractionContext)();
    const releaseHoldRef = (0, $4tluv.useRef)(null);
    const locale = (0, $dqHaj.getLocale)();
    const { browserManifestVersion: browserManifestVersion } = (0, $hAM4Q.useManifestVersion)();
    const sendAnalyticEvent = (0, $dX6kP.useSendAnalyticEvent)();
    // Set up provider callback to trigger store updates when feature gates change
    (0, $4tluv.useEffect)(()=>{
        (0, $lKdQo.pollingProvider).setClientVersion("5.5.7");
        (0, $lKdQo.pollingProvider).setApplyUpdateCallback((_experimentsResult)=>{
            (0, $3Dil2.statsigStore).emitChange();
        });
    }, []);
    const featureGatesIdentifiers = (0, $4tluv.useMemo)(()=>({
            ...atlassianAccountId ? {
                atlassianAccountId: atlassianAccountId
            } : {},
            ...analyticsAnonymousId ? {
                analyticsAnonymousId: analyticsAnonymousId
            } : {},
            tenantId: site?.workspace.cloudId,
            atlassianOrgId: site?.workspace.organisationId
        }), [
        atlassianAccountId,
        analyticsAnonymousId,
        site
    ]);
    const customAttributes = (0, $4tluv.useMemo)(()=>({
            tenantId: site?.workspace.cloudId ?? "",
            atlassianOrgId: site?.workspace.organisationId ?? "",
            extensionLocale: locale,
            extensionVersion: browserManifestVersion
        }), [
        site,
        locale,
        browserManifestVersion
    ]);
    // Use programmatic UFO hold for StatSig initialization
    (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).useEffect(()=>{
        const releaseHold = ufoContext?.hold("feature-gates-statsig-initialization");
        releaseHoldRef.current = releaseHold ?? null;
        return ()=>{
            // Cleanup: release hold if component unmounts before initialization completes
            releaseHoldRef.current?.();
            releaseHoldRef.current = null;
        };
    }, [
        ufoContext
    ]);
    const handleOnReady = (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).useCallback((err)=>{
        // Release the UFO hold when initialization completes
        releaseHoldRef.current?.();
        releaseHoldRef.current = null;
        if (err) // https://data-portal.internal.atlassian.com/analytics/registry/80196
        sendAnalyticEvent({
            eventType: "operational",
            event: {
                action: "failed",
                actionSubject: (0, $lsxLV.ANALYTICS_OPERATIONAL_EVENT_ACTION_SUBJECTS).FG_CLIENT_INITIALIZATION,
                source: "extensionFrontend",
                attributes: {
                    error: err.message
                }
            },
            userId: atlassianAccountId ?? ""
        });
        else {
            $3b4b724c5ed68853$var$initializeConfigClient(featureGatesIdentifiers);
            onInitialized?.();
        }
    }, [
        sendAnalyticEvent,
        atlassianAccountId,
        featureGatesIdentifiers,
        onInitialized
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $7PVsI.FeatureGatesInitializationWithProvider), {
        customAttributes: customAttributes,
        enabled: true,
        identifiers: featureGatesIdentifiers,
        onReady: handleOnReady,
        options: (0, $lKdQo.featureGatesOptions),
        provider: (0, $lKdQo.pollingProvider)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement($3b4b724c5ed68853$export$6a103eee5b0843dd, null, children));
}
const $3b4b724c5ed68853$export$fac938004b8ad59f = /*#__PURE__*/ (0, $4tluv.createContext)(undefined);
const $3b4b724c5ed68853$export$6a103eee5b0843dd = ({ children: children })=>{
    // Get the current statsig store value
    const value = (0, $4tluv.useSyncExternalStore)((0, $3Dil2.statsigStore).subscribe, (0, $3Dil2.statsigStore).getSnapshot);
    const [updateState, setUpdateState] = (0, $4tluv.useState)(false);
    // using a boolean state to force a re-render of components that depend on useCheckStatSigFeatureGate. the boolean value itself has no meaning
    const refreshStatSigContext = ()=>setUpdateState((state)=>!state);
    // refresh context if external store value changes
    (0, $4tluv.useEffect)(()=>{
        refreshStatSigContext();
    }, [
        value
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement($3b4b724c5ed68853$export$fac938004b8ad59f.Provider, {
        value: {
            refreshStatSigContext: refreshStatSigContext,
            contextState: updateState
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement($3b4b724c5ed68853$var$PlatformFeatureGateResolver, null, children));
};
const $3b4b724c5ed68853$var$useStatSigUpdateContext = ()=>{
    const context = (0, $4tluv.useContext)($3b4b724c5ed68853$export$fac938004b8ad59f);
    if (context === undefined) throw new Error("useStatSigContext must be used within a StatSigUpdateProvider");
    return context;
};
const $3b4b724c5ed68853$export$a206847220e68830 = ()=>{
    const { contextState: contextState } = $3b4b724c5ed68853$var$useStatSigUpdateContext();
    return (0, $4tluv.useCallback)((featureGate)=>{
        return (0, $lVHOI.default).checkGate(featureGate);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        contextState
    ] // this will cause a re-render of components that depend on this hook, meaning they will re-check the feature gate with updated experiment values
    );
};
const $3b4b724c5ed68853$export$7b88a4f26e43ec9a = ()=>{
    const { contextState: contextState } = $3b4b724c5ed68853$var$useStatSigUpdateContext();
    return (0, $4tluv.useCallback)(()=>{
        const allFeatureGates = {};
        // Loop through all enum values
        Object.values((0, $TrAR1.STATSIG_FEATURE_GATES)).forEach((featureGate)=>{
            allFeatureGates[featureGate] = (0, $lVHOI.default).checkGate(featureGate);
        });
        return allFeatureGates;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        contextState
    ] // this will cause a re-render of components that depend on this hook, meaning they will re-check the feature gate with updated experiment values
    );
};
const $3b4b724c5ed68853$var$hasDynamicConfigValue = (configResult)=>{
    return typeof configResult === "object" && configResult !== null && "value" in configResult;
};
const $3b4b724c5ed68853$export$f88e8f22c22ee285 = (configKey)=>{
    const { contextState: contextState } = $3b4b724c5ed68853$var$useStatSigUpdateContext();
    return (0, $4tluv.useMemo)(()=>{
        const configResult = $3b4b724c5ed68853$export$8beae2bb7cabc6fd()?.getBoolean(configKey);
        return $3b4b724c5ed68853$var$hasDynamicConfigValue(configResult) ? configResult.value : false;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        configKey,
        contextState
    ]);
};
const $3b4b724c5ed68853$export$90a9516121173515 = (configKey, fallbackValue = "")=>{
    const { contextState: contextState } = $3b4b724c5ed68853$var$useStatSigUpdateContext();
    return (0, $4tluv.useMemo)(()=>{
        const configResult = $3b4b724c5ed68853$export$8beae2bb7cabc6fd()?.getString(configKey);
        return $3b4b724c5ed68853$var$hasDynamicConfigValue(configResult) ? configResult.value : fallbackValue;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        configKey,
        fallbackValue,
        contextState
    ]);
};
const $3b4b724c5ed68853$export$ee54c2d113c24b93 = (configKey, fallbackValue)=>{
    const { contextState: contextState } = $3b4b724c5ed68853$var$useStatSigUpdateContext();
    return (0, $4tluv.useMemo)(()=>{
        const configResult = $3b4b724c5ed68853$export$8beae2bb7cabc6fd()?.getNumber(configKey);
        return $3b4b724c5ed68853$var$hasDynamicConfigValue(configResult) ? configResult.value : fallbackValue;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        configKey,
        fallbackValue,
        contextState
    ]);
};
const $3b4b724c5ed68853$export$addbb45fa105d750 = (configKey, fallbackValue)=>{
    const { contextState: contextState } = $3b4b724c5ed68853$var$useStatSigUpdateContext();
    return (0, $4tluv.useMemo)(()=>{
        const configResult = $3b4b724c5ed68853$export$8beae2bb7cabc6fd()?.getStringList(configKey);
        return $3b4b724c5ed68853$var$hasDynamicConfigValue(configResult) ? configResult.value : fallbackValue;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        configKey,
        fallbackValue,
        contextState
    ]);
};
const $3b4b724c5ed68853$export$5b20d03d8c798d4b = ()=>{
    const { contextState: contextState } = $3b4b724c5ed68853$var$useStatSigUpdateContext();
    return (0, $4tluv.useMemo)(()=>{
        const configClient = $3b4b724c5ed68853$export$8beae2bb7cabc6fd();
        if (!configClient) return {
            isInitialized: false,
            listedDynamicConfigs: []
        };
        return {
            isInitialized: true,
            listedDynamicConfigs: Object.entries((0, $TrAR1.STATSIG_DYNAMIC_CONFIGS)).map(([enumKey, configName])=>{
                const configNameString = String(configName);
                const booleanValueResult = configClient.getBoolean(configNameString);
                const stringValueResult = configClient.getString(configNameString);
                const numberValueResult = configClient.getNumber(configNameString);
                const stringListValueResult = configClient.getStringList(configNameString);
                const booleanValue = $3b4b724c5ed68853$var$hasDynamicConfigValue(booleanValueResult) ? booleanValueResult.value : undefined;
                const stringValue = $3b4b724c5ed68853$var$hasDynamicConfigValue(stringValueResult) ? stringValueResult.value : undefined;
                const numberValue = $3b4b724c5ed68853$var$hasDynamicConfigValue(numberValueResult) ? numberValueResult.value : undefined;
                const stringListValue = $3b4b724c5ed68853$var$hasDynamicConfigValue(stringListValueResult) ? stringListValueResult.value : undefined;
                if (typeof booleanValue === "boolean") return {
                    name: configNameString,
                    value: booleanValue,
                    type: "boolean",
                    enumKey: enumKey,
                    statsigUrl: (0, $dqHaj.getStatsigUrl)(configNameString, "dynamicConfig"),
                    switcherooUrl: (0, $dqHaj.getSwitcherooUrl)(configNameString, "dynamicConfig")
                };
                if (typeof stringValue === "string") return {
                    name: configNameString,
                    value: `\"${stringValue}\"`,
                    type: "string",
                    enumKey: enumKey,
                    statsigUrl: (0, $dqHaj.getStatsigUrl)(configNameString, "dynamicConfig"),
                    switcherooUrl: (0, $dqHaj.getSwitcherooUrl)(configNameString, "dynamicConfig")
                };
                if (typeof numberValue === "number") return {
                    name: configNameString,
                    value: numberValue,
                    type: "number",
                    enumKey: enumKey,
                    statsigUrl: (0, $dqHaj.getStatsigUrl)(configNameString, "dynamicConfig"),
                    switcherooUrl: (0, $dqHaj.getSwitcherooUrl)(configNameString, "dynamicConfig")
                };
                if (Array.isArray(stringListValue) && stringListValue.every((item)=>typeof item === "string")) return {
                    name: configNameString,
                    value: stringListValue,
                    type: "string []",
                    enumKey: enumKey,
                    statsigUrl: (0, $dqHaj.getStatsigUrl)(configNameString, "dynamicConfig"),
                    switcherooUrl: (0, $dqHaj.getSwitcherooUrl)(configNameString, "dynamicConfig")
                };
                return {
                    name: configNameString,
                    value: "Not found",
                    type: "unknown",
                    enumKey: enumKey,
                    statsigUrl: (0, $dqHaj.getStatsigUrl)(configNameString, "dynamicConfig"),
                    switcherooUrl: (0, $dqHaj.getSwitcherooUrl)(configNameString, "dynamicConfig")
                };
            })
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contextState
    ]);
};
const $3b4b724c5ed68853$export$569e7a603f4242a6 = (configClient)=>{
    $3b4b724c5ed68853$var$configClientInstance = configClient;
};
const $3b4b724c5ed68853$export$2c2302bdcd1c63f1 = ()=>{
    $3b4b724c5ed68853$var$configClientInstance = null;
};
const $3b4b724c5ed68853$var$PlatformFeatureGateResolver = ({ children: children })=>{
    (0, $lFK5D.setPlatformFeatureFlagResolver)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).Fragment, null, children);
};

});
parcelRegister("lKdQo", function(module, exports) {
$parcel$export(module.exports, "pollingProvider", () => $9dcab05ae59e0014$export$a44f07fc377ba900);
$parcel$export(module.exports, "featureGatesOptions", () => $9dcab05ae59e0014$export$6d95ae50c07db82e);

var $3BHcm = parcelRequire("3BHcm");

var $42xfx = parcelRequire("42xfx");
parcelRequire("iuDZJ");
var $dqHaj = parcelRequire("dqHaj");
const $9dcab05ae59e0014$var$isProd = (0, $dqHaj.bifrostEnv) === "prod";
const $9dcab05ae59e0014$var$getFeatureGateEnv = ()=>$9dcab05ae59e0014$var$isProd ? (0, $42xfx.FeatureGateEnvironment).Production : (0, $42xfx.FeatureGateEnvironment).Staging;
const $9dcab05ae59e0014$var$providerOptions = {
    apiKey: "ebe2c06b-b4ec-4545-82a1-da3ae7cad15b",
    initialFetchTimeout: 5000,
    useGatewayURL: false // Browser extensions must use direct FFS URLs, not gateway proxy
};
/**
 * Singleton instance of PollingProvider for feature gate management
 *
 * Features:
 * - Automatic polling for feature gate updates
 * - IndexedDB caching for fast initialization
 * - Cross-tab synchronization via BroadcastChannel
 */ const $9dcab05ae59e0014$var$provider = new (0, $3BHcm.default)($9dcab05ae59e0014$var$providerOptions);
// Using the FeatureGates client version from package.json
$9dcab05ae59e0014$var$provider.setClientVersion("5.5.7");
const $9dcab05ae59e0014$export$a44f07fc377ba900 = $9dcab05ae59e0014$var$provider;
const $9dcab05ae59e0014$export$6d95ae50c07db82e = {
    targetApp: "rovo-extension_web",
    apiKey: "ebe2c06b-b4ec-4545-82a1-da3ae7cad15b",
    environment: $9dcab05ae59e0014$var$getFeatureGateEnv(),
    perimeter: (0, $42xfx.PerimeterType).COMMERCIAL
};

});

parcelRegister("lFK5D", function(module, exports) {
$parcel$export(module.exports, "setPlatformFeatureFlagResolver", () => $a10f9b8762cab036$export$438cd9f17441b356);

var $3X3Vo = parcelRequire("3X3Vo");

var $lVHOI = parcelRequire("lVHOI");
const $a10f9b8762cab036$export$438cd9f17441b356 = ()=>{
    (0, $3X3Vo.setBooleanFeatureFlagResolver)((key)=>{
        return (0, $lVHOI.default).checkGate(key);
    });
};

});

parcelRegister("3Dil2", function(module, exports) {
$parcel$export(module.exports, "statsigStore", () => $24c059b3a96baa82$export$d5468990a66e2f3c);
// This is a simple store that allows us to subscribe to changes in the statsig context
// and trigger a re-render of components that depend on the statsig context.
// This is used to avoid remounting components when the statsig context changes.
class $24c059b3a96baa82$var$StatsigStore {
    constructor(){
        this.listeners = new Set();
        this.updateCount = 0;
        this.subscribe = (listener)=>{
            this.listeners.add(listener);
            return ()=>this.listeners.delete(listener);
        };
        this.emitChange = ()=>{
            this.updateCount++;
            this.listeners.forEach((listener)=>listener());
        };
        this.getSnapshot = ()=>this.updateCount;
    }
}
const $24c059b3a96baa82$export$d5468990a66e2f3c = new $24c059b3a96baa82$var$StatsigStore();

});






parcelRegister("6ascs", function(module, exports) {
$parcel$export(module.exports, "AnalyticsUserMetadataProvider", () => $aae8b551a2b64d12$export$bdea01a6b1d2d7bb);
$parcel$export(module.exports, "useAnalyticsUserMetadata", () => $aae8b551a2b64d12$export$5266e6a20baaf888);

var $4tluv = parcelRequire("4tluv");

var $bI4fx = parcelRequire("bI4fx");
const $aae8b551a2b64d12$export$a31cbab4c94546dc = /*#__PURE__*/ (0, $4tluv.createContext)(undefined);
const $aae8b551a2b64d12$export$bdea01a6b1d2d7bb = ({ children: children })=>{
    const [userMetadata, setUserMetadata] = (0, $4tluv.useState)();
    (0, $4tluv.useEffect)(()=>{
        const messageHandler = (event)=>{
            if (event.data.type === "GET_USER_METADATA_RESPONSE") setUserMetadata({
                isExtensionPinned: event.data.isExtensionPinned,
                ntpEnabled: event.data.ntpEnabled
            });
        };
        window.addEventListener("message", messageHandler, false);
        (0, $bI4fx.postMessageToParent)({
            type: "GET_USER_METADATA_REQUEST"
        });
        return ()=>{
            window.removeEventListener("message", messageHandler);
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement($aae8b551a2b64d12$export$a31cbab4c94546dc.Provider, {
        value: {
            userMetadata: userMetadata,
            setUserMetadata: setUserMetadata
        }
    }, children);
};
const $aae8b551a2b64d12$export$5266e6a20baaf888 = ()=>{
    /// context may be undefined if outside context provider, extension does not have message handler and cannot respond, or still awaiting response
    return (0, $4tluv.useContext)($aae8b551a2b64d12$export$a31cbab4c94546dc);
};

});

parcelRegister("1VhLk", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = Promise.all([
    $20gJU("jOsRz"),
    $20gJU("dAYgE")
]).then(()=>parcelRequire('1onKS'));

});


parcelRegister("7jMOi", function(module, exports) {
$parcel$export(module.exports, "assetsConfig", () => $0c865b8448de8f3f$export$3c97e0dabadb52a9);
const $0c865b8448de8f3f$var$allAtlassian = ({ entry: entry })=>{
    const isAtlassian = entry.name.includes("atlaskit") || entry.name.includes("atlassian") || entry.name.includes("atl-pass.net/") || entry.name.includes("cloudfront") && entry.name.includes("batch.js");
    return isAtlassian;
};
const $0c865b8448de8f3f$var$preloaded = ({ entry: entry, SSRDoneTime: SSRDoneTime })=>{
    return Boolean(SSRDoneTime && entry.startTime <= SSRDoneTime);
};
const $0c865b8448de8f3f$export$3c97e0dabadb52a9 = {
    allowedTypes: [
        "js",
        "css"
    ],
    classification: {
        all: true,
        allAtlassian: $0c865b8448de8f3f$var$allAtlassian,
        preloaded: $0c865b8448de8f3f$var$preloaded
    }
};

});


parcelRegister("67pgD", function(module, exports) {
$parcel$export(module.exports, "useReactUFORouteWatcher", () => $d492408853c0b7a1$export$cfd6347884237953);

var $4tluv = parcelRequire("4tluv");
parcelRequire("3mxm3");
var $bfivG = parcelRequire("bfivG");

var $c1YdO = parcelRequire("c1YdO");

var $1l4Yc = parcelRequire("1l4Yc");
parcelRequire("lxvXO");
var $3dX4H = parcelRequire("3dX4H");
/**
 * **Important**: This variable definition is read by the observability pipeline step for the purpose of automatically
 * setting up service level objectives (SLOs) for selected routes. If you want to create an SLO for your route, provide
 * a RouteSLOKey for its UFO name below, otherwise use a regular string. If you need to rename this variable or move its
 * definition into another file for some reason, update the `ROUTE_DEFINITION_VARIABLE` and `ROUTE_DEFINITION_FILE` in
 * the file `afm/rovo-extension/operations/scripts/constants.ts` accordingly.
 */ const $d492408853c0b7a1$var$ufoRouteNameByPath = {
    "/extension": (0, $3dX4H.RouteSLOKeys).HOME,
    "/extension/login-redirect": "login-redirect",
    "/extension/log-out": "logout",
    "/extension/menu": "menu",
    "/extension/ntp-login-redirect": (0, $3dX4H.RouteSLOKeys).NTP_LOGIN_REDIRECT,
    "/extension/ntp-logout-redirect": "ntp-logout-redirect",
    "/extension/options": (0, $3dX4H.RouteSLOKeys).OPTIONS,
    "/extension/popup": (0, $3dX4H.RouteSLOKeys).POPUP,
    "/extension/rovo-chat": (0, $3dX4H.RouteSLOKeys).CHAT,
    "/extension/session": "session",
    "/extension/uninstall": (0, $3dX4H.RouteSLOKeys).UNINSTALL,
    "/extension/welcome": (0, $3dX4H.RouteSLOKeys).WELCOME
};
function $d492408853c0b7a1$export$cfd6347884237953() {
    const location = (0, $bfivG.useLocation)();
    const isFirstRender = (0, $4tluv.useRef)(true);
    const pathname = (0, $4tluv.useRef)("");
    if (pathname.current !== location.pathname) {
        pathname.current = location.pathname;
        // do not emit UFO events for any undefined experiences
        const ufoName = $d492408853c0b7a1$var$ufoRouteNameByPath[location.pathname];
        if (ufoName) {
            if (isFirstRender.current) {
                (0, $c1YdO.default)(ufoName);
                isFirstRender.current = false;
            } else (0, $1l4Yc.default)(ufoName);
        }
    }
}

});
parcelRegister("1l4Yc", function(module, exports) {
$parcel$export(module.exports, "default", () => $bd0136b18fda9d46$export$2e2bcd8739ae039);

var $4tluv = parcelRequire("4tluv");

var $40SCs = parcelRequire("40SCs");

var $irOPS = parcelRequire("irOPS");

var $dXdid = parcelRequire("dXdid");

var $3EjrT = parcelRequire("3EjrT");

var $kPZVD = parcelRequire("kPZVD");

var $dWn9F = parcelRequire("dWn9F");

var $g96Dv = parcelRequire("g96Dv");

var $6nxcG = parcelRequire("6nxcG");
function $bd0136b18fda9d46$var$traceUFOTransition(ufoName, routeName = ufoName) {
    if (!(0, $dXdid.isUFOEnabled)()) return;
    const pressInteractionsList = (0, $dXdid.getDoNotAbortActivePressInteractionOnTransition)();
    const interaction = (0, $dWn9F.getActiveInteraction)();
    if (pressInteractionsList && interaction) {
        if (pressInteractionsList.includes(interaction.ufoName)) return;
    }
    (0, $dWn9F.abortAll)('transition', ufoName ?? undefined);
    if (ufoName) {
        (0, $g96Dv.default).current = ufoName;
        const rate = (0, $dXdid.getInteractionRate)(ufoName, 'transition');
        if ((0, $irOPS.default)(rate)) {
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            const newId = (0, $40SCs.v4)();
            (0, $6nxcG.setInteractionActiveTrace)(newId);
            (0, $kPZVD.DefaultInteractionID).current = newId;
            (0, $dWn9F.addNewInteraction)(newId, ufoName, 'transition', performance.now(), rate, null, routeName, (0, $3EjrT.getActiveTrace)());
        }
    }
}
function $bd0136b18fda9d46$export$369f0ded13ce6c50() {
    const interactionId = (0, $4tluv.useContext)((0, $kPZVD.default));
    const capturedInteractionId = interactionId.current;
    (0, $4tluv.useEffect)(()=>{
        // If we have a current interaction set...
        if (capturedInteractionId != null) {
            let cancel = requestAnimationFrame(()=>{
                cancel = requestAnimationFrame(()=>{
                    if (capturedInteractionId === interactionId.current) (0, $dWn9F.tryComplete)(capturedInteractionId);
                });
            });
            (0, $dWn9F.addOnCancelCallback)(capturedInteractionId, ()=>{
                cancelAnimationFrame(cancel);
            });
        }
    }, [
        capturedInteractionId,
        interactionId
    ]);
}
var $bd0136b18fda9d46$export$2e2bcd8739ae039 = $bd0136b18fda9d46$var$traceUFOTransition;

});
parcelRegister("6nxcG", function(module, exports) {
$parcel$export(module.exports, "setInteractionActiveTrace", () => $f346abda62c76908$export$f2e521e495a88544);

var $3EjrT = parcelRequire("3EjrT");

var $iWd73 = parcelRequire("iWd73");
function $f346abda62c76908$export$f2e521e495a88544(newId) {
    (0, $3EjrT.setActiveTrace)(newId.replace(/-/g, ''), (0, $iWd73.generateSpanId)(), 'transition');
}

});
parcelRegister("iWd73", function(module, exports) {
$parcel$export(module.exports, "generateSpanId", () => $8aded9ee64d790f0$export$295213bc4d0c54ad);
function $8aded9ee64d790f0$export$295213bc4d0c54ad() {
    return Array.from(new Array(16), ()=>Math.floor(Math.random() * 16).toString(16)).join('');
}

});



parcelRegister("lxvXO", function(module, exports) {
$parcel$export(module.exports, "ExperienceSLOKeys", () => (parcelRequire("3dX4H")).ExperienceSLOKeys);
$parcel$export(module.exports, "PerformanceSLOKeys", () => (parcelRequire("3dX4H")).PerformanceSLOKeys);
$parcel$export(module.exports, "RouteSLOKeys", () => (parcelRequire("3dX4H")).RouteSLOKeys);

var $3dX4H = parcelRequire("3dX4H");

});
parcelRegister("3dX4H", function(module, exports) {
$parcel$export(module.exports, "RouteSLOKeys", () => $370ba3cc4bb486b0$export$cc067c37658d47e4);
$parcel$export(module.exports, "PerformanceSLOKeys", () => $370ba3cc4bb486b0$export$818b2df6d68c10f);
$parcel$export(module.exports, "ExperienceSLOKeys", () => $370ba3cc4bb486b0$export$24627c49e42d1e9f);
const $370ba3cc4bb486b0$export$cc067c37658d47e4 = {
    CHAT: "chat",
    HOME: "home",
    NTP_LOGIN_REDIRECT: "ntp-login-redirect",
    OPTIONS: "options",
    POPUP: "popup",
    UNINSTALL: "uninstall",
    WELCOME: "welcome"
};
const $370ba3cc4bb486b0$export$818b2df6d68c10f = {
    APPLICATION_BOOTSTRAP: "application-bootstrap"
};
const $370ba3cc4bb486b0$export$24627c49e42d1e9f = {
    ANNOUNCEMENT_BANNER: "announcement-banner",
    ANNOUNCEMENT_WIDGET: "announcement-widget",
    APP_ROOT: "app-root",
    BOOKMARKS_BAR: "bookmarks-bar",
    CHAT_CONTENT_FULLPAGE: "chat-content-fullpage",
    CHAT_PAGE: "chat-page",
    CONVERSATION_ASSISTANT_FULLPAGE: "conversation-assistant-fullpage",
    DISMISSIBLE_WIDGETS: "dismissible-widgets",
    GENERAL_OPTIONS_SECTION: "general-options-section",
    HOME_CONTENT: "home-content",
    HOME_LAYOUT: "home-layout",
    NEW_TAB_PAGE_OPTIONS_SECTION: "new-tab-page-options-section",
    OPTIONS_FOOTER: "options-footer",
    OPTIONS_PAGE: "options-page",
    PAGE_LAYOUT: "page-layout",
    RECENT_WORK_WIDGET: "recent-work-widget",
    SEARCH_TAB: "search-tab",
    SEARCH_TAB_SELECTOR: "search-tab-selector",
    SEARCH_TAB_SELECTOR_WIDGET: "search-tab-selector-widget",
    SHORTCUTS: "shortcuts",
    SITE_SELECTOR: "site-selector",
    SITE_SELECTOR_WIDGET: "site-selector-widget",
    TOP_BAR: "top-bar",
    WELCOME_HEADER: "welcome-header"
};

});



parcelRegister("j0FUQ", function(module, exports) {
$parcel$export(module.exports, "toError", () => $bed9ac47c0171753$export$cc3b967c039ed3e7);
$parcel$export(module.exports, "reportUFOError", () => $bed9ac47c0171753$export$ff4295e7b5197bb4);
$parcel$export(module.exports, "useReportUFOError", () => $bed9ac47c0171753$export$b131dcf56bc238d7);

var $f6Olw = parcelRequire("f6Olw");

var $dWn9F = parcelRequire("dWn9F");

var $4tluv = parcelRequire("4tluv");
function $bed9ac47c0171753$var$isError(maybeError) {
    return maybeError !== null && typeof maybeError === "object" && "name" in maybeError && "message" in maybeError && typeof maybeError.name === "string" && typeof maybeError.message === "string";
}
function $bed9ac47c0171753$export$54a3d316be2099f1(unknown) {
    return typeof unknown === "object" ? JSON.stringify(unknown) : String(unknown);
}
function $bed9ac47c0171753$export$cc3b967c039ed3e7(maybeError) {
    return $bed9ac47c0171753$var$isError(maybeError) ? maybeError : new Error($bed9ac47c0171753$export$54a3d316be2099f1(maybeError));
}
const $bed9ac47c0171753$var$reportedUFOErrors = new WeakSet();
function $bed9ac47c0171753$export$ff4295e7b5197bb4(error, origin, context) {
    if ($bed9ac47c0171753$var$reportedUFOErrors.has(error)) return false;
    const interaction = (0, $dWn9F.getActiveInteraction)();
    const labelStack = context?.labelStack ?? null;
    if (interaction?.id) (0, $dWn9F.addError)(interaction.id, origin, labelStack, error.name, error.message, error.stack);
    else (0, $dWn9F.addErrorToAll)(origin, labelStack, error.name, error.message, error.stack);
    $bed9ac47c0171753$var$reportedUFOErrors.add(error);
    return true;
}
function $bed9ac47c0171753$export$b131dcf56bc238d7(origin = "[unknown]") {
    const ufoInteractionContext = (0, $f6Olw.useInteractionContext)();
    return (0, $4tluv.useCallback)((maybeError)=>void $bed9ac47c0171753$export$ff4295e7b5197bb4($bed9ac47c0171753$export$cc3b967c039ed3e7(maybeError), origin, ufoInteractionContext), [
        origin,
        ufoInteractionContext
    ]);
}

});

parcelRegister("8widT", function(module, exports) {
$parcel$export(module.exports, "UFOLoadingSpinner", () => $d694ede1be70d4a2$export$5a0e489182bd8790);

var $4tluv = parcelRequire("4tluv");

var $jJcBA = parcelRequire("jJcBA");
function $d694ede1be70d4a2$export$5a0e489182bd8790({ interactionName: interactionName, label: label, size: size = "medium", testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $jJcBA.default), {
        interactionName: interactionName,
        label: label,
        size: size,
        testId: testId
    });
}

});

parcelRegister("cFd5E", function(module, exports) {
$parcel$export(module.exports, "UFOSuspenseFallback", () => $e1b84d7be1e5c7b6$export$4f598ec1eca7d9b7);

var $4tluv = parcelRequire("4tluv");

var $7JI9m = parcelRequire("7JI9m");
function $e1b84d7be1e5c7b6$export$4f598ec1eca7d9b7({ name: name, children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $7JI9m.default), {
        name: name
    }, children);
}

});
parcelRegister("7JI9m", function(module, exports) {
$parcel$export(module.exports, "default", () => $fbfc5e435367d674$export$2e2bcd8739ae039);

var $l14Sg = parcelRequire("l14Sg");
var $fbfc5e435367d674$export$2e2bcd8739ae039 = (0, $l14Sg.default);

});
parcelRegister("l14Sg", function(module, exports) {
$parcel$export(module.exports, "default", () => $1552183e377ea7ea$export$2e2bcd8739ae039);

var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $dXdid = parcelRequire("dXdid");

var $f6Olw = parcelRequire("f6Olw");

var $kPZVD = parcelRequire("kPZVD");
const $1552183e377ea7ea$var$useLayoutEffectSAFE = typeof window === 'undefined' ? (0, $4tluv.useEffect) : (0, $4tluv.useLayoutEffect);
/**
 * Custom hook to track changes to the interaction ID.
 * Uses a subscription system to automatically update when the interaction ID changes.
 */ function $1552183e377ea7ea$var$useInteractionIdValue() {
    const interactionId = (0, $4tluv.useContext)((0, $kPZVD.default));
    const [currentId, setCurrentId] = (0, $4tluv.useState)(interactionId?.current || null);
    $1552183e377ea7ea$var$useLayoutEffectSAFE(()=>{
        setCurrentId(interactionId?.current || null);
        const unsubscribe = (0, $kPZVD.subscribeToInteractionIdChanges)((newId)=>{
            setCurrentId(newId);
        });
        return unsubscribe;
    }, [
        interactionId
    ]);
    return currentId;
}
function $1552183e377ea7ea$export$2e2bcd8739ae039({ children: children, name: name, hold: hold = true, experimental: experimental = false }) {
    // Check if UFO is enabled
    // Note: isUFOEnabled() returns a stable value based on config, so it's safe to call before hooks
    const ufoEnabled = (0, $dXdid.isUFOEnabled)();
    const currentInteractionId = $1552183e377ea7ea$var$useInteractionIdValue();
    // react-18: useId instead
    const context = (0, $4tluv.useContext)((0, $f6Olw.default));
    $1552183e377ea7ea$var$useLayoutEffectSAFE(()=>{
        // Skip hold registration if UFO is disabled
        if (!ufoEnabled) return;
        if (hold && context != null) {
            if (experimental && context.holdExperimental) return context.holdExperimental(name);
            return context.hold(name);
        }
    }, [
        hold,
        context,
        name,
        currentInteractionId,
        ufoEnabled
    ]);
    // react-18: can return children directly
    return children != null ? /*#__PURE__*/ (0, $2iln5.jsx)((0, $2iln5.Fragment), {
        children: children
    }) : null;
}

});



parcelRegister("cyDwo", function(module, exports) {
$parcel$export(module.exports, "default", () => $23f4ed10119534a1$export$2e2bcd8739ae039);

var $5hYPy = parcelRequire("5hYPy");


var $23f4ed10119534a1$export$2e2bcd8739ae039 = (0, $5hYPy.default);

});
parcelRegister("5hYPy", function(module, exports) {
$parcel$export(module.exports, "default", () => $7e585c1e492bfd97$export$2e2bcd8739ae039);

var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $5Ktbc = parcelRequire("5Ktbc");

var $40SCs = parcelRequire("40SCs");

var $irOPS = parcelRequire("irOPS");

var $dXdid = parcelRequire("dXdid");

var $3EjrT = parcelRequire("3EjrT");

var $f6Olw = parcelRequire("f6Olw");

var $kPZVD = parcelRequire("kPZVD");

var $dWn9F = parcelRequire("dWn9F");

var $g96Dv = parcelRequire("g96Dv");

var $iLVku = parcelRequire("iLVku");

var $ck7De = parcelRequire("ck7De");

var $dD8QO = parcelRequire("dD8QO");
let $7e585c1e492bfd97$var$tryCompleteHandle;
let $7e585c1e492bfd97$var$hasMarkedFirstSegmentLoad = false;
/** A portion of the page we apply measurement to */ const $7e585c1e492bfd97$var$UFOSegment = ({ name: segmentName, children: children, mode: mode = 'single', type: type = 'first-party' })=>{
    // If UFO is disabled, render children without any tracking overhead
    // Note: isUFOEnabled() returns a stable value based on config, so it's safe to call before hooks
    const ufoEnabled = (0, $dXdid.isUFOEnabled)();
    const parentContext = (0, $4tluv.useContext)((0, $f6Olw.default));
    const segmentIdMap = (0, $4tluv.useMemo)(()=>{
        if (!parentContext?.segmentIdMap) return new Map();
        return parentContext.segmentIdMap;
    }, [
        parentContext
    ]);
    const segmentId = (0, $4tluv.useMemo)(()=>{
        if (mode === 'single') return (0, $iLVku.default)();
        if (segmentIdMap.has(segmentName)) return segmentIdMap.get(segmentName);
        const newSegmentId = (0, $iLVku.default)();
        segmentIdMap.set(segmentName, newSegmentId);
        return newSegmentId;
    }, [
        mode,
        segmentName,
        segmentIdMap
    ]);
    const labelStack = (0, $4tluv.useMemo)(()=>parentContext?.labelStack ? [
            ...parentContext.labelStack,
            {
                name: segmentName,
                segmentId: segmentId,
                ...type !== 'first-party' ? {
                    type: type
                } : {}
            } // Only pass non-default types (not 'first-party') in payload to reduce size
        ] : [
            {
                name: segmentName,
                segmentId: segmentId,
                ...type !== 'first-party' ? {
                    type: type
                } : {}
            }
        ], [
        parentContext,
        segmentName,
        segmentId,
        type
    ]);
    const interactionId = (0, $4tluv.useContext)((0, $kPZVD.default));
    if (interactionId.current != null && !$7e585c1e492bfd97$var$hasMarkedFirstSegmentLoad) {
        (0, $dWn9F.markFirstSegmentLoad)(interactionId.current, labelStack, performance.now());
        $7e585c1e492bfd97$var$hasMarkedFirstSegmentLoad = true;
    }
    const interactionContext = (0, $4tluv.useMemo)(()=>{
        let lastCompleteEndTime = 0;
        function complete(endTime = performance.now()) {
            if (interactionId.current) {
                if (parentContext) parentContext.complete();
                else {
                    const capturedInteractionId = interactionId.current;
                    if (endTime > lastCompleteEndTime) lastCompleteEndTime = endTime;
                    if ($7e585c1e492bfd97$var$tryCompleteHandle) cancelAnimationFrame?.($7e585c1e492bfd97$var$tryCompleteHandle);
                    const onComplete = ()=>{
                        if (capturedInteractionId === interactionId.current) {
                            const isPageVisible = globalThis?.document?.visibilityState === 'visible';
                            const canDoRAF = typeof requestAnimationFrame !== 'undefined';
                            if (isPageVisible && canDoRAF) $7e585c1e492bfd97$var$tryCompleteHandle = requestAnimationFrame(()=>{
                                $7e585c1e492bfd97$var$tryCompleteHandle = requestAnimationFrame(()=>{
                                    if (capturedInteractionId === interactionId.current) (0, $dWn9F.tryComplete)(interactionId.current, lastCompleteEndTime);
                                });
                            });
                            else (0, $dWn9F.tryComplete)(interactionId.current, lastCompleteEndTime);
                        }
                    };
                    (0, $5Ktbc.unstable_scheduleCallback)((0, $5Ktbc.unstable_NormalPriority), onComplete);
                }
            }
        }
        function _internalHold(labelStack, name, experimental = false) {
            if (interactionId.current != null) {
                if (parentContext) return parentContext._internalHold(labelStack, name, experimental);
                else {
                    const capturedInteractionId = interactionId.current;
                    const disposeHold = (0, $dWn9F.addHold)(interactionId.current, labelStack, name, experimental);
                    return ()=>{
                        if (capturedInteractionId === interactionId.current) disposeHold();
                    };
                }
            }
        }
        function _internalHoldByID(labelStack, id, name, remove) {
            if (interactionId.current != null) {
                if (parentContext) {
                    parentContext._internalHoldByID(labelStack, name, id, remove);
                    return;
                }
                if (!remove) (0, $dWn9F.addHoldByID)(interactionId.current, labelStack, name, id);
                else (0, $dWn9F.removeHoldByID)(interactionId.current, id);
            }
        }
        if (parentContext) return {
            ...parentContext,
            labelStack: labelStack,
            complete: complete
        };
        return {
            labelStack: labelStack,
            segmentIdMap: segmentIdMap,
            hold (name = 'unknown') {
                return this._internalHold(this.labelStack, name);
            },
            holdExperimental (name = 'unknown') {
                return this._internalHold(this.labelStack, name, true);
            },
            addHoldByID (labelStack, id, name = 'unknown') {
                this._internalHoldByID(labelStack, id, name, false);
            },
            removeHoldByID (labelStack, id, name = 'unknown') {
                this._internalHoldByID(labelStack, id, name, true);
            },
            tracePress (name = 'unknown', timestamp) {
                const minorInteractions = [
                    ...(0, $dXdid.getDoNotAbortActivePressInteraction)() ?? [],
                    ...(0, $dXdid.getMinorInteractions)() ?? []
                ];
                if (minorInteractions.includes(name)) {
                    const activeInteraction = (0, $dWn9F.getActiveInteraction)();
                    activeInteraction?.minorInteractions?.push({
                        name: name,
                        startTime: timestamp ?? performance.now()
                    });
                    return;
                } else if (interactionId.current != null) (0, $dWn9F.abortByNewInteraction)(interactionId.current, name);
                const rate = (0, $dXdid.getInteractionRate)(name, 'press');
                if ((0, $irOPS.default)(rate)) {
                    const startTimestamp = timestamp ?? performance.now();
                    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                    const newId = (0, $40SCs.v4)();
                    interactionId.current = newId;
                    // covered experiences with tracing instrumentation:
                    // inline-result.global-issue.create-modal.submit
                    // inline-result.global-issue.create-modal-subsequent
                    (0, $3EjrT.setInteractionActiveTrace)(newId, 'press');
                    (0, $dWn9F.addNewInteraction)(newId, name, 'press', startTimestamp, rate, this.labelStack, (0, $g96Dv.default).current, (0, $3EjrT.getActiveTrace)());
                }
            },
            retainQuery (info) {
                if (interactionId.current != null) (0, $dWn9F.addRequestInfo)(interactionId.current, this.labelStack, info);
            },
            addPreload (moduleId, timestamp) {
                if (interactionId.current != null) (0, $dWn9F.addMark)(interactionId.current, 'bundle_preload', moduleId, this.labelStack, timestamp);
            },
            addLoad (identifier, start, end) {
                if (interactionId.current != null) {
                    const { labelStack: labelStack = [] } = this;
                    (0, $dWn9F.addSpan)(interactionId.current, 'bundle_load', identifier, labelStack, start, end);
                }
            },
            addMark (name, timestamp) {
                if (interactionId.current != null) {
                    const time = timestamp ?? performance.now();
                    (0, $dWn9F.addMark)(interactionId.current, 'custom', name, this.labelStack, time);
                }
            },
            addCustomData (customData) {
                if (interactionId.current != null) (0, $dWn9F.addCustomData)(interactionId.current, this.labelStack, customData);
            },
            addCustomTimings (customTimings) {
                if (interactionId.current != null) (0, $dWn9F.addCustomTiming)(interactionId.current, this.labelStack, customTimings);
            },
            addApdex (apdexInfo) {
                if (interactionId.current != null) {
                    const { key: key, stopTime: stopTime, startTime: startTime } = apdexInfo;
                    (0, $dWn9F.addApdex)(interactionId.current, {
                        key: key,
                        stopTime: stopTime,
                        startTime: startTime,
                        labelStack: this.labelStack
                    });
                }
            },
            onRender (phase, actualDuration, baseDuration, startTime, commitTime) {
                if (interactionId.current !== null) {
                    (0, $dWn9F.addProfilerTimings)(interactionId.current, this.labelStack, phase, actualDuration, baseDuration, startTime, commitTime);
                    (0, $ck7De.default)(()=>{
                        const paintedTime = performance.now();
                        this.complete(paintedTime);
                    });
                }
            },
            _internalHold: _internalHold,
            _internalHoldByID: _internalHoldByID,
            complete: complete
        };
    }, [
        parentContext,
        labelStack,
        segmentIdMap,
        interactionId
    ]);
    const hasMounted = (0, $4tluv.useRef)(false);
    const onRender = (0, $4tluv.useCallback)((_id, phase, actualDuration, baseDuration, startTime, commitTime)=>{
        // Manually keep track of mount-phase, and ensure that every segment is always mounted at least once
        if ((0, $dXdid.getConfig)()?.manuallyTrackReactProfilerMounts && !hasMounted.current) {
            interactionContext.onRender('mount', actualDuration, baseDuration, startTime, commitTime);
            hasMounted.current = true;
        } else interactionContext.onRender(phase, actualDuration, baseDuration, startTime, commitTime);
    }, [
        interactionContext
    ]);
    (0, $4tluv.useEffect)(()=>{
        (0, $dWn9F.addSegment)(labelStack);
        return ()=>{
            (0, $dWn9F.removeSegment)(labelStack);
        };
    }, [
        interactionId,
        parentContext,
        interactionContext,
        labelStack
    ]);
    const reactProfilerId = (0, $4tluv.useMemo)(()=>labelStack.map((l)=>l.name).join('/'), [
        labelStack
    ]);
    // If UFO is disabled, just render children without tracking overhead
    if (!ufoEnabled) return /*#__PURE__*/ (0, $2iln5.jsx)((0, $2iln5.Fragment), {
        children: children
    });
    const ufoSegment = /*#__PURE__*/ (0, $2iln5.jsx)((0, $f6Olw.default).Provider, {
        value: interactionContext,
        children: /*#__PURE__*/ (0, $2iln5.jsx)((0, $4tluv.Profiler), {
            id: reactProfilerId,
            onRender: onRender,
            children: children
        })
    });
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $dD8QO.default), {
        labelStack: labelStack,
        onRender: (...args)=>interactionContext.onRender.apply(interactionContext, args),
        children: ufoSegment
    });
};
$7e585c1e492bfd97$var$UFOSegment.displayName = 'UFOSegment';
var $7e585c1e492bfd97$export$2e2bcd8739ae039 = $7e585c1e492bfd97$var$UFOSegment;

});
parcelRegister("iLVku", function(module, exports) {
$parcel$export(module.exports, "default", () => $fd7ea8ddc9cfa806$export$2e2bcd8739ae039);
function $fd7ea8ddc9cfa806$var$generateId(length = 7) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for(let i = 0; i < length; i++)result += characters.charAt(Math.floor(Math.random() * characters.length));
    return result;
}
var $fd7ea8ddc9cfa806$export$2e2bcd8739ae039 = $fd7ea8ddc9cfa806$var$generateId;

});

parcelRegister("ck7De", function(module, exports) {
$parcel$export(module.exports, "default", () => $300a708e248ddf50$export$2e2bcd8739ae039);

var $hcSxw = parcelRequire("hcSxw");
function $300a708e248ddf50$var$scheduleOnPaint(callback) {
    const isSSR = typeof window === 'undefined' || Boolean(globalThis?.__SERVER__) || typeof $hcSxw !== 'undefined' && Boolean($hcSxw?.env?.REACT_SSR);
    if (isSSR) {
        // In SSR, execute callback immediately (no paint event exists)
        callback();
        return;
    }
    if (globalThis.document?.visibilityState !== 'visible') {
        // last resort fallback
        setTimeout(callback, 100);
        return;
    }
    // Check if the Scheduler API is available
    if (typeof window.scheduler !== 'undefined' && typeof window.scheduler.postTask === 'function') // Use scheduler.postTask if available
    // https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API
    // Make sure we are scheduling this task before the browser paint the next frame
    requestAnimationFrame(()=>{
        window.scheduler.postTask(callback, {
            priority: 'user-visible'
        });
    });
    else if (typeof requestAnimationFrame !== 'undefined') // Fallback to using double requestAnimationFrame
    requestAnimationFrame(()=>{
        requestAnimationFrame(()=>{
            callback();
        });
    });
}
var $300a708e248ddf50$export$2e2bcd8739ae039 = $300a708e248ddf50$var$scheduleOnPaint;

});





parcelRegister("cKss1", function(module, exports) {
$parcel$export(module.exports, "queryClient", () => $12d35b2aef9102e1$export$7c07b633a151f9c5);
$parcel$export(module.exports, "persister", () => $12d35b2aef9102e1$export$a2ba0fb8628135cb);
$parcel$export(module.exports, "default", () => $12d35b2aef9102e1$export$2e2bcd8739ae039);

var $4tluv = parcelRequire("4tluv");

var $bfivG = parcelRequire("bfivG");

var $2m1d3 = parcelRequire("2m1d3");

var $7LJz7 = parcelRequire("7LJz7");

var $d4v8F = parcelRequire("d4v8F");

var $6ascs = parcelRequire("6ascs");

var $642vm = parcelRequire("642vm");
parcelRequire("1wxU2");
var $cFd5E = parcelRequire("cFd5E");
var $67pgD = parcelRequire("67pgD");
parcelRequire("iuDZJ");
var $dqHaj = parcelRequire("dqHaj");
parcelRequire("imFpy");
var $aBqKF = parcelRequire("aBqKF");
parcelRequire("gfRi5");
var $8jOpu = parcelRequire("8jOpu");
var $3dX4H = parcelRequire("3dX4H");

var $2j9H9 = parcelRequire("2j9H9");

const $12d35b2aef9102e1$var$SessionLazy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).lazy(()=>(parcelRequire("i9GZq")));

const $12d35b2aef9102e1$var$PopupLoginRedirectPageLazy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).lazy(()=>(parcelRequire("9oo0u")).then((module)=>({
            default: module.PopupLoginRedirectPage
        })));

const $12d35b2aef9102e1$var$NtpLoginRedirectPageLazy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).lazy(()=>(parcelRequire("iwW6h")).then((module)=>({
            default: module.NtpLoginRedirectPage
        })));

const $12d35b2aef9102e1$var$NtpLogoutRedirectPageLazy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).lazy(()=>(parcelRequire("50ATz")).then((module)=>({
            default: module.NtpLogoutRedirectPage
        })));

const $12d35b2aef9102e1$var$ChatPageLazy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).lazy(()=>(parcelRequire("dzYJi")).then((module)=>({
            default: module.ChatPage
        })));

const $12d35b2aef9102e1$var$OptionsPageLazy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).lazy(()=>(parcelRequire("hLQ6G")).then((module)=>({
            default: module.OptionsPage
        })));

const $12d35b2aef9102e1$var$HomeLazy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).lazy(()=>(parcelRequire("eHKp4")));

const $12d35b2aef9102e1$var$WelcomePageLazy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).lazy(()=>(parcelRequire("lHQ6G")));

const $12d35b2aef9102e1$var$PopupPageLazy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).lazy(()=>(parcelRequire("cYiqF")));

const $12d35b2aef9102e1$var$MenuPageLazy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).lazy(()=>(parcelRequire("hvPcI")).then((module)=>({
            default: module.MenuPage
        })));

const $12d35b2aef9102e1$var$PageLayoutLazy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).lazy(()=>(parcelRequire("fwrRN")));

const $12d35b2aef9102e1$var$UninstallPageLazy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).lazy(()=>(parcelRequire("gSZP1")));
const $12d35b2aef9102e1$export$7c07b633a151f9c5 = new (0, $2m1d3.QueryClient)({
    defaultOptions: {
        queries: {
            gcTime: 86400000 // 24 hours
        }
    }
});
const $12d35b2aef9102e1$export$a2ba0fb8628135cb = (0, $7LJz7.createSyncStoragePersister)({
    storage: window.localStorage
});
function $12d35b2aef9102e1$export$2e2bcd8739ae039({ userAccount: userAccount }) {
    // Add route watcher inside router context
    (0, $67pgD.useReactUFORouteWatcher)();
    const isDevBuild = (0, $dqHaj.bifrostEnv) === "dev";
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $6ascs.AnalyticsUserMetadataProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $2j9H9.SessionReplayInitializer), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $8jOpu.ExperienceSLO), {
        ufo: (0, $3dX4H.ExperienceSLOKeys).APP_ROOT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $4tluv.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $cFd5E.UFOSuspenseFallback), {
            name: "app-root-suspense"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $642vm.default), null), isDevBuild && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $aBqKF.LocalDevBanner), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $bfivG.Routes), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $bfivG.Route), {
        path: "/extension"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $bfivG.Route), {
        Component: $12d35b2aef9102e1$var$WelcomePageLazy,
        path: "welcome"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $bfivG.Route), {
        Component: $12d35b2aef9102e1$var$PopupLoginRedirectPageLazy,
        path: "login-redirect"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $bfivG.Route), {
        Component: (0, $d4v8F.IdentityLogout),
        path: "log-out"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $bfivG.Route), {
        Component: $12d35b2aef9102e1$var$NtpLoginRedirectPageLazy,
        path: "ntp-login-redirect"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $bfivG.Route), {
        Component: $12d35b2aef9102e1$var$NtpLogoutRedirectPageLazy,
        path: "ntp-logout-redirect"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $bfivG.Route), {
        Component: $12d35b2aef9102e1$var$PopupPageLazy,
        path: "popup"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $bfivG.Route), {
        Component: $12d35b2aef9102e1$var$UninstallPageLazy,
        path: "uninstall"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $bfivG.Route), {
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement($12d35b2aef9102e1$var$PageLayoutLazy, {
            userAccount: userAccount
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $bfivG.Route), {
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement($12d35b2aef9102e1$var$MenuPageLazy, {
            userAccount: userAccount
        }),
        path: "menu"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $bfivG.Route), {
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement($12d35b2aef9102e1$var$OptionsPageLazy, {
            userAccount: userAccount
        }),
        path: "options"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $bfivG.Route), {
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement($12d35b2aef9102e1$var$HomeLazy, {
            userAccount: userAccount
        }),
        path: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $bfivG.Route), {
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement($12d35b2aef9102e1$var$ChatPageLazy, {
            userAccount: userAccount
        }),
        path: "rovo-chat"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $bfivG.Route), {
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement($12d35b2aef9102e1$var$SessionLazy, null),
        path: "session"
    }))))));
}

});
parcelRegister("d4v8F", function(module, exports) {
$parcel$export(module.exports, "IdentityLogout", () => $2d99e710bd4c2cb9$export$5d2f0914e2ff154b);

var $4tluv = parcelRequire("4tluv");
parcelRequire("iuDZJ");
var $dqHaj = parcelRequire("dqHaj");

var $lsxLV = parcelRequire("lsxLV");

var $dX6kP = parcelRequire("dX6kP");

var $f0dSY = parcelRequire("f0dSY");
const $2d99e710bd4c2cb9$export$5d2f0914e2ff154b = ()=>{
    const sendAnalyticEvent = (0, $dX6kP.useSendAnalyticEvent)();
    (0, $4tluv.useEffect)(()=>{
        const redirectToIdentity = ()=>{
            // https://data-portal.internal.atlassian.com/analytics/registry/74804
            sendAnalyticEvent({
                eventType: "track",
                event: {
                    action: "initialised",
                    actionSubject: (0, $lsxLV.ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS).LOGOUT,
                    source: (0, $lsxLV.ANALYTICS_SCREEN_NAMES).EXTENSION_REDIRECT_TO_IDENTITY_SCREEN
                },
                userId: ""
            });
            (0, $f0dSY.clearSentryUser)();
            const IdentityLogoutUrl = (0, $dqHaj.getIdentityUrl)() + "/logout";
            const IdentityLogOutUrlWithRedirect = `${IdentityLogoutUrl}?continue=${encodeURIComponent((0, $dqHaj.getRovoExtensionWebBaseUrl)() + "/extension/ntp-logout-redirect")}`;
            window.parent.location.href = IdentityLogOutUrlWithRedirect;
        };
        redirectToIdentity();
    }, [
        sendAnalyticEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).Fragment, null);
};

});

parcelRegister("642vm", function(module, exports) {
$parcel$export(module.exports, "default", () => $5ee50410b1fd3b05$export$2e2bcd8739ae039);

var $4tluv = parcelRequire("4tluv");

var $gkc74 = parcelRequire("gkc74");
const $5ee50410b1fd3b05$var$MetaTags = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $gkc74.Helmet), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement("meta", {
        content: "Rovo Extension",
        name: "application-name"
    }));
};
var $5ee50410b1fd3b05$export$2e2bcd8739ae039 = $5ee50410b1fd3b05$var$MetaTags;

});

parcelRegister("imFpy", function(module, exports) {
$parcel$export(module.exports, "LocalDevBanner", () => (parcelRequire("aBqKF")).LocalDevBanner);

var $aBqKF = parcelRequire("aBqKF");

});
parcelRegister("aBqKF", function(module, exports) {
$parcel$export(module.exports, "LocalDevBanner", () => $45d521762c118a78$export$666bf55c5f3504f6);

var $4tluv = parcelRequire("4tluv");

var $kbKpL = parcelRequire("kbKpL");
var $hT0yS = parcelRequire("hT0yS");
var $kfPot = parcelRequire("kfPot");

var $7Ywk8 = parcelRequire("7Ywk8");

var $3lyVW = parcelRequire("3lyVW");

var $jx7eF = parcelRequire("jx7eF");

var $3PWWl = parcelRequire("3PWWl");

var $4PeMk = parcelRequire("4PeMk");
parcelRequire("cDuOd");
var $fgIUF = parcelRequire("fgIUF");

var $gLHVH = parcelRequire("gLHVH");

var $crLv5 = parcelRequire("crLv5");
parcelRequire("jMN8E");
var $hZQIF = parcelRequire("hZQIF");
const $45d521762c118a78$var$bannerContainerStyles = (0, $kfPot.xcss)({
    position: "fixed",
    bottom: "space.200",
    left: "space.200",
    zIndex: "tooltip"
});
const $45d521762c118a78$var$bannerStyles = (0, $kfPot.xcss)({
    position: "relative",
    backgroundColor: "color.background.warning.bold",
    color: "color.text.inverse",
    paddingBlock: "space.100",
    paddingInline: "space.200",
    borderRadius: "radius.medium",
    font: "font.body.small",
    fontWeight: "font.weight.bold",
    boxShadow: "elevation.shadow.overlay",
    userSelect: "none"
});
const $45d521762c118a78$var$closeButtonStyles = (0, $kfPot.xcss)({
    position: "absolute",
    top: "space.negative.150",
    right: "space.negative.150"
});
const $45d521762c118a78$export$666bf55c5f3504f6 = ()=>{
    const { formatMessage: formatMessage } = (0, $7Ywk8.default)();
    const isSettingsAdminSiteControlsEnabled = (0, $crLv5.isSettingsAdminSiteControlsExperimentEnabled)();
    const { localStoredSettings: localStoredSettings } = (0, $hZQIF.useSettings)();
    const [legacyIsLocalDevBannerEnabled] = (0, $gLHVH.useStateWithSync)((0, $fgIUF.LocalStorageKey).LOCAL_DEV_BANNER_ENABLED, true);
    const isLocalDevBannerEnabled = isSettingsAdminSiteControlsEnabled ? localStoredSettings[(0, $fgIUF.LocalStorageKey).LOCAL_DEV_BANNER_ENABLED] : legacyIsLocalDevBannerEnabled;
    const [isHidden, setIsHidden] = (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).useState(false);
    const [isHovered, setIsHovered] = (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).useState(false);
    if (!isLocalDevBannerEnabled || isHidden) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $kbKpL.default), {
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false),
        testId: "local-dev-banner-container",
        xcss: $45d521762c118a78$var$bannerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $kbKpL.default), {
        testId: "local-dev-banner",
        xcss: $45d521762c118a78$var$bannerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $hT0yS.default), {
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jx7eF))), {
        label: ""
    }), formatMessage((0, $4PeMk.messages).localDevBannerLabel)), isHovered && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $kbKpL.default), {
        xcss: $45d521762c118a78$var$closeButtonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $3lyVW.default), {
        appearance: "subtle",
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3PWWl))), {
                ...iconProps,
                size: "small"
            }),
        label: "Close",
        onClick: ()=>setIsHidden(true),
        shape: "circle",
        spacing: "compact",
        testId: "local-dev-banner-close-button"
    }))));
};

});
parcelRegister("3lyVW", function(module, exports) {
$parcel$export(module.exports, "default", () => $50f24d2a49c3fb89$export$2e2bcd8739ae039);

var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $hHj16 = parcelRequire("hHj16");

var $eCj8S = parcelRequire("eCj8S");

var $k7gbB = parcelRequire("k7gbB");

var $cpPps = parcelRequire("cpPps");

var $fu5fM = parcelRequire("fu5fM");

var $kAcdt = parcelRequire("kAcdt");
/**
 * __Icon Button__
 *
 * Renders an icon-only button lets people take a common and recognizable action where space is limited.
 *
 * - [Examples](https://atlassian.design/components/button/icon-button/examples)
 * - [Code](https://atlassian.design/components/button/icon-button/code)
 * - [Usage](https://atlassian.design/components/button/icon-button/usage)
 */ const $50f24d2a49c3fb89$var$IconButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).forwardRef(function Button({ // Prevent duplicate labels being added.
'aria-label': preventedAriaLabel, 'aria-labelledby': ariaLabelledBy, analyticsContext: analyticsContext, appearance: appearance, autoFocus: autoFocus, icon: icon, interactionName: interactionName, isDisabled: isDisabled, isLoading: isLoading = false, isSelected: isSelected, isTooltipDisabled: isTooltipDisabled = true, label: label, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shape: shape, spacing: spacing, testId: testId, tooltip: tooltip, type: type = 'button', ...unsafeRest }, ref) {
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    if (isTooltipDisabled) return /*#__PURE__*/ (0, $2iln5.jsx)((0, $cpPps.default), {
        ...saferRest,
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        isIconButton: true,
        isCircle: shape === 'circle',
        hasIconBefore: !!icon,
        spacing: spacing,
        ariaLabelledBy: ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "IconButton",
        analyticsContext: analyticsContext,
        type: type,
        interactionName: interactionName,
        children: /*#__PURE__*/ (0, $2iln5.jsxs)((0, $fu5fM.default), {
            type: "icon",
            isLoading: isLoading,
            children: [
                /*#__PURE__*/ (0, $2iln5.jsx)((0, $kAcdt.default), {
                    icon: icon
                }),
                /*#__PURE__*/ (0, $2iln5.jsx)((0, $k7gbB.default), {
                    children: label
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $eCj8S.default), {
        content: tooltip?.content ?? label,
        testId: tooltip?.testId,
        position: tooltip?.position,
        delay: tooltip?.delay,
        onShow: tooltip?.onShow,
        onHide: tooltip?.onHide,
        mousePosition: tooltip?.mousePosition,
        analyticsContext: tooltip?.analyticsContext,
        strategy: tooltip?.strategy,
        tag: tooltip?.tag,
        truncate: tooltip?.truncate,
        component: tooltip?.component,
        hideTooltipOnClick: tooltip?.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip?.hideTooltipOnMouseDown,
        ignoreTooltipPointerEvents: tooltip?.ignoreTooltipPointerEvents,
        shortcut: tooltip?.shortcut,
        children: (triggerProps)=>/*#__PURE__*/ (0, $2iln5.jsx)((0, $cpPps.default), {
                ...saferRest,
                appearance: appearance,
                autoFocus: autoFocus,
                isDisabled: isDisabled,
                isLoading: isLoading,
                isSelected: isSelected,
                isIconButton: true,
                isCircle: shape === 'circle',
                hasIconBefore: false,
                spacing: spacing,
                ariaLabelledBy: ariaLabelledBy,
                onClick: (e, analyticsEvent)=>{
                    onClick?.(e, analyticsEvent);
                    triggerProps.onClick?.(e);
                },
                onMouseOver: (e)=>{
                    triggerProps.onMouseOver?.(e);
                    saferRest.onMouseOver?.(e);
                },
                onMouseOut: (e)=>{
                    triggerProps.onMouseOut?.(e);
                    saferRest.onMouseOut?.(e);
                },
                onMouseMove: (e)=>{
                    triggerProps.onMouseMove?.(e);
                    saferRest.onMouseMove?.(e);
                },
                onMouseDown: (e)=>{
                    triggerProps.onMouseDown?.(e);
                    saferRest.onMouseDown?.(e);
                },
                onFocus: (e)=>{
                    triggerProps.onFocus?.(e);
                    saferRest.onFocus?.(e);
                },
                onBlur: (e)=>{
                    triggerProps.onBlur?.(e);
                    saferRest.onBlur?.(e);
                },
                ref: (0, $hHj16.default)([
                    ref,
                    triggerProps?.ref
                ].filter(Boolean)),
                onMouseDownCapture: onMouseDownCapture,
                onMouseUpCapture: onMouseUpCapture,
                onKeyDownCapture: onKeyDownCapture,
                onKeyUpCapture: onKeyUpCapture,
                onTouchStartCapture: onTouchStartCapture,
                onTouchEndCapture: onTouchEndCapture,
                onPointerDownCapture: onPointerDownCapture,
                onPointerUpCapture: onPointerUpCapture,
                onClickCapture: onClickCapture,
                type: type,
                testId: testId,
                analyticsContext: analyticsContext,
                interactionName: interactionName,
                componentName: "IconButton",
                children: /*#__PURE__*/ (0, $2iln5.jsxs)((0, $fu5fM.default), {
                    type: "icon",
                    isLoading: isLoading,
                    children: [
                        /*#__PURE__*/ (0, $2iln5.jsx)((0, $kAcdt.default), {
                            icon: icon
                        }),
                        /*#__PURE__*/ (0, $2iln5.jsx)((0, $k7gbB.default), {
                            children: label
                        })
                    ]
                })
            })
    });
}));
$50f24d2a49c3fb89$var$IconButton.displayName = 'IconButton';
var $50f24d2a49c3fb89$export$2e2bcd8739ae039 = $50f24d2a49c3fb89$var$IconButton;

});

parcelRegister("3PWWl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::13080645a1b889dca339823c8ecd9929>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2cb3dac78c9924df$var$_react = $2cb3dac78c9924df$var$_interopRequireDefault((parcelRequire("4tluv")));

var $2cb3dac78c9924df$var$_baseNew = $2cb3dac78c9924df$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $2cb3dac78c9924df$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cross".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2cb3dac78c9924df$var$CrossIcon = (props)=>/*#__PURE__*/ $2cb3dac78c9924df$var$_react.default.createElement($2cb3dac78c9924df$var$_baseNew.default, Object.assign({
        name: "CrossIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.03 3.03 9.06 8l4.97 4.97-1.06 1.06L8 9.06l-4.97 4.97-1.06-1.06L6.94 8 1.97 3.03l1.06-1.06L8 6.94l4.97-4.97z"/>`
    }, props));
$2cb3dac78c9924df$var$CrossIcon.displayName = 'CrossIcon';
var $2cb3dac78c9924df$var$_default = module.exports.default = $2cb3dac78c9924df$var$CrossIcon;

});

parcelRegister("4PeMk", function(module, exports) {
$parcel$export(module.exports, "messages", () => $0eb5cb14898616fb$export$defe85febe8b728c);

var $38Fhe = parcelRequire("38Fhe");
const $0eb5cb14898616fb$export$defe85febe8b728c = (0, $38Fhe.defineMessages)({
    localDevBannerLabel: {
        id: "rovo-extension.local-dev-banner.label.no-translate",
        defaultMessage: "LOCAL DEV",
        description: "The text is shown as a banner label at the top of the extension UI when running in local development mode to distinguish it from production. This string should NOT be translated."
    }
});

});



parcelRegister("gfRi5", function(module, exports) {
$parcel$export(module.exports, "ExperienceSLO", () => (parcelRequire("8jOpu")).ExperienceSLO);
$parcel$export(module.exports, "PerformanceSLO", () => (parcelRequire("4xT8j")).PerformanceSLO);
$parcel$export(module.exports, "ExperienceSLOKeys", () => (parcelRequire("3dX4H")).ExperienceSLOKeys);
$parcel$export(module.exports, "PerformanceSLOKeys", () => (parcelRequire("3dX4H")).PerformanceSLOKeys);

var $8jOpu = parcelRequire("8jOpu");

var $4xT8j = parcelRequire("4xT8j");
parcelRequire("lxvXO");
var $3dX4H = parcelRequire("3dX4H");

});
parcelRegister("8jOpu", function(module, exports) {
$parcel$export(module.exports, "ExperienceSLO", () => $7d88e33816f8fd49$export$d2edfcbe997fe43d);

var $dWn9F = parcelRequire("dWn9F");

var $cDSkE = parcelRequire("cDSkE");

var $gGGDG = parcelRequire("gGGDG");

var $4tluv = parcelRequire("4tluv");
parcelRequire("1wxU2");
var $cyDwo = parcelRequire("cyDwo");

var $j0FUQ = parcelRequire("j0FUQ");
/**
 * This "soft" error boundary reports UFO failure events only for the outermost, originating SLO component.
 */ class $7d88e33816f8fd49$var$UFOErrorReporter extends (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).Component {
    static{
        this.contextType = (0, $cDSkE.default);
    }
    constructor(props){
        super(props);
        this.state = {
            childHasThrown: false
        };
    }
    static getDerivedStateFromError(_) {
        return {
            childHasThrown: true
        };
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).Fragment, null, this.state.childHasThrown ? null : this.props.children);
    }
    componentDidCatch(maybeError, _) {
        // original signature: componentDidCatch?(error: Error, errorInfo: ErrorInfo): void
        // …but React isn't telling the truth: error may not be an Error… hence the below verification
        const error = (0, $j0FUQ.toError)(maybeError);
        if ((0, $j0FUQ.reportUFOError)(error, this.props.ufo, this.context)) $gGGDG.withScope((scope)=>{
            scope.setTag("slo-key", this.props.ufo);
            scope.setTag("interaction-id", (0, $dWn9F.getActiveInteraction)()?.id);
            scope.captureException(error, {
                mechanism: {
                    handled: false
                }
            });
        });
        throw error;
    }
}
const $7d88e33816f8fd49$export$d2edfcbe997fe43d = ({ children: children, ufo: ufo })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $cyDwo.default), {
        name: ufo
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement($7d88e33816f8fd49$var$UFOErrorReporter, {
        ufo: ufo
    }, children));
};

});

parcelRegister("4xT8j", function(module, exports) {
$parcel$export(module.exports, "PerformanceSLO", () => $c2a0e391e5e971ec$export$81f8fd4eaf989719);

var $4tluv = parcelRequire("4tluv");
parcelRequire("1wxU2");
var $cyDwo = parcelRequire("cyDwo");
const $c2a0e391e5e971ec$export$81f8fd4eaf989719 = ({ children: children, ufo: ufo })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $cyDwo.default), {
        name: ufo
    }, children);
};

});


parcelRegister("2j9H9", function(module, exports) {
$parcel$export(module.exports, "SessionReplayInitializer", () => $f1dc510eb77a0827$export$f511ef2adb3a5466);

var $4tluv = parcelRequire("4tluv");
parcelRequire("3mxm3");
var $bfivG = parcelRequire("bfivG");

var $crLv5 = parcelRequire("crLv5");

var $22hwD = parcelRequire("22hwD");

var $hAu9l = parcelRequire("hAu9l");

var $39pGM = parcelRequire("39pGM");

var $jliSL = parcelRequire("jliSL");

var $aiwEv = parcelRequire("aiwEv");

var $8i7E1 = parcelRequire("8i7E1");
/** Serialized reconcile so concurrent ticks (Strict Mode, poll + subscription) do not race. */ let $f1dc510eb77a0827$var$reconcileTail = Promise.resolve();
/**
 * Poll interval for install-window eligibility only (experiment changes use Statsig subscription).
 * 60s balances picking up “installed just over an hour ago” edge cases without waking the tab often
 * for battery / background-tab cost. Kept as a local const unless we need env- or experiment-driven tuning.
 */ const $f1dc510eb77a0827$var$SESSION_REPLAY_CONDITION_POLL_MS = 60000;
const $f1dc510eb77a0827$export$cea275c20b2dc2d6 = ()=>{
    (0, $39pGM.sessionReplayDocumentState).reset();
    $f1dc510eb77a0827$var$reconcileTail = Promise.resolve();
};
async function $f1dc510eb77a0827$var$runSessionReplayReconcileSafe() {
    try {
        await $f1dc510eb77a0827$var$runSessionReplayReconcile();
    } catch (error) {
        (0, $22hwD.logError)({
            error: error,
            impact: "Session replay eligibility reconcile failed"
        });
    }
}
/** Chains work on `reconcileTail` so ticks never overlap; the work itself uses async/await in {@link runSessionReplayReconcileSafe}. */ function $f1dc510eb77a0827$var$enqueueSessionReplayReconcile() {
    $f1dc510eb77a0827$var$reconcileTail = $f1dc510eb77a0827$var$reconcileTail.then(()=>$f1dc510eb77a0827$var$runSessionReplayReconcileSafe());
    return $f1dc510eb77a0827$var$reconcileTail;
}
async function $f1dc510eb77a0827$var$runSessionReplayReconcile() {
    const eligible = await (0, $aiwEv.isInstalledWithinSessionReplayWindow)() && (0, $crLv5.isSessionReplayExperimentEnabled)();
    if (eligible && !(0, $39pGM.sessionReplayDocumentState).isInitialized) {
        await (0, $hAu9l.initializeSessionReplay)();
        (0, $39pGM.sessionReplayDocumentState).markInitialized();
    }
// While the same Gas session id is active, keep recording even if experiment/install window
// later become false. When Gas mints a new session id, `onAnalyticsWebClientSessionRotation`
// flushes and either updates Amplitude's session or shuts replay down if no longer eligible.
}


const $f1dc510eb77a0827$export$f511ef2adb3a5466 = ()=>{
    const flushAttachedRef = (0, $4tluv.useRef)(false);
    const removePagehideRef = (0, $4tluv.useRef)(undefined);
    const location = (0, $bfivG.useLocation)();
    const prevPathnameRef = (0, $4tluv.useRef)(location.pathname);
    (0, $4tluv.useEffect)(()=>{
        let mounted = true;
        const detachFlushListeners = ()=>{
            removePagehideRef.current?.();
            removePagehideRef.current = undefined;
            flushAttachedRef.current = false;
        };
        const attachFlushListeners = async ()=>{
            if (flushAttachedRef.current || !(0, $39pGM.sessionReplayDocumentState).isInitialized) return;
            // Named async chunk for session-replay (see `initializeSessionReplay.ts` module comment: Atlaspack + `webpackChunkName`).
            const { flush: flush } = await (parcelRequire("9qSid"));
            const doFlush = ()=>{
                flush(true);
            };
            window.addEventListener("pagehide", doFlush);
            removePagehideRef.current = ()=>window.removeEventListener("pagehide", doFlush);
            flushAttachedRef.current = true;
        };
        const syncFlushAttachment = async ()=>{
            if ((0, $39pGM.sessionReplayDocumentState).isInitialized && !flushAttachedRef.current) await attachFlushListeners();
            else if (!(0, $39pGM.sessionReplayDocumentState).isInitialized && flushAttachedRef.current) detachFlushListeners();
        };
        const unregisterFlushAttachmentSync = (0, $jliSL.registerSessionReplayFlushAttachmentSync)(()=>{
            syncFlushAttachment();
        });
        const tick = async ()=>{
            await $f1dc510eb77a0827$var$enqueueSessionReplayReconcile();
            if (!mounted) return;
            await syncFlushAttachment();
        };
        tick();
        const unsubscribeExperiment = (0, $8i7E1.subscribeSessionReplayExperiment)(()=>{
            tick();
        });
        const pollId = window.setInterval(()=>{
            tick();
        }, $f1dc510eb77a0827$var$SESSION_REPLAY_CONDITION_POLL_MS);
        return ()=>{
            mounted = false;
            unregisterFlushAttachmentSync();
            unsubscribeExperiment();
            window.clearInterval(pollId);
            detachFlushListeners();
        // NTP mounts once per tab today; if this component were reused in a mount/unmount loop, this
        // cleanup must stay in sync with every timer and listener above.
        };
    }, []);
    // Flush when user navigates within the app (e.g. NTP → options) so events are sent before the view changes.
    (0, $4tluv.useEffect)(()=>{
        if (!flushAttachedRef.current || prevPathnameRef.current === location.pathname) return;
        prevPathnameRef.current = location.pathname;
        // Same async chunk — see `initializeSessionReplay.ts` module comment.
        (parcelRequire("9qSid")).then(({ flush: flush })=>flush(true));
    }, [
        location.pathname
    ]);
    return null;
};

});
parcelRegister("hAu9l", function(module, exports) {
$parcel$export(module.exports, "initializeSessionReplay", () => $d92c1b31faac3cf1$export$f690d86bb27f2336);
$parcel$export(module.exports, "shutdownSessionReplay", () => $d92c1b31faac3cf1$export$eb455cee783926a7);
parcelRequire("iuDZJ");
var $dqHaj = parcelRequire("dqHaj");

var $dX6kP = parcelRequire("dX6kP");

var $22hwD = parcelRequire("22hwD");
/**
 * Dynamic imports of `@amplitude/session-replay-browser` use `webpackChunkName` magic comments so the
 * bundler can emit a stable async chunk. **Atlaspack respects these** when built with
 * `supportWebpackChunkName` (see `scripts/atlaspack-build.js` in extension-frontend).
 */ /**
 * UGC filter rules for session replay (required if Heatmaps are enabled).
 * Redact URLs to avoid recording sensitive paths. Aligned with Atlassian integration guide.
 */ const $d92c1b31faac3cf1$var$UGC_FILTER_RULES = [
    {
        selector: "https://*.atlassian.net/browse/*",
        replacement: "https://REDACTED.atlassian.net/browse/REDACTED"
    },
    {
        selector: "https://*",
        replacement: "https://REDACTED"
    },
    {
        selector: "http://*",
        replacement: "http://REDACTED"
    }
];
/**
 * NTP (New Tab Page) UGC privacy: mask or block user-identifiable and user-generated content in session replay.
 *
 * All widgets (shortcuts, recent work, announcements, calendar) get the same treatment:
 * - Block only images (favicons, avatars, icons) → grey in replay.
 * - Mask text (titles, metadata) → starred in replay.
 *
 * Profile (top right): container text masked, profile picture blocked (grey).
 *
 * Chat input area (uploaded files, chat mode options, prompt text): entire area masked (text starred),
 * any file preview images blocked (grey).
 *
 * `body` is included last as an Atlassian session-replay integration failsafe: when the effective
 * `defaultMaskLevel` is not `conservative` (e.g. remote `sr_privacy_config` override), the SDK falls
 * back to `maskSelector` only without `maskTextSelector: '*'`. `body` then keeps text masked broadly.
 *
 * **Root `amp-mask`:** `public/index.html` sets `class="amp-mask"` on `#root` (same class as
 * {@link SessionReplayUGC}). rrweb only runs `maskTextFn` on text when `needMaskingText` passes; with
 * conservative config the SDK sets `maskTextSelector: '*'`, and `closest('*')` can fail inside rrweb’s
 * try/catch so static text is skipped while `maskAllInputs` still masks typing. A real `.amp-mask`
 * ancestor fixes the gate for the whole app on first paint and async-loaded NTP content.
 */ const $d92c1b31faac3cf1$var$NTP_PRIVACY_MASK_SELECTORS = [
    "[data-testid='search-input']",
    "[data-testid='full-chat-input']",
    /** Chat box: prompt text, uploaded file names, chat mode menu labels (reasoning, web search, etc.) */ "[data-testid='rovo-chat-box-wrapper']",
    "[data-testid='chat-input-wrapper']",
    "[data-testid='welcome-header-container']",
    "[data-testid='profile-container']",
    "[data-testid='empty-shortcuts-container']",
    /** Shortcuts: star titles */ "[data-testid='ntp-shortcuts-section']",
    /** All dismissible widgets (recent work, announcements, calendar): star text */ "[data-testid='ntp-dismissible-widgets']",
    /** Failsafe — see module comment above */ "body"
];
const $d92c1b31faac3cf1$var$NTP_PRIVACY_BLOCK_SELECTORS = [
    ".bookmarks_container",
    /** Shortcuts: grey favicons only */ "[data-testid='ntp-shortcuts-section'] img",
    /** All widgets: grey images only (avatars, icons, favicons in recent work, announcements, calendar) */ "[data-testid='ntp-dismissible-widgets'] img",
    /** Profile (top right): grey profile picture only */ "[data-testid='profile-container'] img",
    /** Chat box: grey file preview / thumbnail images only */ "[data-testid='rovo-chat-box-wrapper'] img",
    "[data-testid='chat-input-wrapper'] img"
];

const $d92c1b31faac3cf1$export$f690d86bb27f2336 = async ()=>{
    const apiKey = (0, $dqHaj.getSessionReplayAmplitudeApiKey)();
    if (!apiKey) return;
    try {
        // Same async chunk as `onAnalyticsWebClientSessionRotation` / `SessionReplayInitializer` (see file comment above).
        const { init: init } = await (parcelRequire("9qSid"));
        const deviceId = (0, $dX6kP.analyticsClient).getAnonymousId();
        const sessionId = (0, $dX6kP.analyticsClient).getCurrentSessionId();
        await init(apiKey, {
            deviceId: deviceId,
            sessionId: sessionId,
            /** Use IndexedDB so events persist when the user navigates away (e.g. to options); memory is lost on unload. */ storeType: "idb",
            optOut: false,
            applyBackgroundColorToBlockedElements: true,
            /** Record 100% of sessions when selected; without this the SDK defaults to sampling and opts sessions out */ sampleRate: 1,
            /** In dev, level 4 (Debug) so you can see when replay data is sent in the console */ logLevel: (0, $dqHaj.debugEnabled) ? 4 : undefined,
            privacyConfig: {
                defaultMaskLevel: "conservative",
                maskSelector: $d92c1b31faac3cf1$var$NTP_PRIVACY_MASK_SELECTORS,
                blockSelector: $d92c1b31faac3cf1$var$NTP_PRIVACY_BLOCK_SELECTORS
            },
            interactionConfig: {
                enabled: true,
                batch: true,
                ugcFilterRules: $d92c1b31faac3cf1$var$UGC_FILTER_RULES
            }
        }).promise;
    } catch (error) {
        (0, $22hwD.logError)({
            error: error,
            impact: "Failed to initialize session replay"
        });
    }
};

const $d92c1b31faac3cf1$export$eb455cee783926a7 = async ()=>{
    try {
        const { shutdown: shutdown } = await (parcelRequire("9qSid"));
        shutdown();
    } catch (error) {
        (0, $22hwD.logError)({
            error: error,
            impact: "Failed to shutdown session replay"
        });
    }
};

});
parcelRegister("9qSid", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = Promise.all([
    $20gJU("jOsRz"),
    $20gJU("52gsf")
]).then(()=>parcelRequire('2lx0z'));

});


parcelRegister("39pGM", function(module, exports) {
$parcel$export(module.exports, "sessionReplayDocumentState", () => $a1d5b3e5a25b17e6$export$28c1476832ad9fdd);
/**
 * Document-scoped session replay flag (survives React Strict Mode for the first start).
 *
 * After `shutdownSessionReplay` (e.g. Gas rotation while ineligible), {@link SessionReplayDocumentState.reset}
 * clears state so {@link SessionReplayInitializer} may call `initializeSessionReplay` again — multiple
 * start/stop cycles per document are intentional.
 *
 * Use {@link sessionReplayDocumentState} rather than module-level `let` exports: private field avoids
 * accidental mutation, and `isInitialized` is always read at access time (no stale captured binding).
 */ class $a1d5b3e5a25b17e6$export$31d667b2aa0ae85c {
    get isInitialized() {
        return this._initialized;
    }
    markInitialized() {
        this._initialized = true;
    }
    reset() {
        this._initialized = false;
    }
    constructor(){
        this._initialized = false;
    }
}
const $a1d5b3e5a25b17e6$export$28c1476832ad9fdd = new $a1d5b3e5a25b17e6$export$31d667b2aa0ae85c();

});

parcelRegister("jliSL", function(module, exports) {
$parcel$export(module.exports, "registerSessionReplayFlushAttachmentSync", () => $209ecfb854425216$export$94528fca79ed440d);
$parcel$export(module.exports, "runSessionReplayFlushAttachmentSync", () => $209ecfb854425216$export$b3f82bbebfe3db66);
/**
 * Single-slot callback so session-replay code outside the React tree can refresh pagehide / flush
 * attachment after shutdown. Only one registrant is supported: a second `register*` overwrites the
 * previous slot until its returned unregister runs. That matches today’s single `SessionReplayInitializer`
 * instance; if multiple mount concurrently, the last registration wins (call unregister on unmount).
 */ let $209ecfb854425216$var$syncFlushAttachment;
function $209ecfb854425216$export$94528fca79ed440d(fn) {
    $209ecfb854425216$var$syncFlushAttachment = fn;
    return ()=>{
        $209ecfb854425216$var$syncFlushAttachment = undefined;
    };
}
function $209ecfb854425216$export$b3f82bbebfe3db66() {
    $209ecfb854425216$var$syncFlushAttachment?.();
}

});

parcelRegister("aiwEv", function(module, exports) {
$parcel$export(module.exports, "isInstalledWithinSessionReplayWindow", () => $6ba480b784c01a45$export$ebb8b2eed9769825);

var $izLSa = parcelRequire("izLSa");
const $6ba480b784c01a45$export$ef5991f53e164d1 = "extension_installed_at_ms";
const $6ba480b784c01a45$export$7f05de54b7fa9912 = 3600000;
async function $6ba480b784c01a45$export$ebb8b2eed9769825() {
    const storage = (0, $izLSa.getChromeStorageLocal)();
    if (!storage) return false;
    try {
        const result = await storage.get($6ba480b784c01a45$export$ef5991f53e164d1);
        const installedAt = result[$6ba480b784c01a45$export$ef5991f53e164d1];
        if (typeof installedAt !== "number" || Number.isNaN(installedAt)) return false;
        return Date.now() - installedAt <= $6ba480b784c01a45$export$7f05de54b7fa9912;
    } catch  {
        return false;
    }
}

});
parcelRegister("izLSa", function(module, exports) {
$parcel$export(module.exports, "getChromeStorageLocal", () => $71678a22b5debe98$export$fc217863a9fee2bf);
/**
 * Narrow chrome.storage.local surface used by the extension UI (no dependency on @types/chrome).
 */ function $71678a22b5debe98$export$fc217863a9fee2bf() {
    const g = globalThis;
    return g.chrome?.storage?.local;
}

});


parcelRegister("8i7E1", function(module, exports) {
$parcel$export(module.exports, "subscribeSessionReplayExperiment", () => $43fd3bc1ac716e3f$export$7157f7768f7ff166);

var $lVHOI = parcelRequire("lVHOI");

var $crLv5 = parcelRequire("crLv5");
const $43fd3bc1ac716e3f$export$7157f7768f7ff166 = (onExperimentMaybeChanged)=>{
    return (0, $lVHOI.default).onExperimentValueUpdated((0, $crLv5.EXPERIMENTS).SESSION_REPLAY, (0, $crLv5.PARAMETERS).isSessionReplayEnabled, false, ()=>{
        onExperimentMaybeChanged();
    }, {
        fireExperimentExposure: false
    });
};

});


parcelRegister("i9GZq", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = Promise.all([
    $20gJU("jOsRz"),
    $20gJU("25yRO")
]).then(()=>parcelRequire('SjqiU'));

});

parcelRegister("9oo0u", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = Promise.all([
    $20gJU("jOsRz"),
    $20gJU("25yRO")
]).then(()=>parcelRequire('eVpdu'));

});

parcelRegister("iwW6h", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = Promise.all([
    $20gJU("jOsRz"),
    $20gJU("25yRO")
]).then(()=>parcelRequire('gdrql'));

});

parcelRegister("50ATz", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = Promise.all([
    $20gJU("jOsRz"),
    $20gJU("25yRO")
]).then(()=>parcelRequire('b1ht5'));

});

parcelRegister("dzYJi", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = Promise.all([
    $20gJU("jOsRz"),
    $20gJU("jdzWq")
]).then(()=>parcelRequire('4ZxOH'));

});

parcelRegister("hLQ6G", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = Promise.all([
    $20gJU("jOsRz"),
    $20gJU("bFpnu"),
    $20gJU("6y1PR"),
    $20gJU("8muIR")
]).then(()=>parcelRequire('eNWQ7'));

});

parcelRegister("eHKp4", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = Promise.all([
    $20gJU("eBcn9"),
    $20gJU("eeFSj"),
    $20gJU("1u2kx"),
    $20gJU("dMnjs"),
    $20gJU("8udjg"),
    $20gJU("jXsZG"),
    $20gJU("fVSeO"),
    $20gJU("kEtNc"),
    $20gJU("02UhU"),
    $20gJU("1LFip"),
    $20gJU("gbkwR"),
    $20gJU("35wUL"),
    $20gJU("ei4gN"),
    $20gJU("jOsRz"),
    $20gJU("gO1e8"),
    $20gJU("4DzDA"),
    $20gJU("lanIe"),
    $20gJU("lfJSz"),
    $20gJU("4CLKA"),
    $20gJU("atyGP"),
    $20gJU("2fA9Q"),
    $20gJU("59v4P"),
    $20gJU("3MWWk"),
    $20gJU("6y1PR"),
    $20gJU("67nVR")
]).then(()=>parcelRequire('7R4XE'));

});

parcelRegister("lHQ6G", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = Promise.all([
    $20gJU("jOsRz"),
    $20gJU("eeFSj"),
    $20gJU("6y1PR"),
    $20gJU("8nf1l")
]).then(()=>parcelRequire('l8zUz'));

});

parcelRegister("cYiqF", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = Promise.all([
    $20gJU("jOsRz"),
    $20gJU("25yRO")
]).then(()=>parcelRequire('7gMoN'));

});

parcelRegister("hvPcI", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = Promise.all([
    $20gJU("jOsRz"),
    $20gJU("eeFSj"),
    $20gJU("6y1PR"),
    $20gJU("8nf1l")
]).then(()=>parcelRequire('ieuG6'));

});

parcelRegister("fwrRN", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = Promise.all([
    $20gJU("jOsRz"),
    $20gJU("dMnjs"),
    $20gJU("bFpnu"),
    $20gJU("d11q3"),
    $20gJU("59v4P"),
    $20gJU("3MWWk"),
    $20gJU("6y1PR"),
    $20gJU("aOg0l")
]).then(()=>parcelRequire('3gu2l'));

});

parcelRegister("gSZP1", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = Promise.all([
    $20gJU("jOsRz"),
    $20gJU("25yRO")
]).then(()=>parcelRequire('59nED'));

});


parcelRegister("juxxB", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("b0H3N").then(()=>parcelRequire('5hjYZ'));

});

parcelRegister("jG15d", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("7yCke").then(()=>parcelRequire('3NQ5H'));

});

parcelRegister("2riAN", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("5kCDp").then(()=>parcelRequire('camXG'));

});

parcelRegister("7b32I", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("6p0GC").then(()=>parcelRequire('ds4f3'));

});

parcelRegister("avQPH", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("1C0D7").then(()=>parcelRequire('5qSjm'));

});

parcelRegister("f6Jgj", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("6p0GC").then(()=>parcelRequire('3pG42'));

});

parcelRegister("hKHxs", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("7Ix5n").then(()=>parcelRequire('cYfH3'));

});

parcelRegister("9rhKM", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("7vVPK").then(()=>parcelRequire('e4PcR'));

});

parcelRegister("csGK9", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("k70IZ").then(()=>parcelRequire('77moQ'));

});

parcelRegister("fwThl", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("60W3W").then(()=>parcelRequire('15sm2'));

});

parcelRegister("5GKSC", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("5Nrbt").then(()=>parcelRequire('6Mvv3'));

});

parcelRegister("bIokc", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("aOpBt").then(()=>parcelRequire('h9EJE'));

});

parcelRegister("kYfhk", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("3sbC6").then(()=>parcelRequire('7Ue0t'));

});

parcelRegister("eCTN4", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("1C0D7").then(()=>parcelRequire('anbLc'));

});

parcelRegister("cHB8h", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("yKyom").then(()=>parcelRequire('9tHtz'));

});

parcelRegister("2VEeA", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("54fax").then(()=>parcelRequire('eX0Yw'));

});

parcelRegister("7XuIO", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("6Fe8G").then(()=>parcelRequire('duIiO'));

});

parcelRegister("7BXaG", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("ifiLK").then(()=>parcelRequire('cbtvO'));

});

parcelRegister("lETpY", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("2oNZI").then(()=>parcelRequire('846kB'));

});

parcelRegister("bpbMK", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("dbRm8").then(()=>parcelRequire('gDHAj'));

});

parcelRegister("9lnx2", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("54fax").then(()=>parcelRequire('lTtph'));

});

parcelRegister("5SN7Z", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("7Ix5n").then(()=>parcelRequire('8SwjV'));

});

parcelRegister("jLul9", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("cyGaO").then(()=>parcelRequire('1VpIi'));

});

parcelRegister("5qw06", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("6Fe8G").then(()=>parcelRequire('2PFmn'));

});

parcelRegister("hAkSR", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = Promise.all([
    $20gJU("jOsRz"),
    $20gJU("25yRO")
]).then(()=>parcelRequire('bfKbR'));

});

parcelRegister("2PxKQ", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("OYKdS").then(()=>parcelRequire('729GH'));

});

parcelRegister("5rsEs", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("9OF49").then(()=>parcelRequire('8Lz3J'));

});

parcelRegister("g2sj8", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("knUEM").then(()=>parcelRequire('azzsn'));

});

parcelRegister("lGJlF", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("egnDe").then(()=>parcelRequire('6g98o'));

});

parcelRegister("4WiOL", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("3Y5YE").then(()=>parcelRequire('8gST1'));

});

parcelRegister("6LSxc", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("giktw").then(()=>parcelRequire('gCn1q'));

});

parcelRegister("bDBsq", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("5Nrbt").then(()=>parcelRequire('j13U6'));

});

parcelRegister("dKGoH", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("7vVPK").then(()=>parcelRequire('imsfy'));

});

parcelRegister("29IKQ", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("1C0D7").then(()=>parcelRequire('bKOCh'));

});

parcelRegister("ai86H", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("60W3W").then(()=>parcelRequire('aekjR'));

});

parcelRegister("bob7G", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("1OtZK").then(()=>parcelRequire('jWPk1'));

});

parcelRegister("jOyDS", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("gf5xk").then(()=>parcelRequire('lrzEC'));

});

parcelRegister("5dozx", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("8wATD").then(()=>parcelRequire('aXoR6'));

});

parcelRegister("6owbF", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("1C0D7").then(()=>parcelRequire('4bfP1'));

});

parcelRegister("40N3F", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("60W3W").then(()=>parcelRequire('jkCJs'));

});

parcelRegister("h7xEv", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("gf5xk").then(()=>parcelRequire('f5tEc'));

});

parcelRegister("1vmGS", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("5D0iQ").then(()=>parcelRequire('fSNQf'));

});

parcelRegister("9Da1W", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("3sbC6").then(()=>parcelRequire('le70M'));

});

parcelRegister("eiZIW", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("3sbC6").then(()=>parcelRequire('9UfMd'));

});

parcelRegister("a58gJ", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("yKyom").then(()=>parcelRequire('jnDXh'));

});

parcelRegister("ieKTK", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("giktw").then(()=>parcelRequire('6ITva'));

});

parcelRegister("kPkcD", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("4mpn5").then(()=>parcelRequire('cVcsr'));

});

parcelRegister("40dvu", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("ZiyFn").then(()=>parcelRequire('3vk6P'));

});

parcelRegister("6VVKf", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("60W3W").then(()=>parcelRequire('h0EFk'));

});

parcelRegister("ltaZD", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("yKyom").then(()=>parcelRequire('gPTse'));

});

parcelRegister("gjbXJ", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("dbRm8").then(()=>parcelRequire('kclny'));

});

parcelRegister("bdxxN", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("kUUJR").then(()=>parcelRequire('jCjXY'));

});

parcelRegister("ge7es", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("gTcD1").then(()=>parcelRequire('jMSbJ'));

});

parcelRegister("gLmeJ", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("45d7s").then(()=>parcelRequire('8Zrrb'));

});

parcelRegister("hQvOA", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("1C0D7").then(()=>parcelRequire('3wauM'));

});

parcelRegister("dXfxI", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("2oNZI").then(()=>parcelRequire('kz8uD'));

});

parcelRegister("k9Fak", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("45d7s").then(()=>parcelRequire('052Qp'));

});

parcelRegister("nYE9H", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("7vVPK").then(()=>parcelRequire('g6pM2'));

});

parcelRegister("5C7V9", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("1C0D7").then(()=>parcelRequire('5qNqK'));

});

parcelRegister("iL4Gu", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("60W3W").then(()=>parcelRequire('1nuUc'));

});

parcelRegister("3K8N7", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("gEzjU").then(()=>parcelRequire('fJD32'));

});

parcelRegister("4aIUG", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = Promise.all([
    $20gJU("jOsRz"),
    $20gJU("k12fx")
]).then(()=>parcelRequire('44GpG'));

});

parcelRegister("cczCX", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("gEzjU").then(()=>parcelRequire('hLoh7'));

});

parcelRegister("haGAz", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("giktw").then(()=>parcelRequire('6VYZ0'));

});

parcelRegister("gE99F", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("5Nrbt").then(()=>parcelRequire('f1CeM'));

});

parcelRegister("kTQ7A", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("gbNmQ").then(()=>parcelRequire('aJiYm'));

});

parcelRegister("gEbQr", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("kdw2u").then(()=>parcelRequire('galVy'));

});

parcelRegister("em0Ul", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("5kCDp").then(()=>parcelRequire('g6H9Q'));

});

parcelRegister("c5DMb", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("egnDe").then(()=>parcelRequire('jpnjj'));

});

parcelRegister("ibDEC", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("gf5xk").then(()=>parcelRequire('6Rc4m'));

});

parcelRegister("99vq6", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("6p0GC").then(()=>parcelRequire('iaG09'));

});

parcelRegister("ccpOD", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("cvdfU").then(()=>parcelRequire('9uICG'));

});

parcelRegister("16as1", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("cyGaO").then(()=>parcelRequire('kFggt'));

});

parcelRegister("6w3SL", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("54fax").then(()=>parcelRequire('cdue2'));

});

parcelRegister("7jfbo", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("60W3W").then(()=>parcelRequire('9agbN'));

});

parcelRegister("fPM10", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("45d7s").then(()=>parcelRequire('i8HB3'));

});

parcelRegister("aFAkb", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("2oNZI").then(()=>parcelRequire('iRHld'));

});

parcelRegister("bfYZ2", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("ZiyFn").then(()=>parcelRequire('iKMAj'));

});

parcelRegister("8ks7T", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("5D0iQ").then(()=>parcelRequire('gq3i4'));

});

parcelRegister("h4zk6", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("60W3W").then(()=>parcelRequire('kvirk'));

});

parcelRegister("8KsWf", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("kdw2u").then(()=>parcelRequire('lYycK'));

});

parcelRegister("jM9yH", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("b0H3N").then(()=>parcelRequire('hVjef'));

});

parcelRegister("ilOLc", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("8wATD").then(()=>parcelRequire('fcmE9'));

});

parcelRegister("hf5Dc", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("gTcD1").then(()=>parcelRequire('dnPXu'));

});

parcelRegister("e91b3", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("1C0D7").then(()=>parcelRequire('l2Oqe'));

});

parcelRegister("bGLjt", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("cvdfU").then(()=>parcelRequire('k06rb'));

});

parcelRegister("j6vLS", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("cY6r5").then(()=>parcelRequire('liPvE'));

});

parcelRegister("6Djv8", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("ifiLK").then(()=>parcelRequire('71gsF'));

});

parcelRegister("lVKqf", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("1C0D7").then(()=>parcelRequire('dcmVZ'));

});

parcelRegister("lcffS", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("60W3W").then(()=>parcelRequire('kN9ug'));

});

parcelRegister("7TfnW", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("4iiR5").then(()=>parcelRequire('2QmHW'));

});

parcelRegister("d4jbC", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("bJLcy").then(()=>parcelRequire('eNWga'));

});

parcelRegister("aJYAb", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("cY6r5").then(()=>parcelRequire('kDyTE'));

});

parcelRegister("4EXMn", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("ZiyFn").then(()=>parcelRequire('hk3nc'));

});

parcelRegister("dLk4E", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("3sbC6").then(()=>parcelRequire('4AX4k'));

});

parcelRegister("gzIGM", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("8wATD").then(()=>parcelRequire('eFrMD'));

});

parcelRegister("jnUe2", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("gTcD1").then(()=>parcelRequire('f9soP'));

});

parcelRegister("3ULI9", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("ifiLK").then(()=>parcelRequire('eDjeE'));

});

parcelRegister("51Byv", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("yKyom").then(()=>parcelRequire('eZW6G'));

});

parcelRegister("7GOwe", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("yKyom").then(()=>parcelRequire('bGp40'));

});

parcelRegister("fDrhX", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("egnDe").then(()=>parcelRequire('agl14'));

});

parcelRegister("e2mID", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("4mpn5").then(()=>parcelRequire('cn4jy'));

});

parcelRegister("abXfI", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("7vVPK").then(()=>parcelRequire('iUpGZ'));

});

parcelRegister("b9Y2u", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("f9XFu").then(()=>parcelRequire('b7i5Q'));

});

parcelRegister("VJ3zl", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("yKyom").then(()=>parcelRequire('6jhyE'));

});

parcelRegister("fIsmW", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("6Fe8G").then(()=>parcelRequire('19U4P'));

});

parcelRegister("khxTS", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("aOpBt").then(()=>parcelRequire('aDxrL'));

});

parcelRegister("1SrpM", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("ZiyFn").then(()=>parcelRequire('sRqoQ'));

});

parcelRegister("hV9E4", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("yKyom").then(()=>parcelRequire('3Rhj4'));

});

parcelRegister("1ODwD", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("60W3W").then(()=>parcelRequire('dYbE3'));

});

parcelRegister("99sy1", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("k70IZ").then(()=>parcelRequire('eJAiH'));

});

parcelRegister("a5ODZ", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("f9XFu").then(()=>parcelRequire('lrKjt'));

});

parcelRegister("5nfSs", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("kUUJR").then(()=>parcelRequire('2meH3'));

});

parcelRegister("bHwfi", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("cyGaO").then(()=>parcelRequire('2eC5G'));

});

parcelRegister("41FIO", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("knUEM").then(()=>parcelRequire('5wJHt'));

});

parcelRegister("27W1P", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("5D0iQ").then(()=>parcelRequire('7GW5F'));

});

parcelRegister("jWm6m", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("dbRm8").then(()=>parcelRequire('4NJYy'));

});

parcelRegister("jzK5z", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("gTcD1").then(()=>parcelRequire('262Zn'));

});

parcelRegister("cgFkE", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("8wATD").then(()=>parcelRequire('6Lahd'));

});

parcelRegister("8brxU", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("yKyom").then(()=>parcelRequire('aVSEO'));

});

parcelRegister("gHf6Y", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("jTY28").then(()=>parcelRequire('kA9rQ'));

});

parcelRegister("ahsjd", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("9vW80").then(()=>parcelRequire('7unH0'));

});

parcelRegister("jmQi0", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("1OtZK").then(()=>parcelRequire('bhMQB'));

});

parcelRegister("72LDO", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("5kCDp").then(()=>parcelRequire('3qwli'));

});

parcelRegister("kZ2oc", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("ifiLK").then(()=>parcelRequire('20iJ7'));

});

parcelRegister("lvicC", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("7yCke").then(()=>parcelRequire('lo0gZ'));

});

parcelRegister("17beQ", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("byUhc").then(()=>parcelRequire('3i9BQ'));

});

parcelRegister("lGf4Y", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("3Y5YE").then(()=>parcelRequire('cmzzi'));

});

parcelRegister("7pIqO", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("aOpBt").then(()=>parcelRequire('3H8FM'));

});

parcelRegister("4xiB6", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("4mpn5").then(()=>parcelRequire('3hmZ8'));

});

parcelRegister("l1A2T", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("gbNmQ").then(()=>parcelRequire('l3YlN'));

});

parcelRegister("54KLF", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("f6UPB").then(()=>parcelRequire('7DECC'));

});

parcelRegister("8quJE", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("4mpn5").then(()=>parcelRequire('27wXn'));

});

parcelRegister("8d9sb", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("cvdfU").then(()=>parcelRequire('dioX9'));

});

parcelRegister("2Td8X", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("cyGaO").then(()=>parcelRequire('l24ul'));

});

parcelRegister("jHIgJ", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("byUhc").then(()=>parcelRequire('1OOFb'));

});

parcelRegister("kbaUP", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("f6UPB").then(()=>parcelRequire('ls4N5'));

});

parcelRegister("aD7wK", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("3Y5YE").then(()=>parcelRequire('8Wela'));

});

parcelRegister("5kBZV", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("7Ix5n").then(()=>parcelRequire('41u5j'));

});

parcelRegister("7ROw6", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = $20gJU("cyGaO").then(()=>parcelRequire('3YWKZ'));

});

parcelRegister("5oM6j", function(module, exports) {
$parcel$export(module.exports, "default", () => $a1c554d680f8a474$export$2e2bcd8739ae039);
$parcel$export(module.exports, "addUFOCustomData", () => $a1c554d680f8a474$export$d12f56a472cdbe6c);

var $4tluv = parcelRequire("4tluv");

var $f6Olw = parcelRequire("f6Olw");

var $kPZVD = parcelRequire("kPZVD");

var $dWn9F = parcelRequire("dWn9F");
function $a1c554d680f8a474$export$2e2bcd8739ae039({ data: data }) {
    const interactionContext = (0, $4tluv.useContext)((0, $f6Olw.default));
    (0, $4tluv.useMemo)(()=>{
        if (!interactionContext) return;
        if (typeof globalThis?.structuredClone === 'function') interactionContext.addCustomData(globalThis.structuredClone(data));
        else interactionContext.addCustomData(data);
    }, [
        data,
        interactionContext
    ]);
    return null;
}
function $a1c554d680f8a474$export$d12f56a472cdbe6c(data) {
    const interactionId = (0, $kPZVD.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    if (typeof globalThis?.structuredClone === 'function') (0, $dWn9F.addCustomData)(currentInteractionId, [], globalThis.structuredClone(data));
    else (0, $dWn9F.addCustomData)(currentInteractionId, [], data);
}

});

parcelRegister("3d7IG", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = Promise.all([
    $20gJU("jOsRz"),
    $20gJU("k12fx")
]).then(()=>parcelRequire('7z7ba'));

});

parcelRegister("ej7At", function(module, exports) {

var $20gJU = parcelRequire("20gJU");
module.exports = Promise.all([
    $20gJU("jOsRz"),
    $20gJU("59v4P"),
    $20gJU("aV9zV")
]).then(()=>parcelRequire('6K9xo'));

});

parcelRegister("h8GVL", function(module, exports) {
$parcel$export(module.exports, "createStrictAPI", () => $c7a47c2883644525$export$39716b4af53f4ad);

var $akybX = parcelRequire("akybX");

var $3yCbE = parcelRequire("3yCbE");
function $c7a47c2883644525$export$39716b4af53f4ad() {
    return {
        css () {
            throw (0, $akybX.createStrictSetupError)();
        },
        cssMap () {
            throw (0, $akybX.createStrictSetupError)();
        },
        cx: $3yCbE.cx,
        XCSSProp () {
            throw (0, $akybX.createStrictSetupError)();
        }
    };
}

});
parcelRegister("akybX", function(module, exports) {
$parcel$export(module.exports, "createStrictSetupError", () => $78564b6f36491d9e$export$c4df1cb0c2b4d77c);
const $78564b6f36491d9e$export$6c9a87045746941d = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. This could have happened because:

  1. You haven't configured a transformer yet. Visit https://compiledcssinjs.com/docs/installation and follow the instructions.
  2. You have duplicate versions of React and hooks are blowing up. You need to de-duplicate your dependencies.

  Good luck!
`);
};
const $78564b6f36491d9e$export$c4df1cb0c2b4d77c = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. To resolve make sure to:

  1. Set up Compiled.
  2. Configure importSources in your Compiled config to point to the module that exports the output of createStrictAPI().

  For more information visit https://compiledcssinjs.com/docs/installation and follow the instructions.
`);
};

});


parcelRegister("laisU", function(module, exports) {
'use strict';
var $f688daf7c0231b11$var$has = Object.prototype.hasOwnProperty, $f688daf7c0231b11$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $f688daf7c0231b11$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $f688daf7c0231b11$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $f688daf7c0231b11$var$Events().__proto__) $f688daf7c0231b11$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $f688daf7c0231b11$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $f688daf7c0231b11$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $f688daf7c0231b11$var$EE(fn, context || emitter, once), evt = $f688daf7c0231b11$var$prefix ? $f688daf7c0231b11$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $f688daf7c0231b11$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $f688daf7c0231b11$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $f688daf7c0231b11$var$EventEmitter() {
    this._events = new $f688daf7c0231b11$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $f688daf7c0231b11$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($f688daf7c0231b11$var$has.call(events, name)) names.push($f688daf7c0231b11$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $f688daf7c0231b11$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $f688daf7c0231b11$var$prefix ? $f688daf7c0231b11$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $f688daf7c0231b11$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $f688daf7c0231b11$var$prefix ? $f688daf7c0231b11$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $f688daf7c0231b11$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $f688daf7c0231b11$var$prefix ? $f688daf7c0231b11$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $f688daf7c0231b11$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $f688daf7c0231b11$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $f688daf7c0231b11$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $f688daf7c0231b11$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $f688daf7c0231b11$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $f688daf7c0231b11$var$prefix ? $f688daf7c0231b11$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $f688daf7c0231b11$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $f688daf7c0231b11$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $f688daf7c0231b11$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $f688daf7c0231b11$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $f688daf7c0231b11$var$prefix ? $f688daf7c0231b11$var$prefix + event : event;
        if (this._events[evt]) $f688daf7c0231b11$var$clearEvent(this, evt);
    } else {
        this._events = new $f688daf7c0231b11$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$f688daf7c0231b11$var$EventEmitter.prototype.off = $f688daf7c0231b11$var$EventEmitter.prototype.removeListener;
$f688daf7c0231b11$var$EventEmitter.prototype.addListener = $f688daf7c0231b11$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$f688daf7c0231b11$var$EventEmitter.prefixed = $f688daf7c0231b11$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$f688daf7c0231b11$var$EventEmitter.EventEmitter = $f688daf7c0231b11$var$EventEmitter;
module.exports = $f688daf7c0231b11$var$EventEmitter;

});

parcelRegister("9APme", function(module, exports) {
$parcel$export(module.exports, "isFedRamp", () => $bb45813e8405dff3$export$64d6499adf9b2e51);

var $1D3Lk = parcelRequire("1D3Lk");
function $bb45813e8405dff3$export$64d6499adf9b2e51() {
    const global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    const env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === (0, $1D3Lk.FEDRAMP_MODERATE);
    const matches = global.location?.hostname?.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});
parcelRegister("1D3Lk", function(module, exports) {
$parcel$export(module.exports, "FEDRAMP_MODERATE", () => $63495486f217a201$export$ce553301d55c2fd8);
$parcel$export(module.exports, "COMMERCIAL", () => $63495486f217a201$export$f005e2e9f707cb5f);
$parcel$export(module.exports, "FEDRAMP_FEDEX", () => $63495486f217a201$export$bd6b5a7802d76127);
$parcel$export(module.exports, "STAGING", () => $63495486f217a201$export$a739cd5aac835909);
$parcel$export(module.exports, "PRODUCTION", () => $63495486f217a201$export$42dd0cdd351a4a9);
$parcel$export(module.exports, "DEV", () => $63495486f217a201$export$404582bc18fe4d9e);
const $63495486f217a201$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $63495486f217a201$export$f005e2e9f707cb5f = 'commercial';
const $63495486f217a201$export$bd6b5a7802d76127 = 'fedramp-fedex';
const $63495486f217a201$export$a739cd5aac835909 = 'stg';
const $63495486f217a201$export$42dd0cdd351a4a9 = 'prod';
const $63495486f217a201$export$404582bc18fe4d9e = 'dev';

});


parcelRegister("groaY", function(module, exports) {
$parcel$export(module.exports, "default", () => $a547652aca53e9c0$export$2e2bcd8739ae039);

var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $5n10H = parcelRequire("5n10H");

var $9xsIZ = parcelRequire("9xsIZ");

var $30n6g = parcelRequire("30n6g");

var $aAune = parcelRequire("aAune");

var $hqD9I = parcelRequire("hqD9I");

var $30Ztb = parcelRequire("30Ztb");

var $16rYe = parcelRequire("16rYe");
function $a547652aca53e9c0$var$getInteractionState({ isDisabled: isDisabled = false, isActive: isActive = false, isFocus: isFocus = false, isHover: isHover = false, isSelected: isSelected = false, isLoading: isLoading = false }) {
    if (isDisabled) return 'disabled';
    if (isSelected && isFocus) return 'focusSelected';
    if (isSelected) return 'selected';
    // not allowing active or focus style changes while loading
    if (!isLoading && isActive) return 'active';
    if (!isLoading && isHover) return 'hover';
    if (isFocus) return 'focus';
    return 'default';
}
const $a547652aca53e9c0$var$initial = {
    isHover: false,
    isActive: false,
    isFocus: false
};
/**
 * __Custom theme button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new`
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A custom theme button. Avoid using this component. It exists for those already using custom theming, which is hard to use and has performance issues.
 *
 * - [Examples](https://atlassian.design/components/button/examples#custom-theme-button)
 */ const $a547652aca53e9c0$var$CustomThemeButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).forwardRef(function CustomThemeButton({ appearance: // Calculate default props for use in custom themes
appearance = 'default', autoFocus: autoFocus = false, isDisabled: isDisabled = false, isSelected: isSelected = false, shouldFitContainer: shouldFitContainer = false, spacing: spacing = 'default', isLoading: isLoading = false, onMouseEnter: providedOnMouseEnter, onMouseLeave: providedOnMouseLeave, onMouseDown: providedOnMouseDown, onMouseUp: providedOnMouseUp, onFocus: providedOnFocus, onBlur: providedOnBlur, theme: theme = (0, $hqD9I.defaultThemeFn), ...rest }, ref) {
    // TODO is there a nicer way to do this?
    // Add default props back into object for spreading
    const restProps = {
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        ...rest
    };
    const [state, setState] = (0, $4tluv.useState)($a547652aca53e9c0$var$initial);
    const onMouseEnter = (0, $4tluv.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isHover: true
            }));
        if (providedOnMouseEnter) providedOnMouseEnter(event);
    }, [
        providedOnMouseEnter
    ]);
    const onMouseLeave = (0, $4tluv.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isHover: false,
                isActive: false
            }));
        if (providedOnMouseLeave) providedOnMouseLeave(event);
    }, [
        providedOnMouseLeave
    ]);
    const onMouseDown = (0, $4tluv.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isActive: true
            }));
        if (providedOnMouseDown) providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    const onMouseUp = (0, $4tluv.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isActive: false
            }));
        if (providedOnMouseUp) providedOnMouseUp(event);
    }, [
        providedOnMouseUp
    ]);
    const onFocus = (0, $4tluv.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isFocus: true
            }));
        if (providedOnFocus) providedOnFocus(event);
    }, [
        providedOnFocus
    ]);
    const onBlur = (0, $4tluv.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isFocus: false
            }));
        if (providedOnBlur) providedOnBlur(event);
    }, [
        providedOnBlur
    ]);
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $16rYe.default).Provider, {
        value: theme,
        children: /*#__PURE__*/ (0, $2iln5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5n10H))).Consumer, {
            children: ({ mode: mode })=>/*#__PURE__*/ (0, $2iln5.jsx)((0, $16rYe.default).Consumer, {
                    mode: mode,
                    state: $a547652aca53e9c0$var$getInteractionState({
                        ...state,
                        isLoading: isLoading,
                        isSelected: restProps.isSelected,
                        isDisabled: restProps.isDisabled
                    }),
                    iconIsOnlyChild: (0, $30n6g.default)(restProps),
                    isLoading: isLoading,
                    ...restProps,
                    children: ({ buttonStyles: buttonStyles })=>/*#__PURE__*/ (0, $2iln5.jsx)((0, $9xsIZ.default), {
                            ...restProps,
                            ref: ref,
                            overlay: isLoading ? /*#__PURE__*/ (0, $2iln5.jsx)((0, $aAune.default), {
                                ...restProps
                            }) : null,
                            // No need to render aria-disabled when it is false
                            "aria-disabled": isLoading || restProps['aria-disabled'],
                            onMouseEnter: onMouseEnter,
                            onMouseLeave: onMouseLeave,
                            onMouseDown: onMouseDown,
                            onMouseUp: onMouseUp,
                            onFocus: onFocus,
                            onBlur: onBlur,
                            buttonCss: (0, $30Ztb.getSpecifiers)(buttonStyles)
                        })
                })
        })
    });
}));
// Tools including enzyme rely on components having a display name
$a547652aca53e9c0$var$CustomThemeButton.displayName = 'CustomThemeButton';
var $a547652aca53e9c0$export$2e2bcd8739ae039 = $a547652aca53e9c0$var$CustomThemeButton;

});
parcelRegister("5n10H", function(module, exports) {
/**
 * @generated — manual edits won't persist!
 * Shim sources: platform/build/monorepo-utils/deprecation-removal-recovery/index.js
 * Regenerate: node platform/build/monorepo-utils/deprecation-removal-recovery/generate-shims.js
 */ 
var $lvn8a = parcelRequire("lvn8a");
module.exports = Object.assign({}, $lvn8a, {
    themed: (propsToValues)=>(props)=>{
            const vals = typeof propsToValues === 'function' ? propsToValues(props) : propsToValues;
            return vals.light;
        }
});
if ($lvn8a.__esModule) Object.defineProperty(module.exports, '__esModule', {
    value: true
});

});

parcelRegister("aAune", function(module, exports) {
$parcel$export(module.exports, "default", () => $5299125380021952$export$2e2bcd8739ae039);

var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $jJcBA = parcelRequire("jJcBA");
function $5299125380021952$var$getSpinnerAppearance({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected }) {
    if (isDisabled) return 'inherit';
    if (isSelected) return 'invert';
    if (appearance === 'primary' || appearance === 'danger') return 'invert';
    return 'inherit';
}
function $5299125380021952$export$2e2bcd8739ae039({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected, spacing: spacing = 'default' }) {
    const size = spacing === 'default' ? 'medium' : 'small';
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $jJcBA.default), {
        size: size,
        label: ", Loading",
        appearance: $5299125380021952$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        })
    });
}

});

parcelRegister("hqD9I", function(module, exports) {
$parcel$export(module.exports, "defaultThemeFn", () => $a808b5afda0c3a15$export$437a7f77d13d7916);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $a808b5afda0c3a15$export$437a7f77d13d7916(current, values) {
    return current(values);
}

});

parcelRegister("30Ztb", function(module, exports) {
$parcel$export(module.exports, "getSpecifiers", () => $bc9ef9470f5fcb06$export$643db0b8d8778e);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $bc9ef9470f5fcb06$export$643db0b8d8778e(styles) {
    return {
        '&, &:hover, &:active, &:focus, &:focus-visible, &:visited, &:disabled, &[disabled]': styles
    };
}

});

parcelRegister("16rYe", function(module, exports) {
$parcel$export(module.exports, "default", () => $7ddc01f2d1997027$export$2e2bcd8739ae039);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $5n10H = parcelRequire("5n10H");

var $c8Q76 = parcelRequire("c8Q76");
const $7ddc01f2d1997027$var$Theme = (0, $5n10H.createTheme)((themeProps)=>({
        buttonStyles: (0, $c8Q76.getCustomCss)(themeProps),
        // No styles being applied directly to spinner by default
        // Keeping this for legacy compat. We could remove it, but given
        // that we are changing theme soon there is no point
        spinnerStyles: {}
    }));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7ddc01f2d1997027$export$2e2bcd8739ae039 = $7ddc01f2d1997027$var$Theme;

});
parcelRegister("c8Q76", function(module, exports) {
$parcel$export(module.exports, "getCustomCss", () => $9fde7d07e2e1f217$export$31512de7fa606fa4);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $h47Ub = parcelRequire("h47Ub");
const $9fde7d07e2e1f217$var$stateToSelectorMap = {
    focus: '&:focus',
    focusSelected: '&:focus',
    hover: '&:hover',
    active: '&:active',
    disabled: '&[disabled]'
};
function $9fde7d07e2e1f217$export$31512de7fa606fa4({ appearance: appearance = 'default', spacing: spacing = 'default', isSelected: isSelected = false, shouldFitContainer: shouldFitContainer = false, iconIsOnlyChild: iconIsOnlyChild = false, isLoading: isLoading = false, state: state }) {
    let result = (0, $h47Ub.getCss)({
        appearance: appearance,
        spacing: spacing,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        isOnlySingleIcon: iconIsOnlyChild
    });
    // we need to disable the default browser focus styles always
    // this is because we are not expressing that we can have two pseudo states at a time
    result.outline = 'none';
    // Pulling relevant styles up to the top level
    const selector = $9fde7d07e2e1f217$var$stateToSelectorMap[state];
    if (selector) result = {
        ...result,
        ...result[selector]
    };
    if (isLoading) result = {
        ...result,
        // Pull overlay styles up to the top
        ...result['&[data-has-overlay="true"]']
    };
    // Delete all selectors and just keep root styles
    Object.keys(result).forEach((key)=>{
        // want to keep this one
        if (key === '&::-moz-focus-inner') return;
        // Not using .startsWith for ie11
        if (key.indexOf('&') === 0) delete result[key];
    });
    return result;
}

});



parcelRegister("75X5e", function(module, exports) {
$parcel$export(module.exports, "default", () => $76929a750fa1c8ef$export$2e2bcd8739ae039);

var $e5lMD = parcelRequire("e5lMD");

var $xG0ax = parcelRequire("xG0ax");
class $76929a750fa1c8ef$export$2e2bcd8739ae039 {
    static{
        this.observer = null;
    }
    static{
        this.callbacks = new Set();
    }
    constructor(callback){
        this.legacyObserver = null;
        this.callback = callback;
        $76929a750fa1c8ef$export$2e2bcd8739ae039.callbacks.add(callback);
    }
    observe() {
        if (!$76929a750fa1c8ef$export$2e2bcd8739ae039.observer) {
            $76929a750fa1c8ef$export$2e2bcd8739ae039.observer = new MutationObserver(()=>{
                const theme = (0, $xG0ax.default)();
                $76929a750fa1c8ef$export$2e2bcd8739ae039.callbacks.forEach((callback)=>callback(theme));
            });
            // Observer only needs to be configured once
            $76929a750fa1c8ef$export$2e2bcd8739ae039.observer.observe(document.documentElement, {
                attributeFilter: [
                    (0, $e5lMD.THEME_DATA_ATTRIBUTE),
                    (0, $e5lMD.COLOR_MODE_ATTRIBUTE)
                ]
            });
        }
    }
    disconnect() {
        if (this.callback) $76929a750fa1c8ef$export$2e2bcd8739ae039.callbacks.delete(this.callback);
        if ($76929a750fa1c8ef$export$2e2bcd8739ae039.callbacks.size === 0 && $76929a750fa1c8ef$export$2e2bcd8739ae039.observer) {
            $76929a750fa1c8ef$export$2e2bcd8739ae039.observer.disconnect();
            $76929a750fa1c8ef$export$2e2bcd8739ae039.observer = null;
        }
    }
}

});

parcelRegister("2ocq9", function(module, exports) {
/**
 * @generated — manual edits won't persist!
 * Shim sources: platform/build/monorepo-utils/deprecation-removal-recovery/index.js
 * Regenerate: node platform/build/monorepo-utils/deprecation-removal-recovery/generate-shims.js
 */ 
var $j6jci = parcelRequire("j6jci");
module.exports = Object.assign({}, $j6jci, {
    gridSize: ()=>8,
    borderRadius: ()=>3,
    fontSize: ()=>14,
    fontSizeSmall: ()=>11
});
if ($j6jci.__esModule) Object.defineProperty(module.exports, '__esModule', {
    value: true
});

});

parcelRegister("bnlbq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3f93f06e22108e36edaead143b4f646b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8482463ba6cb4777$var$_react = $8482463ba6cb4777$var$_interopRequireDefault((parcelRequire("4tluv")));

var $8482463ba6cb4777$var$_baseNew = $8482463ba6cb4777$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $8482463ba6cb4777$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusError".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8482463ba6cb4777$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $8482463ba6cb4777$var$_react.default.createElement($8482463ba6cb4777$var$_baseNew.default, Object.assign({
        name: "StatusErrorIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.603a2 2 0 0 1 2.828 0l5.983 5.983a2 2 0 0 1 0 2.828l-5.983 5.982a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM8 10.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.75-6.5V9h1.5V3.75z" clip-rule="evenodd"/>`
    }, props));
$8482463ba6cb4777$var$StatusErrorIcon.displayName = 'StatusErrorIcon';
var $8482463ba6cb4777$var$_default = module.exports.default = $8482463ba6cb4777$var$StatusErrorIcon;

});

parcelRegister("6o94o", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::456639fbdc991aefe1af05acf697365d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4a6c050800cca244$var$_react = $4a6c050800cca244$var$_interopRequireDefault((parcelRequire("4tluv")));

var $4a6c050800cca244$var$_baseNew = $4a6c050800cca244$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $4a6c050800cca244$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusInformation".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for information statuses and messaging. 
Filled status icons provide higher visual contrast to draw attention to important information.
For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4a6c050800cca244$var$StatusInformationIcon = (props)=>/*#__PURE__*/ $4a6c050800cca244$var$_react.default.createElement($4a6c050800cca244$var$_baseNew.default, Object.assign({
        name: "StatusInformationIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.5 6.75v1.5h.75v4.25h1.5v-5A.75.75 0 0 0 8 6.75zM8 3.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$4a6c050800cca244$var$StatusInformationIcon.displayName = 'StatusInformationIcon';
var $4a6c050800cca244$var$_default = module.exports.default = $4a6c050800cca244$var$StatusInformationIcon;

});

parcelRegister("fHnP4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::174472a7e38932dc7a97866e0be8034a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b6dd59e1d5e491bc$var$_react = $b6dd59e1d5e491bc$var$_interopRequireDefault((parcelRequire("4tluv")));

var $b6dd59e1d5e491bc$var$_baseNew = $b6dd59e1d5e491bc$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $b6dd59e1d5e491bc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusSuccess".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b6dd59e1d5e491bc$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $b6dd59e1d5e491bc$var$_react.default.createElement($b6dd59e1d5e491bc$var$_baseNew.default, Object.assign({
        name: "StatusSuccessIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0l5-6-1.152-.96z" clip-rule="evenodd"/>`
    }, props));
$b6dd59e1d5e491bc$var$StatusSuccessIcon.displayName = 'StatusSuccessIcon';
var $b6dd59e1d5e491bc$var$_default = module.exports.default = $b6dd59e1d5e491bc$var$StatusSuccessIcon;

});

parcelRegister("gm2sB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2ee7b3f114c675eea0f953c33a485bcf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $be809bf7bedaaaf1$var$_react = $be809bf7bedaaaf1$var$_interopRequireDefault((parcelRequire("4tluv")));

var $be809bf7bedaaaf1$var$_baseNew = $be809bf7bedaaaf1$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $be809bf7bedaaaf1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusWarning".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $be809bf7bedaaaf1$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $be809bf7bedaaaf1$var$_react.default.createElement($be809bf7bedaaaf1$var$_baseNew.default, Object.assign({
        name: "StatusWarningIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.168c.756-1.395 2.76-1.395 3.516 0l5.9 10.878c.723 1.333-.242 2.953-1.758 2.953H2.1C.584 15-.38 13.38.342 12.046zM8 10.75a1 1 0 1 0 0 2.001 1 1 0 0 0 0-2M7.25 4.5v5h1.5v-5z" clip-rule="evenodd"/>`
    }, props));
$be809bf7bedaaaf1$var$StatusWarningIcon.displayName = 'StatusWarningIcon';
var $be809bf7bedaaaf1$var$_default = module.exports.default = $be809bf7bedaaaf1$var$StatusWarningIcon;

});

parcelRegister("1uL2b", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafSyntheticEventHandler", () => $742ab30c490ef02b$export$1a04351537078b55);

var $4tluv = parcelRequire("4tluv");

var $8ik9q = parcelRequire("8ik9q");

var $8lhHD = parcelRequire("8lhHD");
function $742ab30c490ef02b$export$1a04351537078b55({ fn: fn, action: action, componentName: componentName, packageName: packageName, packageVersion: packageVersion, analyticsData: analyticsData }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $8ik9q.useAnalyticsEvents)();
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    const dataRef = (0, $8lhHD.useTrackedRef)(analyticsData);
    const fnRef = (0, $8lhHD.useTrackedRef)(fn);
    const handler = (0, $4tluv.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        const context = {
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion,
            ...dataRef.current
        };
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        const clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});

parcelRegister("l6Otc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d56e8662eb8a8d2462ec3a39ff3aa40b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f5e14ec620d4c705$var$_react = $f5e14ec620d4c705$var$_interopRequireDefault((parcelRequire("4tluv")));

var $f5e14ec620d4c705$var$_baseNew = $f5e14ec620d4c705$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $f5e14ec620d4c705$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f5e14ec620d4c705$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $f5e14ec620d4c705$var$_react.default.createElement($f5e14ec620d4c705$var$_baseNew.default, Object.assign({
        name: "ChevronDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$f5e14ec620d4c705$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $f5e14ec620d4c705$var$_default = module.exports.default = $f5e14ec620d4c705$var$ChevronDownIcon;

});

parcelRegister("iCx26", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b6f832dcdc2d7a1f91afd5e9b90e10b9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d8e5663c9ec7dbdc$var$_react = $d8e5663c9ec7dbdc$var$_interopRequireDefault((parcelRequire("4tluv")));

var $d8e5663c9ec7dbdc$var$_baseNew = $d8e5663c9ec7dbdc$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $d8e5663c9ec7dbdc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Close dropdown menu
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d8e5663c9ec7dbdc$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $d8e5663c9ec7dbdc$var$_react.default.createElement($d8e5663c9ec7dbdc$var$_baseNew.default, Object.assign({
        name: "ChevronUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 9.97-6-6a.75.75 0 0 0-1.004-.052l-.056.052-6 6 1.06 1.06L8 5.56l5.47 5.47z"/>`
    }, props));
$d8e5663c9ec7dbdc$var$ChevronUpIcon.displayName = 'ChevronUpIcon';
var $d8e5663c9ec7dbdc$var$_default = module.exports.default = $d8e5663c9ec7dbdc$var$ChevronUpIcon;

});

parcelRegister("eHCM0", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $ab43286ae608b25d$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
module.exports = $ab43286ae608b25d$var$invariant;

});

parcelRegister("dIGjm", function(module, exports) {
//
module.exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};

});

parcelRegister("1r8Gx", function(module, exports) {
$parcel$export(module.exports, "default", () => $8ee09ccd35df4686$export$2e2bcd8739ae039);

var $4tluv = parcelRequire("4tluv");

var $xG0ax = parcelRequire("xG0ax");

var $75X5e = parcelRequire("75X5e");
/**
 * A React hook which returns the current themes and color-mode set on `<html>`.
 *
 * @example
 * ```
 * const { colorMode, dark, light, spacing, typography } = useThemeObserver();
 *
 * // Performing side effects when it changes
 * useEffect(() => {
 *   console.log(`The color mode has changed to ${theme.colorMode}`);
 * }, [theme.colorMode]);
 * ```
 */ const $8ee09ccd35df4686$var$useThemeObserver = ()=>{
    const [theme, setTheme] = (0, $4tluv.useState)((0, $xG0ax.default)());
    (0, $4tluv.useEffect)(()=>{
        const observer = new (0, $75X5e.default)((theme)=>setTheme(theme));
        observer.observe();
        return ()=>observer.disconnect();
    }, []);
    return theme;
};
var $8ee09ccd35df4686$export$2e2bcd8739ae039 = $8ee09ccd35df4686$var$useThemeObserver;

});

parcelRegister("42rJW", function(module, exports) {
$parcel$export(module.exports, "extract", () => $2f0cdde904a412e6$export$f9380c9a627682d3, (v) => $2f0cdde904a412e6$export$f9380c9a627682d3 = v);
$parcel$export(module.exports, "parse", () => $2f0cdde904a412e6$export$98e6a39c04603d36, (v) => $2f0cdde904a412e6$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "stringify", () => $2f0cdde904a412e6$export$fac44ee5b035f737, (v) => $2f0cdde904a412e6$export$fac44ee5b035f737 = v);
$parcel$export(module.exports, "parseUrl", () => $2f0cdde904a412e6$export$7a5253c0f62e0150, (v) => $2f0cdde904a412e6$export$7a5253c0f62e0150 = v);
$parcel$export(module.exports, "stringifyUrl", () => $2f0cdde904a412e6$export$a8c1621ea79325d3, (v) => $2f0cdde904a412e6$export$a8c1621ea79325d3 = v);
$parcel$export(module.exports, "pick", () => $2f0cdde904a412e6$export$357523c63a2253b9, (v) => $2f0cdde904a412e6$export$357523c63a2253b9 = v);
var $2f0cdde904a412e6$export$f9380c9a627682d3;
var $2f0cdde904a412e6$export$98e6a39c04603d36;
var $2f0cdde904a412e6$export$fac44ee5b035f737;
var $2f0cdde904a412e6$export$7a5253c0f62e0150;
var $2f0cdde904a412e6$export$a8c1621ea79325d3;
var $2f0cdde904a412e6$export$357523c63a2253b9;
var $2f0cdde904a412e6$export$44c361b8ec72ef7f;
'use strict';

var $bt98Q = parcelRequire("bt98Q");

var $nN9X0 = parcelRequire("nN9X0");

var $bgUIF = parcelRequire("bgUIF");

var $2npV5 = parcelRequire("2npV5");
const $2f0cdde904a412e6$var$isNullOrUndefined = (value)=>value === null || value === undefined;
const $2f0cdde904a412e6$var$encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');
function $2f0cdde904a412e6$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case 'index':
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $2f0cdde904a412e6$var$encode(key, options),
                            '[',
                            index,
                            ']'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $2f0cdde904a412e6$var$encode(key, options),
                            '[',
                            $2f0cdde904a412e6$var$encode(index, options),
                            ']=',
                            $2f0cdde904a412e6$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'bracket':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $2f0cdde904a412e6$var$encode(key, options),
                            '[]'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $2f0cdde904a412e6$var$encode(key, options),
                            '[]=',
                            $2f0cdde904a412e6$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'colon-list-separator':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $2f0cdde904a412e6$var$encode(key, options),
                            ':list='
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $2f0cdde904a412e6$var$encode(key, options),
                            ':list=',
                            $2f0cdde904a412e6$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'comma':
        case 'separator':
        case 'bracket-separator':
            {
                const keyValueSep = options.arrayFormat === 'bracket-separator' ? '[]=' : '=';
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? '' : value;
                        if (result.length === 0) return [
                            [
                                $2f0cdde904a412e6$var$encode(key, options),
                                keyValueSep,
                                $2f0cdde904a412e6$var$encode(value, options)
                            ].join('')
                        ];
                        return [
                            [
                                result,
                                $2f0cdde904a412e6$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        $2f0cdde904a412e6$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $2f0cdde904a412e6$var$encode(key, options),
                            '=',
                            $2f0cdde904a412e6$var$encode(value, options)
                        ].join('')
                    ];
                };
    }
}
function $2f0cdde904a412e6$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case 'index':
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case 'bracket':
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'colon-list-separator':
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'comma':
        case 'separator':
            return (key, value, accumulator)=>{
                const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === 'string' && !isArray && $2f0cdde904a412e6$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $2f0cdde904a412e6$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$2f0cdde904a412e6$var$decode(item, options)) : value === null ? value : $2f0cdde904a412e6$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case 'bracket-separator':
            return (key, value, accumulator)=>{
                const isArray = /(\[\])$/.test(key);
                key = key.replace(/\[\]$/, '');
                if (!isArray) {
                    accumulator[key] = value ? $2f0cdde904a412e6$var$decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$2f0cdde904a412e6$var$decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], arrayValue);
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $2f0cdde904a412e6$var$validateArrayFormatSeparator(value) {
    if (typeof value !== 'string' || value.length !== 1) throw new TypeError('arrayFormatSeparator must be single character string');
}
function $2f0cdde904a412e6$var$encode(value, options) {
    if (options.encode) return options.strict ? $bt98Q(value) : encodeURIComponent(value);
    return value;
}
function $2f0cdde904a412e6$var$decode(value, options) {
    if (options.decode) return $nN9X0(value);
    return value;
}
function $2f0cdde904a412e6$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === 'object') return $2f0cdde904a412e6$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $2f0cdde904a412e6$var$removeHash(input) {
    const hashStart = input.indexOf('#');
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $2f0cdde904a412e6$var$getHash(url) {
    let hash = '';
    const hashStart = url.indexOf('#');
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $2f0cdde904a412e6$var$extract(input) {
    input = $2f0cdde904a412e6$var$removeHash(input);
    const queryStart = input.indexOf('?');
    if (queryStart === -1) return '';
    return input.slice(queryStart + 1);
}
function $2f0cdde904a412e6$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) value = value.toLowerCase() === 'true';
    return value;
}
function $2f0cdde904a412e6$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ',',
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $2f0cdde904a412e6$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $2f0cdde904a412e6$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== 'string') return ret;
    query = query.trim().replace(/^[?#&]/, '');
    if (!query) return ret;
    for (const param of query.split('&')){
        if (param === '') continue;
        let [key, value] = $bgUIF(options.decode ? param.replace(/\+/g, ' ') : param, '=');
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            'comma',
            'separator',
            'bracket-separator'
        ].includes(options.arrayFormat) ? value : $2f0cdde904a412e6$var$decode(value, options);
        formatter($2f0cdde904a412e6$var$decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === 'object' && value !== null) for (const k of Object.keys(value))value[k] = $2f0cdde904a412e6$var$parseValue(value[k], options);
        else ret[key] = $2f0cdde904a412e6$var$parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $2f0cdde904a412e6$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$2f0cdde904a412e6$export$f9380c9a627682d3 = $2f0cdde904a412e6$var$extract;
$2f0cdde904a412e6$export$98e6a39c04603d36 = $2f0cdde904a412e6$var$parse;
$2f0cdde904a412e6$export$fac44ee5b035f737 = (object, options)=>{
    if (!object) return '';
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ','
    }, options);
    $2f0cdde904a412e6$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $2f0cdde904a412e6$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === '';
    const formatter = $2f0cdde904a412e6$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return '';
        if (value === null) return $2f0cdde904a412e6$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === 'bracket-separator') return $2f0cdde904a412e6$var$encode(key, options) + '[]';
            return value.reduce(formatter(key), []).join('&');
        }
        return $2f0cdde904a412e6$var$encode(key, options) + '=' + $2f0cdde904a412e6$var$encode(value, options);
    }).filter((x)=>x.length > 0).join('&');
};
$2f0cdde904a412e6$export$7a5253c0f62e0150 = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = $bgUIF(url, '#');
    return Object.assign({
        url: url_.split('?')[0] || '',
        query: $2f0cdde904a412e6$var$parse($2f0cdde904a412e6$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $2f0cdde904a412e6$var$decode(hash, options)
    } : {});
};
$2f0cdde904a412e6$export$a8c1621ea79325d3 = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true,
        [$2f0cdde904a412e6$var$encodeFragmentIdentifier]: true
    }, options);
    const url = $2f0cdde904a412e6$var$removeHash(object.url).split('?')[0] || '';
    const queryFromUrl = $2f0cdde904a412e6$export$f9380c9a627682d3(object.url);
    const parsedQueryFromUrl = $2f0cdde904a412e6$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = $2f0cdde904a412e6$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $2f0cdde904a412e6$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${options[$2f0cdde904a412e6$var$encodeFragmentIdentifier] ? $2f0cdde904a412e6$var$encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
    return `${url}${queryString}${hash}`;
};
$2f0cdde904a412e6$export$357523c63a2253b9 = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true,
        [$2f0cdde904a412e6$var$encodeFragmentIdentifier]: false
    }, options);
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $2f0cdde904a412e6$export$7a5253c0f62e0150(input, options);
    return $2f0cdde904a412e6$export$a8c1621ea79325d3({
        url: url,
        query: $2npV5(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$2f0cdde904a412e6$export$44c361b8ec72ef7f = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $2f0cdde904a412e6$export$357523c63a2253b9(input, exclusionFilter, options);
};

});
parcelRegister("bt98Q", function(module, exports) {
'use strict';
module.exports = (str)=>encodeURIComponent(str).replace(/[!'()*]/g, (x)=>`%${x.charCodeAt(0).toString(16).toUpperCase()}`);

});

parcelRegister("nN9X0", function(module, exports) {
'use strict';
var $04784826284ed285$var$token = '%[a-f0-9]{2}';
var $04784826284ed285$var$singleMatcher = new RegExp('(' + $04784826284ed285$var$token + ')|([^%]+?)', 'gi');
var $04784826284ed285$var$multiMatcher = new RegExp('(' + $04784826284ed285$var$token + ')+', 'gi');
function $04784826284ed285$var$decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return [
            decodeURIComponent(components.join(''))
        ];
    } catch (err) {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    var left = components.slice(0, split);
    var right = components.slice(split);
    return Array.prototype.concat.call([], $04784826284ed285$var$decodeComponents(left), $04784826284ed285$var$decodeComponents(right));
}
function $04784826284ed285$var$decode(input) {
    try {
        return decodeURIComponent(input);
    } catch (err) {
        var tokens = input.match($04784826284ed285$var$singleMatcher) || [];
        for(var i = 1; i < tokens.length; i++){
            input = $04784826284ed285$var$decodeComponents(tokens, i).join('');
            tokens = input.match($04784826284ed285$var$singleMatcher) || [];
        }
        return input;
    }
}
function $04784826284ed285$var$customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    var replaceMap = {
        '%FE%FF': '\uFFFD\uFFFD',
        '%FF%FE': '\uFFFD\uFFFD'
    };
    var match = $04784826284ed285$var$multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch (err) {
            var result = $04784826284ed285$var$decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = $04784826284ed285$var$multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap['%C2'] = '\uFFFD';
    var entries = Object.keys(replaceMap);
    for(var i = 0; i < entries.length; i++){
        // Replace all decoded components
        var key = entries[i];
        input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
    }
    return input;
}
module.exports = function(encodedURI) {
    if (typeof encodedURI !== 'string') throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
    try {
        encodedURI = encodedURI.replace(/\+/g, ' ');
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch (err) {
        // Fallback to a more advanced decoder
        return $04784826284ed285$var$customDecodeURIComponent(encodedURI);
    }
};

});

parcelRegister("bgUIF", function(module, exports) {
'use strict';
module.exports = (string, separator)=>{
    if (!(typeof string === 'string' && typeof separator === 'string')) throw new TypeError('Expected the arguments to be of type `string`');
    if (separator === '') return [
        string
    ];
    const separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [
        string
    ];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
};

});

parcelRegister("2npV5", function(module, exports) {
'use strict';
module.exports = function(obj, predicate) {
    var ret = {};
    var keys = Object.keys(obj);
    var isArr = Array.isArray(predicate);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var val = obj[key];
        if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) ret[key] = val;
    }
    return ret;
};

});


parcelRegister("ife0G", function(module, exports) {
$parcel$export(module.exports, "default", () => $d4847ed0f5c6782e$export$2e2bcd8739ae039);
var $d4847ed0f5c6782e$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function $d4847ed0f5c6782e$var$isEqual(first, second) {
    if (first === second) return true;
    if ($d4847ed0f5c6782e$var$safeIsNaN(first) && $d4847ed0f5c6782e$var$safeIsNaN(second)) return true;
    return false;
}
function $d4847ed0f5c6782e$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$d4847ed0f5c6782e$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $d4847ed0f5c6782e$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $d4847ed0f5c6782e$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}

});

parcelRegister("76EzV", function(module, exports) {
$parcel$export(module.exports, "default", () => $52c891f36ad3ce78$export$2e2bcd8739ae039);

var $anlFg = parcelRequire("anlFg");

var $lrPmF = parcelRequire("lrPmF");

var $fOyCv = parcelRequire("fOyCv");
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $52c891f36ad3ce78$var$compareLocalAsc(dateLeft, dateRight) {
    var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}
function $52c891f36ad3ce78$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $fOyCv.default)(2, arguments);
    var dateLeft = (0, $anlFg.default)(dirtyDateLeft);
    var dateRight = (0, $anlFg.default)(dirtyDateRight);
    var sign = $52c891f36ad3ce78$var$compareLocalAsc(dateLeft, dateRight);
    var difference = Math.abs((0, $lrPmF.default)(dateLeft, dateRight));
    dateLeft.setDate(dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastDayNotFull = Number($52c891f36ad3ce78$var$compareLocalAsc(dateLeft, dateRight) === -sign);
    var result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});
parcelRegister("anlFg", function(module, exports) {
$parcel$export(module.exports, "default", () => $78dcdb78de0cc690$export$2e2bcd8739ae039);

var $bd2WF = parcelRequire("bd2WF");

var $fOyCv = parcelRequire("fOyCv");
function $78dcdb78de0cc690$export$2e2bcd8739ae039(argument) {
    (0, $fOyCv.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $bd2WF.default)(argument) === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}

});
parcelRegister("bd2WF", function(module, exports) {
$parcel$export(module.exports, "default", () => $8293317b3c1bb2b3$export$2e2bcd8739ae039);
function $8293317b3c1bb2b3$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $8293317b3c1bb2b3$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $8293317b3c1bb2b3$export$2e2bcd8739ae039(o);
}

});

parcelRegister("fOyCv", function(module, exports) {
$parcel$export(module.exports, "default", () => $b83661599cf236f1$export$2e2bcd8739ae039);
function $b83661599cf236f1$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}

});


parcelRegister("lrPmF", function(module, exports) {
$parcel$export(module.exports, "default", () => $f9d3f6860bd30683$export$2e2bcd8739ae039);

var $iICw1 = parcelRequire("iICw1");

var $4nP3K = parcelRequire("4nP3K");

var $fOyCv = parcelRequire("fOyCv");
var $f9d3f6860bd30683$var$MILLISECONDS_IN_DAY = 86400000;
function $f9d3f6860bd30683$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $fOyCv.default)(2, arguments);
    var startOfDayLeft = (0, $4nP3K.default)(dirtyDateLeft);
    var startOfDayRight = (0, $4nP3K.default)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, $iICw1.default)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, $iICw1.default)(startOfDayRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $f9d3f6860bd30683$var$MILLISECONDS_IN_DAY);
}

});
parcelRegister("iICw1", function(module, exports) {
$parcel$export(module.exports, "default", () => $da0a366fcfef455a$export$2e2bcd8739ae039);
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $da0a366fcfef455a$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}

});

parcelRegister("4nP3K", function(module, exports) {
$parcel$export(module.exports, "default", () => $3310eabd9d8dfba5$export$2e2bcd8739ae039);

var $anlFg = parcelRequire("anlFg");

var $fOyCv = parcelRequire("fOyCv");
function $3310eabd9d8dfba5$export$2e2bcd8739ae039(dirtyDate) {
    (0, $fOyCv.default)(1, arguments);
    var date = (0, $anlFg.default)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}

});



parcelRegister("lQcwb", function(module, exports) {
/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */ (function(factory) {
    var registeredInModuleLoader;
    if (typeof define === 'function' && define.amd) {
        define(factory);
        registeredInModuleLoader = true;
    }
    module.exports = factory();
    registeredInModuleLoader = true;
    if (!registeredInModuleLoader) {
        var OldCookies = window.Cookies;
        var api = window.Cookies = factory();
        api.noConflict = function() {
            window.Cookies = OldCookies;
            return api;
        };
    }
})(function() {
    function extend() {
        var i = 0;
        var result = {};
        for(; i < arguments.length; i++){
            var attributes = arguments[i];
            for(var key in attributes)result[key] = attributes[key];
        }
        return result;
    }
    function decode(s) {
        return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }
    function init(converter) {
        function api() {}
        function set(key, value, attributes) {
            if (typeof document === 'undefined') return;
            attributes = extend({
                path: '/'
            }, api.defaults, attributes);
            if (typeof attributes.expires === 'number') attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
            // We're using "expires" because "max-age" is not supported by IE
            attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';
            try {
                var result = JSON.stringify(value);
                if (/^[\{\[]/.test(result)) value = result;
            } catch (e) {}
            value = converter.write ? converter.write(value, key) : encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
            key = encodeURIComponent(String(key)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
            var stringifiedAttributes = '';
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += '; ' + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
            }
            return document.cookie = key + '=' + value + stringifiedAttributes;
        }
        function get(key, json) {
            if (typeof document === 'undefined') return;
            var jar = {};
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split('; ') : [];
            var i = 0;
            for(; i < cookies.length; i++){
                var parts = cookies[i].split('=');
                var cookie = parts.slice(1).join('=');
                if (!json && cookie.charAt(0) === '"') cookie = cookie.slice(1, -1);
                try {
                    var name = decode(parts[0]);
                    cookie = (converter.read || converter)(cookie, name) || decode(cookie);
                    if (json) try {
                        cookie = JSON.parse(cookie);
                    } catch (e) {}
                    jar[name] = cookie;
                    if (key === name) break;
                } catch (e) {}
            }
            return key ? jar[key] : jar;
        }
        api.set = set;
        api.get = function(key) {
            return get(key, false);
        };
        api.getJSON = function(key) {
            return get(key, true);
        };
        api.remove = function(key, attributes) {
            set(key, '', extend(attributes, {
                expires: -1
            }));
        };
        api.defaults = {};
        api.withConverter = init;
        return api;
    }
    return init(function() {});
});

});

parcelRegister("dzE3p", function(module, exports) {
'use strict';

var $f0gMU = parcelRequire("f0gMU");
/**
 * Expose `traverse`.
 */ module.exports = $9e1d9d1cf38becc7$var$traverse;
/**
 * Recursively traverse an object or array, and convert
 * all ISO date strings parse into Date objects.
 *
 * @param {Object} input - object, array, or string to convert
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */ function $9e1d9d1cf38becc7$var$traverse(input, strict) {
    if (strict === undefined) strict = true;
    if (input && typeof input === 'object') return $9e1d9d1cf38becc7$var$traverseObject(input, strict);
    else if (Array.isArray(input)) return $9e1d9d1cf38becc7$var$traverseArray(input, strict);
    else if ($f0gMU.is(input, strict)) return $f0gMU.parse(input);
    return input;
}
/**
 * Object traverser helper function.
 *
 * @param {Object} obj - object to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */ function $9e1d9d1cf38becc7$var$traverseObject(obj, strict) {
    Object.keys(obj).forEach(function(key) {
        obj[key] = $9e1d9d1cf38becc7$var$traverse(obj[key], strict);
    });
    return obj;
}
/**
 * Array traverser helper function
 *
 * @param {Array} arr - array to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Array}
 */ function $9e1d9d1cf38becc7$var$traverseArray(arr, strict) {
    arr.forEach(function(value, index) {
        arr[index] = $9e1d9d1cf38becc7$var$traverse(value, strict);
    });
    return arr;
}

});
parcelRegister("f0gMU", function(module, exports) {
$parcel$export(module.exports, "parse", () => $aec3e0cd5feebb7d$export$98e6a39c04603d36, (v) => $aec3e0cd5feebb7d$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "is", () => $aec3e0cd5feebb7d$export$226b3eccf92c9ed9, (v) => $aec3e0cd5feebb7d$export$226b3eccf92c9ed9 = v);
/**
 * Convert an ISO date string to a date. Fallback to native `Date.parse`.
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 *
 * @param {String} iso
 * @return {Date}
 */ var $aec3e0cd5feebb7d$export$98e6a39c04603d36;
/**
 * Checks whether a `string` is an ISO date string. `strict` mode requires that
 * the date string at least have a year, month and date.
 *
 * @param {String} string
 * @param {Boolean} strict
 * @return {Boolean}
 */ var $aec3e0cd5feebb7d$export$226b3eccf92c9ed9;
'use strict';
/**
 * Matcher, slightly modified from:
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 */ var $aec3e0cd5feebb7d$var$matcher = /^(\d{4})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:([ T])(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
$aec3e0cd5feebb7d$export$98e6a39c04603d36 = function(iso) {
    var numericKeys = [
        1,
        5,
        6,
        7,
        11,
        12
    ];
    var arr = $aec3e0cd5feebb7d$var$matcher.exec(iso);
    var offset = 0;
    // fallback to native parsing
    if (!arr) return new Date(iso);
    /* eslint-disable no-cond-assign */ // remove undefined values
    for(var i = 0, val; val = numericKeys[i]; i++)arr[val] = parseInt(arr[val], 10) || 0;
    /* eslint-enable no-cond-assign */ // allow undefined days and months
    arr[2] = parseInt(arr[2], 10) || 1;
    arr[3] = parseInt(arr[3], 10) || 1;
    // month is 0-11
    arr[2]--;
    // allow abitrary sub-second precision
    arr[8] = arr[8] ? (arr[8] + '00').substring(0, 3) : 0;
    // apply timezone if one exists
    if (arr[4] === ' ') offset = new Date().getTimezoneOffset();
    else if (arr[9] !== 'Z' && arr[10]) {
        offset = arr[11] * 60 + arr[12];
        if (arr[10] === '+') offset = 0 - offset;
    }
    var millis = Date.UTC(arr[1], arr[2], arr[3], arr[5], arr[6] + offset, arr[7], arr[8]);
    return new Date(millis);
};
$aec3e0cd5feebb7d$export$226b3eccf92c9ed9 = function(string, strict) {
    if (typeof string !== 'string') return false;
    if (strict && /^\d{4}-\d{2}-\d{2}/.test(string) === false) return false;
    return $aec3e0cd5feebb7d$var$matcher.test(string);
};

});


parcelRegister("kEkKo", function(module, exports) {
$parcel$export(module.exports, "default", () => $f087a3077cafae7d$export$2e2bcd8739ae039);
var $f087a3077cafae7d$var$isProduction = true;
var $f087a3077cafae7d$var$prefix = 'Invariant failed';
function $f087a3077cafae7d$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($f087a3077cafae7d$var$isProduction) throw new Error($f087a3077cafae7d$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat($f087a3077cafae7d$var$prefix, ": ").concat(provided) : $f087a3077cafae7d$var$prefix;
    throw new Error(value);
}

});

parcelRegister("iXWBi", function(module, exports) {
$parcel$export(module.exports, "default", () => $dceb318ab17a3f28$export$2e2bcd8739ae039);

var $2y77k = parcelRequire("2y77k");

var $e59eg = parcelRequire("e59eg");

var $etlKF = parcelRequire("etlKF");

var $2rhpO = parcelRequire("2rhpO");
function $dceb318ab17a3f28$export$2e2bcd8739ae039(r) {
    return (0, $2y77k.default)(r) || (0, $e59eg.default)(r) || (0, $etlKF.default)(r) || (0, $2rhpO.default)();
}

});
parcelRegister("2y77k", function(module, exports) {
$parcel$export(module.exports, "default", () => $1db44716065d75b4$export$2e2bcd8739ae039);

var $dpWgB = parcelRequire("dpWgB");
function $1db44716065d75b4$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $dpWgB.default)(r);
}

});
parcelRegister("dpWgB", function(module, exports) {
$parcel$export(module.exports, "default", () => $9c4aceb9823a9f5a$export$2e2bcd8739ae039);
function $9c4aceb9823a9f5a$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("e59eg", function(module, exports) {
$parcel$export(module.exports, "default", () => $a408b10afc664204$export$2e2bcd8739ae039);
function $a408b10afc664204$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("etlKF", function(module, exports) {
$parcel$export(module.exports, "default", () => $a894a59282f05390$export$2e2bcd8739ae039);

var $dpWgB = parcelRequire("dpWgB");
function $a894a59282f05390$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $dpWgB.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $dpWgB.default)(r, a) : void 0;
    }
}

});

parcelRegister("2rhpO", function(module, exports) {
$parcel$export(module.exports, "default", () => $1c6b9cb8a79a2f99$export$2e2bcd8739ae039);
function $1c6b9cb8a79a2f99$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("hh01j", function(module, exports) {
$parcel$export(module.exports, "default", () => $c9340a2eb631fd72$export$2e2bcd8739ae039);

var $h44eT = parcelRequire("h44eT");
function $c9340a2eb631fd72$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $h44eT.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("h44eT", function(module, exports) {
$parcel$export(module.exports, "default", () => $c6c619341eb3a65e$export$2e2bcd8739ae039);

var $bd2WF = parcelRequire("bd2WF");

var $8Xvwu = parcelRequire("8Xvwu");
function $c6c619341eb3a65e$export$2e2bcd8739ae039(t) {
    var i = (0, $8Xvwu.default)(t, "string");
    return "symbol" == (0, $bd2WF.default)(i) ? i : i + "";
}

});
parcelRegister("8Xvwu", function(module, exports) {
$parcel$export(module.exports, "default", () => $685c4941b006d237$export$2e2bcd8739ae039);

var $bd2WF = parcelRequire("bd2WF");
function $685c4941b006d237$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $bd2WF.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $bd2WF.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("9DNBn", function(module, exports) {
$parcel$export(module.exports, "default", () => $704e3b79455ff90b$export$2e2bcd8739ae039);

var $kfuau = parcelRequire("kfuau");

var $a29Lo = parcelRequire("a29Lo");

var $etlKF = parcelRequire("etlKF");

var $clfzz = parcelRequire("clfzz");
function $704e3b79455ff90b$export$2e2bcd8739ae039(r, e) {
    return (0, $kfuau.default)(r) || (0, $a29Lo.default)(r, e) || (0, $etlKF.default)(r, e) || (0, $clfzz.default)();
}

});
parcelRegister("kfuau", function(module, exports) {
$parcel$export(module.exports, "default", () => $ebdc9c246b20ff78$export$2e2bcd8739ae039);
function $ebdc9c246b20ff78$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("a29Lo", function(module, exports) {
$parcel$export(module.exports, "default", () => $74e1aa1417d84831$export$2e2bcd8739ae039);
function $74e1aa1417d84831$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("clfzz", function(module, exports) {
$parcel$export(module.exports, "default", () => $8fc3869e77cb993a$export$2e2bcd8739ae039);
function $8fc3869e77cb993a$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("bRlc1", function(module, exports) {
$parcel$export(module.exports, "default", () => $8a25156d564b051d$export$2e2bcd8739ae039);

var $gM5oA = parcelRequire("gM5oA");
function $8a25156d564b051d$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $gM5oA.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("gM5oA", function(module, exports) {
$parcel$export(module.exports, "default", () => $c365507bb4a50cf9$export$2e2bcd8739ae039);
function $c365507bb4a50cf9$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("dIQe5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2a789640350a4d3b29556a43626f35de>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9fd7e571c734b28d$var$_react = $9fd7e571c734b28d$var$_interopRequireDefault((parcelRequire("4tluv")));

var $9fd7e571c734b28d$var$_baseNew = $9fd7e571c734b28d$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $9fd7e571c734b28d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ShowMoreHorizontal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for more action menus.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9fd7e571c734b28d$var$ShowMoreHorizontalIcon = (props)=>/*#__PURE__*/ $9fd7e571c734b28d$var$_react.default.createElement($9fd7e571c734b28d$var$_baseNew.default, Object.assign({
        name: "ShowMoreHorizontalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m6.5 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M13 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0" clip-rule="evenodd"/>`
    }, props));
$9fd7e571c734b28d$var$ShowMoreHorizontalIcon.displayName = 'ShowMoreHorizontalIcon';
var $9fd7e571c734b28d$var$_default = module.exports.default = $9fd7e571c734b28d$var$ShowMoreHorizontalIcon;

});

parcelRegister("jyJtr", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $e3d4777149341167$var$__DEV__ = false;
var $e3d4777149341167$var$warning = function() {};
if ($e3d4777149341167$var$__DEV__) {
    var $e3d4777149341167$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $e3d4777149341167$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $e3d4777149341167$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
module.exports = $e3d4777149341167$var$warning;

});

parcelRegister("gH6fz", function(module, exports) {

var $1ubpj = parcelRequire("1ubpj");
var $c27582a1ffe05289$var$listeningFocusTrap = null;
function $c27582a1ffe05289$var$focusTrap(element, userOptions) {
    var tabbableNodes = [];
    var firstTabbableNode = null;
    var lastTabbableNode = null;
    var nodeFocusedBeforeActivation = null;
    var active = false;
    var paused = false;
    var tabEvent = null;
    var container = typeof element === 'string' ? document.querySelector(element) : element;
    var config = userOptions || {};
    config.returnFocusOnDeactivate = userOptions && userOptions.returnFocusOnDeactivate !== undefined ? userOptions.returnFocusOnDeactivate : true;
    config.escapeDeactivates = userOptions && userOptions.escapeDeactivates !== undefined ? userOptions.escapeDeactivates : true;
    var trap = {
        activate: activate,
        deactivate: deactivate,
        pause: pause,
        unpause: unpause
    };
    return trap;
    function activate(activateOptions) {
        if (active) return;
        var defaultedActivateOptions = {
            onActivate: activateOptions && activateOptions.onActivate !== undefined ? activateOptions.onActivate : config.onActivate
        };
        active = true;
        paused = false;
        nodeFocusedBeforeActivation = document.activeElement;
        if (defaultedActivateOptions.onActivate) defaultedActivateOptions.onActivate();
        addListeners();
        return trap;
    }
    function deactivate(deactivateOptions) {
        if (!active) return;
        var defaultedDeactivateOptions = {
            returnFocus: deactivateOptions && deactivateOptions.returnFocus !== undefined ? deactivateOptions.returnFocus : config.returnFocusOnDeactivate,
            onDeactivate: deactivateOptions && deactivateOptions.onDeactivate !== undefined ? deactivateOptions.onDeactivate : config.onDeactivate
        };
        removeListeners();
        if (defaultedDeactivateOptions.onDeactivate) defaultedDeactivateOptions.onDeactivate();
        if (defaultedDeactivateOptions.returnFocus) setTimeout(function() {
            $c27582a1ffe05289$var$tryFocus(nodeFocusedBeforeActivation);
        }, 0);
        active = false;
        paused = false;
        return this;
    }
    function pause() {
        if (paused || !active) return;
        paused = true;
        removeListeners();
    }
    function unpause() {
        if (!paused || !active) return;
        paused = false;
        addListeners();
    }
    function addListeners() {
        if (!active) return;
        // There can be only one listening focus trap at a time
        if ($c27582a1ffe05289$var$listeningFocusTrap) $c27582a1ffe05289$var$listeningFocusTrap.pause();
        $c27582a1ffe05289$var$listeningFocusTrap = trap;
        updateTabbableNodes();
        $c27582a1ffe05289$var$tryFocus(firstFocusNode());
        document.addEventListener('focus', checkFocus, true);
        document.addEventListener('click', checkClick, true);
        document.addEventListener('mousedown', checkPointerDown, true);
        document.addEventListener('touchstart', checkPointerDown, true);
        document.addEventListener('keydown', checkKey, true);
        return trap;
    }
    function removeListeners() {
        if (!active || $c27582a1ffe05289$var$listeningFocusTrap !== trap) return;
        document.removeEventListener('focus', checkFocus, true);
        document.removeEventListener('click', checkClick, true);
        document.removeEventListener('mousedown', checkPointerDown, true);
        document.removeEventListener('touchstart', checkPointerDown, true);
        document.removeEventListener('keydown', checkKey, true);
        $c27582a1ffe05289$var$listeningFocusTrap = null;
        return trap;
    }
    function getNodeForOption(optionName) {
        var optionValue = config[optionName];
        var node = optionValue;
        if (!optionValue) return null;
        if (typeof optionValue === 'string') {
            node = document.querySelector(optionValue);
            if (!node) throw new Error('`' + optionName + '` refers to no known node');
        }
        if (typeof optionValue === 'function') {
            node = optionValue();
            if (!node) throw new Error('`' + optionName + '` did not return a node');
        }
        return node;
    }
    function firstFocusNode() {
        var node;
        if (getNodeForOption('initialFocus') !== null) node = getNodeForOption('initialFocus');
        else if (container.contains(document.activeElement)) node = document.activeElement;
        else node = tabbableNodes[0] || getNodeForOption('fallbackFocus');
        if (!node) throw new Error('You can\'t have a focus-trap without at least one focusable element');
        return node;
    }
    // This needs to be done on mousedown and touchstart instead of click
    // so that it precedes the focus event
    function checkPointerDown(e) {
        if (config.clickOutsideDeactivates && !container.contains(e.target)) deactivate({
            returnFocus: false
        });
    }
    function checkClick(e) {
        if (config.clickOutsideDeactivates) return;
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
    }
    function checkFocus(e) {
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        // Checking for a blur method here resolves a Firefox issue (#15)
        if (typeof e.target.blur === 'function') e.target.blur();
        if (tabEvent) readjustFocus(tabEvent);
    }
    function checkKey(e) {
        if (e.key === 'Tab' || e.keyCode === 9) handleTab(e);
        if (config.escapeDeactivates !== false && $c27582a1ffe05289$var$isEscapeEvent(e)) deactivate();
    }
    function handleTab(e) {
        updateTabbableNodes();
        if (e.target.hasAttribute('tabindex') && Number(e.target.getAttribute('tabindex')) < 0) return tabEvent = e;
        e.preventDefault();
        var currentFocusIndex = tabbableNodes.indexOf(e.target);
        if (e.shiftKey) {
            if (e.target === firstTabbableNode || tabbableNodes.indexOf(e.target) === -1) return $c27582a1ffe05289$var$tryFocus(lastTabbableNode);
            return $c27582a1ffe05289$var$tryFocus(tabbableNodes[currentFocusIndex - 1]);
        }
        if (e.target === lastTabbableNode) return $c27582a1ffe05289$var$tryFocus(firstTabbableNode);
        $c27582a1ffe05289$var$tryFocus(tabbableNodes[currentFocusIndex + 1]);
    }
    function updateTabbableNodes() {
        tabbableNodes = $1ubpj(container);
        firstTabbableNode = tabbableNodes[0];
        lastTabbableNode = tabbableNodes[tabbableNodes.length - 1];
    }
    function readjustFocus(e) {
        if (e.shiftKey) return $c27582a1ffe05289$var$tryFocus(lastTabbableNode);
        $c27582a1ffe05289$var$tryFocus(firstTabbableNode);
    }
}
function $c27582a1ffe05289$var$isEscapeEvent(e) {
    return e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
}
function $c27582a1ffe05289$var$tryFocus(node) {
    if (!node || !node.focus) return;
    if (node === document.activeElement) return;
    node.focus();
    if (node.tagName.toLowerCase() === 'input') node.select();
}
module.exports = $c27582a1ffe05289$var$focusTrap;

});
parcelRegister("1ubpj", function(module, exports) {
module.exports = function(el, options) {
    options = options || {};
    var elementDocument = el.ownerDocument || el;
    var basicTabbables = [];
    var orderedTabbables = [];
    // A node is "available" if
    // - it's computed style
    var isUnavailable = $11517109f3a827c0$var$createIsUnavailable(elementDocument);
    var candidateSelectors = [
        'input',
        'select',
        'a[href]',
        'textarea',
        'button',
        '[tabindex]'
    ];
    var candidates = el.querySelectorAll(candidateSelectors.join(','));
    if (options.includeContainer) {
        var matches = Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
        if (candidateSelectors.some(function(candidateSelector) {
            return matches.call(el, candidateSelector);
        })) {
            candidates = Array.prototype.slice.apply(candidates);
            candidates.unshift(el);
        }
    }
    var candidate, candidateIndexAttr, candidateIndex;
    for(var i = 0, l = candidates.length; i < l; i++){
        candidate = candidates[i];
        candidateIndexAttr = parseInt(candidate.getAttribute('tabindex'), 10);
        candidateIndex = isNaN(candidateIndexAttr) ? candidate.tabIndex : candidateIndexAttr;
        if (candidateIndex < 0 || candidate.tagName === 'INPUT' && candidate.type === 'hidden' || candidate.disabled || isUnavailable(candidate, elementDocument)) continue;
        if (candidateIndex === 0) basicTabbables.push(candidate);
        else orderedTabbables.push({
            index: i,
            tabIndex: candidateIndex,
            node: candidate
        });
    }
    var tabbableNodes = orderedTabbables.sort(function(a, b) {
        return a.tabIndex === b.tabIndex ? a.index - b.index : a.tabIndex - b.tabIndex;
    }).map(function(a) {
        return a.node;
    });
    Array.prototype.push.apply(tabbableNodes, basicTabbables);
    return tabbableNodes;
};
function $11517109f3a827c0$var$createIsUnavailable(elementDocument) {
    // Node cache must be refreshed on every check, in case
    // the content of the element has changed
    var isOffCache = [];
    // "off" means `display: none;`, as opposed to "hidden",
    // which means `visibility: hidden;`. getComputedStyle
    // accurately reflects visiblity in context but not
    // "off" state, so we need to recursively check parents.
    function isOff(node, nodeComputedStyle) {
        if (node === elementDocument.documentElement) return false;
        // Find the cached node (Array.prototype.find not available in IE9)
        for(var i = 0, length = isOffCache.length; i < length; i++){
            if (isOffCache[i][0] === node) return isOffCache[i][1];
        }
        nodeComputedStyle = nodeComputedStyle || elementDocument.defaultView.getComputedStyle(node);
        var result = false;
        if (nodeComputedStyle.display === 'none') result = true;
        else if (node.parentNode) result = isOff(node.parentNode);
        isOffCache.push([
            node,
            result
        ]);
        return result;
    }
    return function isUnavailable(node) {
        if (node === elementDocument.documentElement) return false;
        var computedStyle = elementDocument.defaultView.getComputedStyle(node);
        if (isOff(node, computedStyle)) return true;
        return computedStyle.visibility === 'hidden';
    };
}

});


parcelRegister("iS5Jc", function(module, exports) {
$parcel$export(module.exports, "default", () => $829117acb82d5e8d$export$2e2bcd8739ae039);
/* link.tsx generated by @compiled/babel-plugin v0.36.1 */ /* link.tsx generated by @compiled/babel-plugin v0.36.1 */ /* link.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $klNPa = parcelRequire("klNPa");

var $hHj16 = parcelRequire("hHj16");

var $eL2h4 = parcelRequire("eL2h4");

var $3X3Vo = parcelRequire("3X3Vo");

var $eb3Wn = parcelRequire("eb3Wn");

var $fu5fM = parcelRequire("fu5fM");

var $kAcdt = parcelRequire("kAcdt");
const $829117acb82d5e8d$var$styles = {
    base: "_2rkofajl _11c8fhey _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    baseT26Shape: "_2rko1qi0",
    linkDecorationUnset: "_4bfu1snc _1hmsagmp _ajmmvv82 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _bfhkby5v _syaz1gmx _aetrglyw _irr3by5v _30l31gmx _1di6by5v _9h8h1gmx",
    spacingCompact: "_1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    buttonIconBefore: "_bozgutpp _gy1p12x7",
    buttonIconAfter: "_y4tiutpp _gy1p12x7",
    fullWidth: "_1bsb1osq"
};
const $829117acb82d5e8d$var$defaultStyles = {
    root: "_bfhksm61 _syazazsu _8l3m1l7x _aetrb3bt _1053azsu _f8pjazsu _irr31dpa _30l3azsu _1di6fcek _9h8hazsu"
};
const $829117acb82d5e8d$var$primaryStyles = {
    root: "_bfhk1856 _syaz15cr _105315cr _f8pj15cr _30l315cr _irr3hf2y _9h8h15cr _1di6g6ey"
};
const $829117acb82d5e8d$var$warningStyles = {
    root: "_bfhk1kmu _syaz1yd3 _10531yd3 _f8pj1yd3 _30l31yd3 _irr31spp _9h8h1yd3 _1di64m4m"
};
const $829117acb82d5e8d$var$dangerStyles = {
    root: "_bfhkybec _syaz15cr _105315cr _f8pj15cr _30l315cr _irr3s9hg _9h8h15cr _1di613a9"
};
const $829117acb82d5e8d$var$discoveryStyles = {
    root: "_bfhku5tj _syaz15cr _105315cr _f8pj15cr _30l315cr _irr3fqeg _9h8h15cr _1di61f1m"
};
const $829117acb82d5e8d$var$subtleStyles = {
    root: "_bfhksm61 _syazazsu _1053azsu _f8pj1mjl _irr31dpa _30l3azsu _1di6fcek _9h8hazsu"
};
const $829117acb82d5e8d$var$selectedStyles = {
    root: "_bfhk15s3 _syaz6x5g _8l3mq98m _aetrb3bt _10536x5g _f8pj6x5g _30l36x5g _9h8h6x5g",
    warning: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3",
    danger: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3",
    discovery: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3"
};
/**
 * __Link Button__
 *
 * Renders a link in the style of a button.
 *
 * - [Examples](https://atlassian.design/components/link-button/examples)
 * - [Code](https://atlassian.design/components/link-button/code)
 * - [Usage](https://atlassian.design/components/link-button/usage)
 */ const $829117acb82d5e8d$var$LinkButtonBase = ({ analyticsContext: analyticsContext, appearance: appearance = 'default', 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, autoFocus: autoFocus = false, children: children, href: href, iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId, ...unsafeRest }, ref)=>{
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    const hasIconAfter = Boolean(iconAfter);
    const hasIconBefore = Boolean(iconBefore);
    const localRef = (0, $4tluv.useRef)(null);
    (0, $eL2h4.default)(localRef, autoFocus);
    const combinedRef = (0, $hHj16.default)([
        localRef,
        ref
    ]);
    return /*#__PURE__*/ (0, $2iln5.jsxs)((0, $eb3Wn.default), {
        analyticsContext: analyticsContext,
        ref: combinedRef,
        /**
   * Disable link in an accessible way using `href`, `role`, and `aria-disabled`.
   * @see https://a11y-guidelines.orange.com/en/articles/disable-elements/#disable-a-link
   */ // @ts-expect-error (`href` is required, we could make it optional but don't want to encourage this pattern elsewhere)
        href: isDisabled ? undefined : href,
        role: isDisabled ? 'link' : undefined,
        "aria-disabled": isDisabled === true ? true : undefined,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        testId: testId,
        componentName: "LinkButton",
        interactionName: interactionName,
        ...saferRest,
        xcss: (0, $klNPa.cx)($829117acb82d5e8d$var$styles.base, (0, $3X3Vo.fg)('platform-dst-shape-theme-default') && $829117acb82d5e8d$var$styles.baseT26Shape, appearance === 'default' && $829117acb82d5e8d$var$defaultStyles.root, appearance === 'primary' && $829117acb82d5e8d$var$primaryStyles.root, appearance === 'warning' && $829117acb82d5e8d$var$warningStyles.root, appearance === 'danger' && $829117acb82d5e8d$var$dangerStyles.root, appearance === 'discovery' && $829117acb82d5e8d$var$discoveryStyles.root, appearance === 'subtle' && $829117acb82d5e8d$var$subtleStyles.root, $829117acb82d5e8d$var$styles.linkDecorationUnset, isSelected && $829117acb82d5e8d$var$selectedStyles.root, isSelected && appearance === 'danger' && $829117acb82d5e8d$var$selectedStyles.danger, isSelected && appearance === 'warning' && $829117acb82d5e8d$var$selectedStyles.warning, isSelected && appearance === 'discovery' && $829117acb82d5e8d$var$selectedStyles.discovery, isDisabled && $829117acb82d5e8d$var$styles.disabled, spacing === 'compact' && $829117acb82d5e8d$var$styles.spacingCompact, hasIconBefore && $829117acb82d5e8d$var$styles.buttonIconBefore, hasIconAfter && $829117acb82d5e8d$var$styles.buttonIconAfter, shouldFitContainer && $829117acb82d5e8d$var$styles.fullWidth),
        children: [
            iconBefore && /*#__PURE__*/ (0, $2iln5.jsx)((0, $fu5fM.default), {
                type: "icon",
                position: "before",
                isLoading: false,
                children: /*#__PURE__*/ (0, $2iln5.jsx)((0, $kAcdt.default), {
                    icon: iconBefore
                })
            }),
            children && /*#__PURE__*/ (0, $2iln5.jsx)((0, $fu5fM.default), {
                isLoading: false,
                children: children
            }),
            iconAfter && /*#__PURE__*/ (0, $2iln5.jsx)((0, $fu5fM.default), {
                type: "icon",
                position: "after",
                isLoading: false,
                children: /*#__PURE__*/ (0, $2iln5.jsx)((0, $kAcdt.default), {
                    icon: iconAfter
                })
            })
        ]
    });
};
// Workarounds to support generic types with forwardRef
/**
 * __Link Button__
 *
 * Renders a link in the style of a button.
 *
 * - [Examples](https://atlassian.design/components/link-button/examples)
 * - [Code](https://atlassian.design/components/link-button/code)
 * - [Usage](https://atlassian.design/components/link-button/usage)
 */ const $829117acb82d5e8d$var$LinkButton = /*#__PURE__*/ (0, $4tluv.forwardRef)($829117acb82d5e8d$var$LinkButtonBase);
$829117acb82d5e8d$var$LinkButton.displayName = 'LinkButton';
var $829117acb82d5e8d$export$2e2bcd8739ae039 = $829117acb82d5e8d$var$LinkButton;

});

parcelRegister("edM9z", function(module, exports) {
$parcel$export(module.exports, "default", () => $82f7ff96bed70eab$export$2e2bcd8739ae039);
/* link.tsx generated by @compiled/babel-plugin v0.36.1 */ /* link.tsx generated by @compiled/babel-plugin v0.36.1 */ /* link.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $klNPa = parcelRequire("klNPa");

var $hHj16 = parcelRequire("hHj16");

var $eL2h4 = parcelRequire("eL2h4");

var $3X3Vo = parcelRequire("3X3Vo");

var $eb3Wn = parcelRequire("eb3Wn");

var $eCj8S = parcelRequire("eCj8S");

var $k7gbB = parcelRequire("k7gbB");

var $fu5fM = parcelRequire("fu5fM");

var $kAcdt = parcelRequire("kAcdt");
const $82f7ff96bed70eab$var$styles = {
    base: "_2rkofajl _11c8fhey _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    baseT26Shape: "_2rko1qi0",
    linkDecorationUnset: "_4bfu1snc _1hmsagmp _ajmmvv82 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _bfhkby5v _syaz1gmx _aetrglyw _irr3by5v _30l31gmx _1di6by5v _9h8h1gmx",
    spacingCompact: "_1rjcv77o _gy1p1b66 _y4tiutpp _bozgutpp _s7n4nkob _4t3i1k8s _1bsb1k8s",
    iconButton: "_4t3iviql _1bsbviql _y4tize3t _bozgze3t",
    circle: "_2rko1rr0"
};
const $82f7ff96bed70eab$var$defaultStyles = {
    root: "_bfhksm61 _syazazsu _8l3m1l7x _aetrb3bt _1053azsu _f8pjazsu _irr31dpa _30l3azsu _1di6fcek _9h8hazsu"
};
const $82f7ff96bed70eab$var$primaryStyles = {
    root: "_bfhk1856 _syaz15cr _105315cr _30l315cr _irr3hf2y _9h8h15cr _1di6g6ey"
};
const $82f7ff96bed70eab$var$discoveryStyles = {
    root: "_bfhku5tj _syaz15cr _105315cr _30l315cr _irr3fqeg _9h8h15cr _1di61f1m"
};
const $82f7ff96bed70eab$var$subtleStyles = {
    root: "_bfhksm61 _syazazsu _1053azsu _f8pj1mjl _irr31dpa _30l3azsu _1di6fcek _9h8hazsu"
};
const $82f7ff96bed70eab$var$selectedStyles = {
    root: "_bfhk15s3 _syaz6x5g _8l3mq98m _aetrb3bt _10536x5g _f8pj6x5g _30l36x5g _9h8h6x5g",
    discovery: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3"
};
const $82f7ff96bed70eab$var$LinkIconButtonBase = ({ // Prevent duplicate labels being added.
'aria-label': preventedAriaLabel, 'aria-labelledby': ariaLabelledBy, analyticsContext: analyticsContext, appearance: appearance = 'default', autoFocus: autoFocus = false, href: href, icon: icon, interactionName: interactionName, isDisabled: isDisabled, isSelected: isSelected, isTooltipDisabled: isTooltipDisabled = true, label: label, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shape: shape, spacing: spacing, testId: testId, tooltip: tooltip, ...unsafeRest }, ref)=>{
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    const localRef = (0, $4tluv.useRef)(null);
    (0, $eL2h4.default)(localRef, autoFocus);
    if (!isTooltipDisabled) return /*#__PURE__*/ (0, $2iln5.jsx)((0, $eCj8S.default), {
        content: tooltip?.content ?? label,
        testId: tooltip?.testId,
        position: tooltip?.position,
        delay: tooltip?.delay,
        onShow: tooltip?.onShow,
        onHide: tooltip?.onHide,
        mousePosition: tooltip?.mousePosition,
        analyticsContext: tooltip?.analyticsContext,
        strategy: tooltip?.strategy,
        tag: tooltip?.tag,
        truncate: tooltip?.truncate,
        component: tooltip?.component,
        hideTooltipOnClick: tooltip?.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip?.hideTooltipOnMouseDown,
        ignoreTooltipPointerEvents: tooltip?.ignoreTooltipPointerEvents,
        children: (triggerProps)=>/*#__PURE__*/ (0, $2iln5.jsx)((0, $eb3Wn.default), {
                ...saferRest,
                "aria-labelledby": ariaLabelledBy,
                testId: testId,
                componentName: "LinkIconButton",
                analyticsContext: analyticsContext,
                interactionName: interactionName,
                // Shared between tooltip and native props
                onMouseOver: (e)=>{
                    triggerProps.onMouseOver?.(e);
                    saferRest.onMouseOver?.(e);
                },
                onMouseOut: (e)=>{
                    triggerProps.onMouseOut?.(e);
                    saferRest.onMouseOut?.(e);
                },
                onMouseMove: (e)=>{
                    triggerProps.onMouseMove?.(e);
                    saferRest.onMouseMove?.(e);
                },
                onMouseDown: (e)=>{
                    triggerProps.onMouseDown?.(e);
                    saferRest.onMouseDown?.(e);
                },
                onFocus: (e)=>{
                    triggerProps.onFocus?.(e);
                    saferRest.onFocus?.(e);
                },
                onBlur: (e)=>{
                    triggerProps.onBlur?.(e);
                    saferRest.onBlur?.(e);
                },
                // Shared between tooltip and base props
                onClick: (event, analyticsEvent)=>{
                    onClick?.(event, analyticsEvent);
                    triggerProps?.onClick?.(event);
                },
                ref: (0, $hHj16.default)([
                    localRef,
                    ref,
                    triggerProps.ref
                ].filter(Boolean)),
                // Base props only
                xcss: (0, $klNPa.cx)($82f7ff96bed70eab$var$styles.base, (0, $3X3Vo.fg)('platform-dst-shape-theme-default') && $82f7ff96bed70eab$var$styles.baseT26Shape, appearance === 'default' && $82f7ff96bed70eab$var$defaultStyles.root, appearance === 'primary' && $82f7ff96bed70eab$var$primaryStyles.root, appearance === 'discovery' && $82f7ff96bed70eab$var$discoveryStyles.root, appearance === 'subtle' && $82f7ff96bed70eab$var$subtleStyles.root, $82f7ff96bed70eab$var$styles.linkDecorationUnset, isSelected && $82f7ff96bed70eab$var$selectedStyles.root, isSelected && appearance === 'discovery' && $82f7ff96bed70eab$var$selectedStyles.discovery, isDisabled && $82f7ff96bed70eab$var$styles.disabled, $82f7ff96bed70eab$var$styles.iconButton, spacing === 'compact' && $82f7ff96bed70eab$var$styles.spacingCompact, shape === 'circle' && $82f7ff96bed70eab$var$styles.circle),
                onMouseDownCapture: onMouseDownCapture,
                onMouseUpCapture: onMouseUpCapture,
                onKeyDownCapture: onKeyDownCapture,
                onKeyUpCapture: onKeyUpCapture,
                onTouchStartCapture: onTouchStartCapture,
                onTouchEndCapture: onTouchEndCapture,
                onPointerDownCapture: onPointerDownCapture,
                onPointerUpCapture: onPointerUpCapture,
                onClickCapture: onClickCapture,
                /**
       * Disable link in an accessible way using `href`, `role`, and `aria-disabled`.
       * @see https://a11y-guidelines.orange.com/en/articles/disable-elements/#disable-a-link
       */ // @ts-expect-error (`href` is required, we could make it optional but don't want to encourage this pattern elsewhere)
                href: isDisabled ? undefined : href,
                role: isDisabled ? 'link' : undefined,
                "aria-disabled": isDisabled === true ? true : undefined,
                children: /*#__PURE__*/ (0, $2iln5.jsxs)((0, $fu5fM.default), {
                    type: "icon",
                    isLoading: false,
                    children: [
                        /*#__PURE__*/ (0, $2iln5.jsx)((0, $kAcdt.default), {
                            icon: icon
                        }),
                        /*#__PURE__*/ (0, $2iln5.jsx)((0, $k7gbB.default), {
                            children: label
                        })
                    ]
                })
            })
    });
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $eb3Wn.default), {
        ...saferRest,
        // aria-label={preventedAriaLabel}
        "aria-labelledby": ariaLabelledBy,
        ref: (0, $hHj16.default)([
            localRef,
            ref
        ]),
        xcss: (0, $klNPa.cx)($82f7ff96bed70eab$var$styles.base, (0, $3X3Vo.fg)('platform-dst-shape-theme-default') && $82f7ff96bed70eab$var$styles.baseT26Shape, appearance === 'default' && $82f7ff96bed70eab$var$defaultStyles.root, appearance === 'primary' && $82f7ff96bed70eab$var$primaryStyles.root, appearance === 'discovery' && $82f7ff96bed70eab$var$discoveryStyles.root, appearance === 'subtle' && $82f7ff96bed70eab$var$subtleStyles.root, $82f7ff96bed70eab$var$styles.linkDecorationUnset, isSelected && $82f7ff96bed70eab$var$selectedStyles.root, isSelected && appearance === 'discovery' && $82f7ff96bed70eab$var$selectedStyles.discovery, isDisabled && $82f7ff96bed70eab$var$styles.disabled, $82f7ff96bed70eab$var$styles.iconButton, spacing === 'compact' && $82f7ff96bed70eab$var$styles.spacingCompact, shape === 'circle' && $82f7ff96bed70eab$var$styles.circle),
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture,
        testId: testId,
        /**
   * Disable link in an accessible way using `href`, `role`, and `aria-disabled`.
   * @see https://a11y-guidelines.orange.com/en/articles/disable-elements/#disable-a-link
   */ // @ts-expect-error (`href` is required, we could make it optional but don't want to encourage this pattern elsewhere)
        href: isDisabled ? undefined : href,
        role: isDisabled ? 'link' : undefined,
        "aria-disabled": isDisabled === true ? true : undefined,
        componentName: "LinkIconButton",
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        children: /*#__PURE__*/ (0, $2iln5.jsxs)((0, $fu5fM.default), {
            type: "icon",
            isLoading: false,
            children: [
                /*#__PURE__*/ (0, $2iln5.jsx)((0, $kAcdt.default), {
                    icon: icon
                }),
                /*#__PURE__*/ (0, $2iln5.jsx)((0, $k7gbB.default), {
                    children: label
                })
            ]
        })
    });
};
// Workarounds to support generic types with forwardRef + memo
const $82f7ff96bed70eab$var$WithRef = /*#__PURE__*/ (0, $4tluv.forwardRef)($82f7ff96bed70eab$var$LinkIconButtonBase);
/**
 * __Link Icon Button__
 *
 * Renders a link in the style of an icon button.
 *
 * - [Examples](https://atlassian.design/components/button/link-icon-button/examples)
 * - [Code](https://atlassian.design/components/button/link-icon-button/code)
 * - [Usage](https://atlassian.design/components/button/link-icon-button/usage)
 */ const $82f7ff96bed70eab$var$LinkIconButton = /*#__PURE__*/ (0, $4tluv.memo)($82f7ff96bed70eab$var$WithRef);
var $82f7ff96bed70eab$export$2e2bcd8739ae039 = $82f7ff96bed70eab$var$LinkIconButton;

});

parcelRegister("ijJ9X", function(module, exports) {
$parcel$export(module.exports, "default", () => $d55d0819d04916aa$export$2e2bcd8739ae039);
function $d55d0819d04916aa$var$fromHex(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace("#", "").match(/.{2}/g);
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a], 16);
    switch(e){
        case "rgb":
            return {
                r: n[0],
                g: n[1],
                b: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                r: n[0],
                g: n[1],
                b: n[2]
            });
    }
}
function $d55d0819d04916aa$var$fromRgb(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "hex":
            return 1 == (g = Math.round(n.r).toString(16)).length && (g = "0" + g), 1 == (y = Math.round(n.g).toString(16)).length && (y = "0" + y), 1 == (_ = Math.round(n.b).toString(16)).length && (_ = "0" + _), "#" + g + y + _;
        case "cssrgb":
            return "rgb(" + Math.round(n.r) + "," + Math.round(n.g) + "," + Math.round(n.b) + ")";
        case "hsl":
            var a = [
                g = n.r / 255,
                y = n.g / 255,
                _ = n.b / 255
            ].sort(), i = (a[0] + a[2]) / 2 * 100;
            return a[0] == a[2] ? (b = 0, d = 0) : (b = i >= 50 ? (a[2] - a[0]) / (2 - a[2] - a[0]) * 100 : (a[2] - a[0]) / (a[2] + a[0]) * 100, (d = a[2] == g ? (y - _) / (a[2] - a[0]) * 60 : a[2] == y ? 60 * (2 + (_ - g) / (a[2] - a[0])) : 60 * (4 + (g - y) / (a[2] - a[0]))) < 0 ? d += 360 : d > 360 && (d %= 360)), {
                h: d,
                s: b,
                l: i
            };
        case "csshsl":
            var c = o.convert({
                conversions: t,
                helpers: s
            }, "hsl", n);
            return "hsl(" + Math.round(c.h) + "," + Math.round(c.s) + "%," + Math.round(c.l) + "%)";
        case "cmyk":
            var u = n.r / 255, l = n.g / 255, h = n.b / 255, v = 1 - Math.max(u, l, h);
            if (1 != v) var p = (1 - u - v) / (1 - v), f = (1 - l - v) / (1 - v), m = (1 - h - v) / (1 - v);
            else var p = 0, f = 0, m = 0;
            return {
                c: p,
                m: f,
                y: m,
                k: v
            };
        case "hsv":
            var d, b, g = n.r / 255, y = n.g / 255, _ = n.b / 255, M = Math.min(g, y, _), Y = Math.max(g, y, _), L = Y - M, X = Y;
            if (0 == L) d = 0, b = 0;
            else {
                b = L / Y;
                var Z = ((Y - g) / 6 + L / 2) / L, R = ((Y - y) / 6 + L / 2) / L, w = ((Y - _) / 6 + L / 2) / L;
                g == Y ? d = w - R : y == Y ? d = 1 / 3 + Z - w : _ == Y && (d = 2 / 3 + R - Z), d < 0 && (d += 1), d > 1 && (d -= 1);
            }
            return {
                h: 360 * d,
                s: 100 * b,
                v: 100 * X
            };
        case "yiq":
            var m = n.r / 255 * .299 + n.g / 255 * .587 + n.b / 255 * .114, C = n.r / 255 * .596 + n.g / 255 * -0.274 + n.b / 255 * -0.322, x = n.r / 255 * .211 + n.g / 255 * -0.523 + n.b / 255 * .312;
            return C = s.bounded(C, [
                -0.5957,
                .5957
            ]), x = s.bounded(x, [
                -0.5226,
                .5226
            ]), {
                y: m,
                i: C,
                q: x
            };
        case "XYZ":
            var A = [
                n.r,
                n.g,
                n.b
            ].map(function(r) {
                return r / 255;
            }).map(function(r) {
                return r <= .04045 ? r / 12.92 : Math.pow((r + .055) / 1.055, 2.4);
            }), S = s.getTransform("SRGB_XYZ").map(function(r) {
                return A.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            }).map(function(r) {
                return 100 * r;
            }), O = $d55d0819d04916aa$var$slicedToArray(S, 3);
            return {
                X: O[0],
                Y: O[1],
                Z: O[2]
            };
        case "lms":
        case "cielab":
        case "cieluv":
        case "xyY":
            var I = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, I);
        case "cielch":
            var j = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cieluv", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, j);
        case "hsluv":
            var D = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cielch", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, D);
    }
}
function $d55d0819d04916aa$var$fromCssRgb(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace(/((rgb\(|\))|[\s]*)/g, "").split(",");
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a]);
    switch(e){
        case "rgb":
            return {
                r: n[0],
                g: n[1],
                b: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                r: n[0],
                g: n[1],
                b: n[2]
            });
    }
}
function $d55d0819d04916aa$var$fromHsl(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            if (0 == n.s) {
                var a = n.l / 100 * 255;
                return {
                    r: a,
                    g: a,
                    b: a
                };
            }
            var i, c, u;
            i = n.l >= 50 ? n.l / 100 + n.s / 100 - n.l / 100 * (n.s / 100) : n.l / 100 * (1 + n.s / 100), c = n.l / 100 * 2 - i;
            var l, h, v, p = ((u = n.h / 360) + .333) % 1, f = u, m = s.negMod(u - .333, 1);
            return l = 6 * p < 1 ? c + 6 * (i - c) * p : 2 * p < 1 ? i : 3 * p < 2 ? c + 6 * (.666 - p) * (i - c) : c, h = 6 * f < 1 ? c + 6 * (i - c) * f : 2 * f < 1 ? i : 3 * f < 2 ? c + 6 * (.666 - f) * (i - c) : c, v = 6 * m < 1 ? c + 6 * (i - c) * m : 2 * m < 1 ? i : 3 * m < 2 ? c + 6 * (.666 - m) * (i - c) : c, l < 0 && (l = 0), h < 0 && (h = 0), v < 0 && (v = 0), {
                r: 255 * l,
                g: 255 * h,
                b: 255 * v
            };
        case "csshsl":
            return "hsl(" + Math.round(n.h) + "," + Math.round(n.s) + "%," + Math.round(n.l) + "%)";
        case "hsv":
            n.s = n.s / 100, n.l = n.l / 100;
            var d = n.s * (n.l < .5 ? n.l : 1 - n.l);
            return {
                h: n.h,
                s: 100 * (2 * d / (n.l + d)),
                v: 100 * (n.l + d)
            };
        default:
            var b = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, b);
    }
}
function $d55d0819d04916aa$var$fromCssHsl(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace(/(hsl\(|\)|%|[\s]*)/g, "").split(",");
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a]);
    switch(e){
        case "hsl":
            return {
                h: n[0],
                s: n[1],
                l: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                h: n[0],
                s: n[1],
                l: n[2]
            });
    }
}
function $d55d0819d04916aa$var$fromHsv(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            var a, i, c;
            n.h = n.h / 360, n.s = n.s / 100, n.v = n.v / 100;
            var u = 6 * n.h;
            6 == u && (u = 0);
            var l, h, v, p = Math.round(u), f = n.v * (1 - n.s), m = n.v * (1 - n.s * (u - p)), d = n.v * (1 - n.s * (1 - (u - p)));
            return 0 == p ? (l = n.v, h = d, v = f) : 1 == p ? (l = m, h = n.v, v = f) : 2 == p ? (l = f, h = n.v, v = d) : 3 == p ? (l = f, h = m, v = n.v) : 4 == p ? (l = d, h = f, v = n.v) : (l = n.v, h = f, v = m), a = 255 * l, i = 255 * h, c = 255 * v, {
                r: a,
                g: i,
                b: c
            };
        case "hsl":
            n.h = n.h / 360, n.s = n.s / 100, n.v = n.v / 100;
            return {
                h: 360 * n.h,
                s: 100 * ((2 - n.s) * n.v < 1 ? n.s * n.v / ((2 - n.s) * n.v) : n.s * n.v / (2 - (2 - n.s) * n.v)),
                l: 100 * ((2 - n.s) * n.v / 2)
            };
        default:
            var b = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, b);
    }
}
function $d55d0819d04916aa$var$fromCmyk(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            return {
                r: a = 255 * (1 - n.c) * (1 - n.k),
                g: i = 255 * (1 - n.m) * (1 - n.k),
                b: c = 255 * (1 - n.y) * (1 - n.k)
            };
        case "cssrgb":
            var a = 255 * (1 - n.c) * (1 - n.k), i = 255 * (1 - n.m) * (1 - n.k), c = 255 * (1 - n.y) * (1 - n.k);
            return "rgb(" + Math.round(a) + "," + Math.round(i) + "," + Math.round(c) + ")";
        default:
            var u = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, u);
    }
}
function $d55d0819d04916aa$var$fromYiq(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(n.i = s.bounded(n.i, [
        -0.5957,
        .5957
    ]), n.q = s.bounded(n.q, [
        -0.5226,
        .5226
    ]), e){
        case "rgb":
            var a = 255 * (n.y + .956 * n.i + .621 * n.q), i = 255 * (n.y + -0.272 * n.i + -0.647 * n.q), c = 255 * (n.y + -1.106 * n.i + -1.703 * n.q);
            return a = s.bounded(a, [
                0,
                255
            ]), i = s.bounded(i, [
                0,
                255
            ]), c = s.bounded(c, [
                0,
                255
            ]), {
                r: a,
                g: i,
                b: c
            };
        default:
            var u = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, u);
    }
}
function $d55d0819d04916aa$var$fromXYZ(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers, a = s.getIlluminant("D65");
    switch(e){
        case "rgb":
            var i = [
                n.X,
                n.Y,
                n.Z
            ].map(function(r) {
                return r / 100;
            }), c = s.getTransform("INVERSE_SRGB_XYZ").map(function(r) {
                return i.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            }).map(function(r) {
                return r <= .0031308 ? 12.92 * r : 1.055 * Math.pow(r, 1 / 2.4) - .055;
            }).map(function(r) {
                return 255 * r;
            }), u = $d55d0819d04916aa$var$slicedToArray(c, 3), l = u[0], h = u[1], v = u[2];
            return s.boundedRgb({
                r: l,
                g: h,
                b: v
            });
        case "lms":
            var p = [
                n.X,
                n.Y,
                n.Z
            ].map(function(r) {
                return r / 100;
            }), f = s.getTransform("BRADFORD").map(function(r) {
                return p.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            });
            return {
                rho: f[0],
                gamma: f[1],
                beta: f[2]
            };
        case "cielab":
            var m = n.X / a.X, d = n.Y / a.Y, b = n.Z / a.Z, g = function(r) {
                return r > .008856 ? s.cbrt(r) : (903.3 * r + 16) / 116;
            }, y = g(m), _ = g(d);
            return {
                L: 116 * _ - 16,
                a: 500 * (y - _),
                b: 200 * (_ - g(b))
            };
        case "cieluv":
            var M = n.Y / a.Y, Y = M > .008856 ? 116 * s.cbrt(M) - 16 : 903.3 * M, L = function(r) {
                return 4 * r.X / (r.X + 15 * r.Y + 3 * r.Z);
            }, X = function(r) {
                return 9 * r.Y / (r.X + 15 * r.Y + 3 * r.Z);
            };
            return {
                L: Y,
                u: 13 * Y * (L(n) - L(a)),
                v: 13 * Y * (X(n) - X(a))
            };
        case "xyY":
            return {
                x: n.X / (n.X + n.Y + n.Z),
                y: n.Y / (n.X + n.Y + n.Z),
                Y: n.Y
            };
        default:
            var Z = s.boundedRgb(o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n));
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, Z);
    }
}
function $d55d0819d04916aa$var$fromxyY(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = n.Y / n.y * n.x, i = n.Y / n.y * (1 - n.x - n.y);
            return {
                X: a,
                Y: n.Y,
                Z: i
            };
        default:
            var c = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, c);
    }
}
function $d55d0819d04916aa$var$fromLms(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = [
                n.rho,
                n.gamma,
                n.beta
            ], i = s.getTransform("INVERSE_BRADFORD").map(function(r) {
                return a.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            });
            return {
                X: 100 * i[0],
                Y: 100 * i[1],
                Z: 100 * i[2]
            };
        default:
            var c = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, c);
    }
}
function $d55d0819d04916aa$var$fromCieLab(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = s.getIlluminant("D65"), i = (n.L + 16) / 116, c = n.a / 500 + i, u = i - n.b / 200, l = function(r) {
                return Math.pow(r, 3) > .008856 ? Math.pow(r, 3) : (116 * r - 16) / 903.3;
            }, h = l(c), v = l(u), p = n.L > 903.3 * .008856 ? Math.pow(i, 3) : n.L / 903.3;
            return {
                X: h * a.X,
                Y: p * a.Y,
                Z: v * a.Z
            };
        default:
            var f = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, f);
    }
}
function $d55d0819d04916aa$var$fromCieLuv(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = s.getIlluminant("D65"), i = function(r) {
                return 4 * r.X / (r.X + 15 * r.Y + 3 * r.Z);
            }(a), c = function(r) {
                return 9 * r.Y / (r.X + 15 * r.Y + 3 * r.Z);
            }(a), u = 1 / 3 * (52 * n.L / (n.u + 13 * n.L * i) - 1), l = n.L > 903.3 * .008856 ? Math.pow((n.L + 16) / 116, 3) : n.L / 903.3, h = -5 * l, v = (l * (39 * n.L / (n.v + 13 * n.L * c) - 5) - h) / (u - -1 / 3);
            return {
                X: 100 * v,
                Y: 100 * l,
                Z: 100 * (v * u + h)
            };
        case "cielch":
            var p = Math.sqrt(Math.pow(n.u, 2) + Math.pow(n.v, 2)), f = Math.atan2(n.v, n.u);
            return f < 0 && (f += 2 * Math.PI), f = s.toDeg(f), {
                L: n.L,
                C: p,
                h: f
            };
        default:
            var m = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, m);
    }
}
function $d55d0819d04916aa$var$fromCieLch(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "cieluv":
            var a = s.toRad(n.h), i = n.C * Math.cos(a), c = n.C * Math.sin(a);
            return {
                L: n.L,
                u: i,
                v: c
            };
        case "hsluv":
            if (n.L > 99.9999999) return {
                hu: n.h,
                s: 0,
                l: 100
            };
            if (n.L < 1e-8) return {
                hu: n.h,
                s: 0,
                l: 0
            };
            for(var u = (n.L + 16) / 1560896, l = u > .008856 ? u : n.L / 903.3, h = s.getTransform("INVERSE_SRGB_XYZ"), v = [], p = 0; p < 3; p++)for(var f = h[p][0], m = h[p][1], d = h[p][2], b = 0; b < 2; b++){
                var g = (284517 * f - 94839 * d) * l, y = (838422 * d + 769860 * m + 731718 * f) * n.L * l - 769860 * b * n.L, _ = (632260 * d - 126452 * m) * l + 126452 * b;
                v.push({
                    m: g / _,
                    b: y / _
                });
            }
            var M = Number.MAX_VALUE, Y = s.toRad(n.h);
            v.forEach(function(r) {
                var e = r.b / (Math.sin(Y) - r.m * Math.cos(Y));
                e >= 0 && (M = Math.min(M, e));
            });
            var L = M;
            return {
                hu: n.h,
                s: n.C / L * 100,
                l: n.L
            };
        default:
            var X = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cieluv", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, X);
    }
}
function $d55d0819d04916aa$var$fromCieLch$1(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "cielch":
            if (n.L > 99.9999999) return {
                L: 100,
                C: 0,
                h: n.hu
            };
            if (n.L < 1e-8) return {
                L: 0,
                C: 0,
                h: n.hu
            };
            for(var a = (n.l + 16) / 1560896, i = a > .008856 ? a : n.l / 903.3, c = s.getTransform("INVERSE_SRGB_XYZ"), u = [], l = 0; l < 3; l++)for(var h = c[l][0], v = c[l][1], p = c[l][2], f = 0; f < 2; f++){
                var m = (284517 * h - 94839 * p) * i, d = (838422 * p + 769860 * v + 731718 * h) * n.l * i - 769860 * f * n.l, b = (632260 * p - 126452 * v) * i + 126452 * f;
                u.push({
                    m: m / b,
                    b: d / b
                });
            }
            var g = Number.MAX_VALUE, y = s.toRad(n.hu);
            u.forEach(function(r) {
                var e = r.b / (Math.sin(y) - r.m * Math.cos(y));
                e >= 0 && (g = Math.min(g, e));
            });
            var _ = g;
            return {
                L: n.l,
                C: _ / 100 * n.s,
                h: n.hu
            };
        default:
            var M = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cielch", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, M);
    }
}
function $d55d0819d04916aa$var$contains(r, e) {
    return Object.keys(r).every(function(r) {
        return -1 !== e.indexOf(r);
    });
}
function $d55d0819d04916aa$var$adapt(r, e, n, t) {
    var o = r.operations.convert(r, "XYZ", e), s = r.operations.convert(r, "lms", n);
    if (t) a = r.operations.convert(r, "lms", t);
    else var a = r.operations.convert(r, "lms", r.helpers.getIlluminant("D65"));
    var i = r.helpers.getTransform("BRADFORD"), c = r.helpers.getTransform("INVERSE_BRADFORD"), u = [
        [
            s.rho / a.rho,
            0,
            0
        ],
        [
            0,
            s.gamma / a.gamma,
            0
        ],
        [
            0,
            0,
            s.beta / a.beta
        ]
    ], l = r.helpers.matrixMultiply(c, u), h = r.helpers.matrixMultiply(l, i), v = [
        [
            o.X
        ],
        [
            o.Y
        ],
        [
            o.Z
        ]
    ], p = r.helpers.matrixMultiply(h, v), f = {
        X: p[0][0],
        Y: p[1][0],
        Z: p[2][0]
    };
    return r.helpers.ready(r, f);
}
function $d55d0819d04916aa$var$adjacent(r, e, n, t) {
    for(var o = r.operations.convert(r, "hsl", t), s = [
        {
            h: o.h,
            s: o.s,
            l: o.l
        }
    ], a = 0; a < n - 1; a++)o.h = r.helpers.negMod(o.h + e, 360), s.push({
        h: o.h,
        s: o.s,
        l: o.l
    });
    return r.helpers.ready(r, s);
}
function $d55d0819d04916aa$var$brightness(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.l += e, t.l < 0 ? t.l = 0 : t.l > 100 && (t.l = 100), r.helpers.ready(r, t);
}
function $d55d0819d04916aa$var$complementary(r, e) {
    var n = r.operations.convert(r, "hsl", e);
    return n.h = (n.h + 180) % 360, r.helpers.ready(r, n);
}
function $d55d0819d04916aa$var$contrast(r, e, n) {
    var t = r.operations.convert(r, "rgb", n);
    return t.r = 255 * ((t.r / 255 - .5) * e + .5), t.r < 0 ? t.r = 0 : t.r > 255 && (t.r = 255), t.g = 255 * ((t.g / 255 - .5) * e + .5), t.g < 0 ? t.g = 0 : t.g > 255 && (t.g = 255), t.b = 255 * ((t.b / 255 - .5) * e + .5), t.b < 0 ? t.b = 0 : t.b > 255 && (t.b = 255), r.helpers.ready(r, t);
}
function $d55d0819d04916aa$var$contrastRatio(r, e) {
    var n = r.operations.convert(r, "rgb", e);
    return n = (299 * n.r + 587 * n.g + 114 * n.b) / 1e3 >= 128 ? {
        r: 0,
        g: 0,
        b: 0
    } : {
        r: 255,
        g: 255,
        b: 255
    }, r.helpers.ready(r, n);
}
function $d55d0819d04916aa$var$convert(r, e, n) {
    if (Object.keys(r.conversions).indexOf(e) > -1) {
        n.colour ? n = n.colour : n.colours && (n = n.colours);
        var t = r.helpers.determineMode(n);
        return t != e ? r.conversions[t].convert(r, e, n) : n;
    }
    return r.helpers.ready(r, e);
}
function $d55d0819d04916aa$var$difference(r, e, n, t, o) {
    t = t || 1, o = o || 1;
    var s = r.operations.convert(r, "cielab", e), a = r.operations.convert(r, "cielab", n), i = Math.sqrt(Math.pow(s.a, 2) + Math.pow(s.b, 2)), c = i - Math.sqrt(Math.pow(a.a, 2) + Math.pow(a.b, 2)), u = s.L - a.L, l = s.a - a.a, h = s.b - a.b, v = Math.sqrt(Math.pow(l, 2) + Math.pow(h, 2) - Math.pow(c, 2)), p = s.L < 16 ? .511 : .040975 * s.L / (1.01765 * s.L), f = .0638 * i / (1.0131 * i), m = Math.atan2(s.b, s.a), d = m >= 0 ? m : m + 360, b = 164 <= d && d <= 345 ? .56 + Math.abs(.2 * Math.cos(r.helpers.toRad(d + 168))) : .36 + Math.abs(.4 * Math.cos(r.helpers.toRad(d + 35))), g = Math.pow(i, 4) / (Math.pow(i, 4) + 1900), y = f * (g * b + 1 - g), _ = Math.pow(u / (t * p), 2);
    return Math.sqrt(_ + _ + _);
}
function $d55d0819d04916aa$var$fade(r, e, n, t) {
    var o = r.operations.convert(r, "rgb", n), s = r.operations.convert(r, "rgb", t), a = [
        o
    ];
    e -= 1;
    for(var i = (s.r - o.r) / e, c = (s.g - o.g) / e, u = (s.b - o.b) / e, l = {
        r: o.r,
        g: o.g,
        b: o.b
    }, h = 0; h < e - 1; h++)l.r = r.helpers.slopeMod(l.r + i, 255), l.g = r.helpers.slopeMod(l.g + c, 255), l.b = r.helpers.slopeMod(l.b + u, 255), a.push({
        r: l.r,
        g: l.g,
        b: l.b
    });
    return a.push(s), r.helpers.ready(r, a);
}
function $d55d0819d04916aa$var$greyscale(r, e) {
    var n = r.operations.convert(r, "rgb", e), t = (n.r + n.g + n.b) / 3;
    return n = {
        r: t,
        g: t,
        b: t
    }, r.helpers.ready(r, n);
}
function $d55d0819d04916aa$var$hue(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.h = r.helpers.negMod(t.h + e, 360), r.helpers.ready(r, t);
}
function $d55d0819d04916aa$var$invert(r, e) {
    var n = r.operations.convert(r, "rgb", e);
    return n.r = r.helpers.negMod(255 - n.r, 255), n.g = r.helpers.negMod(255 - n.g, 255), n.b = r.helpers.negMod(255 - n.b, 255), r.helpers.ready(r, n);
}
function $d55d0819d04916aa$var$invertLightness(r, e) {
    var n = r.operations.convert(r, "hsl", e);
    return n.l = 100 - n.l, r.helpers.ready(r, n);
}
function $d55d0819d04916aa$var$mid(r, e, n) {
    var t = r.operations.convert(r, "hsl", e), o = r.operations.convert(r, "hsl", n), s = {
        h: (t.h + o.h) / 2,
        s: (t.s + o.s) / 2,
        l: (t.l + o.l) / 2
    };
    return r.helpers.ready(r, s);
}
function $d55d0819d04916aa$var$multiply(r, e, n) {
    var t = r.operations.convert(r, "hsl", e), o = r.operations.convert(r, "hsl", n), s = {
        h: t.h,
        s: t.s,
        l: t.l / 100 * (o.l / 100) * 100
    };
    return s.l = s.l > 100 ? 100 : s.l, s.l = s.l < 0 ? 0 : s.l, r.helpers.ready(r, s);
}
function $d55d0819d04916aa$var$saturation(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.s += e, t.s < 0 ? t.s = 0 : t.s > 100 && (t.s = 100), r.helpers.ready(r, t);
}
function $d55d0819d04916aa$var$sepia(r, e) {
    var n = r.operations.convert(r, "rgb", e), t = {};
    return t.r = .393 * n.r + .769 * n.g + .189 * n.b, t.g = .349 * n.r + .686 * n.g + .168 * n.b, t.b = .272 * n.r + .534 * n.g + .131 * n.b, r.helpers.ready(r, t);
}
function $d55d0819d04916aa$var$shade(r, e, n) {
    var t = r.operations.convert(r, "hsv", n);
    return t.v += e, t.v < 0 ? t.v = 0 : t.v > 100 && (t.v = 100), r.helpers.ready(r, t);
}
function $d55d0819d04916aa$var$temperature(r, e) {
    var n = r.operations.convert(r, "xyY", e), t = (n.x - .332) / (n.y - .1858);
    return -449 * Math.pow(t, 3) + 3525 * Math.pow(t, 2) - 6823.3 * t + 5520.33;
}
function $d55d0819d04916aa$var$tetrad(r, e) {
    for(var n = r.operations.convert(r, "hsl", e), t = [
        {
            h: n.h,
            s: n.s,
            l: n.l
        }
    ], o = 0; o < 3; o++)n.h = (n.h + 90) % 360, t.push({
        h: n.h,
        s: n.s,
        l: n.l
    });
    return r.helpers.ready(r, t);
}
function $d55d0819d04916aa$var$triad(r, e) {
    for(var n = r.operations.convert(r, "hsl", e), t = [
        {
            h: n.h,
            s: n.s,
            l: n.l
        }
    ], o = 0; o < 2; o++)n.h = (n.h + 120) % 360, t.push({
        h: n.h,
        s: n.s,
        l: n.l
    });
    return r.helpers.ready(r, t);
}
var $d55d0819d04916aa$var$fromHex_1 = $d55d0819d04916aa$var$fromHex, $d55d0819d04916aa$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(r) {
    return typeof r;
} : function(r) {
    return r && "function" == typeof Symbol && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
}, $d55d0819d04916aa$var$slicedToArray = function() {
    function r(r, e) {
        var n = [], t = !0, o = !1, s = void 0;
        try {
            for(var a, i = r[Symbol.iterator](); !(t = (a = i.next()).done) && (n.push(a.value), !e || n.length !== e); t = !0);
        } catch (r) {
            o = !0, s = r;
        } finally{
            try {
                !t && i.return && i.return();
            } finally{
                if (o) throw s;
            }
        }
        return n;
    }
    return function(e, n) {
        if (Array.isArray(e)) return e;
        if (Symbol.iterator in Object(e)) return r(e, n);
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}(), $d55d0819d04916aa$var$toConsumableArray = function(r) {
    if (Array.isArray(r)) {
        for(var e = 0, n = Array(r.length); e < r.length; e++)n[e] = r[e];
        return n;
    }
    return Array.from(r);
}, $d55d0819d04916aa$var$fromRgb_1 = $d55d0819d04916aa$var$fromRgb, $d55d0819d04916aa$var$fromCssRgb_1 = $d55d0819d04916aa$var$fromCssRgb, $d55d0819d04916aa$var$fromHsl_1 = $d55d0819d04916aa$var$fromHsl, $d55d0819d04916aa$var$fromCssHsl_1 = $d55d0819d04916aa$var$fromCssHsl, $d55d0819d04916aa$var$fromHsv_1 = $d55d0819d04916aa$var$fromHsv, $d55d0819d04916aa$var$fromCmyk_1 = $d55d0819d04916aa$var$fromCmyk, $d55d0819d04916aa$var$fromYiq_1 = $d55d0819d04916aa$var$fromYiq, $d55d0819d04916aa$var$fromXYZ_1 = $d55d0819d04916aa$var$fromXYZ, $d55d0819d04916aa$var$fromxyY_1 = $d55d0819d04916aa$var$fromxyY, $d55d0819d04916aa$var$fromLms_1 = $d55d0819d04916aa$var$fromLms, $d55d0819d04916aa$var$fromCieLab_1 = $d55d0819d04916aa$var$fromCieLab, $d55d0819d04916aa$var$fromCieLuv_1 = $d55d0819d04916aa$var$fromCieLuv, $d55d0819d04916aa$var$fromCieLch_1 = $d55d0819d04916aa$var$fromCieLch, $d55d0819d04916aa$var$fromHsluv = $d55d0819d04916aa$var$fromCieLch$1, $d55d0819d04916aa$var$index = {
    hex: {
        test: function(r) {
            return "string" == typeof r && "#" === r.slice(0, 1);
        },
        convert: $d55d0819d04916aa$var$fromHex_1
    },
    rgb: {
        test: function(r) {
            return $d55d0819d04916aa$var$contains(r, [
                "r",
                "g",
                "b"
            ]);
        },
        convert: $d55d0819d04916aa$var$fromRgb_1
    },
    cssrgb: {
        test: function(r) {
            return "string" == typeof r && "rgb(" === r.slice(0, 4);
        },
        convert: $d55d0819d04916aa$var$fromCssRgb_1
    },
    hsl: {
        test: function(r) {
            return $d55d0819d04916aa$var$contains(r, [
                "h",
                "s",
                "l"
            ]);
        },
        convert: $d55d0819d04916aa$var$fromHsl_1
    },
    csshsl: {
        test: function(r) {
            return "string" == typeof r && "hsl(" === r.slice(0, 4);
        },
        convert: $d55d0819d04916aa$var$fromCssHsl_1
    },
    hsv: {
        test: function(r) {
            return $d55d0819d04916aa$var$contains(r, [
                "h",
                "s",
                "v"
            ]);
        },
        convert: $d55d0819d04916aa$var$fromHsv_1
    },
    cmyk: {
        test: function(r) {
            return $d55d0819d04916aa$var$contains(r, [
                "c",
                "m",
                "y",
                "k"
            ]);
        },
        convert: $d55d0819d04916aa$var$fromCmyk_1
    },
    yiq: {
        test: function(r) {
            return $d55d0819d04916aa$var$contains(r, [
                "y",
                "i",
                "q"
            ]);
        },
        convert: $d55d0819d04916aa$var$fromYiq_1
    },
    XYZ: {
        test: function(r) {
            return $d55d0819d04916aa$var$contains(r, [
                "X",
                "Y",
                "Z"
            ]);
        },
        convert: $d55d0819d04916aa$var$fromXYZ_1
    },
    xyY: {
        test: function(r) {
            return $d55d0819d04916aa$var$contains(r, [
                "x",
                "y",
                "Y"
            ]);
        },
        convert: $d55d0819d04916aa$var$fromxyY_1
    },
    lms: {
        test: function(r) {
            return $d55d0819d04916aa$var$contains(r, [
                "rho",
                "gamma",
                "beta"
            ]);
        },
        convert: $d55d0819d04916aa$var$fromLms_1
    },
    cielab: {
        test: function(r) {
            return $d55d0819d04916aa$var$contains(r, [
                "L",
                "a",
                "b"
            ]);
        },
        convert: $d55d0819d04916aa$var$fromCieLab_1
    },
    cieluv: {
        test: function(r) {
            return $d55d0819d04916aa$var$contains(r, [
                "L",
                "u",
                "v"
            ]);
        },
        convert: $d55d0819d04916aa$var$fromCieLuv_1
    },
    cielch: {
        test: function(r) {
            return $d55d0819d04916aa$var$contains(r, [
                "L",
                "C",
                "h"
            ]);
        },
        convert: $d55d0819d04916aa$var$fromCieLch_1
    },
    hsluv: {
        test: function(r) {
            return $d55d0819d04916aa$var$contains(r, [
                "hu",
                "s",
                "l"
            ]);
        },
        convert: $d55d0819d04916aa$var$fromHsluv
    }
}, $d55d0819d04916aa$var$adapt_1 = $d55d0819d04916aa$var$adapt, $d55d0819d04916aa$var$adjacent_1 = $d55d0819d04916aa$var$adjacent, $d55d0819d04916aa$var$brightness_1 = $d55d0819d04916aa$var$brightness, $d55d0819d04916aa$var$complementary_1 = $d55d0819d04916aa$var$complementary, $d55d0819d04916aa$var$contrast_1 = $d55d0819d04916aa$var$contrast, $d55d0819d04916aa$var$contrastRatio_1 = $d55d0819d04916aa$var$contrastRatio, $d55d0819d04916aa$var$convert_1 = $d55d0819d04916aa$var$convert, $d55d0819d04916aa$var$difference_1 = $d55d0819d04916aa$var$difference, $d55d0819d04916aa$var$fade_1 = $d55d0819d04916aa$var$fade, $d55d0819d04916aa$var$greyscale_1 = $d55d0819d04916aa$var$greyscale, $d55d0819d04916aa$var$hue_1 = $d55d0819d04916aa$var$hue, $d55d0819d04916aa$var$invert_1 = $d55d0819d04916aa$var$invert, $d55d0819d04916aa$var$invertLightness_1 = $d55d0819d04916aa$var$invertLightness, $d55d0819d04916aa$var$mid_1 = $d55d0819d04916aa$var$mid, $d55d0819d04916aa$var$multiply_1 = $d55d0819d04916aa$var$multiply, $d55d0819d04916aa$var$saturation_1 = $d55d0819d04916aa$var$saturation, $d55d0819d04916aa$var$sepia_1 = $d55d0819d04916aa$var$sepia, $d55d0819d04916aa$var$shade_1 = $d55d0819d04916aa$var$shade, $d55d0819d04916aa$var$temperature_1 = $d55d0819d04916aa$var$temperature, $d55d0819d04916aa$var$tetrad_1 = $d55d0819d04916aa$var$tetrad, $d55d0819d04916aa$var$triad_1 = $d55d0819d04916aa$var$triad, $d55d0819d04916aa$var$index$2 = {
    adapt: $d55d0819d04916aa$var$adapt_1,
    adjacent: $d55d0819d04916aa$var$adjacent_1,
    brightness: $d55d0819d04916aa$var$brightness_1,
    complementary: $d55d0819d04916aa$var$complementary_1,
    contrast: $d55d0819d04916aa$var$contrast_1,
    contrastRatio: $d55d0819d04916aa$var$contrastRatio_1,
    convert: $d55d0819d04916aa$var$convert_1,
    difference: $d55d0819d04916aa$var$difference_1,
    fade: $d55d0819d04916aa$var$fade_1,
    greyscale: $d55d0819d04916aa$var$greyscale_1,
    hue: $d55d0819d04916aa$var$hue_1,
    invert: $d55d0819d04916aa$var$invert_1,
    invertLightness: $d55d0819d04916aa$var$invertLightness_1,
    mid: $d55d0819d04916aa$var$mid_1,
    multiply: $d55d0819d04916aa$var$multiply_1,
    saturation: $d55d0819d04916aa$var$saturation_1,
    sepia: $d55d0819d04916aa$var$sepia_1,
    shade: $d55d0819d04916aa$var$shade_1,
    temperature: $d55d0819d04916aa$var$temperature_1,
    tetrad: $d55d0819d04916aa$var$tetrad_1,
    triad: $d55d0819d04916aa$var$triad_1
}, $d55d0819d04916aa$var$constants = {
    ILLUMINANTS: {
        A: {
            X: 1.0985 * 100,
            Y: 100,
            Z: 35.585
        },
        B: {
            X: 99.072,
            Y: 100,
            Z: 85.223
        },
        C: {
            X: 98.074,
            Y: 100,
            Z: 118.232
        },
        D50: {
            X: 96.422,
            Y: 100,
            Z: 82.521
        },
        D55: {
            X: 95.682,
            Y: 100,
            Z: 92.149
        },
        D65: {
            X: 95.047,
            Y: 100,
            Z: 108.883
        },
        D75: {
            X: 94.972,
            Y: 100,
            Z: 122.638
        },
        E: {
            X: 100,
            Y: 100,
            Z: 100
        },
        F2: {
            X: .99186 * 100,
            Y: 100,
            Z: 67.393
        },
        F7: {
            X: 95.041,
            Y: 100,
            Z: 108.747
        },
        F11: {
            X: 1.00962 * 100,
            Y: 100,
            Z: 64.35
        }
    },
    TRANSFORMS: {
        BRADFORD: [
            [
                .8951,
                .2664,
                -0.1614
            ],
            [
                -0.7502,
                1.7135,
                .0367
            ],
            [
                .0389,
                -0.0685,
                1.0296
            ]
        ],
        INVERSE_BRADFORD: [
            [
                .9869929,
                -0.1470543,
                .1599627
            ],
            [
                .4323053,
                .5183603,
                .0492912
            ],
            [
                -0.0085287,
                .0400428,
                .9684867
            ]
        ],
        SRGB_XYZ: [
            [
                .4124,
                .3576,
                .1805
            ],
            [
                .2126,
                .7152,
                .0722
            ],
            [
                .0193,
                .1192,
                .9505
            ]
        ],
        INVERSE_SRGB_XYZ: [
            [
                3.2406,
                -1.5372,
                -0.4986
            ],
            [
                -0.9689,
                1.8758,
                .0415
            ],
            [
                .0557,
                -0.204,
                1.057
            ]
        ]
    }
}, $d55d0819d04916aa$var$api = function(r, e, n) {
    var t = Object.keys(r.operations).reduce(function(e, t) {
        var o = r.operations[t];
        return e[t] = function() {
            for(var e = arguments.length, t = Array(e), s = 0; s < e; s++)t[s] = arguments[s];
            var a = t.slice(0).map(function(r) {
                return "object" === (void 0 === r ? "undefined" : $d55d0819d04916aa$var$_typeof(r)) ? Object.assign({}, r) : r;
            });
            if (n && n.colours) return function e(n) {
                var t = n.map(function(n) {
                    if (Array.isArray(n)) {
                        var t = e(n);
                        return t.colours || t.colour;
                    }
                    var s = o.apply(void 0, [
                        r
                    ].concat($d55d0819d04916aa$var$toConsumableArray(a), [
                        n
                    ]));
                    return "object" === (void 0 === s ? "undefined" : $d55d0819d04916aa$var$_typeof(s)) ? s.colours || s.colour : s;
                });
                return "number" != typeof t[0] ? r.helpers.ready(r, t) : t;
            }(n.colours);
            return o.apply(void 0, [
                r
            ].concat($d55d0819d04916aa$var$toConsumableArray(a), [
                n ? n.colour : void 0
            ]));
        }, e;
    }, {});
    return n || (t = Object.assign(t, e)), t;
}, $d55d0819d04916aa$var$api_1 = $d55d0819d04916aa$var$api, $d55d0819d04916aa$var$helpers = {
    getIlluminant: function(r) {
        return $d55d0819d04916aa$var$constants.ILLUMINANTS[r];
    },
    getTransform: function(r) {
        return $d55d0819d04916aa$var$constants.TRANSFORMS[r];
    },
    matrixMultiply: function(r, e) {
        for(var n = [], t = 0; t < r.length; t++){
            n[t] = [];
            for(var o = 0; o < e[0].length; o++){
                for(var s = 0, a = 0; a < r[0].length; a++)s += r[t][a] * e[a][o];
                n[t][o] = s;
            }
        }
        return n;
    },
    cbrt: function(r) {
        if (Math.cbrt) return Math.cbrt(r);
        var e = Math.pow(Math.abs(r), 1 / 3);
        return r < 0 ? -e : e;
    },
    toRad: function(r) {
        return r * (Math.PI / 180);
    },
    toDeg: function(r) {
        return r * (180 / Math.PI);
    },
    negMod: function(r, e) {
        return (r % e + e) % e;
    },
    slopeMod: function(r) {
        function e(e, n) {
            return r.apply(this, arguments);
        }
        return e.toString = function() {
            return r.toString();
        }, e;
    }(function(r, e) {
        return r > 2 * e ? slopeMod(r - 2 * e, e) : r > e ? 2 * e - r : r < 0 ? slopeMod(r + 2 * e, e) : r;
    }),
    bounded: function(r, e) {
        return r < e[0] ? r = e[0] : r > e[1] && (r = e[1]), r;
    },
    boundedRgb: function(r) {
        var e = this, n = function(r) {
            return e.bounded(r, [
                0,
                255
            ]);
        };
        return {
            r: n(r.r),
            g: n(r.g),
            b: n(r.b)
        };
    },
    determineMode: function(r) {
        for(var e in $d55d0819d04916aa$var$index)if ($d55d0819d04916aa$var$index.hasOwnProperty(e) && $d55d0819d04916aa$var$index[e].test(r)) return e;
        return null;
    },
    ready: function(r, e) {
        var n = r.conversions, t = r.operations, o = r.helpers, s = {};
        switch(Object.prototype.toString.call(e)){
            case "[object Object]":
            case "[object String]":
                s.colour = e;
                for(var a in n)n.hasOwnProperty(a) && function(r) {
                    Object.defineProperty(s, r, {
                        get: function() {
                            o.determineMode(e);
                            return t.convert({
                                conversions: n,
                                operations: t,
                                helpers: o
                            }, r, e);
                        },
                        enumerable: !0
                    });
                }(a);
                return s = Object.assign(s, $d55d0819d04916aa$var$api_1({
                    conversions: n,
                    operations: t,
                    helpers: o
                }, $d55d0819d04916aa$var$constants, s));
            case "[object Array]":
                s.colours = e;
                for(var i in n)n.hasOwnProperty(i) && function(r) {
                    Object.defineProperty(s, r, {
                        get: function() {
                            return function e(s) {
                                return s.map(function(s) {
                                    return Array.isArray(s) ? e(s) : t.convert({
                                        conversions: n,
                                        operations: t,
                                        helpers: o
                                    }, r, s);
                                });
                            }(e);
                        },
                        enumerable: !0
                    });
                }(i);
                return s = Object.assign(s, $d55d0819d04916aa$var$api_1({
                    conversions: n,
                    operations: t,
                    helpers: o
                }, $d55d0819d04916aa$var$constants, s));
            default:
                return null;
        }
    }
}, $d55d0819d04916aa$var$helpers_1 = $d55d0819d04916aa$var$helpers, $d55d0819d04916aa$var$dependencies = {
    conversions: $d55d0819d04916aa$var$index,
    operations: $d55d0819d04916aa$var$index$2,
    helpers: $d55d0819d04916aa$var$helpers_1
}, $d55d0819d04916aa$var$entry = $d55d0819d04916aa$var$api_1($d55d0819d04916aa$var$dependencies, $d55d0819d04916aa$var$constants);
var $d55d0819d04916aa$export$2e2bcd8739ae039 = $d55d0819d04916aa$var$entry;

});

parcelRegister("50OLG", function(module, exports) {
$parcel$export(module.exports, "default", () => $d19921b7779cc56a$export$2e2bcd8739ae039);

var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $3X3Vo = parcelRequire("3X3Vo");

var $bPecp = parcelRequire("bPecp");

var $9EkAK = parcelRequire("9EkAK");

var $7p5N7 = parcelRequire("7p5N7");
const $d19921b7779cc56a$var$AnalyticsContext = (props)=>{
    const isModernContext = (0, $bPecp.default) || (0, $3X3Vo.fg)('analytics-next-use-legacy-context') === false;
    return isModernContext ? /*#__PURE__*/ (0, $2iln5.jsx)((0, $7p5N7.default), {
        ...props
    }) : /*#__PURE__*/ (0, $2iln5.jsx)((0, $9EkAK.default), {
        ...props
    });
};
var $d19921b7779cc56a$export$2e2bcd8739ae039 = $d19921b7779cc56a$var$AnalyticsContext;

});
parcelRegister("bPecp", function(module, exports) {
$parcel$export(module.exports, "default", () => $17ac2b2535d9ba09$export$2e2bcd8739ae039);
/// <reference types="node" />

var $hcSxw = parcelRequire("hcSxw");
const $17ac2b2535d9ba09$var$_default_1 = typeof $hcSxw !== 'undefined' && $hcSxw !== null && $hcSxw.env?.['ANALYTICS_NEXT_MODERN_CONTEXT'];
var $17ac2b2535d9ba09$export$2e2bcd8739ae039 = $17ac2b2535d9ba09$var$_default_1;

});

parcelRegister("9EkAK", function(module, exports) {
$parcel$export(module.exports, "default", () => $c259e93c1723304c$export$2e2bcd8739ae039);

var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $jjHN9 = parcelRequire("jjHN9");

var $fz2Rk = parcelRequire("fz2Rk");
const $c259e93c1723304c$var$ContextTypes = {
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($jjHN9))).func,
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($jjHN9))).func
};
const $c259e93c1723304c$var$noop = ()=>[];
// eslint-disable-next-line @repo/internal/react/no-class-components
class $c259e93c1723304c$var$AnalyticsContext extends (0, $4tluv.Component) {
    static{
        this.contextTypes = $c259e93c1723304c$var$ContextTypes;
    }
    static{
        this.childContextTypes = $c259e93c1723304c$var$ContextTypes;
    }
    constructor(props){
        super(props), this.getChildContext = ()=>({
                getAtlaskitAnalyticsContext: this.getAnalyticsContext
            }), this.getAnalyticsContext = ()=>{
            const { data: data } = this.props;
            const { getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext = $c259e93c1723304c$var$noop } = this.context;
            return [
                ...getAtlaskitAnalyticsContext(),
                data
            ];
        }, this.getAnalyticsEventHandlers = ()=>{
            const { getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers = $c259e93c1723304c$var$noop } = this.context;
            return getAtlaskitAnalyticsEventHandlers();
        };
        this.contextValue = {
            getAtlaskitAnalyticsContext: this.getAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: this.getAnalyticsEventHandlers
        };
    }
    render() {
        const { children: children } = this.props;
        return /*#__PURE__*/ (0, $2iln5.jsx)((0, $fz2Rk.default).Provider, {
            value: this.contextValue,
            children: children
        });
    }
}
var $c259e93c1723304c$export$2e2bcd8739ae039 = $c259e93c1723304c$var$AnalyticsContext;

});
parcelRegister("jjHN9", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e101c2c7dc3714d1$var$ReactIs, $e101c2c7dc3714d1$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("koVEg"))();

});
parcelRegister("koVEg", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $d6UlJ = parcelRequire("d6UlJ");
function $eda2c45434205e2a$var$emptyFunction() {}
function $eda2c45434205e2a$var$emptyFunctionWithReset() {}
$eda2c45434205e2a$var$emptyFunctionWithReset.resetWarningCache = $eda2c45434205e2a$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $d6UlJ) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $eda2c45434205e2a$var$emptyFunctionWithReset,
        resetWarningCache: $eda2c45434205e2a$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("d6UlJ", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $98b78bbd63d5f41a$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $98b78bbd63d5f41a$var$ReactPropTypesSecret;

});




parcelRegister("7p5N7", function(module, exports) {
$parcel$export(module.exports, "default", () => $19fc88767372d929$export$2e2bcd8739ae039);

var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $fz2Rk = parcelRequire("fz2Rk");

var $dAjGy = parcelRequire("dAjGy");

var $8lhHD = parcelRequire("8lhHD");
const $19fc88767372d929$var$AnalyticsContext = ({ data: data, children: children })=>{
    const dataRef = (0, $8lhHD.useTrackedRef)(data);
    const { getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsContext: getOriginalAnalyticsContext } = (0, $dAjGy.useAnalyticsContext)();
    const getAtlaskitAnalyticsContext = (0, $4tluv.useCallback)(()=>{
        return [
            ...getOriginalAnalyticsContext(),
            dataRef.current
        ];
    }, [
        getOriginalAnalyticsContext,
        dataRef
    ]);
    const value = (0, $4tluv.useMemo)(()=>({
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers
        }), [
        getAtlaskitAnalyticsContext,
        getAtlaskitAnalyticsEventHandlers
    ]);
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $fz2Rk.default).Provider, {
        value: value,
        children: children
    });
};
var $19fc88767372d929$export$2e2bcd8739ae039 = $19fc88767372d929$var$AnalyticsContext;

});


parcelRegister("f6jDN", function(module, exports) {
$parcel$export(module.exports, "getIn", () => $afe6a6d655f0eded$export$c52e5867d5879e24);
$parcel$export(module.exports, "createForm", () => $afe6a6d655f0eded$export$f681a8129d2e9d28);

var $iXMid = parcelRequire("iXMid");

var $gM5oA = parcelRequire("gM5oA");
//      
var $afe6a6d655f0eded$var$charCodeOfDot = ".".charCodeAt(0);
var $afe6a6d655f0eded$var$reEscapeChar = /\\(\\)?/g;
var $afe6a6d655f0eded$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $afe6a6d655f0eded$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $afe6a6d655f0eded$var$charCodeOfDot) result.push("");
    string.replace($afe6a6d655f0eded$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($afe6a6d655f0eded$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $afe6a6d655f0eded$var$keysCache = {};
var $afe6a6d655f0eded$var$keysRegex = /[.[\]]+/;
var $afe6a6d655f0eded$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($afe6a6d655f0eded$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $afe6a6d655f0eded$var$keysCache[key] = key.split($afe6a6d655f0eded$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $afe6a6d655f0eded$var$keysCache[key] = $afe6a6d655f0eded$var$stringToPath(key);
    }
    return $afe6a6d655f0eded$var$keysCache[key];
};
//      
var $afe6a6d655f0eded$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $afe6a6d655f0eded$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $afe6a6d655f0eded$var$_toPropertyKey(arg) {
    var key = $afe6a6d655f0eded$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $afe6a6d655f0eded$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $afe6a6d655f0eded$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $gM5oA.default)(current, [
                key
            ].map($afe6a6d655f0eded$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $iXMid.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $afe6a6d655f0eded$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $afe6a6d655f0eded$var$setInRecursor(state, 0, $afe6a6d655f0eded$var$toPath(key), value1, destroyArrays);
};
var $afe6a6d655f0eded$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $afe6a6d655f0eded$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $afe6a6d655f0eded$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $afe6a6d655f0eded$export$c52e5867d5879e24(values, name);
    var error = $afe6a6d655f0eded$export$c52e5867d5879e24(errors, name);
    if (error && error[$afe6a6d655f0eded$export$735bebc8ffabf28a]) error = error[$afe6a6d655f0eded$export$735bebc8ffabf28a];
    var submitError = submitErrors && $afe6a6d655f0eded$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $afe6a6d655f0eded$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($afe6a6d655f0eded$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $afe6a6d655f0eded$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $afe6a6d655f0eded$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $afe6a6d655f0eded$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$afe6a6d655f0eded$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $afe6a6d655f0eded$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $afe6a6d655f0eded$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $afe6a6d655f0eded$var$subscriptionFilter(result, state, previousState, subscription, $afe6a6d655f0eded$export$41e855cb628c1b55, $afe6a6d655f0eded$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $afe6a6d655f0eded$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $afe6a6d655f0eded$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $afe6a6d655f0eded$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $afe6a6d655f0eded$var$subscriptionFilter(result, state, previousState, subscription, $afe6a6d655f0eded$export$f1ff97b9d1c7a3c3, $afe6a6d655f0eded$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $afe6a6d655f0eded$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$afe6a6d655f0eded$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $afe6a6d655f0eded$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $afe6a6d655f0eded$export$83d89fbfd8236492 = "4.20.10";
var $afe6a6d655f0eded$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $afe6a6d655f0eded$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $afe6a6d655f0eded$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $afe6a6d655f0eded$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $afe6a6d655f0eded$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $afe6a6d655f0eded$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $afe6a6d655f0eded$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $afe6a6d655f0eded$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($afe6a6d655f0eded$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $afe6a6d655f0eded$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $iXMid.default)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $iXMid.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $afe6a6d655f0eded$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $afe6a6d655f0eded$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $iXMid.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $iXMid.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $iXMid.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $afe6a6d655f0eded$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $afe6a6d655f0eded$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $afe6a6d655f0eded$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $afe6a6d655f0eded$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $afe6a6d655f0eded$export$e6bdf135a54e021b,
                    shallowEqual: $afe6a6d655f0eded$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $iXMid.default)({}, state.formState.values)); // clone to avoid writing
            if ($afe6a6d655f0eded$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($afe6a6d655f0eded$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $afe6a6d655f0eded$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $afe6a6d655f0eded$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $iXMid.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $iXMid.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $afe6a6d655f0eded$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $afe6a6d655f0eded$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $afe6a6d655f0eded$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$afe6a6d655f0eded$export$735bebc8ffabf28a]) {
                    var existing = $afe6a6d655f0eded$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$afe6a6d655f0eded$export$735bebc8ffabf28a] = error[$afe6a6d655f0eded$export$735bebc8ffabf28a];
                    merged = $afe6a6d655f0eded$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$afe6a6d655f0eded$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$afe6a6d655f0eded$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $iXMid.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $afe6a6d655f0eded$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $afe6a6d655f0eded$var$notify(fieldSubscriber, fieldState, lastFieldState, $afe6a6d655f0eded$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $afe6a6d655f0eded$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $iXMid.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($afe6a6d655f0eded$export$c52e5867d5879e24(formState.values, key), $afe6a6d655f0eded$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($afe6a6d655f0eded$export$c52e5867d5879e24(formState.values, key), $afe6a6d655f0eded$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$afe6a6d655f0eded$var$hasAnyError(formState.errors) && !(formState.submitErrors && $afe6a6d655f0eded$var$hasAnyError(formState.submitErrors));
        var nextFormState = $afe6a6d655f0eded$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $afe6a6d655f0eded$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $afe6a6d655f0eded$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $afe6a6d655f0eded$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $afe6a6d655f0eded$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $afe6a6d655f0eded$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $afe6a6d655f0eded$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $afe6a6d655f0eded$var$notify(state.subscribers, nextFormState, lastFormState, $afe6a6d655f0eded$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $iXMid.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($afe6a6d655f0eded$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $iXMid.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $iXMid.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($afe6a6d655f0eded$export$c52e5867d5879e24(formState.values, key), $afe6a6d655f0eded$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $afe6a6d655f0eded$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $afe6a6d655f0eded$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $afe6a6d655f0eded$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $afe6a6d655f0eded$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $afe6a6d655f0eded$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $afe6a6d655f0eded$export$c52e5867d5879e24(state.formState.values, name) === $afe6a6d655f0eded$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $afe6a6d655f0eded$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $afe6a6d655f0eded$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $afe6a6d655f0eded$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $afe6a6d655f0eded$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $afe6a6d655f0eded$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $afe6a6d655f0eded$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $iXMid.default)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $iXMid.default)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $iXMid.default)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $afe6a6d655f0eded$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$afe6a6d655f0eded$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $iXMid.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $afe6a6d655f0eded$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $afe6a6d655f0eded$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $afe6a6d655f0eded$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $afe6a6d655f0eded$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}

});

parcelRegister("ifZ00", function(module, exports) {
$parcel$export(module.exports, "default", () => $d4a8f1d8e30fca02$export$2e2bcd8739ae039);

var $f6jDN = parcelRequire("f6jDN");
//      
/**
 * Predicate to identify inputs that can have focus() called on them
 */ var $d4a8f1d8e30fca02$var$isFocusableInput = function isFocusableInput(wtf) {
    return !!(wtf && typeof wtf.focus === 'function');
};
//      
/**
 * Gets all the inputs inside all forms on the page
 */ var $d4a8f1d8e30fca02$var$getAllInputs = function getAllInputs() {
    if (typeof document === 'undefined') return [];
    return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
        return accumulator.concat(Array.prototype.slice.call(form).filter($d4a8f1d8e30fca02$var$isFocusableInput));
    }, []);
};
//      
/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */ var $d4a8f1d8e30fca02$var$findInput = function findInput(inputs, errors) {
    return inputs.find(function(input) {
        return input.name && (0, $f6jDN.getIn)(errors, input.name);
    });
};
//      
var $d4a8f1d8e30fca02$var$noop = function noop() {};
var $d4a8f1d8e30fca02$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
    return function(form) {
        var focusOnFirstError = function focusOnFirstError(errors) {
            if (!getInputs) getInputs = $d4a8f1d8e30fca02$var$getAllInputs;
            if (!findInput$$1) findInput$$1 = $d4a8f1d8e30fca02$var$findInput;
            var firstInput = findInput$$1(getInputs(), errors);
            if (firstInput) firstInput.focus();
        }; // Save original submit function
        var originalSubmit = form.submit; // Subscribe to errors, and keep a local copy of them
        var state = {};
        var unsubscribe = form.subscribe(function(nextState) {
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        }); // What to do after submit
        var afterSubmit = function afterSubmit() {
            var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        }; // Rewrite submit function
        form.submit = function() {
            var result = originalSubmit.call(form);
            if (result && typeof result.then === 'function') // async
            result.then(afterSubmit, $d4a8f1d8e30fca02$var$noop);
            else // sync
            afterSubmit();
            return result;
        };
        return function() {
            unsubscribe();
            form.submit = originalSubmit;
        };
    };
};
//      
/**
 * Generates a function to get all the inputs in a form with the specified name
 */ var $d4a8f1d8e30fca02$export$a53c79cbd9f0d029 = function getFormInputs(name) {
    return function() {
        if (typeof document === 'undefined') return [];
         // $FlowFixMe
        var form = document.forms[name];
        return form && form.length ? Array.prototype.slice.call(form).filter($d4a8f1d8e30fca02$var$isFocusableInput) : []; // cast cheat to get from HTMLFormElement children to FocusableInput
    };
};
var //
$d4a8f1d8e30fca02$export$2e2bcd8739ae039 = $d4a8f1d8e30fca02$var$createDecorator;

});

parcelRegister("jxVML", function(module, exports) {

var $dTA3s = parcelRequire("dTA3s");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $e3adec65dc39bc11$var$set(object, path, value) {
    return object == null ? object : $dTA3s(object, path, value);
}
module.exports = $e3adec65dc39bc11$var$set;

});
parcelRegister("dTA3s", function(module, exports) {

var $iIu4H = parcelRequire("iIu4H");

var $1fA0W = parcelRequire("1fA0W");

var $edtoq = parcelRequire("edtoq");

var $erMec = parcelRequire("erMec");

var $9xcd1 = parcelRequire("9xcd1");
/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function $a1dc61200145a0be$var$baseSet(object, path, value, customizer) {
    if (!$erMec(object)) return object;
    path = $1fA0W(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = $9xcd1(path[index]), newValue = value;
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = $erMec(objValue) ? objValue : $edtoq(path[index + 1]) ? [] : {};
        }
        $iIu4H(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
module.exports = $a1dc61200145a0be$var$baseSet;

});
parcelRegister("iIu4H", function(module, exports) {

var $dWc1r = parcelRequire("dWc1r");

var $bszkr = parcelRequire("bszkr");
/** Used for built-in method references. */ var $da03aa44b21e9519$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $da03aa44b21e9519$var$hasOwnProperty = $da03aa44b21e9519$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $da03aa44b21e9519$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($da03aa44b21e9519$var$hasOwnProperty.call(object, key) && $bszkr(objValue, value)) || value === undefined && !(key in object)) $dWc1r(object, key, value);
}
module.exports = $da03aa44b21e9519$var$assignValue;

});
parcelRegister("dWc1r", function(module, exports) {

var $fKSf3 = parcelRequire("fKSf3");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $a25a0488a3fe4487$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && $fKSf3) $fKSf3(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
module.exports = $a25a0488a3fe4487$var$baseAssignValue;

});
parcelRegister("fKSf3", function(module, exports) {

var $7OMUJ = parcelRequire("7OMUJ");
var $b7853a3057f5a7f2$var$defineProperty = function() {
    try {
        var func = $7OMUJ(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
module.exports = $b7853a3057f5a7f2$var$defineProperty;

});
parcelRegister("7OMUJ", function(module, exports) {

var $kE8GC = parcelRequire("kE8GC");

var $4HfPh = parcelRequire("4HfPh");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $5b132533bd7f7f83$var$getNative(object, key) {
    var value = $4HfPh(object, key);
    return $kE8GC(value) ? value : undefined;
}
module.exports = $5b132533bd7f7f83$var$getNative;

});
parcelRegister("kE8GC", function(module, exports) {

var $jK3fo = parcelRequire("jK3fo");

var $987B4 = parcelRequire("987B4");

var $erMec = parcelRequire("erMec");

var $cy1mA = parcelRequire("cy1mA");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $f07e480765967a8d$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $f07e480765967a8d$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $f07e480765967a8d$var$funcProto = Function.prototype, $f07e480765967a8d$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $f07e480765967a8d$var$funcToString = $f07e480765967a8d$var$funcProto.toString;
/** Used to check objects for own properties. */ var $f07e480765967a8d$var$hasOwnProperty = $f07e480765967a8d$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $f07e480765967a8d$var$reIsNative = RegExp('^' + $f07e480765967a8d$var$funcToString.call($f07e480765967a8d$var$hasOwnProperty).replace($f07e480765967a8d$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $f07e480765967a8d$var$baseIsNative(value) {
    if (!$erMec(value) || $987B4(value)) return false;
    var pattern = $jK3fo(value) ? $f07e480765967a8d$var$reIsNative : $f07e480765967a8d$var$reIsHostCtor;
    return pattern.test($cy1mA(value));
}
module.exports = $f07e480765967a8d$var$baseIsNative;

});
parcelRegister("jK3fo", function(module, exports) {

var $4JsI8 = parcelRequire("4JsI8");

var $erMec = parcelRequire("erMec");
/** `Object#toString` result references. */ var $e5f4d50e6fdb6b1a$var$asyncTag = '[object AsyncFunction]', $e5f4d50e6fdb6b1a$var$funcTag = '[object Function]', $e5f4d50e6fdb6b1a$var$genTag = '[object GeneratorFunction]', $e5f4d50e6fdb6b1a$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $e5f4d50e6fdb6b1a$var$isFunction(value) {
    if (!$erMec(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $4JsI8(value);
    return tag == $e5f4d50e6fdb6b1a$var$funcTag || tag == $e5f4d50e6fdb6b1a$var$genTag || tag == $e5f4d50e6fdb6b1a$var$asyncTag || tag == $e5f4d50e6fdb6b1a$var$proxyTag;
}
module.exports = $e5f4d50e6fdb6b1a$var$isFunction;

});
parcelRegister("4JsI8", function(module, exports) {

var $13cTt = parcelRequire("13cTt");

var $9Fb2e = parcelRequire("9Fb2e");

var $fWcmH = parcelRequire("fWcmH");
/** `Object#toString` result references. */ var $3721a2c405d06186$var$nullTag = '[object Null]', $3721a2c405d06186$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $3721a2c405d06186$var$symToStringTag = $13cTt ? $13cTt.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $3721a2c405d06186$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $3721a2c405d06186$var$undefinedTag : $3721a2c405d06186$var$nullTag;
    return $3721a2c405d06186$var$symToStringTag && $3721a2c405d06186$var$symToStringTag in Object(value) ? $9Fb2e(value) : $fWcmH(value);
}
module.exports = $3721a2c405d06186$var$baseGetTag;

});
parcelRegister("13cTt", function(module, exports) {

var $7TNGW = parcelRequire("7TNGW");
/** Built-in value references. */ var $0c4012b39c601360$var$Symbol = $7TNGW.Symbol;
module.exports = $0c4012b39c601360$var$Symbol;

});
parcelRegister("7TNGW", function(module, exports) {

var $jL9NK = parcelRequire("jL9NK");
/** Detect free variable `self`. */ var $5c0437263087d151$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $5c0437263087d151$var$root = $jL9NK || $5c0437263087d151$var$freeSelf || Function('return this')();
module.exports = $5c0437263087d151$var$root;

});
parcelRegister("jL9NK", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $e62a02783a125e85$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $e62a02783a125e85$var$freeGlobal;

});



parcelRegister("9Fb2e", function(module, exports) {

var $13cTt = parcelRequire("13cTt");
/** Used for built-in method references. */ var $709080b086cfaf02$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $709080b086cfaf02$var$hasOwnProperty = $709080b086cfaf02$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $709080b086cfaf02$var$nativeObjectToString = $709080b086cfaf02$var$objectProto.toString;
/** Built-in value references. */ var $709080b086cfaf02$var$symToStringTag = $13cTt ? $13cTt.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $709080b086cfaf02$var$getRawTag(value) {
    var isOwn = $709080b086cfaf02$var$hasOwnProperty.call(value, $709080b086cfaf02$var$symToStringTag), tag = value[$709080b086cfaf02$var$symToStringTag];
    try {
        value[$709080b086cfaf02$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $709080b086cfaf02$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$709080b086cfaf02$var$symToStringTag] = tag;
        else delete value[$709080b086cfaf02$var$symToStringTag];
    }
    return result;
}
module.exports = $709080b086cfaf02$var$getRawTag;

});

parcelRegister("fWcmH", function(module, exports) {
/** Used for built-in method references. */ var $b9a5dd461fffe765$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $b9a5dd461fffe765$var$nativeObjectToString = $b9a5dd461fffe765$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $b9a5dd461fffe765$var$objectToString(value) {
    return $b9a5dd461fffe765$var$nativeObjectToString.call(value);
}
module.exports = $b9a5dd461fffe765$var$objectToString;

});


parcelRegister("erMec", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $a848ff681e84d3f5$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
module.exports = $a848ff681e84d3f5$var$isObject;

});


parcelRegister("987B4", function(module, exports) {

var $kLxi4 = parcelRequire("kLxi4");
/** Used to detect methods masquerading as native. */ var $6a5ac103748dfebd$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($kLxi4 && $kLxi4.keys && $kLxi4.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $6a5ac103748dfebd$var$isMasked(func) {
    return !!$6a5ac103748dfebd$var$maskSrcKey && $6a5ac103748dfebd$var$maskSrcKey in func;
}
module.exports = $6a5ac103748dfebd$var$isMasked;

});
parcelRegister("kLxi4", function(module, exports) {

var $7TNGW = parcelRequire("7TNGW");
/** Used to detect overreaching core-js shims. */ var $f1e2053976b84ac8$var$coreJsData = $7TNGW["__core-js_shared__"];
module.exports = $f1e2053976b84ac8$var$coreJsData;

});


parcelRegister("cy1mA", function(module, exports) {
/** Used for built-in method references. */ var $9229b7bbe623ffa3$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $9229b7bbe623ffa3$var$funcToString = $9229b7bbe623ffa3$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $9229b7bbe623ffa3$var$toSource(func) {
    if (func != null) {
        try {
            return $9229b7bbe623ffa3$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
module.exports = $9229b7bbe623ffa3$var$toSource;

});


parcelRegister("4HfPh", function(module, exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $36b774522b59befb$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = $36b774522b59befb$var$getValue;

});




parcelRegister("bszkr", function(module, exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $857db6c255697b6e$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = $857db6c255697b6e$var$eq;

});


parcelRegister("1fA0W", function(module, exports) {

var $c1j63 = parcelRequire("c1j63");

var $kvKEE = parcelRequire("kvKEE");

var $etYb4 = parcelRequire("etYb4");

var $lU5pp = parcelRequire("lU5pp");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $0e9320d6392afc9e$var$castPath(value, object) {
    if ($c1j63(value)) return value;
    return $kvKEE(value, object) ? [
        value
    ] : $etYb4($lU5pp(value));
}
module.exports = $0e9320d6392afc9e$var$castPath;

});
parcelRegister("c1j63", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $8c04643ebb0bb05c$var$isArray = Array.isArray;
module.exports = $8c04643ebb0bb05c$var$isArray;

});

parcelRegister("kvKEE", function(module, exports) {

var $c1j63 = parcelRequire("c1j63");

var $7ENDX = parcelRequire("7ENDX");
/** Used to match property names within property paths. */ var $eeeae4844baf730c$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $eeeae4844baf730c$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $eeeae4844baf730c$var$isKey(value, object) {
    if ($c1j63(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $7ENDX(value)) return true;
    return $eeeae4844baf730c$var$reIsPlainProp.test(value) || !$eeeae4844baf730c$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = $eeeae4844baf730c$var$isKey;

});
parcelRegister("7ENDX", function(module, exports) {

var $4JsI8 = parcelRequire("4JsI8");

var $6J0WJ = parcelRequire("6J0WJ");
/** `Object#toString` result references. */ var $5932c6fe7dfd401d$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $5932c6fe7dfd401d$var$isSymbol(value) {
    return typeof value == 'symbol' || $6J0WJ(value) && $4JsI8(value) == $5932c6fe7dfd401d$var$symbolTag;
}
module.exports = $5932c6fe7dfd401d$var$isSymbol;

});
parcelRegister("6J0WJ", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $4e57adfba23cc892$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
module.exports = $4e57adfba23cc892$var$isObjectLike;

});



parcelRegister("etYb4", function(module, exports) {

var $fjRQk = parcelRequire("fjRQk");
/** Used to match property names within property paths. */ var $a8b2741c2c704754$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $a8b2741c2c704754$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $a8b2741c2c704754$var$stringToPath = $fjRQk(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($a8b2741c2c704754$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($a8b2741c2c704754$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
module.exports = $a8b2741c2c704754$var$stringToPath;

});
parcelRegister("fjRQk", function(module, exports) {

var $jXP5l = parcelRequire("jXP5l");
/** Used as the maximum memoize cache size. */ var $b2726574f6e85492$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $b2726574f6e85492$var$memoizeCapped(func) {
    var result = $jXP5l(func, function(key) {
        if (cache.size === $b2726574f6e85492$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = $b2726574f6e85492$var$memoizeCapped;

});
parcelRegister("jXP5l", function(module, exports) {

var $ctyji = parcelRequire("ctyji");
/** Error message constants. */ var $e88b277c55bc8b77$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $e88b277c55bc8b77$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($e88b277c55bc8b77$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($e88b277c55bc8b77$var$memoize.Cache || $ctyji);
    return memoized;
}
// Expose `MapCache`.
$e88b277c55bc8b77$var$memoize.Cache = $ctyji;
module.exports = $e88b277c55bc8b77$var$memoize;

});
parcelRegister("ctyji", function(module, exports) {

var $1vlSF = parcelRequire("1vlSF");

var $30maz = parcelRequire("30maz");

var $iDxJ0 = parcelRequire("iDxJ0");

var $6CCE5 = parcelRequire("6CCE5");

var $16XtT = parcelRequire("16XtT");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $9152cec5d2380aea$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$9152cec5d2380aea$var$MapCache.prototype.clear = $1vlSF;
$9152cec5d2380aea$var$MapCache.prototype['delete'] = $30maz;
$9152cec5d2380aea$var$MapCache.prototype.get = $iDxJ0;
$9152cec5d2380aea$var$MapCache.prototype.has = $6CCE5;
$9152cec5d2380aea$var$MapCache.prototype.set = $16XtT;
module.exports = $9152cec5d2380aea$var$MapCache;

});
parcelRegister("1vlSF", function(module, exports) {

var $iAr5O = parcelRequire("iAr5O");

var $k4osY = parcelRequire("k4osY");

var $5xH4D = parcelRequire("5xH4D");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $1189a8ba13bcea48$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $iAr5O,
        'map': new ($5xH4D || $k4osY),
        'string': new $iAr5O
    };
}
module.exports = $1189a8ba13bcea48$var$mapCacheClear;

});
parcelRegister("iAr5O", function(module, exports) {

var $hy11S = parcelRequire("hy11S");

var $g5gIV = parcelRequire("g5gIV");

var $eFAwX = parcelRequire("eFAwX");

var $bvCIX = parcelRequire("bvCIX");

var $gGveE = parcelRequire("gGveE");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $d8809ad6520a5022$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$d8809ad6520a5022$var$Hash.prototype.clear = $hy11S;
$d8809ad6520a5022$var$Hash.prototype['delete'] = $g5gIV;
$d8809ad6520a5022$var$Hash.prototype.get = $eFAwX;
$d8809ad6520a5022$var$Hash.prototype.has = $bvCIX;
$d8809ad6520a5022$var$Hash.prototype.set = $gGveE;
module.exports = $d8809ad6520a5022$var$Hash;

});
parcelRegister("hy11S", function(module, exports) {

var $aE1TL = parcelRequire("aE1TL");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $cc66690e6876c2c5$var$hashClear() {
    this.__data__ = $aE1TL ? $aE1TL(null) : {};
    this.size = 0;
}
module.exports = $cc66690e6876c2c5$var$hashClear;

});
parcelRegister("aE1TL", function(module, exports) {

var $7OMUJ = parcelRequire("7OMUJ");
/* Built-in method references that are verified to be native. */ var $7bff1cc572fef7b1$var$nativeCreate = $7OMUJ(Object, 'create');
module.exports = $7bff1cc572fef7b1$var$nativeCreate;

});


parcelRegister("g5gIV", function(module, exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $bb5a15e8964e1e2a$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $bb5a15e8964e1e2a$var$hashDelete;

});

parcelRegister("eFAwX", function(module, exports) {

var $aE1TL = parcelRequire("aE1TL");
/** Used to stand-in for `undefined` hash values. */ var $aae13b3b20953a96$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $aae13b3b20953a96$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $aae13b3b20953a96$var$hasOwnProperty = $aae13b3b20953a96$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $aae13b3b20953a96$var$hashGet(key) {
    var data = this.__data__;
    if ($aE1TL) {
        var result = data[key];
        return result === $aae13b3b20953a96$var$HASH_UNDEFINED ? undefined : result;
    }
    return $aae13b3b20953a96$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = $aae13b3b20953a96$var$hashGet;

});

parcelRegister("bvCIX", function(module, exports) {

var $aE1TL = parcelRequire("aE1TL");
/** Used for built-in method references. */ var $02298efaf4a22b33$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $02298efaf4a22b33$var$hasOwnProperty = $02298efaf4a22b33$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $02298efaf4a22b33$var$hashHas(key) {
    var data = this.__data__;
    return $aE1TL ? data[key] !== undefined : $02298efaf4a22b33$var$hasOwnProperty.call(data, key);
}
module.exports = $02298efaf4a22b33$var$hashHas;

});

parcelRegister("gGveE", function(module, exports) {

var $aE1TL = parcelRequire("aE1TL");
/** Used to stand-in for `undefined` hash values. */ var $c258cc3f69799b19$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $c258cc3f69799b19$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $aE1TL && value === undefined ? $c258cc3f69799b19$var$HASH_UNDEFINED : value;
    return this;
}
module.exports = $c258cc3f69799b19$var$hashSet;

});


parcelRegister("k4osY", function(module, exports) {

var $d56Fq = parcelRequire("d56Fq");

var $28TR6 = parcelRequire("28TR6");

var $kQxD1 = parcelRequire("kQxD1");

var $8s9nn = parcelRequire("8s9nn");

var $3WPG7 = parcelRequire("3WPG7");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $e9c728e2f9ed8c00$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$e9c728e2f9ed8c00$var$ListCache.prototype.clear = $d56Fq;
$e9c728e2f9ed8c00$var$ListCache.prototype['delete'] = $28TR6;
$e9c728e2f9ed8c00$var$ListCache.prototype.get = $kQxD1;
$e9c728e2f9ed8c00$var$ListCache.prototype.has = $8s9nn;
$e9c728e2f9ed8c00$var$ListCache.prototype.set = $3WPG7;
module.exports = $e9c728e2f9ed8c00$var$ListCache;

});
parcelRegister("d56Fq", function(module, exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $9860e9f58d665669$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = $9860e9f58d665669$var$listCacheClear;

});

parcelRegister("28TR6", function(module, exports) {

var $kcMox = parcelRequire("kcMox");
/** Used for built-in method references. */ var $18f7a7df034fc2e9$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $18f7a7df034fc2e9$var$splice = $18f7a7df034fc2e9$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $18f7a7df034fc2e9$var$listCacheDelete(key) {
    var data = this.__data__, index = $kcMox(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $18f7a7df034fc2e9$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = $18f7a7df034fc2e9$var$listCacheDelete;

});
parcelRegister("kcMox", function(module, exports) {

var $bszkr = parcelRequire("bszkr");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $eb5a77d13b5de7a6$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($bszkr(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = $eb5a77d13b5de7a6$var$assocIndexOf;

});


parcelRegister("kQxD1", function(module, exports) {

var $kcMox = parcelRequire("kcMox");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $f2d2bfdad590f700$var$listCacheGet(key) {
    var data = this.__data__, index = $kcMox(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = $f2d2bfdad590f700$var$listCacheGet;

});

parcelRegister("8s9nn", function(module, exports) {

var $kcMox = parcelRequire("kcMox");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $6278362ab6cce6a4$var$listCacheHas(key) {
    return $kcMox(this.__data__, key) > -1;
}
module.exports = $6278362ab6cce6a4$var$listCacheHas;

});

parcelRegister("3WPG7", function(module, exports) {

var $kcMox = parcelRequire("kcMox");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $2dfee01da35e2755$var$listCacheSet(key, value) {
    var data = this.__data__, index = $kcMox(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = $2dfee01da35e2755$var$listCacheSet;

});


parcelRegister("5xH4D", function(module, exports) {

var $7OMUJ = parcelRequire("7OMUJ");

var $7TNGW = parcelRequire("7TNGW");
/* Built-in method references that are verified to be native. */ var $4091725bf180fe11$var$Map = $7OMUJ($7TNGW, 'Map');
module.exports = $4091725bf180fe11$var$Map;

});


parcelRegister("30maz", function(module, exports) {

var $7DxYF = parcelRequire("7DxYF");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $23029194763f2daa$var$mapCacheDelete(key) {
    var result = $7DxYF(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $23029194763f2daa$var$mapCacheDelete;

});
parcelRegister("7DxYF", function(module, exports) {

var $gMo0Y = parcelRequire("gMo0Y");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $58f688215d1a7ba5$var$getMapData(map, key) {
    var data = map.__data__;
    return $gMo0Y(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
module.exports = $58f688215d1a7ba5$var$getMapData;

});
parcelRegister("gMo0Y", function(module, exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $c373c1d53001dd0d$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
module.exports = $c373c1d53001dd0d$var$isKeyable;

});



parcelRegister("iDxJ0", function(module, exports) {

var $7DxYF = parcelRequire("7DxYF");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $d9160792a93bd79c$var$mapCacheGet(key) {
    return $7DxYF(this, key).get(key);
}
module.exports = $d9160792a93bd79c$var$mapCacheGet;

});

parcelRegister("6CCE5", function(module, exports) {

var $7DxYF = parcelRequire("7DxYF");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $4d2444e0abbfa3de$var$mapCacheHas(key) {
    return $7DxYF(this, key).has(key);
}
module.exports = $4d2444e0abbfa3de$var$mapCacheHas;

});

parcelRegister("16XtT", function(module, exports) {

var $7DxYF = parcelRequire("7DxYF");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $0cf47dae1c3ebb54$var$mapCacheSet(key, value) {
    var data = $7DxYF(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = $0cf47dae1c3ebb54$var$mapCacheSet;

});





parcelRegister("lU5pp", function(module, exports) {

var $juYrA = parcelRequire("juYrA");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $ff2305feb184f348$var$toString(value) {
    return value == null ? '' : $juYrA(value);
}
module.exports = $ff2305feb184f348$var$toString;

});
parcelRegister("juYrA", function(module, exports) {

var $13cTt = parcelRequire("13cTt");

var $35DzK = parcelRequire("35DzK");

var $c1j63 = parcelRequire("c1j63");

var $7ENDX = parcelRequire("7ENDX");
/** Used as references for various `Number` constants. */ var $e31fb496c5a51137$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $e31fb496c5a51137$var$symbolProto = $13cTt ? $13cTt.prototype : undefined, $e31fb496c5a51137$var$symbolToString = $e31fb496c5a51137$var$symbolProto ? $e31fb496c5a51137$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $e31fb496c5a51137$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($c1j63(value)) // Recursively convert values (susceptible to call stack limits).
    return $35DzK(value, $e31fb496c5a51137$var$baseToString) + '';
    if ($7ENDX(value)) return $e31fb496c5a51137$var$symbolToString ? $e31fb496c5a51137$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$e31fb496c5a51137$var$INFINITY ? '-0' : result;
}
module.exports = $e31fb496c5a51137$var$baseToString;

});
parcelRegister("35DzK", function(module, exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $2400899c258021bb$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = $2400899c258021bb$var$arrayMap;

});




parcelRegister("edtoq", function(module, exports) {
/** Used as references for various `Number` constants. */ var $a599146484e913e5$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $a599146484e913e5$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $a599146484e913e5$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $a599146484e913e5$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $a599146484e913e5$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = $a599146484e913e5$var$isIndex;

});

parcelRegister("9xcd1", function(module, exports) {

var $7ENDX = parcelRequire("7ENDX");
/** Used as references for various `Number` constants. */ var $6f10aa9b8a3b232e$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $6f10aa9b8a3b232e$var$toKey(value) {
    if (typeof value == 'string' || $7ENDX(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$6f10aa9b8a3b232e$var$INFINITY ? '-0' : result;
}
module.exports = $6f10aa9b8a3b232e$var$toKey;

});



parcelRegister("jk22y", function(module, exports) {
$parcel$export(module.exports, "z", () => $e11177b792bd10b5$export$2e2bcd8739ae039);
var $e11177b792bd10b5$export$7debb50ef11d5e0b;
(function(util) {
    util.assertEqual = (val)=>val;
    function assertIs(_arg) {}
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items)=>{
        const obj = {};
        for (const item of items)obj[item] = item;
        return obj;
    };
    util.getValidEnumValues = (obj)=>{
        const validKeys = util.objectKeys(obj).filter((k)=>typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys)filtered[k] = obj[k];
        return util.objectValues(filtered);
    };
    util.objectValues = (obj)=>{
        return util.objectKeys(obj).map(function(e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
     ? (obj)=>Object.keys(obj) // eslint-disable-line ban/ban
     : (object)=>{
        const keys = [];
        for(const key in object)if (Object.prototype.hasOwnProperty.call(object, key)) keys.push(key);
        return keys;
    };
    util.find = (arr, checker)=>{
        for (const item of arr){
            if (checker(item)) return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function" ? (val)=>Number.isInteger(val) // eslint-disable-line ban/ban
     : (val)=>typeof val === "number" && isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array.map((val)=>typeof val === "string" ? `'${val}'` : val).join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value)=>{
        if (typeof value === "bigint") return value.toString();
        return value;
    };
})($e11177b792bd10b5$export$7debb50ef11d5e0b || ($e11177b792bd10b5$export$7debb50ef11d5e0b = {}));
var $e11177b792bd10b5$export$4aa2142c225fd5c7;
(function(objectUtil) {
    objectUtil.mergeShapes = (first, second)=>{
        return {
            ...first,
            ...second
        };
    };
})($e11177b792bd10b5$export$4aa2142c225fd5c7 || ($e11177b792bd10b5$export$4aa2142c225fd5c7 = {}));
const $e11177b792bd10b5$export$5716da67bfaa244d = $e11177b792bd10b5$export$7debb50ef11d5e0b.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
]);
const $e11177b792bd10b5$export$3e9057828ebd5c7a = (data)=>{
    const t = typeof data;
    switch(t){
        case "undefined":
            return $e11177b792bd10b5$export$5716da67bfaa244d.undefined;
        case "string":
            return $e11177b792bd10b5$export$5716da67bfaa244d.string;
        case "number":
            return isNaN(data) ? $e11177b792bd10b5$export$5716da67bfaa244d.nan : $e11177b792bd10b5$export$5716da67bfaa244d.number;
        case "boolean":
            return $e11177b792bd10b5$export$5716da67bfaa244d.boolean;
        case "function":
            return $e11177b792bd10b5$export$5716da67bfaa244d.function;
        case "bigint":
            return $e11177b792bd10b5$export$5716da67bfaa244d.bigint;
        case "symbol":
            return $e11177b792bd10b5$export$5716da67bfaa244d.symbol;
        case "object":
            if (Array.isArray(data)) return $e11177b792bd10b5$export$5716da67bfaa244d.array;
            if (data === null) return $e11177b792bd10b5$export$5716da67bfaa244d.null;
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return $e11177b792bd10b5$export$5716da67bfaa244d.promise;
            if (typeof Map !== "undefined" && data instanceof Map) return $e11177b792bd10b5$export$5716da67bfaa244d.map;
            if (typeof Set !== "undefined" && data instanceof Set) return $e11177b792bd10b5$export$5716da67bfaa244d.set;
            if (typeof Date !== "undefined" && data instanceof Date) return $e11177b792bd10b5$export$5716da67bfaa244d.date;
            return $e11177b792bd10b5$export$5716da67bfaa244d.object;
        default:
            return $e11177b792bd10b5$export$5716da67bfaa244d.unknown;
    }
};
const $e11177b792bd10b5$export$5ba560653e4a1035 = $e11177b792bd10b5$export$7debb50ef11d5e0b.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
]);
const $e11177b792bd10b5$export$913eddeaf297cfea = (obj)=>{
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
class $e11177b792bd10b5$export$f98dac4b251ab333 extends Error {
    get errors() {
        return this.issues;
    }
    constructor(issues){
        super();
        this.issues = [];
        this.addIssue = (sub)=>{
            this.issues = [
                ...this.issues,
                sub
            ];
        };
        this.addIssues = (subs = [])=>{
            this.issues = [
                ...this.issues,
                ...subs
            ];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) // eslint-disable-next-line ban/ban
        Object.setPrototypeOf(this, actualProto);
        else this.__proto__ = actualProto;
        this.name = "ZodError";
        this.issues = issues;
    }
    format(_mapper) {
        const mapper = _mapper || function(issue) {
            return issue.message;
        };
        const fieldErrors = {
            _errors: []
        };
        const processError = (error)=>{
            for (const issue of error.issues){
                if (issue.code === "invalid_union") issue.unionErrors.map(processError);
                else if (issue.code === "invalid_return_type") processError(issue.returnTypeError);
                else if (issue.code === "invalid_arguments") processError(issue.argumentsError);
                else if (issue.path.length === 0) fieldErrors._errors.push(mapper(issue));
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while(i < issue.path.length){
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        if (!terminal) curr[el] = curr[el] || {
                            _errors: []
                        };
                        else {
                            curr[el] = curr[el] || {
                                _errors: []
                            };
                            curr[el]._errors.push(mapper(issue));
                        }
                        curr = curr[el];
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    static assert(value) {
        if (!(value instanceof $e11177b792bd10b5$export$f98dac4b251ab333)) throw new Error(`Not a ZodError: ${value}`);
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, $e11177b792bd10b5$export$7debb50ef11d5e0b.jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue)=>issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub of this.issues)if (sub.path.length > 0) {
            fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
            fieldErrors[sub.path[0]].push(mapper(sub));
        } else formErrors.push(mapper(sub));
        return {
            formErrors: formErrors,
            fieldErrors: fieldErrors
        };
    }
    get formErrors() {
        return this.flatten();
    }
}
$e11177b792bd10b5$export$f98dac4b251ab333.create = (issues)=>{
    const error = new $e11177b792bd10b5$export$f98dac4b251ab333(issues);
    return error;
};
const $e11177b792bd10b5$export$341b0b6e0a6f5099 = (issue, _ctx)=>{
    let message;
    switch(issue.code){
        case $e11177b792bd10b5$export$5ba560653e4a1035.invalid_type:
            if (issue.received === $e11177b792bd10b5$export$5716da67bfaa244d.undefined) message = "Required";
            else message = `Expected ${issue.expected}, received ${issue.received}`;
            break;
        case $e11177b792bd10b5$export$5ba560653e4a1035.invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, $e11177b792bd10b5$export$7debb50ef11d5e0b.jsonStringifyReplacer)}`;
            break;
        case $e11177b792bd10b5$export$5ba560653e4a1035.unrecognized_keys:
            message = `Unrecognized key(s) in object: ${$e11177b792bd10b5$export$7debb50ef11d5e0b.joinValues(issue.keys, ", ")}`;
            break;
        case $e11177b792bd10b5$export$5ba560653e4a1035.invalid_union:
            message = `Invalid input`;
            break;
        case $e11177b792bd10b5$export$5ba560653e4a1035.invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${$e11177b792bd10b5$export$7debb50ef11d5e0b.joinValues(issue.options)}`;
            break;
        case $e11177b792bd10b5$export$5ba560653e4a1035.invalid_enum_value:
            message = `Invalid enum value. Expected ${$e11177b792bd10b5$export$7debb50ef11d5e0b.joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case $e11177b792bd10b5$export$5ba560653e4a1035.invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case $e11177b792bd10b5$export$5ba560653e4a1035.invalid_return_type:
            message = `Invalid function return type`;
            break;
        case $e11177b792bd10b5$export$5ba560653e4a1035.invalid_date:
            message = `Invalid date`;
            break;
        case $e11177b792bd10b5$export$5ba560653e4a1035.invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = `Invalid input: must include "${issue.validation.includes}"`;
                    if (typeof issue.validation.position === "number") message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
                } else if ("startsWith" in issue.validation) message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                else if ("endsWith" in issue.validation) message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                else $e11177b792bd10b5$export$7debb50ef11d5e0b.assertNever(issue.validation);
            } else if (issue.validation !== "regex") message = `Invalid ${issue.validation}`;
            else message = "Invalid";
            break;
        case $e11177b792bd10b5$export$5ba560653e4a1035.too_small:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
            else message = "Invalid input";
            break;
        case $e11177b792bd10b5$export$5ba560653e4a1035.too_big:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "bigint") message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
            else message = "Invalid input";
            break;
        case $e11177b792bd10b5$export$5ba560653e4a1035.custom:
            message = `Invalid input`;
            break;
        case $e11177b792bd10b5$export$5ba560653e4a1035.invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case $e11177b792bd10b5$export$5ba560653e4a1035.not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        case $e11177b792bd10b5$export$5ba560653e4a1035.not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            $e11177b792bd10b5$export$7debb50ef11d5e0b.assertNever(issue);
    }
    return {
        message: message
    };
};
let $e11177b792bd10b5$var$overrideErrorMap = $e11177b792bd10b5$export$341b0b6e0a6f5099;
function $e11177b792bd10b5$export$1097a8289cfd22d7(map) {
    $e11177b792bd10b5$var$overrideErrorMap = map;
}
function $e11177b792bd10b5$export$32f27c719778d4c4() {
    return $e11177b792bd10b5$var$overrideErrorMap;
}
const $e11177b792bd10b5$export$244a85fde9c419ed = (params)=>{
    const { data: data, path: path, errorMaps: errorMaps, issueData: issueData } = params;
    const fullPath = [
        ...path,
        ...issueData.path || []
    ];
    const fullIssue = {
        ...issueData,
        path: fullPath
    };
    if (issueData.message !== undefined) return {
        ...issueData,
        path: fullPath,
        message: issueData.message
    };
    let errorMessage = "";
    const maps = errorMaps.filter((m)=>!!m).slice().reverse();
    for (const map of maps)errorMessage = map(fullIssue, {
        data: data,
        defaultError: errorMessage
    }).message;
    return {
        ...issueData,
        path: fullPath,
        message: errorMessage
    };
};
const $e11177b792bd10b5$export$1526d2e05f74572 = [];
function $e11177b792bd10b5$export$db7caee60e5d514d(ctx, issueData) {
    const overrideMap = $e11177b792bd10b5$export$32f27c719778d4c4();
    const issue = $e11177b792bd10b5$export$244a85fde9c419ed({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            overrideMap,
            overrideMap === $e11177b792bd10b5$export$341b0b6e0a6f5099 ? undefined : $e11177b792bd10b5$export$341b0b6e0a6f5099
        ].filter((x)=>!!x)
    });
    ctx.common.issues.push(issue);
}
class $e11177b792bd10b5$export$5b20a5c3d05c1f6f {
    constructor(){
        this.value = "valid";
    }
    dirty() {
        if (this.value === "valid") this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted") this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results){
            if (s.status === "aborted") return $e11177b792bd10b5$export$9a105a556e65c2c0;
            if (s.status === "dirty") status.dirty();
            arrayValue.push(s.value);
        }
        return {
            status: status.value,
            value: arrayValue
        };
    }
    static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs){
            const key = await pair.key;
            const value = await pair.value;
            syncPairs.push({
                key: key,
                value: value
            });
        }
        return $e11177b792bd10b5$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs){
            const { key: key, value: value } = pair;
            if (key.status === "aborted") return $e11177b792bd10b5$export$9a105a556e65c2c0;
            if (value.status === "aborted") return $e11177b792bd10b5$export$9a105a556e65c2c0;
            if (key.status === "dirty") status.dirty();
            if (value.status === "dirty") status.dirty();
            if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) finalObject[key.value] = value.value;
        }
        return {
            status: status.value,
            value: finalObject
        };
    }
}
const $e11177b792bd10b5$export$9a105a556e65c2c0 = Object.freeze({
    status: "aborted"
});
const $e11177b792bd10b5$export$325a211da9693fcf = (value)=>({
        status: "dirty",
        value: value
    });
const $e11177b792bd10b5$export$c6813a8d51f77eaf = (value)=>({
        status: "valid",
        value: value
    });
const $e11177b792bd10b5$export$afa861e3c5730743 = (x)=>x.status === "aborted";
const $e11177b792bd10b5$export$910b6cdd390341b3 = (x)=>x.status === "dirty";
const $e11177b792bd10b5$export$1ea939691cdc45b8 = (x)=>x.status === "valid";
const $e11177b792bd10b5$export$aefee5ebe1dcfd9e = (x)=>typeof Promise !== "undefined" && x instanceof Promise;
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $e11177b792bd10b5$var$__classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $e11177b792bd10b5$var$__classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
typeof SuppressedError === "function" && SuppressedError;
var $e11177b792bd10b5$var$errorUtil;
(function(errorUtil) {
    errorUtil.errToObj = (message)=>typeof message === "string" ? {
            message: message
        } : message || {};
    errorUtil.toString = (message)=>typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
})($e11177b792bd10b5$var$errorUtil || ($e11177b792bd10b5$var$errorUtil = {}));
var $e11177b792bd10b5$var$_ZodEnum_cache, $e11177b792bd10b5$var$_ZodNativeEnum_cache;
class $e11177b792bd10b5$var$ParseInputLazyPath {
    constructor(parent, value, path, key){
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
    get path() {
        if (!this._cachedPath.length) {
            if (this._key instanceof Array) this._cachedPath.push(...this._path, ...this._key);
            else this._cachedPath.push(...this._path, this._key);
        }
        return this._cachedPath;
    }
}
const $e11177b792bd10b5$var$handleResult = (ctx, result)=>{
    if ($e11177b792bd10b5$export$1ea939691cdc45b8(result)) return {
        success: true,
        data: result.value
    };
    else {
        if (!ctx.common.issues.length) throw new Error("Validation failed but no issues detected.");
        return {
            success: false,
            get error () {
                if (this._error) return this._error;
                const error = new $e11177b792bd10b5$export$f98dac4b251ab333(ctx.common.issues);
                this._error = error;
                return this._error;
            }
        };
    }
};
function $e11177b792bd10b5$var$processCreateParams(params) {
    if (!params) return {};
    const { errorMap: errorMap, invalid_type_error: invalid_type_error, required_error: required_error, description: description } = params;
    if (errorMap && (invalid_type_error || required_error)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    if (errorMap) return {
        errorMap: errorMap,
        description: description
    };
    const customMap = (iss, ctx)=>{
        var _a, _b;
        const { message: message } = params;
        if (iss.code === "invalid_enum_value") return {
            message: message !== null && message !== void 0 ? message : ctx.defaultError
        };
        if (typeof ctx.data === "undefined") return {
            message: (_a = message !== null && message !== void 0 ? message : required_error) !== null && _a !== void 0 ? _a : ctx.defaultError
        };
        if (iss.code !== "invalid_type") return {
            message: ctx.defaultError
        };
        return {
            message: (_b = message !== null && message !== void 0 ? message : invalid_type_error) !== null && _b !== void 0 ? _b : ctx.defaultError
        };
    };
    return {
        errorMap: customMap,
        description: description
    };
}
class $e11177b792bd10b5$export$19342e026b58ebb7 {
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return $e11177b792bd10b5$export$3e9057828ebd5c7a(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: $e11177b792bd10b5$export$3e9057828ebd5c7a(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent
        };
    }
    _processInputParams(input) {
        return {
            status: new $e11177b792bd10b5$export$5b20a5c3d05c1f6f(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: $e11177b792bd10b5$export$3e9057828ebd5c7a(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent
            }
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if ($e11177b792bd10b5$export$aefee5ebe1dcfd9e(result)) throw new Error("Synchronous parse encountered promise.");
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        var _a;
        const ctx = {
            common: {
                issues: [],
                async: (_a = params === null || params === void 0 ? void 0 : params.async) !== null && _a !== void 0 ? _a : false,
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $e11177b792bd10b5$export$3e9057828ebd5c7a(data)
        };
        const result = this._parseSync({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        return $e11177b792bd10b5$var$handleResult(ctx, result);
    }
    "~validate"(data) {
        var _a, _b;
        const ctx = {
            common: {
                issues: [],
                async: !!this["~standard"].async
            },
            path: [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $e11177b792bd10b5$export$3e9057828ebd5c7a(data)
        };
        if (!this["~standard"].async) try {
            const result = this._parseSync({
                data: data,
                path: [],
                parent: ctx
            });
            return $e11177b792bd10b5$export$1ea939691cdc45b8(result) ? {
                value: result.value
            } : {
                issues: ctx.common.issues
            };
        } catch (err) {
            if ((_b = (_a = err === null || err === void 0 ? void 0 : err.message) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.includes("encountered")) this["~standard"].async = true;
            ctx.common = {
                issues: [],
                async: true
            };
        }
        return this._parseAsync({
            data: data,
            path: [],
            parent: ctx
        }).then((result)=>$e11177b792bd10b5$export$1ea939691cdc45b8(result) ? {
                value: result.value
            } : {
                issues: ctx.common.issues
            });
    }
    async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    async safeParseAsync(data, params) {
        const ctx = {
            common: {
                issues: [],
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
                async: true
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $e11177b792bd10b5$export$3e9057828ebd5c7a(data)
        };
        const maybeAsyncResult = this._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        const result = await ($e11177b792bd10b5$export$aefee5ebe1dcfd9e(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
        return $e11177b792bd10b5$var$handleResult(ctx, result);
    }
    refine(check, message) {
        const getIssueProperties = (val)=>{
            if (typeof message === "string" || typeof message === "undefined") return {
                message: message
            };
            else if (typeof message === "function") return message(val);
            else return message;
        };
        return this._refinement((val, ctx)=>{
            const result = check(val);
            const setError = ()=>ctx.addIssue({
                    code: $e11177b792bd10b5$export$5ba560653e4a1035.custom,
                    ...getIssueProperties(val)
                });
            if (typeof Promise !== "undefined" && result instanceof Promise) return result.then((data)=>{
                if (!data) {
                    setError();
                    return false;
                } else return true;
            });
            if (!result) {
                setError();
                return false;
            } else return true;
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx)=>{
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
                return false;
            } else return true;
        });
    }
    _refinement(refinement) {
        return new $e11177b792bd10b5$export$a60af00cc0ce2582({
            schema: this,
            typeName: $e11177b792bd10b5$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "refinement",
                refinement: refinement
            }
        });
    }
    superRefine(refinement) {
        return this._refinement(refinement);
    }
    constructor(def){
        /** Alias of safeParseAsync */ this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
        this["~standard"] = {
            version: 1,
            vendor: "zod",
            validate: (data)=>this["~validate"](data)
        };
    }
    optional() {
        return $e11177b792bd10b5$export$aa56fec1e9d629b8.create(this, this._def);
    }
    nullable() {
        return $e11177b792bd10b5$export$aaac0b8b429cef5.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return $e11177b792bd10b5$export$7acfc3e64785411.create(this);
    }
    promise() {
        return $e11177b792bd10b5$export$3f196b0127d6e50a.create(this, this._def);
    }
    or(option) {
        return $e11177b792bd10b5$export$a8b236cb5070a311.create([
            this,
            option
        ], this._def);
    }
    and(incoming) {
        return $e11177b792bd10b5$export$c02deaf0bb5203d4.create(this, incoming, this._def);
    }
    transform(transform) {
        return new $e11177b792bd10b5$export$a60af00cc0ce2582({
            ...$e11177b792bd10b5$var$processCreateParams(this._def),
            schema: this,
            typeName: $e11177b792bd10b5$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "transform",
                transform: transform
            }
        });
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : ()=>def;
        return new $e11177b792bd10b5$export$bb19b37874861e7e({
            ...$e11177b792bd10b5$var$processCreateParams(this._def),
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: $e11177b792bd10b5$export$558106ce543bd011.ZodDefault
        });
    }
    brand() {
        return new $e11177b792bd10b5$export$66b0c798a395271f({
            typeName: $e11177b792bd10b5$export$558106ce543bd011.ZodBranded,
            type: this,
            ...$e11177b792bd10b5$var$processCreateParams(this._def)
        });
    }
    catch(def) {
        const catchValueFunc = typeof def === "function" ? def : ()=>def;
        return new $e11177b792bd10b5$export$75a44ec6249ac76b({
            ...$e11177b792bd10b5$var$processCreateParams(this._def),
            innerType: this,
            catchValue: catchValueFunc,
            typeName: $e11177b792bd10b5$export$558106ce543bd011.ZodCatch
        });
    }
    describe(description) {
        const This = this.constructor;
        return new This({
            ...this._def,
            description: description
        });
    }
    pipe(target) {
        return $e11177b792bd10b5$export$a3c3ef8a0e95c6da.create(this, target);
    }
    readonly() {
        return $e11177b792bd10b5$export$5d1f7ef05c4e493a.create(this);
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
}
const $e11177b792bd10b5$var$cuidRegex = /^c[^\s-]{8,}$/i;
const $e11177b792bd10b5$var$cuid2Regex = /^[0-9a-z]+$/;
const $e11177b792bd10b5$var$ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/i;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
const $e11177b792bd10b5$var$uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
const $e11177b792bd10b5$var$nanoidRegex = /^[a-z0-9_-]{21}$/i;
const $e11177b792bd10b5$var$jwtRegex = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/;
const $e11177b792bd10b5$var$durationRegex = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
const $e11177b792bd10b5$var$emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const $e11177b792bd10b5$var$_emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
let $e11177b792bd10b5$var$emojiRegex;
// faster, simpler, safer
const $e11177b792bd10b5$var$ipv4Regex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/;
const $e11177b792bd10b5$var$ipv4CidrRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/;
// const ipv6Regex =
// /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
const $e11177b792bd10b5$var$ipv6Regex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/;
const $e11177b792bd10b5$var$ipv6CidrRegex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/;
// https://stackoverflow.com/questions/7860392/determine-if-string-is-in-base64-using-javascript
const $e11177b792bd10b5$var$base64Regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
// https://base64.guru/standards/base64url
const $e11177b792bd10b5$var$base64urlRegex = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/;
// simple
// const dateRegexSource = `\\d{4}-\\d{2}-\\d{2}`;
// no leap year validation
// const dateRegexSource = `\\d{4}-((0[13578]|10|12)-31|(0[13-9]|1[0-2])-30|(0[1-9]|1[0-2])-(0[1-9]|1\\d|2\\d))`;
// with leap year validation
const $e11177b792bd10b5$var$dateRegexSource = `((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))`;
const $e11177b792bd10b5$var$dateRegex = new RegExp(`^${$e11177b792bd10b5$var$dateRegexSource}$`);
function $e11177b792bd10b5$var$timeRegexSource(args) {
    // let regex = `\\d{2}:\\d{2}:\\d{2}`;
    let regex = `([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d`;
    if (args.precision) regex = `${regex}\\.\\d{${args.precision}}`;
    else if (args.precision == null) regex = `${regex}(\\.\\d+)?`;
    return regex;
}
function $e11177b792bd10b5$var$timeRegex(args) {
    return new RegExp(`^${$e11177b792bd10b5$var$timeRegexSource(args)}$`);
}
// Adapted from https://stackoverflow.com/a/3143231
function $e11177b792bd10b5$export$a4b563879add27a(args) {
    let regex = `${$e11177b792bd10b5$var$dateRegexSource}T${$e11177b792bd10b5$var$timeRegexSource(args)}`;
    const opts = [];
    opts.push(args.local ? `Z?` : `Z`);
    if (args.offset) opts.push(`([+-]\\d{2}:?\\d{2})`);
    regex = `${regex}(${opts.join("|")})`;
    return new RegExp(`^${regex}$`);
}
function $e11177b792bd10b5$var$isValidIP(ip, version) {
    if ((version === "v4" || !version) && $e11177b792bd10b5$var$ipv4Regex.test(ip)) return true;
    if ((version === "v6" || !version) && $e11177b792bd10b5$var$ipv6Regex.test(ip)) return true;
    return false;
}
function $e11177b792bd10b5$var$isValidJWT(jwt, alg) {
    if (!$e11177b792bd10b5$var$jwtRegex.test(jwt)) return false;
    try {
        const [header] = jwt.split(".");
        // Convert base64url to base64
        const base64 = header.replace(/-/g, "+").replace(/_/g, "/").padEnd(header.length + (4 - header.length % 4) % 4, "=");
        const decoded = JSON.parse(atob(base64));
        if (typeof decoded !== "object" || decoded === null) return false;
        if (!decoded.typ || !decoded.alg) return false;
        if (alg && decoded.alg !== alg) return false;
        return true;
    } catch (_a) {
        return false;
    }
}
function $e11177b792bd10b5$var$isValidCidr(ip, version) {
    if ((version === "v4" || !version) && $e11177b792bd10b5$var$ipv4CidrRegex.test(ip)) return true;
    if ((version === "v6" || !version) && $e11177b792bd10b5$var$ipv6CidrRegex.test(ip)) return true;
    return false;
}
class $e11177b792bd10b5$export$1230eb29b8d3b502 extends $e11177b792bd10b5$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = String(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $e11177b792bd10b5$export$5716da67bfaa244d.string) {
            const ctx = this._getOrReturnCtx(input);
            $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                code: $e11177b792bd10b5$export$5ba560653e4a1035.invalid_type,
                expected: $e11177b792bd10b5$export$5716da67bfaa244d.string,
                received: ctx.parsedType
            });
            return $e11177b792bd10b5$export$9a105a556e65c2c0;
        }
        const status = new $e11177b792bd10b5$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                        code: $e11177b792bd10b5$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                        code: $e11177b792bd10b5$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "length") {
                const tooBig = input.data.length > check.value;
                const tooSmall = input.data.length < check.value;
                if (tooBig || tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    if (tooBig) $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                        code: $e11177b792bd10b5$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    else if (tooSmall) $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                        code: $e11177b792bd10b5$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "email") {
                if (!$e11177b792bd10b5$var$emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                        validation: "email",
                        code: $e11177b792bd10b5$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "emoji") {
                if (!$e11177b792bd10b5$var$emojiRegex) $e11177b792bd10b5$var$emojiRegex = new RegExp($e11177b792bd10b5$var$_emojiRegex, "u");
                if (!$e11177b792bd10b5$var$emojiRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                        validation: "emoji",
                        code: $e11177b792bd10b5$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "uuid") {
                if (!$e11177b792bd10b5$var$uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                        validation: "uuid",
                        code: $e11177b792bd10b5$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "nanoid") {
                if (!$e11177b792bd10b5$var$nanoidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                        validation: "nanoid",
                        code: $e11177b792bd10b5$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid") {
                if (!$e11177b792bd10b5$var$cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                        validation: "cuid",
                        code: $e11177b792bd10b5$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid2") {
                if (!$e11177b792bd10b5$var$cuid2Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                        validation: "cuid2",
                        code: $e11177b792bd10b5$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ulid") {
                if (!$e11177b792bd10b5$var$ulidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                        validation: "ulid",
                        code: $e11177b792bd10b5$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "url") try {
                new URL(input.data);
            } catch (_a) {
                ctx = this._getOrReturnCtx(input, ctx);
                $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                    validation: "url",
                    code: $e11177b792bd10b5$export$5ba560653e4a1035.invalid_string,
                    message: check.message
                });
                status.dirty();
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                        validation: "regex",
                        code: $e11177b792bd10b5$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "trim") input.data = input.data.trim();
            else if (check.kind === "includes") {
                if (!input.data.includes(check.value, check.position)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                        code: $e11177b792bd10b5$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            includes: check.value,
                            position: check.position
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "toLowerCase") input.data = input.data.toLowerCase();
            else if (check.kind === "toUpperCase") input.data = input.data.toUpperCase();
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                        code: $e11177b792bd10b5$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            startsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                        code: $e11177b792bd10b5$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            endsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "datetime") {
                const regex = $e11177b792bd10b5$export$a4b563879add27a(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                        code: $e11177b792bd10b5$export$5ba560653e4a1035.invalid_string,
                        validation: "datetime",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "date") {
                const regex = $e11177b792bd10b5$var$dateRegex;
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                        code: $e11177b792bd10b5$export$5ba560653e4a1035.invalid_string,
                        validation: "date",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "time") {
                const regex = $e11177b792bd10b5$var$timeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                        code: $e11177b792bd10b5$export$5ba560653e4a1035.invalid_string,
                        validation: "time",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "duration") {
                if (!$e11177b792bd10b5$var$durationRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                        validation: "duration",
                        code: $e11177b792bd10b5$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ip") {
                if (!$e11177b792bd10b5$var$isValidIP(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                        validation: "ip",
                        code: $e11177b792bd10b5$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "jwt") {
                if (!$e11177b792bd10b5$var$isValidJWT(input.data, check.alg)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                        validation: "jwt",
                        code: $e11177b792bd10b5$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cidr") {
                if (!$e11177b792bd10b5$var$isValidCidr(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                        validation: "cidr",
                        code: $e11177b792bd10b5$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "base64") {
                if (!$e11177b792bd10b5$var$base64Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                        validation: "base64",
                        code: $e11177b792bd10b5$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "base64url") {
                if (!$e11177b792bd10b5$var$base64urlRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                        validation: "base64url",
                        code: $e11177b792bd10b5$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $e11177b792bd10b5$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _regex(regex, validation, message) {
        return this.refinement((data)=>regex.test(data), {
            validation: validation,
            code: $e11177b792bd10b5$export$5ba560653e4a1035.invalid_string,
            ...$e11177b792bd10b5$var$errorUtil.errToObj(message)
        });
    }
    _addCheck(check) {
        return new $e11177b792bd10b5$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    email(message) {
        return this._addCheck({
            kind: "email",
            ...$e11177b792bd10b5$var$errorUtil.errToObj(message)
        });
    }
    url(message) {
        return this._addCheck({
            kind: "url",
            ...$e11177b792bd10b5$var$errorUtil.errToObj(message)
        });
    }
    emoji(message) {
        return this._addCheck({
            kind: "emoji",
            ...$e11177b792bd10b5$var$errorUtil.errToObj(message)
        });
    }
    uuid(message) {
        return this._addCheck({
            kind: "uuid",
            ...$e11177b792bd10b5$var$errorUtil.errToObj(message)
        });
    }
    nanoid(message) {
        return this._addCheck({
            kind: "nanoid",
            ...$e11177b792bd10b5$var$errorUtil.errToObj(message)
        });
    }
    cuid(message) {
        return this._addCheck({
            kind: "cuid",
            ...$e11177b792bd10b5$var$errorUtil.errToObj(message)
        });
    }
    cuid2(message) {
        return this._addCheck({
            kind: "cuid2",
            ...$e11177b792bd10b5$var$errorUtil.errToObj(message)
        });
    }
    ulid(message) {
        return this._addCheck({
            kind: "ulid",
            ...$e11177b792bd10b5$var$errorUtil.errToObj(message)
        });
    }
    base64(message) {
        return this._addCheck({
            kind: "base64",
            ...$e11177b792bd10b5$var$errorUtil.errToObj(message)
        });
    }
    base64url(message) {
        // base64url encoding is a modification of base64 that can safely be used in URLs and filenames
        return this._addCheck({
            kind: "base64url",
            ...$e11177b792bd10b5$var$errorUtil.errToObj(message)
        });
    }
    jwt(options) {
        return this._addCheck({
            kind: "jwt",
            ...$e11177b792bd10b5$var$errorUtil.errToObj(options)
        });
    }
    ip(options) {
        return this._addCheck({
            kind: "ip",
            ...$e11177b792bd10b5$var$errorUtil.errToObj(options)
        });
    }
    cidr(options) {
        return this._addCheck({
            kind: "cidr",
            ...$e11177b792bd10b5$var$errorUtil.errToObj(options)
        });
    }
    datetime(options) {
        var _a, _b;
        if (typeof options === "string") return this._addCheck({
            kind: "datetime",
            precision: null,
            offset: false,
            local: false,
            message: options
        });
        return this._addCheck({
            kind: "datetime",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            offset: (_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : false,
            local: (_b = options === null || options === void 0 ? void 0 : options.local) !== null && _b !== void 0 ? _b : false,
            ...$e11177b792bd10b5$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    date(message) {
        return this._addCheck({
            kind: "date",
            message: message
        });
    }
    time(options) {
        if (typeof options === "string") return this._addCheck({
            kind: "time",
            precision: null,
            message: options
        });
        return this._addCheck({
            kind: "time",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            ...$e11177b792bd10b5$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    duration(message) {
        return this._addCheck({
            kind: "duration",
            ...$e11177b792bd10b5$var$errorUtil.errToObj(message)
        });
    }
    regex(regex, message) {
        return this._addCheck({
            kind: "regex",
            regex: regex,
            ...$e11177b792bd10b5$var$errorUtil.errToObj(message)
        });
    }
    includes(value, options) {
        return this._addCheck({
            kind: "includes",
            value: value,
            position: options === null || options === void 0 ? void 0 : options.position,
            ...$e11177b792bd10b5$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    startsWith(value, message) {
        return this._addCheck({
            kind: "startsWith",
            value: value,
            ...$e11177b792bd10b5$var$errorUtil.errToObj(message)
        });
    }
    endsWith(value, message) {
        return this._addCheck({
            kind: "endsWith",
            value: value,
            ...$e11177b792bd10b5$var$errorUtil.errToObj(message)
        });
    }
    min(minLength, message) {
        return this._addCheck({
            kind: "min",
            value: minLength,
            ...$e11177b792bd10b5$var$errorUtil.errToObj(message)
        });
    }
    max(maxLength, message) {
        return this._addCheck({
            kind: "max",
            value: maxLength,
            ...$e11177b792bd10b5$var$errorUtil.errToObj(message)
        });
    }
    length(len, message) {
        return this._addCheck({
            kind: "length",
            value: len,
            ...$e11177b792bd10b5$var$errorUtil.errToObj(message)
        });
    }
    /**
     * Equivalent to `.min(1)`
     */ nonempty(message) {
        return this.min(1, $e11177b792bd10b5$var$errorUtil.errToObj(message));
    }
    trim() {
        return new $e11177b792bd10b5$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "trim"
                }
            ]
        });
    }
    toLowerCase() {
        return new $e11177b792bd10b5$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toLowerCase"
                }
            ]
        });
    }
    toUpperCase() {
        return new $e11177b792bd10b5$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toUpperCase"
                }
            ]
        });
    }
    get isDatetime() {
        return !!this._def.checks.find((ch)=>ch.kind === "datetime");
    }
    get isDate() {
        return !!this._def.checks.find((ch)=>ch.kind === "date");
    }
    get isTime() {
        return !!this._def.checks.find((ch)=>ch.kind === "time");
    }
    get isDuration() {
        return !!this._def.checks.find((ch)=>ch.kind === "duration");
    }
    get isEmail() {
        return !!this._def.checks.find((ch)=>ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch)=>ch.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((ch)=>ch.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "uuid");
    }
    get isNANOID() {
        return !!this._def.checks.find((ch)=>ch.kind === "nanoid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((ch)=>ch.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((ch)=>ch.kind === "ip");
    }
    get isCIDR() {
        return !!this._def.checks.find((ch)=>ch.kind === "cidr");
    }
    get isBase64() {
        return !!this._def.checks.find((ch)=>ch.kind === "base64");
    }
    get isBase64url() {
        // base64url encoding is a modification of base64 that can safely be used in URLs and filenames
        return !!this._def.checks.find((ch)=>ch.kind === "base64url");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$e11177b792bd10b5$export$1230eb29b8d3b502.create = (params)=>{
    var _a;
    return new $e11177b792bd10b5$export$1230eb29b8d3b502({
        checks: [],
        typeName: $e11177b792bd10b5$export$558106ce543bd011.ZodString,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...$e11177b792bd10b5$var$processCreateParams(params)
    });
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function $e11177b792bd10b5$var$floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / Math.pow(10, decCount);
}
class $e11177b792bd10b5$export$5b070a55c0c43e09 extends $e11177b792bd10b5$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
    _parse(input) {
        if (this._def.coerce) input.data = Number(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $e11177b792bd10b5$export$5716da67bfaa244d.number) {
            const ctx = this._getOrReturnCtx(input);
            $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                code: $e11177b792bd10b5$export$5ba560653e4a1035.invalid_type,
                expected: $e11177b792bd10b5$export$5716da67bfaa244d.number,
                received: ctx.parsedType
            });
            return $e11177b792bd10b5$export$9a105a556e65c2c0;
        }
        let ctx = undefined;
        const status = new $e11177b792bd10b5$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "int") {
                if (!$e11177b792bd10b5$export$7debb50ef11d5e0b.isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                        code: $e11177b792bd10b5$export$5ba560653e4a1035.invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                        code: $e11177b792bd10b5$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                        code: $e11177b792bd10b5$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if ($e11177b792bd10b5$var$floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                        code: $e11177b792bd10b5$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "finite") {
                if (!Number.isFinite(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                        code: $e11177b792bd10b5$export$5ba560653e4a1035.not_finite,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $e11177b792bd10b5$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $e11177b792bd10b5$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $e11177b792bd10b5$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $e11177b792bd10b5$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $e11177b792bd10b5$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $e11177b792bd10b5$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $e11177b792bd10b5$var$errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $e11177b792bd10b5$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: $e11177b792bd10b5$var$errorUtil.toString(message)
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: $e11177b792bd10b5$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: $e11177b792bd10b5$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: $e11177b792bd10b5$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: $e11177b792bd10b5$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $e11177b792bd10b5$var$errorUtil.toString(message)
        });
    }
    finite(message) {
        return this._addCheck({
            kind: "finite",
            message: $e11177b792bd10b5$var$errorUtil.toString(message)
        });
    }
    safe(message) {
        return this._addCheck({
            kind: "min",
            inclusive: true,
            value: Number.MIN_SAFE_INTEGER,
            message: $e11177b792bd10b5$var$errorUtil.toString(message)
        })._addCheck({
            kind: "max",
            inclusive: true,
            value: Number.MAX_SAFE_INTEGER,
            message: $e11177b792bd10b5$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch)=>ch.kind === "int" || ch.kind === "multipleOf" && $e11177b792bd10b5$export$7debb50ef11d5e0b.isInteger(ch.value));
    }
    get isFinite() {
        let max = null, min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") return true;
            else if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            } else if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return Number.isFinite(min) && Number.isFinite(max);
    }
}
$e11177b792bd10b5$export$5b070a55c0c43e09.create = (params)=>{
    return new $e11177b792bd10b5$export$5b070a55c0c43e09({
        checks: [],
        typeName: $e11177b792bd10b5$export$558106ce543bd011.ZodNumber,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...$e11177b792bd10b5$var$processCreateParams(params)
    });
};
class $e11177b792bd10b5$export$67d741fd70ff98f4 extends $e11177b792bd10b5$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
    }
    _parse(input) {
        if (this._def.coerce) try {
            input.data = BigInt(input.data);
        } catch (_a) {
            return this._getInvalidInput(input);
        }
        const parsedType = this._getType(input);
        if (parsedType !== $e11177b792bd10b5$export$5716da67bfaa244d.bigint) return this._getInvalidInput(input);
        let ctx = undefined;
        const status = new $e11177b792bd10b5$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                        code: $e11177b792bd10b5$export$5ba560653e4a1035.too_small,
                        type: "bigint",
                        minimum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                        code: $e11177b792bd10b5$export$5ba560653e4a1035.too_big,
                        type: "bigint",
                        maximum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if (input.data % check.value !== BigInt(0)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                        code: $e11177b792bd10b5$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $e11177b792bd10b5$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _getInvalidInput(input) {
        const ctx = this._getOrReturnCtx(input);
        $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
            code: $e11177b792bd10b5$export$5ba560653e4a1035.invalid_type,
            expected: $e11177b792bd10b5$export$5716da67bfaa244d.bigint,
            received: ctx.parsedType
        });
        return $e11177b792bd10b5$export$9a105a556e65c2c0;
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $e11177b792bd10b5$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $e11177b792bd10b5$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $e11177b792bd10b5$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $e11177b792bd10b5$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $e11177b792bd10b5$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $e11177b792bd10b5$var$errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $e11177b792bd10b5$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: false,
            message: $e11177b792bd10b5$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: false,
            message: $e11177b792bd10b5$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: true,
            message: $e11177b792bd10b5$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: true,
            message: $e11177b792bd10b5$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $e11177b792bd10b5$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$e11177b792bd10b5$export$67d741fd70ff98f4.create = (params)=>{
    var _a;
    return new $e11177b792bd10b5$export$67d741fd70ff98f4({
        checks: [],
        typeName: $e11177b792bd10b5$export$558106ce543bd011.ZodBigInt,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...$e11177b792bd10b5$var$processCreateParams(params)
    });
};
class $e11177b792bd10b5$export$723d146f80596191 extends $e11177b792bd10b5$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = Boolean(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $e11177b792bd10b5$export$5716da67bfaa244d.boolean) {
            const ctx = this._getOrReturnCtx(input);
            $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                code: $e11177b792bd10b5$export$5ba560653e4a1035.invalid_type,
                expected: $e11177b792bd10b5$export$5716da67bfaa244d.boolean,
                received: ctx.parsedType
            });
            return $e11177b792bd10b5$export$9a105a556e65c2c0;
        }
        return $e11177b792bd10b5$export$c6813a8d51f77eaf(input.data);
    }
}
$e11177b792bd10b5$export$723d146f80596191.create = (params)=>{
    return new $e11177b792bd10b5$export$723d146f80596191({
        typeName: $e11177b792bd10b5$export$558106ce543bd011.ZodBoolean,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...$e11177b792bd10b5$var$processCreateParams(params)
    });
};
class $e11177b792bd10b5$export$e974be33bdc55521 extends $e11177b792bd10b5$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = new Date(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $e11177b792bd10b5$export$5716da67bfaa244d.date) {
            const ctx = this._getOrReturnCtx(input);
            $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                code: $e11177b792bd10b5$export$5ba560653e4a1035.invalid_type,
                expected: $e11177b792bd10b5$export$5716da67bfaa244d.date,
                received: ctx.parsedType
            });
            return $e11177b792bd10b5$export$9a105a556e65c2c0;
        }
        if (isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                code: $e11177b792bd10b5$export$5ba560653e4a1035.invalid_date
            });
            return $e11177b792bd10b5$export$9a105a556e65c2c0;
        }
        const status = new $e11177b792bd10b5$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                        code: $e11177b792bd10b5$export$5ba560653e4a1035.too_small,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        minimum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                        code: $e11177b792bd10b5$export$5ba560653e4a1035.too_big,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        maximum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else $e11177b792bd10b5$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime())
        };
    }
    _addCheck(check) {
        return new $e11177b792bd10b5$export$e974be33bdc55521({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: $e11177b792bd10b5$var$errorUtil.toString(message)
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: $e11177b792bd10b5$var$errorUtil.toString(message)
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
$e11177b792bd10b5$export$e974be33bdc55521.create = (params)=>{
    return new $e11177b792bd10b5$export$e974be33bdc55521({
        checks: [],
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        typeName: $e11177b792bd10b5$export$558106ce543bd011.ZodDate,
        ...$e11177b792bd10b5$var$processCreateParams(params)
    });
};
class $e11177b792bd10b5$export$bcc3b40f6b638044 extends $e11177b792bd10b5$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $e11177b792bd10b5$export$5716da67bfaa244d.symbol) {
            const ctx = this._getOrReturnCtx(input);
            $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                code: $e11177b792bd10b5$export$5ba560653e4a1035.invalid_type,
                expected: $e11177b792bd10b5$export$5716da67bfaa244d.symbol,
                received: ctx.parsedType
            });
            return $e11177b792bd10b5$export$9a105a556e65c2c0;
        }
        return $e11177b792bd10b5$export$c6813a8d51f77eaf(input.data);
    }
}
$e11177b792bd10b5$export$bcc3b40f6b638044.create = (params)=>{
    return new $e11177b792bd10b5$export$bcc3b40f6b638044({
        typeName: $e11177b792bd10b5$export$558106ce543bd011.ZodSymbol,
        ...$e11177b792bd10b5$var$processCreateParams(params)
    });
};
class $e11177b792bd10b5$export$4e780e961c30340d extends $e11177b792bd10b5$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $e11177b792bd10b5$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                code: $e11177b792bd10b5$export$5ba560653e4a1035.invalid_type,
                expected: $e11177b792bd10b5$export$5716da67bfaa244d.undefined,
                received: ctx.parsedType
            });
            return $e11177b792bd10b5$export$9a105a556e65c2c0;
        }
        return $e11177b792bd10b5$export$c6813a8d51f77eaf(input.data);
    }
}
$e11177b792bd10b5$export$4e780e961c30340d.create = (params)=>{
    return new $e11177b792bd10b5$export$4e780e961c30340d({
        typeName: $e11177b792bd10b5$export$558106ce543bd011.ZodUndefined,
        ...$e11177b792bd10b5$var$processCreateParams(params)
    });
};
class $e11177b792bd10b5$export$a96281f914484f2d extends $e11177b792bd10b5$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $e11177b792bd10b5$export$5716da67bfaa244d.null) {
            const ctx = this._getOrReturnCtx(input);
            $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                code: $e11177b792bd10b5$export$5ba560653e4a1035.invalid_type,
                expected: $e11177b792bd10b5$export$5716da67bfaa244d.null,
                received: ctx.parsedType
            });
            return $e11177b792bd10b5$export$9a105a556e65c2c0;
        }
        return $e11177b792bd10b5$export$c6813a8d51f77eaf(input.data);
    }
}
$e11177b792bd10b5$export$a96281f914484f2d.create = (params)=>{
    return new $e11177b792bd10b5$export$a96281f914484f2d({
        typeName: $e11177b792bd10b5$export$558106ce543bd011.ZodNull,
        ...$e11177b792bd10b5$var$processCreateParams(params)
    });
};
class $e11177b792bd10b5$export$b9d1edb536b4e4eb extends $e11177b792bd10b5$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
    _parse(input) {
        return $e11177b792bd10b5$export$c6813a8d51f77eaf(input.data);
    }
}
$e11177b792bd10b5$export$b9d1edb536b4e4eb.create = (params)=>{
    return new $e11177b792bd10b5$export$b9d1edb536b4e4eb({
        typeName: $e11177b792bd10b5$export$558106ce543bd011.ZodAny,
        ...$e11177b792bd10b5$var$processCreateParams(params)
    });
};
class $e11177b792bd10b5$export$ef3b1bb1630977ae extends $e11177b792bd10b5$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        // required
        this._unknown = true;
    }
    _parse(input) {
        return $e11177b792bd10b5$export$c6813a8d51f77eaf(input.data);
    }
}
$e11177b792bd10b5$export$ef3b1bb1630977ae.create = (params)=>{
    return new $e11177b792bd10b5$export$ef3b1bb1630977ae({
        typeName: $e11177b792bd10b5$export$558106ce543bd011.ZodUnknown,
        ...$e11177b792bd10b5$var$processCreateParams(params)
    });
};
class $e11177b792bd10b5$export$1e576a20c3ce9fb5 extends $e11177b792bd10b5$export$19342e026b58ebb7 {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
            code: $e11177b792bd10b5$export$5ba560653e4a1035.invalid_type,
            expected: $e11177b792bd10b5$export$5716da67bfaa244d.never,
            received: ctx.parsedType
        });
        return $e11177b792bd10b5$export$9a105a556e65c2c0;
    }
}
$e11177b792bd10b5$export$1e576a20c3ce9fb5.create = (params)=>{
    return new $e11177b792bd10b5$export$1e576a20c3ce9fb5({
        typeName: $e11177b792bd10b5$export$558106ce543bd011.ZodNever,
        ...$e11177b792bd10b5$var$processCreateParams(params)
    });
};
class $e11177b792bd10b5$export$7d39f5df85f21031 extends $e11177b792bd10b5$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $e11177b792bd10b5$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                code: $e11177b792bd10b5$export$5ba560653e4a1035.invalid_type,
                expected: $e11177b792bd10b5$export$5716da67bfaa244d.void,
                received: ctx.parsedType
            });
            return $e11177b792bd10b5$export$9a105a556e65c2c0;
        }
        return $e11177b792bd10b5$export$c6813a8d51f77eaf(input.data);
    }
}
$e11177b792bd10b5$export$7d39f5df85f21031.create = (params)=>{
    return new $e11177b792bd10b5$export$7d39f5df85f21031({
        typeName: $e11177b792bd10b5$export$558106ce543bd011.ZodVoid,
        ...$e11177b792bd10b5$var$processCreateParams(params)
    });
};
class $e11177b792bd10b5$export$7acfc3e64785411 extends $e11177b792bd10b5$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx, status: status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== $e11177b792bd10b5$export$5716da67bfaa244d.array) {
            $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                code: $e11177b792bd10b5$export$5ba560653e4a1035.invalid_type,
                expected: $e11177b792bd10b5$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $e11177b792bd10b5$export$9a105a556e65c2c0;
        }
        if (def.exactLength !== null) {
            const tooBig = ctx.data.length > def.exactLength.value;
            const tooSmall = ctx.data.length < def.exactLength.value;
            if (tooBig || tooSmall) {
                $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                    code: tooBig ? $e11177b792bd10b5$export$5ba560653e4a1035.too_big : $e11177b792bd10b5$export$5ba560653e4a1035.too_small,
                    minimum: tooSmall ? def.exactLength.value : undefined,
                    maximum: tooBig ? def.exactLength.value : undefined,
                    type: "array",
                    inclusive: true,
                    exact: true,
                    message: def.exactLength.message
                });
                status.dirty();
            }
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                    code: $e11177b792bd10b5$export$5ba560653e4a1035.too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.minLength.message
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                    code: $e11177b792bd10b5$export$5ba560653e4a1035.too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.maxLength.message
                });
                status.dirty();
            }
        }
        if (ctx.common.async) return Promise.all([
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseAsync(new $e11177b792bd10b5$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        })).then((result)=>{
            return $e11177b792bd10b5$export$5b20a5c3d05c1f6f.mergeArray(status, result);
        });
        const result = [
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseSync(new $e11177b792bd10b5$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return $e11177b792bd10b5$export$5b20a5c3d05c1f6f.mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new $e11177b792bd10b5$export$7acfc3e64785411({
            ...this._def,
            minLength: {
                value: minLength,
                message: $e11177b792bd10b5$var$errorUtil.toString(message)
            }
        });
    }
    max(maxLength, message) {
        return new $e11177b792bd10b5$export$7acfc3e64785411({
            ...this._def,
            maxLength: {
                value: maxLength,
                message: $e11177b792bd10b5$var$errorUtil.toString(message)
            }
        });
    }
    length(len, message) {
        return new $e11177b792bd10b5$export$7acfc3e64785411({
            ...this._def,
            exactLength: {
                value: len,
                message: $e11177b792bd10b5$var$errorUtil.toString(message)
            }
        });
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$e11177b792bd10b5$export$7acfc3e64785411.create = (schema, params)=>{
    return new $e11177b792bd10b5$export$7acfc3e64785411({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: $e11177b792bd10b5$export$558106ce543bd011.ZodArray,
        ...$e11177b792bd10b5$var$processCreateParams(params)
    });
};
function $e11177b792bd10b5$var$deepPartialify(schema) {
    if (schema instanceof $e11177b792bd10b5$export$736315c5b55efbad) {
        const newShape = {};
        for(const key in schema.shape){
            const fieldSchema = schema.shape[key];
            newShape[key] = $e11177b792bd10b5$export$aa56fec1e9d629b8.create($e11177b792bd10b5$var$deepPartialify(fieldSchema));
        }
        return new $e11177b792bd10b5$export$736315c5b55efbad({
            ...schema._def,
            shape: ()=>newShape
        });
    } else if (schema instanceof $e11177b792bd10b5$export$7acfc3e64785411) return new $e11177b792bd10b5$export$7acfc3e64785411({
        ...schema._def,
        type: $e11177b792bd10b5$var$deepPartialify(schema.element)
    });
    else if (schema instanceof $e11177b792bd10b5$export$aa56fec1e9d629b8) return $e11177b792bd10b5$export$aa56fec1e9d629b8.create($e11177b792bd10b5$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $e11177b792bd10b5$export$aaac0b8b429cef5) return $e11177b792bd10b5$export$aaac0b8b429cef5.create($e11177b792bd10b5$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $e11177b792bd10b5$export$e2a18bb771d8e6a3) return $e11177b792bd10b5$export$e2a18bb771d8e6a3.create(schema.items.map((item)=>$e11177b792bd10b5$var$deepPartialify(item)));
    else return schema;
}
class $e11177b792bd10b5$export$736315c5b55efbad extends $e11177b792bd10b5$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */ this.nonstrict = this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */ this.augment = this.extend;
    }
    _getCached() {
        if (this._cached !== null) return this._cached;
        const shape = this._def.shape();
        const keys = $e11177b792bd10b5$export$7debb50ef11d5e0b.objectKeys(shape);
        return this._cached = {
            shape: shape,
            keys: keys
        };
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $e11177b792bd10b5$export$5716da67bfaa244d.object) {
            const ctx = this._getOrReturnCtx(input);
            $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                code: $e11177b792bd10b5$export$5ba560653e4a1035.invalid_type,
                expected: $e11177b792bd10b5$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $e11177b792bd10b5$export$9a105a556e65c2c0;
        }
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const { shape: shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof $e11177b792bd10b5$export$1e576a20c3ce9fb5 && this._def.unknownKeys === "strip")) {
            for(const key in ctx.data)if (!shapeKeys.includes(key)) extraKeys.push(key);
        }
        const pairs = [];
        for (const key of shapeKeys){
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: keyValidator._parse(new $e11177b792bd10b5$var$ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data
            });
        }
        if (this._def.catchall instanceof $e11177b792bd10b5$export$1e576a20c3ce9fb5) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") for (const key of extraKeys)pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: {
                    status: "valid",
                    value: ctx.data[key]
                }
            });
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                        code: $e11177b792bd10b5$export$5ba560653e4a1035.unrecognized_keys,
                        keys: extraKeys
                    });
                    status.dirty();
                }
            } else if (unknownKeys === "strip") ;
            else throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
        } else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys){
                const value = ctx.data[key];
                pairs.push({
                    key: {
                        status: "valid",
                        value: key
                    },
                    value: catchall._parse(new $e11177b792bd10b5$var$ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data
                });
            }
        }
        if (ctx.common.async) return Promise.resolve().then(async ()=>{
            const syncPairs = [];
            for (const pair of pairs){
                const key = await pair.key;
                const value = await pair.value;
                syncPairs.push({
                    key: key,
                    value: value,
                    alwaysSet: pair.alwaysSet
                });
            }
            return syncPairs;
        }).then((syncPairs)=>{
            return $e11177b792bd10b5$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
        });
        else return $e11177b792bd10b5$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        $e11177b792bd10b5$var$errorUtil.errToObj;
        return new $e11177b792bd10b5$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strict",
            ...message !== undefined ? {
                errorMap: (issue, ctx)=>{
                    var _a, _b, _c, _d;
                    const defaultError = (_c = (_b = (_a = this._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
                    if (issue.code === "unrecognized_keys") return {
                        message: (_d = $e11177b792bd10b5$var$errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError
                    };
                    return {
                        message: defaultError
                    };
                }
            } : {}
        });
    }
    strip() {
        return new $e11177b792bd10b5$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strip"
        });
    }
    passthrough() {
        return new $e11177b792bd10b5$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "passthrough"
        });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
        return new $e11177b792bd10b5$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>({
                    ...this._def.shape(),
                    ...augmentation
                })
        });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */ merge(merging) {
        const merged = new $e11177b792bd10b5$export$736315c5b55efbad({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: ()=>({
                    ...this._def.shape(),
                    ...merging._def.shape()
                }),
            typeName: $e11177b792bd10b5$export$558106ce543bd011.ZodObject
        });
        return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
        return this.augment({
            [key]: schema
        });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index) {
        return new $e11177b792bd10b5$export$736315c5b55efbad({
            ...this._def,
            catchall: index
        });
    }
    pick(mask) {
        const shape = {};
        $e11177b792bd10b5$export$7debb50ef11d5e0b.objectKeys(mask).forEach((key)=>{
            if (mask[key] && this.shape[key]) shape[key] = this.shape[key];
        });
        return new $e11177b792bd10b5$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    omit(mask) {
        const shape = {};
        $e11177b792bd10b5$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (!mask[key]) shape[key] = this.shape[key];
        });
        return new $e11177b792bd10b5$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    /**
     * @deprecated
     */ deepPartial() {
        return $e11177b792bd10b5$var$deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        $e11177b792bd10b5$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            const fieldSchema = this.shape[key];
            if (mask && !mask[key]) newShape[key] = fieldSchema;
            else newShape[key] = fieldSchema.optional();
        });
        return new $e11177b792bd10b5$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    required(mask) {
        const newShape = {};
        $e11177b792bd10b5$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (mask && !mask[key]) newShape[key] = this.shape[key];
            else {
                const fieldSchema = this.shape[key];
                let newField = fieldSchema;
                while(newField instanceof $e11177b792bd10b5$export$aa56fec1e9d629b8)newField = newField._def.innerType;
                newShape[key] = newField;
            }
        });
        return new $e11177b792bd10b5$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    keyof() {
        return $e11177b792bd10b5$var$createZodEnum($e11177b792bd10b5$export$7debb50ef11d5e0b.objectKeys(this.shape));
    }
}
$e11177b792bd10b5$export$736315c5b55efbad.create = (shape, params)=>{
    return new $e11177b792bd10b5$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strip",
        catchall: $e11177b792bd10b5$export$1e576a20c3ce9fb5.create(),
        typeName: $e11177b792bd10b5$export$558106ce543bd011.ZodObject,
        ...$e11177b792bd10b5$var$processCreateParams(params)
    });
};
$e11177b792bd10b5$export$736315c5b55efbad.strictCreate = (shape, params)=>{
    return new $e11177b792bd10b5$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strict",
        catchall: $e11177b792bd10b5$export$1e576a20c3ce9fb5.create(),
        typeName: $e11177b792bd10b5$export$558106ce543bd011.ZodObject,
        ...$e11177b792bd10b5$var$processCreateParams(params)
    });
};
$e11177b792bd10b5$export$736315c5b55efbad.lazycreate = (shape, params)=>{
    return new $e11177b792bd10b5$export$736315c5b55efbad({
        shape: shape,
        unknownKeys: "strip",
        catchall: $e11177b792bd10b5$export$1e576a20c3ce9fb5.create(),
        typeName: $e11177b792bd10b5$export$558106ce543bd011.ZodObject,
        ...$e11177b792bd10b5$var$processCreateParams(params)
    });
};
class $e11177b792bd10b5$export$a8b236cb5070a311 extends $e11177b792bd10b5$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results){
                if (result.result.status === "valid") return result.result;
            }
            for (const result of results)if (result.result.status === "dirty") {
                // add issues from dirty option
                ctx.common.issues.push(...result.ctx.common.issues);
                return result.result;
            }
            // return invalid
            const unionErrors = results.map((result)=>new $e11177b792bd10b5$export$f98dac4b251ab333(result.ctx.common.issues));
            $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                code: $e11177b792bd10b5$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $e11177b792bd10b5$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return Promise.all(options.map(async (option)=>{
            const childCtx = {
                ...ctx,
                common: {
                    ...ctx.common,
                    issues: []
                },
                parent: null
            };
            return {
                result: await option._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                }),
                ctx: childCtx
            };
        })).then(handleResults);
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options){
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: []
                    },
                    parent: null
                };
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                });
                if (result.status === "valid") return result;
                else if (result.status === "dirty" && !dirty) dirty = {
                    result: result,
                    ctx: childCtx
                };
                if (childCtx.common.issues.length) issues.push(childCtx.common.issues);
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues)=>new $e11177b792bd10b5$export$f98dac4b251ab333(issues));
            $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                code: $e11177b792bd10b5$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $e11177b792bd10b5$export$9a105a556e65c2c0;
        }
    }
    get options() {
        return this._def.options;
    }
}
$e11177b792bd10b5$export$a8b236cb5070a311.create = (types, params)=>{
    return new $e11177b792bd10b5$export$a8b236cb5070a311({
        options: types,
        typeName: $e11177b792bd10b5$export$558106ce543bd011.ZodUnion,
        ...$e11177b792bd10b5$var$processCreateParams(params)
    });
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
const $e11177b792bd10b5$var$getDiscriminator = (type)=>{
    if (type instanceof $e11177b792bd10b5$export$378d0cfce37406e6) return $e11177b792bd10b5$var$getDiscriminator(type.schema);
    else if (type instanceof $e11177b792bd10b5$export$a60af00cc0ce2582) return $e11177b792bd10b5$var$getDiscriminator(type.innerType());
    else if (type instanceof $e11177b792bd10b5$export$7e44096782a165d3) return [
        type.value
    ];
    else if (type instanceof $e11177b792bd10b5$export$d325d1f0e1c20179) return type.options;
    else if (type instanceof $e11177b792bd10b5$export$370b2e8d6d6f5c56) // eslint-disable-next-line ban/ban
    return $e11177b792bd10b5$export$7debb50ef11d5e0b.objectValues(type.enum);
    else if (type instanceof $e11177b792bd10b5$export$bb19b37874861e7e) return $e11177b792bd10b5$var$getDiscriminator(type._def.innerType);
    else if (type instanceof $e11177b792bd10b5$export$4e780e961c30340d) return [
        undefined
    ];
    else if (type instanceof $e11177b792bd10b5$export$a96281f914484f2d) return [
        null
    ];
    else if (type instanceof $e11177b792bd10b5$export$aa56fec1e9d629b8) return [
        undefined,
        ...$e11177b792bd10b5$var$getDiscriminator(type.unwrap())
    ];
    else if (type instanceof $e11177b792bd10b5$export$aaac0b8b429cef5) return [
        null,
        ...$e11177b792bd10b5$var$getDiscriminator(type.unwrap())
    ];
    else if (type instanceof $e11177b792bd10b5$export$66b0c798a395271f) return $e11177b792bd10b5$var$getDiscriminator(type.unwrap());
    else if (type instanceof $e11177b792bd10b5$export$5d1f7ef05c4e493a) return $e11177b792bd10b5$var$getDiscriminator(type.unwrap());
    else if (type instanceof $e11177b792bd10b5$export$75a44ec6249ac76b) return $e11177b792bd10b5$var$getDiscriminator(type._def.innerType);
    else return [];
};
class $e11177b792bd10b5$export$5ef2424805ac76a3 extends $e11177b792bd10b5$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $e11177b792bd10b5$export$5716da67bfaa244d.object) {
            $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                code: $e11177b792bd10b5$export$5ba560653e4a1035.invalid_type,
                expected: $e11177b792bd10b5$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $e11177b792bd10b5$export$9a105a556e65c2c0;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
            $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                code: $e11177b792bd10b5$export$5ba560653e4a1035.invalid_union_discriminator,
                options: Array.from(this.optionsMap.keys()),
                path: [
                    discriminator
                ]
            });
            return $e11177b792bd10b5$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
        else return option._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */ static create(discriminator, options, params) {
        // Get all the valid discriminator values
        const optionsMap = new Map();
        // try {
        for (const type of options){
            const discriminatorValues = $e11177b792bd10b5$var$getDiscriminator(type.shape[discriminator]);
            if (!discriminatorValues.length) throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
            for (const value of discriminatorValues){
                if (optionsMap.has(value)) throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
                optionsMap.set(value, type);
            }
        }
        return new $e11177b792bd10b5$export$5ef2424805ac76a3({
            typeName: $e11177b792bd10b5$export$558106ce543bd011.ZodDiscriminatedUnion,
            discriminator: discriminator,
            options: options,
            optionsMap: optionsMap,
            ...$e11177b792bd10b5$var$processCreateParams(params)
        });
    }
}
function $e11177b792bd10b5$var$mergeValues(a, b) {
    const aType = $e11177b792bd10b5$export$3e9057828ebd5c7a(a);
    const bType = $e11177b792bd10b5$export$3e9057828ebd5c7a(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    else if (aType === $e11177b792bd10b5$export$5716da67bfaa244d.object && bType === $e11177b792bd10b5$export$5716da67bfaa244d.object) {
        const bKeys = $e11177b792bd10b5$export$7debb50ef11d5e0b.objectKeys(b);
        const sharedKeys = $e11177b792bd10b5$export$7debb50ef11d5e0b.objectKeys(a).filter((key)=>bKeys.indexOf(key) !== -1);
        const newObj = {
            ...a,
            ...b
        };
        for (const key of sharedKeys){
            const sharedValue = $e11177b792bd10b5$var$mergeValues(a[key], b[key]);
            if (!sharedValue.valid) return {
                valid: false
            };
            newObj[key] = sharedValue.data;
        }
        return {
            valid: true,
            data: newObj
        };
    } else if (aType === $e11177b792bd10b5$export$5716da67bfaa244d.array && bType === $e11177b792bd10b5$export$5716da67bfaa244d.array) {
        if (a.length !== b.length) return {
            valid: false
        };
        const newArray = [];
        for(let index = 0; index < a.length; index++){
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = $e11177b792bd10b5$var$mergeValues(itemA, itemB);
            if (!sharedValue.valid) return {
                valid: false
            };
            newArray.push(sharedValue.data);
        }
        return {
            valid: true,
            data: newArray
        };
    } else if (aType === $e11177b792bd10b5$export$5716da67bfaa244d.date && bType === $e11177b792bd10b5$export$5716da67bfaa244d.date && +a === +b) return {
        valid: true,
        data: a
    };
    else return {
        valid: false
    };
}
class $e11177b792bd10b5$export$c02deaf0bb5203d4 extends $e11177b792bd10b5$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight)=>{
            if ($e11177b792bd10b5$export$afa861e3c5730743(parsedLeft) || $e11177b792bd10b5$export$afa861e3c5730743(parsedRight)) return $e11177b792bd10b5$export$9a105a556e65c2c0;
            const merged = $e11177b792bd10b5$var$mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                    code: $e11177b792bd10b5$export$5ba560653e4a1035.invalid_intersection_types
                });
                return $e11177b792bd10b5$export$9a105a556e65c2c0;
            }
            if ($e11177b792bd10b5$export$910b6cdd390341b3(parsedLeft) || $e11177b792bd10b5$export$910b6cdd390341b3(parsedRight)) status.dirty();
            return {
                status: status.value,
                value: merged.data
            };
        };
        if (ctx.common.async) return Promise.all([
            this._def.left._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }),
            this._def.right._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            })
        ]).then(([left, right])=>handleParsed(left, right));
        else return handleParsed(this._def.left._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }), this._def.right._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }));
    }
}
$e11177b792bd10b5$export$c02deaf0bb5203d4.create = (left, right, params)=>{
    return new $e11177b792bd10b5$export$c02deaf0bb5203d4({
        left: left,
        right: right,
        typeName: $e11177b792bd10b5$export$558106ce543bd011.ZodIntersection,
        ...$e11177b792bd10b5$var$processCreateParams(params)
    });
};
class $e11177b792bd10b5$export$e2a18bb771d8e6a3 extends $e11177b792bd10b5$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $e11177b792bd10b5$export$5716da67bfaa244d.array) {
            $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                code: $e11177b792bd10b5$export$5ba560653e4a1035.invalid_type,
                expected: $e11177b792bd10b5$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $e11177b792bd10b5$export$9a105a556e65c2c0;
        }
        if (ctx.data.length < this._def.items.length) {
            $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                code: $e11177b792bd10b5$export$5ba560653e4a1035.too_small,
                minimum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            return $e11177b792bd10b5$export$9a105a556e65c2c0;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                code: $e11177b792bd10b5$export$5ba560653e4a1035.too_big,
                maximum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            status.dirty();
        }
        const items = [
            ...ctx.data
        ].map((item, itemIndex)=>{
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema) return null;
            return schema._parse(new $e11177b792bd10b5$var$ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        }).filter((x)=>!!x); // filter nulls
        if (ctx.common.async) return Promise.all(items).then((results)=>{
            return $e11177b792bd10b5$export$5b20a5c3d05c1f6f.mergeArray(status, results);
        });
        else return $e11177b792bd10b5$export$5b20a5c3d05c1f6f.mergeArray(status, items);
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new $e11177b792bd10b5$export$e2a18bb771d8e6a3({
            ...this._def,
            rest: rest
        });
    }
}
$e11177b792bd10b5$export$e2a18bb771d8e6a3.create = (schemas, params)=>{
    if (!Array.isArray(schemas)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    return new $e11177b792bd10b5$export$e2a18bb771d8e6a3({
        items: schemas,
        typeName: $e11177b792bd10b5$export$558106ce543bd011.ZodTuple,
        rest: null,
        ...$e11177b792bd10b5$var$processCreateParams(params)
    });
};
class $e11177b792bd10b5$export$a2acc09968cb4b7f extends $e11177b792bd10b5$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $e11177b792bd10b5$export$5716da67bfaa244d.object) {
            $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                code: $e11177b792bd10b5$export$5ba560653e4a1035.invalid_type,
                expected: $e11177b792bd10b5$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $e11177b792bd10b5$export$9a105a556e65c2c0;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for(const key in ctx.data)pairs.push({
            key: keyType._parse(new $e11177b792bd10b5$var$ParseInputLazyPath(ctx, key, ctx.path, key)),
            value: valueType._parse(new $e11177b792bd10b5$var$ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key)),
            alwaysSet: key in ctx.data
        });
        if (ctx.common.async) return $e11177b792bd10b5$export$5b20a5c3d05c1f6f.mergeObjectAsync(status, pairs);
        else return $e11177b792bd10b5$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof $e11177b792bd10b5$export$19342e026b58ebb7) return new $e11177b792bd10b5$export$a2acc09968cb4b7f({
            keyType: first,
            valueType: second,
            typeName: $e11177b792bd10b5$export$558106ce543bd011.ZodRecord,
            ...$e11177b792bd10b5$var$processCreateParams(third)
        });
        return new $e11177b792bd10b5$export$a2acc09968cb4b7f({
            keyType: $e11177b792bd10b5$export$1230eb29b8d3b502.create(),
            valueType: first,
            typeName: $e11177b792bd10b5$export$558106ce543bd011.ZodRecord,
            ...$e11177b792bd10b5$var$processCreateParams(second)
        });
    }
}
class $e11177b792bd10b5$export$163b6a2b712d9542 extends $e11177b792bd10b5$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $e11177b792bd10b5$export$5716da67bfaa244d.map) {
            $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                code: $e11177b792bd10b5$export$5ba560653e4a1035.invalid_type,
                expected: $e11177b792bd10b5$export$5716da67bfaa244d.map,
                received: ctx.parsedType
            });
            return $e11177b792bd10b5$export$9a105a556e65c2c0;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [
            ...ctx.data.entries()
        ].map(([key, value], index)=>{
            return {
                key: keyType._parse(new $e11177b792bd10b5$var$ParseInputLazyPath(ctx, key, ctx.path, [
                    index,
                    "key"
                ])),
                value: valueType._parse(new $e11177b792bd10b5$var$ParseInputLazyPath(ctx, value, ctx.path, [
                    index,
                    "value"
                ]))
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(async ()=>{
                for (const pair of pairs){
                    const key = await pair.key;
                    const value = await pair.value;
                    if (key.status === "aborted" || value.status === "aborted") return $e11177b792bd10b5$export$9a105a556e65c2c0;
                    if (key.status === "dirty" || value.status === "dirty") status.dirty();
                    finalMap.set(key.value, value.value);
                }
                return {
                    status: status.value,
                    value: finalMap
                };
            });
        } else {
            const finalMap = new Map();
            for (const pair of pairs){
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") return $e11177b792bd10b5$export$9a105a556e65c2c0;
                if (key.status === "dirty" || value.status === "dirty") status.dirty();
                finalMap.set(key.value, value.value);
            }
            return {
                status: status.value,
                value: finalMap
            };
        }
    }
}
$e11177b792bd10b5$export$163b6a2b712d9542.create = (keyType, valueType, params)=>{
    return new $e11177b792bd10b5$export$163b6a2b712d9542({
        valueType: valueType,
        keyType: keyType,
        typeName: $e11177b792bd10b5$export$558106ce543bd011.ZodMap,
        ...$e11177b792bd10b5$var$processCreateParams(params)
    });
};
class $e11177b792bd10b5$export$977057706f816712 extends $e11177b792bd10b5$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $e11177b792bd10b5$export$5716da67bfaa244d.set) {
            $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                code: $e11177b792bd10b5$export$5ba560653e4a1035.invalid_type,
                expected: $e11177b792bd10b5$export$5716da67bfaa244d.set,
                received: ctx.parsedType
            });
            return $e11177b792bd10b5$export$9a105a556e65c2c0;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                    code: $e11177b792bd10b5$export$5ba560653e4a1035.too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.minSize.message
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                    code: $e11177b792bd10b5$export$5ba560653e4a1035.too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.maxSize.message
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements){
                if (element.status === "aborted") return $e11177b792bd10b5$export$9a105a556e65c2c0;
                if (element.status === "dirty") status.dirty();
                parsedSet.add(element.value);
            }
            return {
                status: status.value,
                value: parsedSet
            };
        }
        const elements = [
            ...ctx.data.values()
        ].map((item, i)=>valueType._parse(new $e11177b792bd10b5$var$ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) return Promise.all(elements).then((elements)=>finalizeSet(elements));
        else return finalizeSet(elements);
    }
    min(minSize, message) {
        return new $e11177b792bd10b5$export$977057706f816712({
            ...this._def,
            minSize: {
                value: minSize,
                message: $e11177b792bd10b5$var$errorUtil.toString(message)
            }
        });
    }
    max(maxSize, message) {
        return new $e11177b792bd10b5$export$977057706f816712({
            ...this._def,
            maxSize: {
                value: maxSize,
                message: $e11177b792bd10b5$var$errorUtil.toString(message)
            }
        });
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$e11177b792bd10b5$export$977057706f816712.create = (valueType, params)=>{
    return new $e11177b792bd10b5$export$977057706f816712({
        valueType: valueType,
        minSize: null,
        maxSize: null,
        typeName: $e11177b792bd10b5$export$558106ce543bd011.ZodSet,
        ...$e11177b792bd10b5$var$processCreateParams(params)
    });
};
class $e11177b792bd10b5$export$d4602ba55673f53c extends $e11177b792bd10b5$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.validate = this.implement;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $e11177b792bd10b5$export$5716da67bfaa244d.function) {
            $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                code: $e11177b792bd10b5$export$5ba560653e4a1035.invalid_type,
                expected: $e11177b792bd10b5$export$5716da67bfaa244d.function,
                received: ctx.parsedType
            });
            return $e11177b792bd10b5$export$9a105a556e65c2c0;
        }
        function makeArgsIssue(args, error) {
            return $e11177b792bd10b5$export$244a85fde9c419ed({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $e11177b792bd10b5$export$32f27c719778d4c4(),
                    $e11177b792bd10b5$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $e11177b792bd10b5$export$5ba560653e4a1035.invalid_arguments,
                    argumentsError: error
                }
            });
        }
        function makeReturnsIssue(returns, error) {
            return $e11177b792bd10b5$export$244a85fde9c419ed({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $e11177b792bd10b5$export$32f27c719778d4c4(),
                    $e11177b792bd10b5$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $e11177b792bd10b5$export$5ba560653e4a1035.invalid_return_type,
                    returnTypeError: error
                }
            });
        }
        const params = {
            errorMap: ctx.common.contextualErrorMap
        };
        const fn = ctx.data;
        if (this._def.returns instanceof $e11177b792bd10b5$export$3f196b0127d6e50a) {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $e11177b792bd10b5$export$c6813a8d51f77eaf(async function(...args) {
                const error = new $e11177b792bd10b5$export$f98dac4b251ab333([]);
                const parsedArgs = await me._def.args.parseAsync(args, params).catch((e)=>{
                    error.addIssue(makeArgsIssue(args, e));
                    throw error;
                });
                const result = await Reflect.apply(fn, this, parsedArgs);
                const parsedReturns = await me._def.returns._def.type.parseAsync(result, params).catch((e)=>{
                    error.addIssue(makeReturnsIssue(result, e));
                    throw error;
                });
                return parsedReturns;
            });
        } else {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $e11177b792bd10b5$export$c6813a8d51f77eaf(function(...args) {
                const parsedArgs = me._def.args.safeParse(args, params);
                if (!parsedArgs.success) throw new $e11177b792bd10b5$export$f98dac4b251ab333([
                    makeArgsIssue(args, parsedArgs.error)
                ]);
                const result = Reflect.apply(fn, this, parsedArgs.data);
                const parsedReturns = me._def.returns.safeParse(result, params);
                if (!parsedReturns.success) throw new $e11177b792bd10b5$export$f98dac4b251ab333([
                    makeReturnsIssue(result, parsedReturns.error)
                ]);
                return parsedReturns.data;
            });
        }
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new $e11177b792bd10b5$export$d4602ba55673f53c({
            ...this._def,
            args: $e11177b792bd10b5$export$e2a18bb771d8e6a3.create(items).rest($e11177b792bd10b5$export$ef3b1bb1630977ae.create())
        });
    }
    returns(returnType) {
        return new $e11177b792bd10b5$export$d4602ba55673f53c({
            ...this._def,
            returns: returnType
        });
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new $e11177b792bd10b5$export$d4602ba55673f53c({
            args: args ? args : $e11177b792bd10b5$export$e2a18bb771d8e6a3.create([]).rest($e11177b792bd10b5$export$ef3b1bb1630977ae.create()),
            returns: returns || $e11177b792bd10b5$export$ef3b1bb1630977ae.create(),
            typeName: $e11177b792bd10b5$export$558106ce543bd011.ZodFunction,
            ...$e11177b792bd10b5$var$processCreateParams(params)
        });
    }
}
class $e11177b792bd10b5$export$378d0cfce37406e6 extends $e11177b792bd10b5$export$19342e026b58ebb7 {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
}
$e11177b792bd10b5$export$378d0cfce37406e6.create = (getter, params)=>{
    return new $e11177b792bd10b5$export$378d0cfce37406e6({
        getter: getter,
        typeName: $e11177b792bd10b5$export$558106ce543bd011.ZodLazy,
        ...$e11177b792bd10b5$var$processCreateParams(params)
    });
};
class $e11177b792bd10b5$export$7e44096782a165d3 extends $e11177b792bd10b5$export$19342e026b58ebb7 {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $e11177b792bd10b5$export$5ba560653e4a1035.invalid_literal,
                expected: this._def.value
            });
            return $e11177b792bd10b5$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
    get value() {
        return this._def.value;
    }
}
$e11177b792bd10b5$export$7e44096782a165d3.create = (value, params)=>{
    return new $e11177b792bd10b5$export$7e44096782a165d3({
        value: value,
        typeName: $e11177b792bd10b5$export$558106ce543bd011.ZodLiteral,
        ...$e11177b792bd10b5$var$processCreateParams(params)
    });
};
function $e11177b792bd10b5$var$createZodEnum(values, params) {
    return new $e11177b792bd10b5$export$d325d1f0e1c20179({
        values: values,
        typeName: $e11177b792bd10b5$export$558106ce543bd011.ZodEnum,
        ...$e11177b792bd10b5$var$processCreateParams(params)
    });
}
class $e11177b792bd10b5$export$d325d1f0e1c20179 extends $e11177b792bd10b5$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        $e11177b792bd10b5$var$_ZodEnum_cache.set(this, void 0);
    }
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                expected: $e11177b792bd10b5$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $e11177b792bd10b5$export$5ba560653e4a1035.invalid_type
            });
            return $e11177b792bd10b5$export$9a105a556e65c2c0;
        }
        if (!$e11177b792bd10b5$var$__classPrivateFieldGet(this, $e11177b792bd10b5$var$_ZodEnum_cache, "f")) $e11177b792bd10b5$var$__classPrivateFieldSet(this, $e11177b792bd10b5$var$_ZodEnum_cache, new Set(this._def.values), "f");
        if (!$e11177b792bd10b5$var$__classPrivateFieldGet(this, $e11177b792bd10b5$var$_ZodEnum_cache, "f").has(input.data)) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $e11177b792bd10b5$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $e11177b792bd10b5$export$9a105a556e65c2c0;
        }
        return $e11177b792bd10b5$export$c6813a8d51f77eaf(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    extract(values, newDef = this._def) {
        return $e11177b792bd10b5$export$d325d1f0e1c20179.create(values, {
            ...this._def,
            ...newDef
        });
    }
    exclude(values, newDef = this._def) {
        return $e11177b792bd10b5$export$d325d1f0e1c20179.create(this.options.filter((opt)=>!values.includes(opt)), {
            ...this._def,
            ...newDef
        });
    }
}
$e11177b792bd10b5$var$_ZodEnum_cache = new WeakMap();
$e11177b792bd10b5$export$d325d1f0e1c20179.create = $e11177b792bd10b5$var$createZodEnum;
class $e11177b792bd10b5$export$370b2e8d6d6f5c56 extends $e11177b792bd10b5$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        $e11177b792bd10b5$var$_ZodNativeEnum_cache.set(this, void 0);
    }
    _parse(input) {
        const nativeEnumValues = $e11177b792bd10b5$export$7debb50ef11d5e0b.getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== $e11177b792bd10b5$export$5716da67bfaa244d.string && ctx.parsedType !== $e11177b792bd10b5$export$5716da67bfaa244d.number) {
            const expectedValues = $e11177b792bd10b5$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                expected: $e11177b792bd10b5$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $e11177b792bd10b5$export$5ba560653e4a1035.invalid_type
            });
            return $e11177b792bd10b5$export$9a105a556e65c2c0;
        }
        if (!$e11177b792bd10b5$var$__classPrivateFieldGet(this, $e11177b792bd10b5$var$_ZodNativeEnum_cache, "f")) $e11177b792bd10b5$var$__classPrivateFieldSet(this, $e11177b792bd10b5$var$_ZodNativeEnum_cache, new Set($e11177b792bd10b5$export$7debb50ef11d5e0b.getValidEnumValues(this._def.values)), "f");
        if (!$e11177b792bd10b5$var$__classPrivateFieldGet(this, $e11177b792bd10b5$var$_ZodNativeEnum_cache, "f").has(input.data)) {
            const expectedValues = $e11177b792bd10b5$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $e11177b792bd10b5$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $e11177b792bd10b5$export$9a105a556e65c2c0;
        }
        return $e11177b792bd10b5$export$c6813a8d51f77eaf(input.data);
    }
    get enum() {
        return this._def.values;
    }
}
$e11177b792bd10b5$var$_ZodNativeEnum_cache = new WeakMap();
$e11177b792bd10b5$export$370b2e8d6d6f5c56.create = (values, params)=>{
    return new $e11177b792bd10b5$export$370b2e8d6d6f5c56({
        values: values,
        typeName: $e11177b792bd10b5$export$558106ce543bd011.ZodNativeEnum,
        ...$e11177b792bd10b5$var$processCreateParams(params)
    });
};
class $e11177b792bd10b5$export$3f196b0127d6e50a extends $e11177b792bd10b5$export$19342e026b58ebb7 {
    unwrap() {
        return this._def.type;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $e11177b792bd10b5$export$5716da67bfaa244d.promise && ctx.common.async === false) {
            $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                code: $e11177b792bd10b5$export$5ba560653e4a1035.invalid_type,
                expected: $e11177b792bd10b5$export$5716da67bfaa244d.promise,
                received: ctx.parsedType
            });
            return $e11177b792bd10b5$export$9a105a556e65c2c0;
        }
        const promisified = ctx.parsedType === $e11177b792bd10b5$export$5716da67bfaa244d.promise ? ctx.data : Promise.resolve(ctx.data);
        return $e11177b792bd10b5$export$c6813a8d51f77eaf(promisified.then((data)=>{
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap
            });
        }));
    }
}
$e11177b792bd10b5$export$3f196b0127d6e50a.create = (schema, params)=>{
    return new $e11177b792bd10b5$export$3f196b0127d6e50a({
        type: schema,
        typeName: $e11177b792bd10b5$export$558106ce543bd011.ZodPromise,
        ...$e11177b792bd10b5$var$processCreateParams(params)
    });
};
class $e11177b792bd10b5$export$a60af00cc0ce2582 extends $e11177b792bd10b5$export$19342e026b58ebb7 {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === $e11177b792bd10b5$export$558106ce543bd011.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        const checkCtx = {
            addIssue: (arg)=>{
                $e11177b792bd10b5$export$db7caee60e5d514d(ctx, arg);
                if (arg.fatal) status.abort();
                else status.dirty();
            },
            get path () {
                return ctx.path;
            }
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data, checkCtx);
            if (ctx.common.async) return Promise.resolve(processed).then(async (processed)=>{
                if (status.value === "aborted") return $e11177b792bd10b5$export$9a105a556e65c2c0;
                const result = await this._def.schema._parseAsync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return $e11177b792bd10b5$export$9a105a556e65c2c0;
                if (result.status === "dirty") return $e11177b792bd10b5$export$325a211da9693fcf(result.value);
                if (status.value === "dirty") return $e11177b792bd10b5$export$325a211da9693fcf(result.value);
                return result;
            });
            else {
                if (status.value === "aborted") return $e11177b792bd10b5$export$9a105a556e65c2c0;
                const result = this._def.schema._parseSync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return $e11177b792bd10b5$export$9a105a556e65c2c0;
                if (result.status === "dirty") return $e11177b792bd10b5$export$325a211da9693fcf(result.value);
                if (status.value === "dirty") return $e11177b792bd10b5$export$325a211da9693fcf(result.value);
                return result;
            }
        }
        if (effect.type === "refinement") {
            const executeRefinement = (acc)=>{
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) return Promise.resolve(result);
                if (result instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inner.status === "aborted") return $e11177b792bd10b5$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return {
                    status: status.value,
                    value: inner.value
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((inner)=>{
                if (inner.status === "aborted") return $e11177b792bd10b5$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                return executeRefinement(inner.value).then(()=>{
                    return {
                        status: status.value,
                        value: inner.value
                    };
                });
            });
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (!$e11177b792bd10b5$export$1ea939691cdc45b8(base)) return base;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                return {
                    status: status.value,
                    value: result
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((base)=>{
                if (!$e11177b792bd10b5$export$1ea939691cdc45b8(base)) return base;
                return Promise.resolve(effect.transform(base.value, checkCtx)).then((result)=>({
                        status: status.value,
                        value: result
                    }));
            });
        }
        $e11177b792bd10b5$export$7debb50ef11d5e0b.assertNever(effect);
    }
}
$e11177b792bd10b5$export$a60af00cc0ce2582.create = (schema, effect, params)=>{
    return new $e11177b792bd10b5$export$a60af00cc0ce2582({
        schema: schema,
        typeName: $e11177b792bd10b5$export$558106ce543bd011.ZodEffects,
        effect: effect,
        ...$e11177b792bd10b5$var$processCreateParams(params)
    });
};
$e11177b792bd10b5$export$a60af00cc0ce2582.createWithPreprocess = (preprocess, schema, params)=>{
    return new $e11177b792bd10b5$export$a60af00cc0ce2582({
        schema: schema,
        effect: {
            type: "preprocess",
            transform: preprocess
        },
        typeName: $e11177b792bd10b5$export$558106ce543bd011.ZodEffects,
        ...$e11177b792bd10b5$var$processCreateParams(params)
    });
};
class $e11177b792bd10b5$export$aa56fec1e9d629b8 extends $e11177b792bd10b5$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $e11177b792bd10b5$export$5716da67bfaa244d.undefined) return $e11177b792bd10b5$export$c6813a8d51f77eaf(undefined);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$e11177b792bd10b5$export$aa56fec1e9d629b8.create = (type, params)=>{
    return new $e11177b792bd10b5$export$aa56fec1e9d629b8({
        innerType: type,
        typeName: $e11177b792bd10b5$export$558106ce543bd011.ZodOptional,
        ...$e11177b792bd10b5$var$processCreateParams(params)
    });
};
class $e11177b792bd10b5$export$aaac0b8b429cef5 extends $e11177b792bd10b5$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $e11177b792bd10b5$export$5716da67bfaa244d.null) return $e11177b792bd10b5$export$c6813a8d51f77eaf(null);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$e11177b792bd10b5$export$aaac0b8b429cef5.create = (type, params)=>{
    return new $e11177b792bd10b5$export$aaac0b8b429cef5({
        innerType: type,
        typeName: $e11177b792bd10b5$export$558106ce543bd011.ZodNullable,
        ...$e11177b792bd10b5$var$processCreateParams(params)
    });
};
class $e11177b792bd10b5$export$bb19b37874861e7e extends $e11177b792bd10b5$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === $e11177b792bd10b5$export$5716da67bfaa244d.undefined) data = this._def.defaultValue();
        return this._def.innerType._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
$e11177b792bd10b5$export$bb19b37874861e7e.create = (type, params)=>{
    return new $e11177b792bd10b5$export$bb19b37874861e7e({
        innerType: type,
        typeName: $e11177b792bd10b5$export$558106ce543bd011.ZodDefault,
        defaultValue: typeof params.default === "function" ? params.default : ()=>params.default,
        ...$e11177b792bd10b5$var$processCreateParams(params)
    });
};
class $e11177b792bd10b5$export$75a44ec6249ac76b extends $e11177b792bd10b5$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        // newCtx is used to not collect issues from inner types in ctx
        const newCtx = {
            ...ctx,
            common: {
                ...ctx.common,
                issues: []
            }
        };
        const result = this._def.innerType._parse({
            data: newCtx.data,
            path: newCtx.path,
            parent: {
                ...newCtx
            }
        });
        if ($e11177b792bd10b5$export$aefee5ebe1dcfd9e(result)) return result.then((result)=>{
            return {
                status: "valid",
                value: result.status === "valid" ? result.value : this._def.catchValue({
                    get error () {
                        return new $e11177b792bd10b5$export$f98dac4b251ab333(newCtx.common.issues);
                    },
                    input: newCtx.data
                })
            };
        });
        else return {
            status: "valid",
            value: result.status === "valid" ? result.value : this._def.catchValue({
                get error () {
                    return new $e11177b792bd10b5$export$f98dac4b251ab333(newCtx.common.issues);
                },
                input: newCtx.data
            })
        };
    }
    removeCatch() {
        return this._def.innerType;
    }
}
$e11177b792bd10b5$export$75a44ec6249ac76b.create = (type, params)=>{
    return new $e11177b792bd10b5$export$75a44ec6249ac76b({
        innerType: type,
        typeName: $e11177b792bd10b5$export$558106ce543bd011.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : ()=>params.catch,
        ...$e11177b792bd10b5$var$processCreateParams(params)
    });
};
class $e11177b792bd10b5$export$26ccfa0145e8511f extends $e11177b792bd10b5$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $e11177b792bd10b5$export$5716da67bfaa244d.nan) {
            const ctx = this._getOrReturnCtx(input);
            $e11177b792bd10b5$export$db7caee60e5d514d(ctx, {
                code: $e11177b792bd10b5$export$5ba560653e4a1035.invalid_type,
                expected: $e11177b792bd10b5$export$5716da67bfaa244d.nan,
                received: ctx.parsedType
            });
            return $e11177b792bd10b5$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
}
$e11177b792bd10b5$export$26ccfa0145e8511f.create = (params)=>{
    return new $e11177b792bd10b5$export$26ccfa0145e8511f({
        typeName: $e11177b792bd10b5$export$558106ce543bd011.ZodNaN,
        ...$e11177b792bd10b5$var$processCreateParams(params)
    });
};
const $e11177b792bd10b5$export$cf2deea74cde46b4 = Symbol("zod_brand");
class $e11177b792bd10b5$export$66b0c798a395271f extends $e11177b792bd10b5$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    unwrap() {
        return this._def.type;
    }
}
class $e11177b792bd10b5$export$a3c3ef8a0e95c6da extends $e11177b792bd10b5$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.common.async) {
            const handleAsync = async ()=>{
                const inResult = await this._def.in._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inResult.status === "aborted") return $e11177b792bd10b5$export$9a105a556e65c2c0;
                if (inResult.status === "dirty") {
                    status.dirty();
                    return $e11177b792bd10b5$export$325a211da9693fcf(inResult.value);
                } else return this._def.out._parseAsync({
                    data: inResult.value,
                    path: ctx.path,
                    parent: ctx
                });
            };
            return handleAsync();
        } else {
            const inResult = this._def.in._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            });
            if (inResult.status === "aborted") return $e11177b792bd10b5$export$9a105a556e65c2c0;
            if (inResult.status === "dirty") {
                status.dirty();
                return {
                    status: "dirty",
                    value: inResult.value
                };
            } else return this._def.out._parseSync({
                data: inResult.value,
                path: ctx.path,
                parent: ctx
            });
        }
    }
    static create(a, b) {
        return new $e11177b792bd10b5$export$a3c3ef8a0e95c6da({
            in: a,
            out: b,
            typeName: $e11177b792bd10b5$export$558106ce543bd011.ZodPipeline
        });
    }
}
class $e11177b792bd10b5$export$5d1f7ef05c4e493a extends $e11177b792bd10b5$export$19342e026b58ebb7 {
    _parse(input) {
        const result = this._def.innerType._parse(input);
        const freeze = (data)=>{
            if ($e11177b792bd10b5$export$1ea939691cdc45b8(data)) data.value = Object.freeze(data.value);
            return data;
        };
        return $e11177b792bd10b5$export$aefee5ebe1dcfd9e(result) ? result.then((data)=>freeze(data)) : freeze(result);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$e11177b792bd10b5$export$5d1f7ef05c4e493a.create = (type, params)=>{
    return new $e11177b792bd10b5$export$5d1f7ef05c4e493a({
        innerType: type,
        typeName: $e11177b792bd10b5$export$558106ce543bd011.ZodReadonly,
        ...$e11177b792bd10b5$var$processCreateParams(params)
    });
};
////////////////////////////////////////
////////////////////////////////////////
//////////                    //////////
//////////      z.custom      //////////
//////////                    //////////
////////////////////////////////////////
////////////////////////////////////////
function $e11177b792bd10b5$var$cleanParams(params, data) {
    const p = typeof params === "function" ? params(data) : typeof params === "string" ? {
        message: params
    } : params;
    const p2 = typeof p === "string" ? {
        message: p
    } : p;
    return p2;
}
function $e11177b792bd10b5$export$4c00f665f0d4b443(check, _params = {}, /**
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */ fatal) {
    if (check) return $e11177b792bd10b5$export$b9d1edb536b4e4eb.create().superRefine((data, ctx)=>{
        var _a, _b;
        const r = check(data);
        if (r instanceof Promise) return r.then((r)=>{
            var _a, _b;
            if (!r) {
                const params = $e11177b792bd10b5$var$cleanParams(_params, data);
                const _fatal = (_b = (_a = params.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
                ctx.addIssue({
                    code: "custom",
                    ...params,
                    fatal: _fatal
                });
            }
        });
        if (!r) {
            const params = $e11177b792bd10b5$var$cleanParams(_params, data);
            const _fatal = (_b = (_a = params.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
            ctx.addIssue({
                code: "custom",
                ...params,
                fatal: _fatal
            });
        }
        return;
    });
    return $e11177b792bd10b5$export$b9d1edb536b4e4eb.create();
}
const $e11177b792bd10b5$export$1ee8ee30835eab8b = {
    object: $e11177b792bd10b5$export$736315c5b55efbad.lazycreate
};
var $e11177b792bd10b5$export$558106ce543bd011;
(function(ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})($e11177b792bd10b5$export$558106ce543bd011 || ($e11177b792bd10b5$export$558106ce543bd011 = {}));
const $e11177b792bd10b5$export$3d916e7c22dbd8b5 = (// const instanceOfType = <T extends new (...args: any[]) => any>(
cls, params = {
    message: `Input not instance of ${cls.name}`
})=>$e11177b792bd10b5$export$4c00f665f0d4b443((data)=>data instanceof cls, params);
const $e11177b792bd10b5$export$22b082955e083ec3 = $e11177b792bd10b5$export$1230eb29b8d3b502.create;
const $e11177b792bd10b5$export$98e628dec113755e = $e11177b792bd10b5$export$5b070a55c0c43e09.create;
const $e11177b792bd10b5$export$9e06de0973666692 = $e11177b792bd10b5$export$26ccfa0145e8511f.create;
const $e11177b792bd10b5$export$a0f65b52274bcc00 = $e11177b792bd10b5$export$67d741fd70ff98f4.create;
const $e11177b792bd10b5$export$4a21f16c33752377 = $e11177b792bd10b5$export$723d146f80596191.create;
const $e11177b792bd10b5$export$324d90190a8b822a = $e11177b792bd10b5$export$e974be33bdc55521.create;
const $e11177b792bd10b5$export$8f701197936bc2a6 = $e11177b792bd10b5$export$bcc3b40f6b638044.create;
const $e11177b792bd10b5$export$1db45310990710a5 = $e11177b792bd10b5$export$4e780e961c30340d.create;
const $e11177b792bd10b5$export$7b1b591b262c240 = $e11177b792bd10b5$export$a96281f914484f2d.create;
const $e11177b792bd10b5$export$4154a199d7d90455 = $e11177b792bd10b5$export$b9d1edb536b4e4eb.create;
const $e11177b792bd10b5$export$19282c40b967aec6 = $e11177b792bd10b5$export$ef3b1bb1630977ae.create;
const $e11177b792bd10b5$export$b3e22bcfd64c1022 = $e11177b792bd10b5$export$1e576a20c3ce9fb5.create;
const $e11177b792bd10b5$export$490e536ee7389aeb = $e11177b792bd10b5$export$7d39f5df85f21031.create;
const $e11177b792bd10b5$export$2f23118c22fb2630 = $e11177b792bd10b5$export$7acfc3e64785411.create;
const $e11177b792bd10b5$export$be5493f9613cbbe = $e11177b792bd10b5$export$736315c5b55efbad.create;
const $e11177b792bd10b5$export$8fb0df5f40d0b477 = $e11177b792bd10b5$export$736315c5b55efbad.strictCreate;
const $e11177b792bd10b5$export$971dd5b0dfd021b6 = $e11177b792bd10b5$export$a8b236cb5070a311.create;
const $e11177b792bd10b5$export$4b888e40c4ee26dd = $e11177b792bd10b5$export$5ef2424805ac76a3.create;
const $e11177b792bd10b5$export$bc86dfbf7795668c = $e11177b792bd10b5$export$c02deaf0bb5203d4.create;
const $e11177b792bd10b5$export$65e3907585753458 = $e11177b792bd10b5$export$e2a18bb771d8e6a3.create;
const $e11177b792bd10b5$export$e5185e241753e543 = $e11177b792bd10b5$export$a2acc09968cb4b7f.create;
const $e11177b792bd10b5$export$871de8747c9eaa88 = $e11177b792bd10b5$export$163b6a2b712d9542.create;
const $e11177b792bd10b5$export$adaa4cf7ef1b65be = $e11177b792bd10b5$export$977057706f816712.create;
const $e11177b792bd10b5$export$44e51c8aac7c2deb = $e11177b792bd10b5$export$d4602ba55673f53c.create;
const $e11177b792bd10b5$export$488013bae63b21da = $e11177b792bd10b5$export$378d0cfce37406e6.create;
const $e11177b792bd10b5$export$c8ec6e1ec9fefcb0 = $e11177b792bd10b5$export$7e44096782a165d3.create;
const $e11177b792bd10b5$export$78a99c8d44d72635 = $e11177b792bd10b5$export$d325d1f0e1c20179.create;
const $e11177b792bd10b5$export$6fe7eca19ebe5199 = $e11177b792bd10b5$export$370b2e8d6d6f5c56.create;
const $e11177b792bd10b5$export$c957ef27a0ebfd4 = $e11177b792bd10b5$export$3f196b0127d6e50a.create;
const $e11177b792bd10b5$export$dc573d8a6576cdb3 = $e11177b792bd10b5$export$a60af00cc0ce2582.create;
const $e11177b792bd10b5$export$516e28dec6a4b6d4 = $e11177b792bd10b5$export$aa56fec1e9d629b8.create;
const $e11177b792bd10b5$export$133fc36489ac9add = $e11177b792bd10b5$export$aaac0b8b429cef5.create;
const $e11177b792bd10b5$export$fc37fe19dfda43ee = $e11177b792bd10b5$export$a60af00cc0ce2582.createWithPreprocess;
const $e11177b792bd10b5$export$43f28b24e1eb8181 = $e11177b792bd10b5$export$a3c3ef8a0e95c6da.create;
const $e11177b792bd10b5$export$3b3d07727c5b702c = ()=>$e11177b792bd10b5$export$22b082955e083ec3().optional();
const $e11177b792bd10b5$export$eb150471a61fced6 = ()=>$e11177b792bd10b5$export$98e628dec113755e().optional();
const $e11177b792bd10b5$export$269251733cdcbbf1 = ()=>$e11177b792bd10b5$export$4a21f16c33752377().optional();
const $e11177b792bd10b5$export$8c14e57e778d3873 = {
    string: (arg)=>$e11177b792bd10b5$export$1230eb29b8d3b502.create({
            ...arg,
            coerce: true
        }),
    number: (arg)=>$e11177b792bd10b5$export$5b070a55c0c43e09.create({
            ...arg,
            coerce: true
        }),
    boolean: (arg)=>$e11177b792bd10b5$export$723d146f80596191.create({
            ...arg,
            coerce: true
        }),
    bigint: (arg)=>$e11177b792bd10b5$export$67d741fd70ff98f4.create({
            ...arg,
            coerce: true
        }),
    date: (arg)=>$e11177b792bd10b5$export$e974be33bdc55521.create({
            ...arg,
            coerce: true
        })
};
const $e11177b792bd10b5$export$96c94437c95d7862 = $e11177b792bd10b5$export$9a105a556e65c2c0;
var $e11177b792bd10b5$export$2e2bcd8739ae039 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    defaultErrorMap: $e11177b792bd10b5$export$341b0b6e0a6f5099,
    setErrorMap: $e11177b792bd10b5$export$1097a8289cfd22d7,
    getErrorMap: $e11177b792bd10b5$export$32f27c719778d4c4,
    makeIssue: $e11177b792bd10b5$export$244a85fde9c419ed,
    EMPTY_PATH: $e11177b792bd10b5$export$1526d2e05f74572,
    addIssueToContext: $e11177b792bd10b5$export$db7caee60e5d514d,
    ParseStatus: $e11177b792bd10b5$export$5b20a5c3d05c1f6f,
    INVALID: $e11177b792bd10b5$export$9a105a556e65c2c0,
    DIRTY: $e11177b792bd10b5$export$325a211da9693fcf,
    OK: $e11177b792bd10b5$export$c6813a8d51f77eaf,
    isAborted: $e11177b792bd10b5$export$afa861e3c5730743,
    isDirty: $e11177b792bd10b5$export$910b6cdd390341b3,
    isValid: $e11177b792bd10b5$export$1ea939691cdc45b8,
    isAsync: $e11177b792bd10b5$export$aefee5ebe1dcfd9e,
    get util () {
        return $e11177b792bd10b5$export$7debb50ef11d5e0b;
    },
    get objectUtil () {
        return $e11177b792bd10b5$export$4aa2142c225fd5c7;
    },
    ZodParsedType: $e11177b792bd10b5$export$5716da67bfaa244d,
    getParsedType: $e11177b792bd10b5$export$3e9057828ebd5c7a,
    ZodType: $e11177b792bd10b5$export$19342e026b58ebb7,
    datetimeRegex: $e11177b792bd10b5$export$a4b563879add27a,
    ZodString: $e11177b792bd10b5$export$1230eb29b8d3b502,
    ZodNumber: $e11177b792bd10b5$export$5b070a55c0c43e09,
    ZodBigInt: $e11177b792bd10b5$export$67d741fd70ff98f4,
    ZodBoolean: $e11177b792bd10b5$export$723d146f80596191,
    ZodDate: $e11177b792bd10b5$export$e974be33bdc55521,
    ZodSymbol: $e11177b792bd10b5$export$bcc3b40f6b638044,
    ZodUndefined: $e11177b792bd10b5$export$4e780e961c30340d,
    ZodNull: $e11177b792bd10b5$export$a96281f914484f2d,
    ZodAny: $e11177b792bd10b5$export$b9d1edb536b4e4eb,
    ZodUnknown: $e11177b792bd10b5$export$ef3b1bb1630977ae,
    ZodNever: $e11177b792bd10b5$export$1e576a20c3ce9fb5,
    ZodVoid: $e11177b792bd10b5$export$7d39f5df85f21031,
    ZodArray: $e11177b792bd10b5$export$7acfc3e64785411,
    ZodObject: $e11177b792bd10b5$export$736315c5b55efbad,
    ZodUnion: $e11177b792bd10b5$export$a8b236cb5070a311,
    ZodDiscriminatedUnion: $e11177b792bd10b5$export$5ef2424805ac76a3,
    ZodIntersection: $e11177b792bd10b5$export$c02deaf0bb5203d4,
    ZodTuple: $e11177b792bd10b5$export$e2a18bb771d8e6a3,
    ZodRecord: $e11177b792bd10b5$export$a2acc09968cb4b7f,
    ZodMap: $e11177b792bd10b5$export$163b6a2b712d9542,
    ZodSet: $e11177b792bd10b5$export$977057706f816712,
    ZodFunction: $e11177b792bd10b5$export$d4602ba55673f53c,
    ZodLazy: $e11177b792bd10b5$export$378d0cfce37406e6,
    ZodLiteral: $e11177b792bd10b5$export$7e44096782a165d3,
    ZodEnum: $e11177b792bd10b5$export$d325d1f0e1c20179,
    ZodNativeEnum: $e11177b792bd10b5$export$370b2e8d6d6f5c56,
    ZodPromise: $e11177b792bd10b5$export$3f196b0127d6e50a,
    ZodEffects: $e11177b792bd10b5$export$a60af00cc0ce2582,
    ZodTransformer: $e11177b792bd10b5$export$a60af00cc0ce2582,
    ZodOptional: $e11177b792bd10b5$export$aa56fec1e9d629b8,
    ZodNullable: $e11177b792bd10b5$export$aaac0b8b429cef5,
    ZodDefault: $e11177b792bd10b5$export$bb19b37874861e7e,
    ZodCatch: $e11177b792bd10b5$export$75a44ec6249ac76b,
    ZodNaN: $e11177b792bd10b5$export$26ccfa0145e8511f,
    BRAND: $e11177b792bd10b5$export$cf2deea74cde46b4,
    ZodBranded: $e11177b792bd10b5$export$66b0c798a395271f,
    ZodPipeline: $e11177b792bd10b5$export$a3c3ef8a0e95c6da,
    ZodReadonly: $e11177b792bd10b5$export$5d1f7ef05c4e493a,
    custom: $e11177b792bd10b5$export$4c00f665f0d4b443,
    Schema: $e11177b792bd10b5$export$19342e026b58ebb7,
    ZodSchema: $e11177b792bd10b5$export$19342e026b58ebb7,
    late: $e11177b792bd10b5$export$1ee8ee30835eab8b,
    get ZodFirstPartyTypeKind () {
        return $e11177b792bd10b5$export$558106ce543bd011;
    },
    coerce: $e11177b792bd10b5$export$8c14e57e778d3873,
    any: $e11177b792bd10b5$export$4154a199d7d90455,
    array: $e11177b792bd10b5$export$2f23118c22fb2630,
    bigint: $e11177b792bd10b5$export$a0f65b52274bcc00,
    boolean: $e11177b792bd10b5$export$4a21f16c33752377,
    date: $e11177b792bd10b5$export$324d90190a8b822a,
    discriminatedUnion: $e11177b792bd10b5$export$4b888e40c4ee26dd,
    effect: $e11177b792bd10b5$export$dc573d8a6576cdb3,
    'enum': $e11177b792bd10b5$export$78a99c8d44d72635,
    'function': $e11177b792bd10b5$export$44e51c8aac7c2deb,
    'instanceof': $e11177b792bd10b5$export$3d916e7c22dbd8b5,
    intersection: $e11177b792bd10b5$export$bc86dfbf7795668c,
    lazy: $e11177b792bd10b5$export$488013bae63b21da,
    literal: $e11177b792bd10b5$export$c8ec6e1ec9fefcb0,
    map: $e11177b792bd10b5$export$871de8747c9eaa88,
    nan: $e11177b792bd10b5$export$9e06de0973666692,
    nativeEnum: $e11177b792bd10b5$export$6fe7eca19ebe5199,
    never: $e11177b792bd10b5$export$b3e22bcfd64c1022,
    'null': $e11177b792bd10b5$export$7b1b591b262c240,
    nullable: $e11177b792bd10b5$export$133fc36489ac9add,
    number: $e11177b792bd10b5$export$98e628dec113755e,
    object: $e11177b792bd10b5$export$be5493f9613cbbe,
    oboolean: $e11177b792bd10b5$export$269251733cdcbbf1,
    onumber: $e11177b792bd10b5$export$eb150471a61fced6,
    optional: $e11177b792bd10b5$export$516e28dec6a4b6d4,
    ostring: $e11177b792bd10b5$export$3b3d07727c5b702c,
    pipeline: $e11177b792bd10b5$export$43f28b24e1eb8181,
    preprocess: $e11177b792bd10b5$export$fc37fe19dfda43ee,
    promise: $e11177b792bd10b5$export$c957ef27a0ebfd4,
    record: $e11177b792bd10b5$export$e5185e241753e543,
    set: $e11177b792bd10b5$export$adaa4cf7ef1b65be,
    strictObject: $e11177b792bd10b5$export$8fb0df5f40d0b477,
    string: $e11177b792bd10b5$export$22b082955e083ec3,
    symbol: $e11177b792bd10b5$export$8f701197936bc2a6,
    transformer: $e11177b792bd10b5$export$dc573d8a6576cdb3,
    tuple: $e11177b792bd10b5$export$65e3907585753458,
    'undefined': $e11177b792bd10b5$export$1db45310990710a5,
    union: $e11177b792bd10b5$export$971dd5b0dfd021b6,
    unknown: $e11177b792bd10b5$export$19282c40b967aec6,
    'void': $e11177b792bd10b5$export$490e536ee7389aeb,
    NEVER: $e11177b792bd10b5$export$96c94437c95d7862,
    ZodIssueCode: $e11177b792bd10b5$export$5ba560653e4a1035,
    quotelessJson: $e11177b792bd10b5$export$913eddeaf297cfea,
    ZodError: $e11177b792bd10b5$export$f98dac4b251ab333
});

});



var $4tluv = parcelRequire("4tluv");

var $eMmed = parcelRequire("eMmed");

var $3mxm3 = parcelRequire("3mxm3");

var $frEQt = parcelRequire("frEQt");


var $gkc74 = parcelRequire("gkc74");

var $k3zcO = parcelRequire("k3zcO");

var $aX5WL = parcelRequire("aX5WL");

var $f0dSY = parcelRequire("f0dSY");

var $4tluv = parcelRequire("4tluv");
parcelRequire("3mxm3");
var $bfivG = parcelRequire("bfivG");

var $7JI9m = parcelRequire("7JI9m");

var $f0dSY = parcelRequire("f0dSY");

var $9NbMC = parcelRequire("9NbMC");

var $9aNsE = parcelRequire("9aNsE");

var $bFW4F = parcelRequire("bFW4F");

var $1QYE6 = parcelRequire("1QYE6");

var $bI4fx = parcelRequire("bI4fx");
function $6a928bdc46f360ef$export$5f3292ad3ab2d536(userEmail) {
    return userEmail.endsWith("@atlassian.com");
}



var $4tluv = parcelRequire("4tluv");

var $jJcBA = parcelRequire("jJcBA");
const $c105407717ae6200$var$AuthLoadingScreen = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement("div", {
        "data-testid": "auth-loading-screen",
        style: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            width: "100vw",
            backgroundColor: "elevation.surface"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $jJcBA.default), {
        size: 150
    }));
};
var $c105407717ae6200$export$2e2bcd8739ae039 = $c105407717ae6200$var$AuthLoadingScreen;


const $a801d5f2705eca37$export$a832bf999c337547 = "site-loading";
const $a801d5f2705eca37$export$cab619d1bce8d47a = "user-loading";
function $a801d5f2705eca37$export$2e2bcd8739ae039({ Component: Component, LoginComponent: LoginComponent, publicRoutes: publicRoutes = [] }) {
    const [site, setSite] = (0, $4tluv.useState)((0, $1QYE6.getSelectedSiteFromLocalStorage)());
    const [_, setIsInitialized] = (0, $4tluv.useState)(false);
    const { pathname: pathname } = (0, $bfivG.useLocation)();
    const { data: userAccount, error: userError, isLoading: isUserLoading, isFetching: isFetching, isSuccess: isSuccess, isError: isError } = (0, $bFW4F.useUserAccount)();
    const isPublicRoute = publicRoutes.some((route)=>pathname.startsWith(route));
    if (isPublicRoute) {
        const isQueryRunning = isFetching || !isSuccess && !isError;
        // block Statsig initialization until we know the final user state
        // instead, show a loading screen while waiting for the user account to load
        if (isQueryRunning) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $c105407717ae6200$export$2e2bcd8739ae039), null);
        // if the user is logged out, use the anonymous id for initialization
        const anonymousId = JSON.parse(localStorage.getItem("ajs_anonymous_id") ?? '""');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $9NbMC.StatSigInitialization), {
            analyticsAnonymousId: anonymousId,
            userAccount: userAccount
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement(Component, {
            site: site,
            userAccount: userAccount
        }));
    }
    const handleSiteChange = async (newSite)=>{
        setSite(newSite);
    };
    if (isUserLoading || !userAccount && !userError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $7JI9m.default), {
        name: "user-authentication-loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement("div", {
        "data-testid": $a801d5f2705eca37$export$cab619d1bce8d47a
    }));
    if (userError) return LoginComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $9NbMC.StatSigInitialization), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement(LoginComponent, {
        hasError: userError.errorType !== (0, $9aNsE.RequestErrorType).AUTH_ERROR
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).Fragment, null);
    (0, $bI4fx.postMessageToParent)({
        type: "USER_UPDATE",
        value: {
            userId: userAccount.accountId,
            isAtlassianUser: (0, $6a928bdc46f360ef$export$5f3292ad3ab2d536)(userAccount.email)
        }
    });
    (0, $f0dSY.setSentryUser)(userAccount.accountId);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $9NbMC.StatSigInitialization), {
        onInitialized: ()=>setIsInitialized(true),
        site: site,
        userAccount: userAccount
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $1QYE6.SiteProvider), {
        onSiteChange: handleSiteChange,
        userAccount: userAccount
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement(Component, {
        site: site,
        userAccount: userAccount
    })));
}



var $cKss1 = parcelRequire("cKss1");

var $4tluv = parcelRequire("4tluv");

var $iEMA6 = parcelRequire("iEMA6");
function $2607425a14879ed4$export$89c0607256d35f0a(message) {
    if (typeof console !== 'undefined' && console.info) console.info(`[rovo-extension/i18n] ${message}`);
}
function $2607425a14879ed4$export$58da9968c3170cb1(errorInfo) {
    if (typeof console !== 'undefined' && console.error) console.error(`[rovo-extension/i18n] ${errorInfo.impact}`, errorInfo.error);
}


const $59980554dc17d83c$export$94d2d72df36bbb16 = [
    "cs",
    "da",
    "de",
    "en",
    "en-GB",
    "en-AU",
    "en-IN",
    "en-NZ",
    "en-US",
    "en-XA",
    "en-XB",
    "en-ZZ",
    "es",
    "fi",
    "fr",
    "hr",
    "hu",
    "it",
    "ja",
    "ko",
    "nb",
    "nl",
    "pl",
    "pt",
    "pt-BR",
    "ru",
    "sl",
    "sr",
    "sv",
    "th",
    "tr",
    "uk",
    "vi",
    "zh",
    "zh-TW"
];
function $59980554dc17d83c$export$e88b669f03544b69(locale) {
    const normalizedLocale = locale.replace("_", "-");
    if ($59980554dc17d83c$export$94d2d72df36bbb16.includes(normalizedLocale)) return normalizedLocale;
    if ((normalizedLocale.match(/-/g) ?? []).length > 1) {
        const secondHyphen = normalizedLocale.indexOf("-", 3);
        const localeWithoutVariant = normalizedLocale.substring(0, secondHyphen);
        if ($59980554dc17d83c$export$94d2d72df36bbb16.includes(localeWithoutVariant)) {
            (0, $2607425a14879ed4$export$89c0607256d35f0a)(`Unable to find locale data for ${locale}, attempting to load ${localeWithoutVariant} fallback`);
            return localeWithoutVariant;
        }
    }
    const languageCode = normalizedLocale.substring(0, 2);
    if ($59980554dc17d83c$export$94d2d72df36bbb16.includes(languageCode)) {
        (0, $2607425a14879ed4$export$89c0607256d35f0a)(`Unable to find locale data for ${locale}, attempting to load ${languageCode} fallback`);
        return languageCode;
    }
    (0, $2607425a14879ed4$export$89c0607256d35f0a)(`Unable to find locale data for ${locale}, attempting to load English fallback`);
    return "en";
}


function $60a78826cc77b8ff$export$aaf01d6467973d49(messages) {
    const blockified = {};
    const blockMap = {
        a: "\uFF41",
        b: "\uFF42",
        c: "\uFF43",
        d: "\uFF44",
        e: "\uFF45",
        f: "\uFF46",
        g: "\uFF47",
        h: "\uFF48",
        i: "\uFF49",
        j: "\uFF4A",
        k: "\uFF4B",
        l: "\uFF4C",
        m: "\uFF4D",
        n: "\uFF4E",
        o: "\uFF4F",
        p: "\uFF50",
        q: "\uFF51",
        r: "\uFF52",
        s: "\uFF53",
        t: "\uFF54",
        u: "\uFF55",
        v: "\uFF56",
        w: "\uFF57",
        x: "\uFF58",
        y: "\uFF59",
        z: "\uFF5A",
        A: "\uFF21",
        B: "\uFF22",
        C: "\uFF23",
        D: "\uFF24",
        E: "\uFF25",
        F: "\uFF26",
        G: "\uFF27",
        H: "\uFF28",
        I: "\uFF29",
        J: "\uFF2A",
        K: "\uFF2B",
        L: "\uFF2C",
        M: "\uFF2D",
        N: "\uFF2E",
        O: "\uFF2F",
        P: "\uFF30",
        Q: "\uFF31",
        R: "\uFF32",
        S: "\uFF33",
        T: "\uFF34",
        U: "\uFF35",
        V: "\uFF36",
        W: "\uFF37",
        X: "\uFF38",
        Y: "\uFF39",
        Z: "\uFF3A",
        0: "\uFF10",
        1: "\uFF11",
        2: "\uFF12",
        3: "\uFF13",
        4: "\uFF14",
        5: "\uFF15",
        6: "\uFF16",
        7: "\uFF17",
        8: "\uFF18",
        9: "\uFF19"
    };
    for (const [key, value] of Object.entries(messages))if (typeof value === 'string') blockified[key] = `[${value.split('').map((char)=>blockMap[char] || char).join('')}]`;
    else blockified[key] = value;
    return blockified;
}
function $60a78826cc77b8ff$export$899c38795c0a61a4(messages) {
    const bracketed = {};
    for (const [key, value] of Object.entries(messages))if (typeof value === 'string') bracketed[key] = `\xab${value}\xbb`;
    else bracketed[key] = value;
    return bracketed;
}



/**
 * Extract messages from a dynamic import result.
 * Handles both ESM default exports (webpack) and CJS module.exports (Atlaspack).
 * - Webpack wraps JSON in { default: {...} }
 * - Atlaspack transforms JSON to module.exports = {...} which may not have .default
 */ function $fb4ecfc96dddde6e$var$resolveMessages(mod) {
    return mod?.default ?? mod;
}


















































































































































/**
 * Returns all i18n import promises for a given locale —
 * extension messages + conversation-assistant sub-package messages.
 */ function $fb4ecfc96dddde6e$var$getMessageLoaders(localeToLoad) {
    switch(localeToLoad){
        case "cs":
            return [
                (parcelRequire("juxxB")),
                (parcelRequire("jG15d")),
                (parcelRequire("2riAN")),
                (parcelRequire("7b32I")),
                (parcelRequire("avQPH"))
            ];
        case "da":
            return [
                (parcelRequire("f6Jgj")),
                (parcelRequire("hKHxs")),
                (parcelRequire("9rhKM")),
                (parcelRequire("csGK9")),
                (parcelRequire("fwThl"))
            ];
        case "de":
            return [
                (parcelRequire("5GKSC")),
                (parcelRequire("bIokc")),
                (parcelRequire("kYfhk")),
                (parcelRequire("eCTN4")),
                (parcelRequire("cHB8h"))
            ];
        case "en-GB":
        case "en-AU":
        case "en-IN":
        case "en-NZ":
            return [
                (parcelRequire("2VEeA")),
                (parcelRequire("7XuIO")),
                (parcelRequire("7BXaG")),
                (parcelRequire("lETpY")),
                (parcelRequire("bpbMK"))
            ];
        case "en-XA":
            return [
                (parcelRequire("9lnx2")).then((mod)=>(0, $60a78826cc77b8ff$export$aaf01d6467973d49)($fb4ecfc96dddde6e$var$resolveMessages(mod))),
                (parcelRequire("5SN7Z")).then((mod)=>(0, $60a78826cc77b8ff$export$aaf01d6467973d49)($fb4ecfc96dddde6e$var$resolveMessages(mod))),
                (parcelRequire("jLul9")).then((mod)=>(0, $60a78826cc77b8ff$export$aaf01d6467973d49)($fb4ecfc96dddde6e$var$resolveMessages(mod))),
                (parcelRequire("5qw06")).then((mod)=>(0, $60a78826cc77b8ff$export$aaf01d6467973d49)($fb4ecfc96dddde6e$var$resolveMessages(mod))),
                (parcelRequire("hAkSR")).then((mod)=>(0, $60a78826cc77b8ff$export$aaf01d6467973d49)($fb4ecfc96dddde6e$var$resolveMessages(mod)))
            ];
        case "en-XB":
            return [
                (parcelRequire("9lnx2")).then((mod)=>(0, $60a78826cc77b8ff$export$899c38795c0a61a4)($fb4ecfc96dddde6e$var$resolveMessages(mod))),
                (parcelRequire("5SN7Z")).then((mod)=>(0, $60a78826cc77b8ff$export$899c38795c0a61a4)($fb4ecfc96dddde6e$var$resolveMessages(mod))),
                (parcelRequire("jLul9")).then((mod)=>(0, $60a78826cc77b8ff$export$899c38795c0a61a4)($fb4ecfc96dddde6e$var$resolveMessages(mod))),
                (parcelRequire("5qw06")).then((mod)=>(0, $60a78826cc77b8ff$export$899c38795c0a61a4)($fb4ecfc96dddde6e$var$resolveMessages(mod))),
                (parcelRequire("hAkSR")).then((mod)=>(0, $60a78826cc77b8ff$export$899c38795c0a61a4)($fb4ecfc96dddde6e$var$resolveMessages(mod)))
            ];
        case "en-ZZ":
            return [
                (parcelRequire("2PxKQ")),
                (parcelRequire("5rsEs")),
                (parcelRequire("g2sj8")),
                (parcelRequire("lGJlF")),
                (parcelRequire("4WiOL"))
            ];
        case "es":
            return [
                (parcelRequire("6LSxc")),
                (parcelRequire("bDBsq")),
                (parcelRequire("dKGoH")),
                (parcelRequire("29IKQ")),
                (parcelRequire("ai86H"))
            ];
        case "fi":
            return [
                (parcelRequire("bob7G")),
                (parcelRequire("jOyDS")),
                (parcelRequire("5dozx")),
                (parcelRequire("6owbF")),
                (parcelRequire("40N3F"))
            ];
        case "fr":
            return [
                (parcelRequire("h7xEv")),
                (parcelRequire("1vmGS")),
                (parcelRequire("9Da1W")),
                (parcelRequire("eiZIW")),
                (parcelRequire("a58gJ"))
            ];
        case "hr":
            return [
                (parcelRequire("ieKTK")),
                (parcelRequire("kPkcD")),
                (parcelRequire("40dvu")),
                (parcelRequire("6VVKf")),
                (parcelRequire("ltaZD"))
            ];
        case "hu":
            return [
                (parcelRequire("gjbXJ")),
                (parcelRequire("bdxxN")),
                (parcelRequire("ge7es")),
                (parcelRequire("gLmeJ")),
                (parcelRequire("hQvOA"))
            ];
        case "it":
            return [
                (parcelRequire("dXfxI")),
                (parcelRequire("k9Fak")),
                (parcelRequire("nYE9H")),
                (parcelRequire("5C7V9")),
                (parcelRequire("iL4Gu"))
            ];
        case "ja":
            return [
                (parcelRequire("3K8N7")),
                (parcelRequire("4aIUG")),
                (parcelRequire("cczCX")),
                (parcelRequire("haGAz")),
                (parcelRequire("gE99F"))
            ];
        case "ko":
            return [
                (parcelRequire("kTQ7A")),
                (parcelRequire("gEbQr")),
                (parcelRequire("em0Ul")),
                (parcelRequire("c5DMb")),
                (parcelRequire("ibDEC"))
            ];
        case "nb":
            return [
                (parcelRequire("99vq6")),
                (parcelRequire("ccpOD")),
                (parcelRequire("16as1")),
                (parcelRequire("6w3SL")),
                (parcelRequire("7jfbo"))
            ];
        case "nl":
            return [
                (parcelRequire("fPM10")),
                (parcelRequire("aFAkb")),
                (parcelRequire("bfYZ2")),
                (parcelRequire("8ks7T")),
                (parcelRequire("h4zk6"))
            ];
        case "pl":
            return [
                (parcelRequire("8KsWf")),
                (parcelRequire("jM9yH")),
                (parcelRequire("ilOLc")),
                (parcelRequire("hf5Dc")),
                (parcelRequire("e91b3"))
            ];
        case "pt":
        case "pt-BR":
            return [
                (parcelRequire("bGLjt")),
                (parcelRequire("j6vLS")),
                (parcelRequire("6Djv8")),
                (parcelRequire("lVKqf")),
                (parcelRequire("lcffS"))
            ];
        case "ru":
            return [
                (parcelRequire("7TfnW")),
                (parcelRequire("d4jbC")),
                (parcelRequire("aJYAb")),
                (parcelRequire("4EXMn")),
                (parcelRequire("dLk4E"))
            ];
        case "sl":
            return [
                (parcelRequire("gzIGM")),
                (parcelRequire("jnUe2")),
                (parcelRequire("3ULI9")),
                (parcelRequire("51Byv")),
                (parcelRequire("7GOwe"))
            ];
        case "sr":
            return [
                (parcelRequire("fDrhX")),
                (parcelRequire("e2mID")),
                (parcelRequire("abXfI")),
                (parcelRequire("b9Y2u")),
                (parcelRequire("VJ3zl"))
            ];
        case "sv":
            return [
                (parcelRequire("fIsmW")),
                (parcelRequire("khxTS")),
                (parcelRequire("1SrpM")),
                (parcelRequire("hV9E4")),
                (parcelRequire("1ODwD"))
            ];
        case "th":
            return [
                (parcelRequire("99sy1")),
                (parcelRequire("a5ODZ")),
                (parcelRequire("5nfSs")),
                (parcelRequire("bHwfi")),
                (parcelRequire("41FIO"))
            ];
        case "tr":
            return [
                (parcelRequire("27W1P")),
                (parcelRequire("jWm6m")),
                (parcelRequire("jzK5z")),
                (parcelRequire("cgFkE")),
                (parcelRequire("8brxU"))
            ];
        case "uk":
            return [
                (parcelRequire("gHf6Y")),
                (parcelRequire("ahsjd")),
                (parcelRequire("jmQi0")),
                (parcelRequire("72LDO")),
                (parcelRequire("kZ2oc"))
            ];
        case "vi":
            return [
                (parcelRequire("lvicC")),
                (parcelRequire("17beQ")),
                (parcelRequire("lGf4Y")),
                (parcelRequire("7pIqO")),
                (parcelRequire("4xiB6"))
            ];
        case "zh":
            return [
                (parcelRequire("l1A2T")),
                (parcelRequire("54KLF")),
                (parcelRequire("8quJE")),
                (parcelRequire("8d9sb")),
                (parcelRequire("2Td8X"))
            ];
        case "zh-TW":
            return [
                (parcelRequire("jHIgJ")),
                (parcelRequire("kbaUP")),
                (parcelRequire("aD7wK")),
                (parcelRequire("5kBZV")),
                (parcelRequire("7ROw6"))
            ];
        case "en":
        case "en-US":
        default:
            return [
                (parcelRequire("9lnx2"))
            ];
    }
}

async function $fb4ecfc96dddde6e$export$99be592f797bf55d(locale) {
    const localeToLoad = (0, $59980554dc17d83c$export$e88b669f03544b69)(locale);
    try {
        const results = await Promise.all($fb4ecfc96dddde6e$var$getMessageLoaders(localeToLoad));
        return Object.assign({}, ...results.map($fb4ecfc96dddde6e$var$resolveMessages));
    } catch (error) {
        (0, $2607425a14879ed4$export$58da9968c3170cb1)({
            error: error,
            impact: "Failed to import locale strings, attempting to load English fallback"
        });
        return $fb4ecfc96dddde6e$var$resolveMessages(await (parcelRequire("9lnx2")));
    }
}


parcelRequire("iuDZJ");
var $dqHaj = parcelRequire("dqHaj");

var $22hwD = parcelRequire("22hwD");
const $41e07a503512b44a$export$43ce528bbe72160e = (props)=>{
    const [messages, setMessages] = (0, $4tluv.useState)({});
    const locale = (0, $dqHaj.getLocale)();
    (0, $4tluv.useEffect)(()=>{
        (0, $fb4ecfc96dddde6e$export$99be592f797bf55d)(locale).then((localeMessages)=>{
            setMessages(localeMessages);
        }).catch((error)=>{
            (0, $22hwD.logError)({
                error: error,
                impact: "Failed to load locale strings"
            });
        });
    }, [
        locale
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $iEMA6.default), {
        locale: locale,
        messages: messages,
        onError: ()=>{}
    }, props.children);
};


parcelRequire("1wxU2");
var $iVysF = parcelRequire("iVysF");
var $cFd5E = parcelRequire("cFd5E");

var $4tluv = parcelRequire("4tluv");

var $5oM6j = parcelRequire("5oM6j");

var $4tluv = parcelRequire("4tluv");

var $bI4fx = parcelRequire("bI4fx");
const $1c59f638f90642aa$export$9438e87dff4966f4 = ()=>{
    const [timingData, setTimingData] = (0, $4tluv.useState)();
    (0, $4tluv.useEffect)(()=>{
        const messageHandler = (event)=>{
            if (event.data.type === "GET_EXTENSION_INIT_TIMING_RESPONSE") setTimingData(event.data.timingData);
            else if (event.data.type === "IFRAME_LOAD_COMPLETE") // Request updated timing data immediately when iframe load completes
            (0, $bI4fx.postMessageToParent)({
                type: "GET_EXTENSION_INIT_TIMING_REQUEST"
            });
        };
        window.addEventListener("message", messageHandler, false);
        // Request timing data from extension-chrome
        (0, $bI4fx.postMessageToParent)({
            type: "GET_EXTENSION_INIT_TIMING_REQUEST"
        });
        return ()=>{
            window.removeEventListener("message", messageHandler);
        };
    }, []); // No dependencies - effect runs once on mount
    return timingData;
};


const $72a03799bd3fe790$export$62712945821e44d1 = ()=>{
    const timingData = (0, $1c59f638f90642aa$export$9438e87dff4966f4)();
    if (!timingData) return null;
    const customData = {
        extensionScriptInitDuration: timingData.scriptInitDuration,
        extensionPageReadyDuration: timingData.pageReadyDuration,
        extensionInitStartTime: timingData.scriptInitStartTime,
        extensionInitEndTime: timingData.pageReadyEndTime,
        // Include iframe load timing data if available
        ...timingData.iframeLoadDuration && {
            extensionIframeLoadDuration: timingData.iframeLoadDuration,
            extensionIframeLoadStartTime: timingData.iframeLoadStartTime,
            extensionIframeLoadEndTime: timingData.iframeLoadEndTime
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $5oM6j.default), {
        data: customData
    });
};



var $kA1Vr = parcelRequire("kA1Vr");
parcelRequire("gfRi5");
var $4xT8j = parcelRequire("4xT8j");
var $3dX4H = parcelRequire("3dX4H");
parcelRequire("iuDZJ");

const $c4c47b0e78c26f17$var$HomeLoginPageLazy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).lazy(()=>(parcelRequire("3d7IG")));
(0, $f0dSY.initializeSentry)();
// Initialize UFO as early as possible to capture more initialization time
(0, $iVysF.initUFO)();
const $c4c47b0e78c26f17$var$container = document.getElementById("root");
const $c4c47b0e78c26f17$var$root = (0, $eMmed.createRoot)($c4c47b0e78c26f17$var$container);

const $c4c47b0e78c26f17$var$LazyApp = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).lazy(()=>(parcelRequire("ej7At")));
// Component to handle extension timing data within UFO context
const $c4c47b0e78c26f17$var$ExtensionTimingHandler = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $72a03799bd3fe790$export$62712945821e44d1), null);
};
$c4c47b0e78c26f17$var$root.render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $4xT8j.PerformanceSLO), {
    ufo: (0, $3dX4H.PerformanceSLOKeys).APPLICATION_BOOTSTRAP
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement($c4c47b0e78c26f17$var$ExtensionTimingHandler, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $gkc74.HelmetProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $41e07a503512b44a$export$43ce528bbe72160e), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $aX5WL.ErrorBoundary), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $3mxm3.BrowserRouter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $frEQt.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $k3zcO.PersistQueryClientProvider), {
    client: (0, $cKss1.queryClient),
    persistOptions: {
        persister: $cKss1.persister
    }
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $kA1Vr.ThemeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $4tluv.Suspense), {
    fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $cFd5E.UFOSuspenseFallback), {
        name: "main-app-loading"
    })
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $a801d5f2705eca37$export$2e2bcd8739ae039), {
    Component: $c4c47b0e78c26f17$var$LazyApp,
    LoginComponent: $c4c47b0e78c26f17$var$HomeLoginPageLazy,
    publicRoutes: [
        "/extension/welcome",
        "/extension/log-out",
        "/extension/ntp-logout-redirect"
    ]
})))))))))));


//# sourceMappingURL=index.ff18a1bb.js.map
